;(function (e) {
  function t (t) {
    for (
      var i, s, o = t[0], l = t[1], c = t[2], u = 0, d = [];
      u < o.length;
      u++
    )
      (s = o[u]),
        Object.prototype.hasOwnProperty.call(r, s) && r[s] && d.push(r[s][0]),
        (r[s] = 0)
    for (i in l) Object.prototype.hasOwnProperty.call(l, i) && (e[i] = l[i])
    h && h(t)
    while (d.length) d.shift()()
    return a.push.apply(a, c || []), n()
  }
  function n () {
    for (var e, t = 0; t < a.length; t++) {
      for (var n = a[t], i = !0, o = 1; o < n.length; o++) {
        var l = n[o]
        0 !== r[l] && (i = !1)
      }
      i && (a.splice(t--, 1), (e = s((s.s = n[0]))))
    }
    return e
  }
  var i = {},
    r = { app: 0 },
    a = []
  function s (t) {
    if (i[t]) return i[t].exports
    var n = (i[t] = { i: t, l: !1, exports: {} })
    return e[t].call(n.exports, n, n.exports, s), (n.l = !0), n.exports
  }
  ;(s.m = e),
    (s.c = i),
    (s.d = function (e, t, n) {
      s.o(e, t) || Object.defineProperty(e, t, { enumerable: !0, get: n })
    }),
    (s.r = function (e) {
      'undefined' !== typeof Symbol &&
        Symbol.toStringTag &&
        Object.defineProperty(e, Symbol.toStringTag, { value: 'Module' }),
        Object.defineProperty(e, '__esModule', { value: !0 })
    }),
    (s.t = function (e, t) {
      if ((1 & t && (e = s(e)), 8 & t)) return e
      if (4 & t && 'object' === typeof e && e && e.__esModule) return e
      var n = Object.create(null)
      if (
        (s.r(n),
        Object.defineProperty(n, 'default', { enumerable: !0, value: e }),
        2 & t && 'string' != typeof e)
      )
        for (var i in e)
          s.d(
            n,
            i,
            function (t) {
              return e[t]
            }.bind(null, i)
          )
      return n
    }),
    (s.n = function (e) {
      var t =
        e && e.__esModule
          ? function () {
              return e['default']
            }
          : function () {
              return e
            }
      return s.d(t, 'a', t), t
    }),
    (s.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t)
    }),
    (s.p = '')
  var o = (window['webpackJsonp'] = window['webpackJsonp'] || []),
    l = o.push.bind(o)
  ;(o.push = t), (o = o.slice())
  for (var c = 0; c < o.length; c++) t(o[c])
  var h = l
  a.push(['422c', 'chunk-vendors']), n()
})({
  '3bdb': function (e, t, n) {},
  '3c76': function (e, t, n) {
    'use strict'
    n('3bdb')
  },
  '422c': function (e, t, n) {
    'use strict'
    n.r(t)
    var i = n('2b0e'),
      r = function () {
        var e = this,
          t = e.$createElement,
          n = e._self._c || t
        return n(
          'div',
          { staticClass: '__brfv5', attrs: { id: '__artov5__app' } },
          [
            e._l(e.views, function (t, i) {
              return e.brfv5 &&
                e.camera &&
                e.events &&
                e.views &&
                e.views.length > 0
                ? n(
                    'div',
                    { staticClass: 'abs oh', class: t.viewSpot },
                    [
                      0 === i
                        ? n('BRFv5CameraTracker', {
                            ref: '_tracker',
                            refInFor: !0,
                            attrs: {
                              'app-id': e.brfv5.appId,
                              'path-to-models': e.brfv5.pathToModels,
                              'model-type': e.brfv5.modelType,
                              'num-faces-to-track': e.isMobileOS
                                ? e.brfv5.numFacesToTrackOnMobile
                                : e.brfv5.numFacesToTrackOnDesktop,
                              'num-chunks-to-load': e.isMobileOS
                                ? e.brfv5.numChunksToLoadOnMobile
                                : e.brfv5.numChunksToLoadOnDesktop,
                              'enable-dynamic-performance':
                                e.brfv5.enableDynamicPerformance,
                              'show-stats': e.brfv5.showStats,
                              'show-debug-draw': e.brfv5.showDebugDraw,
                              'camera-enabled': e.camera.enabled,
                              'camera-constraints': e.camera.constraints
                            },
                            on: {
                              onProgress: e.onReportedProgress,
                              onCameraOpened: e.onCameraOpened,
                              onCameraClosed: e.onCameraClosed,
                              onCameraError: e.onCameraError,
                              onBRFv5Ready: e.onBRFv5Ready,
                              onBRFv5Tracked: e.onBRFv5Tracked,
                              onBRFv5Error: e.onBRFv5Error
                            }
                          })
                        : n('BRFv5CameraCopy', {
                            ref: '_camera_copy',
                            refInFor: !0,
                            attrs: { input: e.currentCanvas }
                          }),
                      n('ARTOv5ThreeJS', {
                        ref: '_renderer',
                        refInFor: !0,
                        attrs: {
                          view: t,
                          numFacesToTrack:
                            0 === e.numFacesToTrack ? 1 : e.numFacesToTrack,
                          resolution: e.resolution,
                          faces: e.faces
                        },
                        on: {
                          onProgress: e.onReportedProgress,
                          onThreeJSReady: e.onThreeJSReady,
                          onThreeJSModelsLoaded: e.onThreeJSModelsLoaded,
                          onThreeJSError: e.onThreeJSError
                        }
                      })
                    ],
                    1
                  )
                : e._e()
            }),
            n(
              'transition',
              { attrs: { name: 'fade' } },
              [
                n('ARTOv5Preloader', {
                  directives: [
                    {
                      name: 'show',
                      rawName: 'v-show',
                      value: e.showPreloader && e.preloadProgress < 1,
                      expression: 'showPreloader && preloadProgress < 1.00'
                    }
                  ],
                  ref: '_preloader'
                })
              ],
              1
            )
          ],
          2
        )
      },
      a = []
    n('5cc6'), n('219c')
    const s = {
        ANDROID: 'Android',
        IOS: 'iOS',
        UNKNOWN: 'unknown',
        WINDOWS_PHONE: 'Windows Phone'
      },
      o = () => {
        let e = navigator.userAgent || navigator.vendor || window.opera
        return /windows phone/i.test(e)
          ? s.WINDOWS_PHONE
          : /android/i.test(e)
          ? s.ANDROID
          : /iPad|iPhone|iPod/.test(e) && !window.MSStream
          ? s.IOS
          : s.UNKNOWN
      },
      l = () => {
        try {
          if (
            'object' === typeof WebAssembly &&
            'function' === typeof WebAssembly.instantiate
          ) {
            const e = new Uint8Array([
                0,
                97,
                115,
                109,
                1,
                0,
                0,
                0,
                1,
                6,
                1,
                96,
                1,
                127,
                1,
                127,
                3,
                2,
                1,
                0,
                5,
                3,
                1,
                0,
                1,
                7,
                8,
                1,
                4,
                116,
                101,
                115,
                116,
                0,
                0,
                10,
                16,
                1,
                14,
                0,
                32,
                0,
                65,
                1,
                54,
                2,
                0,
                32,
                0,
                40,
                2,
                0,
                11
              ]),
              t = new WebAssembly.Module(e)
            if (t instanceof WebAssembly.Module) {
              const e = new WebAssembly.Instance(t, {})
              return (
                e instanceof WebAssembly.Instance && 0 !== e.exports.test(4)
              )
            }
          }
        } catch (e) {}
        return !1
      },
      c = () => {
        try {
          const e = document.createElement('canvas')
          return (
            !!window.WebGLRenderingContext &&
            (!!e.getContext('experimental-webgl') || !!e.getContext('webgl'))
          )
        } catch (e) {
          return !1
        }
      },
      h = {
        mobileOS: o(),
        isMobileOS: o() !== s.UNKNOWN,
        isWebAssemblySupported: l(),
        isWebGLSupported: c()
      }
    let u = !0
    const d = e => {
        u = e
      },
      p = (...e) => {
        u && console.log.apply(null, e)
      },
      f = (...e) => {
        u && console.warn.apply(null, e)
      },
      m = (...e) => {
        console.error.apply(null, e)
      }
    const g = {}
    let v = 0,
      y = 0,
      _ = -1,
      x = null
    const w = () => {
        v > 0.98 && (v = 1),
          v <= 0.9
            ? 0.7 * v > y && (y = 0.7 * v)
            : v >= 1 && ((y += 0.02), y > 0.98 && ((y = 1), clearInterval(_))),
          x && x(y)
      },
      b = ({ url: e, loaded: t, total: n }, i) => {
        x = i
        let r = g[e],
          a = !1
        r
          ? ((r.loaded = t), (r.total = n))
          : ((g[e] = { loaded: t, total: n }), (a = !0))
        let s = 100,
          o = 1,
          l = 0
        for (var c in g)
          g.hasOwnProperty(c) &&
            (g[c].total > 0
              ? ((s += g[c].total), (o += g[c].loaded))
              : ((s += g[c].loaded), (o += g[c].loaded)),
            l++)
        return (
          a && p('onProgress: numLoaders: ', l),
          s > 100 && (s -= 100),
          o > 1 && (o -= 1),
          (v = Math.ceil((o / s) * 1e4) / 1e4),
          -1 === _
            ? ((_ = setInterval(w, 50)), p('onProgress: intervalId: ', _))
            : w(),
          v
        )
      }
    let M = !0
    const S = e => {
        M = e
      },
      E = (...e) => {
        M && console.log.apply(null, e)
      },
      T = (...e) => {
        M && console.warn.apply(null, e)
      },
      A = (...e) => {
        console.error.apply(null, e)
      }
    const R = e => (180 * e) / Math.PI,
      L = e => (e * Math.PI) / 180
    n('8f40'),
      n('acef'),
      n('bf19'),
      n('fd87'),
      n('8a59'),
      n('8b09'),
      n('84c3'),
      n('143c'),
      n('fb2c'),
      n('cfc3'),
      n('4a9b'),
      n('5319')
    /**
     * @license
     * Copyright 2010-2021 Three.js Authors
     * SPDX-License-Identifier: MIT
     */
    const C = '130',
      P = 0,
      D = 1,
      I = 2,
      N = 1,
      O = 2,
      F = 3,
      B = 0,
      z = 1,
      U = 2,
      k = 1,
      H = 0,
      W = 1,
      V = 2,
      G = 3,
      j = 4,
      q = 5,
      Y = 100,
      X = 101,
      J = 102,
      Z = 103,
      K = 104,
      Q = 200,
      $ = 201,
      ee = 202,
      te = 203,
      ne = 204,
      ie = 205,
      re = 206,
      ae = 207,
      se = 208,
      oe = 209,
      le = 210,
      ce = 0,
      he = 1,
      ue = 2,
      de = 3,
      pe = 4,
      fe = 5,
      me = 6,
      ge = 7,
      ve = 0,
      ye = 1,
      _e = 2,
      xe = 0,
      we = 1,
      be = 2,
      Me = 3,
      Se = 4,
      Ee = 5,
      Te = 300,
      Ae = 301,
      Re = 302,
      Le = 303,
      Ce = 304,
      Pe = 306,
      De = 307,
      Ie = 1e3,
      Ne = 1001,
      Oe = 1002,
      Fe = 1003,
      Be = 1004,
      ze = 1005,
      Ue = 1006,
      ke = 1007,
      He = 1008,
      We = 1009,
      Ve = 1010,
      Ge = 1011,
      je = 1012,
      qe = 1013,
      Ye = 1014,
      Xe = 1015,
      Je = 1016,
      Ze = 1017,
      Ke = 1018,
      Qe = 1019,
      $e = 1020,
      et = 1021,
      tt = 1022,
      nt = 1023,
      it = 1024,
      rt = 1025,
      at = 1026,
      st = 1027,
      ot = 1028,
      lt = 1029,
      ct = 1030,
      ht = 1031,
      ut = 1032,
      dt = 1033,
      pt = 33776,
      ft = 33777,
      mt = 33778,
      gt = 33779,
      vt = 35840,
      yt = 35841,
      _t = 35842,
      xt = 35843,
      wt = 36196,
      bt = 37492,
      Mt = 37496,
      St = 37808,
      Et = 37809,
      Tt = 37810,
      At = 37811,
      Rt = 37812,
      Lt = 37813,
      Ct = 37814,
      Pt = 37815,
      Dt = 37816,
      It = 37817,
      Nt = 37818,
      Ot = 37819,
      Ft = 37820,
      Bt = 37821,
      zt = 36492,
      Ut = 37840,
      kt = 37841,
      Ht = 37842,
      Wt = 37843,
      Vt = 37844,
      Gt = 37845,
      jt = 37846,
      qt = 37847,
      Yt = 37848,
      Xt = 37849,
      Jt = 37850,
      Zt = 37851,
      Kt = 37852,
      Qt = 37853,
      $t = 2200,
      en = 2201,
      tn = 2202,
      nn = 2300,
      rn = 2301,
      an = 2302,
      sn = 2400,
      on = 2401,
      ln = 2402,
      cn = 2500,
      hn = 2501,
      un = 0,
      dn = 3e3,
      pn = 3001,
      fn = 3007,
      mn = 3002,
      gn = 3003,
      vn = 3004,
      yn = 3005,
      _n = 3006,
      xn = 3200,
      wn = 3201,
      bn = 0,
      Mn = 1,
      Sn = 7680,
      En = 519,
      Tn = 35044,
      An = 35048,
      Rn = '300 es'
    class Ln {
      addEventListener (e, t) {
        void 0 === this._listeners && (this._listeners = {})
        const n = this._listeners
        void 0 === n[e] && (n[e] = []), -1 === n[e].indexOf(t) && n[e].push(t)
      }
      hasEventListener (e, t) {
        if (void 0 === this._listeners) return !1
        const n = this._listeners
        return void 0 !== n[e] && -1 !== n[e].indexOf(t)
      }
      removeEventListener (e, t) {
        if (void 0 === this._listeners) return
        const n = this._listeners,
          i = n[e]
        if (void 0 !== i) {
          const e = i.indexOf(t)
          ;-1 !== e && i.splice(e, 1)
        }
      }
      dispatchEvent (e) {
        if (void 0 === this._listeners) return
        const t = this._listeners,
          n = t[e.type]
        if (void 0 !== n) {
          e.target = this
          const t = n.slice(0)
          for (let n = 0, i = t.length; n < i; n++) t[n].call(this, e)
          e.target = null
        }
      }
    }
    const Cn = []
    for (let my = 0; my < 256; my++)
      Cn[my] = (my < 16 ? '0' : '') + my.toString(16)
    const Pn = Math.PI / 180,
      Dn = 180 / Math.PI
    function In () {
      const e = (4294967295 * Math.random()) | 0,
        t = (4294967295 * Math.random()) | 0,
        n = (4294967295 * Math.random()) | 0,
        i = (4294967295 * Math.random()) | 0,
        r =
          Cn[255 & e] +
          Cn[(e >> 8) & 255] +
          Cn[(e >> 16) & 255] +
          Cn[(e >> 24) & 255] +
          '-' +
          Cn[255 & t] +
          Cn[(t >> 8) & 255] +
          '-' +
          Cn[((t >> 16) & 15) | 64] +
          Cn[(t >> 24) & 255] +
          '-' +
          Cn[(63 & n) | 128] +
          Cn[(n >> 8) & 255] +
          '-' +
          Cn[(n >> 16) & 255] +
          Cn[(n >> 24) & 255] +
          Cn[255 & i] +
          Cn[(i >> 8) & 255] +
          Cn[(i >> 16) & 255] +
          Cn[(i >> 24) & 255]
      return r.toUpperCase()
    }
    function Nn (e, t, n) {
      return Math.max(t, Math.min(n, e))
    }
    function On (e, t) {
      return ((e % t) + t) % t
    }
    function Fn (e, t, n) {
      return (1 - n) * e + n * t
    }
    function Bn (e) {
      return 0 === (e & (e - 1)) && 0 !== e
    }
    function zn (e) {
      return Math.pow(2, Math.ceil(Math.log(e) / Math.LN2))
    }
    function Un (e) {
      return Math.pow(2, Math.floor(Math.log(e) / Math.LN2))
    }
    class kn {
      constructor (e = 0, t = 0) {
        ;(this.x = e), (this.y = t)
      }
      get width () {
        return this.x
      }
      set width (e) {
        this.x = e
      }
      get height () {
        return this.y
      }
      set height (e) {
        this.y = e
      }
      set (e, t) {
        return (this.x = e), (this.y = t), this
      }
      setScalar (e) {
        return (this.x = e), (this.y = e), this
      }
      setX (e) {
        return (this.x = e), this
      }
      setY (e) {
        return (this.y = e), this
      }
      setComponent (e, t) {
        switch (e) {
          case 0:
            this.x = t
            break
          case 1:
            this.y = t
            break
          default:
            throw new Error('index is out of range: ' + e)
        }
        return this
      }
      getComponent (e) {
        switch (e) {
          case 0:
            return this.x
          case 1:
            return this.y
          default:
            throw new Error('index is out of range: ' + e)
        }
      }
      clone () {
        return new this.constructor(this.x, this.y)
      }
      copy (e) {
        return (this.x = e.x), (this.y = e.y), this
      }
      add (e, t) {
        return void 0 !== t
          ? (console.warn(
              'THREE.Vector2: .add() now only accepts one argument. Use .addVectors( a, b ) instead.'
            ),
            this.addVectors(e, t))
          : ((this.x += e.x), (this.y += e.y), this)
      }
      addScalar (e) {
        return (this.x += e), (this.y += e), this
      }
      addVectors (e, t) {
        return (this.x = e.x + t.x), (this.y = e.y + t.y), this
      }
      addScaledVector (e, t) {
        return (this.x += e.x * t), (this.y += e.y * t), this
      }
      sub (e, t) {
        return void 0 !== t
          ? (console.warn(
              'THREE.Vector2: .sub() now only accepts one argument. Use .subVectors( a, b ) instead.'
            ),
            this.subVectors(e, t))
          : ((this.x -= e.x), (this.y -= e.y), this)
      }
      subScalar (e) {
        return (this.x -= e), (this.y -= e), this
      }
      subVectors (e, t) {
        return (this.x = e.x - t.x), (this.y = e.y - t.y), this
      }
      multiply (e) {
        return (this.x *= e.x), (this.y *= e.y), this
      }
      multiplyScalar (e) {
        return (this.x *= e), (this.y *= e), this
      }
      divide (e) {
        return (this.x /= e.x), (this.y /= e.y), this
      }
      divideScalar (e) {
        return this.multiplyScalar(1 / e)
      }
      applyMatrix3 (e) {
        const t = this.x,
          n = this.y,
          i = e.elements
        return (
          (this.x = i[0] * t + i[3] * n + i[6]),
          (this.y = i[1] * t + i[4] * n + i[7]),
          this
        )
      }
      min (e) {
        return (
          (this.x = Math.min(this.x, e.x)),
          (this.y = Math.min(this.y, e.y)),
          this
        )
      }
      max (e) {
        return (
          (this.x = Math.max(this.x, e.x)),
          (this.y = Math.max(this.y, e.y)),
          this
        )
      }
      clamp (e, t) {
        return (
          (this.x = Math.max(e.x, Math.min(t.x, this.x))),
          (this.y = Math.max(e.y, Math.min(t.y, this.y))),
          this
        )
      }
      clampScalar (e, t) {
        return (
          (this.x = Math.max(e, Math.min(t, this.x))),
          (this.y = Math.max(e, Math.min(t, this.y))),
          this
        )
      }
      clampLength (e, t) {
        const n = this.length()
        return this.divideScalar(n || 1).multiplyScalar(
          Math.max(e, Math.min(t, n))
        )
      }
      floor () {
        return (
          (this.x = Math.floor(this.x)), (this.y = Math.floor(this.y)), this
        )
      }
      ceil () {
        return (this.x = Math.ceil(this.x)), (this.y = Math.ceil(this.y)), this
      }
      round () {
        return (
          (this.x = Math.round(this.x)), (this.y = Math.round(this.y)), this
        )
      }
      roundToZero () {
        return (
          (this.x = this.x < 0 ? Math.ceil(this.x) : Math.floor(this.x)),
          (this.y = this.y < 0 ? Math.ceil(this.y) : Math.floor(this.y)),
          this
        )
      }
      negate () {
        return (this.x = -this.x), (this.y = -this.y), this
      }
      dot (e) {
        return this.x * e.x + this.y * e.y
      }
      cross (e) {
        return this.x * e.y - this.y * e.x
      }
      lengthSq () {
        return this.x * this.x + this.y * this.y
      }
      length () {
        return Math.sqrt(this.x * this.x + this.y * this.y)
      }
      manhattanLength () {
        return Math.abs(this.x) + Math.abs(this.y)
      }
      normalize () {
        return this.divideScalar(this.length() || 1)
      }
      angle () {
        const e = Math.atan2(-this.y, -this.x) + Math.PI
        return e
      }
      distanceTo (e) {
        return Math.sqrt(this.distanceToSquared(e))
      }
      distanceToSquared (e) {
        const t = this.x - e.x,
          n = this.y - e.y
        return t * t + n * n
      }
      manhattanDistanceTo (e) {
        return Math.abs(this.x - e.x) + Math.abs(this.y - e.y)
      }
      setLength (e) {
        return this.normalize().multiplyScalar(e)
      }
      lerp (e, t) {
        return (
          (this.x += (e.x - this.x) * t), (this.y += (e.y - this.y) * t), this
        )
      }
      lerpVectors (e, t, n) {
        return (
          (this.x = e.x + (t.x - e.x) * n),
          (this.y = e.y + (t.y - e.y) * n),
          this
        )
      }
      equals (e) {
        return e.x === this.x && e.y === this.y
      }
      fromArray (e, t = 0) {
        return (this.x = e[t]), (this.y = e[t + 1]), this
      }
      toArray (e = [], t = 0) {
        return (e[t] = this.x), (e[t + 1] = this.y), e
      }
      fromBufferAttribute (e, t, n) {
        return (
          void 0 !== n &&
            console.warn(
              'THREE.Vector2: offset has been removed from .fromBufferAttribute().'
            ),
          (this.x = e.getX(t)),
          (this.y = e.getY(t)),
          this
        )
      }
      rotateAround (e, t) {
        const n = Math.cos(t),
          i = Math.sin(t),
          r = this.x - e.x,
          a = this.y - e.y
        return (
          (this.x = r * n - a * i + e.x), (this.y = r * i + a * n + e.y), this
        )
      }
      random () {
        return (this.x = Math.random()), (this.y = Math.random()), this
      }
    }
    kn.prototype.isVector2 = !0
    class Hn {
      constructor () {
        ;(this.elements = [1, 0, 0, 0, 1, 0, 0, 0, 1]),
          arguments.length > 0 &&
            console.error(
              'THREE.Matrix3: the constructor no longer reads arguments. use .set() instead.'
            )
      }
      set (e, t, n, i, r, a, s, o, l) {
        const c = this.elements
        return (
          (c[0] = e),
          (c[1] = i),
          (c[2] = s),
          (c[3] = t),
          (c[4] = r),
          (c[5] = o),
          (c[6] = n),
          (c[7] = a),
          (c[8] = l),
          this
        )
      }
      identity () {
        return this.set(1, 0, 0, 0, 1, 0, 0, 0, 1), this
      }
      copy (e) {
        const t = this.elements,
          n = e.elements
        return (
          (t[0] = n[0]),
          (t[1] = n[1]),
          (t[2] = n[2]),
          (t[3] = n[3]),
          (t[4] = n[4]),
          (t[5] = n[5]),
          (t[6] = n[6]),
          (t[7] = n[7]),
          (t[8] = n[8]),
          this
        )
      }
      extractBasis (e, t, n) {
        return (
          e.setFromMatrix3Column(this, 0),
          t.setFromMatrix3Column(this, 1),
          n.setFromMatrix3Column(this, 2),
          this
        )
      }
      setFromMatrix4 (e) {
        const t = e.elements
        return (
          this.set(t[0], t[4], t[8], t[1], t[5], t[9], t[2], t[6], t[10]), this
        )
      }
      multiply (e) {
        return this.multiplyMatrices(this, e)
      }
      premultiply (e) {
        return this.multiplyMatrices(e, this)
      }
      multiplyMatrices (e, t) {
        const n = e.elements,
          i = t.elements,
          r = this.elements,
          a = n[0],
          s = n[3],
          o = n[6],
          l = n[1],
          c = n[4],
          h = n[7],
          u = n[2],
          d = n[5],
          p = n[8],
          f = i[0],
          m = i[3],
          g = i[6],
          v = i[1],
          y = i[4],
          _ = i[7],
          x = i[2],
          w = i[5],
          b = i[8]
        return (
          (r[0] = a * f + s * v + o * x),
          (r[3] = a * m + s * y + o * w),
          (r[6] = a * g + s * _ + o * b),
          (r[1] = l * f + c * v + h * x),
          (r[4] = l * m + c * y + h * w),
          (r[7] = l * g + c * _ + h * b),
          (r[2] = u * f + d * v + p * x),
          (r[5] = u * m + d * y + p * w),
          (r[8] = u * g + d * _ + p * b),
          this
        )
      }
      multiplyScalar (e) {
        const t = this.elements
        return (
          (t[0] *= e),
          (t[3] *= e),
          (t[6] *= e),
          (t[1] *= e),
          (t[4] *= e),
          (t[7] *= e),
          (t[2] *= e),
          (t[5] *= e),
          (t[8] *= e),
          this
        )
      }
      determinant () {
        const e = this.elements,
          t = e[0],
          n = e[1],
          i = e[2],
          r = e[3],
          a = e[4],
          s = e[5],
          o = e[6],
          l = e[7],
          c = e[8]
        return (
          t * a * c - t * s * l - n * r * c + n * s * o + i * r * l - i * a * o
        )
      }
      invert () {
        const e = this.elements,
          t = e[0],
          n = e[1],
          i = e[2],
          r = e[3],
          a = e[4],
          s = e[5],
          o = e[6],
          l = e[7],
          c = e[8],
          h = c * a - s * l,
          u = s * o - c * r,
          d = l * r - a * o,
          p = t * h + n * u + i * d
        if (0 === p) return this.set(0, 0, 0, 0, 0, 0, 0, 0, 0)
        const f = 1 / p
        return (
          (e[0] = h * f),
          (e[1] = (i * l - c * n) * f),
          (e[2] = (s * n - i * a) * f),
          (e[3] = u * f),
          (e[4] = (c * t - i * o) * f),
          (e[5] = (i * r - s * t) * f),
          (e[6] = d * f),
          (e[7] = (n * o - l * t) * f),
          (e[8] = (a * t - n * r) * f),
          this
        )
      }
      transpose () {
        let e
        const t = this.elements
        return (
          (e = t[1]),
          (t[1] = t[3]),
          (t[3] = e),
          (e = t[2]),
          (t[2] = t[6]),
          (t[6] = e),
          (e = t[5]),
          (t[5] = t[7]),
          (t[7] = e),
          this
        )
      }
      getNormalMatrix (e) {
        return this.setFromMatrix4(e)
          .invert()
          .transpose()
      }
      transposeIntoArray (e) {
        const t = this.elements
        return (
          (e[0] = t[0]),
          (e[1] = t[3]),
          (e[2] = t[6]),
          (e[3] = t[1]),
          (e[4] = t[4]),
          (e[5] = t[7]),
          (e[6] = t[2]),
          (e[7] = t[5]),
          (e[8] = t[8]),
          this
        )
      }
      setUvTransform (e, t, n, i, r, a, s) {
        const o = Math.cos(r),
          l = Math.sin(r)
        return (
          this.set(
            n * o,
            n * l,
            -n * (o * a + l * s) + a + e,
            -i * l,
            i * o,
            -i * (-l * a + o * s) + s + t,
            0,
            0,
            1
          ),
          this
        )
      }
      scale (e, t) {
        const n = this.elements
        return (
          (n[0] *= e),
          (n[3] *= e),
          (n[6] *= e),
          (n[1] *= t),
          (n[4] *= t),
          (n[7] *= t),
          this
        )
      }
      rotate (e) {
        const t = Math.cos(e),
          n = Math.sin(e),
          i = this.elements,
          r = i[0],
          a = i[3],
          s = i[6],
          o = i[1],
          l = i[4],
          c = i[7]
        return (
          (i[0] = t * r + n * o),
          (i[3] = t * a + n * l),
          (i[6] = t * s + n * c),
          (i[1] = -n * r + t * o),
          (i[4] = -n * a + t * l),
          (i[7] = -n * s + t * c),
          this
        )
      }
      translate (e, t) {
        const n = this.elements
        return (
          (n[0] += e * n[2]),
          (n[3] += e * n[5]),
          (n[6] += e * n[8]),
          (n[1] += t * n[2]),
          (n[4] += t * n[5]),
          (n[7] += t * n[8]),
          this
        )
      }
      equals (e) {
        const t = this.elements,
          n = e.elements
        for (let i = 0; i < 9; i++) if (t[i] !== n[i]) return !1
        return !0
      }
      fromArray (e, t = 0) {
        for (let n = 0; n < 9; n++) this.elements[n] = e[n + t]
        return this
      }
      toArray (e = [], t = 0) {
        const n = this.elements
        return (
          (e[t] = n[0]),
          (e[t + 1] = n[1]),
          (e[t + 2] = n[2]),
          (e[t + 3] = n[3]),
          (e[t + 4] = n[4]),
          (e[t + 5] = n[5]),
          (e[t + 6] = n[6]),
          (e[t + 7] = n[7]),
          (e[t + 8] = n[8]),
          e
        )
      }
      clone () {
        return new this.constructor().fromArray(this.elements)
      }
    }
    let Wn
    Hn.prototype.isMatrix3 = !0
    class Vn {
      static getDataURL (e) {
        if (/^data:/i.test(e.src)) return e.src
        if ('undefined' == typeof HTMLCanvasElement) return e.src
        let t
        if (e instanceof HTMLCanvasElement) t = e
        else {
          void 0 === Wn &&
            (Wn = document.createElementNS(
              'http://www.w3.org/1999/xhtml',
              'canvas'
            )),
            (Wn.width = e.width),
            (Wn.height = e.height)
          const n = Wn.getContext('2d')
          e instanceof ImageData
            ? n.putImageData(e, 0, 0)
            : n.drawImage(e, 0, 0, e.width, e.height),
            (t = Wn)
        }
        return t.width > 2048 || t.height > 2048
          ? (console.warn(
              'THREE.ImageUtils.getDataURL: Image converted to jpg for performance reasons',
              e
            ),
            t.toDataURL('image/jpeg', 0.6))
          : t.toDataURL('image/png')
      }
    }
    let Gn = 0
    class jn extends Ln {
      constructor (
        e = jn.DEFAULT_IMAGE,
        t = jn.DEFAULT_MAPPING,
        n = Ne,
        i = Ne,
        r = Ue,
        a = He,
        s = nt,
        o = We,
        l = 1,
        c = dn
      ) {
        super(),
          Object.defineProperty(this, 'id', { value: Gn++ }),
          (this.uuid = In()),
          (this.name = ''),
          (this.image = e),
          (this.mipmaps = []),
          (this.mapping = t),
          (this.wrapS = n),
          (this.wrapT = i),
          (this.magFilter = r),
          (this.minFilter = a),
          (this.anisotropy = l),
          (this.format = s),
          (this.internalFormat = null),
          (this.type = o),
          (this.offset = new kn(0, 0)),
          (this.repeat = new kn(1, 1)),
          (this.center = new kn(0, 0)),
          (this.rotation = 0),
          (this.matrixAutoUpdate = !0),
          (this.matrix = new Hn()),
          (this.generateMipmaps = !0),
          (this.premultiplyAlpha = !1),
          (this.flipY = !0),
          (this.unpackAlignment = 4),
          (this.encoding = c),
          (this.version = 0),
          (this.onUpdate = null)
      }
      updateMatrix () {
        this.matrix.setUvTransform(
          this.offset.x,
          this.offset.y,
          this.repeat.x,
          this.repeat.y,
          this.rotation,
          this.center.x,
          this.center.y
        )
      }
      clone () {
        return new this.constructor().copy(this)
      }
      copy (e) {
        return (
          (this.name = e.name),
          (this.image = e.image),
          (this.mipmaps = e.mipmaps.slice(0)),
          (this.mapping = e.mapping),
          (this.wrapS = e.wrapS),
          (this.wrapT = e.wrapT),
          (this.magFilter = e.magFilter),
          (this.minFilter = e.minFilter),
          (this.anisotropy = e.anisotropy),
          (this.format = e.format),
          (this.internalFormat = e.internalFormat),
          (this.type = e.type),
          this.offset.copy(e.offset),
          this.repeat.copy(e.repeat),
          this.center.copy(e.center),
          (this.rotation = e.rotation),
          (this.matrixAutoUpdate = e.matrixAutoUpdate),
          this.matrix.copy(e.matrix),
          (this.generateMipmaps = e.generateMipmaps),
          (this.premultiplyAlpha = e.premultiplyAlpha),
          (this.flipY = e.flipY),
          (this.unpackAlignment = e.unpackAlignment),
          (this.encoding = e.encoding),
          this
        )
      }
      toJSON (e) {
        const t = void 0 === e || 'string' === typeof e
        if (!t && void 0 !== e.textures[this.uuid]) return e.textures[this.uuid]
        const n = {
          metadata: {
            version: 4.5,
            type: 'Texture',
            generator: 'Texture.toJSON'
          },
          uuid: this.uuid,
          name: this.name,
          mapping: this.mapping,
          repeat: [this.repeat.x, this.repeat.y],
          offset: [this.offset.x, this.offset.y],
          center: [this.center.x, this.center.y],
          rotation: this.rotation,
          wrap: [this.wrapS, this.wrapT],
          format: this.format,
          type: this.type,
          encoding: this.encoding,
          minFilter: this.minFilter,
          magFilter: this.magFilter,
          anisotropy: this.anisotropy,
          flipY: this.flipY,
          premultiplyAlpha: this.premultiplyAlpha,
          unpackAlignment: this.unpackAlignment
        }
        if (void 0 !== this.image) {
          const i = this.image
          if (
            (void 0 === i.uuid && (i.uuid = In()),
            !t && void 0 === e.images[i.uuid])
          ) {
            let t
            if (Array.isArray(i)) {
              t = []
              for (let e = 0, n = i.length; e < n; e++)
                i[e].isDataTexture ? t.push(qn(i[e].image)) : t.push(qn(i[e]))
            } else t = qn(i)
            e.images[i.uuid] = { uuid: i.uuid, url: t }
          }
          n.image = i.uuid
        }
        return t || (e.textures[this.uuid] = n), n
      }
      dispose () {
        this.dispatchEvent({ type: 'dispose' })
      }
      transformUv (e) {
        if (this.mapping !== Te) return e
        if ((e.applyMatrix3(this.matrix), e.x < 0 || e.x > 1))
          switch (this.wrapS) {
            case Ie:
              e.x = e.x - Math.floor(e.x)
              break
            case Ne:
              e.x = e.x < 0 ? 0 : 1
              break
            case Oe:
              1 === Math.abs(Math.floor(e.x) % 2)
                ? (e.x = Math.ceil(e.x) - e.x)
                : (e.x = e.x - Math.floor(e.x))
              break
          }
        if (e.y < 0 || e.y > 1)
          switch (this.wrapT) {
            case Ie:
              e.y = e.y - Math.floor(e.y)
              break
            case Ne:
              e.y = e.y < 0 ? 0 : 1
              break
            case Oe:
              1 === Math.abs(Math.floor(e.y) % 2)
                ? (e.y = Math.ceil(e.y) - e.y)
                : (e.y = e.y - Math.floor(e.y))
              break
          }
        return this.flipY && (e.y = 1 - e.y), e
      }
      set needsUpdate (e) {
        !0 === e && this.version++
      }
    }
    function qn (e) {
      return ('undefined' !== typeof HTMLImageElement &&
        e instanceof HTMLImageElement) ||
        ('undefined' !== typeof HTMLCanvasElement &&
          e instanceof HTMLCanvasElement) ||
        ('undefined' !== typeof ImageBitmap && e instanceof ImageBitmap)
        ? Vn.getDataURL(e)
        : e.data
        ? {
            data: Array.prototype.slice.call(e.data),
            width: e.width,
            height: e.height,
            type: e.data.constructor.name
          }
        : (console.warn('THREE.Texture: Unable to serialize Texture.'), {})
    }
    ;(jn.DEFAULT_IMAGE = void 0),
      (jn.DEFAULT_MAPPING = Te),
      (jn.prototype.isTexture = !0)
    class Yn {
      constructor (e = 0, t = 0, n = 0, i = 1) {
        ;(this.x = e), (this.y = t), (this.z = n), (this.w = i)
      }
      get width () {
        return this.z
      }
      set width (e) {
        this.z = e
      }
      get height () {
        return this.w
      }
      set height (e) {
        this.w = e
      }
      set (e, t, n, i) {
        return (this.x = e), (this.y = t), (this.z = n), (this.w = i), this
      }
      setScalar (e) {
        return (this.x = e), (this.y = e), (this.z = e), (this.w = e), this
      }
      setX (e) {
        return (this.x = e), this
      }
      setY (e) {
        return (this.y = e), this
      }
      setZ (e) {
        return (this.z = e), this
      }
      setW (e) {
        return (this.w = e), this
      }
      setComponent (e, t) {
        switch (e) {
          case 0:
            this.x = t
            break
          case 1:
            this.y = t
            break
          case 2:
            this.z = t
            break
          case 3:
            this.w = t
            break
          default:
            throw new Error('index is out of range: ' + e)
        }
        return this
      }
      getComponent (e) {
        switch (e) {
          case 0:
            return this.x
          case 1:
            return this.y
          case 2:
            return this.z
          case 3:
            return this.w
          default:
            throw new Error('index is out of range: ' + e)
        }
      }
      clone () {
        return new this.constructor(this.x, this.y, this.z, this.w)
      }
      copy (e) {
        return (
          (this.x = e.x),
          (this.y = e.y),
          (this.z = e.z),
          (this.w = void 0 !== e.w ? e.w : 1),
          this
        )
      }
      add (e, t) {
        return void 0 !== t
          ? (console.warn(
              'THREE.Vector4: .add() now only accepts one argument. Use .addVectors( a, b ) instead.'
            ),
            this.addVectors(e, t))
          : ((this.x += e.x),
            (this.y += e.y),
            (this.z += e.z),
            (this.w += e.w),
            this)
      }
      addScalar (e) {
        return (this.x += e), (this.y += e), (this.z += e), (this.w += e), this
      }
      addVectors (e, t) {
        return (
          (this.x = e.x + t.x),
          (this.y = e.y + t.y),
          (this.z = e.z + t.z),
          (this.w = e.w + t.w),
          this
        )
      }
      addScaledVector (e, t) {
        return (
          (this.x += e.x * t),
          (this.y += e.y * t),
          (this.z += e.z * t),
          (this.w += e.w * t),
          this
        )
      }
      sub (e, t) {
        return void 0 !== t
          ? (console.warn(
              'THREE.Vector4: .sub() now only accepts one argument. Use .subVectors( a, b ) instead.'
            ),
            this.subVectors(e, t))
          : ((this.x -= e.x),
            (this.y -= e.y),
            (this.z -= e.z),
            (this.w -= e.w),
            this)
      }
      subScalar (e) {
        return (this.x -= e), (this.y -= e), (this.z -= e), (this.w -= e), this
      }
      subVectors (e, t) {
        return (
          (this.x = e.x - t.x),
          (this.y = e.y - t.y),
          (this.z = e.z - t.z),
          (this.w = e.w - t.w),
          this
        )
      }
      multiply (e) {
        return (
          (this.x *= e.x),
          (this.y *= e.y),
          (this.z *= e.z),
          (this.w *= e.w),
          this
        )
      }
      multiplyScalar (e) {
        return (this.x *= e), (this.y *= e), (this.z *= e), (this.w *= e), this
      }
      applyMatrix4 (e) {
        const t = this.x,
          n = this.y,
          i = this.z,
          r = this.w,
          a = e.elements
        return (
          (this.x = a[0] * t + a[4] * n + a[8] * i + a[12] * r),
          (this.y = a[1] * t + a[5] * n + a[9] * i + a[13] * r),
          (this.z = a[2] * t + a[6] * n + a[10] * i + a[14] * r),
          (this.w = a[3] * t + a[7] * n + a[11] * i + a[15] * r),
          this
        )
      }
      divideScalar (e) {
        return this.multiplyScalar(1 / e)
      }
      setAxisAngleFromQuaternion (e) {
        this.w = 2 * Math.acos(e.w)
        const t = Math.sqrt(1 - e.w * e.w)
        return (
          t < 1e-4
            ? ((this.x = 1), (this.y = 0), (this.z = 0))
            : ((this.x = e.x / t), (this.y = e.y / t), (this.z = e.z / t)),
          this
        )
      }
      setAxisAngleFromRotationMatrix (e) {
        let t, n, i, r
        const a = 0.01,
          s = 0.1,
          o = e.elements,
          l = o[0],
          c = o[4],
          h = o[8],
          u = o[1],
          d = o[5],
          p = o[9],
          f = o[2],
          m = o[6],
          g = o[10]
        if (Math.abs(c - u) < a && Math.abs(h - f) < a && Math.abs(p - m) < a) {
          if (
            Math.abs(c + u) < s &&
            Math.abs(h + f) < s &&
            Math.abs(p + m) < s &&
            Math.abs(l + d + g - 3) < s
          )
            return this.set(1, 0, 0, 0), this
          t = Math.PI
          const e = (l + 1) / 2,
            o = (d + 1) / 2,
            v = (g + 1) / 2,
            y = (c + u) / 4,
            _ = (h + f) / 4,
            x = (p + m) / 4
          return (
            e > o && e > v
              ? e < a
                ? ((n = 0), (i = 0.707106781), (r = 0.707106781))
                : ((n = Math.sqrt(e)), (i = y / n), (r = _ / n))
              : o > v
              ? o < a
                ? ((n = 0.707106781), (i = 0), (r = 0.707106781))
                : ((i = Math.sqrt(o)), (n = y / i), (r = x / i))
              : v < a
              ? ((n = 0.707106781), (i = 0.707106781), (r = 0))
              : ((r = Math.sqrt(v)), (n = _ / r), (i = x / r)),
            this.set(n, i, r, t),
            this
          )
        }
        let v = Math.sqrt(
          (m - p) * (m - p) + (h - f) * (h - f) + (u - c) * (u - c)
        )
        return (
          Math.abs(v) < 0.001 && (v = 1),
          (this.x = (m - p) / v),
          (this.y = (h - f) / v),
          (this.z = (u - c) / v),
          (this.w = Math.acos((l + d + g - 1) / 2)),
          this
        )
      }
      min (e) {
        return (
          (this.x = Math.min(this.x, e.x)),
          (this.y = Math.min(this.y, e.y)),
          (this.z = Math.min(this.z, e.z)),
          (this.w = Math.min(this.w, e.w)),
          this
        )
      }
      max (e) {
        return (
          (this.x = Math.max(this.x, e.x)),
          (this.y = Math.max(this.y, e.y)),
          (this.z = Math.max(this.z, e.z)),
          (this.w = Math.max(this.w, e.w)),
          this
        )
      }
      clamp (e, t) {
        return (
          (this.x = Math.max(e.x, Math.min(t.x, this.x))),
          (this.y = Math.max(e.y, Math.min(t.y, this.y))),
          (this.z = Math.max(e.z, Math.min(t.z, this.z))),
          (this.w = Math.max(e.w, Math.min(t.w, this.w))),
          this
        )
      }
      clampScalar (e, t) {
        return (
          (this.x = Math.max(e, Math.min(t, this.x))),
          (this.y = Math.max(e, Math.min(t, this.y))),
          (this.z = Math.max(e, Math.min(t, this.z))),
          (this.w = Math.max(e, Math.min(t, this.w))),
          this
        )
      }
      clampLength (e, t) {
        const n = this.length()
        return this.divideScalar(n || 1).multiplyScalar(
          Math.max(e, Math.min(t, n))
        )
      }
      floor () {
        return (
          (this.x = Math.floor(this.x)),
          (this.y = Math.floor(this.y)),
          (this.z = Math.floor(this.z)),
          (this.w = Math.floor(this.w)),
          this
        )
      }
      ceil () {
        return (
          (this.x = Math.ceil(this.x)),
          (this.y = Math.ceil(this.y)),
          (this.z = Math.ceil(this.z)),
          (this.w = Math.ceil(this.w)),
          this
        )
      }
      round () {
        return (
          (this.x = Math.round(this.x)),
          (this.y = Math.round(this.y)),
          (this.z = Math.round(this.z)),
          (this.w = Math.round(this.w)),
          this
        )
      }
      roundToZero () {
        return (
          (this.x = this.x < 0 ? Math.ceil(this.x) : Math.floor(this.x)),
          (this.y = this.y < 0 ? Math.ceil(this.y) : Math.floor(this.y)),
          (this.z = this.z < 0 ? Math.ceil(this.z) : Math.floor(this.z)),
          (this.w = this.w < 0 ? Math.ceil(this.w) : Math.floor(this.w)),
          this
        )
      }
      negate () {
        return (
          (this.x = -this.x),
          (this.y = -this.y),
          (this.z = -this.z),
          (this.w = -this.w),
          this
        )
      }
      dot (e) {
        return this.x * e.x + this.y * e.y + this.z * e.z + this.w * e.w
      }
      lengthSq () {
        return (
          this.x * this.x + this.y * this.y + this.z * this.z + this.w * this.w
        )
      }
      length () {
        return Math.sqrt(
          this.x * this.x + this.y * this.y + this.z * this.z + this.w * this.w
        )
      }
      manhattanLength () {
        return (
          Math.abs(this.x) +
          Math.abs(this.y) +
          Math.abs(this.z) +
          Math.abs(this.w)
        )
      }
      normalize () {
        return this.divideScalar(this.length() || 1)
      }
      setLength (e) {
        return this.normalize().multiplyScalar(e)
      }
      lerp (e, t) {
        return (
          (this.x += (e.x - this.x) * t),
          (this.y += (e.y - this.y) * t),
          (this.z += (e.z - this.z) * t),
          (this.w += (e.w - this.w) * t),
          this
        )
      }
      lerpVectors (e, t, n) {
        return (
          (this.x = e.x + (t.x - e.x) * n),
          (this.y = e.y + (t.y - e.y) * n),
          (this.z = e.z + (t.z - e.z) * n),
          (this.w = e.w + (t.w - e.w) * n),
          this
        )
      }
      equals (e) {
        return (
          e.x === this.x && e.y === this.y && e.z === this.z && e.w === this.w
        )
      }
      fromArray (e, t = 0) {
        return (
          (this.x = e[t]),
          (this.y = e[t + 1]),
          (this.z = e[t + 2]),
          (this.w = e[t + 3]),
          this
        )
      }
      toArray (e = [], t = 0) {
        return (
          (e[t] = this.x),
          (e[t + 1] = this.y),
          (e[t + 2] = this.z),
          (e[t + 3] = this.w),
          e
        )
      }
      fromBufferAttribute (e, t, n) {
        return (
          void 0 !== n &&
            console.warn(
              'THREE.Vector4: offset has been removed from .fromBufferAttribute().'
            ),
          (this.x = e.getX(t)),
          (this.y = e.getY(t)),
          (this.z = e.getZ(t)),
          (this.w = e.getW(t)),
          this
        )
      }
      random () {
        return (
          (this.x = Math.random()),
          (this.y = Math.random()),
          (this.z = Math.random()),
          (this.w = Math.random()),
          this
        )
      }
    }
    Yn.prototype.isVector4 = !0
    class Xn extends Ln {
      constructor (e, t, n = {}) {
        super(),
          (this.width = e),
          (this.height = t),
          (this.depth = 1),
          (this.scissor = new Yn(0, 0, e, t)),
          (this.scissorTest = !1),
          (this.viewport = new Yn(0, 0, e, t)),
          (this.texture = new jn(
            void 0,
            n.mapping,
            n.wrapS,
            n.wrapT,
            n.magFilter,
            n.minFilter,
            n.format,
            n.type,
            n.anisotropy,
            n.encoding
          )),
          (this.texture.image = { width: e, height: t, depth: 1 }),
          (this.texture.generateMipmaps =
            void 0 !== n.generateMipmaps && n.generateMipmaps),
          (this.texture.minFilter = void 0 !== n.minFilter ? n.minFilter : Ue),
          (this.depthBuffer = void 0 === n.depthBuffer || n.depthBuffer),
          (this.stencilBuffer = void 0 !== n.stencilBuffer && n.stencilBuffer),
          (this.depthTexture =
            void 0 !== n.depthTexture ? n.depthTexture : null)
      }
      setTexture (e) {
        ;(e.image = {
          width: this.width,
          height: this.height,
          depth: this.depth
        }),
          (this.texture = e)
      }
      setSize (e, t, n = 1) {
        ;(this.width === e && this.height === t && this.depth === n) ||
          ((this.width = e),
          (this.height = t),
          (this.depth = n),
          (this.texture.image.width = e),
          (this.texture.image.height = t),
          (this.texture.image.depth = n),
          this.dispose()),
          this.viewport.set(0, 0, e, t),
          this.scissor.set(0, 0, e, t)
      }
      clone () {
        return new this.constructor().copy(this)
      }
      copy (e) {
        return (
          (this.width = e.width),
          (this.height = e.height),
          (this.depth = e.depth),
          this.viewport.copy(e.viewport),
          (this.texture = e.texture.clone()),
          (this.texture.image = { ...this.texture.image }),
          (this.depthBuffer = e.depthBuffer),
          (this.stencilBuffer = e.stencilBuffer),
          (this.depthTexture = e.depthTexture),
          this
        )
      }
      dispose () {
        this.dispatchEvent({ type: 'dispose' })
      }
    }
    Xn.prototype.isWebGLRenderTarget = !0
    class Jn extends Xn {
      constructor (e, t, n) {
        super(e, t)
        const i = this.texture
        this.texture = []
        for (let r = 0; r < n; r++) this.texture[r] = i.clone()
      }
      setSize (e, t, n = 1) {
        if (this.width !== e || this.height !== t || this.depth !== n) {
          ;(this.width = e), (this.height = t), (this.depth = n)
          for (let i = 0, r = this.texture.length; i < r; i++)
            (this.texture[i].image.width = e),
              (this.texture[i].image.height = t),
              (this.texture[i].image.depth = n)
          this.dispose()
        }
        return this.viewport.set(0, 0, e, t), this.scissor.set(0, 0, e, t), this
      }
      copy (e) {
        this.dispose(),
          (this.width = e.width),
          (this.height = e.height),
          (this.depth = e.depth),
          this.viewport.set(0, 0, this.width, this.height),
          this.scissor.set(0, 0, this.width, this.height),
          (this.depthBuffer = e.depthBuffer),
          (this.stencilBuffer = e.stencilBuffer),
          (this.depthTexture = e.depthTexture),
          (this.texture.length = 0)
        for (let t = 0, n = e.texture.length; t < n; t++)
          this.texture[t] = e.texture[t].clone()
        return this
      }
    }
    Jn.prototype.isWebGLMultipleRenderTargets = !0
    class Zn extends Xn {
      constructor (e, t, n) {
        super(e, t, n), (this.samples = 4)
      }
      copy (e) {
        return super.copy.call(this, e), (this.samples = e.samples), this
      }
    }
    Zn.prototype.isWebGLMultisampleRenderTarget = !0
    class Kn {
      constructor (e = 0, t = 0, n = 0, i = 1) {
        ;(this._x = e), (this._y = t), (this._z = n), (this._w = i)
      }
      static slerp (e, t, n, i) {
        return (
          console.warn(
            'THREE.Quaternion: Static .slerp() has been deprecated. Use qm.slerpQuaternions( qa, qb, t ) instead.'
          ),
          n.slerpQuaternions(e, t, i)
        )
      }
      static slerpFlat (e, t, n, i, r, a, s) {
        let o = n[i + 0],
          l = n[i + 1],
          c = n[i + 2],
          h = n[i + 3]
        const u = r[a + 0],
          d = r[a + 1],
          p = r[a + 2],
          f = r[a + 3]
        if (0 === s)
          return (
            (e[t + 0] = o), (e[t + 1] = l), (e[t + 2] = c), void (e[t + 3] = h)
          )
        if (1 === s)
          return (
            (e[t + 0] = u), (e[t + 1] = d), (e[t + 2] = p), void (e[t + 3] = f)
          )
        if (h !== f || o !== u || l !== d || c !== p) {
          let e = 1 - s
          const t = o * u + l * d + c * p + h * f,
            n = t >= 0 ? 1 : -1,
            i = 1 - t * t
          if (i > Number.EPSILON) {
            const r = Math.sqrt(i),
              a = Math.atan2(r, t * n)
            ;(e = Math.sin(e * a) / r), (s = Math.sin(s * a) / r)
          }
          const r = s * n
          if (
            ((o = o * e + u * r),
            (l = l * e + d * r),
            (c = c * e + p * r),
            (h = h * e + f * r),
            e === 1 - s)
          ) {
            const e = 1 / Math.sqrt(o * o + l * l + c * c + h * h)
            ;(o *= e), (l *= e), (c *= e), (h *= e)
          }
        }
        ;(e[t] = o), (e[t + 1] = l), (e[t + 2] = c), (e[t + 3] = h)
      }
      static multiplyQuaternionsFlat (e, t, n, i, r, a) {
        const s = n[i],
          o = n[i + 1],
          l = n[i + 2],
          c = n[i + 3],
          h = r[a],
          u = r[a + 1],
          d = r[a + 2],
          p = r[a + 3]
        return (
          (e[t] = s * p + c * h + o * d - l * u),
          (e[t + 1] = o * p + c * u + l * h - s * d),
          (e[t + 2] = l * p + c * d + s * u - o * h),
          (e[t + 3] = c * p - s * h - o * u - l * d),
          e
        )
      }
      get x () {
        return this._x
      }
      set x (e) {
        ;(this._x = e), this._onChangeCallback()
      }
      get y () {
        return this._y
      }
      set y (e) {
        ;(this._y = e), this._onChangeCallback()
      }
      get z () {
        return this._z
      }
      set z (e) {
        ;(this._z = e), this._onChangeCallback()
      }
      get w () {
        return this._w
      }
      set w (e) {
        ;(this._w = e), this._onChangeCallback()
      }
      set (e, t, n, i) {
        return (
          (this._x = e),
          (this._y = t),
          (this._z = n),
          (this._w = i),
          this._onChangeCallback(),
          this
        )
      }
      clone () {
        return new this.constructor(this._x, this._y, this._z, this._w)
      }
      copy (e) {
        return (
          (this._x = e.x),
          (this._y = e.y),
          (this._z = e.z),
          (this._w = e.w),
          this._onChangeCallback(),
          this
        )
      }
      setFromEuler (e, t) {
        if (!e || !e.isEuler)
          throw new Error(
            'THREE.Quaternion: .setFromEuler() now expects an Euler rotation rather than a Vector3 and order.'
          )
        const n = e._x,
          i = e._y,
          r = e._z,
          a = e._order,
          s = Math.cos,
          o = Math.sin,
          l = s(n / 2),
          c = s(i / 2),
          h = s(r / 2),
          u = o(n / 2),
          d = o(i / 2),
          p = o(r / 2)
        switch (a) {
          case 'XYZ':
            ;(this._x = u * c * h + l * d * p),
              (this._y = l * d * h - u * c * p),
              (this._z = l * c * p + u * d * h),
              (this._w = l * c * h - u * d * p)
            break
          case 'YXZ':
            ;(this._x = u * c * h + l * d * p),
              (this._y = l * d * h - u * c * p),
              (this._z = l * c * p - u * d * h),
              (this._w = l * c * h + u * d * p)
            break
          case 'ZXY':
            ;(this._x = u * c * h - l * d * p),
              (this._y = l * d * h + u * c * p),
              (this._z = l * c * p + u * d * h),
              (this._w = l * c * h - u * d * p)
            break
          case 'ZYX':
            ;(this._x = u * c * h - l * d * p),
              (this._y = l * d * h + u * c * p),
              (this._z = l * c * p - u * d * h),
              (this._w = l * c * h + u * d * p)
            break
          case 'YZX':
            ;(this._x = u * c * h + l * d * p),
              (this._y = l * d * h + u * c * p),
              (this._z = l * c * p - u * d * h),
              (this._w = l * c * h - u * d * p)
            break
          case 'XZY':
            ;(this._x = u * c * h - l * d * p),
              (this._y = l * d * h - u * c * p),
              (this._z = l * c * p + u * d * h),
              (this._w = l * c * h + u * d * p)
            break
          default:
            console.warn(
              'THREE.Quaternion: .setFromEuler() encountered an unknown order: ' +
                a
            )
        }
        return !1 !== t && this._onChangeCallback(), this
      }
      setFromAxisAngle (e, t) {
        const n = t / 2,
          i = Math.sin(n)
        return (
          (this._x = e.x * i),
          (this._y = e.y * i),
          (this._z = e.z * i),
          (this._w = Math.cos(n)),
          this._onChangeCallback(),
          this
        )
      }
      setFromRotationMatrix (e) {
        const t = e.elements,
          n = t[0],
          i = t[4],
          r = t[8],
          a = t[1],
          s = t[5],
          o = t[9],
          l = t[2],
          c = t[6],
          h = t[10],
          u = n + s + h
        if (u > 0) {
          const e = 0.5 / Math.sqrt(u + 1)
          ;(this._w = 0.25 / e),
            (this._x = (c - o) * e),
            (this._y = (r - l) * e),
            (this._z = (a - i) * e)
        } else if (n > s && n > h) {
          const e = 2 * Math.sqrt(1 + n - s - h)
          ;(this._w = (c - o) / e),
            (this._x = 0.25 * e),
            (this._y = (i + a) / e),
            (this._z = (r + l) / e)
        } else if (s > h) {
          const e = 2 * Math.sqrt(1 + s - n - h)
          ;(this._w = (r - l) / e),
            (this._x = (i + a) / e),
            (this._y = 0.25 * e),
            (this._z = (o + c) / e)
        } else {
          const e = 2 * Math.sqrt(1 + h - n - s)
          ;(this._w = (a - i) / e),
            (this._x = (r + l) / e),
            (this._y = (o + c) / e),
            (this._z = 0.25 * e)
        }
        return this._onChangeCallback(), this
      }
      setFromUnitVectors (e, t) {
        let n = e.dot(t) + 1
        return (
          n < Number.EPSILON
            ? ((n = 0),
              Math.abs(e.x) > Math.abs(e.z)
                ? ((this._x = -e.y),
                  (this._y = e.x),
                  (this._z = 0),
                  (this._w = n))
                : ((this._x = 0),
                  (this._y = -e.z),
                  (this._z = e.y),
                  (this._w = n)))
            : ((this._x = e.y * t.z - e.z * t.y),
              (this._y = e.z * t.x - e.x * t.z),
              (this._z = e.x * t.y - e.y * t.x),
              (this._w = n)),
          this.normalize()
        )
      }
      angleTo (e) {
        return 2 * Math.acos(Math.abs(Nn(this.dot(e), -1, 1)))
      }
      rotateTowards (e, t) {
        const n = this.angleTo(e)
        if (0 === n) return this
        const i = Math.min(1, t / n)
        return this.slerp(e, i), this
      }
      identity () {
        return this.set(0, 0, 0, 1)
      }
      invert () {
        return this.conjugate()
      }
      conjugate () {
        return (
          (this._x *= -1),
          (this._y *= -1),
          (this._z *= -1),
          this._onChangeCallback(),
          this
        )
      }
      dot (e) {
        return this._x * e._x + this._y * e._y + this._z * e._z + this._w * e._w
      }
      lengthSq () {
        return (
          this._x * this._x +
          this._y * this._y +
          this._z * this._z +
          this._w * this._w
        )
      }
      length () {
        return Math.sqrt(
          this._x * this._x +
            this._y * this._y +
            this._z * this._z +
            this._w * this._w
        )
      }
      normalize () {
        let e = this.length()
        return (
          0 === e
            ? ((this._x = 0), (this._y = 0), (this._z = 0), (this._w = 1))
            : ((e = 1 / e),
              (this._x = this._x * e),
              (this._y = this._y * e),
              (this._z = this._z * e),
              (this._w = this._w * e)),
          this._onChangeCallback(),
          this
        )
      }
      multiply (e, t) {
        return void 0 !== t
          ? (console.warn(
              'THREE.Quaternion: .multiply() now only accepts one argument. Use .multiplyQuaternions( a, b ) instead.'
            ),
            this.multiplyQuaternions(e, t))
          : this.multiplyQuaternions(this, e)
      }
      premultiply (e) {
        return this.multiplyQuaternions(e, this)
      }
      multiplyQuaternions (e, t) {
        const n = e._x,
          i = e._y,
          r = e._z,
          a = e._w,
          s = t._x,
          o = t._y,
          l = t._z,
          c = t._w
        return (
          (this._x = n * c + a * s + i * l - r * o),
          (this._y = i * c + a * o + r * s - n * l),
          (this._z = r * c + a * l + n * o - i * s),
          (this._w = a * c - n * s - i * o - r * l),
          this._onChangeCallback(),
          this
        )
      }
      slerp (e, t) {
        if (0 === t) return this
        if (1 === t) return this.copy(e)
        const n = this._x,
          i = this._y,
          r = this._z,
          a = this._w
        let s = a * e._w + n * e._x + i * e._y + r * e._z
        if (
          (s < 0
            ? ((this._w = -e._w),
              (this._x = -e._x),
              (this._y = -e._y),
              (this._z = -e._z),
              (s = -s))
            : this.copy(e),
          s >= 1)
        )
          return (
            (this._w = a), (this._x = n), (this._y = i), (this._z = r), this
          )
        const o = 1 - s * s
        if (o <= Number.EPSILON) {
          const e = 1 - t
          return (
            (this._w = e * a + t * this._w),
            (this._x = e * n + t * this._x),
            (this._y = e * i + t * this._y),
            (this._z = e * r + t * this._z),
            this.normalize(),
            this._onChangeCallback(),
            this
          )
        }
        const l = Math.sqrt(o),
          c = Math.atan2(l, s),
          h = Math.sin((1 - t) * c) / l,
          u = Math.sin(t * c) / l
        return (
          (this._w = a * h + this._w * u),
          (this._x = n * h + this._x * u),
          (this._y = i * h + this._y * u),
          (this._z = r * h + this._z * u),
          this._onChangeCallback(),
          this
        )
      }
      slerpQuaternions (e, t, n) {
        this.copy(e).slerp(t, n)
      }
      equals (e) {
        return (
          e._x === this._x &&
          e._y === this._y &&
          e._z === this._z &&
          e._w === this._w
        )
      }
      fromArray (e, t = 0) {
        return (
          (this._x = e[t]),
          (this._y = e[t + 1]),
          (this._z = e[t + 2]),
          (this._w = e[t + 3]),
          this._onChangeCallback(),
          this
        )
      }
      toArray (e = [], t = 0) {
        return (
          (e[t] = this._x),
          (e[t + 1] = this._y),
          (e[t + 2] = this._z),
          (e[t + 3] = this._w),
          e
        )
      }
      fromBufferAttribute (e, t) {
        return (
          (this._x = e.getX(t)),
          (this._y = e.getY(t)),
          (this._z = e.getZ(t)),
          (this._w = e.getW(t)),
          this
        )
      }
      _onChange (e) {
        return (this._onChangeCallback = e), this
      }
      _onChangeCallback () {}
    }
    Kn.prototype.isQuaternion = !0
    class Qn {
      constructor (e = 0, t = 0, n = 0) {
        ;(this.x = e), (this.y = t), (this.z = n)
      }
      set (e, t, n) {
        return (
          void 0 === n && (n = this.z),
          (this.x = e),
          (this.y = t),
          (this.z = n),
          this
        )
      }
      setScalar (e) {
        return (this.x = e), (this.y = e), (this.z = e), this
      }
      setX (e) {
        return (this.x = e), this
      }
      setY (e) {
        return (this.y = e), this
      }
      setZ (e) {
        return (this.z = e), this
      }
      setComponent (e, t) {
        switch (e) {
          case 0:
            this.x = t
            break
          case 1:
            this.y = t
            break
          case 2:
            this.z = t
            break
          default:
            throw new Error('index is out of range: ' + e)
        }
        return this
      }
      getComponent (e) {
        switch (e) {
          case 0:
            return this.x
          case 1:
            return this.y
          case 2:
            return this.z
          default:
            throw new Error('index is out of range: ' + e)
        }
      }
      clone () {
        return new this.constructor(this.x, this.y, this.z)
      }
      copy (e) {
        return (this.x = e.x), (this.y = e.y), (this.z = e.z), this
      }
      add (e, t) {
        return void 0 !== t
          ? (console.warn(
              'THREE.Vector3: .add() now only accepts one argument. Use .addVectors( a, b ) instead.'
            ),
            this.addVectors(e, t))
          : ((this.x += e.x), (this.y += e.y), (this.z += e.z), this)
      }
      addScalar (e) {
        return (this.x += e), (this.y += e), (this.z += e), this
      }
      addVectors (e, t) {
        return (
          (this.x = e.x + t.x), (this.y = e.y + t.y), (this.z = e.z + t.z), this
        )
      }
      addScaledVector (e, t) {
        return (
          (this.x += e.x * t), (this.y += e.y * t), (this.z += e.z * t), this
        )
      }
      sub (e, t) {
        return void 0 !== t
          ? (console.warn(
              'THREE.Vector3: .sub() now only accepts one argument. Use .subVectors( a, b ) instead.'
            ),
            this.subVectors(e, t))
          : ((this.x -= e.x), (this.y -= e.y), (this.z -= e.z), this)
      }
      subScalar (e) {
        return (this.x -= e), (this.y -= e), (this.z -= e), this
      }
      subVectors (e, t) {
        return (
          (this.x = e.x - t.x), (this.y = e.y - t.y), (this.z = e.z - t.z), this
        )
      }
      multiply (e, t) {
        return void 0 !== t
          ? (console.warn(
              'THREE.Vector3: .multiply() now only accepts one argument. Use .multiplyVectors( a, b ) instead.'
            ),
            this.multiplyVectors(e, t))
          : ((this.x *= e.x), (this.y *= e.y), (this.z *= e.z), this)
      }
      multiplyScalar (e) {
        return (this.x *= e), (this.y *= e), (this.z *= e), this
      }
      multiplyVectors (e, t) {
        return (
          (this.x = e.x * t.x), (this.y = e.y * t.y), (this.z = e.z * t.z), this
        )
      }
      applyEuler (e) {
        return (
          (e && e.isEuler) ||
            console.error(
              'THREE.Vector3: .applyEuler() now expects an Euler rotation rather than a Vector3 and order.'
            ),
          this.applyQuaternion(ei.setFromEuler(e))
        )
      }
      applyAxisAngle (e, t) {
        return this.applyQuaternion(ei.setFromAxisAngle(e, t))
      }
      applyMatrix3 (e) {
        const t = this.x,
          n = this.y,
          i = this.z,
          r = e.elements
        return (
          (this.x = r[0] * t + r[3] * n + r[6] * i),
          (this.y = r[1] * t + r[4] * n + r[7] * i),
          (this.z = r[2] * t + r[5] * n + r[8] * i),
          this
        )
      }
      applyNormalMatrix (e) {
        return this.applyMatrix3(e).normalize()
      }
      applyMatrix4 (e) {
        const t = this.x,
          n = this.y,
          i = this.z,
          r = e.elements,
          a = 1 / (r[3] * t + r[7] * n + r[11] * i + r[15])
        return (
          (this.x = (r[0] * t + r[4] * n + r[8] * i + r[12]) * a),
          (this.y = (r[1] * t + r[5] * n + r[9] * i + r[13]) * a),
          (this.z = (r[2] * t + r[6] * n + r[10] * i + r[14]) * a),
          this
        )
      }
      applyQuaternion (e) {
        const t = this.x,
          n = this.y,
          i = this.z,
          r = e.x,
          a = e.y,
          s = e.z,
          o = e.w,
          l = o * t + a * i - s * n,
          c = o * n + s * t - r * i,
          h = o * i + r * n - a * t,
          u = -r * t - a * n - s * i
        return (
          (this.x = l * o + u * -r + c * -s - h * -a),
          (this.y = c * o + u * -a + h * -r - l * -s),
          (this.z = h * o + u * -s + l * -a - c * -r),
          this
        )
      }
      project (e) {
        return this.applyMatrix4(e.matrixWorldInverse).applyMatrix4(
          e.projectionMatrix
        )
      }
      unproject (e) {
        return this.applyMatrix4(e.projectionMatrixInverse).applyMatrix4(
          e.matrixWorld
        )
      }
      transformDirection (e) {
        const t = this.x,
          n = this.y,
          i = this.z,
          r = e.elements
        return (
          (this.x = r[0] * t + r[4] * n + r[8] * i),
          (this.y = r[1] * t + r[5] * n + r[9] * i),
          (this.z = r[2] * t + r[6] * n + r[10] * i),
          this.normalize()
        )
      }
      divide (e) {
        return (this.x /= e.x), (this.y /= e.y), (this.z /= e.z), this
      }
      divideScalar (e) {
        return this.multiplyScalar(1 / e)
      }
      min (e) {
        return (
          (this.x = Math.min(this.x, e.x)),
          (this.y = Math.min(this.y, e.y)),
          (this.z = Math.min(this.z, e.z)),
          this
        )
      }
      max (e) {
        return (
          (this.x = Math.max(this.x, e.x)),
          (this.y = Math.max(this.y, e.y)),
          (this.z = Math.max(this.z, e.z)),
          this
        )
      }
      clamp (e, t) {
        return (
          (this.x = Math.max(e.x, Math.min(t.x, this.x))),
          (this.y = Math.max(e.y, Math.min(t.y, this.y))),
          (this.z = Math.max(e.z, Math.min(t.z, this.z))),
          this
        )
      }
      clampScalar (e, t) {
        return (
          (this.x = Math.max(e, Math.min(t, this.x))),
          (this.y = Math.max(e, Math.min(t, this.y))),
          (this.z = Math.max(e, Math.min(t, this.z))),
          this
        )
      }
      clampLength (e, t) {
        const n = this.length()
        return this.divideScalar(n || 1).multiplyScalar(
          Math.max(e, Math.min(t, n))
        )
      }
      floor () {
        return (
          (this.x = Math.floor(this.x)),
          (this.y = Math.floor(this.y)),
          (this.z = Math.floor(this.z)),
          this
        )
      }
      ceil () {
        return (
          (this.x = Math.ceil(this.x)),
          (this.y = Math.ceil(this.y)),
          (this.z = Math.ceil(this.z)),
          this
        )
      }
      round () {
        return (
          (this.x = Math.round(this.x)),
          (this.y = Math.round(this.y)),
          (this.z = Math.round(this.z)),
          this
        )
      }
      roundToZero () {
        return (
          (this.x = this.x < 0 ? Math.ceil(this.x) : Math.floor(this.x)),
          (this.y = this.y < 0 ? Math.ceil(this.y) : Math.floor(this.y)),
          (this.z = this.z < 0 ? Math.ceil(this.z) : Math.floor(this.z)),
          this
        )
      }
      negate () {
        return (this.x = -this.x), (this.y = -this.y), (this.z = -this.z), this
      }
      dot (e) {
        return this.x * e.x + this.y * e.y + this.z * e.z
      }
      lengthSq () {
        return this.x * this.x + this.y * this.y + this.z * this.z
      }
      length () {
        return Math.sqrt(this.x * this.x + this.y * this.y + this.z * this.z)
      }
      manhattanLength () {
        return Math.abs(this.x) + Math.abs(this.y) + Math.abs(this.z)
      }
      normalize () {
        return this.divideScalar(this.length() || 1)
      }
      setLength (e) {
        return this.normalize().multiplyScalar(e)
      }
      lerp (e, t) {
        return (
          (this.x += (e.x - this.x) * t),
          (this.y += (e.y - this.y) * t),
          (this.z += (e.z - this.z) * t),
          this
        )
      }
      lerpVectors (e, t, n) {
        return (
          (this.x = e.x + (t.x - e.x) * n),
          (this.y = e.y + (t.y - e.y) * n),
          (this.z = e.z + (t.z - e.z) * n),
          this
        )
      }
      cross (e, t) {
        return void 0 !== t
          ? (console.warn(
              'THREE.Vector3: .cross() now only accepts one argument. Use .crossVectors( a, b ) instead.'
            ),
            this.crossVectors(e, t))
          : this.crossVectors(this, e)
      }
      crossVectors (e, t) {
        const n = e.x,
          i = e.y,
          r = e.z,
          a = t.x,
          s = t.y,
          o = t.z
        return (
          (this.x = i * o - r * s),
          (this.y = r * a - n * o),
          (this.z = n * s - i * a),
          this
        )
      }
      projectOnVector (e) {
        const t = e.lengthSq()
        if (0 === t) return this.set(0, 0, 0)
        const n = e.dot(this) / t
        return this.copy(e).multiplyScalar(n)
      }
      projectOnPlane (e) {
        return $n.copy(this).projectOnVector(e), this.sub($n)
      }
      reflect (e) {
        return this.sub($n.copy(e).multiplyScalar(2 * this.dot(e)))
      }
      angleTo (e) {
        const t = Math.sqrt(this.lengthSq() * e.lengthSq())
        if (0 === t) return Math.PI / 2
        const n = this.dot(e) / t
        return Math.acos(Nn(n, -1, 1))
      }
      distanceTo (e) {
        return Math.sqrt(this.distanceToSquared(e))
      }
      distanceToSquared (e) {
        const t = this.x - e.x,
          n = this.y - e.y,
          i = this.z - e.z
        return t * t + n * n + i * i
      }
      manhattanDistanceTo (e) {
        return (
          Math.abs(this.x - e.x) +
          Math.abs(this.y - e.y) +
          Math.abs(this.z - e.z)
        )
      }
      setFromSpherical (e) {
        return this.setFromSphericalCoords(e.radius, e.phi, e.theta)
      }
      setFromSphericalCoords (e, t, n) {
        const i = Math.sin(t) * e
        return (
          (this.x = i * Math.sin(n)),
          (this.y = Math.cos(t) * e),
          (this.z = i * Math.cos(n)),
          this
        )
      }
      setFromCylindrical (e) {
        return this.setFromCylindricalCoords(e.radius, e.theta, e.y)
      }
      setFromCylindricalCoords (e, t, n) {
        return (
          (this.x = e * Math.sin(t)),
          (this.y = n),
          (this.z = e * Math.cos(t)),
          this
        )
      }
      setFromMatrixPosition (e) {
        const t = e.elements
        return (this.x = t[12]), (this.y = t[13]), (this.z = t[14]), this
      }
      setFromMatrixScale (e) {
        const t = this.setFromMatrixColumn(e, 0).length(),
          n = this.setFromMatrixColumn(e, 1).length(),
          i = this.setFromMatrixColumn(e, 2).length()
        return (this.x = t), (this.y = n), (this.z = i), this
      }
      setFromMatrixColumn (e, t) {
        return this.fromArray(e.elements, 4 * t)
      }
      setFromMatrix3Column (e, t) {
        return this.fromArray(e.elements, 3 * t)
      }
      equals (e) {
        return e.x === this.x && e.y === this.y && e.z === this.z
      }
      fromArray (e, t = 0) {
        return (this.x = e[t]), (this.y = e[t + 1]), (this.z = e[t + 2]), this
      }
      toArray (e = [], t = 0) {
        return (e[t] = this.x), (e[t + 1] = this.y), (e[t + 2] = this.z), e
      }
      fromBufferAttribute (e, t, n) {
        return (
          void 0 !== n &&
            console.warn(
              'THREE.Vector3: offset has been removed from .fromBufferAttribute().'
            ),
          (this.x = e.getX(t)),
          (this.y = e.getY(t)),
          (this.z = e.getZ(t)),
          this
        )
      }
      random () {
        return (
          (this.x = Math.random()),
          (this.y = Math.random()),
          (this.z = Math.random()),
          this
        )
      }
    }
    Qn.prototype.isVector3 = !0
    const $n = new Qn(),
      ei = new Kn()
    class ti {
      constructor (
        e = new Qn(1 / 0, 1 / 0, 1 / 0),
        t = new Qn(-1 / 0, -1 / 0, -1 / 0)
      ) {
        ;(this.min = e), (this.max = t)
      }
      set (e, t) {
        return this.min.copy(e), this.max.copy(t), this
      }
      setFromArray (e) {
        let t = 1 / 0,
          n = 1 / 0,
          i = 1 / 0,
          r = -1 / 0,
          a = -1 / 0,
          s = -1 / 0
        for (let o = 0, l = e.length; o < l; o += 3) {
          const l = e[o],
            c = e[o + 1],
            h = e[o + 2]
          l < t && (t = l),
            c < n && (n = c),
            h < i && (i = h),
            l > r && (r = l),
            c > a && (a = c),
            h > s && (s = h)
        }
        return this.min.set(t, n, i), this.max.set(r, a, s), this
      }
      setFromBufferAttribute (e) {
        let t = 1 / 0,
          n = 1 / 0,
          i = 1 / 0,
          r = -1 / 0,
          a = -1 / 0,
          s = -1 / 0
        for (let o = 0, l = e.count; o < l; o++) {
          const l = e.getX(o),
            c = e.getY(o),
            h = e.getZ(o)
          l < t && (t = l),
            c < n && (n = c),
            h < i && (i = h),
            l > r && (r = l),
            c > a && (a = c),
            h > s && (s = h)
        }
        return this.min.set(t, n, i), this.max.set(r, a, s), this
      }
      setFromPoints (e) {
        this.makeEmpty()
        for (let t = 0, n = e.length; t < n; t++) this.expandByPoint(e[t])
        return this
      }
      setFromCenterAndSize (e, t) {
        const n = ii.copy(t).multiplyScalar(0.5)
        return this.min.copy(e).sub(n), this.max.copy(e).add(n), this
      }
      setFromObject (e) {
        return this.makeEmpty(), this.expandByObject(e)
      }
      clone () {
        return new this.constructor().copy(this)
      }
      copy (e) {
        return this.min.copy(e.min), this.max.copy(e.max), this
      }
      makeEmpty () {
        return (
          (this.min.x = this.min.y = this.min.z = 1 / 0),
          (this.max.x = this.max.y = this.max.z = -1 / 0),
          this
        )
      }
      isEmpty () {
        return (
          this.max.x < this.min.x ||
          this.max.y < this.min.y ||
          this.max.z < this.min.z
        )
      }
      getCenter (e) {
        return this.isEmpty()
          ? e.set(0, 0, 0)
          : e.addVectors(this.min, this.max).multiplyScalar(0.5)
      }
      getSize (e) {
        return this.isEmpty()
          ? e.set(0, 0, 0)
          : e.subVectors(this.max, this.min)
      }
      expandByPoint (e) {
        return this.min.min(e), this.max.max(e), this
      }
      expandByVector (e) {
        return this.min.sub(e), this.max.add(e), this
      }
      expandByScalar (e) {
        return this.min.addScalar(-e), this.max.addScalar(e), this
      }
      expandByObject (e) {
        e.updateWorldMatrix(!1, !1)
        const t = e.geometry
        void 0 !== t &&
          (null === t.boundingBox && t.computeBoundingBox(),
          ri.copy(t.boundingBox),
          ri.applyMatrix4(e.matrixWorld),
          this.union(ri))
        const n = e.children
        for (let i = 0, r = n.length; i < r; i++) this.expandByObject(n[i])
        return this
      }
      containsPoint (e) {
        return !(
          e.x < this.min.x ||
          e.x > this.max.x ||
          e.y < this.min.y ||
          e.y > this.max.y ||
          e.z < this.min.z ||
          e.z > this.max.z
        )
      }
      containsBox (e) {
        return (
          this.min.x <= e.min.x &&
          e.max.x <= this.max.x &&
          this.min.y <= e.min.y &&
          e.max.y <= this.max.y &&
          this.min.z <= e.min.z &&
          e.max.z <= this.max.z
        )
      }
      getParameter (e, t) {
        return t.set(
          (e.x - this.min.x) / (this.max.x - this.min.x),
          (e.y - this.min.y) / (this.max.y - this.min.y),
          (e.z - this.min.z) / (this.max.z - this.min.z)
        )
      }
      intersectsBox (e) {
        return !(
          e.max.x < this.min.x ||
          e.min.x > this.max.x ||
          e.max.y < this.min.y ||
          e.min.y > this.max.y ||
          e.max.z < this.min.z ||
          e.min.z > this.max.z
        )
      }
      intersectsSphere (e) {
        return (
          this.clampPoint(e.center, ii),
          ii.distanceToSquared(e.center) <= e.radius * e.radius
        )
      }
      intersectsPlane (e) {
        let t, n
        return (
          e.normal.x > 0
            ? ((t = e.normal.x * this.min.x), (n = e.normal.x * this.max.x))
            : ((t = e.normal.x * this.max.x), (n = e.normal.x * this.min.x)),
          e.normal.y > 0
            ? ((t += e.normal.y * this.min.y), (n += e.normal.y * this.max.y))
            : ((t += e.normal.y * this.max.y), (n += e.normal.y * this.min.y)),
          e.normal.z > 0
            ? ((t += e.normal.z * this.min.z), (n += e.normal.z * this.max.z))
            : ((t += e.normal.z * this.max.z), (n += e.normal.z * this.min.z)),
          t <= -e.constant && n >= -e.constant
        )
      }
      intersectsTriangle (e) {
        if (this.isEmpty()) return !1
        this.getCenter(ui),
          di.subVectors(this.max, ui),
          ai.subVectors(e.a, ui),
          si.subVectors(e.b, ui),
          oi.subVectors(e.c, ui),
          li.subVectors(si, ai),
          ci.subVectors(oi, si),
          hi.subVectors(ai, oi)
        let t = [
          0,
          -li.z,
          li.y,
          0,
          -ci.z,
          ci.y,
          0,
          -hi.z,
          hi.y,
          li.z,
          0,
          -li.x,
          ci.z,
          0,
          -ci.x,
          hi.z,
          0,
          -hi.x,
          -li.y,
          li.x,
          0,
          -ci.y,
          ci.x,
          0,
          -hi.y,
          hi.x,
          0
        ]
        return (
          !!mi(t, ai, si, oi, di) &&
          ((t = [1, 0, 0, 0, 1, 0, 0, 0, 1]),
          !!mi(t, ai, si, oi, di) &&
            (pi.crossVectors(li, ci),
            (t = [pi.x, pi.y, pi.z]),
            mi(t, ai, si, oi, di)))
        )
      }
      clampPoint (e, t) {
        return t.copy(e).clamp(this.min, this.max)
      }
      distanceToPoint (e) {
        const t = ii.copy(e).clamp(this.min, this.max)
        return t.sub(e).length()
      }
      getBoundingSphere (e) {
        return (
          this.getCenter(e.center),
          (e.radius = 0.5 * this.getSize(ii).length()),
          e
        )
      }
      intersect (e) {
        return (
          this.min.max(e.min),
          this.max.min(e.max),
          this.isEmpty() && this.makeEmpty(),
          this
        )
      }
      union (e) {
        return this.min.min(e.min), this.max.max(e.max), this
      }
      applyMatrix4 (e) {
        return (
          this.isEmpty() ||
            (ni[0].set(this.min.x, this.min.y, this.min.z).applyMatrix4(e),
            ni[1].set(this.min.x, this.min.y, this.max.z).applyMatrix4(e),
            ni[2].set(this.min.x, this.max.y, this.min.z).applyMatrix4(e),
            ni[3].set(this.min.x, this.max.y, this.max.z).applyMatrix4(e),
            ni[4].set(this.max.x, this.min.y, this.min.z).applyMatrix4(e),
            ni[5].set(this.max.x, this.min.y, this.max.z).applyMatrix4(e),
            ni[6].set(this.max.x, this.max.y, this.min.z).applyMatrix4(e),
            ni[7].set(this.max.x, this.max.y, this.max.z).applyMatrix4(e),
            this.setFromPoints(ni)),
          this
        )
      }
      translate (e) {
        return this.min.add(e), this.max.add(e), this
      }
      equals (e) {
        return e.min.equals(this.min) && e.max.equals(this.max)
      }
    }
    ti.prototype.isBox3 = !0
    const ni = [
        new Qn(),
        new Qn(),
        new Qn(),
        new Qn(),
        new Qn(),
        new Qn(),
        new Qn(),
        new Qn()
      ],
      ii = new Qn(),
      ri = new ti(),
      ai = new Qn(),
      si = new Qn(),
      oi = new Qn(),
      li = new Qn(),
      ci = new Qn(),
      hi = new Qn(),
      ui = new Qn(),
      di = new Qn(),
      pi = new Qn(),
      fi = new Qn()
    function mi (e, t, n, i, r) {
      for (let a = 0, s = e.length - 3; a <= s; a += 3) {
        fi.fromArray(e, a)
        const s =
            r.x * Math.abs(fi.x) + r.y * Math.abs(fi.y) + r.z * Math.abs(fi.z),
          o = t.dot(fi),
          l = n.dot(fi),
          c = i.dot(fi)
        if (Math.max(-Math.max(o, l, c), Math.min(o, l, c)) > s) return !1
      }
      return !0
    }
    const gi = new ti(),
      vi = new Qn(),
      yi = new Qn(),
      _i = new Qn()
    class xi {
      constructor (e = new Qn(), t = -1) {
        ;(this.center = e), (this.radius = t)
      }
      set (e, t) {
        return this.center.copy(e), (this.radius = t), this
      }
      setFromPoints (e, t) {
        const n = this.center
        void 0 !== t ? n.copy(t) : gi.setFromPoints(e).getCenter(n)
        let i = 0
        for (let r = 0, a = e.length; r < a; r++)
          i = Math.max(i, n.distanceToSquared(e[r]))
        return (this.radius = Math.sqrt(i)), this
      }
      copy (e) {
        return this.center.copy(e.center), (this.radius = e.radius), this
      }
      isEmpty () {
        return this.radius < 0
      }
      makeEmpty () {
        return this.center.set(0, 0, 0), (this.radius = -1), this
      }
      containsPoint (e) {
        return e.distanceToSquared(this.center) <= this.radius * this.radius
      }
      distanceToPoint (e) {
        return e.distanceTo(this.center) - this.radius
      }
      intersectsSphere (e) {
        const t = this.radius + e.radius
        return e.center.distanceToSquared(this.center) <= t * t
      }
      intersectsBox (e) {
        return e.intersectsSphere(this)
      }
      intersectsPlane (e) {
        return Math.abs(e.distanceToPoint(this.center)) <= this.radius
      }
      clampPoint (e, t) {
        const n = this.center.distanceToSquared(e)
        return (
          t.copy(e),
          n > this.radius * this.radius &&
            (t.sub(this.center).normalize(),
            t.multiplyScalar(this.radius).add(this.center)),
          t
        )
      }
      getBoundingBox (e) {
        return this.isEmpty()
          ? (e.makeEmpty(), e)
          : (e.set(this.center, this.center), e.expandByScalar(this.radius), e)
      }
      applyMatrix4 (e) {
        return (
          this.center.applyMatrix4(e),
          (this.radius = this.radius * e.getMaxScaleOnAxis()),
          this
        )
      }
      translate (e) {
        return this.center.add(e), this
      }
      expandByPoint (e) {
        _i.subVectors(e, this.center)
        const t = _i.lengthSq()
        if (t > this.radius * this.radius) {
          const e = Math.sqrt(t),
            n = 0.5 * (e - this.radius)
          this.center.add(_i.multiplyScalar(n / e)), (this.radius += n)
        }
        return this
      }
      union (e) {
        return (
          yi
            .subVectors(e.center, this.center)
            .normalize()
            .multiplyScalar(e.radius),
          this.expandByPoint(vi.copy(e.center).add(yi)),
          this.expandByPoint(vi.copy(e.center).sub(yi)),
          this
        )
      }
      equals (e) {
        return e.center.equals(this.center) && e.radius === this.radius
      }
      clone () {
        return new this.constructor().copy(this)
      }
    }
    const wi = new Qn(),
      bi = new Qn(),
      Mi = new Qn(),
      Si = new Qn(),
      Ei = new Qn(),
      Ti = new Qn(),
      Ai = new Qn()
    class Ri {
      constructor (e = new Qn(), t = new Qn(0, 0, -1)) {
        ;(this.origin = e), (this.direction = t)
      }
      set (e, t) {
        return this.origin.copy(e), this.direction.copy(t), this
      }
      copy (e) {
        return (
          this.origin.copy(e.origin), this.direction.copy(e.direction), this
        )
      }
      at (e, t) {
        return t
          .copy(this.direction)
          .multiplyScalar(e)
          .add(this.origin)
      }
      lookAt (e) {
        return (
          this.direction
            .copy(e)
            .sub(this.origin)
            .normalize(),
          this
        )
      }
      recast (e) {
        return this.origin.copy(this.at(e, wi)), this
      }
      closestPointToPoint (e, t) {
        t.subVectors(e, this.origin)
        const n = t.dot(this.direction)
        return n < 0
          ? t.copy(this.origin)
          : t
              .copy(this.direction)
              .multiplyScalar(n)
              .add(this.origin)
      }
      distanceToPoint (e) {
        return Math.sqrt(this.distanceSqToPoint(e))
      }
      distanceSqToPoint (e) {
        const t = wi.subVectors(e, this.origin).dot(this.direction)
        return t < 0
          ? this.origin.distanceToSquared(e)
          : (wi
              .copy(this.direction)
              .multiplyScalar(t)
              .add(this.origin),
            wi.distanceToSquared(e))
      }
      distanceSqToSegment (e, t, n, i) {
        bi
          .copy(e)
          .add(t)
          .multiplyScalar(0.5),
          Mi.copy(t)
            .sub(e)
            .normalize(),
          Si.copy(this.origin).sub(bi)
        const r = 0.5 * e.distanceTo(t),
          a = -this.direction.dot(Mi),
          s = Si.dot(this.direction),
          o = -Si.dot(Mi),
          l = Si.lengthSq(),
          c = Math.abs(1 - a * a)
        let h, u, d, p
        if (c > 0)
          if (((h = a * o - s), (u = a * s - o), (p = r * c), h >= 0))
            if (u >= -p)
              if (u <= p) {
                const e = 1 / c
                ;(h *= e),
                  (u *= e),
                  (d = h * (h + a * u + 2 * s) + u * (a * h + u + 2 * o) + l)
              } else
                (u = r),
                  (h = Math.max(0, -(a * u + s))),
                  (d = -h * h + u * (u + 2 * o) + l)
            else
              (u = -r),
                (h = Math.max(0, -(a * u + s))),
                (d = -h * h + u * (u + 2 * o) + l)
          else
            u <= -p
              ? ((h = Math.max(0, -(-a * r + s))),
                (u = h > 0 ? -r : Math.min(Math.max(-r, -o), r)),
                (d = -h * h + u * (u + 2 * o) + l))
              : u <= p
              ? ((h = 0),
                (u = Math.min(Math.max(-r, -o), r)),
                (d = u * (u + 2 * o) + l))
              : ((h = Math.max(0, -(a * r + s))),
                (u = h > 0 ? r : Math.min(Math.max(-r, -o), r)),
                (d = -h * h + u * (u + 2 * o) + l))
        else
          (u = a > 0 ? -r : r),
            (h = Math.max(0, -(a * u + s))),
            (d = -h * h + u * (u + 2 * o) + l)
        return (
          n &&
            n
              .copy(this.direction)
              .multiplyScalar(h)
              .add(this.origin),
          i &&
            i
              .copy(Mi)
              .multiplyScalar(u)
              .add(bi),
          d
        )
      }
      intersectSphere (e, t) {
        wi.subVectors(e.center, this.origin)
        const n = wi.dot(this.direction),
          i = wi.dot(wi) - n * n,
          r = e.radius * e.radius
        if (i > r) return null
        const a = Math.sqrt(r - i),
          s = n - a,
          o = n + a
        return s < 0 && o < 0 ? null : s < 0 ? this.at(o, t) : this.at(s, t)
      }
      intersectsSphere (e) {
        return this.distanceSqToPoint(e.center) <= e.radius * e.radius
      }
      distanceToPlane (e) {
        const t = e.normal.dot(this.direction)
        if (0 === t) return 0 === e.distanceToPoint(this.origin) ? 0 : null
        const n = -(this.origin.dot(e.normal) + e.constant) / t
        return n >= 0 ? n : null
      }
      intersectPlane (e, t) {
        const n = this.distanceToPlane(e)
        return null === n ? null : this.at(n, t)
      }
      intersectsPlane (e) {
        const t = e.distanceToPoint(this.origin)
        if (0 === t) return !0
        const n = e.normal.dot(this.direction)
        return n * t < 0
      }
      intersectBox (e, t) {
        let n, i, r, a, s, o
        const l = 1 / this.direction.x,
          c = 1 / this.direction.y,
          h = 1 / this.direction.z,
          u = this.origin
        return (
          l >= 0
            ? ((n = (e.min.x - u.x) * l), (i = (e.max.x - u.x) * l))
            : ((n = (e.max.x - u.x) * l), (i = (e.min.x - u.x) * l)),
          c >= 0
            ? ((r = (e.min.y - u.y) * c), (a = (e.max.y - u.y) * c))
            : ((r = (e.max.y - u.y) * c), (a = (e.min.y - u.y) * c)),
          n > a || r > i
            ? null
            : ((r > n || n !== n) && (n = r),
              (a < i || i !== i) && (i = a),
              h >= 0
                ? ((s = (e.min.z - u.z) * h), (o = (e.max.z - u.z) * h))
                : ((s = (e.max.z - u.z) * h), (o = (e.min.z - u.z) * h)),
              n > o || s > i
                ? null
                : ((s > n || n !== n) && (n = s),
                  (o < i || i !== i) && (i = o),
                  i < 0 ? null : this.at(n >= 0 ? n : i, t)))
        )
      }
      intersectsBox (e) {
        return null !== this.intersectBox(e, wi)
      }
      intersectTriangle (e, t, n, i, r) {
        Ei.subVectors(t, e), Ti.subVectors(n, e), Ai.crossVectors(Ei, Ti)
        let a,
          s = this.direction.dot(Ai)
        if (s > 0) {
          if (i) return null
          a = 1
        } else {
          if (!(s < 0)) return null
          ;(a = -1), (s = -s)
        }
        Si.subVectors(this.origin, e)
        const o = a * this.direction.dot(Ti.crossVectors(Si, Ti))
        if (o < 0) return null
        const l = a * this.direction.dot(Ei.cross(Si))
        if (l < 0) return null
        if (o + l > s) return null
        const c = -a * Si.dot(Ai)
        return c < 0 ? null : this.at(c / s, r)
      }
      applyMatrix4 (e) {
        return (
          this.origin.applyMatrix4(e),
          this.direction.transformDirection(e),
          this
        )
      }
      equals (e) {
        return (
          e.origin.equals(this.origin) && e.direction.equals(this.direction)
        )
      }
      clone () {
        return new this.constructor().copy(this)
      }
    }
    class Li {
      constructor () {
        ;(this.elements = [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1]),
          arguments.length > 0 &&
            console.error(
              'THREE.Matrix4: the constructor no longer reads arguments. use .set() instead.'
            )
      }
      set (e, t, n, i, r, a, s, o, l, c, h, u, d, p, f, m) {
        const g = this.elements
        return (
          (g[0] = e),
          (g[4] = t),
          (g[8] = n),
          (g[12] = i),
          (g[1] = r),
          (g[5] = a),
          (g[9] = s),
          (g[13] = o),
          (g[2] = l),
          (g[6] = c),
          (g[10] = h),
          (g[14] = u),
          (g[3] = d),
          (g[7] = p),
          (g[11] = f),
          (g[15] = m),
          this
        )
      }
      identity () {
        return this.set(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1), this
      }
      clone () {
        return new Li().fromArray(this.elements)
      }
      copy (e) {
        const t = this.elements,
          n = e.elements
        return (
          (t[0] = n[0]),
          (t[1] = n[1]),
          (t[2] = n[2]),
          (t[3] = n[3]),
          (t[4] = n[4]),
          (t[5] = n[5]),
          (t[6] = n[6]),
          (t[7] = n[7]),
          (t[8] = n[8]),
          (t[9] = n[9]),
          (t[10] = n[10]),
          (t[11] = n[11]),
          (t[12] = n[12]),
          (t[13] = n[13]),
          (t[14] = n[14]),
          (t[15] = n[15]),
          this
        )
      }
      copyPosition (e) {
        const t = this.elements,
          n = e.elements
        return (t[12] = n[12]), (t[13] = n[13]), (t[14] = n[14]), this
      }
      setFromMatrix3 (e) {
        const t = e.elements
        return (
          this.set(
            t[0],
            t[3],
            t[6],
            0,
            t[1],
            t[4],
            t[7],
            0,
            t[2],
            t[5],
            t[8],
            0,
            0,
            0,
            0,
            1
          ),
          this
        )
      }
      extractBasis (e, t, n) {
        return (
          e.setFromMatrixColumn(this, 0),
          t.setFromMatrixColumn(this, 1),
          n.setFromMatrixColumn(this, 2),
          this
        )
      }
      makeBasis (e, t, n) {
        return (
          this.set(
            e.x,
            t.x,
            n.x,
            0,
            e.y,
            t.y,
            n.y,
            0,
            e.z,
            t.z,
            n.z,
            0,
            0,
            0,
            0,
            1
          ),
          this
        )
      }
      extractRotation (e) {
        const t = this.elements,
          n = e.elements,
          i = 1 / Ci.setFromMatrixColumn(e, 0).length(),
          r = 1 / Ci.setFromMatrixColumn(e, 1).length(),
          a = 1 / Ci.setFromMatrixColumn(e, 2).length()
        return (
          (t[0] = n[0] * i),
          (t[1] = n[1] * i),
          (t[2] = n[2] * i),
          (t[3] = 0),
          (t[4] = n[4] * r),
          (t[5] = n[5] * r),
          (t[6] = n[6] * r),
          (t[7] = 0),
          (t[8] = n[8] * a),
          (t[9] = n[9] * a),
          (t[10] = n[10] * a),
          (t[11] = 0),
          (t[12] = 0),
          (t[13] = 0),
          (t[14] = 0),
          (t[15] = 1),
          this
        )
      }
      makeRotationFromEuler (e) {
        ;(e && e.isEuler) ||
          console.error(
            'THREE.Matrix4: .makeRotationFromEuler() now expects a Euler rotation rather than a Vector3 and order.'
          )
        const t = this.elements,
          n = e.x,
          i = e.y,
          r = e.z,
          a = Math.cos(n),
          s = Math.sin(n),
          o = Math.cos(i),
          l = Math.sin(i),
          c = Math.cos(r),
          h = Math.sin(r)
        if ('XYZ' === e.order) {
          const e = a * c,
            n = a * h,
            i = s * c,
            r = s * h
          ;(t[0] = o * c),
            (t[4] = -o * h),
            (t[8] = l),
            (t[1] = n + i * l),
            (t[5] = e - r * l),
            (t[9] = -s * o),
            (t[2] = r - e * l),
            (t[6] = i + n * l),
            (t[10] = a * o)
        } else if ('YXZ' === e.order) {
          const e = o * c,
            n = o * h,
            i = l * c,
            r = l * h
          ;(t[0] = e + r * s),
            (t[4] = i * s - n),
            (t[8] = a * l),
            (t[1] = a * h),
            (t[5] = a * c),
            (t[9] = -s),
            (t[2] = n * s - i),
            (t[6] = r + e * s),
            (t[10] = a * o)
        } else if ('ZXY' === e.order) {
          const e = o * c,
            n = o * h,
            i = l * c,
            r = l * h
          ;(t[0] = e - r * s),
            (t[4] = -a * h),
            (t[8] = i + n * s),
            (t[1] = n + i * s),
            (t[5] = a * c),
            (t[9] = r - e * s),
            (t[2] = -a * l),
            (t[6] = s),
            (t[10] = a * o)
        } else if ('ZYX' === e.order) {
          const e = a * c,
            n = a * h,
            i = s * c,
            r = s * h
          ;(t[0] = o * c),
            (t[4] = i * l - n),
            (t[8] = e * l + r),
            (t[1] = o * h),
            (t[5] = r * l + e),
            (t[9] = n * l - i),
            (t[2] = -l),
            (t[6] = s * o),
            (t[10] = a * o)
        } else if ('YZX' === e.order) {
          const e = a * o,
            n = a * l,
            i = s * o,
            r = s * l
          ;(t[0] = o * c),
            (t[4] = r - e * h),
            (t[8] = i * h + n),
            (t[1] = h),
            (t[5] = a * c),
            (t[9] = -s * c),
            (t[2] = -l * c),
            (t[6] = n * h + i),
            (t[10] = e - r * h)
        } else if ('XZY' === e.order) {
          const e = a * o,
            n = a * l,
            i = s * o,
            r = s * l
          ;(t[0] = o * c),
            (t[4] = -h),
            (t[8] = l * c),
            (t[1] = e * h + r),
            (t[5] = a * c),
            (t[9] = n * h - i),
            (t[2] = i * h - n),
            (t[6] = s * c),
            (t[10] = r * h + e)
        }
        return (
          (t[3] = 0),
          (t[7] = 0),
          (t[11] = 0),
          (t[12] = 0),
          (t[13] = 0),
          (t[14] = 0),
          (t[15] = 1),
          this
        )
      }
      makeRotationFromQuaternion (e) {
        return this.compose(
          Di,
          e,
          Ii
        )
      }
      lookAt (e, t, n) {
        const i = this.elements
        return (
          Fi.subVectors(e, t),
          0 === Fi.lengthSq() && (Fi.z = 1),
          Fi.normalize(),
          Ni.crossVectors(n, Fi),
          0 === Ni.lengthSq() &&
            (1 === Math.abs(n.z) ? (Fi.x += 1e-4) : (Fi.z += 1e-4),
            Fi.normalize(),
            Ni.crossVectors(n, Fi)),
          Ni.normalize(),
          Oi.crossVectors(Fi, Ni),
          (i[0] = Ni.x),
          (i[4] = Oi.x),
          (i[8] = Fi.x),
          (i[1] = Ni.y),
          (i[5] = Oi.y),
          (i[9] = Fi.y),
          (i[2] = Ni.z),
          (i[6] = Oi.z),
          (i[10] = Fi.z),
          this
        )
      }
      multiply (e, t) {
        return void 0 !== t
          ? (console.warn(
              'THREE.Matrix4: .multiply() now only accepts one argument. Use .multiplyMatrices( a, b ) instead.'
            ),
            this.multiplyMatrices(e, t))
          : this.multiplyMatrices(this, e)
      }
      premultiply (e) {
        return this.multiplyMatrices(e, this)
      }
      multiplyMatrices (e, t) {
        const n = e.elements,
          i = t.elements,
          r = this.elements,
          a = n[0],
          s = n[4],
          o = n[8],
          l = n[12],
          c = n[1],
          h = n[5],
          u = n[9],
          d = n[13],
          p = n[2],
          f = n[6],
          m = n[10],
          g = n[14],
          v = n[3],
          y = n[7],
          _ = n[11],
          x = n[15],
          w = i[0],
          b = i[4],
          M = i[8],
          S = i[12],
          E = i[1],
          T = i[5],
          A = i[9],
          R = i[13],
          L = i[2],
          C = i[6],
          P = i[10],
          D = i[14],
          I = i[3],
          N = i[7],
          O = i[11],
          F = i[15]
        return (
          (r[0] = a * w + s * E + o * L + l * I),
          (r[4] = a * b + s * T + o * C + l * N),
          (r[8] = a * M + s * A + o * P + l * O),
          (r[12] = a * S + s * R + o * D + l * F),
          (r[1] = c * w + h * E + u * L + d * I),
          (r[5] = c * b + h * T + u * C + d * N),
          (r[9] = c * M + h * A + u * P + d * O),
          (r[13] = c * S + h * R + u * D + d * F),
          (r[2] = p * w + f * E + m * L + g * I),
          (r[6] = p * b + f * T + m * C + g * N),
          (r[10] = p * M + f * A + m * P + g * O),
          (r[14] = p * S + f * R + m * D + g * F),
          (r[3] = v * w + y * E + _ * L + x * I),
          (r[7] = v * b + y * T + _ * C + x * N),
          (r[11] = v * M + y * A + _ * P + x * O),
          (r[15] = v * S + y * R + _ * D + x * F),
          this
        )
      }
      multiplyScalar (e) {
        const t = this.elements
        return (
          (t[0] *= e),
          (t[4] *= e),
          (t[8] *= e),
          (t[12] *= e),
          (t[1] *= e),
          (t[5] *= e),
          (t[9] *= e),
          (t[13] *= e),
          (t[2] *= e),
          (t[6] *= e),
          (t[10] *= e),
          (t[14] *= e),
          (t[3] *= e),
          (t[7] *= e),
          (t[11] *= e),
          (t[15] *= e),
          this
        )
      }
      determinant () {
        const e = this.elements,
          t = e[0],
          n = e[4],
          i = e[8],
          r = e[12],
          a = e[1],
          s = e[5],
          o = e[9],
          l = e[13],
          c = e[2],
          h = e[6],
          u = e[10],
          d = e[14],
          p = e[3],
          f = e[7],
          m = e[11],
          g = e[15]
        return (
          p *
            (+r * o * h -
              i * l * h -
              r * s * u +
              n * l * u +
              i * s * d -
              n * o * d) +
          f *
            (+t * o * d -
              t * l * u +
              r * a * u -
              i * a * d +
              i * l * c -
              r * o * c) +
          m *
            (+t * l * h -
              t * s * d -
              r * a * h +
              n * a * d +
              r * s * c -
              n * l * c) +
          g *
            (-i * s * c -
              t * o * h +
              t * s * u +
              i * a * h -
              n * a * u +
              n * o * c)
        )
      }
      transpose () {
        const e = this.elements
        let t
        return (
          (t = e[1]),
          (e[1] = e[4]),
          (e[4] = t),
          (t = e[2]),
          (e[2] = e[8]),
          (e[8] = t),
          (t = e[6]),
          (e[6] = e[9]),
          (e[9] = t),
          (t = e[3]),
          (e[3] = e[12]),
          (e[12] = t),
          (t = e[7]),
          (e[7] = e[13]),
          (e[13] = t),
          (t = e[11]),
          (e[11] = e[14]),
          (e[14] = t),
          this
        )
      }
      setPosition (e, t, n) {
        const i = this.elements
        return (
          e.isVector3
            ? ((i[12] = e.x), (i[13] = e.y), (i[14] = e.z))
            : ((i[12] = e), (i[13] = t), (i[14] = n)),
          this
        )
      }
      invert () {
        const e = this.elements,
          t = e[0],
          n = e[1],
          i = e[2],
          r = e[3],
          a = e[4],
          s = e[5],
          o = e[6],
          l = e[7],
          c = e[8],
          h = e[9],
          u = e[10],
          d = e[11],
          p = e[12],
          f = e[13],
          m = e[14],
          g = e[15],
          v =
            h * m * l -
            f * u * l +
            f * o * d -
            s * m * d -
            h * o * g +
            s * u * g,
          y =
            p * u * l -
            c * m * l -
            p * o * d +
            a * m * d +
            c * o * g -
            a * u * g,
          _ =
            c * f * l -
            p * h * l +
            p * s * d -
            a * f * d -
            c * s * g +
            a * h * g,
          x =
            p * h * o -
            c * f * o -
            p * s * u +
            a * f * u +
            c * s * m -
            a * h * m,
          w = t * v + n * y + i * _ + r * x
        if (0 === w)
          return this.set(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0)
        const b = 1 / w
        return (
          (e[0] = v * b),
          (e[1] =
            (f * u * r -
              h * m * r -
              f * i * d +
              n * m * d +
              h * i * g -
              n * u * g) *
            b),
          (e[2] =
            (s * m * r -
              f * o * r +
              f * i * l -
              n * m * l -
              s * i * g +
              n * o * g) *
            b),
          (e[3] =
            (h * o * r -
              s * u * r -
              h * i * l +
              n * u * l +
              s * i * d -
              n * o * d) *
            b),
          (e[4] = y * b),
          (e[5] =
            (c * m * r -
              p * u * r +
              p * i * d -
              t * m * d -
              c * i * g +
              t * u * g) *
            b),
          (e[6] =
            (p * o * r -
              a * m * r -
              p * i * l +
              t * m * l +
              a * i * g -
              t * o * g) *
            b),
          (e[7] =
            (a * u * r -
              c * o * r +
              c * i * l -
              t * u * l -
              a * i * d +
              t * o * d) *
            b),
          (e[8] = _ * b),
          (e[9] =
            (p * h * r -
              c * f * r -
              p * n * d +
              t * f * d +
              c * n * g -
              t * h * g) *
            b),
          (e[10] =
            (a * f * r -
              p * s * r +
              p * n * l -
              t * f * l -
              a * n * g +
              t * s * g) *
            b),
          (e[11] =
            (c * s * r -
              a * h * r -
              c * n * l +
              t * h * l +
              a * n * d -
              t * s * d) *
            b),
          (e[12] = x * b),
          (e[13] =
            (c * f * i -
              p * h * i +
              p * n * u -
              t * f * u -
              c * n * m +
              t * h * m) *
            b),
          (e[14] =
            (p * s * i -
              a * f * i -
              p * n * o +
              t * f * o +
              a * n * m -
              t * s * m) *
            b),
          (e[15] =
            (a * h * i -
              c * s * i +
              c * n * o -
              t * h * o -
              a * n * u +
              t * s * u) *
            b),
          this
        )
      }
      scale (e) {
        const t = this.elements,
          n = e.x,
          i = e.y,
          r = e.z
        return (
          (t[0] *= n),
          (t[4] *= i),
          (t[8] *= r),
          (t[1] *= n),
          (t[5] *= i),
          (t[9] *= r),
          (t[2] *= n),
          (t[6] *= i),
          (t[10] *= r),
          (t[3] *= n),
          (t[7] *= i),
          (t[11] *= r),
          this
        )
      }
      getMaxScaleOnAxis () {
        const e = this.elements,
          t = e[0] * e[0] + e[1] * e[1] + e[2] * e[2],
          n = e[4] * e[4] + e[5] * e[5] + e[6] * e[6],
          i = e[8] * e[8] + e[9] * e[9] + e[10] * e[10]
        return Math.sqrt(Math.max(t, n, i))
      }
      makeTranslation (e, t, n) {
        return this.set(1, 0, 0, e, 0, 1, 0, t, 0, 0, 1, n, 0, 0, 0, 1), this
      }
      makeRotationX (e) {
        const t = Math.cos(e),
          n = Math.sin(e)
        return this.set(1, 0, 0, 0, 0, t, -n, 0, 0, n, t, 0, 0, 0, 0, 1), this
      }
      makeRotationY (e) {
        const t = Math.cos(e),
          n = Math.sin(e)
        return this.set(t, 0, n, 0, 0, 1, 0, 0, -n, 0, t, 0, 0, 0, 0, 1), this
      }
      makeRotationZ (e) {
        const t = Math.cos(e),
          n = Math.sin(e)
        return this.set(t, -n, 0, 0, n, t, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1), this
      }
      makeRotationAxis (e, t) {
        const n = Math.cos(t),
          i = Math.sin(t),
          r = 1 - n,
          a = e.x,
          s = e.y,
          o = e.z,
          l = r * a,
          c = r * s
        return (
          this.set(
            l * a + n,
            l * s - i * o,
            l * o + i * s,
            0,
            l * s + i * o,
            c * s + n,
            c * o - i * a,
            0,
            l * o - i * s,
            c * o + i * a,
            r * o * o + n,
            0,
            0,
            0,
            0,
            1
          ),
          this
        )
      }
      makeScale (e, t, n) {
        return this.set(e, 0, 0, 0, 0, t, 0, 0, 0, 0, n, 0, 0, 0, 0, 1), this
      }
      makeShear (e, t, n, i, r, a) {
        return this.set(1, n, r, 0, e, 1, a, 0, t, i, 1, 0, 0, 0, 0, 1), this
      }
      compose (e, t, n) {
        const i = this.elements,
          r = t._x,
          a = t._y,
          s = t._z,
          o = t._w,
          l = r + r,
          c = a + a,
          h = s + s,
          u = r * l,
          d = r * c,
          p = r * h,
          f = a * c,
          m = a * h,
          g = s * h,
          v = o * l,
          y = o * c,
          _ = o * h,
          x = n.x,
          w = n.y,
          b = n.z
        return (
          (i[0] = (1 - (f + g)) * x),
          (i[1] = (d + _) * x),
          (i[2] = (p - y) * x),
          (i[3] = 0),
          (i[4] = (d - _) * w),
          (i[5] = (1 - (u + g)) * w),
          (i[6] = (m + v) * w),
          (i[7] = 0),
          (i[8] = (p + y) * b),
          (i[9] = (m - v) * b),
          (i[10] = (1 - (u + f)) * b),
          (i[11] = 0),
          (i[12] = e.x),
          (i[13] = e.y),
          (i[14] = e.z),
          (i[15] = 1),
          this
        )
      }
      decompose (e, t, n) {
        const i = this.elements
        let r = Ci.set(i[0], i[1], i[2]).length()
        const a = Ci.set(i[4], i[5], i[6]).length(),
          s = Ci.set(i[8], i[9], i[10]).length(),
          o = this.determinant()
        o < 0 && (r = -r),
          (e.x = i[12]),
          (e.y = i[13]),
          (e.z = i[14]),
          Pi.copy(this)
        const l = 1 / r,
          c = 1 / a,
          h = 1 / s
        return (
          (Pi.elements[0] *= l),
          (Pi.elements[1] *= l),
          (Pi.elements[2] *= l),
          (Pi.elements[4] *= c),
          (Pi.elements[5] *= c),
          (Pi.elements[6] *= c),
          (Pi.elements[8] *= h),
          (Pi.elements[9] *= h),
          (Pi.elements[10] *= h),
          t.setFromRotationMatrix(Pi),
          (n.x = r),
          (n.y = a),
          (n.z = s),
          this
        )
      }
      makePerspective (e, t, n, i, r, a) {
        void 0 === a &&
          console.warn(
            'THREE.Matrix4: .makePerspective() has been redefined and has a new signature. Please check the docs.'
          )
        const s = this.elements,
          o = (2 * r) / (t - e),
          l = (2 * r) / (n - i),
          c = (t + e) / (t - e),
          h = (n + i) / (n - i),
          u = -(a + r) / (a - r),
          d = (-2 * a * r) / (a - r)
        return (
          (s[0] = o),
          (s[4] = 0),
          (s[8] = c),
          (s[12] = 0),
          (s[1] = 0),
          (s[5] = l),
          (s[9] = h),
          (s[13] = 0),
          (s[2] = 0),
          (s[6] = 0),
          (s[10] = u),
          (s[14] = d),
          (s[3] = 0),
          (s[7] = 0),
          (s[11] = -1),
          (s[15] = 0),
          this
        )
      }
      makeOrthographic (e, t, n, i, r, a) {
        const s = this.elements,
          o = 1 / (t - e),
          l = 1 / (n - i),
          c = 1 / (a - r),
          h = (t + e) * o,
          u = (n + i) * l,
          d = (a + r) * c
        return (
          (s[0] = 2 * o),
          (s[4] = 0),
          (s[8] = 0),
          (s[12] = -h),
          (s[1] = 0),
          (s[5] = 2 * l),
          (s[9] = 0),
          (s[13] = -u),
          (s[2] = 0),
          (s[6] = 0),
          (s[10] = -2 * c),
          (s[14] = -d),
          (s[3] = 0),
          (s[7] = 0),
          (s[11] = 0),
          (s[15] = 1),
          this
        )
      }
      equals (e) {
        const t = this.elements,
          n = e.elements
        for (let i = 0; i < 16; i++) if (t[i] !== n[i]) return !1
        return !0
      }
      fromArray (e, t = 0) {
        for (let n = 0; n < 16; n++) this.elements[n] = e[n + t]
        return this
      }
      toArray (e = [], t = 0) {
        const n = this.elements
        return (
          (e[t] = n[0]),
          (e[t + 1] = n[1]),
          (e[t + 2] = n[2]),
          (e[t + 3] = n[3]),
          (e[t + 4] = n[4]),
          (e[t + 5] = n[5]),
          (e[t + 6] = n[6]),
          (e[t + 7] = n[7]),
          (e[t + 8] = n[8]),
          (e[t + 9] = n[9]),
          (e[t + 10] = n[10]),
          (e[t + 11] = n[11]),
          (e[t + 12] = n[12]),
          (e[t + 13] = n[13]),
          (e[t + 14] = n[14]),
          (e[t + 15] = n[15]),
          e
        )
      }
    }
    Li.prototype.isMatrix4 = !0
    const Ci = new Qn(),
      Pi = new Li(),
      Di = new Qn(0, 0, 0),
      Ii = new Qn(1, 1, 1),
      Ni = new Qn(),
      Oi = new Qn(),
      Fi = new Qn(),
      Bi = new Li(),
      zi = new Kn()
    class Ui {
      constructor (e = 0, t = 0, n = 0, i = Ui.DefaultOrder) {
        ;(this._x = e), (this._y = t), (this._z = n), (this._order = i)
      }
      get x () {
        return this._x
      }
      set x (e) {
        ;(this._x = e), this._onChangeCallback()
      }
      get y () {
        return this._y
      }
      set y (e) {
        ;(this._y = e), this._onChangeCallback()
      }
      get z () {
        return this._z
      }
      set z (e) {
        ;(this._z = e), this._onChangeCallback()
      }
      get order () {
        return this._order
      }
      set order (e) {
        ;(this._order = e), this._onChangeCallback()
      }
      set (e, t, n, i = this._order) {
        return (
          (this._x = e),
          (this._y = t),
          (this._z = n),
          (this._order = i),
          this._onChangeCallback(),
          this
        )
      }
      clone () {
        return new this.constructor(this._x, this._y, this._z, this._order)
      }
      copy (e) {
        return (
          (this._x = e._x),
          (this._y = e._y),
          (this._z = e._z),
          (this._order = e._order),
          this._onChangeCallback(),
          this
        )
      }
      setFromRotationMatrix (e, t = this._order, n = !0) {
        const i = e.elements,
          r = i[0],
          a = i[4],
          s = i[8],
          o = i[1],
          l = i[5],
          c = i[9],
          h = i[2],
          u = i[6],
          d = i[10]
        switch (t) {
          case 'XYZ':
            ;(this._y = Math.asin(Nn(s, -1, 1))),
              Math.abs(s) < 0.9999999
                ? ((this._x = Math.atan2(-c, d)), (this._z = Math.atan2(-a, r)))
                : ((this._x = Math.atan2(u, l)), (this._z = 0))
            break
          case 'YXZ':
            ;(this._x = Math.asin(-Nn(c, -1, 1))),
              Math.abs(c) < 0.9999999
                ? ((this._y = Math.atan2(s, d)), (this._z = Math.atan2(o, l)))
                : ((this._y = Math.atan2(-h, r)), (this._z = 0))
            break
          case 'ZXY':
            ;(this._x = Math.asin(Nn(u, -1, 1))),
              Math.abs(u) < 0.9999999
                ? ((this._y = Math.atan2(-h, d)), (this._z = Math.atan2(-a, l)))
                : ((this._y = 0), (this._z = Math.atan2(o, r)))
            break
          case 'ZYX':
            ;(this._y = Math.asin(-Nn(h, -1, 1))),
              Math.abs(h) < 0.9999999
                ? ((this._x = Math.atan2(u, d)), (this._z = Math.atan2(o, r)))
                : ((this._x = 0), (this._z = Math.atan2(-a, l)))
            break
          case 'YZX':
            ;(this._z = Math.asin(Nn(o, -1, 1))),
              Math.abs(o) < 0.9999999
                ? ((this._x = Math.atan2(-c, l)), (this._y = Math.atan2(-h, r)))
                : ((this._x = 0), (this._y = Math.atan2(s, d)))
            break
          case 'XZY':
            ;(this._z = Math.asin(-Nn(a, -1, 1))),
              Math.abs(a) < 0.9999999
                ? ((this._x = Math.atan2(u, l)), (this._y = Math.atan2(s, r)))
                : ((this._x = Math.atan2(-c, d)), (this._y = 0))
            break
          default:
            console.warn(
              'THREE.Euler: .setFromRotationMatrix() encountered an unknown order: ' +
                t
            )
        }
        return (this._order = t), !0 === n && this._onChangeCallback(), this
      }
      setFromQuaternion (e, t, n) {
        return (
          Bi.makeRotationFromQuaternion(e), this.setFromRotationMatrix(Bi, t, n)
        )
      }
      setFromVector3 (e, t = this._order) {
        return this.set(e.x, e.y, e.z, t)
      }
      reorder (e) {
        return zi.setFromEuler(this), this.setFromQuaternion(zi, e)
      }
      equals (e) {
        return (
          e._x === this._x &&
          e._y === this._y &&
          e._z === this._z &&
          e._order === this._order
        )
      }
      fromArray (e) {
        return (
          (this._x = e[0]),
          (this._y = e[1]),
          (this._z = e[2]),
          void 0 !== e[3] && (this._order = e[3]),
          this._onChangeCallback(),
          this
        )
      }
      toArray (e = [], t = 0) {
        return (
          (e[t] = this._x),
          (e[t + 1] = this._y),
          (e[t + 2] = this._z),
          (e[t + 3] = this._order),
          e
        )
      }
      toVector3 (e) {
        return e
          ? e.set(this._x, this._y, this._z)
          : new Qn(this._x, this._y, this._z)
      }
      _onChange (e) {
        return (this._onChangeCallback = e), this
      }
      _onChangeCallback () {}
    }
    ;(Ui.prototype.isEuler = !0),
      (Ui.DefaultOrder = 'XYZ'),
      (Ui.RotationOrders = ['XYZ', 'YZX', 'ZXY', 'XZY', 'YXZ', 'ZYX'])
    class ki {
      constructor () {
        this.mask = 1
      }
      set (e) {
        this.mask = (1 << e) | 0
      }
      enable (e) {
        this.mask |= (1 << e) | 0
      }
      enableAll () {
        this.mask = -1
      }
      toggle (e) {
        this.mask ^= (1 << e) | 0
      }
      disable (e) {
        this.mask &= ~((1 << e) | 0)
      }
      disableAll () {
        this.mask = 0
      }
      test (e) {
        return 0 !== (this.mask & e.mask)
      }
    }
    let Hi = 0
    const Wi = new Qn(),
      Vi = new Kn(),
      Gi = new Li(),
      ji = new Qn(),
      qi = new Qn(),
      Yi = new Qn(),
      Xi = new Kn(),
      Ji = new Qn(1, 0, 0),
      Zi = new Qn(0, 1, 0),
      Ki = new Qn(0, 0, 1),
      Qi = { type: 'added' },
      $i = { type: 'removed' }
    class er extends Ln {
      constructor () {
        super(),
          Object.defineProperty(this, 'id', { value: Hi++ }),
          (this.uuid = In()),
          (this.name = ''),
          (this.type = 'Object3D'),
          (this.parent = null),
          (this.children = []),
          (this.up = er.DefaultUp.clone())
        const e = new Qn(),
          t = new Ui(),
          n = new Kn(),
          i = new Qn(1, 1, 1)
        function r () {
          n.setFromEuler(t, !1)
        }
        function a () {
          t.setFromQuaternion(n, void 0, !1)
        }
        t._onChange(r),
          n._onChange(a),
          Object.defineProperties(this, {
            position: { configurable: !0, enumerable: !0, value: e },
            rotation: { configurable: !0, enumerable: !0, value: t },
            quaternion: { configurable: !0, enumerable: !0, value: n },
            scale: { configurable: !0, enumerable: !0, value: i },
            modelViewMatrix: { value: new Li() },
            normalMatrix: { value: new Hn() }
          }),
          (this.matrix = new Li()),
          (this.matrixWorld = new Li()),
          (this.matrixAutoUpdate = er.DefaultMatrixAutoUpdate),
          (this.matrixWorldNeedsUpdate = !1),
          (this.layers = new ki()),
          (this.visible = !0),
          (this.castShadow = !1),
          (this.receiveShadow = !1),
          (this.frustumCulled = !0),
          (this.renderOrder = 0),
          (this.animations = []),
          (this.userData = {})
      }
      onBeforeRender () {}
      onAfterRender () {}
      applyMatrix4 (e) {
        this.matrixAutoUpdate && this.updateMatrix(),
          this.matrix.premultiply(e),
          this.matrix.decompose(this.position, this.quaternion, this.scale)
      }
      applyQuaternion (e) {
        return this.quaternion.premultiply(e), this
      }
      setRotationFromAxisAngle (e, t) {
        this.quaternion.setFromAxisAngle(e, t)
      }
      setRotationFromEuler (e) {
        this.quaternion.setFromEuler(e, !0)
      }
      setRotationFromMatrix (e) {
        this.quaternion.setFromRotationMatrix(e)
      }
      setRotationFromQuaternion (e) {
        this.quaternion.copy(e)
      }
      rotateOnAxis (e, t) {
        return Vi.setFromAxisAngle(e, t), this.quaternion.multiply(Vi), this
      }
      rotateOnWorldAxis (e, t) {
        return Vi.setFromAxisAngle(e, t), this.quaternion.premultiply(Vi), this
      }
      rotateX (e) {
        return this.rotateOnAxis(Ji, e)
      }
      rotateY (e) {
        return this.rotateOnAxis(Zi, e)
      }
      rotateZ (e) {
        return this.rotateOnAxis(Ki, e)
      }
      translateOnAxis (e, t) {
        return (
          Wi.copy(e).applyQuaternion(this.quaternion),
          this.position.add(Wi.multiplyScalar(t)),
          this
        )
      }
      translateX (e) {
        return this.translateOnAxis(Ji, e)
      }
      translateY (e) {
        return this.translateOnAxis(Zi, e)
      }
      translateZ (e) {
        return this.translateOnAxis(Ki, e)
      }
      localToWorld (e) {
        return e.applyMatrix4(this.matrixWorld)
      }
      worldToLocal (e) {
        return e.applyMatrix4(Gi.copy(this.matrixWorld).invert())
      }
      lookAt (e, t, n) {
        e.isVector3 ? ji.copy(e) : ji.set(e, t, n)
        const i = this.parent
        this.updateWorldMatrix(!0, !1),
          qi.setFromMatrixPosition(this.matrixWorld),
          this.isCamera || this.isLight
            ? Gi.lookAt(qi, ji, this.up)
            : Gi.lookAt(ji, qi, this.up),
          this.quaternion.setFromRotationMatrix(Gi),
          i &&
            (Gi.extractRotation(i.matrixWorld),
            Vi.setFromRotationMatrix(Gi),
            this.quaternion.premultiply(Vi.invert()))
      }
      add (e) {
        if (arguments.length > 1) {
          for (let e = 0; e < arguments.length; e++) this.add(arguments[e])
          return this
        }
        return e === this
          ? (console.error(
              "THREE.Object3D.add: object can't be added as a child of itself.",
              e
            ),
            this)
          : (e && e.isObject3D
              ? (null !== e.parent && e.parent.remove(e),
                (e.parent = this),
                this.children.push(e),
                e.dispatchEvent(Qi))
              : console.error(
                  'THREE.Object3D.add: object not an instance of THREE.Object3D.',
                  e
                ),
            this)
      }
      remove (e) {
        if (arguments.length > 1) {
          for (let e = 0; e < arguments.length; e++) this.remove(arguments[e])
          return this
        }
        const t = this.children.indexOf(e)
        return (
          -1 !== t &&
            ((e.parent = null),
            this.children.splice(t, 1),
            e.dispatchEvent($i)),
          this
        )
      }
      removeFromParent () {
        const e = this.parent
        return null !== e && e.remove(this), this
      }
      clear () {
        for (let e = 0; e < this.children.length; e++) {
          const t = this.children[e]
          ;(t.parent = null), t.dispatchEvent($i)
        }
        return (this.children.length = 0), this
      }
      attach (e) {
        return (
          this.updateWorldMatrix(!0, !1),
          Gi.copy(this.matrixWorld).invert(),
          null !== e.parent &&
            (e.parent.updateWorldMatrix(!0, !1),
            Gi.multiply(e.parent.matrixWorld)),
          e.applyMatrix4(Gi),
          this.add(e),
          e.updateWorldMatrix(!1, !0),
          this
        )
      }
      getObjectById (e) {
        return this.getObjectByProperty('id', e)
      }
      getObjectByName (e) {
        return this.getObjectByProperty('name', e)
      }
      getObjectByProperty (e, t) {
        if (this[e] === t) return this
        for (let n = 0, i = this.children.length; n < i; n++) {
          const i = this.children[n],
            r = i.getObjectByProperty(e, t)
          if (void 0 !== r) return r
        }
      }
      getWorldPosition (e) {
        return (
          this.updateWorldMatrix(!0, !1),
          e.setFromMatrixPosition(this.matrixWorld)
        )
      }
      getWorldQuaternion (e) {
        return (
          this.updateWorldMatrix(!0, !1),
          this.matrixWorld.decompose(qi, e, Yi),
          e
        )
      }
      getWorldScale (e) {
        return (
          this.updateWorldMatrix(!0, !1),
          this.matrixWorld.decompose(qi, Xi, e),
          e
        )
      }
      getWorldDirection (e) {
        this.updateWorldMatrix(!0, !1)
        const t = this.matrixWorld.elements
        return e.set(t[8], t[9], t[10]).normalize()
      }
      raycast () {}
      traverse (e) {
        e(this)
        const t = this.children
        for (let n = 0, i = t.length; n < i; n++) t[n].traverse(e)
      }
      traverseVisible (e) {
        if (!1 === this.visible) return
        e(this)
        const t = this.children
        for (let n = 0, i = t.length; n < i; n++) t[n].traverseVisible(e)
      }
      traverseAncestors (e) {
        const t = this.parent
        null !== t && (e(t), t.traverseAncestors(e))
      }
      updateMatrix () {
        this.matrix.compose(
          this.position,
          this.quaternion,
          this.scale
        ),
          (this.matrixWorldNeedsUpdate = !0)
      }
      updateMatrixWorld (e) {
        this.matrixAutoUpdate && this.updateMatrix(),
          (this.matrixWorldNeedsUpdate || e) &&
            (null === this.parent
              ? this.matrixWorld.copy(this.matrix)
              : this.matrixWorld.multiplyMatrices(
                  this.parent.matrixWorld,
                  this.matrix
                ),
            (this.matrixWorldNeedsUpdate = !1),
            (e = !0))
        const t = this.children
        for (let n = 0, i = t.length; n < i; n++) t[n].updateMatrixWorld(e)
      }
      updateWorldMatrix (e, t) {
        const n = this.parent
        if (
          (!0 === e && null !== n && n.updateWorldMatrix(!0, !1),
          this.matrixAutoUpdate && this.updateMatrix(),
          null === this.parent
            ? this.matrixWorld.copy(this.matrix)
            : this.matrixWorld.multiplyMatrices(
                this.parent.matrixWorld,
                this.matrix
              ),
          !0 === t)
        ) {
          const e = this.children
          for (let t = 0, n = e.length; t < n; t++)
            e[t].updateWorldMatrix(!1, !0)
        }
      }
      toJSON (e) {
        const t = void 0 === e || 'string' === typeof e,
          n = {}
        t &&
          ((e = {
            geometries: {},
            materials: {},
            textures: {},
            images: {},
            shapes: {},
            skeletons: {},
            animations: {}
          }),
          (n.metadata = {
            version: 4.5,
            type: 'Object',
            generator: 'Object3D.toJSON'
          }))
        const i = {}
        function r (t, n) {
          return void 0 === t[n.uuid] && (t[n.uuid] = n.toJSON(e)), n.uuid
        }
        if (
          ((i.uuid = this.uuid),
          (i.type = this.type),
          '' !== this.name && (i.name = this.name),
          !0 === this.castShadow && (i.castShadow = !0),
          !0 === this.receiveShadow && (i.receiveShadow = !0),
          !1 === this.visible && (i.visible = !1),
          !1 === this.frustumCulled && (i.frustumCulled = !1),
          0 !== this.renderOrder && (i.renderOrder = this.renderOrder),
          '{}' !== JSON.stringify(this.userData) &&
            (i.userData = this.userData),
          (i.layers = this.layers.mask),
          (i.matrix = this.matrix.toArray()),
          !1 === this.matrixAutoUpdate && (i.matrixAutoUpdate = !1),
          this.isInstancedMesh &&
            ((i.type = 'InstancedMesh'),
            (i.count = this.count),
            (i.instanceMatrix = this.instanceMatrix.toJSON()),
            null !== this.instanceColor &&
              (i.instanceColor = this.instanceColor.toJSON())),
          this.isScene)
        )
          this.background &&
            (this.background.isColor
              ? (i.background = this.background.toJSON())
              : this.background.isTexture &&
                (i.background = this.background.toJSON(e).uuid)),
            this.environment &&
              this.environment.isTexture &&
              (i.environment = this.environment.toJSON(e).uuid)
        else if (this.isMesh || this.isLine || this.isPoints) {
          i.geometry = r(e.geometries, this.geometry)
          const t = this.geometry.parameters
          if (void 0 !== t && void 0 !== t.shapes) {
            const n = t.shapes
            if (Array.isArray(n))
              for (let t = 0, i = n.length; t < i; t++) {
                const i = n[t]
                r(e.shapes, i)
              }
            else r(e.shapes, n)
          }
        }
        if (
          (this.isSkinnedMesh &&
            ((i.bindMode = this.bindMode),
            (i.bindMatrix = this.bindMatrix.toArray()),
            void 0 !== this.skeleton &&
              (r(e.skeletons, this.skeleton),
              (i.skeleton = this.skeleton.uuid))),
          void 0 !== this.material)
        )
          if (Array.isArray(this.material)) {
            const t = []
            for (let n = 0, i = this.material.length; n < i; n++)
              t.push(r(e.materials, this.material[n]))
            i.material = t
          } else i.material = r(e.materials, this.material)
        if (this.children.length > 0) {
          i.children = []
          for (let t = 0; t < this.children.length; t++)
            i.children.push(this.children[t].toJSON(e).object)
        }
        if (this.animations.length > 0) {
          i.animations = []
          for (let t = 0; t < this.animations.length; t++) {
            const n = this.animations[t]
            i.animations.push(r(e.animations, n))
          }
        }
        if (t) {
          const t = a(e.geometries),
            i = a(e.materials),
            r = a(e.textures),
            s = a(e.images),
            o = a(e.shapes),
            l = a(e.skeletons),
            c = a(e.animations)
          t.length > 0 && (n.geometries = t),
            i.length > 0 && (n.materials = i),
            r.length > 0 && (n.textures = r),
            s.length > 0 && (n.images = s),
            o.length > 0 && (n.shapes = o),
            l.length > 0 && (n.skeletons = l),
            c.length > 0 && (n.animations = c)
        }
        return (n.object = i), n
        function a (e) {
          const t = []
          for (const n in e) {
            const i = e[n]
            delete i.metadata, t.push(i)
          }
          return t
        }
      }
      clone (e) {
        return new this.constructor().copy(this, e)
      }
      copy (e, t = !0) {
        if (
          ((this.name = e.name),
          this.up.copy(e.up),
          this.position.copy(e.position),
          (this.rotation.order = e.rotation.order),
          this.quaternion.copy(e.quaternion),
          this.scale.copy(e.scale),
          this.matrix.copy(e.matrix),
          this.matrixWorld.copy(e.matrixWorld),
          (this.matrixAutoUpdate = e.matrixAutoUpdate),
          (this.matrixWorldNeedsUpdate = e.matrixWorldNeedsUpdate),
          (this.layers.mask = e.layers.mask),
          (this.visible = e.visible),
          (this.castShadow = e.castShadow),
          (this.receiveShadow = e.receiveShadow),
          (this.frustumCulled = e.frustumCulled),
          (this.renderOrder = e.renderOrder),
          (this.userData = JSON.parse(JSON.stringify(e.userData))),
          !0 === t)
        )
          for (let n = 0; n < e.children.length; n++) {
            const t = e.children[n]
            this.add(t.clone())
          }
        return this
      }
    }
    ;(er.DefaultUp = new Qn(0, 1, 0)),
      (er.DefaultMatrixAutoUpdate = !0),
      (er.prototype.isObject3D = !0)
    const tr = new Qn(),
      nr = new Qn(),
      ir = new Qn(),
      rr = new Qn(),
      ar = new Qn(),
      sr = new Qn(),
      or = new Qn(),
      lr = new Qn(),
      cr = new Qn(),
      hr = new Qn()
    class ur {
      constructor (e = new Qn(), t = new Qn(), n = new Qn()) {
        ;(this.a = e), (this.b = t), (this.c = n)
      }
      static getNormal (e, t, n, i) {
        i.subVectors(n, t), tr.subVectors(e, t), i.cross(tr)
        const r = i.lengthSq()
        return r > 0 ? i.multiplyScalar(1 / Math.sqrt(r)) : i.set(0, 0, 0)
      }
      static getBarycoord (e, t, n, i, r) {
        tr.subVectors(i, t), nr.subVectors(n, t), ir.subVectors(e, t)
        const a = tr.dot(tr),
          s = tr.dot(nr),
          o = tr.dot(ir),
          l = nr.dot(nr),
          c = nr.dot(ir),
          h = a * l - s * s
        if (0 === h) return r.set(-2, -1, -1)
        const u = 1 / h,
          d = (l * o - s * c) * u,
          p = (a * c - s * o) * u
        return r.set(1 - d - p, p, d)
      }
      static containsPoint (e, t, n, i) {
        return (
          this.getBarycoord(e, t, n, i, rr),
          rr.x >= 0 && rr.y >= 0 && rr.x + rr.y <= 1
        )
      }
      static getUV (e, t, n, i, r, a, s, o) {
        return (
          this.getBarycoord(e, t, n, i, rr),
          o.set(0, 0),
          o.addScaledVector(r, rr.x),
          o.addScaledVector(a, rr.y),
          o.addScaledVector(s, rr.z),
          o
        )
      }
      static isFrontFacing (e, t, n, i) {
        return tr.subVectors(n, t), nr.subVectors(e, t), tr.cross(nr).dot(i) < 0
      }
      set (e, t, n) {
        return this.a.copy(e), this.b.copy(t), this.c.copy(n), this
      }
      setFromPointsAndIndices (e, t, n, i) {
        return this.a.copy(e[t]), this.b.copy(e[n]), this.c.copy(e[i]), this
      }
      clone () {
        return new this.constructor().copy(this)
      }
      copy (e) {
        return this.a.copy(e.a), this.b.copy(e.b), this.c.copy(e.c), this
      }
      getArea () {
        return (
          tr.subVectors(this.c, this.b),
          nr.subVectors(this.a, this.b),
          0.5 * tr.cross(nr).length()
        )
      }
      getMidpoint (e) {
        return e
          .addVectors(this.a, this.b)
          .add(this.c)
          .multiplyScalar(1 / 3)
      }
      getNormal (e) {
        return ur.getNormal(this.a, this.b, this.c, e)
      }
      getPlane (e) {
        return e.setFromCoplanarPoints(this.a, this.b, this.c)
      }
      getBarycoord (e, t) {
        return ur.getBarycoord(e, this.a, this.b, this.c, t)
      }
      getUV (e, t, n, i, r) {
        return ur.getUV(e, this.a, this.b, this.c, t, n, i, r)
      }
      containsPoint (e) {
        return ur.containsPoint(e, this.a, this.b, this.c)
      }
      isFrontFacing (e) {
        return ur.isFrontFacing(this.a, this.b, this.c, e)
      }
      intersectsBox (e) {
        return e.intersectsTriangle(this)
      }
      closestPointToPoint (e, t) {
        const n = this.a,
          i = this.b,
          r = this.c
        let a, s
        ar.subVectors(i, n), sr.subVectors(r, n), lr.subVectors(e, n)
        const o = ar.dot(lr),
          l = sr.dot(lr)
        if (o <= 0 && l <= 0) return t.copy(n)
        cr.subVectors(e, i)
        const c = ar.dot(cr),
          h = sr.dot(cr)
        if (c >= 0 && h <= c) return t.copy(i)
        const u = o * h - c * l
        if (u <= 0 && o >= 0 && c <= 0)
          return (a = o / (o - c)), t.copy(n).addScaledVector(ar, a)
        hr.subVectors(e, r)
        const d = ar.dot(hr),
          p = sr.dot(hr)
        if (p >= 0 && d <= p) return t.copy(r)
        const f = d * l - o * p
        if (f <= 0 && l >= 0 && p <= 0)
          return (s = l / (l - p)), t.copy(n).addScaledVector(sr, s)
        const m = c * p - d * h
        if (m <= 0 && h - c >= 0 && d - p >= 0)
          return (
            or.subVectors(r, i),
            (s = (h - c) / (h - c + (d - p))),
            t.copy(i).addScaledVector(or, s)
          )
        const g = 1 / (m + f + u)
        return (
          (a = f * g),
          (s = u * g),
          t
            .copy(n)
            .addScaledVector(ar, a)
            .addScaledVector(sr, s)
        )
      }
      equals (e) {
        return e.a.equals(this.a) && e.b.equals(this.b) && e.c.equals(this.c)
      }
    }
    let dr = 0
    class pr extends Ln {
      constructor () {
        super(),
          Object.defineProperty(this, 'id', { value: dr++ }),
          (this.uuid = In()),
          (this.name = ''),
          (this.type = 'Material'),
          (this.fog = !0),
          (this.blending = W),
          (this.side = B),
          (this.vertexColors = !1),
          (this.opacity = 1),
          (this.transparent = !1),
          (this.blendSrc = ne),
          (this.blendDst = ie),
          (this.blendEquation = Y),
          (this.blendSrcAlpha = null),
          (this.blendDstAlpha = null),
          (this.blendEquationAlpha = null),
          (this.depthFunc = de),
          (this.depthTest = !0),
          (this.depthWrite = !0),
          (this.stencilWriteMask = 255),
          (this.stencilFunc = En),
          (this.stencilRef = 0),
          (this.stencilFuncMask = 255),
          (this.stencilFail = Sn),
          (this.stencilZFail = Sn),
          (this.stencilZPass = Sn),
          (this.stencilWrite = !1),
          (this.clippingPlanes = null),
          (this.clipIntersection = !1),
          (this.clipShadows = !1),
          (this.shadowSide = null),
          (this.colorWrite = !0),
          (this.precision = null),
          (this.polygonOffset = !1),
          (this.polygonOffsetFactor = 0),
          (this.polygonOffsetUnits = 0),
          (this.dithering = !1),
          (this.alphaTest = 0),
          (this.alphaToCoverage = !1),
          (this.premultipliedAlpha = !1),
          (this.visible = !0),
          (this.toneMapped = !0),
          (this.userData = {}),
          (this.version = 0)
      }
      onBuild () {}
      onBeforeCompile () {}
      customProgramCacheKey () {
        return this.onBeforeCompile.toString()
      }
      setValues (e) {
        if (void 0 !== e)
          for (const t in e) {
            const n = e[t]
            if (void 0 === n) {
              console.warn(
                "THREE.Material: '" + t + "' parameter is undefined."
              )
              continue
            }
            if ('shading' === t) {
              console.warn(
                'THREE.' +
                  this.type +
                  ': .shading has been removed. Use the boolean .flatShading instead.'
              ),
                (this.flatShading = n === k)
              continue
            }
            const i = this[t]
            void 0 !== i
              ? i && i.isColor
                ? i.set(n)
                : i && i.isVector3 && n && n.isVector3
                ? i.copy(n)
                : (this[t] = n)
              : console.warn(
                  'THREE.' +
                    this.type +
                    ": '" +
                    t +
                    "' is not a property of this material."
                )
          }
      }
      toJSON (e) {
        const t = void 0 === e || 'string' === typeof e
        t && (e = { textures: {}, images: {} })
        const n = {
          metadata: {
            version: 4.5,
            type: 'Material',
            generator: 'Material.toJSON'
          }
        }
        function i (e) {
          const t = []
          for (const n in e) {
            const i = e[n]
            delete i.metadata, t.push(i)
          }
          return t
        }
        if (
          ((n.uuid = this.uuid),
          (n.type = this.type),
          '' !== this.name && (n.name = this.name),
          this.color && this.color.isColor && (n.color = this.color.getHex()),
          void 0 !== this.roughness && (n.roughness = this.roughness),
          void 0 !== this.metalness && (n.metalness = this.metalness),
          this.sheen && this.sheen.isColor && (n.sheen = this.sheen.getHex()),
          this.emissive &&
            this.emissive.isColor &&
            (n.emissive = this.emissive.getHex()),
          this.emissiveIntensity &&
            1 !== this.emissiveIntensity &&
            (n.emissiveIntensity = this.emissiveIntensity),
          this.specular &&
            this.specular.isColor &&
            (n.specular = this.specular.getHex()),
          void 0 !== this.shininess && (n.shininess = this.shininess),
          void 0 !== this.clearcoat && (n.clearcoat = this.clearcoat),
          void 0 !== this.clearcoatRoughness &&
            (n.clearcoatRoughness = this.clearcoatRoughness),
          this.clearcoatMap &&
            this.clearcoatMap.isTexture &&
            (n.clearcoatMap = this.clearcoatMap.toJSON(e).uuid),
          this.clearcoatRoughnessMap &&
            this.clearcoatRoughnessMap.isTexture &&
            (n.clearcoatRoughnessMap = this.clearcoatRoughnessMap.toJSON(
              e
            ).uuid),
          this.clearcoatNormalMap &&
            this.clearcoatNormalMap.isTexture &&
            ((n.clearcoatNormalMap = this.clearcoatNormalMap.toJSON(e).uuid),
            (n.clearcoatNormalScale = this.clearcoatNormalScale.toArray())),
          this.map && this.map.isTexture && (n.map = this.map.toJSON(e).uuid),
          this.matcap &&
            this.matcap.isTexture &&
            (n.matcap = this.matcap.toJSON(e).uuid),
          this.alphaMap &&
            this.alphaMap.isTexture &&
            (n.alphaMap = this.alphaMap.toJSON(e).uuid),
          this.lightMap &&
            this.lightMap.isTexture &&
            ((n.lightMap = this.lightMap.toJSON(e).uuid),
            (n.lightMapIntensity = this.lightMapIntensity)),
          this.aoMap &&
            this.aoMap.isTexture &&
            ((n.aoMap = this.aoMap.toJSON(e).uuid),
            (n.aoMapIntensity = this.aoMapIntensity)),
          this.bumpMap &&
            this.bumpMap.isTexture &&
            ((n.bumpMap = this.bumpMap.toJSON(e).uuid),
            (n.bumpScale = this.bumpScale)),
          this.normalMap &&
            this.normalMap.isTexture &&
            ((n.normalMap = this.normalMap.toJSON(e).uuid),
            (n.normalMapType = this.normalMapType),
            (n.normalScale = this.normalScale.toArray())),
          this.displacementMap &&
            this.displacementMap.isTexture &&
            ((n.displacementMap = this.displacementMap.toJSON(e).uuid),
            (n.displacementScale = this.displacementScale),
            (n.displacementBias = this.displacementBias)),
          this.roughnessMap &&
            this.roughnessMap.isTexture &&
            (n.roughnessMap = this.roughnessMap.toJSON(e).uuid),
          this.metalnessMap &&
            this.metalnessMap.isTexture &&
            (n.metalnessMap = this.metalnessMap.toJSON(e).uuid),
          this.emissiveMap &&
            this.emissiveMap.isTexture &&
            (n.emissiveMap = this.emissiveMap.toJSON(e).uuid),
          this.specularMap &&
            this.specularMap.isTexture &&
            (n.specularMap = this.specularMap.toJSON(e).uuid),
          this.envMap &&
            this.envMap.isTexture &&
            ((n.envMap = this.envMap.toJSON(e).uuid),
            void 0 !== this.combine && (n.combine = this.combine)),
          void 0 !== this.envMapIntensity &&
            (n.envMapIntensity = this.envMapIntensity),
          void 0 !== this.reflectivity && (n.reflectivity = this.reflectivity),
          void 0 !== this.refractionRatio &&
            (n.refractionRatio = this.refractionRatio),
          this.gradientMap &&
            this.gradientMap.isTexture &&
            (n.gradientMap = this.gradientMap.toJSON(e).uuid),
          void 0 !== this.transmission && (n.transmission = this.transmission),
          this.transmissionMap &&
            this.transmissionMap.isTexture &&
            (n.transmissionMap = this.transmissionMap.toJSON(e).uuid),
          void 0 !== this.thickness && (n.thickness = this.thickness),
          this.thicknessMap &&
            this.thicknessMap.isTexture &&
            (n.thicknessMap = this.thicknessMap.toJSON(e).uuid),
          void 0 !== this.attenuationDistance &&
            (n.attenuationDistance = this.attenuationDistance),
          void 0 !== this.attenuationColor &&
            (n.attenuationColor = this.attenuationColor.getHex()),
          void 0 !== this.size && (n.size = this.size),
          null !== this.shadowSide && (n.shadowSide = this.shadowSide),
          void 0 !== this.sizeAttenuation &&
            (n.sizeAttenuation = this.sizeAttenuation),
          this.blending !== W && (n.blending = this.blending),
          this.side !== B && (n.side = this.side),
          this.vertexColors && (n.vertexColors = !0),
          this.opacity < 1 && (n.opacity = this.opacity),
          !0 === this.transparent && (n.transparent = this.transparent),
          (n.depthFunc = this.depthFunc),
          (n.depthTest = this.depthTest),
          (n.depthWrite = this.depthWrite),
          (n.colorWrite = this.colorWrite),
          (n.stencilWrite = this.stencilWrite),
          (n.stencilWriteMask = this.stencilWriteMask),
          (n.stencilFunc = this.stencilFunc),
          (n.stencilRef = this.stencilRef),
          (n.stencilFuncMask = this.stencilFuncMask),
          (n.stencilFail = this.stencilFail),
          (n.stencilZFail = this.stencilZFail),
          (n.stencilZPass = this.stencilZPass),
          this.rotation && 0 !== this.rotation && (n.rotation = this.rotation),
          !0 === this.polygonOffset && (n.polygonOffset = !0),
          0 !== this.polygonOffsetFactor &&
            (n.polygonOffsetFactor = this.polygonOffsetFactor),
          0 !== this.polygonOffsetUnits &&
            (n.polygonOffsetUnits = this.polygonOffsetUnits),
          this.linewidth &&
            1 !== this.linewidth &&
            (n.linewidth = this.linewidth),
          void 0 !== this.dashSize && (n.dashSize = this.dashSize),
          void 0 !== this.gapSize && (n.gapSize = this.gapSize),
          void 0 !== this.scale && (n.scale = this.scale),
          !0 === this.dithering && (n.dithering = !0),
          this.alphaTest > 0 && (n.alphaTest = this.alphaTest),
          !0 === this.alphaToCoverage &&
            (n.alphaToCoverage = this.alphaToCoverage),
          !0 === this.premultipliedAlpha &&
            (n.premultipliedAlpha = this.premultipliedAlpha),
          !0 === this.wireframe && (n.wireframe = this.wireframe),
          this.wireframeLinewidth > 1 &&
            (n.wireframeLinewidth = this.wireframeLinewidth),
          'round' !== this.wireframeLinecap &&
            (n.wireframeLinecap = this.wireframeLinecap),
          'round' !== this.wireframeLinejoin &&
            (n.wireframeLinejoin = this.wireframeLinejoin),
          !0 === this.morphTargets && (n.morphTargets = !0),
          !0 === this.morphNormals && (n.morphNormals = !0),
          !0 === this.flatShading && (n.flatShading = this.flatShading),
          !1 === this.visible && (n.visible = !1),
          !1 === this.toneMapped && (n.toneMapped = !1),
          '{}' !== JSON.stringify(this.userData) &&
            (n.userData = this.userData),
          t)
        ) {
          const t = i(e.textures),
            r = i(e.images)
          t.length > 0 && (n.textures = t), r.length > 0 && (n.images = r)
        }
        return n
      }
      clone () {
        return new this.constructor().copy(this)
      }
      copy (e) {
        ;(this.name = e.name),
          (this.fog = e.fog),
          (this.blending = e.blending),
          (this.side = e.side),
          (this.vertexColors = e.vertexColors),
          (this.opacity = e.opacity),
          (this.transparent = e.transparent),
          (this.blendSrc = e.blendSrc),
          (this.blendDst = e.blendDst),
          (this.blendEquation = e.blendEquation),
          (this.blendSrcAlpha = e.blendSrcAlpha),
          (this.blendDstAlpha = e.blendDstAlpha),
          (this.blendEquationAlpha = e.blendEquationAlpha),
          (this.depthFunc = e.depthFunc),
          (this.depthTest = e.depthTest),
          (this.depthWrite = e.depthWrite),
          (this.stencilWriteMask = e.stencilWriteMask),
          (this.stencilFunc = e.stencilFunc),
          (this.stencilRef = e.stencilRef),
          (this.stencilFuncMask = e.stencilFuncMask),
          (this.stencilFail = e.stencilFail),
          (this.stencilZFail = e.stencilZFail),
          (this.stencilZPass = e.stencilZPass),
          (this.stencilWrite = e.stencilWrite)
        const t = e.clippingPlanes
        let n = null
        if (null !== t) {
          const e = t.length
          n = new Array(e)
          for (let i = 0; i !== e; ++i) n[i] = t[i].clone()
        }
        return (
          (this.clippingPlanes = n),
          (this.clipIntersection = e.clipIntersection),
          (this.clipShadows = e.clipShadows),
          (this.shadowSide = e.shadowSide),
          (this.colorWrite = e.colorWrite),
          (this.precision = e.precision),
          (this.polygonOffset = e.polygonOffset),
          (this.polygonOffsetFactor = e.polygonOffsetFactor),
          (this.polygonOffsetUnits = e.polygonOffsetUnits),
          (this.dithering = e.dithering),
          (this.alphaTest = e.alphaTest),
          (this.alphaToCoverage = e.alphaToCoverage),
          (this.premultipliedAlpha = e.premultipliedAlpha),
          (this.visible = e.visible),
          (this.toneMapped = e.toneMapped),
          (this.userData = JSON.parse(JSON.stringify(e.userData))),
          this
        )
      }
      dispose () {
        this.dispatchEvent({ type: 'dispose' })
      }
      set needsUpdate (e) {
        !0 === e && this.version++
      }
    }
    pr.prototype.isMaterial = !0
    const fr = {
        aliceblue: 15792383,
        antiquewhite: 16444375,
        aqua: 65535,
        aquamarine: 8388564,
        azure: 15794175,
        beige: 16119260,
        bisque: 16770244,
        black: 0,
        blanchedalmond: 16772045,
        blue: 255,
        blueviolet: 9055202,
        brown: 10824234,
        burlywood: 14596231,
        cadetblue: 6266528,
        chartreuse: 8388352,
        chocolate: 13789470,
        coral: 16744272,
        cornflowerblue: 6591981,
        cornsilk: 16775388,
        crimson: 14423100,
        cyan: 65535,
        darkblue: 139,
        darkcyan: 35723,
        darkgoldenrod: 12092939,
        darkgray: 11119017,
        darkgreen: 25600,
        darkgrey: 11119017,
        darkkhaki: 12433259,
        darkmagenta: 9109643,
        darkolivegreen: 5597999,
        darkorange: 16747520,
        darkorchid: 10040012,
        darkred: 9109504,
        darksalmon: 15308410,
        darkseagreen: 9419919,
        darkslateblue: 4734347,
        darkslategray: 3100495,
        darkslategrey: 3100495,
        darkturquoise: 52945,
        darkviolet: 9699539,
        deeppink: 16716947,
        deepskyblue: 49151,
        dimgray: 6908265,
        dimgrey: 6908265,
        dodgerblue: 2003199,
        firebrick: 11674146,
        floralwhite: 16775920,
        forestgreen: 2263842,
        fuchsia: 16711935,
        gainsboro: 14474460,
        ghostwhite: 16316671,
        gold: 16766720,
        goldenrod: 14329120,
        gray: 8421504,
        green: 32768,
        greenyellow: 11403055,
        grey: 8421504,
        honeydew: 15794160,
        hotpink: 16738740,
        indianred: 13458524,
        indigo: 4915330,
        ivory: 16777200,
        khaki: 15787660,
        lavender: 15132410,
        lavenderblush: 16773365,
        lawngreen: 8190976,
        lemonchiffon: 16775885,
        lightblue: 11393254,
        lightcoral: 15761536,
        lightcyan: 14745599,
        lightgoldenrodyellow: 16448210,
        lightgray: 13882323,
        lightgreen: 9498256,
        lightgrey: 13882323,
        lightpink: 16758465,
        lightsalmon: 16752762,
        lightseagreen: 2142890,
        lightskyblue: 8900346,
        lightslategray: 7833753,
        lightslategrey: 7833753,
        lightsteelblue: 11584734,
        lightyellow: 16777184,
        lime: 65280,
        limegreen: 3329330,
        linen: 16445670,
        magenta: 16711935,
        maroon: 8388608,
        mediumaquamarine: 6737322,
        mediumblue: 205,
        mediumorchid: 12211667,
        mediumpurple: 9662683,
        mediumseagreen: 3978097,
        mediumslateblue: 8087790,
        mediumspringgreen: 64154,
        mediumturquoise: 4772300,
        mediumvioletred: 13047173,
        midnightblue: 1644912,
        mintcream: 16121850,
        mistyrose: 16770273,
        moccasin: 16770229,
        navajowhite: 16768685,
        navy: 128,
        oldlace: 16643558,
        olive: 8421376,
        olivedrab: 7048739,
        orange: 16753920,
        orangered: 16729344,
        orchid: 14315734,
        palegoldenrod: 15657130,
        palegreen: 10025880,
        paleturquoise: 11529966,
        palevioletred: 14381203,
        papayawhip: 16773077,
        peachpuff: 16767673,
        peru: 13468991,
        pink: 16761035,
        plum: 14524637,
        powderblue: 11591910,
        purple: 8388736,
        rebeccapurple: 6697881,
        red: 16711680,
        rosybrown: 12357519,
        royalblue: 4286945,
        saddlebrown: 9127187,
        salmon: 16416882,
        sandybrown: 16032864,
        seagreen: 3050327,
        seashell: 16774638,
        sienna: 10506797,
        silver: 12632256,
        skyblue: 8900331,
        slateblue: 6970061,
        slategray: 7372944,
        slategrey: 7372944,
        snow: 16775930,
        springgreen: 65407,
        steelblue: 4620980,
        tan: 13808780,
        teal: 32896,
        thistle: 14204888,
        tomato: 16737095,
        turquoise: 4251856,
        violet: 15631086,
        wheat: 16113331,
        white: 16777215,
        whitesmoke: 16119285,
        yellow: 16776960,
        yellowgreen: 10145074
      },
      mr = { h: 0, s: 0, l: 0 },
      gr = { h: 0, s: 0, l: 0 }
    function vr (e, t, n) {
      return (
        n < 0 && (n += 1),
        n > 1 && (n -= 1),
        n < 1 / 6
          ? e + 6 * (t - e) * n
          : n < 0.5
          ? t
          : n < 2 / 3
          ? e + 6 * (t - e) * (2 / 3 - n)
          : e
      )
    }
    function yr (e) {
      return e < 0.04045
        ? 0.0773993808 * e
        : Math.pow(0.9478672986 * e + 0.0521327014, 2.4)
    }
    function _r (e) {
      return e < 0.0031308 ? 12.92 * e : 1.055 * Math.pow(e, 0.41666) - 0.055
    }
    class xr {
      constructor (e, t, n) {
        return void 0 === t && void 0 === n ? this.set(e) : this.setRGB(e, t, n)
      }
      set (e) {
        return (
          e && e.isColor
            ? this.copy(e)
            : 'number' === typeof e
            ? this.setHex(e)
            : 'string' === typeof e && this.setStyle(e),
          this
        )
      }
      setScalar (e) {
        return (this.r = e), (this.g = e), (this.b = e), this
      }
      setHex (e) {
        return (
          (e = Math.floor(e)),
          (this.r = ((e >> 16) & 255) / 255),
          (this.g = ((e >> 8) & 255) / 255),
          (this.b = (255 & e) / 255),
          this
        )
      }
      setRGB (e, t, n) {
        return (this.r = e), (this.g = t), (this.b = n), this
      }
      setHSL (e, t, n) {
        if (((e = On(e, 1)), (t = Nn(t, 0, 1)), (n = Nn(n, 0, 1)), 0 === t))
          this.r = this.g = this.b = n
        else {
          const i = n <= 0.5 ? n * (1 + t) : n + t - n * t,
            r = 2 * n - i
          ;(this.r = vr(r, i, e + 1 / 3)),
            (this.g = vr(r, i, e)),
            (this.b = vr(r, i, e - 1 / 3))
        }
        return this
      }
      setStyle (e) {
        function t (t) {
          void 0 !== t &&
            parseFloat(t) < 1 &&
            console.warn(
              'THREE.Color: Alpha component of ' + e + ' will be ignored.'
            )
        }
        let n
        if ((n = /^((?:rgb|hsl)a?)\(([^\)]*)\)/.exec(e))) {
          let e
          const i = n[1],
            r = n[2]
          switch (i) {
            case 'rgb':
            case 'rgba':
              if (
                (e = /^\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(
                  r
                ))
              )
                return (
                  (this.r = Math.min(255, parseInt(e[1], 10)) / 255),
                  (this.g = Math.min(255, parseInt(e[2], 10)) / 255),
                  (this.b = Math.min(255, parseInt(e[3], 10)) / 255),
                  t(e[4]),
                  this
                )
              if (
                (e = /^\s*(\d+)\%\s*,\s*(\d+)\%\s*,\s*(\d+)\%\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(
                  r
                ))
              )
                return (
                  (this.r = Math.min(100, parseInt(e[1], 10)) / 100),
                  (this.g = Math.min(100, parseInt(e[2], 10)) / 100),
                  (this.b = Math.min(100, parseInt(e[3], 10)) / 100),
                  t(e[4]),
                  this
                )
              break
            case 'hsl':
            case 'hsla':
              if (
                (e = /^\s*(\d*\.?\d+)\s*,\s*(\d+)\%\s*,\s*(\d+)\%\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(
                  r
                ))
              ) {
                const n = parseFloat(e[1]) / 360,
                  i = parseInt(e[2], 10) / 100,
                  r = parseInt(e[3], 10) / 100
                return t(e[4]), this.setHSL(n, i, r)
              }
              break
          }
        } else if ((n = /^\#([A-Fa-f\d]+)$/.exec(e))) {
          const e = n[1],
            t = e.length
          if (3 === t)
            return (
              (this.r = parseInt(e.charAt(0) + e.charAt(0), 16) / 255),
              (this.g = parseInt(e.charAt(1) + e.charAt(1), 16) / 255),
              (this.b = parseInt(e.charAt(2) + e.charAt(2), 16) / 255),
              this
            )
          if (6 === t)
            return (
              (this.r = parseInt(e.charAt(0) + e.charAt(1), 16) / 255),
              (this.g = parseInt(e.charAt(2) + e.charAt(3), 16) / 255),
              (this.b = parseInt(e.charAt(4) + e.charAt(5), 16) / 255),
              this
            )
        }
        return e && e.length > 0 ? this.setColorName(e) : this
      }
      setColorName (e) {
        const t = fr[e.toLowerCase()]
        return (
          void 0 !== t
            ? this.setHex(t)
            : console.warn('THREE.Color: Unknown color ' + e),
          this
        )
      }
      clone () {
        return new this.constructor(this.r, this.g, this.b)
      }
      copy (e) {
        return (this.r = e.r), (this.g = e.g), (this.b = e.b), this
      }
      copyGammaToLinear (e, t = 2) {
        return (
          (this.r = Math.pow(e.r, t)),
          (this.g = Math.pow(e.g, t)),
          (this.b = Math.pow(e.b, t)),
          this
        )
      }
      copyLinearToGamma (e, t = 2) {
        const n = t > 0 ? 1 / t : 1
        return (
          (this.r = Math.pow(e.r, n)),
          (this.g = Math.pow(e.g, n)),
          (this.b = Math.pow(e.b, n)),
          this
        )
      }
      convertGammaToLinear (e) {
        return this.copyGammaToLinear(this, e), this
      }
      convertLinearToGamma (e) {
        return this.copyLinearToGamma(this, e), this
      }
      copySRGBToLinear (e) {
        return (this.r = yr(e.r)), (this.g = yr(e.g)), (this.b = yr(e.b)), this
      }
      copyLinearToSRGB (e) {
        return (this.r = _r(e.r)), (this.g = _r(e.g)), (this.b = _r(e.b)), this
      }
      convertSRGBToLinear () {
        return this.copySRGBToLinear(this), this
      }
      convertLinearToSRGB () {
        return this.copyLinearToSRGB(this), this
      }
      getHex () {
        return (
          ((255 * this.r) << 16) ^ ((255 * this.g) << 8) ^ ((255 * this.b) << 0)
        )
      }
      getHexString () {
        return ('000000' + this.getHex().toString(16)).slice(-6)
      }
      getHSL (e) {
        const t = this.r,
          n = this.g,
          i = this.b,
          r = Math.max(t, n, i),
          a = Math.min(t, n, i)
        let s, o
        const l = (a + r) / 2
        if (a === r) (s = 0), (o = 0)
        else {
          const e = r - a
          switch (((o = l <= 0.5 ? e / (r + a) : e / (2 - r - a)), r)) {
            case t:
              s = (n - i) / e + (n < i ? 6 : 0)
              break
            case n:
              s = (i - t) / e + 2
              break
            case i:
              s = (t - n) / e + 4
              break
          }
          s /= 6
        }
        return (e.h = s), (e.s = o), (e.l = l), e
      }
      getStyle () {
        return (
          'rgb(' +
          ((255 * this.r) | 0) +
          ',' +
          ((255 * this.g) | 0) +
          ',' +
          ((255 * this.b) | 0) +
          ')'
        )
      }
      offsetHSL (e, t, n) {
        return (
          this.getHSL(mr),
          (mr.h += e),
          (mr.s += t),
          (mr.l += n),
          this.setHSL(mr.h, mr.s, mr.l),
          this
        )
      }
      add (e) {
        return (this.r += e.r), (this.g += e.g), (this.b += e.b), this
      }
      addColors (e, t) {
        return (
          (this.r = e.r + t.r), (this.g = e.g + t.g), (this.b = e.b + t.b), this
        )
      }
      addScalar (e) {
        return (this.r += e), (this.g += e), (this.b += e), this
      }
      sub (e) {
        return (
          (this.r = Math.max(0, this.r - e.r)),
          (this.g = Math.max(0, this.g - e.g)),
          (this.b = Math.max(0, this.b - e.b)),
          this
        )
      }
      multiply (e) {
        return (this.r *= e.r), (this.g *= e.g), (this.b *= e.b), this
      }
      multiplyScalar (e) {
        return (this.r *= e), (this.g *= e), (this.b *= e), this
      }
      lerp (e, t) {
        return (
          (this.r += (e.r - this.r) * t),
          (this.g += (e.g - this.g) * t),
          (this.b += (e.b - this.b) * t),
          this
        )
      }
      lerpColors (e, t, n) {
        return (
          (this.r = e.r + (t.r - e.r) * n),
          (this.g = e.g + (t.g - e.g) * n),
          (this.b = e.b + (t.b - e.b) * n),
          this
        )
      }
      lerpHSL (e, t) {
        this.getHSL(mr), e.getHSL(gr)
        const n = Fn(mr.h, gr.h, t),
          i = Fn(mr.s, gr.s, t),
          r = Fn(mr.l, gr.l, t)
        return this.setHSL(n, i, r), this
      }
      equals (e) {
        return e.r === this.r && e.g === this.g && e.b === this.b
      }
      fromArray (e, t = 0) {
        return (this.r = e[t]), (this.g = e[t + 1]), (this.b = e[t + 2]), this
      }
      toArray (e = [], t = 0) {
        return (e[t] = this.r), (e[t + 1] = this.g), (e[t + 2] = this.b), e
      }
      fromBufferAttribute (e, t) {
        return (
          (this.r = e.getX(t)),
          (this.g = e.getY(t)),
          (this.b = e.getZ(t)),
          !0 === e.normalized &&
            ((this.r /= 255), (this.g /= 255), (this.b /= 255)),
          this
        )
      }
      toJSON () {
        return this.getHex()
      }
    }
    ;(xr.NAMES = fr),
      (xr.prototype.isColor = !0),
      (xr.prototype.r = 1),
      (xr.prototype.g = 1),
      (xr.prototype.b = 1)
    class wr extends pr {
      constructor (e) {
        super(),
          (this.type = 'MeshBasicMaterial'),
          (this.color = new xr(16777215)),
          (this.map = null),
          (this.lightMap = null),
          (this.lightMapIntensity = 1),
          (this.aoMap = null),
          (this.aoMapIntensity = 1),
          (this.specularMap = null),
          (this.alphaMap = null),
          (this.envMap = null),
          (this.combine = ve),
          (this.reflectivity = 1),
          (this.refractionRatio = 0.98),
          (this.wireframe = !1),
          (this.wireframeLinewidth = 1),
          (this.wireframeLinecap = 'round'),
          (this.wireframeLinejoin = 'round'),
          (this.morphTargets = !1),
          this.setValues(e)
      }
      copy (e) {
        return (
          super.copy(e),
          this.color.copy(e.color),
          (this.map = e.map),
          (this.lightMap = e.lightMap),
          (this.lightMapIntensity = e.lightMapIntensity),
          (this.aoMap = e.aoMap),
          (this.aoMapIntensity = e.aoMapIntensity),
          (this.specularMap = e.specularMap),
          (this.alphaMap = e.alphaMap),
          (this.envMap = e.envMap),
          (this.combine = e.combine),
          (this.reflectivity = e.reflectivity),
          (this.refractionRatio = e.refractionRatio),
          (this.wireframe = e.wireframe),
          (this.wireframeLinewidth = e.wireframeLinewidth),
          (this.wireframeLinecap = e.wireframeLinecap),
          (this.wireframeLinejoin = e.wireframeLinejoin),
          (this.morphTargets = e.morphTargets),
          this
        )
      }
    }
    wr.prototype.isMeshBasicMaterial = !0
    const br = new Qn(),
      Mr = new kn()
    class Sr {
      constructor (e, t, n) {
        if (Array.isArray(e))
          throw new TypeError(
            'THREE.BufferAttribute: array should be a Typed Array.'
          )
        ;(this.name = ''),
          (this.array = e),
          (this.itemSize = t),
          (this.count = void 0 !== e ? e.length / t : 0),
          (this.normalized = !0 === n),
          (this.usage = Tn),
          (this.updateRange = { offset: 0, count: -1 }),
          (this.version = 0)
      }
      onUploadCallback () {}
      set needsUpdate (e) {
        !0 === e && this.version++
      }
      setUsage (e) {
        return (this.usage = e), this
      }
      copy (e) {
        return (
          (this.name = e.name),
          (this.array = new e.array.constructor(e.array)),
          (this.itemSize = e.itemSize),
          (this.count = e.count),
          (this.normalized = e.normalized),
          (this.usage = e.usage),
          this
        )
      }
      copyAt (e, t, n) {
        ;(e *= this.itemSize), (n *= t.itemSize)
        for (let i = 0, r = this.itemSize; i < r; i++)
          this.array[e + i] = t.array[n + i]
        return this
      }
      copyArray (e) {
        return this.array.set(e), this
      }
      copyColorsArray (e) {
        const t = this.array
        let n = 0
        for (let i = 0, r = e.length; i < r; i++) {
          let r = e[i]
          void 0 === r &&
            (console.warn(
              'THREE.BufferAttribute.copyColorsArray(): color is undefined',
              i
            ),
            (r = new xr())),
            (t[n++] = r.r),
            (t[n++] = r.g),
            (t[n++] = r.b)
        }
        return this
      }
      copyVector2sArray (e) {
        const t = this.array
        let n = 0
        for (let i = 0, r = e.length; i < r; i++) {
          let r = e[i]
          void 0 === r &&
            (console.warn(
              'THREE.BufferAttribute.copyVector2sArray(): vector is undefined',
              i
            ),
            (r = new kn())),
            (t[n++] = r.x),
            (t[n++] = r.y)
        }
        return this
      }
      copyVector3sArray (e) {
        const t = this.array
        let n = 0
        for (let i = 0, r = e.length; i < r; i++) {
          let r = e[i]
          void 0 === r &&
            (console.warn(
              'THREE.BufferAttribute.copyVector3sArray(): vector is undefined',
              i
            ),
            (r = new Qn())),
            (t[n++] = r.x),
            (t[n++] = r.y),
            (t[n++] = r.z)
        }
        return this
      }
      copyVector4sArray (e) {
        const t = this.array
        let n = 0
        for (let i = 0, r = e.length; i < r; i++) {
          let r = e[i]
          void 0 === r &&
            (console.warn(
              'THREE.BufferAttribute.copyVector4sArray(): vector is undefined',
              i
            ),
            (r = new Yn())),
            (t[n++] = r.x),
            (t[n++] = r.y),
            (t[n++] = r.z),
            (t[n++] = r.w)
        }
        return this
      }
      applyMatrix3 (e) {
        if (2 === this.itemSize)
          for (let t = 0, n = this.count; t < n; t++)
            Mr.fromBufferAttribute(this, t),
              Mr.applyMatrix3(e),
              this.setXY(t, Mr.x, Mr.y)
        else if (3 === this.itemSize)
          for (let t = 0, n = this.count; t < n; t++)
            br.fromBufferAttribute(this, t),
              br.applyMatrix3(e),
              this.setXYZ(t, br.x, br.y, br.z)
        return this
      }
      applyMatrix4 (e) {
        for (let t = 0, n = this.count; t < n; t++)
          (br.x = this.getX(t)),
            (br.y = this.getY(t)),
            (br.z = this.getZ(t)),
            br.applyMatrix4(e),
            this.setXYZ(t, br.x, br.y, br.z)
        return this
      }
      applyNormalMatrix (e) {
        for (let t = 0, n = this.count; t < n; t++)
          (br.x = this.getX(t)),
            (br.y = this.getY(t)),
            (br.z = this.getZ(t)),
            br.applyNormalMatrix(e),
            this.setXYZ(t, br.x, br.y, br.z)
        return this
      }
      transformDirection (e) {
        for (let t = 0, n = this.count; t < n; t++)
          (br.x = this.getX(t)),
            (br.y = this.getY(t)),
            (br.z = this.getZ(t)),
            br.transformDirection(e),
            this.setXYZ(t, br.x, br.y, br.z)
        return this
      }
      set (e, t = 0) {
        return this.array.set(e, t), this
      }
      getX (e) {
        return this.array[e * this.itemSize]
      }
      setX (e, t) {
        return (this.array[e * this.itemSize] = t), this
      }
      getY (e) {
        return this.array[e * this.itemSize + 1]
      }
      setY (e, t) {
        return (this.array[e * this.itemSize + 1] = t), this
      }
      getZ (e) {
        return this.array[e * this.itemSize + 2]
      }
      setZ (e, t) {
        return (this.array[e * this.itemSize + 2] = t), this
      }
      getW (e) {
        return this.array[e * this.itemSize + 3]
      }
      setW (e, t) {
        return (this.array[e * this.itemSize + 3] = t), this
      }
      setXY (e, t, n) {
        return (
          (e *= this.itemSize),
          (this.array[e + 0] = t),
          (this.array[e + 1] = n),
          this
        )
      }
      setXYZ (e, t, n, i) {
        return (
          (e *= this.itemSize),
          (this.array[e + 0] = t),
          (this.array[e + 1] = n),
          (this.array[e + 2] = i),
          this
        )
      }
      setXYZW (e, t, n, i, r) {
        return (
          (e *= this.itemSize),
          (this.array[e + 0] = t),
          (this.array[e + 1] = n),
          (this.array[e + 2] = i),
          (this.array[e + 3] = r),
          this
        )
      }
      onUpload (e) {
        return (this.onUploadCallback = e), this
      }
      clone () {
        return new this.constructor(this.array, this.itemSize).copy(this)
      }
      toJSON () {
        const e = {
          itemSize: this.itemSize,
          type: this.array.constructor.name,
          array: Array.prototype.slice.call(this.array),
          normalized: this.normalized
        }
        return (
          '' !== this.name && (e.name = this.name),
          this.usage !== Tn && (e.usage = this.usage),
          (0 === this.updateRange.offset && -1 === this.updateRange.count) ||
            (e.updateRange = this.updateRange),
          e
        )
      }
    }
    Sr.prototype.isBufferAttribute = !0
    class Er extends Sr {
      constructor (e, t, n) {
        super(new Uint16Array(e), t, n)
      }
    }
    class Tr extends Sr {
      constructor (e, t, n) {
        super(new Uint32Array(e), t, n)
      }
    }
    class Ar extends Sr {
      constructor (e, t, n) {
        super(new Uint16Array(e), t, n)
      }
    }
    Ar.prototype.isFloat16BufferAttribute = !0
    class Rr extends Sr {
      constructor (e, t, n) {
        super(new Float32Array(e), t, n)
      }
    }
    function Lr (e) {
      if (0 === e.length) return -1 / 0
      let t = e[0]
      for (let n = 1, i = e.length; n < i; ++n) e[n] > t && (t = e[n])
      return t
    }
    const Cr = {
      Int8Array: Int8Array,
      Uint8Array: Uint8Array,
      Uint8ClampedArray: Uint8ClampedArray,
      Int16Array: Int16Array,
      Uint16Array: Uint16Array,
      Int32Array: Int32Array,
      Uint32Array: Uint32Array,
      Float32Array: Float32Array,
      Float64Array: Float64Array
    }
    function Pr (e, t) {
      return new Cr[e](t)
    }
    let Dr = 0
    const Ir = new Li(),
      Nr = new er(),
      Or = new Qn(),
      Fr = new ti(),
      Br = new ti(),
      zr = new Qn()
    class Ur extends Ln {
      constructor () {
        super(),
          Object.defineProperty(this, 'id', { value: Dr++ }),
          (this.uuid = In()),
          (this.name = ''),
          (this.type = 'BufferGeometry'),
          (this.index = null),
          (this.attributes = {}),
          (this.morphAttributes = {}),
          (this.morphTargetsRelative = !1),
          (this.groups = []),
          (this.boundingBox = null),
          (this.boundingSphere = null),
          (this.drawRange = { start: 0, count: 1 / 0 }),
          (this.userData = {})
      }
      getIndex () {
        return this.index
      }
      setIndex (e) {
        return (
          Array.isArray(e)
            ? (this.index = new (Lr(e) > 65535 ? Tr : Er)(e, 1))
            : (this.index = e),
          this
        )
      }
      getAttribute (e) {
        return this.attributes[e]
      }
      setAttribute (e, t) {
        return (this.attributes[e] = t), this
      }
      deleteAttribute (e) {
        return delete this.attributes[e], this
      }
      hasAttribute (e) {
        return void 0 !== this.attributes[e]
      }
      addGroup (e, t, n = 0) {
        this.groups.push({ start: e, count: t, materialIndex: n })
      }
      clearGroups () {
        this.groups = []
      }
      setDrawRange (e, t) {
        ;(this.drawRange.start = e), (this.drawRange.count = t)
      }
      applyMatrix4 (e) {
        const t = this.attributes.position
        void 0 !== t && (t.applyMatrix4(e), (t.needsUpdate = !0))
        const n = this.attributes.normal
        if (void 0 !== n) {
          const t = new Hn().getNormalMatrix(e)
          n.applyNormalMatrix(t), (n.needsUpdate = !0)
        }
        const i = this.attributes.tangent
        return (
          void 0 !== i && (i.transformDirection(e), (i.needsUpdate = !0)),
          null !== this.boundingBox && this.computeBoundingBox(),
          null !== this.boundingSphere && this.computeBoundingSphere(),
          this
        )
      }
      applyQuaternion (e) {
        return Ir.makeRotationFromQuaternion(e), this.applyMatrix4(Ir), this
      }
      rotateX (e) {
        return Ir.makeRotationX(e), this.applyMatrix4(Ir), this
      }
      rotateY (e) {
        return Ir.makeRotationY(e), this.applyMatrix4(Ir), this
      }
      rotateZ (e) {
        return Ir.makeRotationZ(e), this.applyMatrix4(Ir), this
      }
      translate (e, t, n) {
        return Ir.makeTranslation(e, t, n), this.applyMatrix4(Ir), this
      }
      scale (e, t, n) {
        return Ir.makeScale(e, t, n), this.applyMatrix4(Ir), this
      }
      lookAt (e) {
        return (
          Nr.lookAt(e), Nr.updateMatrix(), this.applyMatrix4(Nr.matrix), this
        )
      }
      center () {
        return (
          this.computeBoundingBox(),
          this.boundingBox.getCenter(Or).negate(),
          this.translate(Or.x, Or.y, Or.z),
          this
        )
      }
      setFromPoints (e) {
        const t = []
        for (let n = 0, i = e.length; n < i; n++) {
          const i = e[n]
          t.push(i.x, i.y, i.z || 0)
        }
        return this.setAttribute('position', new Rr(t, 3)), this
      }
      computeBoundingBox () {
        null === this.boundingBox && (this.boundingBox = new ti())
        const e = this.attributes.position,
          t = this.morphAttributes.position
        if (e && e.isGLBufferAttribute)
          return (
            console.error(
              'THREE.BufferGeometry.computeBoundingBox(): GLBufferAttribute requires a manual bounding box. Alternatively set "mesh.frustumCulled" to "false".',
              this
            ),
            void this.boundingBox.set(
              new Qn(-1 / 0, -1 / 0, -1 / 0),
              new Qn(1 / 0, 1 / 0, 1 / 0)
            )
          )
        if (void 0 !== e) {
          if ((this.boundingBox.setFromBufferAttribute(e), t))
            for (let n = 0, i = t.length; n < i; n++) {
              const e = t[n]
              Fr.setFromBufferAttribute(e),
                this.morphTargetsRelative
                  ? (zr.addVectors(this.boundingBox.min, Fr.min),
                    this.boundingBox.expandByPoint(zr),
                    zr.addVectors(this.boundingBox.max, Fr.max),
                    this.boundingBox.expandByPoint(zr))
                  : (this.boundingBox.expandByPoint(Fr.min),
                    this.boundingBox.expandByPoint(Fr.max))
            }
        } else this.boundingBox.makeEmpty()
        ;(isNaN(this.boundingBox.min.x) ||
          isNaN(this.boundingBox.min.y) ||
          isNaN(this.boundingBox.min.z)) &&
          console.error(
            'THREE.BufferGeometry.computeBoundingBox(): Computed min/max have NaN values. The "position" attribute is likely to have NaN values.',
            this
          )
      }
      computeBoundingSphere () {
        null === this.boundingSphere && (this.boundingSphere = new xi())
        const e = this.attributes.position,
          t = this.morphAttributes.position
        if (e && e.isGLBufferAttribute)
          return (
            console.error(
              'THREE.BufferGeometry.computeBoundingSphere(): GLBufferAttribute requires a manual bounding sphere. Alternatively set "mesh.frustumCulled" to "false".',
              this
            ),
            void this.boundingSphere.set(new Qn(), 1 / 0)
          )
        if (e) {
          const n = this.boundingSphere.center
          if ((Fr.setFromBufferAttribute(e), t))
            for (let e = 0, r = t.length; e < r; e++) {
              const n = t[e]
              Br.setFromBufferAttribute(n),
                this.morphTargetsRelative
                  ? (zr.addVectors(Fr.min, Br.min),
                    Fr.expandByPoint(zr),
                    zr.addVectors(Fr.max, Br.max),
                    Fr.expandByPoint(zr))
                  : (Fr.expandByPoint(Br.min), Fr.expandByPoint(Br.max))
            }
          Fr.getCenter(n)
          let i = 0
          for (let t = 0, r = e.count; t < r; t++)
            zr.fromBufferAttribute(e, t),
              (i = Math.max(i, n.distanceToSquared(zr)))
          if (t)
            for (let r = 0, a = t.length; r < a; r++) {
              const a = t[r],
                s = this.morphTargetsRelative
              for (let t = 0, r = a.count; t < r; t++)
                zr.fromBufferAttribute(a, t),
                  s && (Or.fromBufferAttribute(e, t), zr.add(Or)),
                  (i = Math.max(i, n.distanceToSquared(zr)))
            }
          ;(this.boundingSphere.radius = Math.sqrt(i)),
            isNaN(this.boundingSphere.radius) &&
              console.error(
                'THREE.BufferGeometry.computeBoundingSphere(): Computed radius is NaN. The "position" attribute is likely to have NaN values.',
                this
              )
        }
      }
      computeFaceNormals () {}
      computeTangents () {
        const e = this.index,
          t = this.attributes
        if (
          null === e ||
          void 0 === t.position ||
          void 0 === t.normal ||
          void 0 === t.uv
        )
          return void console.error(
            'THREE.BufferGeometry: .computeTangents() failed. Missing required attributes (index, position, normal or uv)'
          )
        const n = e.array,
          i = t.position.array,
          r = t.normal.array,
          a = t.uv.array,
          s = i.length / 3
        void 0 === t.tangent &&
          this.setAttribute('tangent', new Sr(new Float32Array(4 * s), 4))
        const o = t.tangent.array,
          l = [],
          c = []
        for (let E = 0; E < s; E++) (l[E] = new Qn()), (c[E] = new Qn())
        const h = new Qn(),
          u = new Qn(),
          d = new Qn(),
          p = new kn(),
          f = new kn(),
          m = new kn(),
          g = new Qn(),
          v = new Qn()
        function y (e, t, n) {
          h.fromArray(i, 3 * e),
            u.fromArray(i, 3 * t),
            d.fromArray(i, 3 * n),
            p.fromArray(a, 2 * e),
            f.fromArray(a, 2 * t),
            m.fromArray(a, 2 * n),
            u.sub(h),
            d.sub(h),
            f.sub(p),
            m.sub(p)
          const r = 1 / (f.x * m.y - m.x * f.y)
          isFinite(r) &&
            (g
              .copy(u)
              .multiplyScalar(m.y)
              .addScaledVector(d, -f.y)
              .multiplyScalar(r),
            v
              .copy(d)
              .multiplyScalar(f.x)
              .addScaledVector(u, -m.x)
              .multiplyScalar(r),
            l[e].add(g),
            l[t].add(g),
            l[n].add(g),
            c[e].add(v),
            c[t].add(v),
            c[n].add(v))
        }
        let _ = this.groups
        0 === _.length && (_ = [{ start: 0, count: n.length }])
        for (let E = 0, T = _.length; E < T; ++E) {
          const e = _[E],
            t = e.start,
            i = e.count
          for (let r = t, a = t + i; r < a; r += 3)
            y(n[r + 0], n[r + 1], n[r + 2])
        }
        const x = new Qn(),
          w = new Qn(),
          b = new Qn(),
          M = new Qn()
        function S (e) {
          b.fromArray(r, 3 * e), M.copy(b)
          const t = l[e]
          x.copy(t),
            x.sub(b.multiplyScalar(b.dot(t))).normalize(),
            w.crossVectors(M, t)
          const n = w.dot(c[e]),
            i = n < 0 ? -1 : 1
          ;(o[4 * e] = x.x),
            (o[4 * e + 1] = x.y),
            (o[4 * e + 2] = x.z),
            (o[4 * e + 3] = i)
        }
        for (let E = 0, T = _.length; E < T; ++E) {
          const e = _[E],
            t = e.start,
            i = e.count
          for (let r = t, a = t + i; r < a; r += 3)
            S(n[r + 0]), S(n[r + 1]), S(n[r + 2])
        }
      }
      computeVertexNormals () {
        const e = this.index,
          t = this.getAttribute('position')
        if (void 0 !== t) {
          let n = this.getAttribute('normal')
          if (void 0 === n)
            (n = new Sr(new Float32Array(3 * t.count), 3)),
              this.setAttribute('normal', n)
          else for (let e = 0, t = n.count; e < t; e++) n.setXYZ(e, 0, 0, 0)
          const i = new Qn(),
            r = new Qn(),
            a = new Qn(),
            s = new Qn(),
            o = new Qn(),
            l = new Qn(),
            c = new Qn(),
            h = new Qn()
          if (e)
            for (let u = 0, d = e.count; u < d; u += 3) {
              const d = e.getX(u + 0),
                p = e.getX(u + 1),
                f = e.getX(u + 2)
              i.fromBufferAttribute(t, d),
                r.fromBufferAttribute(t, p),
                a.fromBufferAttribute(t, f),
                c.subVectors(a, r),
                h.subVectors(i, r),
                c.cross(h),
                s.fromBufferAttribute(n, d),
                o.fromBufferAttribute(n, p),
                l.fromBufferAttribute(n, f),
                s.add(c),
                o.add(c),
                l.add(c),
                n.setXYZ(d, s.x, s.y, s.z),
                n.setXYZ(p, o.x, o.y, o.z),
                n.setXYZ(f, l.x, l.y, l.z)
            }
          else
            for (let e = 0, u = t.count; e < u; e += 3)
              i.fromBufferAttribute(t, e + 0),
                r.fromBufferAttribute(t, e + 1),
                a.fromBufferAttribute(t, e + 2),
                c.subVectors(a, r),
                h.subVectors(i, r),
                c.cross(h),
                n.setXYZ(e + 0, c.x, c.y, c.z),
                n.setXYZ(e + 1, c.x, c.y, c.z),
                n.setXYZ(e + 2, c.x, c.y, c.z)
          this.normalizeNormals(), (n.needsUpdate = !0)
        }
      }
      merge (e, t) {
        if (!e || !e.isBufferGeometry)
          return void console.error(
            'THREE.BufferGeometry.merge(): geometry not an instance of THREE.BufferGeometry.',
            e
          )
        void 0 === t &&
          ((t = 0),
          console.warn(
            'THREE.BufferGeometry.merge(): Overwriting original geometry, starting at offset=0. Use BufferGeometryUtils.mergeBufferGeometries() for lossless merge.'
          ))
        const n = this.attributes
        for (const i in n) {
          if (void 0 === e.attributes[i]) continue
          const r = n[i],
            a = r.array,
            s = e.attributes[i],
            o = s.array,
            l = s.itemSize * t,
            c = Math.min(o.length, a.length - l)
          for (let e = 0, t = l; e < c; e++, t++) a[t] = o[e]
        }
        return this
      }
      normalizeNormals () {
        const e = this.attributes.normal
        for (let t = 0, n = e.count; t < n; t++)
          zr.fromBufferAttribute(e, t),
            zr.normalize(),
            e.setXYZ(t, zr.x, zr.y, zr.z)
      }
      toNonIndexed () {
        function e (e, t) {
          const n = e.array,
            i = e.itemSize,
            r = e.normalized,
            a = new n.constructor(t.length * i)
          let s = 0,
            o = 0
          for (let l = 0, c = t.length; l < c; l++) {
            s = e.isInterleavedBufferAttribute
              ? t[l] * e.data.stride + e.offset
              : t[l] * i
            for (let e = 0; e < i; e++) a[o++] = n[s++]
          }
          return new Sr(a, i, r)
        }
        if (null === this.index)
          return (
            console.warn(
              'THREE.BufferGeometry.toNonIndexed(): BufferGeometry is already non-indexed.'
            ),
            this
          )
        const t = new Ur(),
          n = this.index.array,
          i = this.attributes
        for (const s in i) {
          const r = i[s],
            a = e(r, n)
          t.setAttribute(s, a)
        }
        const r = this.morphAttributes
        for (const s in r) {
          const i = [],
            a = r[s]
          for (let t = 0, r = a.length; t < r; t++) {
            const r = a[t],
              s = e(r, n)
            i.push(s)
          }
          t.morphAttributes[s] = i
        }
        t.morphTargetsRelative = this.morphTargetsRelative
        const a = this.groups
        for (let s = 0, o = a.length; s < o; s++) {
          const e = a[s]
          t.addGroup(e.start, e.count, e.materialIndex)
        }
        return t
      }
      toJSON () {
        const e = {
          metadata: {
            version: 4.5,
            type: 'BufferGeometry',
            generator: 'BufferGeometry.toJSON'
          }
        }
        if (
          ((e.uuid = this.uuid),
          (e.type = this.type),
          '' !== this.name && (e.name = this.name),
          Object.keys(this.userData).length > 0 && (e.userData = this.userData),
          void 0 !== this.parameters)
        ) {
          const t = this.parameters
          for (const n in t) void 0 !== t[n] && (e[n] = t[n])
          return e
        }
        e.data = { attributes: {} }
        const t = this.index
        null !== t &&
          (e.data.index = {
            type: t.array.constructor.name,
            array: Array.prototype.slice.call(t.array)
          })
        const n = this.attributes
        for (const o in n) {
          const t = n[o]
          e.data.attributes[o] = t.toJSON(e.data)
        }
        const i = {}
        let r = !1
        for (const o in this.morphAttributes) {
          const t = this.morphAttributes[o],
            n = []
          for (let i = 0, r = t.length; i < r; i++) {
            const r = t[i]
            n.push(r.toJSON(e.data))
          }
          n.length > 0 && ((i[o] = n), (r = !0))
        }
        r &&
          ((e.data.morphAttributes = i),
          (e.data.morphTargetsRelative = this.morphTargetsRelative))
        const a = this.groups
        a.length > 0 && (e.data.groups = JSON.parse(JSON.stringify(a)))
        const s = this.boundingSphere
        return (
          null !== s &&
            (e.data.boundingSphere = {
              center: s.center.toArray(),
              radius: s.radius
            }),
          e
        )
      }
      clone () {
        return new Ur().copy(this)
      }
      copy (e) {
        ;(this.index = null),
          (this.attributes = {}),
          (this.morphAttributes = {}),
          (this.groups = []),
          (this.boundingBox = null),
          (this.boundingSphere = null)
        const t = {}
        this.name = e.name
        const n = e.index
        null !== n && this.setIndex(n.clone(t))
        const i = e.attributes
        for (const l in i) {
          const e = i[l]
          this.setAttribute(l, e.clone(t))
        }
        const r = e.morphAttributes
        for (const l in r) {
          const e = [],
            n = r[l]
          for (let i = 0, r = n.length; i < r; i++) e.push(n[i].clone(t))
          this.morphAttributes[l] = e
        }
        this.morphTargetsRelative = e.morphTargetsRelative
        const a = e.groups
        for (let l = 0, c = a.length; l < c; l++) {
          const e = a[l]
          this.addGroup(e.start, e.count, e.materialIndex)
        }
        const s = e.boundingBox
        null !== s && (this.boundingBox = s.clone())
        const o = e.boundingSphere
        return (
          null !== o && (this.boundingSphere = o.clone()),
          (this.drawRange.start = e.drawRange.start),
          (this.drawRange.count = e.drawRange.count),
          (this.userData = e.userData),
          this
        )
      }
      dispose () {
        this.dispatchEvent({ type: 'dispose' })
      }
    }
    Ur.prototype.isBufferGeometry = !0
    const kr = new Li(),
      Hr = new Ri(),
      Wr = new xi(),
      Vr = new Qn(),
      Gr = new Qn(),
      jr = new Qn(),
      qr = new Qn(),
      Yr = new Qn(),
      Xr = new Qn(),
      Jr = new Qn(),
      Zr = new Qn(),
      Kr = new Qn(),
      Qr = new kn(),
      $r = new kn(),
      ea = new kn(),
      ta = new Qn(),
      na = new Qn()
    class ia extends er {
      constructor (e = new Ur(), t = new wr()) {
        super(),
          (this.type = 'Mesh'),
          (this.geometry = e),
          (this.material = t),
          this.updateMorphTargets()
      }
      copy (e) {
        return (
          super.copy(e),
          void 0 !== e.morphTargetInfluences &&
            (this.morphTargetInfluences = e.morphTargetInfluences.slice()),
          void 0 !== e.morphTargetDictionary &&
            (this.morphTargetDictionary = Object.assign(
              {},
              e.morphTargetDictionary
            )),
          (this.material = e.material),
          (this.geometry = e.geometry),
          this
        )
      }
      updateMorphTargets () {
        const e = this.geometry
        if (e.isBufferGeometry) {
          const t = e.morphAttributes,
            n = Object.keys(t)
          if (n.length > 0) {
            const e = t[n[0]]
            if (void 0 !== e) {
              ;(this.morphTargetInfluences = []),
                (this.morphTargetDictionary = {})
              for (let t = 0, n = e.length; t < n; t++) {
                const n = e[t].name || String(t)
                this.morphTargetInfluences.push(0),
                  (this.morphTargetDictionary[n] = t)
              }
            }
          }
        } else {
          const t = e.morphTargets
          void 0 !== t &&
            t.length > 0 &&
            console.error(
              'THREE.Mesh.updateMorphTargets() no longer supports THREE.Geometry. Use THREE.BufferGeometry instead.'
            )
        }
      }
      raycast (e, t) {
        const n = this.geometry,
          i = this.material,
          r = this.matrixWorld
        if (void 0 === i) return
        if (
          (null === n.boundingSphere && n.computeBoundingSphere(),
          Wr.copy(n.boundingSphere),
          Wr.applyMatrix4(r),
          !1 === e.ray.intersectsSphere(Wr))
        )
          return
        if (
          (kr.copy(r).invert(),
          Hr.copy(e.ray).applyMatrix4(kr),
          null !== n.boundingBox && !1 === Hr.intersectsBox(n.boundingBox))
        )
          return
        let a
        if (n.isBufferGeometry) {
          const r = n.index,
            s = n.attributes.position,
            o = n.morphAttributes.position,
            l = n.morphTargetsRelative,
            c = n.attributes.uv,
            h = n.attributes.uv2,
            u = n.groups,
            d = n.drawRange
          if (null !== r)
            if (Array.isArray(i))
              for (let n = 0, p = u.length; n < p; n++) {
                const p = u[n],
                  f = i[p.materialIndex],
                  m = Math.max(p.start, d.start),
                  g = Math.min(p.start + p.count, d.start + d.count)
                for (let n = m, i = g; n < i; n += 3) {
                  const i = r.getX(n),
                    u = r.getX(n + 1),
                    d = r.getX(n + 2)
                  ;(a = aa(this, f, e, Hr, s, o, l, c, h, i, u, d)),
                    a &&
                      ((a.faceIndex = Math.floor(n / 3)),
                      (a.face.materialIndex = p.materialIndex),
                      t.push(a))
                }
              }
            else {
              const n = Math.max(0, d.start),
                u = Math.min(r.count, d.start + d.count)
              for (let d = n, p = u; d < p; d += 3) {
                const n = r.getX(d),
                  u = r.getX(d + 1),
                  p = r.getX(d + 2)
                ;(a = aa(this, i, e, Hr, s, o, l, c, h, n, u, p)),
                  a && ((a.faceIndex = Math.floor(d / 3)), t.push(a))
              }
            }
          else if (void 0 !== s)
            if (Array.isArray(i))
              for (let n = 0, p = u.length; n < p; n++) {
                const r = u[n],
                  p = i[r.materialIndex],
                  f = Math.max(r.start, d.start),
                  m = Math.min(r.start + r.count, d.start + d.count)
                for (let n = f, i = m; n < i; n += 3) {
                  const i = n,
                    u = n + 1,
                    d = n + 2
                  ;(a = aa(this, p, e, Hr, s, o, l, c, h, i, u, d)),
                    a &&
                      ((a.faceIndex = Math.floor(n / 3)),
                      (a.face.materialIndex = r.materialIndex),
                      t.push(a))
                }
              }
            else {
              const n = Math.max(0, d.start),
                r = Math.min(s.count, d.start + d.count)
              for (let u = n, d = r; u < d; u += 3) {
                const n = u,
                  r = u + 1,
                  d = u + 2
                ;(a = aa(this, i, e, Hr, s, o, l, c, h, n, r, d)),
                  a && ((a.faceIndex = Math.floor(u / 3)), t.push(a))
              }
            }
        } else
          n.isGeometry &&
            console.error(
              'THREE.Mesh.raycast() no longer supports THREE.Geometry. Use THREE.BufferGeometry instead.'
            )
      }
    }
    function ra (e, t, n, i, r, a, s, o) {
      let l
      if (
        ((l =
          t.side === z
            ? i.intersectTriangle(s, a, r, !0, o)
            : i.intersectTriangle(r, a, s, t.side !== U, o)),
        null === l)
      )
        return null
      na.copy(o), na.applyMatrix4(e.matrixWorld)
      const c = n.ray.origin.distanceTo(na)
      return c < n.near || c > n.far
        ? null
        : { distance: c, point: na.clone(), object: e }
    }
    function aa (e, t, n, i, r, a, s, o, l, c, h, u) {
      Vr.fromBufferAttribute(r, c),
        Gr.fromBufferAttribute(r, h),
        jr.fromBufferAttribute(r, u)
      const d = e.morphTargetInfluences
      if (t.morphTargets && a && d) {
        Jr.set(0, 0, 0), Zr.set(0, 0, 0), Kr.set(0, 0, 0)
        for (let e = 0, t = a.length; e < t; e++) {
          const t = d[e],
            n = a[e]
          0 !== t &&
            (qr.fromBufferAttribute(n, c),
            Yr.fromBufferAttribute(n, h),
            Xr.fromBufferAttribute(n, u),
            s
              ? (Jr.addScaledVector(qr, t),
                Zr.addScaledVector(Yr, t),
                Kr.addScaledVector(Xr, t))
              : (Jr.addScaledVector(qr.sub(Vr), t),
                Zr.addScaledVector(Yr.sub(Gr), t),
                Kr.addScaledVector(Xr.sub(jr), t)))
        }
        Vr.add(Jr), Gr.add(Zr), jr.add(Kr)
      }
      e.isSkinnedMesh &&
        (e.boneTransform(c, Vr), e.boneTransform(h, Gr), e.boneTransform(u, jr))
      const p = ra(e, t, n, i, Vr, Gr, jr, ta)
      if (p) {
        o &&
          (Qr.fromBufferAttribute(o, c),
          $r.fromBufferAttribute(o, h),
          ea.fromBufferAttribute(o, u),
          (p.uv = ur.getUV(ta, Vr, Gr, jr, Qr, $r, ea, new kn()))),
          l &&
            (Qr.fromBufferAttribute(l, c),
            $r.fromBufferAttribute(l, h),
            ea.fromBufferAttribute(l, u),
            (p.uv2 = ur.getUV(ta, Vr, Gr, jr, Qr, $r, ea, new kn())))
        const e = { a: c, b: h, c: u, normal: new Qn(), materialIndex: 0 }
        ur.getNormal(Vr, Gr, jr, e.normal), (p.face = e)
      }
      return p
    }
    ia.prototype.isMesh = !0
    class sa extends Ur {
      constructor (e = 1, t = 1, n = 1, i = 1, r = 1, a = 1) {
        super(),
          (this.type = 'BoxGeometry'),
          (this.parameters = {
            width: e,
            height: t,
            depth: n,
            widthSegments: i,
            heightSegments: r,
            depthSegments: a
          })
        const s = this
        ;(i = Math.floor(i)), (r = Math.floor(r)), (a = Math.floor(a))
        const o = [],
          l = [],
          c = [],
          h = []
        let u = 0,
          d = 0
        function p (e, t, n, i, r, a, p, f, m, g, v) {
          const y = a / m,
            _ = p / g,
            x = a / 2,
            w = p / 2,
            b = f / 2,
            M = m + 1,
            S = g + 1
          let E = 0,
            T = 0
          const A = new Qn()
          for (let s = 0; s < S; s++) {
            const a = s * _ - w
            for (let o = 0; o < M; o++) {
              const u = o * y - x
              ;(A[e] = u * i),
                (A[t] = a * r),
                (A[n] = b),
                l.push(A.x, A.y, A.z),
                (A[e] = 0),
                (A[t] = 0),
                (A[n] = f > 0 ? 1 : -1),
                c.push(A.x, A.y, A.z),
                h.push(o / m),
                h.push(1 - s / g),
                (E += 1)
            }
          }
          for (let s = 0; s < g; s++)
            for (let e = 0; e < m; e++) {
              const t = u + e + M * s,
                n = u + e + M * (s + 1),
                i = u + (e + 1) + M * (s + 1),
                r = u + (e + 1) + M * s
              o.push(t, n, r), o.push(n, i, r), (T += 6)
            }
          s.addGroup(d, T, v), (d += T), (u += E)
        }
        p('z', 'y', 'x', -1, -1, n, t, e, a, r, 0),
          p('z', 'y', 'x', 1, -1, n, t, -e, a, r, 1),
          p('x', 'z', 'y', 1, 1, e, n, t, i, a, 2),
          p('x', 'z', 'y', 1, -1, e, n, -t, i, a, 3),
          p('x', 'y', 'z', 1, -1, e, t, n, i, r, 4),
          p('x', 'y', 'z', -1, -1, e, t, -n, i, r, 5),
          this.setIndex(o),
          this.setAttribute('position', new Rr(l, 3)),
          this.setAttribute('normal', new Rr(c, 3)),
          this.setAttribute('uv', new Rr(h, 2))
      }
      static fromJSON (e) {
        return new sa(
          e.width,
          e.height,
          e.depth,
          e.widthSegments,
          e.heightSegments,
          e.depthSegments
        )
      }
    }
    function oa (e) {
      const t = {}
      for (const n in e) {
        t[n] = {}
        for (const i in e[n]) {
          const r = e[n][i]
          r &&
          (r.isColor ||
            r.isMatrix3 ||
            r.isMatrix4 ||
            r.isVector2 ||
            r.isVector3 ||
            r.isVector4 ||
            r.isTexture ||
            r.isQuaternion)
            ? (t[n][i] = r.clone())
            : Array.isArray(r)
            ? (t[n][i] = r.slice())
            : (t[n][i] = r)
        }
      }
      return t
    }
    function la (e) {
      const t = {}
      for (let n = 0; n < e.length; n++) {
        const i = oa(e[n])
        for (const e in i) t[e] = i[e]
      }
      return t
    }
    const ca = { clone: oa, merge: la }
    var ha =
        'void main() {\n\tgl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );\n}',
      ua = 'void main() {\n\tgl_FragColor = vec4( 1.0, 0.0, 0.0, 1.0 );\n}'
    class da extends pr {
      constructor (e) {
        super(),
          (this.type = 'ShaderMaterial'),
          (this.defines = {}),
          (this.uniforms = {}),
          (this.vertexShader = ha),
          (this.fragmentShader = ua),
          (this.linewidth = 1),
          (this.wireframe = !1),
          (this.wireframeLinewidth = 1),
          (this.fog = !1),
          (this.lights = !1),
          (this.clipping = !1),
          (this.morphTargets = !1),
          (this.morphNormals = !1),
          (this.extensions = {
            derivatives: !1,
            fragDepth: !1,
            drawBuffers: !1,
            shaderTextureLOD: !1
          }),
          (this.defaultAttributeValues = {
            color: [1, 1, 1],
            uv: [0, 0],
            uv2: [0, 0]
          }),
          (this.index0AttributeName = void 0),
          (this.uniformsNeedUpdate = !1),
          (this.glslVersion = null),
          void 0 !== e &&
            (void 0 !== e.attributes &&
              console.error(
                'THREE.ShaderMaterial: attributes should now be defined in THREE.BufferGeometry instead.'
              ),
            this.setValues(e))
      }
      copy (e) {
        return (
          super.copy(e),
          (this.fragmentShader = e.fragmentShader),
          (this.vertexShader = e.vertexShader),
          (this.uniforms = oa(e.uniforms)),
          (this.defines = Object.assign({}, e.defines)),
          (this.wireframe = e.wireframe),
          (this.wireframeLinewidth = e.wireframeLinewidth),
          (this.lights = e.lights),
          (this.clipping = e.clipping),
          (this.morphTargets = e.morphTargets),
          (this.morphNormals = e.morphNormals),
          (this.extensions = Object.assign({}, e.extensions)),
          (this.glslVersion = e.glslVersion),
          this
        )
      }
      toJSON (e) {
        const t = super.toJSON(e)
        ;(t.glslVersion = this.glslVersion), (t.uniforms = {})
        for (const i in this.uniforms) {
          const n = this.uniforms[i],
            r = n.value
          r && r.isTexture
            ? (t.uniforms[i] = { type: 't', value: r.toJSON(e).uuid })
            : r && r.isColor
            ? (t.uniforms[i] = { type: 'c', value: r.getHex() })
            : r && r.isVector2
            ? (t.uniforms[i] = { type: 'v2', value: r.toArray() })
            : r && r.isVector3
            ? (t.uniforms[i] = { type: 'v3', value: r.toArray() })
            : r && r.isVector4
            ? (t.uniforms[i] = { type: 'v4', value: r.toArray() })
            : r && r.isMatrix3
            ? (t.uniforms[i] = { type: 'm3', value: r.toArray() })
            : r && r.isMatrix4
            ? (t.uniforms[i] = { type: 'm4', value: r.toArray() })
            : (t.uniforms[i] = { value: r })
        }
        Object.keys(this.defines).length > 0 && (t.defines = this.defines),
          (t.vertexShader = this.vertexShader),
          (t.fragmentShader = this.fragmentShader)
        const n = {}
        for (const i in this.extensions)
          !0 === this.extensions[i] && (n[i] = !0)
        return Object.keys(n).length > 0 && (t.extensions = n), t
      }
    }
    da.prototype.isShaderMaterial = !0
    class pa extends er {
      constructor () {
        super(),
          (this.type = 'Camera'),
          (this.matrixWorldInverse = new Li()),
          (this.projectionMatrix = new Li()),
          (this.projectionMatrixInverse = new Li())
      }
      copy (e, t) {
        return (
          super.copy(e, t),
          this.matrixWorldInverse.copy(e.matrixWorldInverse),
          this.projectionMatrix.copy(e.projectionMatrix),
          this.projectionMatrixInverse.copy(e.projectionMatrixInverse),
          this
        )
      }
      getWorldDirection (e) {
        this.updateWorldMatrix(!0, !1)
        const t = this.matrixWorld.elements
        return e.set(-t[8], -t[9], -t[10]).normalize()
      }
      updateMatrixWorld (e) {
        super.updateMatrixWorld(e),
          this.matrixWorldInverse.copy(this.matrixWorld).invert()
      }
      updateWorldMatrix (e, t) {
        super.updateWorldMatrix(e, t),
          this.matrixWorldInverse.copy(this.matrixWorld).invert()
      }
      clone () {
        return new this.constructor().copy(this)
      }
    }
    pa.prototype.isCamera = !0
    class fa extends pa {
      constructor (e = 50, t = 1, n = 0.1, i = 2e3) {
        super(),
          (this.type = 'PerspectiveCamera'),
          (this.fov = e),
          (this.zoom = 1),
          (this.near = n),
          (this.far = i),
          (this.focus = 10),
          (this.aspect = t),
          (this.view = null),
          (this.filmGauge = 35),
          (this.filmOffset = 0),
          this.updateProjectionMatrix()
      }
      copy (e, t) {
        return (
          super.copy(e, t),
          (this.fov = e.fov),
          (this.zoom = e.zoom),
          (this.near = e.near),
          (this.far = e.far),
          (this.focus = e.focus),
          (this.aspect = e.aspect),
          (this.view = null === e.view ? null : Object.assign({}, e.view)),
          (this.filmGauge = e.filmGauge),
          (this.filmOffset = e.filmOffset),
          this
        )
      }
      setFocalLength (e) {
        const t = (0.5 * this.getFilmHeight()) / e
        ;(this.fov = 2 * Dn * Math.atan(t)), this.updateProjectionMatrix()
      }
      getFocalLength () {
        const e = Math.tan(0.5 * Pn * this.fov)
        return (0.5 * this.getFilmHeight()) / e
      }
      getEffectiveFOV () {
        return 2 * Dn * Math.atan(Math.tan(0.5 * Pn * this.fov) / this.zoom)
      }
      getFilmWidth () {
        return this.filmGauge * Math.min(this.aspect, 1)
      }
      getFilmHeight () {
        return this.filmGauge / Math.max(this.aspect, 1)
      }
      setViewOffset (e, t, n, i, r, a) {
        ;(this.aspect = e / t),
          null === this.view &&
            (this.view = {
              enabled: !0,
              fullWidth: 1,
              fullHeight: 1,
              offsetX: 0,
              offsetY: 0,
              width: 1,
              height: 1
            }),
          (this.view.enabled = !0),
          (this.view.fullWidth = e),
          (this.view.fullHeight = t),
          (this.view.offsetX = n),
          (this.view.offsetY = i),
          (this.view.width = r),
          (this.view.height = a),
          this.updateProjectionMatrix()
      }
      clearViewOffset () {
        null !== this.view && (this.view.enabled = !1),
          this.updateProjectionMatrix()
      }
      updateProjectionMatrix () {
        const e = this.near
        let t = (e * Math.tan(0.5 * Pn * this.fov)) / this.zoom,
          n = 2 * t,
          i = this.aspect * n,
          r = -0.5 * i
        const a = this.view
        if (null !== this.view && this.view.enabled) {
          const e = a.fullWidth,
            s = a.fullHeight
          ;(r += (a.offsetX * i) / e),
            (t -= (a.offsetY * n) / s),
            (i *= a.width / e),
            (n *= a.height / s)
        }
        const s = this.filmOffset
        0 !== s && (r += (e * s) / this.getFilmWidth()),
          this.projectionMatrix.makePerspective(
            r,
            r + i,
            t,
            t - n,
            e,
            this.far
          ),
          this.projectionMatrixInverse.copy(this.projectionMatrix).invert()
      }
      toJSON (e) {
        const t = super.toJSON(e)
        return (
          (t.object.fov = this.fov),
          (t.object.zoom = this.zoom),
          (t.object.near = this.near),
          (t.object.far = this.far),
          (t.object.focus = this.focus),
          (t.object.aspect = this.aspect),
          null !== this.view && (t.object.view = Object.assign({}, this.view)),
          (t.object.filmGauge = this.filmGauge),
          (t.object.filmOffset = this.filmOffset),
          t
        )
      }
    }
    fa.prototype.isPerspectiveCamera = !0
    const ma = 90,
      ga = 1
    class va extends er {
      constructor (e, t, n) {
        if (
          (super(),
          (this.type = 'CubeCamera'),
          !0 !== n.isWebGLCubeRenderTarget)
        )
          return void console.error(
            'THREE.CubeCamera: The constructor now expects an instance of WebGLCubeRenderTarget as third parameter.'
          )
        this.renderTarget = n
        const i = new fa(ma, ga, e, t)
        ;(i.layers = this.layers),
          i.up.set(0, -1, 0),
          i.lookAt(new Qn(1, 0, 0)),
          this.add(i)
        const r = new fa(ma, ga, e, t)
        ;(r.layers = this.layers),
          r.up.set(0, -1, 0),
          r.lookAt(new Qn(-1, 0, 0)),
          this.add(r)
        const a = new fa(ma, ga, e, t)
        ;(a.layers = this.layers),
          a.up.set(0, 0, 1),
          a.lookAt(new Qn(0, 1, 0)),
          this.add(a)
        const s = new fa(ma, ga, e, t)
        ;(s.layers = this.layers),
          s.up.set(0, 0, -1),
          s.lookAt(new Qn(0, -1, 0)),
          this.add(s)
        const o = new fa(ma, ga, e, t)
        ;(o.layers = this.layers),
          o.up.set(0, -1, 0),
          o.lookAt(new Qn(0, 0, 1)),
          this.add(o)
        const l = new fa(ma, ga, e, t)
        ;(l.layers = this.layers),
          l.up.set(0, -1, 0),
          l.lookAt(new Qn(0, 0, -1)),
          this.add(l)
      }
      update (e, t) {
        null === this.parent && this.updateMatrixWorld()
        const n = this.renderTarget,
          [i, r, a, s, o, l] = this.children,
          c = e.xr.enabled,
          h = e.getRenderTarget()
        e.xr.enabled = !1
        const u = n.texture.generateMipmaps
        ;(n.texture.generateMipmaps = !1),
          e.setRenderTarget(n, 0),
          e.render(t, i),
          e.setRenderTarget(n, 1),
          e.render(t, r),
          e.setRenderTarget(n, 2),
          e.render(t, a),
          e.setRenderTarget(n, 3),
          e.render(t, s),
          e.setRenderTarget(n, 4),
          e.render(t, o),
          (n.texture.generateMipmaps = u),
          e.setRenderTarget(n, 5),
          e.render(t, l),
          e.setRenderTarget(h),
          (e.xr.enabled = c)
      }
    }
    class ya extends jn {
      constructor (e, t, n, i, r, a, s, o, l, c) {
        ;(e = void 0 !== e ? e : []),
          (t = void 0 !== t ? t : Ae),
          (s = void 0 !== s ? s : tt),
          super(e, t, n, i, r, a, s, o, l, c),
          (this._needsFlipEnvMap = !0),
          (this.flipY = !1)
      }
      get images () {
        return this.image
      }
      set images (e) {
        this.image = e
      }
    }
    ya.prototype.isCubeTexture = !0
    class _a extends Xn {
      constructor (e, t, n) {
        Number.isInteger(t) &&
          (console.warn(
            'THREE.WebGLCubeRenderTarget: constructor signature is now WebGLCubeRenderTarget( size, options )'
          ),
          (t = n)),
          super(e, e, t),
          (t = t || {}),
          (this.texture = new ya(
            void 0,
            t.mapping,
            t.wrapS,
            t.wrapT,
            t.magFilter,
            t.minFilter,
            t.format,
            t.type,
            t.anisotropy,
            t.encoding
          )),
          (this.texture.generateMipmaps =
            void 0 !== t.generateMipmaps && t.generateMipmaps),
          (this.texture.minFilter = void 0 !== t.minFilter ? t.minFilter : Ue),
          (this.texture._needsFlipEnvMap = !1)
      }
      fromEquirectangularTexture (e, t) {
        ;(this.texture.type = t.type),
          (this.texture.format = nt),
          (this.texture.encoding = t.encoding),
          (this.texture.generateMipmaps = t.generateMipmaps),
          (this.texture.minFilter = t.minFilter),
          (this.texture.magFilter = t.magFilter)
        const n = {
            uniforms: { tEquirect: { value: null } },
            vertexShader:
              '\n\n\t\t\t\tvarying vec3 vWorldDirection;\n\n\t\t\t\tvec3 transformDirection( in vec3 dir, in mat4 matrix ) {\n\n\t\t\t\t\treturn normalize( ( matrix * vec4( dir, 0.0 ) ).xyz );\n\n\t\t\t\t}\n\n\t\t\t\tvoid main() {\n\n\t\t\t\t\tvWorldDirection = transformDirection( position, modelMatrix );\n\n\t\t\t\t\t#include <begin_vertex>\n\t\t\t\t\t#include <project_vertex>\n\n\t\t\t\t}\n\t\t\t',
            fragmentShader:
              '\n\n\t\t\t\tuniform sampler2D tEquirect;\n\n\t\t\t\tvarying vec3 vWorldDirection;\n\n\t\t\t\t#include <common>\n\n\t\t\t\tvoid main() {\n\n\t\t\t\t\tvec3 direction = normalize( vWorldDirection );\n\n\t\t\t\t\tvec2 sampleUV = equirectUv( direction );\n\n\t\t\t\t\tgl_FragColor = texture2D( tEquirect, sampleUV );\n\n\t\t\t\t}\n\t\t\t'
          },
          i = new sa(5, 5, 5),
          r = new da({
            name: 'CubemapFromEquirect',
            uniforms: oa(n.uniforms),
            vertexShader: n.vertexShader,
            fragmentShader: n.fragmentShader,
            side: z,
            blending: H
          })
        r.uniforms.tEquirect.value = t
        const a = new ia(i, r),
          s = t.minFilter
        t.minFilter === He && (t.minFilter = Ue)
        const o = new va(1, 10, this)
        return (
          o.update(e, a),
          (t.minFilter = s),
          a.geometry.dispose(),
          a.material.dispose(),
          this
        )
      }
      clear (e, t, n, i) {
        const r = e.getRenderTarget()
        for (let a = 0; a < 6; a++) e.setRenderTarget(this, a), e.clear(t, n, i)
        e.setRenderTarget(r)
      }
    }
    _a.prototype.isWebGLCubeRenderTarget = !0
    const xa = new Qn(),
      wa = new Qn(),
      ba = new Hn()
    class Ma {
      constructor (e = new Qn(1, 0, 0), t = 0) {
        ;(this.normal = e), (this.constant = t)
      }
      set (e, t) {
        return this.normal.copy(e), (this.constant = t), this
      }
      setComponents (e, t, n, i) {
        return this.normal.set(e, t, n), (this.constant = i), this
      }
      setFromNormalAndCoplanarPoint (e, t) {
        return this.normal.copy(e), (this.constant = -t.dot(this.normal)), this
      }
      setFromCoplanarPoints (e, t, n) {
        const i = xa
          .subVectors(n, t)
          .cross(wa.subVectors(e, t))
          .normalize()
        return this.setFromNormalAndCoplanarPoint(i, e), this
      }
      copy (e) {
        return this.normal.copy(e.normal), (this.constant = e.constant), this
      }
      normalize () {
        const e = 1 / this.normal.length()
        return this.normal.multiplyScalar(e), (this.constant *= e), this
      }
      negate () {
        return (this.constant *= -1), this.normal.negate(), this
      }
      distanceToPoint (e) {
        return this.normal.dot(e) + this.constant
      }
      distanceToSphere (e) {
        return this.distanceToPoint(e.center) - e.radius
      }
      projectPoint (e, t) {
        return t
          .copy(this.normal)
          .multiplyScalar(-this.distanceToPoint(e))
          .add(e)
      }
      intersectLine (e, t) {
        const n = e.delta(xa),
          i = this.normal.dot(n)
        if (0 === i)
          return 0 === this.distanceToPoint(e.start) ? t.copy(e.start) : null
        const r = -(e.start.dot(this.normal) + this.constant) / i
        return r < 0 || r > 1
          ? null
          : t
              .copy(n)
              .multiplyScalar(r)
              .add(e.start)
      }
      intersectsLine (e) {
        const t = this.distanceToPoint(e.start),
          n = this.distanceToPoint(e.end)
        return (t < 0 && n > 0) || (n < 0 && t > 0)
      }
      intersectsBox (e) {
        return e.intersectsPlane(this)
      }
      intersectsSphere (e) {
        return e.intersectsPlane(this)
      }
      coplanarPoint (e) {
        return e.copy(this.normal).multiplyScalar(-this.constant)
      }
      applyMatrix4 (e, t) {
        const n = t || ba.getNormalMatrix(e),
          i = this.coplanarPoint(xa).applyMatrix4(e),
          r = this.normal.applyMatrix3(n).normalize()
        return (this.constant = -i.dot(r)), this
      }
      translate (e) {
        return (this.constant -= e.dot(this.normal)), this
      }
      equals (e) {
        return e.normal.equals(this.normal) && e.constant === this.constant
      }
      clone () {
        return new this.constructor().copy(this)
      }
    }
    Ma.prototype.isPlane = !0
    const Sa = new xi(),
      Ea = new Qn()
    class Ta {
      constructor (
        e = new Ma(),
        t = new Ma(),
        n = new Ma(),
        i = new Ma(),
        r = new Ma(),
        a = new Ma()
      ) {
        this.planes = [e, t, n, i, r, a]
      }
      set (e, t, n, i, r, a) {
        const s = this.planes
        return (
          s[0].copy(e),
          s[1].copy(t),
          s[2].copy(n),
          s[3].copy(i),
          s[4].copy(r),
          s[5].copy(a),
          this
        )
      }
      copy (e) {
        const t = this.planes
        for (let n = 0; n < 6; n++) t[n].copy(e.planes[n])
        return this
      }
      setFromProjectionMatrix (e) {
        const t = this.planes,
          n = e.elements,
          i = n[0],
          r = n[1],
          a = n[2],
          s = n[3],
          o = n[4],
          l = n[5],
          c = n[6],
          h = n[7],
          u = n[8],
          d = n[9],
          p = n[10],
          f = n[11],
          m = n[12],
          g = n[13],
          v = n[14],
          y = n[15]
        return (
          t[0].setComponents(s - i, h - o, f - u, y - m).normalize(),
          t[1].setComponents(s + i, h + o, f + u, y + m).normalize(),
          t[2].setComponents(s + r, h + l, f + d, y + g).normalize(),
          t[3].setComponents(s - r, h - l, f - d, y - g).normalize(),
          t[4].setComponents(s - a, h - c, f - p, y - v).normalize(),
          t[5].setComponents(s + a, h + c, f + p, y + v).normalize(),
          this
        )
      }
      intersectsObject (e) {
        const t = e.geometry
        return (
          null === t.boundingSphere && t.computeBoundingSphere(),
          Sa.copy(t.boundingSphere).applyMatrix4(e.matrixWorld),
          this.intersectsSphere(Sa)
        )
      }
      intersectsSprite (e) {
        return (
          Sa.center.set(0, 0, 0),
          (Sa.radius = 0.7071067811865476),
          Sa.applyMatrix4(e.matrixWorld),
          this.intersectsSphere(Sa)
        )
      }
      intersectsSphere (e) {
        const t = this.planes,
          n = e.center,
          i = -e.radius
        for (let r = 0; r < 6; r++) {
          const e = t[r].distanceToPoint(n)
          if (e < i) return !1
        }
        return !0
      }
      intersectsBox (e) {
        const t = this.planes
        for (let n = 0; n < 6; n++) {
          const i = t[n]
          if (
            ((Ea.x = i.normal.x > 0 ? e.max.x : e.min.x),
            (Ea.y = i.normal.y > 0 ? e.max.y : e.min.y),
            (Ea.z = i.normal.z > 0 ? e.max.z : e.min.z),
            i.distanceToPoint(Ea) < 0)
          )
            return !1
        }
        return !0
      }
      containsPoint (e) {
        const t = this.planes
        for (let n = 0; n < 6; n++) if (t[n].distanceToPoint(e) < 0) return !1
        return !0
      }
      clone () {
        return new this.constructor().copy(this)
      }
    }
    function Aa () {
      let e = null,
        t = !1,
        n = null,
        i = null
      function r (t, a) {
        n(t, a), (i = e.requestAnimationFrame(r))
      }
      return {
        start: function () {
          !0 !== t && null !== n && ((i = e.requestAnimationFrame(r)), (t = !0))
        },
        stop: function () {
          e.cancelAnimationFrame(i), (t = !1)
        },
        setAnimationLoop: function (e) {
          n = e
        },
        setContext: function (t) {
          e = t
        }
      }
    }
    function Ra (e, t) {
      const n = t.isWebGL2,
        i = new WeakMap()
      function r (t, i) {
        const r = t.array,
          a = t.usage,
          s = e.createBuffer()
        e.bindBuffer(i, s), e.bufferData(i, r, a), t.onUploadCallback()
        let o = 5126
        return (
          r instanceof Float32Array
            ? (o = 5126)
            : r instanceof Float64Array
            ? console.warn(
                'THREE.WebGLAttributes: Unsupported data buffer format: Float64Array.'
              )
            : r instanceof Uint16Array
            ? t.isFloat16BufferAttribute
              ? n
                ? (o = 5131)
                : console.warn(
                    'THREE.WebGLAttributes: Usage of Float16BufferAttribute requires WebGL2.'
                  )
              : (o = 5123)
            : r instanceof Int16Array
            ? (o = 5122)
            : r instanceof Uint32Array
            ? (o = 5125)
            : r instanceof Int32Array
            ? (o = 5124)
            : r instanceof Int8Array
            ? (o = 5120)
            : (r instanceof Uint8Array || r instanceof Uint8ClampedArray) &&
              (o = 5121),
          {
            buffer: s,
            type: o,
            bytesPerElement: r.BYTES_PER_ELEMENT,
            version: t.version
          }
        )
      }
      function a (t, i, r) {
        const a = i.array,
          s = i.updateRange
        e.bindBuffer(r, t),
          -1 === s.count
            ? e.bufferSubData(r, 0, a)
            : (n
                ? e.bufferSubData(
                    r,
                    s.offset * a.BYTES_PER_ELEMENT,
                    a,
                    s.offset,
                    s.count
                  )
                : e.bufferSubData(
                    r,
                    s.offset * a.BYTES_PER_ELEMENT,
                    a.subarray(s.offset, s.offset + s.count)
                  ),
              (s.count = -1))
      }
      function s (e) {
        return e.isInterleavedBufferAttribute && (e = e.data), i.get(e)
      }
      function o (t) {
        t.isInterleavedBufferAttribute && (t = t.data)
        const n = i.get(t)
        n && (e.deleteBuffer(n.buffer), i.delete(t))
      }
      function l (e, t) {
        if (e.isGLBufferAttribute) {
          const t = i.get(e)
          return void (
            (!t || t.version < e.version) &&
            i.set(e, {
              buffer: e.buffer,
              type: e.type,
              bytesPerElement: e.elementSize,
              version: e.version
            })
          )
        }
        e.isInterleavedBufferAttribute && (e = e.data)
        const n = i.get(e)
        void 0 === n
          ? i.set(e, r(e, t))
          : n.version < e.version &&
            (a(n.buffer, e, t), (n.version = e.version))
      }
      return { get: s, remove: o, update: l }
    }
    class La extends Ur {
      constructor (e = 1, t = 1, n = 1, i = 1) {
        super(),
          (this.type = 'PlaneGeometry'),
          (this.parameters = {
            width: e,
            height: t,
            widthSegments: n,
            heightSegments: i
          })
        const r = e / 2,
          a = t / 2,
          s = Math.floor(n),
          o = Math.floor(i),
          l = s + 1,
          c = o + 1,
          h = e / s,
          u = t / o,
          d = [],
          p = [],
          f = [],
          m = []
        for (let g = 0; g < c; g++) {
          const e = g * u - a
          for (let t = 0; t < l; t++) {
            const n = t * h - r
            p.push(n, -e, 0), f.push(0, 0, 1), m.push(t / s), m.push(1 - g / o)
          }
        }
        for (let g = 0; g < o; g++)
          for (let e = 0; e < s; e++) {
            const t = e + l * g,
              n = e + l * (g + 1),
              i = e + 1 + l * (g + 1),
              r = e + 1 + l * g
            d.push(t, n, r), d.push(n, i, r)
          }
        this.setIndex(d),
          this.setAttribute('position', new Rr(p, 3)),
          this.setAttribute('normal', new Rr(f, 3)),
          this.setAttribute('uv', new Rr(m, 2))
      }
      static fromJSON (e) {
        return new La(e.width, e.height, e.widthSegments, e.heightSegments)
      }
    }
    var Ca =
        '#ifdef USE_ALPHAMAP\n\tdiffuseColor.a *= texture2D( alphaMap, vUv ).g;\n#endif',
      Pa = '#ifdef USE_ALPHAMAP\n\tuniform sampler2D alphaMap;\n#endif',
      Da =
        '#ifdef ALPHATEST\n\tif ( diffuseColor.a < ALPHATEST ) discard;\n#endif',
      Ia =
        '#ifdef USE_AOMAP\n\tfloat ambientOcclusion = ( texture2D( aoMap, vUv2 ).r - 1.0 ) * aoMapIntensity + 1.0;\n\treflectedLight.indirectDiffuse *= ambientOcclusion;\n\t#if defined( USE_ENVMAP ) && defined( STANDARD )\n\t\tfloat dotNV = saturate( dot( geometry.normal, geometry.viewDir ) );\n\t\treflectedLight.indirectSpecular *= computeSpecularOcclusion( dotNV, ambientOcclusion, material.specularRoughness );\n\t#endif\n#endif',
      Na =
        '#ifdef USE_AOMAP\n\tuniform sampler2D aoMap;\n\tuniform float aoMapIntensity;\n#endif',
      Oa = 'vec3 transformed = vec3( position );',
      Fa =
        'vec3 objectNormal = vec3( normal );\n#ifdef USE_TANGENT\n\tvec3 objectTangent = vec3( tangent.xyz );\n#endif',
      Ba =
        'vec2 integrateSpecularBRDF( const in float dotNV, const in float roughness ) {\n\tconst vec4 c0 = vec4( - 1, - 0.0275, - 0.572, 0.022 );\n\tconst vec4 c1 = vec4( 1, 0.0425, 1.04, - 0.04 );\n\tvec4 r = roughness * c0 + c1;\n\tfloat a004 = min( r.x * r.x, exp2( - 9.28 * dotNV ) ) * r.x + r.y;\n\treturn vec2( -1.04, 1.04 ) * a004 + r.zw;\n}\nfloat punctualLightIntensityToIrradianceFactor( const in float lightDistance, const in float cutoffDistance, const in float decayExponent ) {\n#if defined ( PHYSICALLY_CORRECT_LIGHTS )\n\tfloat distanceFalloff = 1.0 / max( pow( lightDistance, decayExponent ), 0.01 );\n\tif( cutoffDistance > 0.0 ) {\n\t\tdistanceFalloff *= pow2( saturate( 1.0 - pow4( lightDistance / cutoffDistance ) ) );\n\t}\n\treturn distanceFalloff;\n#else\n\tif( cutoffDistance > 0.0 && decayExponent > 0.0 ) {\n\t\treturn pow( saturate( -lightDistance / cutoffDistance + 1.0 ), decayExponent );\n\t}\n\treturn 1.0;\n#endif\n}\nvec3 BRDF_Diffuse_Lambert( const in vec3 diffuseColor ) {\n\treturn RECIPROCAL_PI * diffuseColor;\n}\nvec3 F_Schlick( const in vec3 specularColor, const in float dotVH ) {\n\tfloat fresnel = exp2( ( -5.55473 * dotVH - 6.98316 ) * dotVH );\n\treturn ( 1.0 - specularColor ) * fresnel + specularColor;\n}\nvec3 F_Schlick_RoughnessDependent( const in vec3 F0, const in float dotNV, const in float roughness ) {\n\tfloat fresnel = exp2( ( -5.55473 * dotNV - 6.98316 ) * dotNV );\n\tvec3 Fr = max( vec3( 1.0 - roughness ), F0 ) - F0;\n\treturn Fr * fresnel + F0;\n}\nfloat G_GGX_Smith( const in float alpha, const in float dotNL, const in float dotNV ) {\n\tfloat a2 = pow2( alpha );\n\tfloat gl = dotNL + sqrt( a2 + ( 1.0 - a2 ) * pow2( dotNL ) );\n\tfloat gv = dotNV + sqrt( a2 + ( 1.0 - a2 ) * pow2( dotNV ) );\n\treturn 1.0 / ( gl * gv );\n}\nfloat G_GGX_SmithCorrelated( const in float alpha, const in float dotNL, const in float dotNV ) {\n\tfloat a2 = pow2( alpha );\n\tfloat gv = dotNL * sqrt( a2 + ( 1.0 - a2 ) * pow2( dotNV ) );\n\tfloat gl = dotNV * sqrt( a2 + ( 1.0 - a2 ) * pow2( dotNL ) );\n\treturn 0.5 / max( gv + gl, EPSILON );\n}\nfloat D_GGX( const in float alpha, const in float dotNH ) {\n\tfloat a2 = pow2( alpha );\n\tfloat denom = pow2( dotNH ) * ( a2 - 1.0 ) + 1.0;\n\treturn RECIPROCAL_PI * a2 / pow2( denom );\n}\nvec3 BRDF_Specular_GGX( const in IncidentLight incidentLight, const in vec3 viewDir, const in vec3 normal, const in vec3 specularColor, const in float roughness ) {\n\tfloat alpha = pow2( roughness );\n\tvec3 halfDir = normalize( incidentLight.direction + viewDir );\n\tfloat dotNL = saturate( dot( normal, incidentLight.direction ) );\n\tfloat dotNV = saturate( dot( normal, viewDir ) );\n\tfloat dotNH = saturate( dot( normal, halfDir ) );\n\tfloat dotLH = saturate( dot( incidentLight.direction, halfDir ) );\n\tvec3 F = F_Schlick( specularColor, dotLH );\n\tfloat G = G_GGX_SmithCorrelated( alpha, dotNL, dotNV );\n\tfloat D = D_GGX( alpha, dotNH );\n\treturn F * ( G * D );\n}\nvec2 LTC_Uv( const in vec3 N, const in vec3 V, const in float roughness ) {\n\tconst float LUT_SIZE = 64.0;\n\tconst float LUT_SCALE = ( LUT_SIZE - 1.0 ) / LUT_SIZE;\n\tconst float LUT_BIAS = 0.5 / LUT_SIZE;\n\tfloat dotNV = saturate( dot( N, V ) );\n\tvec2 uv = vec2( roughness, sqrt( 1.0 - dotNV ) );\n\tuv = uv * LUT_SCALE + LUT_BIAS;\n\treturn uv;\n}\nfloat LTC_ClippedSphereFormFactor( const in vec3 f ) {\n\tfloat l = length( f );\n\treturn max( ( l * l + f.z ) / ( l + 1.0 ), 0.0 );\n}\nvec3 LTC_EdgeVectorFormFactor( const in vec3 v1, const in vec3 v2 ) {\n\tfloat x = dot( v1, v2 );\n\tfloat y = abs( x );\n\tfloat a = 0.8543985 + ( 0.4965155 + 0.0145206 * y ) * y;\n\tfloat b = 3.4175940 + ( 4.1616724 + y ) * y;\n\tfloat v = a / b;\n\tfloat theta_sintheta = ( x > 0.0 ) ? v : 0.5 * inversesqrt( max( 1.0 - x * x, 1e-7 ) ) - v;\n\treturn cross( v1, v2 ) * theta_sintheta;\n}\nvec3 LTC_Evaluate( const in vec3 N, const in vec3 V, const in vec3 P, const in mat3 mInv, const in vec3 rectCoords[ 4 ] ) {\n\tvec3 v1 = rectCoords[ 1 ] - rectCoords[ 0 ];\n\tvec3 v2 = rectCoords[ 3 ] - rectCoords[ 0 ];\n\tvec3 lightNormal = cross( v1, v2 );\n\tif( dot( lightNormal, P - rectCoords[ 0 ] ) < 0.0 ) return vec3( 0.0 );\n\tvec3 T1, T2;\n\tT1 = normalize( V - N * dot( V, N ) );\n\tT2 = - cross( N, T1 );\n\tmat3 mat = mInv * transposeMat3( mat3( T1, T2, N ) );\n\tvec3 coords[ 4 ];\n\tcoords[ 0 ] = mat * ( rectCoords[ 0 ] - P );\n\tcoords[ 1 ] = mat * ( rectCoords[ 1 ] - P );\n\tcoords[ 2 ] = mat * ( rectCoords[ 2 ] - P );\n\tcoords[ 3 ] = mat * ( rectCoords[ 3 ] - P );\n\tcoords[ 0 ] = normalize( coords[ 0 ] );\n\tcoords[ 1 ] = normalize( coords[ 1 ] );\n\tcoords[ 2 ] = normalize( coords[ 2 ] );\n\tcoords[ 3 ] = normalize( coords[ 3 ] );\n\tvec3 vectorFormFactor = vec3( 0.0 );\n\tvectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 0 ], coords[ 1 ] );\n\tvectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 1 ], coords[ 2 ] );\n\tvectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 2 ], coords[ 3 ] );\n\tvectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 3 ], coords[ 0 ] );\n\tfloat result = LTC_ClippedSphereFormFactor( vectorFormFactor );\n\treturn vec3( result );\n}\nvec3 BRDF_Specular_GGX_Environment( const in vec3 viewDir, const in vec3 normal, const in vec3 specularColor, const in float roughness ) {\n\tfloat dotNV = saturate( dot( normal, viewDir ) );\n\tvec2 brdf = integrateSpecularBRDF( dotNV, roughness );\n\treturn specularColor * brdf.x + brdf.y;\n}\nvoid BRDF_Specular_Multiscattering_Environment( const in GeometricContext geometry, const in vec3 specularColor, const in float roughness, inout vec3 singleScatter, inout vec3 multiScatter ) {\n\tfloat dotNV = saturate( dot( geometry.normal, geometry.viewDir ) );\n\tvec3 F = F_Schlick_RoughnessDependent( specularColor, dotNV, roughness );\n\tvec2 brdf = integrateSpecularBRDF( dotNV, roughness );\n\tvec3 FssEss = F * brdf.x + brdf.y;\n\tfloat Ess = brdf.x + brdf.y;\n\tfloat Ems = 1.0 - Ess;\n\tvec3 Favg = specularColor + ( 1.0 - specularColor ) * 0.047619;\tvec3 Fms = FssEss * Favg / ( 1.0 - Ems * Favg );\n\tsingleScatter += FssEss;\n\tmultiScatter += Fms * Ems;\n}\nfloat G_BlinnPhong_Implicit( ) {\n\treturn 0.25;\n}\nfloat D_BlinnPhong( const in float shininess, const in float dotNH ) {\n\treturn RECIPROCAL_PI * ( shininess * 0.5 + 1.0 ) * pow( dotNH, shininess );\n}\nvec3 BRDF_Specular_BlinnPhong( const in IncidentLight incidentLight, const in GeometricContext geometry, const in vec3 specularColor, const in float shininess ) {\n\tvec3 halfDir = normalize( incidentLight.direction + geometry.viewDir );\n\tfloat dotNH = saturate( dot( geometry.normal, halfDir ) );\n\tfloat dotLH = saturate( dot( incidentLight.direction, halfDir ) );\n\tvec3 F = F_Schlick( specularColor, dotLH );\n\tfloat G = G_BlinnPhong_Implicit( );\n\tfloat D = D_BlinnPhong( shininess, dotNH );\n\treturn F * ( G * D );\n}\nfloat GGXRoughnessToBlinnExponent( const in float ggxRoughness ) {\n\treturn ( 2.0 / pow2( ggxRoughness + 0.0001 ) - 2.0 );\n}\nfloat BlinnExponentToGGXRoughness( const in float blinnExponent ) {\n\treturn sqrt( 2.0 / ( blinnExponent + 2.0 ) );\n}\n#if defined( USE_SHEEN )\nfloat D_Charlie(float roughness, float NoH) {\n\tfloat invAlpha = 1.0 / roughness;\n\tfloat cos2h = NoH * NoH;\n\tfloat sin2h = max(1.0 - cos2h, 0.0078125);\treturn (2.0 + invAlpha) * pow(sin2h, invAlpha * 0.5) / (2.0 * PI);\n}\nfloat V_Neubelt(float NoV, float NoL) {\n\treturn saturate(1.0 / (4.0 * (NoL + NoV - NoL * NoV)));\n}\nvec3 BRDF_Specular_Sheen( const in float roughness, const in vec3 L, const in GeometricContext geometry, vec3 specularColor ) {\n\tvec3 N = geometry.normal;\n\tvec3 V = geometry.viewDir;\n\tvec3 H = normalize( V + L );\n\tfloat dotNH = saturate( dot( N, H ) );\n\treturn specularColor * D_Charlie( roughness, dotNH ) * V_Neubelt( dot(N, V), dot(N, L) );\n}\n#endif',
      za =
        '#ifdef USE_BUMPMAP\n\tuniform sampler2D bumpMap;\n\tuniform float bumpScale;\n\tvec2 dHdxy_fwd() {\n\t\tvec2 dSTdx = dFdx( vUv );\n\t\tvec2 dSTdy = dFdy( vUv );\n\t\tfloat Hll = bumpScale * texture2D( bumpMap, vUv ).x;\n\t\tfloat dBx = bumpScale * texture2D( bumpMap, vUv + dSTdx ).x - Hll;\n\t\tfloat dBy = bumpScale * texture2D( bumpMap, vUv + dSTdy ).x - Hll;\n\t\treturn vec2( dBx, dBy );\n\t}\n\tvec3 perturbNormalArb( vec3 surf_pos, vec3 surf_norm, vec2 dHdxy, float faceDirection ) {\n\t\tvec3 vSigmaX = vec3( dFdx( surf_pos.x ), dFdx( surf_pos.y ), dFdx( surf_pos.z ) );\n\t\tvec3 vSigmaY = vec3( dFdy( surf_pos.x ), dFdy( surf_pos.y ), dFdy( surf_pos.z ) );\n\t\tvec3 vN = surf_norm;\n\t\tvec3 R1 = cross( vSigmaY, vN );\n\t\tvec3 R2 = cross( vN, vSigmaX );\n\t\tfloat fDet = dot( vSigmaX, R1 ) * faceDirection;\n\t\tvec3 vGrad = sign( fDet ) * ( dHdxy.x * R1 + dHdxy.y * R2 );\n\t\treturn normalize( abs( fDet ) * surf_norm - vGrad );\n\t}\n#endif',
      Ua =
        '#if NUM_CLIPPING_PLANES > 0\n\tvec4 plane;\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < UNION_CLIPPING_PLANES; i ++ ) {\n\t\tplane = clippingPlanes[ i ];\n\t\tif ( dot( vClipPosition, plane.xyz ) > plane.w ) discard;\n\t}\n\t#pragma unroll_loop_end\n\t#if UNION_CLIPPING_PLANES < NUM_CLIPPING_PLANES\n\t\tbool clipped = true;\n\t\t#pragma unroll_loop_start\n\t\tfor ( int i = UNION_CLIPPING_PLANES; i < NUM_CLIPPING_PLANES; i ++ ) {\n\t\t\tplane = clippingPlanes[ i ];\n\t\t\tclipped = ( dot( vClipPosition, plane.xyz ) > plane.w ) && clipped;\n\t\t}\n\t\t#pragma unroll_loop_end\n\t\tif ( clipped ) discard;\n\t#endif\n#endif',
      ka =
        '#if NUM_CLIPPING_PLANES > 0\n\tvarying vec3 vClipPosition;\n\tuniform vec4 clippingPlanes[ NUM_CLIPPING_PLANES ];\n#endif',
      Ha = '#if NUM_CLIPPING_PLANES > 0\n\tvarying vec3 vClipPosition;\n#endif',
      Wa =
        '#if NUM_CLIPPING_PLANES > 0\n\tvClipPosition = - mvPosition.xyz;\n#endif',
      Va =
        '#if defined( USE_COLOR_ALPHA )\n\tdiffuseColor *= vColor;\n#elif defined( USE_COLOR )\n\tdiffuseColor.rgb *= vColor;\n#endif',
      Ga =
        '#if defined( USE_COLOR_ALPHA )\n\tvarying vec4 vColor;\n#elif defined( USE_COLOR )\n\tvarying vec3 vColor;\n#endif',
      ja =
        '#if defined( USE_COLOR_ALPHA )\n\tvarying vec4 vColor;\n#elif defined( USE_COLOR ) || defined( USE_INSTANCING_COLOR )\n\tvarying vec3 vColor;\n#endif',
      qa =
        '#if defined( USE_COLOR_ALPHA )\n\tvColor = vec4( 1.0 );\n#elif defined( USE_COLOR ) || defined( USE_INSTANCING_COLOR )\n\tvColor = vec3( 1.0 );\n#endif\n#ifdef USE_COLOR\n\tvColor *= color;\n#endif\n#ifdef USE_INSTANCING_COLOR\n\tvColor.xyz *= instanceColor.xyz;\n#endif',
      Ya =
        '#define PI 3.141592653589793\n#define PI2 6.283185307179586\n#define PI_HALF 1.5707963267948966\n#define RECIPROCAL_PI 0.3183098861837907\n#define RECIPROCAL_PI2 0.15915494309189535\n#define EPSILON 1e-6\n#ifndef saturate\n#define saturate(a) clamp( a, 0.0, 1.0 )\n#endif\n#define whiteComplement(a) ( 1.0 - saturate( a ) )\nfloat pow2( const in float x ) { return x*x; }\nfloat pow3( const in float x ) { return x*x*x; }\nfloat pow4( const in float x ) { float x2 = x*x; return x2*x2; }\nfloat average( const in vec3 color ) { return dot( color, vec3( 0.3333 ) ); }\nhighp float rand( const in vec2 uv ) {\n\tconst highp float a = 12.9898, b = 78.233, c = 43758.5453;\n\thighp float dt = dot( uv.xy, vec2( a,b ) ), sn = mod( dt, PI );\n\treturn fract(sin(sn) * c);\n}\n#ifdef HIGH_PRECISION\n\tfloat precisionSafeLength( vec3 v ) { return length( v ); }\n#else\n\tfloat max3( vec3 v ) { return max( max( v.x, v.y ), v.z ); }\n\tfloat precisionSafeLength( vec3 v ) {\n\t\tfloat maxComponent = max3( abs( v ) );\n\t\treturn length( v / maxComponent ) * maxComponent;\n\t}\n#endif\nstruct IncidentLight {\n\tvec3 color;\n\tvec3 direction;\n\tbool visible;\n};\nstruct ReflectedLight {\n\tvec3 directDiffuse;\n\tvec3 directSpecular;\n\tvec3 indirectDiffuse;\n\tvec3 indirectSpecular;\n};\nstruct GeometricContext {\n\tvec3 position;\n\tvec3 normal;\n\tvec3 viewDir;\n#ifdef CLEARCOAT\n\tvec3 clearcoatNormal;\n#endif\n};\nvec3 transformDirection( in vec3 dir, in mat4 matrix ) {\n\treturn normalize( ( matrix * vec4( dir, 0.0 ) ).xyz );\n}\nvec3 inverseTransformDirection( in vec3 dir, in mat4 matrix ) {\n\treturn normalize( ( vec4( dir, 0.0 ) * matrix ).xyz );\n}\nvec3 projectOnPlane(in vec3 point, in vec3 pointOnPlane, in vec3 planeNormal ) {\n\tfloat distance = dot( planeNormal, point - pointOnPlane );\n\treturn - distance * planeNormal + point;\n}\nfloat sideOfPlane( in vec3 point, in vec3 pointOnPlane, in vec3 planeNormal ) {\n\treturn sign( dot( point - pointOnPlane, planeNormal ) );\n}\nvec3 linePlaneIntersect( in vec3 pointOnLine, in vec3 lineDirection, in vec3 pointOnPlane, in vec3 planeNormal ) {\n\treturn lineDirection * ( dot( planeNormal, pointOnPlane - pointOnLine ) / dot( planeNormal, lineDirection ) ) + pointOnLine;\n}\nmat3 transposeMat3( const in mat3 m ) {\n\tmat3 tmp;\n\ttmp[ 0 ] = vec3( m[ 0 ].x, m[ 1 ].x, m[ 2 ].x );\n\ttmp[ 1 ] = vec3( m[ 0 ].y, m[ 1 ].y, m[ 2 ].y );\n\ttmp[ 2 ] = vec3( m[ 0 ].z, m[ 1 ].z, m[ 2 ].z );\n\treturn tmp;\n}\nfloat linearToRelativeLuminance( const in vec3 color ) {\n\tvec3 weights = vec3( 0.2126, 0.7152, 0.0722 );\n\treturn dot( weights, color.rgb );\n}\nbool isPerspectiveMatrix( mat4 m ) {\n\treturn m[ 2 ][ 3 ] == - 1.0;\n}\nvec2 equirectUv( in vec3 dir ) {\n\tfloat u = atan( dir.z, dir.x ) * RECIPROCAL_PI2 + 0.5;\n\tfloat v = asin( clamp( dir.y, - 1.0, 1.0 ) ) * RECIPROCAL_PI + 0.5;\n\treturn vec2( u, v );\n}',
      Xa =
        '#ifdef ENVMAP_TYPE_CUBE_UV\n\t#define cubeUV_maxMipLevel 8.0\n\t#define cubeUV_minMipLevel 4.0\n\t#define cubeUV_maxTileSize 256.0\n\t#define cubeUV_minTileSize 16.0\n\tfloat getFace( vec3 direction ) {\n\t\tvec3 absDirection = abs( direction );\n\t\tfloat face = - 1.0;\n\t\tif ( absDirection.x > absDirection.z ) {\n\t\t\tif ( absDirection.x > absDirection.y )\n\t\t\t\tface = direction.x > 0.0 ? 0.0 : 3.0;\n\t\t\telse\n\t\t\t\tface = direction.y > 0.0 ? 1.0 : 4.0;\n\t\t} else {\n\t\t\tif ( absDirection.z > absDirection.y )\n\t\t\t\tface = direction.z > 0.0 ? 2.0 : 5.0;\n\t\t\telse\n\t\t\t\tface = direction.y > 0.0 ? 1.0 : 4.0;\n\t\t}\n\t\treturn face;\n\t}\n\tvec2 getUV( vec3 direction, float face ) {\n\t\tvec2 uv;\n\t\tif ( face == 0.0 ) {\n\t\t\tuv = vec2( direction.z, direction.y ) / abs( direction.x );\n\t\t} else if ( face == 1.0 ) {\n\t\t\tuv = vec2( - direction.x, - direction.z ) / abs( direction.y );\n\t\t} else if ( face == 2.0 ) {\n\t\t\tuv = vec2( - direction.x, direction.y ) / abs( direction.z );\n\t\t} else if ( face == 3.0 ) {\n\t\t\tuv = vec2( - direction.z, direction.y ) / abs( direction.x );\n\t\t} else if ( face == 4.0 ) {\n\t\t\tuv = vec2( - direction.x, direction.z ) / abs( direction.y );\n\t\t} else {\n\t\t\tuv = vec2( direction.x, direction.y ) / abs( direction.z );\n\t\t}\n\t\treturn 0.5 * ( uv + 1.0 );\n\t}\n\tvec3 bilinearCubeUV( sampler2D envMap, vec3 direction, float mipInt ) {\n\t\tfloat face = getFace( direction );\n\t\tfloat filterInt = max( cubeUV_minMipLevel - mipInt, 0.0 );\n\t\tmipInt = max( mipInt, cubeUV_minMipLevel );\n\t\tfloat faceSize = exp2( mipInt );\n\t\tfloat texelSize = 1.0 / ( 3.0 * cubeUV_maxTileSize );\n\t\tvec2 uv = getUV( direction, face ) * ( faceSize - 1.0 );\n\t\tvec2 f = fract( uv );\n\t\tuv += 0.5 - f;\n\t\tif ( face > 2.0 ) {\n\t\t\tuv.y += faceSize;\n\t\t\tface -= 3.0;\n\t\t}\n\t\tuv.x += face * faceSize;\n\t\tif ( mipInt < cubeUV_maxMipLevel ) {\n\t\t\tuv.y += 2.0 * cubeUV_maxTileSize;\n\t\t}\n\t\tuv.y += filterInt * 2.0 * cubeUV_minTileSize;\n\t\tuv.x += 3.0 * max( 0.0, cubeUV_maxTileSize - 2.0 * faceSize );\n\t\tuv *= texelSize;\n\t\tvec3 tl = envMapTexelToLinear( texture2D( envMap, uv ) ).rgb;\n\t\tuv.x += texelSize;\n\t\tvec3 tr = envMapTexelToLinear( texture2D( envMap, uv ) ).rgb;\n\t\tuv.y += texelSize;\n\t\tvec3 br = envMapTexelToLinear( texture2D( envMap, uv ) ).rgb;\n\t\tuv.x -= texelSize;\n\t\tvec3 bl = envMapTexelToLinear( texture2D( envMap, uv ) ).rgb;\n\t\tvec3 tm = mix( tl, tr, f.x );\n\t\tvec3 bm = mix( bl, br, f.x );\n\t\treturn mix( tm, bm, f.y );\n\t}\n\t#define r0 1.0\n\t#define v0 0.339\n\t#define m0 - 2.0\n\t#define r1 0.8\n\t#define v1 0.276\n\t#define m1 - 1.0\n\t#define r4 0.4\n\t#define v4 0.046\n\t#define m4 2.0\n\t#define r5 0.305\n\t#define v5 0.016\n\t#define m5 3.0\n\t#define r6 0.21\n\t#define v6 0.0038\n\t#define m6 4.0\n\tfloat roughnessToMip( float roughness ) {\n\t\tfloat mip = 0.0;\n\t\tif ( roughness >= r1 ) {\n\t\t\tmip = ( r0 - roughness ) * ( m1 - m0 ) / ( r0 - r1 ) + m0;\n\t\t} else if ( roughness >= r4 ) {\n\t\t\tmip = ( r1 - roughness ) * ( m4 - m1 ) / ( r1 - r4 ) + m1;\n\t\t} else if ( roughness >= r5 ) {\n\t\t\tmip = ( r4 - roughness ) * ( m5 - m4 ) / ( r4 - r5 ) + m4;\n\t\t} else if ( roughness >= r6 ) {\n\t\t\tmip = ( r5 - roughness ) * ( m6 - m5 ) / ( r5 - r6 ) + m5;\n\t\t} else {\n\t\t\tmip = - 2.0 * log2( 1.16 * roughness );\t\t}\n\t\treturn mip;\n\t}\n\tvec4 textureCubeUV( sampler2D envMap, vec3 sampleDir, float roughness ) {\n\t\tfloat mip = clamp( roughnessToMip( roughness ), m0, cubeUV_maxMipLevel );\n\t\tfloat mipF = fract( mip );\n\t\tfloat mipInt = floor( mip );\n\t\tvec3 color0 = bilinearCubeUV( envMap, sampleDir, mipInt );\n\t\tif ( mipF == 0.0 ) {\n\t\t\treturn vec4( color0, 1.0 );\n\t\t} else {\n\t\t\tvec3 color1 = bilinearCubeUV( envMap, sampleDir, mipInt + 1.0 );\n\t\t\treturn vec4( mix( color0, color1, mipF ), 1.0 );\n\t\t}\n\t}\n#endif',
      Ja =
        'vec3 transformedNormal = objectNormal;\n#ifdef USE_INSTANCING\n\tmat3 m = mat3( instanceMatrix );\n\ttransformedNormal /= vec3( dot( m[ 0 ], m[ 0 ] ), dot( m[ 1 ], m[ 1 ] ), dot( m[ 2 ], m[ 2 ] ) );\n\ttransformedNormal = m * transformedNormal;\n#endif\ntransformedNormal = normalMatrix * transformedNormal;\n#ifdef FLIP_SIDED\n\ttransformedNormal = - transformedNormal;\n#endif\n#ifdef USE_TANGENT\n\tvec3 transformedTangent = ( modelViewMatrix * vec4( objectTangent, 0.0 ) ).xyz;\n\t#ifdef FLIP_SIDED\n\t\ttransformedTangent = - transformedTangent;\n\t#endif\n#endif',
      Za =
        '#ifdef USE_DISPLACEMENTMAP\n\tuniform sampler2D displacementMap;\n\tuniform float displacementScale;\n\tuniform float displacementBias;\n#endif',
      Ka =
        '#ifdef USE_DISPLACEMENTMAP\n\ttransformed += normalize( objectNormal ) * ( texture2D( displacementMap, vUv ).x * displacementScale + displacementBias );\n#endif',
      Qa =
        '#ifdef USE_EMISSIVEMAP\n\tvec4 emissiveColor = texture2D( emissiveMap, vUv );\n\temissiveColor.rgb = emissiveMapTexelToLinear( emissiveColor ).rgb;\n\ttotalEmissiveRadiance *= emissiveColor.rgb;\n#endif',
      $a = '#ifdef USE_EMISSIVEMAP\n\tuniform sampler2D emissiveMap;\n#endif',
      es = 'gl_FragColor = linearToOutputTexel( gl_FragColor );',
      ts =
        '\nvec4 LinearToLinear( in vec4 value ) {\n\treturn value;\n}\nvec4 GammaToLinear( in vec4 value, in float gammaFactor ) {\n\treturn vec4( pow( value.rgb, vec3( gammaFactor ) ), value.a );\n}\nvec4 LinearToGamma( in vec4 value, in float gammaFactor ) {\n\treturn vec4( pow( value.rgb, vec3( 1.0 / gammaFactor ) ), value.a );\n}\nvec4 sRGBToLinear( in vec4 value ) {\n\treturn vec4( mix( pow( value.rgb * 0.9478672986 + vec3( 0.0521327014 ), vec3( 2.4 ) ), value.rgb * 0.0773993808, vec3( lessThanEqual( value.rgb, vec3( 0.04045 ) ) ) ), value.a );\n}\nvec4 LinearTosRGB( in vec4 value ) {\n\treturn vec4( mix( pow( value.rgb, vec3( 0.41666 ) ) * 1.055 - vec3( 0.055 ), value.rgb * 12.92, vec3( lessThanEqual( value.rgb, vec3( 0.0031308 ) ) ) ), value.a );\n}\nvec4 RGBEToLinear( in vec4 value ) {\n\treturn vec4( value.rgb * exp2( value.a * 255.0 - 128.0 ), 1.0 );\n}\nvec4 LinearToRGBE( in vec4 value ) {\n\tfloat maxComponent = max( max( value.r, value.g ), value.b );\n\tfloat fExp = clamp( ceil( log2( maxComponent ) ), -128.0, 127.0 );\n\treturn vec4( value.rgb / exp2( fExp ), ( fExp + 128.0 ) / 255.0 );\n}\nvec4 RGBMToLinear( in vec4 value, in float maxRange ) {\n\treturn vec4( value.rgb * value.a * maxRange, 1.0 );\n}\nvec4 LinearToRGBM( in vec4 value, in float maxRange ) {\n\tfloat maxRGB = max( value.r, max( value.g, value.b ) );\n\tfloat M = clamp( maxRGB / maxRange, 0.0, 1.0 );\n\tM = ceil( M * 255.0 ) / 255.0;\n\treturn vec4( value.rgb / ( M * maxRange ), M );\n}\nvec4 RGBDToLinear( in vec4 value, in float maxRange ) {\n\treturn vec4( value.rgb * ( ( maxRange / 255.0 ) / value.a ), 1.0 );\n}\nvec4 LinearToRGBD( in vec4 value, in float maxRange ) {\n\tfloat maxRGB = max( value.r, max( value.g, value.b ) );\n\tfloat D = max( maxRange / maxRGB, 1.0 );\n\tD = clamp( floor( D ) / 255.0, 0.0, 1.0 );\n\treturn vec4( value.rgb * ( D * ( 255.0 / maxRange ) ), D );\n}\nconst mat3 cLogLuvM = mat3( 0.2209, 0.3390, 0.4184, 0.1138, 0.6780, 0.7319, 0.0102, 0.1130, 0.2969 );\nvec4 LinearToLogLuv( in vec4 value ) {\n\tvec3 Xp_Y_XYZp = cLogLuvM * value.rgb;\n\tXp_Y_XYZp = max( Xp_Y_XYZp, vec3( 1e-6, 1e-6, 1e-6 ) );\n\tvec4 vResult;\n\tvResult.xy = Xp_Y_XYZp.xy / Xp_Y_XYZp.z;\n\tfloat Le = 2.0 * log2(Xp_Y_XYZp.y) + 127.0;\n\tvResult.w = fract( Le );\n\tvResult.z = ( Le - ( floor( vResult.w * 255.0 ) ) / 255.0 ) / 255.0;\n\treturn vResult;\n}\nconst mat3 cLogLuvInverseM = mat3( 6.0014, -2.7008, -1.7996, -1.3320, 3.1029, -5.7721, 0.3008, -1.0882, 5.6268 );\nvec4 LogLuvToLinear( in vec4 value ) {\n\tfloat Le = value.z * 255.0 + value.w;\n\tvec3 Xp_Y_XYZp;\n\tXp_Y_XYZp.y = exp2( ( Le - 127.0 ) / 2.0 );\n\tXp_Y_XYZp.z = Xp_Y_XYZp.y / value.y;\n\tXp_Y_XYZp.x = value.x * Xp_Y_XYZp.z;\n\tvec3 vRGB = cLogLuvInverseM * Xp_Y_XYZp.rgb;\n\treturn vec4( max( vRGB, 0.0 ), 1.0 );\n}',
      ns =
        '#ifdef USE_ENVMAP\n\t#ifdef ENV_WORLDPOS\n\t\tvec3 cameraToFrag;\n\t\tif ( isOrthographic ) {\n\t\t\tcameraToFrag = normalize( vec3( - viewMatrix[ 0 ][ 2 ], - viewMatrix[ 1 ][ 2 ], - viewMatrix[ 2 ][ 2 ] ) );\n\t\t} else {\n\t\t\tcameraToFrag = normalize( vWorldPosition - cameraPosition );\n\t\t}\n\t\tvec3 worldNormal = inverseTransformDirection( normal, viewMatrix );\n\t\t#ifdef ENVMAP_MODE_REFLECTION\n\t\t\tvec3 reflectVec = reflect( cameraToFrag, worldNormal );\n\t\t#else\n\t\t\tvec3 reflectVec = refract( cameraToFrag, worldNormal, refractionRatio );\n\t\t#endif\n\t#else\n\t\tvec3 reflectVec = vReflect;\n\t#endif\n\t#ifdef ENVMAP_TYPE_CUBE\n\t\tvec4 envColor = textureCube( envMap, vec3( flipEnvMap * reflectVec.x, reflectVec.yz ) );\n\t#elif defined( ENVMAP_TYPE_CUBE_UV )\n\t\tvec4 envColor = textureCubeUV( envMap, reflectVec, 0.0 );\n\t#else\n\t\tvec4 envColor = vec4( 0.0 );\n\t#endif\n\t#ifndef ENVMAP_TYPE_CUBE_UV\n\t\tenvColor = envMapTexelToLinear( envColor );\n\t#endif\n\t#ifdef ENVMAP_BLENDING_MULTIPLY\n\t\toutgoingLight = mix( outgoingLight, outgoingLight * envColor.xyz, specularStrength * reflectivity );\n\t#elif defined( ENVMAP_BLENDING_MIX )\n\t\toutgoingLight = mix( outgoingLight, envColor.xyz, specularStrength * reflectivity );\n\t#elif defined( ENVMAP_BLENDING_ADD )\n\t\toutgoingLight += envColor.xyz * specularStrength * reflectivity;\n\t#endif\n#endif',
      is =
        '#ifdef USE_ENVMAP\n\tuniform float envMapIntensity;\n\tuniform float flipEnvMap;\n\tuniform int maxMipLevel;\n\t#ifdef ENVMAP_TYPE_CUBE\n\t\tuniform samplerCube envMap;\n\t#else\n\t\tuniform sampler2D envMap;\n\t#endif\n\t\n#endif',
      rs =
        '#ifdef USE_ENVMAP\n\tuniform float reflectivity;\n\t#if defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) || defined( PHONG )\n\t\t#define ENV_WORLDPOS\n\t#endif\n\t#ifdef ENV_WORLDPOS\n\t\tvarying vec3 vWorldPosition;\n\t\tuniform float refractionRatio;\n\t#else\n\t\tvarying vec3 vReflect;\n\t#endif\n#endif',
      as =
        '#ifdef USE_ENVMAP\n\t#if defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) ||defined( PHONG )\n\t\t#define ENV_WORLDPOS\n\t#endif\n\t#ifdef ENV_WORLDPOS\n\t\t\n\t\tvarying vec3 vWorldPosition;\n\t#else\n\t\tvarying vec3 vReflect;\n\t\tuniform float refractionRatio;\n\t#endif\n#endif',
      ss =
        '#ifdef USE_ENVMAP\n\t#ifdef ENV_WORLDPOS\n\t\tvWorldPosition = worldPosition.xyz;\n\t#else\n\t\tvec3 cameraToVertex;\n\t\tif ( isOrthographic ) {\n\t\t\tcameraToVertex = normalize( vec3( - viewMatrix[ 0 ][ 2 ], - viewMatrix[ 1 ][ 2 ], - viewMatrix[ 2 ][ 2 ] ) );\n\t\t} else {\n\t\t\tcameraToVertex = normalize( worldPosition.xyz - cameraPosition );\n\t\t}\n\t\tvec3 worldNormal = inverseTransformDirection( transformedNormal, viewMatrix );\n\t\t#ifdef ENVMAP_MODE_REFLECTION\n\t\t\tvReflect = reflect( cameraToVertex, worldNormal );\n\t\t#else\n\t\t\tvReflect = refract( cameraToVertex, worldNormal, refractionRatio );\n\t\t#endif\n\t#endif\n#endif',
      os = '#ifdef USE_FOG\n\tfogDepth = - mvPosition.z;\n#endif',
      ls = '#ifdef USE_FOG\n\tvarying float fogDepth;\n#endif',
      cs =
        '#ifdef USE_FOG\n\t#ifdef FOG_EXP2\n\t\tfloat fogFactor = 1.0 - exp( - fogDensity * fogDensity * fogDepth * fogDepth );\n\t#else\n\t\tfloat fogFactor = smoothstep( fogNear, fogFar, fogDepth );\n\t#endif\n\tgl_FragColor.rgb = mix( gl_FragColor.rgb, fogColor, fogFactor );\n#endif',
      hs =
        '#ifdef USE_FOG\n\tuniform vec3 fogColor;\n\tvarying float fogDepth;\n\t#ifdef FOG_EXP2\n\t\tuniform float fogDensity;\n\t#else\n\t\tuniform float fogNear;\n\t\tuniform float fogFar;\n\t#endif\n#endif',
      us =
        '#ifdef USE_GRADIENTMAP\n\tuniform sampler2D gradientMap;\n#endif\nvec3 getGradientIrradiance( vec3 normal, vec3 lightDirection ) {\n\tfloat dotNL = dot( normal, lightDirection );\n\tvec2 coord = vec2( dotNL * 0.5 + 0.5, 0.0 );\n\t#ifdef USE_GRADIENTMAP\n\t\treturn texture2D( gradientMap, coord ).rgb;\n\t#else\n\t\treturn ( coord.x < 0.7 ) ? vec3( 0.7 ) : vec3( 1.0 );\n\t#endif\n}',
      ds =
        '#ifdef USE_LIGHTMAP\n\tvec4 lightMapTexel= texture2D( lightMap, vUv2 );\n\treflectedLight.indirectDiffuse += PI * lightMapTexelToLinear( lightMapTexel ).rgb * lightMapIntensity;\n#endif',
      ps =
        '#ifdef USE_LIGHTMAP\n\tuniform sampler2D lightMap;\n\tuniform float lightMapIntensity;\n#endif',
      fs =
        'vec3 diffuse = vec3( 1.0 );\nGeometricContext geometry;\ngeometry.position = mvPosition.xyz;\ngeometry.normal = normalize( transformedNormal );\ngeometry.viewDir = ( isOrthographic ) ? vec3( 0, 0, 1 ) : normalize( -mvPosition.xyz );\nGeometricContext backGeometry;\nbackGeometry.position = geometry.position;\nbackGeometry.normal = -geometry.normal;\nbackGeometry.viewDir = geometry.viewDir;\nvLightFront = vec3( 0.0 );\nvIndirectFront = vec3( 0.0 );\n#ifdef DOUBLE_SIDED\n\tvLightBack = vec3( 0.0 );\n\tvIndirectBack = vec3( 0.0 );\n#endif\nIncidentLight directLight;\nfloat dotNL;\nvec3 directLightColor_Diffuse;\nvIndirectFront += getAmbientLightIrradiance( ambientLightColor );\nvIndirectFront += getLightProbeIrradiance( lightProbe, geometry );\n#ifdef DOUBLE_SIDED\n\tvIndirectBack += getAmbientLightIrradiance( ambientLightColor );\n\tvIndirectBack += getLightProbeIrradiance( lightProbe, backGeometry );\n#endif\n#if NUM_POINT_LIGHTS > 0\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_POINT_LIGHTS; i ++ ) {\n\t\tgetPointDirectLightIrradiance( pointLights[ i ], geometry, directLight );\n\t\tdotNL = dot( geometry.normal, directLight.direction );\n\t\tdirectLightColor_Diffuse = PI * directLight.color;\n\t\tvLightFront += saturate( dotNL ) * directLightColor_Diffuse;\n\t\t#ifdef DOUBLE_SIDED\n\t\t\tvLightBack += saturate( -dotNL ) * directLightColor_Diffuse;\n\t\t#endif\n\t}\n\t#pragma unroll_loop_end\n#endif\n#if NUM_SPOT_LIGHTS > 0\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_SPOT_LIGHTS; i ++ ) {\n\t\tgetSpotDirectLightIrradiance( spotLights[ i ], geometry, directLight );\n\t\tdotNL = dot( geometry.normal, directLight.direction );\n\t\tdirectLightColor_Diffuse = PI * directLight.color;\n\t\tvLightFront += saturate( dotNL ) * directLightColor_Diffuse;\n\t\t#ifdef DOUBLE_SIDED\n\t\t\tvLightBack += saturate( -dotNL ) * directLightColor_Diffuse;\n\t\t#endif\n\t}\n\t#pragma unroll_loop_end\n#endif\n#if NUM_DIR_LIGHTS > 0\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_DIR_LIGHTS; i ++ ) {\n\t\tgetDirectionalDirectLightIrradiance( directionalLights[ i ], geometry, directLight );\n\t\tdotNL = dot( geometry.normal, directLight.direction );\n\t\tdirectLightColor_Diffuse = PI * directLight.color;\n\t\tvLightFront += saturate( dotNL ) * directLightColor_Diffuse;\n\t\t#ifdef DOUBLE_SIDED\n\t\t\tvLightBack += saturate( -dotNL ) * directLightColor_Diffuse;\n\t\t#endif\n\t}\n\t#pragma unroll_loop_end\n#endif\n#if NUM_HEMI_LIGHTS > 0\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_HEMI_LIGHTS; i ++ ) {\n\t\tvIndirectFront += getHemisphereLightIrradiance( hemisphereLights[ i ], geometry );\n\t\t#ifdef DOUBLE_SIDED\n\t\t\tvIndirectBack += getHemisphereLightIrradiance( hemisphereLights[ i ], backGeometry );\n\t\t#endif\n\t}\n\t#pragma unroll_loop_end\n#endif',
      ms =
        'uniform bool receiveShadow;\nuniform vec3 ambientLightColor;\nuniform vec3 lightProbe[ 9 ];\nvec3 shGetIrradianceAt( in vec3 normal, in vec3 shCoefficients[ 9 ] ) {\n\tfloat x = normal.x, y = normal.y, z = normal.z;\n\tvec3 result = shCoefficients[ 0 ] * 0.886227;\n\tresult += shCoefficients[ 1 ] * 2.0 * 0.511664 * y;\n\tresult += shCoefficients[ 2 ] * 2.0 * 0.511664 * z;\n\tresult += shCoefficients[ 3 ] * 2.0 * 0.511664 * x;\n\tresult += shCoefficients[ 4 ] * 2.0 * 0.429043 * x * y;\n\tresult += shCoefficients[ 5 ] * 2.0 * 0.429043 * y * z;\n\tresult += shCoefficients[ 6 ] * ( 0.743125 * z * z - 0.247708 );\n\tresult += shCoefficients[ 7 ] * 2.0 * 0.429043 * x * z;\n\tresult += shCoefficients[ 8 ] * 0.429043 * ( x * x - y * y );\n\treturn result;\n}\nvec3 getLightProbeIrradiance( const in vec3 lightProbe[ 9 ], const in GeometricContext geometry ) {\n\tvec3 worldNormal = inverseTransformDirection( geometry.normal, viewMatrix );\n\tvec3 irradiance = shGetIrradianceAt( worldNormal, lightProbe );\n\treturn irradiance;\n}\nvec3 getAmbientLightIrradiance( const in vec3 ambientLightColor ) {\n\tvec3 irradiance = ambientLightColor;\n\t#ifndef PHYSICALLY_CORRECT_LIGHTS\n\t\tirradiance *= PI;\n\t#endif\n\treturn irradiance;\n}\n#if NUM_DIR_LIGHTS > 0\n\tstruct DirectionalLight {\n\t\tvec3 direction;\n\t\tvec3 color;\n\t};\n\tuniform DirectionalLight directionalLights[ NUM_DIR_LIGHTS ];\n\tvoid getDirectionalDirectLightIrradiance( const in DirectionalLight directionalLight, const in GeometricContext geometry, out IncidentLight directLight ) {\n\t\tdirectLight.color = directionalLight.color;\n\t\tdirectLight.direction = directionalLight.direction;\n\t\tdirectLight.visible = true;\n\t}\n#endif\n#if NUM_POINT_LIGHTS > 0\n\tstruct PointLight {\n\t\tvec3 position;\n\t\tvec3 color;\n\t\tfloat distance;\n\t\tfloat decay;\n\t};\n\tuniform PointLight pointLights[ NUM_POINT_LIGHTS ];\n\tvoid getPointDirectLightIrradiance( const in PointLight pointLight, const in GeometricContext geometry, out IncidentLight directLight ) {\n\t\tvec3 lVector = pointLight.position - geometry.position;\n\t\tdirectLight.direction = normalize( lVector );\n\t\tfloat lightDistance = length( lVector );\n\t\tdirectLight.color = pointLight.color;\n\t\tdirectLight.color *= punctualLightIntensityToIrradianceFactor( lightDistance, pointLight.distance, pointLight.decay );\n\t\tdirectLight.visible = ( directLight.color != vec3( 0.0 ) );\n\t}\n#endif\n#if NUM_SPOT_LIGHTS > 0\n\tstruct SpotLight {\n\t\tvec3 position;\n\t\tvec3 direction;\n\t\tvec3 color;\n\t\tfloat distance;\n\t\tfloat decay;\n\t\tfloat coneCos;\n\t\tfloat penumbraCos;\n\t};\n\tuniform SpotLight spotLights[ NUM_SPOT_LIGHTS ];\n\tvoid getSpotDirectLightIrradiance( const in SpotLight spotLight, const in GeometricContext geometry, out IncidentLight directLight ) {\n\t\tvec3 lVector = spotLight.position - geometry.position;\n\t\tdirectLight.direction = normalize( lVector );\n\t\tfloat lightDistance = length( lVector );\n\t\tfloat angleCos = dot( directLight.direction, spotLight.direction );\n\t\tif ( angleCos > spotLight.coneCos ) {\n\t\t\tfloat spotEffect = smoothstep( spotLight.coneCos, spotLight.penumbraCos, angleCos );\n\t\t\tdirectLight.color = spotLight.color;\n\t\t\tdirectLight.color *= spotEffect * punctualLightIntensityToIrradianceFactor( lightDistance, spotLight.distance, spotLight.decay );\n\t\t\tdirectLight.visible = true;\n\t\t} else {\n\t\t\tdirectLight.color = vec3( 0.0 );\n\t\t\tdirectLight.visible = false;\n\t\t}\n\t}\n#endif\n#if NUM_RECT_AREA_LIGHTS > 0\n\tstruct RectAreaLight {\n\t\tvec3 color;\n\t\tvec3 position;\n\t\tvec3 halfWidth;\n\t\tvec3 halfHeight;\n\t};\n\tuniform sampler2D ltc_1;\tuniform sampler2D ltc_2;\n\tuniform RectAreaLight rectAreaLights[ NUM_RECT_AREA_LIGHTS ];\n#endif\n#if NUM_HEMI_LIGHTS > 0\n\tstruct HemisphereLight {\n\t\tvec3 direction;\n\t\tvec3 skyColor;\n\t\tvec3 groundColor;\n\t};\n\tuniform HemisphereLight hemisphereLights[ NUM_HEMI_LIGHTS ];\n\tvec3 getHemisphereLightIrradiance( const in HemisphereLight hemiLight, const in GeometricContext geometry ) {\n\t\tfloat dotNL = dot( geometry.normal, hemiLight.direction );\n\t\tfloat hemiDiffuseWeight = 0.5 * dotNL + 0.5;\n\t\tvec3 irradiance = mix( hemiLight.groundColor, hemiLight.skyColor, hemiDiffuseWeight );\n\t\t#ifndef PHYSICALLY_CORRECT_LIGHTS\n\t\t\tirradiance *= PI;\n\t\t#endif\n\t\treturn irradiance;\n\t}\n#endif',
      gs =
        '#if defined( USE_ENVMAP )\n\t#ifdef ENVMAP_MODE_REFRACTION\n\t\tuniform float refractionRatio;\n\t#endif\n\tvec3 getLightProbeIndirectIrradiance( const in GeometricContext geometry, const in int maxMIPLevel ) {\n\t\tvec3 worldNormal = inverseTransformDirection( geometry.normal, viewMatrix );\n\t\t#ifdef ENVMAP_TYPE_CUBE\n\t\t\tvec3 queryVec = vec3( flipEnvMap * worldNormal.x, worldNormal.yz );\n\t\t\t#ifdef TEXTURE_LOD_EXT\n\t\t\t\tvec4 envMapColor = textureCubeLodEXT( envMap, queryVec, float( maxMIPLevel ) );\n\t\t\t#else\n\t\t\t\tvec4 envMapColor = textureCube( envMap, queryVec, float( maxMIPLevel ) );\n\t\t\t#endif\n\t\t\tenvMapColor.rgb = envMapTexelToLinear( envMapColor ).rgb;\n\t\t#elif defined( ENVMAP_TYPE_CUBE_UV )\n\t\t\tvec4 envMapColor = textureCubeUV( envMap, worldNormal, 1.0 );\n\t\t#else\n\t\t\tvec4 envMapColor = vec4( 0.0 );\n\t\t#endif\n\t\treturn PI * envMapColor.rgb * envMapIntensity;\n\t}\n\tfloat getSpecularMIPLevel( const in float roughness, const in int maxMIPLevel ) {\n\t\tfloat maxMIPLevelScalar = float( maxMIPLevel );\n\t\tfloat sigma = PI * roughness * roughness / ( 1.0 + roughness );\n\t\tfloat desiredMIPLevel = maxMIPLevelScalar + log2( sigma );\n\t\treturn clamp( desiredMIPLevel, 0.0, maxMIPLevelScalar );\n\t}\n\tvec3 getLightProbeIndirectRadiance( const in vec3 viewDir, const in vec3 normal, const in float roughness, const in int maxMIPLevel ) {\n\t\t#ifdef ENVMAP_MODE_REFLECTION\n\t\t\tvec3 reflectVec = reflect( -viewDir, normal );\n\t\t\treflectVec = normalize( mix( reflectVec, normal, roughness * roughness) );\n\t\t#else\n\t\t\tvec3 reflectVec = refract( -viewDir, normal, refractionRatio );\n\t\t#endif\n\t\treflectVec = inverseTransformDirection( reflectVec, viewMatrix );\n\t\tfloat specularMIPLevel = getSpecularMIPLevel( roughness, maxMIPLevel );\n\t\t#ifdef ENVMAP_TYPE_CUBE\n\t\t\tvec3 queryReflectVec = vec3( flipEnvMap * reflectVec.x, reflectVec.yz );\n\t\t\t#ifdef TEXTURE_LOD_EXT\n\t\t\t\tvec4 envMapColor = textureCubeLodEXT( envMap, queryReflectVec, specularMIPLevel );\n\t\t\t#else\n\t\t\t\tvec4 envMapColor = textureCube( envMap, queryReflectVec, specularMIPLevel );\n\t\t\t#endif\n\t\t\tenvMapColor.rgb = envMapTexelToLinear( envMapColor ).rgb;\n\t\t#elif defined( ENVMAP_TYPE_CUBE_UV )\n\t\t\tvec4 envMapColor = textureCubeUV( envMap, reflectVec, roughness );\n\t\t#endif\n\t\treturn envMapColor.rgb * envMapIntensity;\n\t}\n#endif',
      vs = 'ToonMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb;',
      ys =
        'varying vec3 vViewPosition;\n#ifndef FLAT_SHADED\n\tvarying vec3 vNormal;\n#endif\nstruct ToonMaterial {\n\tvec3 diffuseColor;\n};\nvoid RE_Direct_Toon( const in IncidentLight directLight, const in GeometricContext geometry, const in ToonMaterial material, inout ReflectedLight reflectedLight ) {\n\tvec3 irradiance = getGradientIrradiance( geometry.normal, directLight.direction ) * directLight.color;\n\t#ifndef PHYSICALLY_CORRECT_LIGHTS\n\t\tirradiance *= PI;\n\t#endif\n\treflectedLight.directDiffuse += irradiance * BRDF_Diffuse_Lambert( material.diffuseColor );\n}\nvoid RE_IndirectDiffuse_Toon( const in vec3 irradiance, const in GeometricContext geometry, const in ToonMaterial material, inout ReflectedLight reflectedLight ) {\n\treflectedLight.indirectDiffuse += irradiance * BRDF_Diffuse_Lambert( material.diffuseColor );\n}\n#define RE_Direct\t\t\t\tRE_Direct_Toon\n#define RE_IndirectDiffuse\t\tRE_IndirectDiffuse_Toon\n#define Material_LightProbeLOD( material )\t(0)',
      _s =
        'BlinnPhongMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb;\nmaterial.specularColor = specular;\nmaterial.specularShininess = shininess;\nmaterial.specularStrength = specularStrength;',
      xs =
        'varying vec3 vViewPosition;\n#ifndef FLAT_SHADED\n\tvarying vec3 vNormal;\n#endif\nstruct BlinnPhongMaterial {\n\tvec3 diffuseColor;\n\tvec3 specularColor;\n\tfloat specularShininess;\n\tfloat specularStrength;\n};\nvoid RE_Direct_BlinnPhong( const in IncidentLight directLight, const in GeometricContext geometry, const in BlinnPhongMaterial material, inout ReflectedLight reflectedLight ) {\n\tfloat dotNL = saturate( dot( geometry.normal, directLight.direction ) );\n\tvec3 irradiance = dotNL * directLight.color;\n\t#ifndef PHYSICALLY_CORRECT_LIGHTS\n\t\tirradiance *= PI;\n\t#endif\n\treflectedLight.directDiffuse += irradiance * BRDF_Diffuse_Lambert( material.diffuseColor );\n\treflectedLight.directSpecular += irradiance * BRDF_Specular_BlinnPhong( directLight, geometry, material.specularColor, material.specularShininess ) * material.specularStrength;\n}\nvoid RE_IndirectDiffuse_BlinnPhong( const in vec3 irradiance, const in GeometricContext geometry, const in BlinnPhongMaterial material, inout ReflectedLight reflectedLight ) {\n\treflectedLight.indirectDiffuse += irradiance * BRDF_Diffuse_Lambert( material.diffuseColor );\n}\n#define RE_Direct\t\t\t\tRE_Direct_BlinnPhong\n#define RE_IndirectDiffuse\t\tRE_IndirectDiffuse_BlinnPhong\n#define Material_LightProbeLOD( material )\t(0)',
      ws =
        'PhysicalMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb * ( 1.0 - metalnessFactor );\nvec3 dxy = max( abs( dFdx( geometryNormal ) ), abs( dFdy( geometryNormal ) ) );\nfloat geometryRoughness = max( max( dxy.x, dxy.y ), dxy.z );\nmaterial.specularRoughness = max( roughnessFactor, 0.0525 );material.specularRoughness += geometryRoughness;\nmaterial.specularRoughness = min( material.specularRoughness, 1.0 );\n#ifdef REFLECTIVITY\n\tmaterial.specularColor = mix( vec3( MAXIMUM_SPECULAR_COEFFICIENT * pow2( reflectivity ) ), diffuseColor.rgb, metalnessFactor );\n#else\n\tmaterial.specularColor = mix( vec3( DEFAULT_SPECULAR_COEFFICIENT ), diffuseColor.rgb, metalnessFactor );\n#endif\n#ifdef CLEARCOAT\n\tmaterial.clearcoat = clearcoat;\n\tmaterial.clearcoatRoughness = clearcoatRoughness;\n\t#ifdef USE_CLEARCOATMAP\n\t\tmaterial.clearcoat *= texture2D( clearcoatMap, vUv ).x;\n\t#endif\n\t#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n\t\tmaterial.clearcoatRoughness *= texture2D( clearcoatRoughnessMap, vUv ).y;\n\t#endif\n\tmaterial.clearcoat = saturate( material.clearcoat );\tmaterial.clearcoatRoughness = max( material.clearcoatRoughness, 0.0525 );\n\tmaterial.clearcoatRoughness += geometryRoughness;\n\tmaterial.clearcoatRoughness = min( material.clearcoatRoughness, 1.0 );\n#endif\n#ifdef USE_SHEEN\n\tmaterial.sheenColor = sheen;\n#endif',
      bs =
        'struct PhysicalMaterial {\n\tvec3 diffuseColor;\n\tfloat specularRoughness;\n\tvec3 specularColor;\n#ifdef CLEARCOAT\n\tfloat clearcoat;\n\tfloat clearcoatRoughness;\n#endif\n#ifdef USE_SHEEN\n\tvec3 sheenColor;\n#endif\n};\n#define MAXIMUM_SPECULAR_COEFFICIENT 0.16\n#define DEFAULT_SPECULAR_COEFFICIENT 0.04\nfloat clearcoatDHRApprox( const in float roughness, const in float dotNL ) {\n\treturn DEFAULT_SPECULAR_COEFFICIENT + ( 1.0 - DEFAULT_SPECULAR_COEFFICIENT ) * ( pow( 1.0 - dotNL, 5.0 ) * pow( 1.0 - roughness, 2.0 ) );\n}\n#if NUM_RECT_AREA_LIGHTS > 0\n\tvoid RE_Direct_RectArea_Physical( const in RectAreaLight rectAreaLight, const in GeometricContext geometry, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {\n\t\tvec3 normal = geometry.normal;\n\t\tvec3 viewDir = geometry.viewDir;\n\t\tvec3 position = geometry.position;\n\t\tvec3 lightPos = rectAreaLight.position;\n\t\tvec3 halfWidth = rectAreaLight.halfWidth;\n\t\tvec3 halfHeight = rectAreaLight.halfHeight;\n\t\tvec3 lightColor = rectAreaLight.color;\n\t\tfloat roughness = material.specularRoughness;\n\t\tvec3 rectCoords[ 4 ];\n\t\trectCoords[ 0 ] = lightPos + halfWidth - halfHeight;\t\trectCoords[ 1 ] = lightPos - halfWidth - halfHeight;\n\t\trectCoords[ 2 ] = lightPos - halfWidth + halfHeight;\n\t\trectCoords[ 3 ] = lightPos + halfWidth + halfHeight;\n\t\tvec2 uv = LTC_Uv( normal, viewDir, roughness );\n\t\tvec4 t1 = texture2D( ltc_1, uv );\n\t\tvec4 t2 = texture2D( ltc_2, uv );\n\t\tmat3 mInv = mat3(\n\t\t\tvec3( t1.x, 0, t1.y ),\n\t\t\tvec3(    0, 1,    0 ),\n\t\t\tvec3( t1.z, 0, t1.w )\n\t\t);\n\t\tvec3 fresnel = ( material.specularColor * t2.x + ( vec3( 1.0 ) - material.specularColor ) * t2.y );\n\t\treflectedLight.directSpecular += lightColor * fresnel * LTC_Evaluate( normal, viewDir, position, mInv, rectCoords );\n\t\treflectedLight.directDiffuse += lightColor * material.diffuseColor * LTC_Evaluate( normal, viewDir, position, mat3( 1.0 ), rectCoords );\n\t}\n#endif\nvoid RE_Direct_Physical( const in IncidentLight directLight, const in GeometricContext geometry, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {\n\tfloat dotNL = saturate( dot( geometry.normal, directLight.direction ) );\n\tvec3 irradiance = dotNL * directLight.color;\n\t#ifndef PHYSICALLY_CORRECT_LIGHTS\n\t\tirradiance *= PI;\n\t#endif\n\t#ifdef CLEARCOAT\n\t\tfloat ccDotNL = saturate( dot( geometry.clearcoatNormal, directLight.direction ) );\n\t\tvec3 ccIrradiance = ccDotNL * directLight.color;\n\t\t#ifndef PHYSICALLY_CORRECT_LIGHTS\n\t\t\tccIrradiance *= PI;\n\t\t#endif\n\t\tfloat clearcoatDHR = material.clearcoat * clearcoatDHRApprox( material.clearcoatRoughness, ccDotNL );\n\t\treflectedLight.directSpecular += ccIrradiance * material.clearcoat * BRDF_Specular_GGX( directLight, geometry.viewDir, geometry.clearcoatNormal, vec3( DEFAULT_SPECULAR_COEFFICIENT ), material.clearcoatRoughness );\n\t#else\n\t\tfloat clearcoatDHR = 0.0;\n\t#endif\n\t#ifdef USE_SHEEN\n\t\treflectedLight.directSpecular += ( 1.0 - clearcoatDHR ) * irradiance * BRDF_Specular_Sheen(\n\t\t\tmaterial.specularRoughness,\n\t\t\tdirectLight.direction,\n\t\t\tgeometry,\n\t\t\tmaterial.sheenColor\n\t\t);\n\t#else\n\t\treflectedLight.directSpecular += ( 1.0 - clearcoatDHR ) * irradiance * BRDF_Specular_GGX( directLight, geometry.viewDir, geometry.normal, material.specularColor, material.specularRoughness);\n\t#endif\n\treflectedLight.directDiffuse += ( 1.0 - clearcoatDHR ) * irradiance * BRDF_Diffuse_Lambert( material.diffuseColor );\n}\nvoid RE_IndirectDiffuse_Physical( const in vec3 irradiance, const in GeometricContext geometry, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {\n\treflectedLight.indirectDiffuse += irradiance * BRDF_Diffuse_Lambert( material.diffuseColor );\n}\nvoid RE_IndirectSpecular_Physical( const in vec3 radiance, const in vec3 irradiance, const in vec3 clearcoatRadiance, const in GeometricContext geometry, const in PhysicalMaterial material, inout ReflectedLight reflectedLight) {\n\t#ifdef CLEARCOAT\n\t\tfloat ccDotNV = saturate( dot( geometry.clearcoatNormal, geometry.viewDir ) );\n\t\treflectedLight.indirectSpecular += clearcoatRadiance * material.clearcoat * BRDF_Specular_GGX_Environment( geometry.viewDir, geometry.clearcoatNormal, vec3( DEFAULT_SPECULAR_COEFFICIENT ), material.clearcoatRoughness );\n\t\tfloat ccDotNL = ccDotNV;\n\t\tfloat clearcoatDHR = material.clearcoat * clearcoatDHRApprox( material.clearcoatRoughness, ccDotNL );\n\t#else\n\t\tfloat clearcoatDHR = 0.0;\n\t#endif\n\tfloat clearcoatInv = 1.0 - clearcoatDHR;\n\tvec3 singleScattering = vec3( 0.0 );\n\tvec3 multiScattering = vec3( 0.0 );\n\tvec3 cosineWeightedIrradiance = irradiance * RECIPROCAL_PI;\n\tBRDF_Specular_Multiscattering_Environment( geometry, material.specularColor, material.specularRoughness, singleScattering, multiScattering );\n\tvec3 diffuse = material.diffuseColor * ( 1.0 - ( singleScattering + multiScattering ) );\n\treflectedLight.indirectSpecular += clearcoatInv * radiance * singleScattering;\n\treflectedLight.indirectSpecular += multiScattering * cosineWeightedIrradiance;\n\treflectedLight.indirectDiffuse += diffuse * cosineWeightedIrradiance;\n}\n#define RE_Direct\t\t\t\tRE_Direct_Physical\n#define RE_Direct_RectArea\t\tRE_Direct_RectArea_Physical\n#define RE_IndirectDiffuse\t\tRE_IndirectDiffuse_Physical\n#define RE_IndirectSpecular\t\tRE_IndirectSpecular_Physical\nfloat computeSpecularOcclusion( const in float dotNV, const in float ambientOcclusion, const in float roughness ) {\n\treturn saturate( pow( dotNV + ambientOcclusion, exp2( - 16.0 * roughness - 1.0 ) ) - 1.0 + ambientOcclusion );\n}',
      Ms =
        '\nGeometricContext geometry;\ngeometry.position = - vViewPosition;\ngeometry.normal = normal;\ngeometry.viewDir = ( isOrthographic ) ? vec3( 0, 0, 1 ) : normalize( vViewPosition );\n#ifdef CLEARCOAT\n\tgeometry.clearcoatNormal = clearcoatNormal;\n#endif\nIncidentLight directLight;\n#if ( NUM_POINT_LIGHTS > 0 ) && defined( RE_Direct )\n\tPointLight pointLight;\n\t#if defined( USE_SHADOWMAP ) && NUM_POINT_LIGHT_SHADOWS > 0\n\tPointLightShadow pointLightShadow;\n\t#endif\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_POINT_LIGHTS; i ++ ) {\n\t\tpointLight = pointLights[ i ];\n\t\tgetPointDirectLightIrradiance( pointLight, geometry, directLight );\n\t\t#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_POINT_LIGHT_SHADOWS )\n\t\tpointLightShadow = pointLightShadows[ i ];\n\t\tdirectLight.color *= all( bvec2( directLight.visible, receiveShadow ) ) ? getPointShadow( pointShadowMap[ i ], pointLightShadow.shadowMapSize, pointLightShadow.shadowBias, pointLightShadow.shadowRadius, vPointShadowCoord[ i ], pointLightShadow.shadowCameraNear, pointLightShadow.shadowCameraFar ) : 1.0;\n\t\t#endif\n\t\tRE_Direct( directLight, geometry, material, reflectedLight );\n\t}\n\t#pragma unroll_loop_end\n#endif\n#if ( NUM_SPOT_LIGHTS > 0 ) && defined( RE_Direct )\n\tSpotLight spotLight;\n\t#if defined( USE_SHADOWMAP ) && NUM_SPOT_LIGHT_SHADOWS > 0\n\tSpotLightShadow spotLightShadow;\n\t#endif\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_SPOT_LIGHTS; i ++ ) {\n\t\tspotLight = spotLights[ i ];\n\t\tgetSpotDirectLightIrradiance( spotLight, geometry, directLight );\n\t\t#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS )\n\t\tspotLightShadow = spotLightShadows[ i ];\n\t\tdirectLight.color *= all( bvec2( directLight.visible, receiveShadow ) ) ? getShadow( spotShadowMap[ i ], spotLightShadow.shadowMapSize, spotLightShadow.shadowBias, spotLightShadow.shadowRadius, vSpotShadowCoord[ i ] ) : 1.0;\n\t\t#endif\n\t\tRE_Direct( directLight, geometry, material, reflectedLight );\n\t}\n\t#pragma unroll_loop_end\n#endif\n#if ( NUM_DIR_LIGHTS > 0 ) && defined( RE_Direct )\n\tDirectionalLight directionalLight;\n\t#if defined( USE_SHADOWMAP ) && NUM_DIR_LIGHT_SHADOWS > 0\n\tDirectionalLightShadow directionalLightShadow;\n\t#endif\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_DIR_LIGHTS; i ++ ) {\n\t\tdirectionalLight = directionalLights[ i ];\n\t\tgetDirectionalDirectLightIrradiance( directionalLight, geometry, directLight );\n\t\t#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_DIR_LIGHT_SHADOWS )\n\t\tdirectionalLightShadow = directionalLightShadows[ i ];\n\t\tdirectLight.color *= all( bvec2( directLight.visible, receiveShadow ) ) ? getShadow( directionalShadowMap[ i ], directionalLightShadow.shadowMapSize, directionalLightShadow.shadowBias, directionalLightShadow.shadowRadius, vDirectionalShadowCoord[ i ] ) : 1.0;\n\t\t#endif\n\t\tRE_Direct( directLight, geometry, material, reflectedLight );\n\t}\n\t#pragma unroll_loop_end\n#endif\n#if ( NUM_RECT_AREA_LIGHTS > 0 ) && defined( RE_Direct_RectArea )\n\tRectAreaLight rectAreaLight;\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_RECT_AREA_LIGHTS; i ++ ) {\n\t\trectAreaLight = rectAreaLights[ i ];\n\t\tRE_Direct_RectArea( rectAreaLight, geometry, material, reflectedLight );\n\t}\n\t#pragma unroll_loop_end\n#endif\n#if defined( RE_IndirectDiffuse )\n\tvec3 iblIrradiance = vec3( 0.0 );\n\tvec3 irradiance = getAmbientLightIrradiance( ambientLightColor );\n\tirradiance += getLightProbeIrradiance( lightProbe, geometry );\n\t#if ( NUM_HEMI_LIGHTS > 0 )\n\t\t#pragma unroll_loop_start\n\t\tfor ( int i = 0; i < NUM_HEMI_LIGHTS; i ++ ) {\n\t\t\tirradiance += getHemisphereLightIrradiance( hemisphereLights[ i ], geometry );\n\t\t}\n\t\t#pragma unroll_loop_end\n\t#endif\n#endif\n#if defined( RE_IndirectSpecular )\n\tvec3 radiance = vec3( 0.0 );\n\tvec3 clearcoatRadiance = vec3( 0.0 );\n#endif',
      Ss =
        '#if defined( RE_IndirectDiffuse )\n\t#ifdef USE_LIGHTMAP\n\t\tvec4 lightMapTexel= texture2D( lightMap, vUv2 );\n\t\tvec3 lightMapIrradiance = lightMapTexelToLinear( lightMapTexel ).rgb * lightMapIntensity;\n\t\t#ifndef PHYSICALLY_CORRECT_LIGHTS\n\t\t\tlightMapIrradiance *= PI;\n\t\t#endif\n\t\tirradiance += lightMapIrradiance;\n\t#endif\n\t#if defined( USE_ENVMAP ) && defined( STANDARD ) && defined( ENVMAP_TYPE_CUBE_UV )\n\t\tiblIrradiance += getLightProbeIndirectIrradiance( geometry, maxMipLevel );\n\t#endif\n#endif\n#if defined( USE_ENVMAP ) && defined( RE_IndirectSpecular )\n\tradiance += getLightProbeIndirectRadiance( geometry.viewDir, geometry.normal, material.specularRoughness, maxMipLevel );\n\t#ifdef CLEARCOAT\n\t\tclearcoatRadiance += getLightProbeIndirectRadiance( geometry.viewDir, geometry.clearcoatNormal, material.clearcoatRoughness, maxMipLevel );\n\t#endif\n#endif',
      Es =
        '#if defined( RE_IndirectDiffuse )\n\tRE_IndirectDiffuse( irradiance, geometry, material, reflectedLight );\n#endif\n#if defined( RE_IndirectSpecular )\n\tRE_IndirectSpecular( radiance, iblIrradiance, clearcoatRadiance, geometry, material, reflectedLight );\n#endif',
      Ts =
        '#if defined( USE_LOGDEPTHBUF ) && defined( USE_LOGDEPTHBUF_EXT )\n\tgl_FragDepthEXT = vIsPerspective == 0.0 ? gl_FragCoord.z : log2( vFragDepth ) * logDepthBufFC * 0.5;\n#endif',
      As =
        '#if defined( USE_LOGDEPTHBUF ) && defined( USE_LOGDEPTHBUF_EXT )\n\tuniform float logDepthBufFC;\n\tvarying float vFragDepth;\n\tvarying float vIsPerspective;\n#endif',
      Rs =
        '#ifdef USE_LOGDEPTHBUF\n\t#ifdef USE_LOGDEPTHBUF_EXT\n\t\tvarying float vFragDepth;\n\t\tvarying float vIsPerspective;\n\t#else\n\t\tuniform float logDepthBufFC;\n\t#endif\n#endif',
      Ls =
        '#ifdef USE_LOGDEPTHBUF\n\t#ifdef USE_LOGDEPTHBUF_EXT\n\t\tvFragDepth = 1.0 + gl_Position.w;\n\t\tvIsPerspective = float( isPerspectiveMatrix( projectionMatrix ) );\n\t#else\n\t\tif ( isPerspectiveMatrix( projectionMatrix ) ) {\n\t\t\tgl_Position.z = log2( max( EPSILON, gl_Position.w + 1.0 ) ) * logDepthBufFC - 1.0;\n\t\t\tgl_Position.z *= gl_Position.w;\n\t\t}\n\t#endif\n#endif',
      Cs =
        '#ifdef USE_MAP\n\tvec4 texelColor = texture2D( map, vUv );\n\ttexelColor = mapTexelToLinear( texelColor );\n\tdiffuseColor *= texelColor;\n#endif',
      Ps = '#ifdef USE_MAP\n\tuniform sampler2D map;\n#endif',
      Ds =
        '#if defined( USE_MAP ) || defined( USE_ALPHAMAP )\n\tvec2 uv = ( uvTransform * vec3( gl_PointCoord.x, 1.0 - gl_PointCoord.y, 1 ) ).xy;\n#endif\n#ifdef USE_MAP\n\tvec4 mapTexel = texture2D( map, uv );\n\tdiffuseColor *= mapTexelToLinear( mapTexel );\n#endif\n#ifdef USE_ALPHAMAP\n\tdiffuseColor.a *= texture2D( alphaMap, uv ).g;\n#endif',
      Is =
        '#if defined( USE_MAP ) || defined( USE_ALPHAMAP )\n\tuniform mat3 uvTransform;\n#endif\n#ifdef USE_MAP\n\tuniform sampler2D map;\n#endif\n#ifdef USE_ALPHAMAP\n\tuniform sampler2D alphaMap;\n#endif',
      Ns =
        'float metalnessFactor = metalness;\n#ifdef USE_METALNESSMAP\n\tvec4 texelMetalness = texture2D( metalnessMap, vUv );\n\tmetalnessFactor *= texelMetalness.b;\n#endif',
      Os = '#ifdef USE_METALNESSMAP\n\tuniform sampler2D metalnessMap;\n#endif',
      Fs =
        '#ifdef USE_MORPHNORMALS\n\tobjectNormal *= morphTargetBaseInfluence;\n\tobjectNormal += morphNormal0 * morphTargetInfluences[ 0 ];\n\tobjectNormal += morphNormal1 * morphTargetInfluences[ 1 ];\n\tobjectNormal += morphNormal2 * morphTargetInfluences[ 2 ];\n\tobjectNormal += morphNormal3 * morphTargetInfluences[ 3 ];\n#endif',
      Bs =
        '#ifdef USE_MORPHTARGETS\n\tuniform float morphTargetBaseInfluence;\n\t#ifndef USE_MORPHNORMALS\n\t\tuniform float morphTargetInfluences[ 8 ];\n\t#else\n\t\tuniform float morphTargetInfluences[ 4 ];\n\t#endif\n#endif',
      zs =
        '#ifdef USE_MORPHTARGETS\n\ttransformed *= morphTargetBaseInfluence;\n\ttransformed += morphTarget0 * morphTargetInfluences[ 0 ];\n\ttransformed += morphTarget1 * morphTargetInfluences[ 1 ];\n\ttransformed += morphTarget2 * morphTargetInfluences[ 2 ];\n\ttransformed += morphTarget3 * morphTargetInfluences[ 3 ];\n\t#ifndef USE_MORPHNORMALS\n\t\ttransformed += morphTarget4 * morphTargetInfluences[ 4 ];\n\t\ttransformed += morphTarget5 * morphTargetInfluences[ 5 ];\n\t\ttransformed += morphTarget6 * morphTargetInfluences[ 6 ];\n\t\ttransformed += morphTarget7 * morphTargetInfluences[ 7 ];\n\t#endif\n#endif',
      Us =
        'float faceDirection = gl_FrontFacing ? 1.0 : - 1.0;\n#ifdef FLAT_SHADED\n\tvec3 fdx = vec3( dFdx( vViewPosition.x ), dFdx( vViewPosition.y ), dFdx( vViewPosition.z ) );\n\tvec3 fdy = vec3( dFdy( vViewPosition.x ), dFdy( vViewPosition.y ), dFdy( vViewPosition.z ) );\n\tvec3 normal = normalize( cross( fdx, fdy ) );\n#else\n\tvec3 normal = normalize( vNormal );\n\t#ifdef DOUBLE_SIDED\n\t\tnormal = normal * faceDirection;\n\t#endif\n\t#ifdef USE_TANGENT\n\t\tvec3 tangent = normalize( vTangent );\n\t\tvec3 bitangent = normalize( vBitangent );\n\t\t#ifdef DOUBLE_SIDED\n\t\t\ttangent = tangent * faceDirection;\n\t\t\tbitangent = bitangent * faceDirection;\n\t\t#endif\n\t\t#if defined( TANGENTSPACE_NORMALMAP ) || defined( USE_CLEARCOAT_NORMALMAP )\n\t\t\tmat3 vTBN = mat3( tangent, bitangent, normal );\n\t\t#endif\n\t#endif\n#endif\nvec3 geometryNormal = normal;',
      ks =
        '#ifdef OBJECTSPACE_NORMALMAP\n\tnormal = texture2D( normalMap, vUv ).xyz * 2.0 - 1.0;\n\t#ifdef FLIP_SIDED\n\t\tnormal = - normal;\n\t#endif\n\t#ifdef DOUBLE_SIDED\n\t\tnormal = normal * faceDirection;\n\t#endif\n\tnormal = normalize( normalMatrix * normal );\n#elif defined( TANGENTSPACE_NORMALMAP )\n\tvec3 mapN = texture2D( normalMap, vUv ).xyz * 2.0 - 1.0;\n\tmapN.xy *= normalScale;\n\t#ifdef USE_TANGENT\n\t\tnormal = normalize( vTBN * mapN );\n\t#else\n\t\tnormal = perturbNormal2Arb( -vViewPosition, normal, mapN, faceDirection );\n\t#endif\n#elif defined( USE_BUMPMAP )\n\tnormal = perturbNormalArb( -vViewPosition, normal, dHdxy_fwd(), faceDirection );\n#endif',
      Hs =
        '#ifdef USE_NORMALMAP\n\tuniform sampler2D normalMap;\n\tuniform vec2 normalScale;\n#endif\n#ifdef OBJECTSPACE_NORMALMAP\n\tuniform mat3 normalMatrix;\n#endif\n#if ! defined ( USE_TANGENT ) && ( defined ( TANGENTSPACE_NORMALMAP ) || defined ( USE_CLEARCOAT_NORMALMAP ) )\n\tvec3 perturbNormal2Arb( vec3 eye_pos, vec3 surf_norm, vec3 mapN, float faceDirection ) {\n\t\tvec3 q0 = vec3( dFdx( eye_pos.x ), dFdx( eye_pos.y ), dFdx( eye_pos.z ) );\n\t\tvec3 q1 = vec3( dFdy( eye_pos.x ), dFdy( eye_pos.y ), dFdy( eye_pos.z ) );\n\t\tvec2 st0 = dFdx( vUv.st );\n\t\tvec2 st1 = dFdy( vUv.st );\n\t\tvec3 N = surf_norm;\n\t\tvec3 q1perp = cross( q1, N );\n\t\tvec3 q0perp = cross( N, q0 );\n\t\tvec3 T = q1perp * st0.x + q0perp * st1.x;\n\t\tvec3 B = q1perp * st0.y + q0perp * st1.y;\n\t\tfloat det = max( dot( T, T ), dot( B, B ) );\n\t\tfloat scale = ( det == 0.0 ) ? 0.0 : faceDirection * inversesqrt( det );\n\t\treturn normalize( T * ( mapN.x * scale ) + B * ( mapN.y * scale ) + N * mapN.z );\n\t}\n#endif',
      Ws = '#ifdef CLEARCOAT\n\tvec3 clearcoatNormal = geometryNormal;\n#endif',
      Vs =
        '#ifdef USE_CLEARCOAT_NORMALMAP\n\tvec3 clearcoatMapN = texture2D( clearcoatNormalMap, vUv ).xyz * 2.0 - 1.0;\n\tclearcoatMapN.xy *= clearcoatNormalScale;\n\t#ifdef USE_TANGENT\n\t\tclearcoatNormal = normalize( vTBN * clearcoatMapN );\n\t#else\n\t\tclearcoatNormal = perturbNormal2Arb( - vViewPosition, clearcoatNormal, clearcoatMapN, faceDirection );\n\t#endif\n#endif',
      Gs =
        '#ifdef USE_CLEARCOATMAP\n\tuniform sampler2D clearcoatMap;\n#endif\n#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n\tuniform sampler2D clearcoatRoughnessMap;\n#endif\n#ifdef USE_CLEARCOAT_NORMALMAP\n\tuniform sampler2D clearcoatNormalMap;\n\tuniform vec2 clearcoatNormalScale;\n#endif',
      js =
        'vec3 packNormalToRGB( const in vec3 normal ) {\n\treturn normalize( normal ) * 0.5 + 0.5;\n}\nvec3 unpackRGBToNormal( const in vec3 rgb ) {\n\treturn 2.0 * rgb.xyz - 1.0;\n}\nconst float PackUpscale = 256. / 255.;const float UnpackDownscale = 255. / 256.;\nconst vec3 PackFactors = vec3( 256. * 256. * 256., 256. * 256., 256. );\nconst vec4 UnpackFactors = UnpackDownscale / vec4( PackFactors, 1. );\nconst float ShiftRight8 = 1. / 256.;\nvec4 packDepthToRGBA( const in float v ) {\n\tvec4 r = vec4( fract( v * PackFactors ), v );\n\tr.yzw -= r.xyz * ShiftRight8;\treturn r * PackUpscale;\n}\nfloat unpackRGBAToDepth( const in vec4 v ) {\n\treturn dot( v, UnpackFactors );\n}\nvec4 pack2HalfToRGBA( vec2 v ) {\n\tvec4 r = vec4( v.x, fract( v.x * 255.0 ), v.y, fract( v.y * 255.0 ));\n\treturn vec4( r.x - r.y / 255.0, r.y, r.z - r.w / 255.0, r.w);\n}\nvec2 unpackRGBATo2Half( vec4 v ) {\n\treturn vec2( v.x + ( v.y / 255.0 ), v.z + ( v.w / 255.0 ) );\n}\nfloat viewZToOrthographicDepth( const in float viewZ, const in float near, const in float far ) {\n\treturn ( viewZ + near ) / ( near - far );\n}\nfloat orthographicDepthToViewZ( const in float linearClipZ, const in float near, const in float far ) {\n\treturn linearClipZ * ( near - far ) - near;\n}\nfloat viewZToPerspectiveDepth( const in float viewZ, const in float near, const in float far ) {\n\treturn (( near + viewZ ) * far ) / (( far - near ) * viewZ );\n}\nfloat perspectiveDepthToViewZ( const in float invClipZ, const in float near, const in float far ) {\n\treturn ( near * far ) / ( ( far - near ) * invClipZ - far );\n}',
      qs =
        '#ifdef PREMULTIPLIED_ALPHA\n\tgl_FragColor.rgb *= gl_FragColor.a;\n#endif',
      Ys =
        'vec4 mvPosition = vec4( transformed, 1.0 );\n#ifdef USE_INSTANCING\n\tmvPosition = instanceMatrix * mvPosition;\n#endif\nmvPosition = modelViewMatrix * mvPosition;\ngl_Position = projectionMatrix * mvPosition;',
      Xs =
        '#ifdef DITHERING\n\tgl_FragColor.rgb = dithering( gl_FragColor.rgb );\n#endif',
      Js =
        '#ifdef DITHERING\n\tvec3 dithering( vec3 color ) {\n\t\tfloat grid_position = rand( gl_FragCoord.xy );\n\t\tvec3 dither_shift_RGB = vec3( 0.25 / 255.0, -0.25 / 255.0, 0.25 / 255.0 );\n\t\tdither_shift_RGB = mix( 2.0 * dither_shift_RGB, -2.0 * dither_shift_RGB, grid_position );\n\t\treturn color + dither_shift_RGB;\n\t}\n#endif',
      Zs =
        'float roughnessFactor = roughness;\n#ifdef USE_ROUGHNESSMAP\n\tvec4 texelRoughness = texture2D( roughnessMap, vUv );\n\troughnessFactor *= texelRoughness.g;\n#endif',
      Ks = '#ifdef USE_ROUGHNESSMAP\n\tuniform sampler2D roughnessMap;\n#endif',
      Qs =
        '#ifdef USE_SHADOWMAP\n\t#if NUM_DIR_LIGHT_SHADOWS > 0\n\t\tuniform sampler2D directionalShadowMap[ NUM_DIR_LIGHT_SHADOWS ];\n\t\tvarying vec4 vDirectionalShadowCoord[ NUM_DIR_LIGHT_SHADOWS ];\n\t\tstruct DirectionalLightShadow {\n\t\t\tfloat shadowBias;\n\t\t\tfloat shadowNormalBias;\n\t\t\tfloat shadowRadius;\n\t\t\tvec2 shadowMapSize;\n\t\t};\n\t\tuniform DirectionalLightShadow directionalLightShadows[ NUM_DIR_LIGHT_SHADOWS ];\n\t#endif\n\t#if NUM_SPOT_LIGHT_SHADOWS > 0\n\t\tuniform sampler2D spotShadowMap[ NUM_SPOT_LIGHT_SHADOWS ];\n\t\tvarying vec4 vSpotShadowCoord[ NUM_SPOT_LIGHT_SHADOWS ];\n\t\tstruct SpotLightShadow {\n\t\t\tfloat shadowBias;\n\t\t\tfloat shadowNormalBias;\n\t\t\tfloat shadowRadius;\n\t\t\tvec2 shadowMapSize;\n\t\t};\n\t\tuniform SpotLightShadow spotLightShadows[ NUM_SPOT_LIGHT_SHADOWS ];\n\t#endif\n\t#if NUM_POINT_LIGHT_SHADOWS > 0\n\t\tuniform sampler2D pointShadowMap[ NUM_POINT_LIGHT_SHADOWS ];\n\t\tvarying vec4 vPointShadowCoord[ NUM_POINT_LIGHT_SHADOWS ];\n\t\tstruct PointLightShadow {\n\t\t\tfloat shadowBias;\n\t\t\tfloat shadowNormalBias;\n\t\t\tfloat shadowRadius;\n\t\t\tvec2 shadowMapSize;\n\t\t\tfloat shadowCameraNear;\n\t\t\tfloat shadowCameraFar;\n\t\t};\n\t\tuniform PointLightShadow pointLightShadows[ NUM_POINT_LIGHT_SHADOWS ];\n\t#endif\n\tfloat texture2DCompare( sampler2D depths, vec2 uv, float compare ) {\n\t\treturn step( compare, unpackRGBAToDepth( texture2D( depths, uv ) ) );\n\t}\n\tvec2 texture2DDistribution( sampler2D shadow, vec2 uv ) {\n\t\treturn unpackRGBATo2Half( texture2D( shadow, uv ) );\n\t}\n\tfloat VSMShadow (sampler2D shadow, vec2 uv, float compare ){\n\t\tfloat occlusion = 1.0;\n\t\tvec2 distribution = texture2DDistribution( shadow, uv );\n\t\tfloat hard_shadow = step( compare , distribution.x );\n\t\tif (hard_shadow != 1.0 ) {\n\t\t\tfloat distance = compare - distribution.x ;\n\t\t\tfloat variance = max( 0.00000, distribution.y * distribution.y );\n\t\t\tfloat softness_probability = variance / (variance + distance * distance );\t\t\tsoftness_probability = clamp( ( softness_probability - 0.3 ) / ( 0.95 - 0.3 ), 0.0, 1.0 );\t\t\tocclusion = clamp( max( hard_shadow, softness_probability ), 0.0, 1.0 );\n\t\t}\n\t\treturn occlusion;\n\t}\n\tfloat getShadow( sampler2D shadowMap, vec2 shadowMapSize, float shadowBias, float shadowRadius, vec4 shadowCoord ) {\n\t\tfloat shadow = 1.0;\n\t\tshadowCoord.xyz /= shadowCoord.w;\n\t\tshadowCoord.z += shadowBias;\n\t\tbvec4 inFrustumVec = bvec4 ( shadowCoord.x >= 0.0, shadowCoord.x <= 1.0, shadowCoord.y >= 0.0, shadowCoord.y <= 1.0 );\n\t\tbool inFrustum = all( inFrustumVec );\n\t\tbvec2 frustumTestVec = bvec2( inFrustum, shadowCoord.z <= 1.0 );\n\t\tbool frustumTest = all( frustumTestVec );\n\t\tif ( frustumTest ) {\n\t\t#if defined( SHADOWMAP_TYPE_PCF )\n\t\t\tvec2 texelSize = vec2( 1.0 ) / shadowMapSize;\n\t\t\tfloat dx0 = - texelSize.x * shadowRadius;\n\t\t\tfloat dy0 = - texelSize.y * shadowRadius;\n\t\t\tfloat dx1 = + texelSize.x * shadowRadius;\n\t\t\tfloat dy1 = + texelSize.y * shadowRadius;\n\t\t\tfloat dx2 = dx0 / 2.0;\n\t\t\tfloat dy2 = dy0 / 2.0;\n\t\t\tfloat dx3 = dx1 / 2.0;\n\t\t\tfloat dy3 = dy1 / 2.0;\n\t\t\tshadow = (\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, dy0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, dy0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx2, dy2 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy2 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx3, dy2 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, 0.0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx2, 0.0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy, shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx3, 0.0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, 0.0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx2, dy3 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy3 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx3, dy3 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, dy1 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy1 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, dy1 ), shadowCoord.z )\n\t\t\t) * ( 1.0 / 17.0 );\n\t\t#elif defined( SHADOWMAP_TYPE_PCF_SOFT )\n\t\t\tvec2 texelSize = vec2( 1.0 ) / shadowMapSize;\n\t\t\tfloat dx = texelSize.x;\n\t\t\tfloat dy = texelSize.y;\n\t\t\tvec2 uv = shadowCoord.xy;\n\t\t\tvec2 f = fract( uv * shadowMapSize + 0.5 );\n\t\t\tuv -= f * texelSize;\n\t\t\tshadow = (\n\t\t\t\ttexture2DCompare( shadowMap, uv, shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, uv + vec2( dx, 0.0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, uv + vec2( 0.0, dy ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, uv + texelSize, shadowCoord.z ) +\n\t\t\t\tmix( texture2DCompare( shadowMap, uv + vec2( -dx, 0.0 ), shadowCoord.z ), \n\t\t\t\t\t texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, 0.0 ), shadowCoord.z ),\n\t\t\t\t\t f.x ) +\n\t\t\t\tmix( texture2DCompare( shadowMap, uv + vec2( -dx, dy ), shadowCoord.z ), \n\t\t\t\t\t texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, dy ), shadowCoord.z ),\n\t\t\t\t\t f.x ) +\n\t\t\t\tmix( texture2DCompare( shadowMap, uv + vec2( 0.0, -dy ), shadowCoord.z ), \n\t\t\t\t\t texture2DCompare( shadowMap, uv + vec2( 0.0, 2.0 * dy ), shadowCoord.z ),\n\t\t\t\t\t f.y ) +\n\t\t\t\tmix( texture2DCompare( shadowMap, uv + vec2( dx, -dy ), shadowCoord.z ), \n\t\t\t\t\t texture2DCompare( shadowMap, uv + vec2( dx, 2.0 * dy ), shadowCoord.z ),\n\t\t\t\t\t f.y ) +\n\t\t\t\tmix( mix( texture2DCompare( shadowMap, uv + vec2( -dx, -dy ), shadowCoord.z ), \n\t\t\t\t\t\t  texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, -dy ), shadowCoord.z ),\n\t\t\t\t\t\t  f.x ),\n\t\t\t\t\t mix( texture2DCompare( shadowMap, uv + vec2( -dx, 2.0 * dy ), shadowCoord.z ), \n\t\t\t\t\t\t  texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, 2.0 * dy ), shadowCoord.z ),\n\t\t\t\t\t\t  f.x ),\n\t\t\t\t\t f.y )\n\t\t\t) * ( 1.0 / 9.0 );\n\t\t#elif defined( SHADOWMAP_TYPE_VSM )\n\t\t\tshadow = VSMShadow( shadowMap, shadowCoord.xy, shadowCoord.z );\n\t\t#else\n\t\t\tshadow = texture2DCompare( shadowMap, shadowCoord.xy, shadowCoord.z );\n\t\t#endif\n\t\t}\n\t\treturn shadow;\n\t}\n\tvec2 cubeToUV( vec3 v, float texelSizeY ) {\n\t\tvec3 absV = abs( v );\n\t\tfloat scaleToCube = 1.0 / max( absV.x, max( absV.y, absV.z ) );\n\t\tabsV *= scaleToCube;\n\t\tv *= scaleToCube * ( 1.0 - 2.0 * texelSizeY );\n\t\tvec2 planar = v.xy;\n\t\tfloat almostATexel = 1.5 * texelSizeY;\n\t\tfloat almostOne = 1.0 - almostATexel;\n\t\tif ( absV.z >= almostOne ) {\n\t\t\tif ( v.z > 0.0 )\n\t\t\t\tplanar.x = 4.0 - v.x;\n\t\t} else if ( absV.x >= almostOne ) {\n\t\t\tfloat signX = sign( v.x );\n\t\t\tplanar.x = v.z * signX + 2.0 * signX;\n\t\t} else if ( absV.y >= almostOne ) {\n\t\t\tfloat signY = sign( v.y );\n\t\t\tplanar.x = v.x + 2.0 * signY + 2.0;\n\t\t\tplanar.y = v.z * signY - 2.0;\n\t\t}\n\t\treturn vec2( 0.125, 0.25 ) * planar + vec2( 0.375, 0.75 );\n\t}\n\tfloat getPointShadow( sampler2D shadowMap, vec2 shadowMapSize, float shadowBias, float shadowRadius, vec4 shadowCoord, float shadowCameraNear, float shadowCameraFar ) {\n\t\tvec2 texelSize = vec2( 1.0 ) / ( shadowMapSize * vec2( 4.0, 2.0 ) );\n\t\tvec3 lightToPosition = shadowCoord.xyz;\n\t\tfloat dp = ( length( lightToPosition ) - shadowCameraNear ) / ( shadowCameraFar - shadowCameraNear );\t\tdp += shadowBias;\n\t\tvec3 bd3D = normalize( lightToPosition );\n\t\t#if defined( SHADOWMAP_TYPE_PCF ) || defined( SHADOWMAP_TYPE_PCF_SOFT ) || defined( SHADOWMAP_TYPE_VSM )\n\t\t\tvec2 offset = vec2( - 1, 1 ) * shadowRadius * texelSize.y;\n\t\t\treturn (\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.xyy, texelSize.y ), dp ) +\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.yyy, texelSize.y ), dp ) +\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.xyx, texelSize.y ), dp ) +\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.yyx, texelSize.y ), dp ) +\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D, texelSize.y ), dp ) +\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.xxy, texelSize.y ), dp ) +\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.yxy, texelSize.y ), dp ) +\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.xxx, texelSize.y ), dp ) +\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.yxx, texelSize.y ), dp )\n\t\t\t) * ( 1.0 / 9.0 );\n\t\t#else\n\t\t\treturn texture2DCompare( shadowMap, cubeToUV( bd3D, texelSize.y ), dp );\n\t\t#endif\n\t}\n#endif',
      $s =
        '#ifdef USE_SHADOWMAP\n\t#if NUM_DIR_LIGHT_SHADOWS > 0\n\t\tuniform mat4 directionalShadowMatrix[ NUM_DIR_LIGHT_SHADOWS ];\n\t\tvarying vec4 vDirectionalShadowCoord[ NUM_DIR_LIGHT_SHADOWS ];\n\t\tstruct DirectionalLightShadow {\n\t\t\tfloat shadowBias;\n\t\t\tfloat shadowNormalBias;\n\t\t\tfloat shadowRadius;\n\t\t\tvec2 shadowMapSize;\n\t\t};\n\t\tuniform DirectionalLightShadow directionalLightShadows[ NUM_DIR_LIGHT_SHADOWS ];\n\t#endif\n\t#if NUM_SPOT_LIGHT_SHADOWS > 0\n\t\tuniform mat4 spotShadowMatrix[ NUM_SPOT_LIGHT_SHADOWS ];\n\t\tvarying vec4 vSpotShadowCoord[ NUM_SPOT_LIGHT_SHADOWS ];\n\t\tstruct SpotLightShadow {\n\t\t\tfloat shadowBias;\n\t\t\tfloat shadowNormalBias;\n\t\t\tfloat shadowRadius;\n\t\t\tvec2 shadowMapSize;\n\t\t};\n\t\tuniform SpotLightShadow spotLightShadows[ NUM_SPOT_LIGHT_SHADOWS ];\n\t#endif\n\t#if NUM_POINT_LIGHT_SHADOWS > 0\n\t\tuniform mat4 pointShadowMatrix[ NUM_POINT_LIGHT_SHADOWS ];\n\t\tvarying vec4 vPointShadowCoord[ NUM_POINT_LIGHT_SHADOWS ];\n\t\tstruct PointLightShadow {\n\t\t\tfloat shadowBias;\n\t\t\tfloat shadowNormalBias;\n\t\t\tfloat shadowRadius;\n\t\t\tvec2 shadowMapSize;\n\t\t\tfloat shadowCameraNear;\n\t\t\tfloat shadowCameraFar;\n\t\t};\n\t\tuniform PointLightShadow pointLightShadows[ NUM_POINT_LIGHT_SHADOWS ];\n\t#endif\n#endif',
      eo =
        '#ifdef USE_SHADOWMAP\n\t#if NUM_DIR_LIGHT_SHADOWS > 0 || NUM_SPOT_LIGHT_SHADOWS > 0 || NUM_POINT_LIGHT_SHADOWS > 0\n\t\tvec3 shadowWorldNormal = inverseTransformDirection( transformedNormal, viewMatrix );\n\t\tvec4 shadowWorldPosition;\n\t#endif\n\t#if NUM_DIR_LIGHT_SHADOWS > 0\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_DIR_LIGHT_SHADOWS; i ++ ) {\n\t\tshadowWorldPosition = worldPosition + vec4( shadowWorldNormal * directionalLightShadows[ i ].shadowNormalBias, 0 );\n\t\tvDirectionalShadowCoord[ i ] = directionalShadowMatrix[ i ] * shadowWorldPosition;\n\t}\n\t#pragma unroll_loop_end\n\t#endif\n\t#if NUM_SPOT_LIGHT_SHADOWS > 0\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_SPOT_LIGHT_SHADOWS; i ++ ) {\n\t\tshadowWorldPosition = worldPosition + vec4( shadowWorldNormal * spotLightShadows[ i ].shadowNormalBias, 0 );\n\t\tvSpotShadowCoord[ i ] = spotShadowMatrix[ i ] * shadowWorldPosition;\n\t}\n\t#pragma unroll_loop_end\n\t#endif\n\t#if NUM_POINT_LIGHT_SHADOWS > 0\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_POINT_LIGHT_SHADOWS; i ++ ) {\n\t\tshadowWorldPosition = worldPosition + vec4( shadowWorldNormal * pointLightShadows[ i ].shadowNormalBias, 0 );\n\t\tvPointShadowCoord[ i ] = pointShadowMatrix[ i ] * shadowWorldPosition;\n\t}\n\t#pragma unroll_loop_end\n\t#endif\n#endif',
      to =
        'float getShadowMask() {\n\tfloat shadow = 1.0;\n\t#ifdef USE_SHADOWMAP\n\t#if NUM_DIR_LIGHT_SHADOWS > 0\n\tDirectionalLightShadow directionalLight;\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_DIR_LIGHT_SHADOWS; i ++ ) {\n\t\tdirectionalLight = directionalLightShadows[ i ];\n\t\tshadow *= receiveShadow ? getShadow( directionalShadowMap[ i ], directionalLight.shadowMapSize, directionalLight.shadowBias, directionalLight.shadowRadius, vDirectionalShadowCoord[ i ] ) : 1.0;\n\t}\n\t#pragma unroll_loop_end\n\t#endif\n\t#if NUM_SPOT_LIGHT_SHADOWS > 0\n\tSpotLightShadow spotLight;\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_SPOT_LIGHT_SHADOWS; i ++ ) {\n\t\tspotLight = spotLightShadows[ i ];\n\t\tshadow *= receiveShadow ? getShadow( spotShadowMap[ i ], spotLight.shadowMapSize, spotLight.shadowBias, spotLight.shadowRadius, vSpotShadowCoord[ i ] ) : 1.0;\n\t}\n\t#pragma unroll_loop_end\n\t#endif\n\t#if NUM_POINT_LIGHT_SHADOWS > 0\n\tPointLightShadow pointLight;\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_POINT_LIGHT_SHADOWS; i ++ ) {\n\t\tpointLight = pointLightShadows[ i ];\n\t\tshadow *= receiveShadow ? getPointShadow( pointShadowMap[ i ], pointLight.shadowMapSize, pointLight.shadowBias, pointLight.shadowRadius, vPointShadowCoord[ i ], pointLight.shadowCameraNear, pointLight.shadowCameraFar ) : 1.0;\n\t}\n\t#pragma unroll_loop_end\n\t#endif\n\t#endif\n\treturn shadow;\n}',
      no =
        '#ifdef USE_SKINNING\n\tmat4 boneMatX = getBoneMatrix( skinIndex.x );\n\tmat4 boneMatY = getBoneMatrix( skinIndex.y );\n\tmat4 boneMatZ = getBoneMatrix( skinIndex.z );\n\tmat4 boneMatW = getBoneMatrix( skinIndex.w );\n#endif',
      io =
        '#ifdef USE_SKINNING\n\tuniform mat4 bindMatrix;\n\tuniform mat4 bindMatrixInverse;\n\t#ifdef BONE_TEXTURE\n\t\tuniform highp sampler2D boneTexture;\n\t\tuniform int boneTextureSize;\n\t\tmat4 getBoneMatrix( const in float i ) {\n\t\t\tfloat j = i * 4.0;\n\t\t\tfloat x = mod( j, float( boneTextureSize ) );\n\t\t\tfloat y = floor( j / float( boneTextureSize ) );\n\t\t\tfloat dx = 1.0 / float( boneTextureSize );\n\t\t\tfloat dy = 1.0 / float( boneTextureSize );\n\t\t\ty = dy * ( y + 0.5 );\n\t\t\tvec4 v1 = texture2D( boneTexture, vec2( dx * ( x + 0.5 ), y ) );\n\t\t\tvec4 v2 = texture2D( boneTexture, vec2( dx * ( x + 1.5 ), y ) );\n\t\t\tvec4 v3 = texture2D( boneTexture, vec2( dx * ( x + 2.5 ), y ) );\n\t\t\tvec4 v4 = texture2D( boneTexture, vec2( dx * ( x + 3.5 ), y ) );\n\t\t\tmat4 bone = mat4( v1, v2, v3, v4 );\n\t\t\treturn bone;\n\t\t}\n\t#else\n\t\tuniform mat4 boneMatrices[ MAX_BONES ];\n\t\tmat4 getBoneMatrix( const in float i ) {\n\t\t\tmat4 bone = boneMatrices[ int(i) ];\n\t\t\treturn bone;\n\t\t}\n\t#endif\n#endif',
      ro =
        '#ifdef USE_SKINNING\n\tvec4 skinVertex = bindMatrix * vec4( transformed, 1.0 );\n\tvec4 skinned = vec4( 0.0 );\n\tskinned += boneMatX * skinVertex * skinWeight.x;\n\tskinned += boneMatY * skinVertex * skinWeight.y;\n\tskinned += boneMatZ * skinVertex * skinWeight.z;\n\tskinned += boneMatW * skinVertex * skinWeight.w;\n\ttransformed = ( bindMatrixInverse * skinned ).xyz;\n#endif',
      ao =
        '#ifdef USE_SKINNING\n\tmat4 skinMatrix = mat4( 0.0 );\n\tskinMatrix += skinWeight.x * boneMatX;\n\tskinMatrix += skinWeight.y * boneMatY;\n\tskinMatrix += skinWeight.z * boneMatZ;\n\tskinMatrix += skinWeight.w * boneMatW;\n\tskinMatrix = bindMatrixInverse * skinMatrix * bindMatrix;\n\tobjectNormal = vec4( skinMatrix * vec4( objectNormal, 0.0 ) ).xyz;\n\t#ifdef USE_TANGENT\n\t\tobjectTangent = vec4( skinMatrix * vec4( objectTangent, 0.0 ) ).xyz;\n\t#endif\n#endif',
      so =
        'float specularStrength;\n#ifdef USE_SPECULARMAP\n\tvec4 texelSpecular = texture2D( specularMap, vUv );\n\tspecularStrength = texelSpecular.r;\n#else\n\tspecularStrength = 1.0;\n#endif',
      oo = '#ifdef USE_SPECULARMAP\n\tuniform sampler2D specularMap;\n#endif',
      lo =
        '#if defined( TONE_MAPPING )\n\tgl_FragColor.rgb = toneMapping( gl_FragColor.rgb );\n#endif',
      co =
        '#ifndef saturate\n#define saturate(a) clamp( a, 0.0, 1.0 )\n#endif\nuniform float toneMappingExposure;\nvec3 LinearToneMapping( vec3 color ) {\n\treturn toneMappingExposure * color;\n}\nvec3 ReinhardToneMapping( vec3 color ) {\n\tcolor *= toneMappingExposure;\n\treturn saturate( color / ( vec3( 1.0 ) + color ) );\n}\nvec3 OptimizedCineonToneMapping( vec3 color ) {\n\tcolor *= toneMappingExposure;\n\tcolor = max( vec3( 0.0 ), color - 0.004 );\n\treturn pow( ( color * ( 6.2 * color + 0.5 ) ) / ( color * ( 6.2 * color + 1.7 ) + 0.06 ), vec3( 2.2 ) );\n}\nvec3 RRTAndODTFit( vec3 v ) {\n\tvec3 a = v * ( v + 0.0245786 ) - 0.000090537;\n\tvec3 b = v * ( 0.983729 * v + 0.4329510 ) + 0.238081;\n\treturn a / b;\n}\nvec3 ACESFilmicToneMapping( vec3 color ) {\n\tconst mat3 ACESInputMat = mat3(\n\t\tvec3( 0.59719, 0.07600, 0.02840 ),\t\tvec3( 0.35458, 0.90834, 0.13383 ),\n\t\tvec3( 0.04823, 0.01566, 0.83777 )\n\t);\n\tconst mat3 ACESOutputMat = mat3(\n\t\tvec3(  1.60475, -0.10208, -0.00327 ),\t\tvec3( -0.53108,  1.10813, -0.07276 ),\n\t\tvec3( -0.07367, -0.00605,  1.07602 )\n\t);\n\tcolor *= toneMappingExposure / 0.6;\n\tcolor = ACESInputMat * color;\n\tcolor = RRTAndODTFit( color );\n\tcolor = ACESOutputMat * color;\n\treturn saturate( color );\n}\nvec3 CustomToneMapping( vec3 color ) { return color; }',
      ho =
        '#ifdef USE_TRANSMISSION\n\tfloat transmissionFactor = transmission;\n\tfloat thicknessFactor = thickness;\n\t#ifdef USE_TRANSMISSIONMAP\n\t\ttransmissionFactor *= texture2D( transmissionMap, vUv ).r;\n\t#endif\n\t#ifdef USE_THICKNESSNMAP\n\t\tthicknessFactor *= texture2D( thicknessMap, vUv ).g;\n\t#endif\n\tvec3 pos = vWorldPosition.xyz / vWorldPosition.w;\n\tvec3 v = normalize( cameraPosition - pos );\n\tfloat ior = ( 1.0 + 0.4 * reflectivity ) / ( 1.0 - 0.4 * reflectivity );\n\tvec3 transmission = transmissionFactor * getIBLVolumeRefraction(\n\t\tnormal, v, roughnessFactor, material.diffuseColor, totalSpecular,\n\t\tpos, modelMatrix, viewMatrix, projectionMatrix, ior, thicknessFactor,\n\t\tattenuationColor, attenuationDistance );\n\ttotalDiffuse = mix( totalDiffuse, transmission, transmissionFactor );\n#endif',
      uo =
        '#ifdef USE_TRANSMISSION\n\t#ifdef USE_TRANSMISSIONMAP\n\t\tuniform sampler2D transmissionMap;\n\t#endif\n\t#ifdef USE_THICKNESSMAP\n\t\tuniform sampler2D thicknessMap;\n\t#endif\n\tuniform vec2 transmissionSamplerSize;\n\tuniform sampler2D transmissionSamplerMap;\n\tuniform mat4 modelMatrix;\n\tuniform mat4 projectionMatrix;\n\tvarying vec4 vWorldPosition;\n\tvec3 getVolumeTransmissionRay(vec3 n, vec3 v, float thickness, float ior, mat4 modelMatrix) {\n\t\tvec3 refractionVector = refract(-v, normalize(n), 1.0 / ior);\n\t\tvec3 modelScale;\n\t\tmodelScale.x = length(vec3(modelMatrix[0].xyz));\n\t\tmodelScale.y = length(vec3(modelMatrix[1].xyz));\n\t\tmodelScale.z = length(vec3(modelMatrix[2].xyz));\n\t\treturn normalize(refractionVector) * thickness * modelScale;\n\t}\n\tfloat applyIorToRoughness(float roughness, float ior) {\n\t\treturn roughness * clamp(ior * 2.0 - 2.0, 0.0, 1.0);\n\t}\n\tvec3 getTransmissionSample(vec2 fragCoord, float roughness, float ior) {\n\t\tfloat framebufferLod = log2(transmissionSamplerSize.x) * applyIorToRoughness(roughness, ior);\n\t\treturn texture2DLodEXT(transmissionSamplerMap, fragCoord.xy, framebufferLod).rgb;\n\t}\n\tvec3 applyVolumeAttenuation(vec3 radiance, float transmissionDistance, vec3 attenuationColor, float attenuationDistance) {\n\t\tif (attenuationDistance == 0.0) {\n\t\t\treturn radiance;\n\t\t} else {\n\t\t\tvec3 attenuationCoefficient = -log(attenuationColor) / attenuationDistance;\n\t\t\tvec3 transmittance = exp(-attenuationCoefficient * transmissionDistance);\t\t\treturn transmittance * radiance;\n\t\t}\n\t}\n\tvec3 getIBLVolumeRefraction(vec3 n, vec3 v, float perceptualRoughness, vec3 baseColor, vec3 specularColor,\n\t\tvec3 position, mat4 modelMatrix, mat4 viewMatrix, mat4 projMatrix, float ior, float thickness,\n\t\tvec3 attenuationColor, float attenuationDistance) {\n\t\tvec3 transmissionRay = getVolumeTransmissionRay(n, v, thickness, ior, modelMatrix);\n\t\tvec3 refractedRayExit = position + transmissionRay;\n\t\tvec4 ndcPos = projMatrix * viewMatrix * vec4(refractedRayExit, 1.0);\n\t\tvec2 refractionCoords = ndcPos.xy / ndcPos.w;\n\t\trefractionCoords += 1.0;\n\t\trefractionCoords /= 2.0;\n\t\tvec3 transmittedLight = getTransmissionSample(refractionCoords, perceptualRoughness, ior);\n\t\tvec3 attenuatedColor = applyVolumeAttenuation(transmittedLight, length(transmissionRay), attenuationColor, attenuationDistance);\n\t\treturn (1.0 - specularColor) * attenuatedColor * baseColor;\n\t}\n#endif',
      po =
        '#if ( defined( USE_UV ) && ! defined( UVS_VERTEX_ONLY ) )\n\tvarying vec2 vUv;\n#endif',
      fo =
        '#ifdef USE_UV\n\t#ifdef UVS_VERTEX_ONLY\n\t\tvec2 vUv;\n\t#else\n\t\tvarying vec2 vUv;\n\t#endif\n\tuniform mat3 uvTransform;\n#endif',
      mo = '#ifdef USE_UV\n\tvUv = ( uvTransform * vec3( uv, 1 ) ).xy;\n#endif',
      go =
        '#if defined( USE_LIGHTMAP ) || defined( USE_AOMAP )\n\tvarying vec2 vUv2;\n#endif',
      vo =
        '#if defined( USE_LIGHTMAP ) || defined( USE_AOMAP )\n\tattribute vec2 uv2;\n\tvarying vec2 vUv2;\n\tuniform mat3 uv2Transform;\n#endif',
      yo =
        '#if defined( USE_LIGHTMAP ) || defined( USE_AOMAP )\n\tvUv2 = ( uv2Transform * vec3( uv2, 1 ) ).xy;\n#endif',
      _o =
        '#if defined( USE_ENVMAP ) || defined( DISTANCE ) || defined ( USE_SHADOWMAP ) || defined ( USE_TRANSMISSION )\n\tvec4 worldPosition = vec4( transformed, 1.0 );\n\t#ifdef USE_INSTANCING\n\t\tworldPosition = instanceMatrix * worldPosition;\n\t#endif\n\tworldPosition = modelMatrix * worldPosition;\n#endif',
      xo =
        'uniform sampler2D t2D;\nvarying vec2 vUv;\nvoid main() {\n\tvec4 texColor = texture2D( t2D, vUv );\n\tgl_FragColor = mapTexelToLinear( texColor );\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n}',
      wo =
        'varying vec2 vUv;\nuniform mat3 uvTransform;\nvoid main() {\n\tvUv = ( uvTransform * vec3( uv, 1 ) ).xy;\n\tgl_Position = vec4( position.xy, 1.0, 1.0 );\n}',
      bo =
        '#include <envmap_common_pars_fragment>\nuniform float opacity;\nvarying vec3 vWorldDirection;\n#include <cube_uv_reflection_fragment>\nvoid main() {\n\tvec3 vReflect = vWorldDirection;\n\t#include <envmap_fragment>\n\tgl_FragColor = envColor;\n\tgl_FragColor.a *= opacity;\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n}',
      Mo =
        'varying vec3 vWorldDirection;\n#include <common>\nvoid main() {\n\tvWorldDirection = transformDirection( position, modelMatrix );\n\t#include <begin_vertex>\n\t#include <project_vertex>\n\tgl_Position.z = gl_Position.w;\n}',
      So =
        '#if DEPTH_PACKING == 3200\n\tuniform float opacity;\n#endif\n#include <common>\n#include <packing>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvarying vec2 vHighPrecisionZW;\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec4 diffuseColor = vec4( 1.0 );\n\t#if DEPTH_PACKING == 3200\n\t\tdiffuseColor.a = opacity;\n\t#endif\n\t#include <map_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <logdepthbuf_fragment>\n\tfloat fragCoordZ = 0.5 * vHighPrecisionZW[0] / vHighPrecisionZW[1] + 0.5;\n\t#if DEPTH_PACKING == 3200\n\t\tgl_FragColor = vec4( vec3( 1.0 - fragCoordZ ), opacity );\n\t#elif DEPTH_PACKING == 3201\n\t\tgl_FragColor = packDepthToRGBA( fragCoordZ );\n\t#endif\n}',
      Eo =
        '#include <common>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvarying vec2 vHighPrecisionZW;\nvoid main() {\n\t#include <uv_vertex>\n\t#include <skinbase_vertex>\n\t#ifdef USE_DISPLACEMENTMAP\n\t\t#include <beginnormal_vertex>\n\t\t#include <morphnormal_vertex>\n\t\t#include <skinnormal_vertex>\n\t#endif\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\tvHighPrecisionZW = gl_Position.zw;\n}',
      To =
        '#define DISTANCE\nuniform vec3 referencePosition;\nuniform float nearDistance;\nuniform float farDistance;\nvarying vec3 vWorldPosition;\n#include <common>\n#include <packing>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main () {\n\t#include <clipping_planes_fragment>\n\tvec4 diffuseColor = vec4( 1.0 );\n\t#include <map_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\tfloat dist = length( vWorldPosition - referencePosition );\n\tdist = ( dist - nearDistance ) / ( farDistance - nearDistance );\n\tdist = saturate( dist );\n\tgl_FragColor = packDepthToRGBA( dist );\n}',
      Ao =
        '#define DISTANCE\nvarying vec3 vWorldPosition;\n#include <common>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <skinbase_vertex>\n\t#ifdef USE_DISPLACEMENTMAP\n\t\t#include <beginnormal_vertex>\n\t\t#include <morphnormal_vertex>\n\t\t#include <skinnormal_vertex>\n\t#endif\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <worldpos_vertex>\n\t#include <clipping_planes_vertex>\n\tvWorldPosition = worldPosition.xyz;\n}',
      Ro =
        'uniform sampler2D tEquirect;\nvarying vec3 vWorldDirection;\n#include <common>\nvoid main() {\n\tvec3 direction = normalize( vWorldDirection );\n\tvec2 sampleUV = equirectUv( direction );\n\tvec4 texColor = texture2D( tEquirect, sampleUV );\n\tgl_FragColor = mapTexelToLinear( texColor );\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n}',
      Lo =
        'varying vec3 vWorldDirection;\n#include <common>\nvoid main() {\n\tvWorldDirection = transformDirection( position, modelMatrix );\n\t#include <begin_vertex>\n\t#include <project_vertex>\n}',
      Co =
        'uniform vec3 diffuse;\nuniform float opacity;\nuniform float dashSize;\nuniform float totalSize;\nvarying float vLineDistance;\n#include <common>\n#include <color_pars_fragment>\n#include <fog_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tif ( mod( vLineDistance, totalSize ) > dashSize ) {\n\t\tdiscard;\n\t}\n\tvec3 outgoingLight = vec3( 0.0 );\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <logdepthbuf_fragment>\n\t#include <color_fragment>\n\toutgoingLight = diffuseColor.rgb;\n\tgl_FragColor = vec4( outgoingLight, diffuseColor.a );\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n}',
      Po =
        'uniform float scale;\nattribute float lineDistance;\nvarying float vLineDistance;\n#include <common>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\tvLineDistance = scale * lineDistance;\n\t#include <color_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <fog_vertex>\n}',
      Do =
        'uniform vec3 diffuse;\nuniform float opacity;\n#ifndef FLAT_SHADED\n\tvarying vec3 vNormal;\n#endif\n#include <common>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <uv2_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_pars_fragment>\n#include <cube_uv_reflection_fragment>\n#include <fog_pars_fragment>\n#include <specularmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <specularmap_fragment>\n\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n\t#ifdef USE_LIGHTMAP\n\t\n\t\tvec4 lightMapTexel= texture2D( lightMap, vUv2 );\n\t\treflectedLight.indirectDiffuse += lightMapTexelToLinear( lightMapTexel ).rgb * lightMapIntensity;\n\t#else\n\t\treflectedLight.indirectDiffuse += vec3( 1.0 );\n\t#endif\n\t#include <aomap_fragment>\n\treflectedLight.indirectDiffuse *= diffuseColor.rgb;\n\tvec3 outgoingLight = reflectedLight.indirectDiffuse;\n\t#include <envmap_fragment>\n\tgl_FragColor = vec4( outgoingLight, diffuseColor.a );\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}',
      Io =
        '#include <common>\n#include <uv_pars_vertex>\n#include <uv2_pars_vertex>\n#include <envmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <uv2_vertex>\n\t#include <color_vertex>\n\t#include <skinbase_vertex>\n\t#ifdef USE_ENVMAP\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#endif\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <worldpos_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <envmap_vertex>\n\t#include <fog_vertex>\n}',
      No =
        'uniform vec3 diffuse;\nuniform vec3 emissive;\nuniform float opacity;\nvarying vec3 vLightFront;\nvarying vec3 vIndirectFront;\n#ifdef DOUBLE_SIDED\n\tvarying vec3 vLightBack;\n\tvarying vec3 vIndirectBack;\n#endif\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <uv2_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_pars_fragment>\n#include <cube_uv_reflection_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <fog_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <shadowmask_pars_fragment>\n#include <specularmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n\tvec3 totalEmissiveRadiance = emissive;\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <specularmap_fragment>\n\t#include <emissivemap_fragment>\n\t#ifdef DOUBLE_SIDED\n\t\treflectedLight.indirectDiffuse += ( gl_FrontFacing ) ? vIndirectFront : vIndirectBack;\n\t#else\n\t\treflectedLight.indirectDiffuse += vIndirectFront;\n\t#endif\n\t#include <lightmap_fragment>\n\treflectedLight.indirectDiffuse *= BRDF_Diffuse_Lambert( diffuseColor.rgb );\n\t#ifdef DOUBLE_SIDED\n\t\treflectedLight.directDiffuse = ( gl_FrontFacing ) ? vLightFront : vLightBack;\n\t#else\n\t\treflectedLight.directDiffuse = vLightFront;\n\t#endif\n\treflectedLight.directDiffuse *= BRDF_Diffuse_Lambert( diffuseColor.rgb ) * getShadowMask();\n\t#include <aomap_fragment>\n\tvec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + totalEmissiveRadiance;\n\t#include <envmap_fragment>\n\tgl_FragColor = vec4( outgoingLight, diffuseColor.a );\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}',
      Oo =
        '#define LAMBERT\nvarying vec3 vLightFront;\nvarying vec3 vIndirectFront;\n#ifdef DOUBLE_SIDED\n\tvarying vec3 vLightBack;\n\tvarying vec3 vIndirectBack;\n#endif\n#include <common>\n#include <uv_pars_vertex>\n#include <uv2_pars_vertex>\n#include <envmap_pars_vertex>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <uv2_vertex>\n\t#include <color_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <worldpos_vertex>\n\t#include <envmap_vertex>\n\t#include <lights_lambert_vertex>\n\t#include <shadowmap_vertex>\n\t#include <fog_vertex>\n}',
      Fo =
        '#define MATCAP\nuniform vec3 diffuse;\nuniform float opacity;\nuniform sampler2D matcap;\nvarying vec3 vViewPosition;\n#ifndef FLAT_SHADED\n\tvarying vec3 vNormal;\n#endif\n#include <common>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <fog_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <normal_fragment_begin>\n\t#include <normal_fragment_maps>\n\tvec3 viewDir = normalize( vViewPosition );\n\tvec3 x = normalize( vec3( viewDir.z, 0.0, - viewDir.x ) );\n\tvec3 y = cross( viewDir, x );\n\tvec2 uv = vec2( dot( x, normal ), dot( y, normal ) ) * 0.495 + 0.5;\n\t#ifdef USE_MATCAP\n\t\tvec4 matcapColor = texture2D( matcap, uv );\n\t\tmatcapColor = matcapTexelToLinear( matcapColor );\n\t#else\n\t\tvec4 matcapColor = vec4( 1.0 );\n\t#endif\n\tvec3 outgoingLight = diffuseColor.rgb * matcapColor.rgb;\n\tgl_FragColor = vec4( outgoingLight, diffuseColor.a );\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}',
      Bo =
        '#define MATCAP\nvarying vec3 vViewPosition;\n#ifndef FLAT_SHADED\n\tvarying vec3 vNormal;\n#endif\n#include <common>\n#include <uv_pars_vertex>\n#include <color_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <color_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#ifndef FLAT_SHADED\n\t\tvNormal = normalize( transformedNormal );\n\t#endif\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <fog_vertex>\n\tvViewPosition = - mvPosition.xyz;\n}',
      zo =
        '#define TOON\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform float opacity;\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <uv2_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <gradientmap_pars_fragment>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <lights_toon_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n\tvec3 totalEmissiveRadiance = emissive;\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <normal_fragment_begin>\n\t#include <normal_fragment_maps>\n\t#include <emissivemap_fragment>\n\t#include <lights_toon_fragment>\n\t#include <lights_fragment_begin>\n\t#include <lights_fragment_maps>\n\t#include <lights_fragment_end>\n\t#include <aomap_fragment>\n\tvec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + totalEmissiveRadiance;\n\tgl_FragColor = vec4( outgoingLight, diffuseColor.a );\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}',
      Uo =
        '#define TOON\nvarying vec3 vViewPosition;\n#ifndef FLAT_SHADED\n\tvarying vec3 vNormal;\n#endif\n#include <common>\n#include <uv_pars_vertex>\n#include <uv2_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <uv2_vertex>\n\t#include <color_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n#ifndef FLAT_SHADED\n\tvNormal = normalize( transformedNormal );\n#endif\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\tvViewPosition = - mvPosition.xyz;\n\t#include <worldpos_vertex>\n\t#include <shadowmap_vertex>\n\t#include <fog_vertex>\n}',
      ko =
        '#define PHONG\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform vec3 specular;\nuniform float shininess;\nuniform float opacity;\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <uv2_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_pars_fragment>\n#include <cube_uv_reflection_fragment>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <lights_phong_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <specularmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n\tvec3 totalEmissiveRadiance = emissive;\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <specularmap_fragment>\n\t#include <normal_fragment_begin>\n\t#include <normal_fragment_maps>\n\t#include <emissivemap_fragment>\n\t#include <lights_phong_fragment>\n\t#include <lights_fragment_begin>\n\t#include <lights_fragment_maps>\n\t#include <lights_fragment_end>\n\t#include <aomap_fragment>\n\tvec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + reflectedLight.directSpecular + reflectedLight.indirectSpecular + totalEmissiveRadiance;\n\t#include <envmap_fragment>\n\tgl_FragColor = vec4( outgoingLight, diffuseColor.a );\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}',
      Ho =
        '#define PHONG\nvarying vec3 vViewPosition;\n#ifndef FLAT_SHADED\n\tvarying vec3 vNormal;\n#endif\n#include <common>\n#include <uv_pars_vertex>\n#include <uv2_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <envmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <uv2_vertex>\n\t#include <color_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n#ifndef FLAT_SHADED\n\tvNormal = normalize( transformedNormal );\n#endif\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\tvViewPosition = - mvPosition.xyz;\n\t#include <worldpos_vertex>\n\t#include <envmap_vertex>\n\t#include <shadowmap_vertex>\n\t#include <fog_vertex>\n}',
      Wo =
        '#define STANDARD\n#ifdef PHYSICAL\n\t#define REFLECTIVITY\n\t#define CLEARCOAT\n#endif\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform float roughness;\nuniform float metalness;\nuniform float opacity;\n#ifdef USE_TRANSMISSION\n\tuniform float transmission;\n\tuniform float thickness;\n\tuniform vec3 attenuationColor;\n\tuniform float attenuationDistance;\n#endif\n#ifdef REFLECTIVITY\n\tuniform float reflectivity;\n#endif\n#ifdef CLEARCOAT\n\tuniform float clearcoat;\n\tuniform float clearcoatRoughness;\n#endif\n#ifdef USE_SHEEN\n\tuniform vec3 sheen;\n#endif\nvarying vec3 vViewPosition;\n#ifndef FLAT_SHADED\n\tvarying vec3 vNormal;\n\t#ifdef USE_TANGENT\n\t\tvarying vec3 vTangent;\n\t\tvarying vec3 vBitangent;\n\t#endif\n#endif\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <uv2_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <bsdfs>\n#include <transmission_pars_fragment>\n#include <cube_uv_reflection_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_physical_pars_fragment>\n#include <fog_pars_fragment>\n#include <lights_pars_begin>\n#include <lights_physical_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <clearcoat_pars_fragment>\n#include <roughnessmap_pars_fragment>\n#include <metalnessmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n\tvec3 totalEmissiveRadiance = emissive;\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <roughnessmap_fragment>\n\t#include <metalnessmap_fragment>\n\t#include <normal_fragment_begin>\n\t#include <normal_fragment_maps>\n\t#include <clearcoat_normal_fragment_begin>\n\t#include <clearcoat_normal_fragment_maps>\n\t#include <emissivemap_fragment>\n\t#include <lights_physical_fragment>\n\t#include <lights_fragment_begin>\n\t#include <lights_fragment_maps>\n\t#include <lights_fragment_end>\n\t#include <aomap_fragment>\n\tvec3 totalDiffuse = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse;\n\tvec3 totalSpecular = reflectedLight.directSpecular + reflectedLight.indirectSpecular;\n\t#include <transmission_fragment>\n\tvec3 outgoingLight = totalDiffuse + totalSpecular + totalEmissiveRadiance;\n\tgl_FragColor = vec4( outgoingLight, diffuseColor.a );\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}',
      Vo =
        '#define STANDARD\nvarying vec3 vViewPosition;\n#ifndef FLAT_SHADED\n\tvarying vec3 vNormal;\n\t#ifdef USE_TANGENT\n\t\tvarying vec3 vTangent;\n\t\tvarying vec3 vBitangent;\n\t#endif\n#endif\n#ifdef USE_TRANSMISSION\n\tvarying vec4 vWorldPosition;\n#endif\n#include <common>\n#include <uv_pars_vertex>\n#include <uv2_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <uv2_vertex>\n\t#include <color_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n#ifndef FLAT_SHADED\n\tvNormal = normalize( transformedNormal );\n\t#ifdef USE_TANGENT\n\t\tvTangent = normalize( transformedTangent );\n\t\tvBitangent = normalize( cross( vNormal, vTangent ) * tangent.w );\n\t#endif\n#endif\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\tvViewPosition = - mvPosition.xyz;\n\t#include <worldpos_vertex>\n\t#include <shadowmap_vertex>\n\t#include <fog_vertex>\n#ifdef USE_TRANSMISSION\n\tvWorldPosition = worldPosition;\n#endif\n}',
      Go =
        '#define NORMAL\nuniform float opacity;\n#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( TANGENTSPACE_NORMALMAP )\n\tvarying vec3 vViewPosition;\n#endif\n#ifndef FLAT_SHADED\n\tvarying vec3 vNormal;\n\t#ifdef USE_TANGENT\n\t\tvarying vec3 vTangent;\n\t\tvarying vec3 vBitangent;\n\t#endif\n#endif\n#include <packing>\n#include <uv_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\t#include <logdepthbuf_fragment>\n\t#include <normal_fragment_begin>\n\t#include <normal_fragment_maps>\n\tgl_FragColor = vec4( packNormalToRGB( normal ), opacity );\n}',
      jo =
        '#define NORMAL\n#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( TANGENTSPACE_NORMALMAP )\n\tvarying vec3 vViewPosition;\n#endif\n#ifndef FLAT_SHADED\n\tvarying vec3 vNormal;\n\t#ifdef USE_TANGENT\n\t\tvarying vec3 vTangent;\n\t\tvarying vec3 vBitangent;\n\t#endif\n#endif\n#include <common>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n#ifndef FLAT_SHADED\n\tvNormal = normalize( transformedNormal );\n\t#ifdef USE_TANGENT\n\t\tvTangent = normalize( transformedTangent );\n\t\tvBitangent = normalize( cross( vNormal, vTangent ) * tangent.w );\n\t#endif\n#endif\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( TANGENTSPACE_NORMALMAP )\n\tvViewPosition = - mvPosition.xyz;\n#endif\n}',
      qo =
        'uniform vec3 diffuse;\nuniform float opacity;\n#include <common>\n#include <color_pars_fragment>\n#include <map_particle_pars_fragment>\n#include <fog_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec3 outgoingLight = vec3( 0.0 );\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <logdepthbuf_fragment>\n\t#include <map_particle_fragment>\n\t#include <color_fragment>\n\t#include <alphatest_fragment>\n\toutgoingLight = diffuseColor.rgb;\n\tgl_FragColor = vec4( outgoingLight, diffuseColor.a );\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n}',
      Yo =
        'uniform float size;\nuniform float scale;\n#include <common>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <color_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <project_vertex>\n\tgl_PointSize = size;\n\t#ifdef USE_SIZEATTENUATION\n\t\tbool isPerspective = isPerspectiveMatrix( projectionMatrix );\n\t\tif ( isPerspective ) gl_PointSize *= ( scale / - mvPosition.z );\n\t#endif\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <worldpos_vertex>\n\t#include <fog_vertex>\n}',
      Xo =
        'uniform vec3 color;\nuniform float opacity;\n#include <common>\n#include <packing>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <shadowmap_pars_fragment>\n#include <shadowmask_pars_fragment>\nvoid main() {\n\tgl_FragColor = vec4( color, opacity * ( 1.0 - getShadowMask() ) );\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n\t#include <fog_fragment>\n}',
      Jo =
        '#include <common>\n#include <fog_pars_vertex>\n#include <shadowmap_pars_vertex>\nvoid main() {\n\t#include <begin_vertex>\n\t#include <project_vertex>\n\t#include <worldpos_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <shadowmap_vertex>\n\t#include <fog_vertex>\n}',
      Zo =
        'uniform vec3 diffuse;\nuniform float opacity;\n#include <common>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <fog_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec3 outgoingLight = vec3( 0.0 );\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\toutgoingLight = diffuseColor.rgb;\n\tgl_FragColor = vec4( outgoingLight, diffuseColor.a );\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n\t#include <fog_fragment>\n}',
      Ko =
        'uniform float rotation;\nuniform vec2 center;\n#include <common>\n#include <uv_pars_vertex>\n#include <fog_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\tvec4 mvPosition = modelViewMatrix * vec4( 0.0, 0.0, 0.0, 1.0 );\n\tvec2 scale;\n\tscale.x = length( vec3( modelMatrix[ 0 ].x, modelMatrix[ 0 ].y, modelMatrix[ 0 ].z ) );\n\tscale.y = length( vec3( modelMatrix[ 1 ].x, modelMatrix[ 1 ].y, modelMatrix[ 1 ].z ) );\n\t#ifndef USE_SIZEATTENUATION\n\t\tbool isPerspective = isPerspectiveMatrix( projectionMatrix );\n\t\tif ( isPerspective ) scale *= - mvPosition.z;\n\t#endif\n\tvec2 alignedPosition = ( position.xy - ( center - vec2( 0.5 ) ) ) * scale;\n\tvec2 rotatedPosition;\n\trotatedPosition.x = cos( rotation ) * alignedPosition.x - sin( rotation ) * alignedPosition.y;\n\trotatedPosition.y = sin( rotation ) * alignedPosition.x + cos( rotation ) * alignedPosition.y;\n\tmvPosition.xy += rotatedPosition;\n\tgl_Position = projectionMatrix * mvPosition;\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <fog_vertex>\n}'
    const Qo = {
        alphamap_fragment: Ca,
        alphamap_pars_fragment: Pa,
        alphatest_fragment: Da,
        aomap_fragment: Ia,
        aomap_pars_fragment: Na,
        begin_vertex: Oa,
        beginnormal_vertex: Fa,
        bsdfs: Ba,
        bumpmap_pars_fragment: za,
        clipping_planes_fragment: Ua,
        clipping_planes_pars_fragment: ka,
        clipping_planes_pars_vertex: Ha,
        clipping_planes_vertex: Wa,
        color_fragment: Va,
        color_pars_fragment: Ga,
        color_pars_vertex: ja,
        color_vertex: qa,
        common: Ya,
        cube_uv_reflection_fragment: Xa,
        defaultnormal_vertex: Ja,
        displacementmap_pars_vertex: Za,
        displacementmap_vertex: Ka,
        emissivemap_fragment: Qa,
        emissivemap_pars_fragment: $a,
        encodings_fragment: es,
        encodings_pars_fragment: ts,
        envmap_fragment: ns,
        envmap_common_pars_fragment: is,
        envmap_pars_fragment: rs,
        envmap_pars_vertex: as,
        envmap_physical_pars_fragment: gs,
        envmap_vertex: ss,
        fog_vertex: os,
        fog_pars_vertex: ls,
        fog_fragment: cs,
        fog_pars_fragment: hs,
        gradientmap_pars_fragment: us,
        lightmap_fragment: ds,
        lightmap_pars_fragment: ps,
        lights_lambert_vertex: fs,
        lights_pars_begin: ms,
        lights_toon_fragment: vs,
        lights_toon_pars_fragment: ys,
        lights_phong_fragment: _s,
        lights_phong_pars_fragment: xs,
        lights_physical_fragment: ws,
        lights_physical_pars_fragment: bs,
        lights_fragment_begin: Ms,
        lights_fragment_maps: Ss,
        lights_fragment_end: Es,
        logdepthbuf_fragment: Ts,
        logdepthbuf_pars_fragment: As,
        logdepthbuf_pars_vertex: Rs,
        logdepthbuf_vertex: Ls,
        map_fragment: Cs,
        map_pars_fragment: Ps,
        map_particle_fragment: Ds,
        map_particle_pars_fragment: Is,
        metalnessmap_fragment: Ns,
        metalnessmap_pars_fragment: Os,
        morphnormal_vertex: Fs,
        morphtarget_pars_vertex: Bs,
        morphtarget_vertex: zs,
        normal_fragment_begin: Us,
        normal_fragment_maps: ks,
        normalmap_pars_fragment: Hs,
        clearcoat_normal_fragment_begin: Ws,
        clearcoat_normal_fragment_maps: Vs,
        clearcoat_pars_fragment: Gs,
        packing: js,
        premultiplied_alpha_fragment: qs,
        project_vertex: Ys,
        dithering_fragment: Xs,
        dithering_pars_fragment: Js,
        roughnessmap_fragment: Zs,
        roughnessmap_pars_fragment: Ks,
        shadowmap_pars_fragment: Qs,
        shadowmap_pars_vertex: $s,
        shadowmap_vertex: eo,
        shadowmask_pars_fragment: to,
        skinbase_vertex: no,
        skinning_pars_vertex: io,
        skinning_vertex: ro,
        skinnormal_vertex: ao,
        specularmap_fragment: so,
        specularmap_pars_fragment: oo,
        tonemapping_fragment: lo,
        tonemapping_pars_fragment: co,
        transmission_fragment: ho,
        transmission_pars_fragment: uo,
        uv_pars_fragment: po,
        uv_pars_vertex: fo,
        uv_vertex: mo,
        uv2_pars_fragment: go,
        uv2_pars_vertex: vo,
        uv2_vertex: yo,
        worldpos_vertex: _o,
        background_frag: xo,
        background_vert: wo,
        cube_frag: bo,
        cube_vert: Mo,
        depth_frag: So,
        depth_vert: Eo,
        distanceRGBA_frag: To,
        distanceRGBA_vert: Ao,
        equirect_frag: Ro,
        equirect_vert: Lo,
        linedashed_frag: Co,
        linedashed_vert: Po,
        meshbasic_frag: Do,
        meshbasic_vert: Io,
        meshlambert_frag: No,
        meshlambert_vert: Oo,
        meshmatcap_frag: Fo,
        meshmatcap_vert: Bo,
        meshtoon_frag: zo,
        meshtoon_vert: Uo,
        meshphong_frag: ko,
        meshphong_vert: Ho,
        meshphysical_frag: Wo,
        meshphysical_vert: Vo,
        normal_frag: Go,
        normal_vert: jo,
        points_frag: qo,
        points_vert: Yo,
        shadow_frag: Xo,
        shadow_vert: Jo,
        sprite_frag: Zo,
        sprite_vert: Ko
      },
      $o = {
        common: {
          diffuse: { value: new xr(16777215) },
          opacity: { value: 1 },
          map: { value: null },
          uvTransform: { value: new Hn() },
          uv2Transform: { value: new Hn() },
          alphaMap: { value: null }
        },
        specularmap: { specularMap: { value: null } },
        envmap: {
          envMap: { value: null },
          flipEnvMap: { value: -1 },
          reflectivity: { value: 1 },
          refractionRatio: { value: 0.98 },
          maxMipLevel: { value: 0 }
        },
        aomap: { aoMap: { value: null }, aoMapIntensity: { value: 1 } },
        lightmap: {
          lightMap: { value: null },
          lightMapIntensity: { value: 1 }
        },
        emissivemap: { emissiveMap: { value: null } },
        bumpmap: { bumpMap: { value: null }, bumpScale: { value: 1 } },
        normalmap: {
          normalMap: { value: null },
          normalScale: { value: new kn(1, 1) }
        },
        displacementmap: {
          displacementMap: { value: null },
          displacementScale: { value: 1 },
          displacementBias: { value: 0 }
        },
        roughnessmap: { roughnessMap: { value: null } },
        metalnessmap: { metalnessMap: { value: null } },
        gradientmap: { gradientMap: { value: null } },
        fog: {
          fogDensity: { value: 25e-5 },
          fogNear: { value: 1 },
          fogFar: { value: 2e3 },
          fogColor: { value: new xr(16777215) }
        },
        lights: {
          ambientLightColor: { value: [] },
          lightProbe: { value: [] },
          directionalLights: {
            value: [],
            properties: { direction: {}, color: {} }
          },
          directionalLightShadows: {
            value: [],
            properties: {
              shadowBias: {},
              shadowNormalBias: {},
              shadowRadius: {},
              shadowMapSize: {}
            }
          },
          directionalShadowMap: { value: [] },
          directionalShadowMatrix: { value: [] },
          spotLights: {
            value: [],
            properties: {
              color: {},
              position: {},
              direction: {},
              distance: {},
              coneCos: {},
              penumbraCos: {},
              decay: {}
            }
          },
          spotLightShadows: {
            value: [],
            properties: {
              shadowBias: {},
              shadowNormalBias: {},
              shadowRadius: {},
              shadowMapSize: {}
            }
          },
          spotShadowMap: { value: [] },
          spotShadowMatrix: { value: [] },
          pointLights: {
            value: [],
            properties: { color: {}, position: {}, decay: {}, distance: {} }
          },
          pointLightShadows: {
            value: [],
            properties: {
              shadowBias: {},
              shadowNormalBias: {},
              shadowRadius: {},
              shadowMapSize: {},
              shadowCameraNear: {},
              shadowCameraFar: {}
            }
          },
          pointShadowMap: { value: [] },
          pointShadowMatrix: { value: [] },
          hemisphereLights: {
            value: [],
            properties: { direction: {}, skyColor: {}, groundColor: {} }
          },
          rectAreaLights: {
            value: [],
            properties: { color: {}, position: {}, width: {}, height: {} }
          },
          ltc_1: { value: null },
          ltc_2: { value: null }
        },
        points: {
          diffuse: { value: new xr(16777215) },
          opacity: { value: 1 },
          size: { value: 1 },
          scale: { value: 1 },
          map: { value: null },
          alphaMap: { value: null },
          uvTransform: { value: new Hn() }
        },
        sprite: {
          diffuse: { value: new xr(16777215) },
          opacity: { value: 1 },
          center: { value: new kn(0.5, 0.5) },
          rotation: { value: 0 },
          map: { value: null },
          alphaMap: { value: null },
          uvTransform: { value: new Hn() }
        }
      },
      el = {
        basic: {
          uniforms: la([
            $o.common,
            $o.specularmap,
            $o.envmap,
            $o.aomap,
            $o.lightmap,
            $o.fog
          ]),
          vertexShader: Qo.meshbasic_vert,
          fragmentShader: Qo.meshbasic_frag
        },
        lambert: {
          uniforms: la([
            $o.common,
            $o.specularmap,
            $o.envmap,
            $o.aomap,
            $o.lightmap,
            $o.emissivemap,
            $o.fog,
            $o.lights,
            { emissive: { value: new xr(0) } }
          ]),
          vertexShader: Qo.meshlambert_vert,
          fragmentShader: Qo.meshlambert_frag
        },
        phong: {
          uniforms: la([
            $o.common,
            $o.specularmap,
            $o.envmap,
            $o.aomap,
            $o.lightmap,
            $o.emissivemap,
            $o.bumpmap,
            $o.normalmap,
            $o.displacementmap,
            $o.fog,
            $o.lights,
            {
              emissive: { value: new xr(0) },
              specular: { value: new xr(1118481) },
              shininess: { value: 30 }
            }
          ]),
          vertexShader: Qo.meshphong_vert,
          fragmentShader: Qo.meshphong_frag
        },
        standard: {
          uniforms: la([
            $o.common,
            $o.envmap,
            $o.aomap,
            $o.lightmap,
            $o.emissivemap,
            $o.bumpmap,
            $o.normalmap,
            $o.displacementmap,
            $o.roughnessmap,
            $o.metalnessmap,
            $o.fog,
            $o.lights,
            {
              emissive: { value: new xr(0) },
              roughness: { value: 1 },
              metalness: { value: 0 },
              envMapIntensity: { value: 1 }
            }
          ]),
          vertexShader: Qo.meshphysical_vert,
          fragmentShader: Qo.meshphysical_frag
        },
        toon: {
          uniforms: la([
            $o.common,
            $o.aomap,
            $o.lightmap,
            $o.emissivemap,
            $o.bumpmap,
            $o.normalmap,
            $o.displacementmap,
            $o.gradientmap,
            $o.fog,
            $o.lights,
            { emissive: { value: new xr(0) } }
          ]),
          vertexShader: Qo.meshtoon_vert,
          fragmentShader: Qo.meshtoon_frag
        },
        matcap: {
          uniforms: la([
            $o.common,
            $o.bumpmap,
            $o.normalmap,
            $o.displacementmap,
            $o.fog,
            { matcap: { value: null } }
          ]),
          vertexShader: Qo.meshmatcap_vert,
          fragmentShader: Qo.meshmatcap_frag
        },
        points: {
          uniforms: la([$o.points, $o.fog]),
          vertexShader: Qo.points_vert,
          fragmentShader: Qo.points_frag
        },
        dashed: {
          uniforms: la([
            $o.common,
            $o.fog,
            {
              scale: { value: 1 },
              dashSize: { value: 1 },
              totalSize: { value: 2 }
            }
          ]),
          vertexShader: Qo.linedashed_vert,
          fragmentShader: Qo.linedashed_frag
        },
        depth: {
          uniforms: la([$o.common, $o.displacementmap]),
          vertexShader: Qo.depth_vert,
          fragmentShader: Qo.depth_frag
        },
        normal: {
          uniforms: la([
            $o.common,
            $o.bumpmap,
            $o.normalmap,
            $o.displacementmap,
            { opacity: { value: 1 } }
          ]),
          vertexShader: Qo.normal_vert,
          fragmentShader: Qo.normal_frag
        },
        sprite: {
          uniforms: la([$o.sprite, $o.fog]),
          vertexShader: Qo.sprite_vert,
          fragmentShader: Qo.sprite_frag
        },
        background: {
          uniforms: { uvTransform: { value: new Hn() }, t2D: { value: null } },
          vertexShader: Qo.background_vert,
          fragmentShader: Qo.background_frag
        },
        cube: {
          uniforms: la([$o.envmap, { opacity: { value: 1 } }]),
          vertexShader: Qo.cube_vert,
          fragmentShader: Qo.cube_frag
        },
        equirect: {
          uniforms: { tEquirect: { value: null } },
          vertexShader: Qo.equirect_vert,
          fragmentShader: Qo.equirect_frag
        },
        distanceRGBA: {
          uniforms: la([
            $o.common,
            $o.displacementmap,
            {
              referencePosition: { value: new Qn() },
              nearDistance: { value: 1 },
              farDistance: { value: 1e3 }
            }
          ]),
          vertexShader: Qo.distanceRGBA_vert,
          fragmentShader: Qo.distanceRGBA_frag
        },
        shadow: {
          uniforms: la([
            $o.lights,
            $o.fog,
            { color: { value: new xr(0) }, opacity: { value: 1 } }
          ]),
          vertexShader: Qo.shadow_vert,
          fragmentShader: Qo.shadow_frag
        }
      }
    function tl (e, t, n, i, r) {
      const a = new xr(0)
      let s,
        o,
        l = 0,
        c = null,
        h = 0,
        u = null
      function d (n, r) {
        let d = !1,
          f = !0 === r.isScene ? r.background : null
        f && f.isTexture && (f = t.get(f))
        const m = e.xr,
          g = m.getSession && m.getSession()
        g && 'additive' === g.environmentBlendMode && (f = null),
          null === f ? p(a, l) : f && f.isColor && (p(f, 1), (d = !0)),
          (e.autoClear || d) &&
            e.clear(e.autoClearColor, e.autoClearDepth, e.autoClearStencil),
          f && (f.isCubeTexture || f.mapping === Pe)
            ? (void 0 === o &&
                ((o = new ia(
                  new sa(1, 1, 1),
                  new da({
                    name: 'BackgroundCubeMaterial',
                    uniforms: oa(el.cube.uniforms),
                    vertexShader: el.cube.vertexShader,
                    fragmentShader: el.cube.fragmentShader,
                    side: z,
                    depthTest: !1,
                    depthWrite: !1,
                    fog: !1
                  })
                )),
                o.geometry.deleteAttribute('normal'),
                o.geometry.deleteAttribute('uv'),
                (o.onBeforeRender = function (e, t, n) {
                  this.matrixWorld.copyPosition(n.matrixWorld)
                }),
                Object.defineProperty(o.material, 'envMap', {
                  get: function () {
                    return this.uniforms.envMap.value
                  }
                }),
                i.update(o)),
              (o.material.uniforms.envMap.value = f),
              (o.material.uniforms.flipEnvMap.value =
                f.isCubeTexture && f._needsFlipEnvMap ? -1 : 1),
              (c === f && h === f.version && u === e.toneMapping) ||
                ((o.material.needsUpdate = !0),
                (c = f),
                (h = f.version),
                (u = e.toneMapping)),
              n.unshift(o, o.geometry, o.material, 0, 0, null))
            : f &&
              f.isTexture &&
              (void 0 === s &&
                ((s = new ia(
                  new La(2, 2),
                  new da({
                    name: 'BackgroundMaterial',
                    uniforms: oa(el.background.uniforms),
                    vertexShader: el.background.vertexShader,
                    fragmentShader: el.background.fragmentShader,
                    side: B,
                    depthTest: !1,
                    depthWrite: !1,
                    fog: !1
                  })
                )),
                s.geometry.deleteAttribute('normal'),
                Object.defineProperty(s.material, 'map', {
                  get: function () {
                    return this.uniforms.t2D.value
                  }
                }),
                i.update(s)),
              (s.material.uniforms.t2D.value = f),
              !0 === f.matrixAutoUpdate && f.updateMatrix(),
              s.material.uniforms.uvTransform.value.copy(f.matrix),
              (c === f && h === f.version && u === e.toneMapping) ||
                ((s.material.needsUpdate = !0),
                (c = f),
                (h = f.version),
                (u = e.toneMapping)),
              n.unshift(s, s.geometry, s.material, 0, 0, null))
      }
      function p (e, t) {
        n.buffers.color.setClear(e.r, e.g, e.b, t, r)
      }
      return {
        getClearColor: function () {
          return a
        },
        setClearColor: function (e, t = 1) {
          a.set(e), (l = t), p(a, l)
        },
        getClearAlpha: function () {
          return l
        },
        setClearAlpha: function (e) {
          ;(l = e), p(a, l)
        },
        render: d
      }
    }
    function nl (e, t, n, i) {
      const r = e.getParameter(34921),
        a = i.isWebGL2 ? null : t.get('OES_vertex_array_object'),
        s = i.isWebGL2 || null !== a,
        o = {},
        l = m(null)
      let c = l
      function h (t, i, r, a, o) {
        let l = !1
        if (s) {
          const e = f(a, r, i)
          c !== e && ((c = e), d(c.object)), (l = g(a, o)), l && v(a, o)
        } else {
          const e = !0 === i.wireframe
          ;(c.geometry === a.id && c.program === r.id && c.wireframe === e) ||
            ((c.geometry = a.id),
            (c.program = r.id),
            (c.wireframe = e),
            (l = !0))
        }
        !0 === t.isInstancedMesh && (l = !0),
          null !== o && n.update(o, 34963),
          l &&
            (M(t, i, r, a), null !== o && e.bindBuffer(34963, n.get(o).buffer))
      }
      function u () {
        return i.isWebGL2 ? e.createVertexArray() : a.createVertexArrayOES()
      }
      function d (t) {
        return i.isWebGL2 ? e.bindVertexArray(t) : a.bindVertexArrayOES(t)
      }
      function p (t) {
        return i.isWebGL2 ? e.deleteVertexArray(t) : a.deleteVertexArrayOES(t)
      }
      function f (e, t, n) {
        const i = !0 === n.wireframe
        let r = o[e.id]
        void 0 === r && ((r = {}), (o[e.id] = r))
        let a = r[t.id]
        void 0 === a && ((a = {}), (r[t.id] = a))
        let s = a[i]
        return void 0 === s && ((s = m(u())), (a[i] = s)), s
      }
      function m (e) {
        const t = [],
          n = [],
          i = []
        for (let a = 0; a < r; a++) (t[a] = 0), (n[a] = 0), (i[a] = 0)
        return {
          geometry: null,
          program: null,
          wireframe: !1,
          newAttributes: t,
          enabledAttributes: n,
          attributeDivisors: i,
          object: e,
          attributes: {},
          index: null
        }
      }
      function g (e, t) {
        const n = c.attributes,
          i = e.attributes
        let r = 0
        for (const a in i) {
          const e = n[a],
            t = i[a]
          if (void 0 === e) return !0
          if (e.attribute !== t) return !0
          if (e.data !== t.data) return !0
          r++
        }
        return c.attributesNum !== r || c.index !== t
      }
      function v (e, t) {
        const n = {},
          i = e.attributes
        let r = 0
        for (const a in i) {
          const e = i[a],
            t = {}
          ;(t.attribute = e), e.data && (t.data = e.data), (n[a] = t), r++
        }
        ;(c.attributes = n), (c.attributesNum = r), (c.index = t)
      }
      function y () {
        const e = c.newAttributes
        for (let t = 0, n = e.length; t < n; t++) e[t] = 0
      }
      function _ (e) {
        x(e, 0)
      }
      function x (n, r) {
        const a = c.newAttributes,
          s = c.enabledAttributes,
          o = c.attributeDivisors
        if (
          ((a[n] = 1),
          0 === s[n] && (e.enableVertexAttribArray(n), (s[n] = 1)),
          o[n] !== r)
        ) {
          const a = i.isWebGL2 ? e : t.get('ANGLE_instanced_arrays')
          a[i.isWebGL2 ? 'vertexAttribDivisor' : 'vertexAttribDivisorANGLE'](
            n,
            r
          ),
            (o[n] = r)
        }
      }
      function w () {
        const t = c.newAttributes,
          n = c.enabledAttributes
        for (let i = 0, r = n.length; i < r; i++)
          n[i] !== t[i] && (e.disableVertexAttribArray(i), (n[i] = 0))
      }
      function b (t, n, r, a, s, o) {
        !0 !== i.isWebGL2 || (5124 !== r && 5125 !== r)
          ? e.vertexAttribPointer(t, n, r, a, s, o)
          : e.vertexAttribIPointer(t, n, r, s, o)
      }
      function M (r, a, s, o) {
        if (
          !1 === i.isWebGL2 &&
          (r.isInstancedMesh || o.isInstancedBufferGeometry) &&
          null === t.get('ANGLE_instanced_arrays')
        )
          return
        y()
        const l = o.attributes,
          c = s.getAttributes(),
          h = a.defaultAttributeValues
        for (const t in c) {
          const i = c[t]
          if (i >= 0) {
            const a = l[t]
            if (void 0 !== a) {
              const t = a.normalized,
                r = a.itemSize,
                s = n.get(a)
              if (void 0 === s) continue
              const l = s.buffer,
                c = s.type,
                h = s.bytesPerElement
              if (a.isInterleavedBufferAttribute) {
                const n = a.data,
                  s = n.stride,
                  u = a.offset
                n && n.isInstancedInterleavedBuffer
                  ? (x(i, n.meshPerAttribute),
                    void 0 === o._maxInstanceCount &&
                      (o._maxInstanceCount = n.meshPerAttribute * n.count))
                  : _(i),
                  e.bindBuffer(34962, l),
                  b(i, r, c, t, s * h, u * h)
              } else
                a.isInstancedBufferAttribute
                  ? (x(i, a.meshPerAttribute),
                    void 0 === o._maxInstanceCount &&
                      (o._maxInstanceCount = a.meshPerAttribute * a.count))
                  : _(i),
                  e.bindBuffer(34962, l),
                  b(i, r, c, t, 0, 0)
            } else if ('instanceMatrix' === t) {
              const t = n.get(r.instanceMatrix)
              if (void 0 === t) continue
              const a = t.buffer,
                s = t.type
              x(i + 0, 1),
                x(i + 1, 1),
                x(i + 2, 1),
                x(i + 3, 1),
                e.bindBuffer(34962, a),
                e.vertexAttribPointer(i + 0, 4, s, !1, 64, 0),
                e.vertexAttribPointer(i + 1, 4, s, !1, 64, 16),
                e.vertexAttribPointer(i + 2, 4, s, !1, 64, 32),
                e.vertexAttribPointer(i + 3, 4, s, !1, 64, 48)
            } else if ('instanceColor' === t) {
              const t = n.get(r.instanceColor)
              if (void 0 === t) continue
              const a = t.buffer,
                s = t.type
              x(i, 1),
                e.bindBuffer(34962, a),
                e.vertexAttribPointer(i, 3, s, !1, 12, 0)
            } else if (void 0 !== h) {
              const n = h[t]
              if (void 0 !== n)
                switch (n.length) {
                  case 2:
                    e.vertexAttrib2fv(i, n)
                    break
                  case 3:
                    e.vertexAttrib3fv(i, n)
                    break
                  case 4:
                    e.vertexAttrib4fv(i, n)
                    break
                  default:
                    e.vertexAttrib1fv(i, n)
                }
            }
          }
        }
        w()
      }
      function S () {
        A()
        for (const e in o) {
          const t = o[e]
          for (const e in t) {
            const n = t[e]
            for (const e in n) p(n[e].object), delete n[e]
            delete t[e]
          }
          delete o[e]
        }
      }
      function E (e) {
        if (void 0 === o[e.id]) return
        const t = o[e.id]
        for (const n in t) {
          const e = t[n]
          for (const t in e) p(e[t].object), delete e[t]
          delete t[n]
        }
        delete o[e.id]
      }
      function T (e) {
        for (const t in o) {
          const n = o[t]
          if (void 0 === n[e.id]) continue
          const i = n[e.id]
          for (const e in i) p(i[e].object), delete i[e]
          delete n[e.id]
        }
      }
      function A () {
        R(), c !== l && ((c = l), d(c.object))
      }
      function R () {
        ;(l.geometry = null), (l.program = null), (l.wireframe = !1)
      }
      return {
        setup: h,
        reset: A,
        resetDefaultState: R,
        dispose: S,
        releaseStatesOfGeometry: E,
        releaseStatesOfProgram: T,
        initAttributes: y,
        enableAttribute: _,
        disableUnusedAttributes: w
      }
    }
    function il (e, t, n, i) {
      const r = i.isWebGL2
      let a
      function s (e) {
        a = e
      }
      function o (t, i) {
        e.drawArrays(a, t, i), n.update(i, a, 1)
      }
      function l (i, s, o) {
        if (0 === o) return
        let l, c
        if (r) (l = e), (c = 'drawArraysInstanced')
        else if (
          ((l = t.get('ANGLE_instanced_arrays')),
          (c = 'drawArraysInstancedANGLE'),
          null === l)
        )
          return void console.error(
            'THREE.WebGLBufferRenderer: using THREE.InstancedBufferGeometry but hardware does not support extension ANGLE_instanced_arrays.'
          )
        l[c](a, i, s, o), n.update(s, a, o)
      }
      ;(this.setMode = s), (this.render = o), (this.renderInstances = l)
    }
    function rl (e, t, n) {
      let i
      function r () {
        if (void 0 !== i) return i
        if (!0 === t.has('EXT_texture_filter_anisotropic')) {
          const n = t.get('EXT_texture_filter_anisotropic')
          i = e.getParameter(n.MAX_TEXTURE_MAX_ANISOTROPY_EXT)
        } else i = 0
        return i
      }
      function a (t) {
        if ('highp' === t) {
          if (
            e.getShaderPrecisionFormat(35633, 36338).precision > 0 &&
            e.getShaderPrecisionFormat(35632, 36338).precision > 0
          )
            return 'highp'
          t = 'mediump'
        }
        return 'mediump' === t &&
          e.getShaderPrecisionFormat(35633, 36337).precision > 0 &&
          e.getShaderPrecisionFormat(35632, 36337).precision > 0
          ? 'mediump'
          : 'lowp'
      }
      const s =
        ('undefined' !== typeof WebGL2RenderingContext &&
          e instanceof WebGL2RenderingContext) ||
        ('undefined' !== typeof WebGL2ComputeRenderingContext &&
          e instanceof WebGL2ComputeRenderingContext)
      let o = void 0 !== n.precision ? n.precision : 'highp'
      const l = a(o)
      l !== o &&
        (console.warn(
          'THREE.WebGLRenderer:',
          o,
          'not supported, using',
          l,
          'instead.'
        ),
        (o = l))
      const c = s || t.has('WEBGL_draw_buffers'),
        h = !0 === n.logarithmicDepthBuffer,
        u = e.getParameter(34930),
        d = e.getParameter(35660),
        p = e.getParameter(3379),
        f = e.getParameter(34076),
        m = e.getParameter(34921),
        g = e.getParameter(36347),
        v = e.getParameter(36348),
        y = e.getParameter(36349),
        _ = d > 0,
        x = s || t.has('OES_texture_float'),
        w = _ && x,
        b = s ? e.getParameter(36183) : 0
      return {
        isWebGL2: s,
        drawBuffers: c,
        getMaxAnisotropy: r,
        getMaxPrecision: a,
        precision: o,
        logarithmicDepthBuffer: h,
        maxTextures: u,
        maxVertexTextures: d,
        maxTextureSize: p,
        maxCubemapSize: f,
        maxAttributes: m,
        maxVertexUniforms: g,
        maxVaryings: v,
        maxFragmentUniforms: y,
        vertexTextures: _,
        floatFragmentTextures: x,
        floatVertexTextures: w,
        maxSamples: b
      }
    }
    function al (e) {
      const t = this
      let n = null,
        i = 0,
        r = !1,
        a = !1
      const s = new Ma(),
        o = new Hn(),
        l = { value: null, needsUpdate: !1 }
      function c () {
        l.value !== n && ((l.value = n), (l.needsUpdate = i > 0)),
          (t.numPlanes = i),
          (t.numIntersection = 0)
      }
      function h (e, n, i, r) {
        const a = null !== e ? e.length : 0
        let c = null
        if (0 !== a) {
          if (((c = l.value), !0 !== r || null === c)) {
            const t = i + 4 * a,
              r = n.matrixWorldInverse
            o.getNormalMatrix(r),
              (null === c || c.length < t) && (c = new Float32Array(t))
            for (let n = 0, l = i; n !== a; ++n, l += 4)
              s.copy(e[n]).applyMatrix4(r, o),
                s.normal.toArray(c, l),
                (c[l + 3] = s.constant)
          }
          ;(l.value = c), (l.needsUpdate = !0)
        }
        return (t.numPlanes = a), (t.numIntersection = 0), c
      }
      ;(this.uniform = l),
        (this.numPlanes = 0),
        (this.numIntersection = 0),
        (this.init = function (e, t, a) {
          const s = 0 !== e.length || t || 0 !== i || r
          return (r = t), (n = h(e, a, 0)), (i = e.length), s
        }),
        (this.beginShadows = function () {
          ;(a = !0), h(null)
        }),
        (this.endShadows = function () {
          ;(a = !1), c()
        }),
        (this.setState = function (t, s, o) {
          const u = t.clippingPlanes,
            d = t.clipIntersection,
            p = t.clipShadows,
            f = e.get(t)
          if (!r || null === u || 0 === u.length || (a && !p)) a ? h(null) : c()
          else {
            const e = a ? 0 : i,
              t = 4 * e
            let r = f.clippingState || null
            ;(l.value = r), (r = h(u, s, t, o))
            for (let i = 0; i !== t; ++i) r[i] = n[i]
            ;(f.clippingState = r),
              (this.numIntersection = d ? this.numPlanes : 0),
              (this.numPlanes += e)
          }
        })
    }
    function sl (e) {
      let t = new WeakMap()
      function n (e, t) {
        return t === Le ? (e.mapping = Ae) : t === Ce && (e.mapping = Re), e
      }
      function i (i) {
        if (i && i.isTexture) {
          const a = i.mapping
          if (a === Le || a === Ce) {
            if (t.has(i)) {
              const e = t.get(i).texture
              return n(e, i.mapping)
            }
            {
              const a = i.image
              if (a && a.height > 0) {
                const s = e.getRenderTarget(),
                  o = new _a(a.height / 2)
                return (
                  o.fromEquirectangularTexture(e, i),
                  t.set(i, o),
                  e.setRenderTarget(s),
                  i.addEventListener('dispose', r),
                  n(o.texture, i.mapping)
                )
              }
              return null
            }
          }
        }
        return i
      }
      function r (e) {
        const n = e.target
        n.removeEventListener('dispose', r)
        const i = t.get(n)
        void 0 !== i && (t.delete(n), i.dispose())
      }
      function a () {
        t = new WeakMap()
      }
      return { get: i, dispose: a }
    }
    function ol (e) {
      const t = {}
      function n (n) {
        if (void 0 !== t[n]) return t[n]
        let i
        switch (n) {
          case 'WEBGL_depth_texture':
            i =
              e.getExtension('WEBGL_depth_texture') ||
              e.getExtension('MOZ_WEBGL_depth_texture') ||
              e.getExtension('WEBKIT_WEBGL_depth_texture')
            break
          case 'EXT_texture_filter_anisotropic':
            i =
              e.getExtension('EXT_texture_filter_anisotropic') ||
              e.getExtension('MOZ_EXT_texture_filter_anisotropic') ||
              e.getExtension('WEBKIT_EXT_texture_filter_anisotropic')
            break
          case 'WEBGL_compressed_texture_s3tc':
            i =
              e.getExtension('WEBGL_compressed_texture_s3tc') ||
              e.getExtension('MOZ_WEBGL_compressed_texture_s3tc') ||
              e.getExtension('WEBKIT_WEBGL_compressed_texture_s3tc')
            break
          case 'WEBGL_compressed_texture_pvrtc':
            i =
              e.getExtension('WEBGL_compressed_texture_pvrtc') ||
              e.getExtension('WEBKIT_WEBGL_compressed_texture_pvrtc')
            break
          default:
            i = e.getExtension(n)
        }
        return (t[n] = i), i
      }
      return {
        has: function (e) {
          return null !== n(e)
        },
        init: function (e) {
          e.isWebGL2
            ? n('EXT_color_buffer_float')
            : (n('WEBGL_depth_texture'),
              n('OES_texture_float'),
              n('OES_texture_half_float'),
              n('OES_texture_half_float_linear'),
              n('OES_standard_derivatives'),
              n('OES_element_index_uint'),
              n('OES_vertex_array_object'),
              n('ANGLE_instanced_arrays')),
            n('OES_texture_float_linear'),
            n('EXT_color_buffer_half_float')
        },
        get: function (e) {
          const t = n(e)
          return (
            null === t &&
              console.warn(
                'THREE.WebGLRenderer: ' + e + ' extension not supported.'
              ),
            t
          )
        }
      }
    }
    function ll (e, t, n, i) {
      const r = {},
        a = new WeakMap()
      function s (e) {
        const o = e.target
        null !== o.index && t.remove(o.index)
        for (const n in o.attributes) t.remove(o.attributes[n])
        o.removeEventListener('dispose', s), delete r[o.id]
        const l = a.get(o)
        l && (t.remove(l), a.delete(o)),
          i.releaseStatesOfGeometry(o),
          !0 === o.isInstancedBufferGeometry && delete o._maxInstanceCount,
          n.memory.geometries--
      }
      function o (e, t) {
        return (
          !0 === r[t.id] ||
            (t.addEventListener('dispose', s),
            (r[t.id] = !0),
            n.memory.geometries++),
          t
        )
      }
      function l (e) {
        const n = e.attributes
        for (const r in n) t.update(n[r], 34962)
        const i = e.morphAttributes
        for (const r in i) {
          const e = i[r]
          for (let n = 0, i = e.length; n < i; n++) t.update(e[n], 34962)
        }
      }
      function c (e) {
        const n = [],
          i = e.index,
          r = e.attributes.position
        let s = 0
        if (null !== i) {
          const e = i.array
          s = i.version
          for (let t = 0, i = e.length; t < i; t += 3) {
            const i = e[t + 0],
              r = e[t + 1],
              a = e[t + 2]
            n.push(i, r, r, a, a, i)
          }
        } else {
          const e = r.array
          s = r.version
          for (let t = 0, i = e.length / 3 - 1; t < i; t += 3) {
            const e = t + 0,
              i = t + 1,
              r = t + 2
            n.push(e, i, i, r, r, e)
          }
        }
        const o = new (Lr(n) > 65535 ? Tr : Er)(n, 1)
        o.version = s
        const l = a.get(e)
        l && t.remove(l), a.set(e, o)
      }
      function h (e) {
        const t = a.get(e)
        if (t) {
          const n = e.index
          null !== n && t.version < n.version && c(e)
        } else c(e)
        return a.get(e)
      }
      return { get: o, update: l, getWireframeAttribute: h }
    }
    function cl (e, t, n, i) {
      const r = i.isWebGL2
      let a, s, o
      function l (e) {
        a = e
      }
      function c (e) {
        ;(s = e.type), (o = e.bytesPerElement)
      }
      function h (t, i) {
        e.drawElements(a, i, s, t * o), n.update(i, a, 1)
      }
      function u (i, l, c) {
        if (0 === c) return
        let h, u
        if (r) (h = e), (u = 'drawElementsInstanced')
        else if (
          ((h = t.get('ANGLE_instanced_arrays')),
          (u = 'drawElementsInstancedANGLE'),
          null === h)
        )
          return void console.error(
            'THREE.WebGLIndexedBufferRenderer: using THREE.InstancedBufferGeometry but hardware does not support extension ANGLE_instanced_arrays.'
          )
        h[u](a, l, s, i * o, c), n.update(l, a, c)
      }
      ;(this.setMode = l),
        (this.setIndex = c),
        (this.render = h),
        (this.renderInstances = u)
    }
    function hl (e) {
      const t = { geometries: 0, textures: 0 },
        n = { frame: 0, calls: 0, triangles: 0, points: 0, lines: 0 }
      function i (e, t, i) {
        switch ((n.calls++, t)) {
          case 4:
            n.triangles += i * (e / 3)
            break
          case 1:
            n.lines += i * (e / 2)
            break
          case 3:
            n.lines += i * (e - 1)
            break
          case 2:
            n.lines += i * e
            break
          case 0:
            n.points += i * e
            break
          default:
            console.error('THREE.WebGLInfo: Unknown draw mode:', t)
            break
        }
      }
      function r () {
        n.frame++,
          (n.calls = 0),
          (n.triangles = 0),
          (n.points = 0),
          (n.lines = 0)
      }
      return {
        memory: t,
        render: n,
        programs: null,
        autoReset: !0,
        reset: r,
        update: i
      }
    }
    function ul (e, t) {
      return e[0] - t[0]
    }
    function dl (e, t) {
      return Math.abs(t[1]) - Math.abs(e[1])
    }
    function pl (e) {
      const t = {},
        n = new Float32Array(8),
        i = []
      for (let a = 0; a < 8; a++) i[a] = [a, 0]
      function r (r, a, s, o) {
        const l = r.morphTargetInfluences,
          c = void 0 === l ? 0 : l.length
        let h = t[a.id]
        if (void 0 === h || h.length !== c) {
          h = []
          for (let e = 0; e < c; e++) h[e] = [e, 0]
          t[a.id] = h
        }
        for (let e = 0; e < c; e++) {
          const t = h[e]
          ;(t[0] = e), (t[1] = l[e])
        }
        h.sort(dl)
        for (let e = 0; e < 8; e++)
          e < c && h[e][1]
            ? ((i[e][0] = h[e][0]), (i[e][1] = h[e][1]))
            : ((i[e][0] = Number.MAX_SAFE_INTEGER), (i[e][1] = 0))
        i.sort(ul)
        const u = s.morphTargets && a.morphAttributes.position,
          d = s.morphNormals && a.morphAttributes.normal
        let p = 0
        for (let e = 0; e < 8; e++) {
          const t = i[e],
            r = t[0],
            s = t[1]
          r !== Number.MAX_SAFE_INTEGER && s
            ? (u &&
                a.getAttribute('morphTarget' + e) !== u[r] &&
                a.setAttribute('morphTarget' + e, u[r]),
              d &&
                a.getAttribute('morphNormal' + e) !== d[r] &&
                a.setAttribute('morphNormal' + e, d[r]),
              (n[e] = s),
              (p += s))
            : (u &&
                !0 === a.hasAttribute('morphTarget' + e) &&
                a.deleteAttribute('morphTarget' + e),
              d &&
                !0 === a.hasAttribute('morphNormal' + e) &&
                a.deleteAttribute('morphNormal' + e),
              (n[e] = 0))
        }
        const f = a.morphTargetsRelative ? 1 : 1 - p
        o.getUniforms().setValue(e, 'morphTargetBaseInfluence', f),
          o.getUniforms().setValue(e, 'morphTargetInfluences', n)
      }
      return { update: r }
    }
    function fl (e, t, n, i) {
      let r = new WeakMap()
      function a (e) {
        const a = i.render.frame,
          s = e.geometry,
          l = t.get(e, s)
        return (
          r.get(l) !== a && (t.update(l), r.set(l, a)),
          e.isInstancedMesh &&
            (!1 === e.hasEventListener('dispose', o) &&
              e.addEventListener('dispose', o),
            n.update(e.instanceMatrix, 34962),
            null !== e.instanceColor && n.update(e.instanceColor, 34962)),
          l
        )
      }
      function s () {
        r = new WeakMap()
      }
      function o (e) {
        const t = e.target
        t.removeEventListener('dispose', o),
          n.remove(t.instanceMatrix),
          null !== t.instanceColor && n.remove(t.instanceColor)
      }
      return { update: a, dispose: s }
    }
    el.physical = {
      uniforms: la([
        el.standard.uniforms,
        {
          clearcoat: { value: 0 },
          clearcoatMap: { value: null },
          clearcoatRoughness: { value: 0 },
          clearcoatRoughnessMap: { value: null },
          clearcoatNormalScale: { value: new kn(1, 1) },
          clearcoatNormalMap: { value: null },
          sheen: { value: new xr(0) },
          transmission: { value: 0 },
          transmissionMap: { value: null },
          transmissionSamplerSize: { value: new kn() },
          transmissionSamplerMap: { value: null },
          thickness: { value: 0 },
          thicknessMap: { value: null },
          attenuationDistance: { value: 0 },
          attenuationColor: { value: new xr(0) }
        }
      ]),
      vertexShader: Qo.meshphysical_vert,
      fragmentShader: Qo.meshphysical_frag
    }
    class ml extends jn {
      constructor (e = null, t = 1, n = 1, i = 1) {
        super(null),
          (this.image = { data: e, width: t, height: n, depth: i }),
          (this.magFilter = Fe),
          (this.minFilter = Fe),
          (this.wrapR = Ne),
          (this.generateMipmaps = !1),
          (this.flipY = !1),
          (this.unpackAlignment = 1),
          (this.needsUpdate = !0)
      }
    }
    ml.prototype.isDataTexture2DArray = !0
    class gl extends jn {
      constructor (e = null, t = 1, n = 1, i = 1) {
        super(null),
          (this.image = { data: e, width: t, height: n, depth: i }),
          (this.magFilter = Fe),
          (this.minFilter = Fe),
          (this.wrapR = Ne),
          (this.generateMipmaps = !1),
          (this.flipY = !1),
          (this.unpackAlignment = 1),
          (this.needsUpdate = !0)
      }
    }
    gl.prototype.isDataTexture3D = !0
    const vl = new jn(),
      yl = new ml(),
      _l = new gl(),
      xl = new ya(),
      wl = [],
      bl = [],
      Ml = new Float32Array(16),
      Sl = new Float32Array(9),
      El = new Float32Array(4)
    function Tl (e, t, n) {
      const i = e[0]
      if (i <= 0 || i > 0) return e
      const r = t * n
      let a = wl[r]
      if ((void 0 === a && ((a = new Float32Array(r)), (wl[r] = a)), 0 !== t)) {
        i.toArray(a, 0)
        for (let i = 1, r = 0; i !== t; ++i) (r += n), e[i].toArray(a, r)
      }
      return a
    }
    function Al (e, t) {
      if (e.length !== t.length) return !1
      for (let n = 0, i = e.length; n < i; n++) if (e[n] !== t[n]) return !1
      return !0
    }
    function Rl (e, t) {
      for (let n = 0, i = t.length; n < i; n++) e[n] = t[n]
    }
    function Ll (e, t) {
      let n = bl[t]
      void 0 === n && ((n = new Int32Array(t)), (bl[t] = n))
      for (let i = 0; i !== t; ++i) n[i] = e.allocateTextureUnit()
      return n
    }
    function Cl (e, t) {
      const n = this.cache
      n[0] !== t && (e.uniform1f(this.addr, t), (n[0] = t))
    }
    function Pl (e, t) {
      const n = this.cache
      if (void 0 !== t.x)
        (n[0] === t.x && n[1] === t.y) ||
          (e.uniform2f(this.addr, t.x, t.y), (n[0] = t.x), (n[1] = t.y))
      else {
        if (Al(n, t)) return
        e.uniform2fv(this.addr, t), Rl(n, t)
      }
    }
    function Dl (e, t) {
      const n = this.cache
      if (void 0 !== t.x)
        (n[0] === t.x && n[1] === t.y && n[2] === t.z) ||
          (e.uniform3f(this.addr, t.x, t.y, t.z),
          (n[0] = t.x),
          (n[1] = t.y),
          (n[2] = t.z))
      else if (void 0 !== t.r)
        (n[0] === t.r && n[1] === t.g && n[2] === t.b) ||
          (e.uniform3f(this.addr, t.r, t.g, t.b),
          (n[0] = t.r),
          (n[1] = t.g),
          (n[2] = t.b))
      else {
        if (Al(n, t)) return
        e.uniform3fv(this.addr, t), Rl(n, t)
      }
    }
    function Il (e, t) {
      const n = this.cache
      if (void 0 !== t.x)
        (n[0] === t.x && n[1] === t.y && n[2] === t.z && n[3] === t.w) ||
          (e.uniform4f(this.addr, t.x, t.y, t.z, t.w),
          (n[0] = t.x),
          (n[1] = t.y),
          (n[2] = t.z),
          (n[3] = t.w))
      else {
        if (Al(n, t)) return
        e.uniform4fv(this.addr, t), Rl(n, t)
      }
    }
    function Nl (e, t) {
      const n = this.cache,
        i = t.elements
      if (void 0 === i) {
        if (Al(n, t)) return
        e.uniformMatrix2fv(this.addr, !1, t), Rl(n, t)
      } else {
        if (Al(n, i)) return
        El.set(i), e.uniformMatrix2fv(this.addr, !1, El), Rl(n, i)
      }
    }
    function Ol (e, t) {
      const n = this.cache,
        i = t.elements
      if (void 0 === i) {
        if (Al(n, t)) return
        e.uniformMatrix3fv(this.addr, !1, t), Rl(n, t)
      } else {
        if (Al(n, i)) return
        Sl.set(i), e.uniformMatrix3fv(this.addr, !1, Sl), Rl(n, i)
      }
    }
    function Fl (e, t) {
      const n = this.cache,
        i = t.elements
      if (void 0 === i) {
        if (Al(n, t)) return
        e.uniformMatrix4fv(this.addr, !1, t), Rl(n, t)
      } else {
        if (Al(n, i)) return
        Ml.set(i), e.uniformMatrix4fv(this.addr, !1, Ml), Rl(n, i)
      }
    }
    function Bl (e, t) {
      const n = this.cache
      n[0] !== t && (e.uniform1i(this.addr, t), (n[0] = t))
    }
    function zl (e, t) {
      const n = this.cache
      Al(n, t) || (e.uniform2iv(this.addr, t), Rl(n, t))
    }
    function Ul (e, t) {
      const n = this.cache
      Al(n, t) || (e.uniform3iv(this.addr, t), Rl(n, t))
    }
    function kl (e, t) {
      const n = this.cache
      Al(n, t) || (e.uniform4iv(this.addr, t), Rl(n, t))
    }
    function Hl (e, t) {
      const n = this.cache
      n[0] !== t && (e.uniform1ui(this.addr, t), (n[0] = t))
    }
    function Wl (e, t) {
      const n = this.cache
      Al(n, t) || (e.uniform2uiv(this.addr, t), Rl(n, t))
    }
    function Vl (e, t) {
      const n = this.cache
      Al(n, t) || (e.uniform3uiv(this.addr, t), Rl(n, t))
    }
    function Gl (e, t) {
      const n = this.cache
      Al(n, t) || (e.uniform4uiv(this.addr, t), Rl(n, t))
    }
    function jl (e, t, n) {
      const i = this.cache,
        r = n.allocateTextureUnit()
      i[0] !== r && (e.uniform1i(this.addr, r), (i[0] = r)),
        n.safeSetTexture2D(t || vl, r)
    }
    function ql (e, t, n) {
      const i = this.cache,
        r = n.allocateTextureUnit()
      i[0] !== r && (e.uniform1i(this.addr, r), (i[0] = r)),
        n.setTexture3D(t || _l, r)
    }
    function Yl (e, t, n) {
      const i = this.cache,
        r = n.allocateTextureUnit()
      i[0] !== r && (e.uniform1i(this.addr, r), (i[0] = r)),
        n.safeSetTextureCube(t || xl, r)
    }
    function Xl (e, t, n) {
      const i = this.cache,
        r = n.allocateTextureUnit()
      i[0] !== r && (e.uniform1i(this.addr, r), (i[0] = r)),
        n.setTexture2DArray(t || yl, r)
    }
    function Jl (e) {
      switch (e) {
        case 5126:
          return Cl
        case 35664:
          return Pl
        case 35665:
          return Dl
        case 35666:
          return Il
        case 35674:
          return Nl
        case 35675:
          return Ol
        case 35676:
          return Fl
        case 5124:
        case 35670:
          return Bl
        case 35667:
        case 35671:
          return zl
        case 35668:
        case 35672:
          return Ul
        case 35669:
        case 35673:
          return kl
        case 5125:
          return Hl
        case 36294:
          return Wl
        case 36295:
          return Vl
        case 36296:
          return Gl
        case 35678:
        case 36198:
        case 36298:
        case 36306:
        case 35682:
          return jl
        case 35679:
        case 36299:
        case 36307:
          return ql
        case 35680:
        case 36300:
        case 36308:
        case 36293:
          return Yl
        case 36289:
        case 36303:
        case 36311:
        case 36292:
          return Xl
      }
    }
    function Zl (e, t) {
      e.uniform1fv(this.addr, t)
    }
    function Kl (e, t) {
      const n = Tl(t, this.size, 2)
      e.uniform2fv(this.addr, n)
    }
    function Ql (e, t) {
      const n = Tl(t, this.size, 3)
      e.uniform3fv(this.addr, n)
    }
    function $l (e, t) {
      const n = Tl(t, this.size, 4)
      e.uniform4fv(this.addr, n)
    }
    function ec (e, t) {
      const n = Tl(t, this.size, 4)
      e.uniformMatrix2fv(this.addr, !1, n)
    }
    function tc (e, t) {
      const n = Tl(t, this.size, 9)
      e.uniformMatrix3fv(this.addr, !1, n)
    }
    function nc (e, t) {
      const n = Tl(t, this.size, 16)
      e.uniformMatrix4fv(this.addr, !1, n)
    }
    function ic (e, t) {
      e.uniform1iv(this.addr, t)
    }
    function rc (e, t) {
      e.uniform2iv(this.addr, t)
    }
    function ac (e, t) {
      e.uniform3iv(this.addr, t)
    }
    function sc (e, t) {
      e.uniform4iv(this.addr, t)
    }
    function oc (e, t) {
      e.uniform1uiv(this.addr, t)
    }
    function lc (e, t) {
      e.uniform2uiv(this.addr, t)
    }
    function cc (e, t) {
      e.uniform3uiv(this.addr, t)
    }
    function hc (e, t) {
      e.uniform4uiv(this.addr, t)
    }
    function uc (e, t, n) {
      const i = t.length,
        r = Ll(n, i)
      e.uniform1iv(this.addr, r)
      for (let a = 0; a !== i; ++a) n.safeSetTexture2D(t[a] || vl, r[a])
    }
    function dc (e, t, n) {
      const i = t.length,
        r = Ll(n, i)
      e.uniform1iv(this.addr, r)
      for (let a = 0; a !== i; ++a) n.safeSetTextureCube(t[a] || xl, r[a])
    }
    function pc (e) {
      switch (e) {
        case 5126:
          return Zl
        case 35664:
          return Kl
        case 35665:
          return Ql
        case 35666:
          return $l
        case 35674:
          return ec
        case 35675:
          return tc
        case 35676:
          return nc
        case 5124:
        case 35670:
          return ic
        case 35667:
        case 35671:
          return rc
        case 35668:
        case 35672:
          return ac
        case 35669:
        case 35673:
          return sc
        case 5125:
          return oc
        case 36294:
          return lc
        case 36295:
          return cc
        case 36296:
          return hc
        case 35678:
        case 36198:
        case 36298:
        case 36306:
        case 35682:
          return uc
        case 35680:
        case 36300:
        case 36308:
        case 36293:
          return dc
      }
    }
    function fc (e, t, n) {
      ;(this.id = e),
        (this.addr = n),
        (this.cache = []),
        (this.setValue = Jl(t.type))
    }
    function mc (e, t, n) {
      ;(this.id = e),
        (this.addr = n),
        (this.cache = []),
        (this.size = t.size),
        (this.setValue = pc(t.type))
    }
    function gc (e) {
      ;(this.id = e), (this.seq = []), (this.map = {})
    }
    ;(mc.prototype.updateCache = function (e) {
      const t = this.cache
      e instanceof Float32Array &&
        t.length !== e.length &&
        (this.cache = new Float32Array(e.length)),
        Rl(t, e)
    }),
      (gc.prototype.setValue = function (e, t, n) {
        const i = this.seq
        for (let r = 0, a = i.length; r !== a; ++r) {
          const a = i[r]
          a.setValue(e, t[a.id], n)
        }
      })
    const vc = /(\w+)(\])?(\[|\.)?/g
    function yc (e, t) {
      e.seq.push(t), (e.map[t.id] = t)
    }
    function _c (e, t, n) {
      const i = e.name,
        r = i.length
      vc.lastIndex = 0
      while (1) {
        const a = vc.exec(i),
          s = vc.lastIndex
        let o = a[1]
        const l = ']' === a[2],
          c = a[3]
        if ((l && (o |= 0), void 0 === c || ('[' === c && s + 2 === r))) {
          yc(n, void 0 === c ? new fc(o, e, t) : new mc(o, e, t))
          break
        }
        {
          const e = n.map
          let t = e[o]
          void 0 === t && ((t = new gc(o)), yc(n, t)), (n = t)
        }
      }
    }
    function xc (e, t) {
      ;(this.seq = []), (this.map = {})
      const n = e.getProgramParameter(t, 35718)
      for (let i = 0; i < n; ++i) {
        const n = e.getActiveUniform(t, i),
          r = e.getUniformLocation(t, n.name)
        _c(n, r, this)
      }
    }
    function wc (e, t, n) {
      const i = e.createShader(t)
      return e.shaderSource(i, n), e.compileShader(i), i
    }
    ;(xc.prototype.setValue = function (e, t, n, i) {
      const r = this.map[t]
      void 0 !== r && r.setValue(e, n, i)
    }),
      (xc.prototype.setOptional = function (e, t, n) {
        const i = t[n]
        void 0 !== i && this.setValue(e, n, i)
      }),
      (xc.upload = function (e, t, n, i) {
        for (let r = 0, a = t.length; r !== a; ++r) {
          const a = t[r],
            s = n[a.id]
          !1 !== s.needsUpdate && a.setValue(e, s.value, i)
        }
      }),
      (xc.seqWithValue = function (e, t) {
        const n = []
        for (let i = 0, r = e.length; i !== r; ++i) {
          const r = e[i]
          r.id in t && n.push(r)
        }
        return n
      })
    let bc = 0
    function Mc (e) {
      const t = e.split('\n')
      for (let n = 0; n < t.length; n++) t[n] = n + 1 + ': ' + t[n]
      return t.join('\n')
    }
    function Sc (e) {
      switch (e) {
        case dn:
          return ['Linear', '( value )']
        case pn:
          return ['sRGB', '( value )']
        case mn:
          return ['RGBE', '( value )']
        case vn:
          return ['RGBM', '( value, 7.0 )']
        case yn:
          return ['RGBM', '( value, 16.0 )']
        case _n:
          return ['RGBD', '( value, 256.0 )']
        case fn:
          return ['Gamma', '( value, float( GAMMA_FACTOR ) )']
        case gn:
          return ['LogLuv', '( value )']
        default:
          return (
            console.warn('THREE.WebGLProgram: Unsupported encoding:', e),
            ['Linear', '( value )']
          )
      }
    }
    function Ec (e, t, n) {
      const i = e.getShaderParameter(t, 35713),
        r = e.getShaderInfoLog(t).trim()
      if (i && '' === r) return ''
      const a = e.getShaderSource(t)
      return 'THREE.WebGLShader: gl.getShaderInfoLog() ' + n + '\n' + r + Mc(a)
    }
    function Tc (e, t) {
      const n = Sc(t)
      return (
        'vec4 ' +
        e +
        '( vec4 value ) { return ' +
        n[0] +
        'ToLinear' +
        n[1] +
        '; }'
      )
    }
    function Ac (e, t) {
      const n = Sc(t)
      return (
        'vec4 ' + e + '( vec4 value ) { return LinearTo' + n[0] + n[1] + '; }'
      )
    }
    function Rc (e, t) {
      let n
      switch (t) {
        case we:
          n = 'Linear'
          break
        case be:
          n = 'Reinhard'
          break
        case Me:
          n = 'OptimizedCineon'
          break
        case Se:
          n = 'ACESFilmic'
          break
        case Ee:
          n = 'Custom'
          break
        default:
          console.warn('THREE.WebGLProgram: Unsupported toneMapping:', t),
            (n = 'Linear')
      }
      return (
        'vec3 ' + e + '( vec3 color ) { return ' + n + 'ToneMapping( color ); }'
      )
    }
    function Lc (e) {
      const t = [
        e.extensionDerivatives ||
        e.envMapCubeUV ||
        e.bumpMap ||
        e.tangentSpaceNormalMap ||
        e.clearcoatNormalMap ||
        e.flatShading ||
        'physical' === e.shaderID
          ? '#extension GL_OES_standard_derivatives : enable'
          : '',
        (e.extensionFragDepth || e.logarithmicDepthBuffer) &&
        e.rendererExtensionFragDepth
          ? '#extension GL_EXT_frag_depth : enable'
          : '',
        e.extensionDrawBuffers && e.rendererExtensionDrawBuffers
          ? '#extension GL_EXT_draw_buffers : require'
          : '',
        (e.extensionShaderTextureLOD || e.envMap || e.transmission > 0) &&
        e.rendererExtensionShaderTextureLod
          ? '#extension GL_EXT_shader_texture_lod : enable'
          : ''
      ]
      return t.filter(Dc).join('\n')
    }
    function Cc (e) {
      const t = []
      for (const n in e) {
        const i = e[n]
        !1 !== i && t.push('#define ' + n + ' ' + i)
      }
      return t.join('\n')
    }
    function Pc (e, t) {
      const n = {},
        i = e.getProgramParameter(t, 35721)
      for (let r = 0; r < i; r++) {
        const i = e.getActiveAttrib(t, r),
          a = i.name
        n[a] = e.getAttribLocation(t, a)
      }
      return n
    }
    function Dc (e) {
      return '' !== e
    }
    function Ic (e, t) {
      return e
        .replace(/NUM_DIR_LIGHTS/g, t.numDirLights)
        .replace(/NUM_SPOT_LIGHTS/g, t.numSpotLights)
        .replace(/NUM_RECT_AREA_LIGHTS/g, t.numRectAreaLights)
        .replace(/NUM_POINT_LIGHTS/g, t.numPointLights)
        .replace(/NUM_HEMI_LIGHTS/g, t.numHemiLights)
        .replace(/NUM_DIR_LIGHT_SHADOWS/g, t.numDirLightShadows)
        .replace(/NUM_SPOT_LIGHT_SHADOWS/g, t.numSpotLightShadows)
        .replace(/NUM_POINT_LIGHT_SHADOWS/g, t.numPointLightShadows)
    }
    function Nc (e, t) {
      return e
        .replace(/NUM_CLIPPING_PLANES/g, t.numClippingPlanes)
        .replace(
          /UNION_CLIPPING_PLANES/g,
          t.numClippingPlanes - t.numClipIntersection
        )
    }
    const Oc = /^[ \t]*#include +<([\w\d./]+)>/gm
    function Fc (e) {
      return e.replace(Oc, Bc)
    }
    function Bc (e, t) {
      const n = Qo[t]
      if (void 0 === n) throw new Error('Can not resolve #include <' + t + '>')
      return Fc(n)
    }
    const zc = /#pragma unroll_loop[\s]+?for \( int i \= (\d+)\; i < (\d+)\; i \+\+ \) \{([\s\S]+?)(?=\})\}/g,
      Uc = /#pragma unroll_loop_start\s+for\s*\(\s*int\s+i\s*=\s*(\d+)\s*;\s*i\s*<\s*(\d+)\s*;\s*i\s*\+\+\s*\)\s*{([\s\S]+?)}\s+#pragma unroll_loop_end/g
    function kc (e) {
      return e.replace(Uc, Wc).replace(zc, Hc)
    }
    function Hc (e, t, n, i) {
      return (
        console.warn(
          'WebGLProgram: #pragma unroll_loop shader syntax is deprecated. Please use #pragma unroll_loop_start syntax instead.'
        ),
        Wc(e, t, n, i)
      )
    }
    function Wc (e, t, n, i) {
      let r = ''
      for (let a = parseInt(t); a < parseInt(n); a++)
        r += i
          .replace(/\[\s*i\s*\]/g, '[ ' + a + ' ]')
          .replace(/UNROLLED_LOOP_INDEX/g, a)
      return r
    }
    function Vc (e) {
      let t =
        'precision ' +
        e.precision +
        ' float;\nprecision ' +
        e.precision +
        ' int;'
      return (
        'highp' === e.precision
          ? (t += '\n#define HIGH_PRECISION')
          : 'mediump' === e.precision
          ? (t += '\n#define MEDIUM_PRECISION')
          : 'lowp' === e.precision && (t += '\n#define LOW_PRECISION'),
        t
      )
    }
    function Gc (e) {
      let t = 'SHADOWMAP_TYPE_BASIC'
      return (
        e.shadowMapType === N
          ? (t = 'SHADOWMAP_TYPE_PCF')
          : e.shadowMapType === O
          ? (t = 'SHADOWMAP_TYPE_PCF_SOFT')
          : e.shadowMapType === F && (t = 'SHADOWMAP_TYPE_VSM'),
        t
      )
    }
    function jc (e) {
      let t = 'ENVMAP_TYPE_CUBE'
      if (e.envMap)
        switch (e.envMapMode) {
          case Ae:
          case Re:
            t = 'ENVMAP_TYPE_CUBE'
            break
          case Pe:
          case De:
            t = 'ENVMAP_TYPE_CUBE_UV'
            break
        }
      return t
    }
    function qc (e) {
      let t = 'ENVMAP_MODE_REFLECTION'
      if (e.envMap)
        switch (e.envMapMode) {
          case Re:
          case De:
            t = 'ENVMAP_MODE_REFRACTION'
            break
        }
      return t
    }
    function Yc (e) {
      let t = 'ENVMAP_BLENDING_NONE'
      if (e.envMap)
        switch (e.combine) {
          case ve:
            t = 'ENVMAP_BLENDING_MULTIPLY'
            break
          case ye:
            t = 'ENVMAP_BLENDING_MIX'
            break
          case _e:
            t = 'ENVMAP_BLENDING_ADD'
            break
        }
      return t
    }
    function Xc (e, t, n, i) {
      const r = e.getContext(),
        a = n.defines
      let s = n.vertexShader,
        o = n.fragmentShader
      const l = Gc(n),
        c = jc(n),
        h = qc(n),
        u = Yc(n),
        d = e.gammaFactor > 0 ? e.gammaFactor : 1,
        p = n.isWebGL2 ? '' : Lc(n),
        f = Cc(a),
        m = r.createProgram()
      let g,
        v,
        y = n.glslVersion ? '#version ' + n.glslVersion + '\n' : ''
      n.isRawShaderMaterial
        ? ((g = [f].filter(Dc).join('\n')),
          g.length > 0 && (g += '\n'),
          (v = [p, f].filter(Dc).join('\n')),
          v.length > 0 && (v += '\n'))
        : ((g = [
            Vc(n),
            '#define SHADER_NAME ' + n.shaderName,
            f,
            n.instancing ? '#define USE_INSTANCING' : '',
            n.instancingColor ? '#define USE_INSTANCING_COLOR' : '',
            n.supportsVertexTextures ? '#define VERTEX_TEXTURES' : '',
            '#define GAMMA_FACTOR ' + d,
            '#define MAX_BONES ' + n.maxBones,
            n.useFog && n.fog ? '#define USE_FOG' : '',
            n.useFog && n.fogExp2 ? '#define FOG_EXP2' : '',
            n.map ? '#define USE_MAP' : '',
            n.envMap ? '#define USE_ENVMAP' : '',
            n.envMap ? '#define ' + h : '',
            n.lightMap ? '#define USE_LIGHTMAP' : '',
            n.aoMap ? '#define USE_AOMAP' : '',
            n.emissiveMap ? '#define USE_EMISSIVEMAP' : '',
            n.bumpMap ? '#define USE_BUMPMAP' : '',
            n.normalMap ? '#define USE_NORMALMAP' : '',
            n.normalMap && n.objectSpaceNormalMap
              ? '#define OBJECTSPACE_NORMALMAP'
              : '',
            n.normalMap && n.tangentSpaceNormalMap
              ? '#define TANGENTSPACE_NORMALMAP'
              : '',
            n.clearcoatMap ? '#define USE_CLEARCOATMAP' : '',
            n.clearcoatRoughnessMap ? '#define USE_CLEARCOAT_ROUGHNESSMAP' : '',
            n.clearcoatNormalMap ? '#define USE_CLEARCOAT_NORMALMAP' : '',
            n.displacementMap && n.supportsVertexTextures
              ? '#define USE_DISPLACEMENTMAP'
              : '',
            n.specularMap ? '#define USE_SPECULARMAP' : '',
            n.roughnessMap ? '#define USE_ROUGHNESSMAP' : '',
            n.metalnessMap ? '#define USE_METALNESSMAP' : '',
            n.alphaMap ? '#define USE_ALPHAMAP' : '',
            n.transmission ? '#define USE_TRANSMISSION' : '',
            n.transmissionMap ? '#define USE_TRANSMISSIONMAP' : '',
            n.thicknessMap ? '#define USE_THICKNESSMAP' : '',
            n.vertexTangents ? '#define USE_TANGENT' : '',
            n.vertexColors ? '#define USE_COLOR' : '',
            n.vertexAlphas ? '#define USE_COLOR_ALPHA' : '',
            n.vertexUvs ? '#define USE_UV' : '',
            n.uvsVertexOnly ? '#define UVS_VERTEX_ONLY' : '',
            n.flatShading ? '#define FLAT_SHADED' : '',
            n.skinning ? '#define USE_SKINNING' : '',
            n.useVertexTexture ? '#define BONE_TEXTURE' : '',
            n.morphTargets ? '#define USE_MORPHTARGETS' : '',
            n.morphNormals && !1 === n.flatShading
              ? '#define USE_MORPHNORMALS'
              : '',
            n.doubleSided ? '#define DOUBLE_SIDED' : '',
            n.flipSided ? '#define FLIP_SIDED' : '',
            n.shadowMapEnabled ? '#define USE_SHADOWMAP' : '',
            n.shadowMapEnabled ? '#define ' + l : '',
            n.sizeAttenuation ? '#define USE_SIZEATTENUATION' : '',
            n.logarithmicDepthBuffer ? '#define USE_LOGDEPTHBUF' : '',
            n.logarithmicDepthBuffer && n.rendererExtensionFragDepth
              ? '#define USE_LOGDEPTHBUF_EXT'
              : '',
            'uniform mat4 modelMatrix;',
            'uniform mat4 modelViewMatrix;',
            'uniform mat4 projectionMatrix;',
            'uniform mat4 viewMatrix;',
            'uniform mat3 normalMatrix;',
            'uniform vec3 cameraPosition;',
            'uniform bool isOrthographic;',
            '#ifdef USE_INSTANCING',
            '\tattribute mat4 instanceMatrix;',
            '#endif',
            '#ifdef USE_INSTANCING_COLOR',
            '\tattribute vec3 instanceColor;',
            '#endif',
            'attribute vec3 position;',
            'attribute vec3 normal;',
            'attribute vec2 uv;',
            '#ifdef USE_TANGENT',
            '\tattribute vec4 tangent;',
            '#endif',
            '#if defined( USE_COLOR_ALPHA )',
            '\tattribute vec4 color;',
            '#elif defined( USE_COLOR )',
            '\tattribute vec3 color;',
            '#endif',
            '#ifdef USE_MORPHTARGETS',
            '\tattribute vec3 morphTarget0;',
            '\tattribute vec3 morphTarget1;',
            '\tattribute vec3 morphTarget2;',
            '\tattribute vec3 morphTarget3;',
            '\t#ifdef USE_MORPHNORMALS',
            '\t\tattribute vec3 morphNormal0;',
            '\t\tattribute vec3 morphNormal1;',
            '\t\tattribute vec3 morphNormal2;',
            '\t\tattribute vec3 morphNormal3;',
            '\t#else',
            '\t\tattribute vec3 morphTarget4;',
            '\t\tattribute vec3 morphTarget5;',
            '\t\tattribute vec3 morphTarget6;',
            '\t\tattribute vec3 morphTarget7;',
            '\t#endif',
            '#endif',
            '#ifdef USE_SKINNING',
            '\tattribute vec4 skinIndex;',
            '\tattribute vec4 skinWeight;',
            '#endif',
            '\n'
          ]
            .filter(Dc)
            .join('\n')),
          (v = [
            p,
            Vc(n),
            '#define SHADER_NAME ' + n.shaderName,
            f,
            n.alphaTest
              ? '#define ALPHATEST ' +
                n.alphaTest +
                (n.alphaTest % 1 ? '' : '.0')
              : '',
            '#define GAMMA_FACTOR ' + d,
            n.useFog && n.fog ? '#define USE_FOG' : '',
            n.useFog && n.fogExp2 ? '#define FOG_EXP2' : '',
            n.map ? '#define USE_MAP' : '',
            n.matcap ? '#define USE_MATCAP' : '',
            n.envMap ? '#define USE_ENVMAP' : '',
            n.envMap ? '#define ' + c : '',
            n.envMap ? '#define ' + h : '',
            n.envMap ? '#define ' + u : '',
            n.lightMap ? '#define USE_LIGHTMAP' : '',
            n.aoMap ? '#define USE_AOMAP' : '',
            n.emissiveMap ? '#define USE_EMISSIVEMAP' : '',
            n.bumpMap ? '#define USE_BUMPMAP' : '',
            n.normalMap ? '#define USE_NORMALMAP' : '',
            n.normalMap && n.objectSpaceNormalMap
              ? '#define OBJECTSPACE_NORMALMAP'
              : '',
            n.normalMap && n.tangentSpaceNormalMap
              ? '#define TANGENTSPACE_NORMALMAP'
              : '',
            n.clearcoatMap ? '#define USE_CLEARCOATMAP' : '',
            n.clearcoatRoughnessMap ? '#define USE_CLEARCOAT_ROUGHNESSMAP' : '',
            n.clearcoatNormalMap ? '#define USE_CLEARCOAT_NORMALMAP' : '',
            n.specularMap ? '#define USE_SPECULARMAP' : '',
            n.roughnessMap ? '#define USE_ROUGHNESSMAP' : '',
            n.metalnessMap ? '#define USE_METALNESSMAP' : '',
            n.alphaMap ? '#define USE_ALPHAMAP' : '',
            n.sheen ? '#define USE_SHEEN' : '',
            n.transmission ? '#define USE_TRANSMISSION' : '',
            n.transmissionMap ? '#define USE_TRANSMISSIONMAP' : '',
            n.thicknessMap ? '#define USE_THICKNESSMAP' : '',
            n.vertexTangents ? '#define USE_TANGENT' : '',
            n.vertexColors || n.instancingColor ? '#define USE_COLOR' : '',
            n.vertexAlphas ? '#define USE_COLOR_ALPHA' : '',
            n.vertexUvs ? '#define USE_UV' : '',
            n.uvsVertexOnly ? '#define UVS_VERTEX_ONLY' : '',
            n.gradientMap ? '#define USE_GRADIENTMAP' : '',
            n.flatShading ? '#define FLAT_SHADED' : '',
            n.doubleSided ? '#define DOUBLE_SIDED' : '',
            n.flipSided ? '#define FLIP_SIDED' : '',
            n.shadowMapEnabled ? '#define USE_SHADOWMAP' : '',
            n.shadowMapEnabled ? '#define ' + l : '',
            n.premultipliedAlpha ? '#define PREMULTIPLIED_ALPHA' : '',
            n.physicallyCorrectLights
              ? '#define PHYSICALLY_CORRECT_LIGHTS'
              : '',
            n.logarithmicDepthBuffer ? '#define USE_LOGDEPTHBUF' : '',
            n.logarithmicDepthBuffer && n.rendererExtensionFragDepth
              ? '#define USE_LOGDEPTHBUF_EXT'
              : '',
            (n.extensionShaderTextureLOD || n.envMap) &&
            n.rendererExtensionShaderTextureLod
              ? '#define TEXTURE_LOD_EXT'
              : '',
            'uniform mat4 viewMatrix;',
            'uniform vec3 cameraPosition;',
            'uniform bool isOrthographic;',
            n.toneMapping !== xe ? '#define TONE_MAPPING' : '',
            n.toneMapping !== xe ? Qo['tonemapping_pars_fragment'] : '',
            n.toneMapping !== xe ? Rc('toneMapping', n.toneMapping) : '',
            n.dithering ? '#define DITHERING' : '',
            Qo['encodings_pars_fragment'],
            n.map ? Tc('mapTexelToLinear', n.mapEncoding) : '',
            n.matcap ? Tc('matcapTexelToLinear', n.matcapEncoding) : '',
            n.envMap ? Tc('envMapTexelToLinear', n.envMapEncoding) : '',
            n.emissiveMap
              ? Tc('emissiveMapTexelToLinear', n.emissiveMapEncoding)
              : '',
            n.lightMap ? Tc('lightMapTexelToLinear', n.lightMapEncoding) : '',
            Ac('linearToOutputTexel', n.outputEncoding),
            n.depthPacking ? '#define DEPTH_PACKING ' + n.depthPacking : '',
            '\n'
          ]
            .filter(Dc)
            .join('\n'))),
        (s = Fc(s)),
        (s = Ic(s, n)),
        (s = Nc(s, n)),
        (o = Fc(o)),
        (o = Ic(o, n)),
        (o = Nc(o, n)),
        (s = kc(s)),
        (o = kc(o)),
        n.isWebGL2 &&
          !0 !== n.isRawShaderMaterial &&
          ((y = '#version 300 es\n'),
          (g =
            [
              '#define attribute in',
              '#define varying out',
              '#define texture2D texture'
            ].join('\n') +
            '\n' +
            g),
          (v =
            [
              '#define varying in',
              n.glslVersion === Rn ? '' : 'out highp vec4 pc_fragColor;',
              n.glslVersion === Rn ? '' : '#define gl_FragColor pc_fragColor',
              '#define gl_FragDepthEXT gl_FragDepth',
              '#define texture2D texture',
              '#define textureCube texture',
              '#define texture2DProj textureProj',
              '#define texture2DLodEXT textureLod',
              '#define texture2DProjLodEXT textureProjLod',
              '#define textureCubeLodEXT textureLod',
              '#define texture2DGradEXT textureGrad',
              '#define texture2DProjGradEXT textureProjGrad',
              '#define textureCubeGradEXT textureGrad'
            ].join('\n') +
            '\n' +
            v))
      const _ = y + g + s,
        x = y + v + o,
        w = wc(r, 35633, _),
        b = wc(r, 35632, x)
      if (
        (r.attachShader(m, w),
        r.attachShader(m, b),
        void 0 !== n.index0AttributeName
          ? r.bindAttribLocation(m, 0, n.index0AttributeName)
          : !0 === n.morphTargets && r.bindAttribLocation(m, 0, 'position'),
        r.linkProgram(m),
        e.debug.checkShaderErrors)
      ) {
        const e = r.getProgramInfoLog(m).trim(),
          t = r.getShaderInfoLog(w).trim(),
          n = r.getShaderInfoLog(b).trim()
        let i = !0,
          a = !0
        if (!1 === r.getProgramParameter(m, 35714)) {
          i = !1
          const t = Ec(r, w, 'vertex'),
            n = Ec(r, b, 'fragment')
          console.error(
            'THREE.WebGLProgram: shader error: ',
            r.getError(),
            '35715',
            r.getProgramParameter(m, 35715),
            'gl.getProgramInfoLog',
            e,
            t,
            n
          )
        } else
          '' !== e
            ? console.warn('THREE.WebGLProgram: gl.getProgramInfoLog()', e)
            : ('' !== t && '' !== n) || (a = !1)
        a &&
          (this.diagnostics = {
            runnable: i,
            programLog: e,
            vertexShader: { log: t, prefix: g },
            fragmentShader: { log: n, prefix: v }
          })
      }
      let M, S
      return (
        r.deleteShader(w),
        r.deleteShader(b),
        (this.getUniforms = function () {
          return void 0 === M && (M = new xc(r, m)), M
        }),
        (this.getAttributes = function () {
          return void 0 === S && (S = Pc(r, m)), S
        }),
        (this.destroy = function () {
          i.releaseStatesOfProgram(this),
            r.deleteProgram(m),
            (this.program = void 0)
        }),
        (this.name = n.shaderName),
        (this.id = bc++),
        (this.cacheKey = t),
        (this.usedTimes = 1),
        (this.program = m),
        (this.vertexShader = w),
        (this.fragmentShader = b),
        this
      )
    }
    function Jc (e, t, n, i, r, a) {
      const s = [],
        o = i.isWebGL2,
        l = i.logarithmicDepthBuffer,
        c = i.floatVertexTextures,
        h = i.maxVertexUniforms,
        u = i.vertexTextures
      let d = i.precision
      const p = {
          MeshDepthMaterial: 'depth',
          MeshDistanceMaterial: 'distanceRGBA',
          MeshNormalMaterial: 'normal',
          MeshBasicMaterial: 'basic',
          MeshLambertMaterial: 'lambert',
          MeshPhongMaterial: 'phong',
          MeshToonMaterial: 'toon',
          MeshStandardMaterial: 'physical',
          MeshPhysicalMaterial: 'physical',
          MeshMatcapMaterial: 'matcap',
          LineBasicMaterial: 'basic',
          LineDashedMaterial: 'dashed',
          PointsMaterial: 'points',
          ShadowMaterial: 'shadow',
          SpriteMaterial: 'sprite'
        },
        f = [
          'precision',
          'isWebGL2',
          'supportsVertexTextures',
          'outputEncoding',
          'instancing',
          'instancingColor',
          'map',
          'mapEncoding',
          'matcap',
          'matcapEncoding',
          'envMap',
          'envMapMode',
          'envMapEncoding',
          'envMapCubeUV',
          'lightMap',
          'lightMapEncoding',
          'aoMap',
          'emissiveMap',
          'emissiveMapEncoding',
          'bumpMap',
          'normalMap',
          'objectSpaceNormalMap',
          'tangentSpaceNormalMap',
          'clearcoatMap',
          'clearcoatRoughnessMap',
          'clearcoatNormalMap',
          'displacementMap',
          'specularMap',
          'roughnessMap',
          'metalnessMap',
          'gradientMap',
          'alphaMap',
          'combine',
          'vertexColors',
          'vertexAlphas',
          'vertexTangents',
          'vertexUvs',
          'uvsVertexOnly',
          'fog',
          'useFog',
          'fogExp2',
          'flatShading',
          'sizeAttenuation',
          'logarithmicDepthBuffer',
          'skinning',
          'maxBones',
          'useVertexTexture',
          'morphTargets',
          'morphNormals',
          'premultipliedAlpha',
          'numDirLights',
          'numPointLights',
          'numSpotLights',
          'numHemiLights',
          'numRectAreaLights',
          'numDirLightShadows',
          'numPointLightShadows',
          'numSpotLightShadows',
          'shadowMapEnabled',
          'shadowMapType',
          'toneMapping',
          'physicallyCorrectLights',
          'alphaTest',
          'doubleSided',
          'flipSided',
          'numClippingPlanes',
          'numClipIntersection',
          'depthPacking',
          'dithering',
          'sheen',
          'transmission',
          'transmissionMap',
          'thicknessMap'
        ]
      function m (e) {
        const t = e.skeleton,
          n = t.bones
        if (c) return 1024
        {
          const e = h,
            t = Math.floor((e - 20) / 4),
            i = Math.min(t, n.length)
          return i < n.length
            ? (console.warn(
                'THREE.WebGLRenderer: Skeleton has ' +
                  n.length +
                  ' bones. This GPU supports ' +
                  i +
                  '.'
              ),
              0)
            : i
        }
      }
      function g (e) {
        let t
        return (
          e && e.isTexture
            ? (t = e.encoding)
            : e && e.isWebGLRenderTarget
            ? (console.warn(
                "THREE.WebGLPrograms.getTextureEncodingFromMap: don't use render targets as textures. Use their .texture property instead."
              ),
              (t = e.texture.encoding))
            : (t = dn),
          t
        )
      }
      function v (r, s, h, f, v) {
        const y = f.fog,
          _ = r.isMeshStandardMaterial ? f.environment : null,
          x = t.get(r.envMap || _),
          w = p[r.type],
          b = v.isSkinnedMesh ? m(v) : 0
        let M, S
        if (
          (null !== r.precision &&
            ((d = i.getMaxPrecision(r.precision)),
            d !== r.precision &&
              console.warn(
                'THREE.WebGLProgram.getParameters:',
                r.precision,
                'not supported, using',
                d,
                'instead.'
              )),
          w)
        ) {
          const e = el[w]
          ;(M = e.vertexShader), (S = e.fragmentShader)
        } else (M = r.vertexShader), (S = r.fragmentShader)
        const E = e.getRenderTarget(),
          T = {
            isWebGL2: o,
            shaderID: w,
            shaderName: r.type,
            vertexShader: M,
            fragmentShader: S,
            defines: r.defines,
            isRawShaderMaterial: !0 === r.isRawShaderMaterial,
            glslVersion: r.glslVersion,
            precision: d,
            instancing: !0 === v.isInstancedMesh,
            instancingColor:
              !0 === v.isInstancedMesh && null !== v.instanceColor,
            supportsVertexTextures: u,
            outputEncoding: null !== E ? g(E.texture) : e.outputEncoding,
            map: !!r.map,
            mapEncoding: g(r.map),
            matcap: !!r.matcap,
            matcapEncoding: g(r.matcap),
            envMap: !!x,
            envMapMode: x && x.mapping,
            envMapEncoding: g(x),
            envMapCubeUV: !!x && (x.mapping === Pe || x.mapping === De),
            lightMap: !!r.lightMap,
            lightMapEncoding: g(r.lightMap),
            aoMap: !!r.aoMap,
            emissiveMap: !!r.emissiveMap,
            emissiveMapEncoding: g(r.emissiveMap),
            bumpMap: !!r.bumpMap,
            normalMap: !!r.normalMap,
            objectSpaceNormalMap: r.normalMapType === Mn,
            tangentSpaceNormalMap: r.normalMapType === bn,
            clearcoatMap: !!r.clearcoatMap,
            clearcoatRoughnessMap: !!r.clearcoatRoughnessMap,
            clearcoatNormalMap: !!r.clearcoatNormalMap,
            displacementMap: !!r.displacementMap,
            roughnessMap: !!r.roughnessMap,
            metalnessMap: !!r.metalnessMap,
            specularMap: !!r.specularMap,
            alphaMap: !!r.alphaMap,
            gradientMap: !!r.gradientMap,
            sheen: !!r.sheen,
            transmission: !!r.transmission,
            transmissionMap: !!r.transmissionMap,
            thicknessMap: !!r.thicknessMap,
            combine: r.combine,
            vertexTangents: r.normalMap && r.vertexTangents,
            vertexColors: r.vertexColors,
            vertexAlphas:
              !0 === r.vertexColors &&
              v.geometry &&
              v.geometry.attributes.color &&
              4 === v.geometry.attributes.color.itemSize,
            vertexUvs:
              !!r.map ||
              !!r.bumpMap ||
              !!r.normalMap ||
              !!r.specularMap ||
              !!r.alphaMap ||
              !!r.emissiveMap ||
              !!r.roughnessMap ||
              !!r.metalnessMap ||
              !!r.clearcoatMap ||
              !!r.clearcoatRoughnessMap ||
              !!r.clearcoatNormalMap ||
              !!r.displacementMap ||
              !!r.transmissionMap ||
              !!r.thicknessMap,
            uvsVertexOnly:
              !(
                r.map ||
                r.bumpMap ||
                r.normalMap ||
                r.specularMap ||
                r.alphaMap ||
                r.emissiveMap ||
                r.roughnessMap ||
                r.metalnessMap ||
                r.clearcoatNormalMap ||
                r.transmission ||
                r.transmissionMap ||
                r.thicknessMap
              ) && !!r.displacementMap,
            fog: !!y,
            useFog: r.fog,
            fogExp2: y && y.isFogExp2,
            flatShading: !!r.flatShading,
            sizeAttenuation: r.sizeAttenuation,
            logarithmicDepthBuffer: l,
            skinning: !0 === v.isSkinnedMesh && b > 0,
            maxBones: b,
            useVertexTexture: c,
            morphTargets: r.morphTargets,
            morphNormals: r.morphNormals,
            numDirLights: s.directional.length,
            numPointLights: s.point.length,
            numSpotLights: s.spot.length,
            numRectAreaLights: s.rectArea.length,
            numHemiLights: s.hemi.length,
            numDirLightShadows: s.directionalShadowMap.length,
            numPointLightShadows: s.pointShadowMap.length,
            numSpotLightShadows: s.spotShadowMap.length,
            numClippingPlanes: a.numPlanes,
            numClipIntersection: a.numIntersection,
            dithering: r.dithering,
            shadowMapEnabled: e.shadowMap.enabled && h.length > 0,
            shadowMapType: e.shadowMap.type,
            toneMapping: r.toneMapped ? e.toneMapping : xe,
            physicallyCorrectLights: e.physicallyCorrectLights,
            premultipliedAlpha: r.premultipliedAlpha,
            alphaTest: r.alphaTest,
            doubleSided: r.side === U,
            flipSided: r.side === z,
            depthPacking: void 0 !== r.depthPacking && r.depthPacking,
            index0AttributeName: r.index0AttributeName,
            extensionDerivatives: r.extensions && r.extensions.derivatives,
            extensionFragDepth: r.extensions && r.extensions.fragDepth,
            extensionDrawBuffers: r.extensions && r.extensions.drawBuffers,
            extensionShaderTextureLOD:
              r.extensions && r.extensions.shaderTextureLOD,
            rendererExtensionFragDepth: o || n.has('EXT_frag_depth'),
            rendererExtensionDrawBuffers: o || n.has('WEBGL_draw_buffers'),
            rendererExtensionShaderTextureLod:
              o || n.has('EXT_shader_texture_lod'),
            customProgramCacheKey: r.customProgramCacheKey()
          }
        return T
      }
      function y (t) {
        const n = []
        if (
          (t.shaderID
            ? n.push(t.shaderID)
            : (n.push(t.fragmentShader), n.push(t.vertexShader)),
          void 0 !== t.defines)
        )
          for (const e in t.defines) n.push(e), n.push(t.defines[e])
        if (!1 === t.isRawShaderMaterial) {
          for (let e = 0; e < f.length; e++) n.push(t[f[e]])
          n.push(e.outputEncoding), n.push(e.gammaFactor)
        }
        return n.push(t.customProgramCacheKey), n.join()
      }
      function _ (e) {
        const t = p[e.type]
        let n
        if (t) {
          const e = el[t]
          n = ca.clone(e.uniforms)
        } else n = e.uniforms
        return n
      }
      function x (t, n) {
        let i
        for (let e = 0, r = s.length; e < r; e++) {
          const t = s[e]
          if (t.cacheKey === n) {
            ;(i = t), ++i.usedTimes
            break
          }
        }
        return void 0 === i && ((i = new Xc(e, n, t, r)), s.push(i)), i
      }
      function w (e) {
        if (0 === --e.usedTimes) {
          const t = s.indexOf(e)
          ;(s[t] = s[s.length - 1]), s.pop(), e.destroy()
        }
      }
      return {
        getParameters: v,
        getProgramCacheKey: y,
        getUniforms: _,
        acquireProgram: x,
        releaseProgram: w,
        programs: s
      }
    }
    function Zc () {
      let e = new WeakMap()
      function t (t) {
        let n = e.get(t)
        return void 0 === n && ((n = {}), e.set(t, n)), n
      }
      function n (t) {
        e.delete(t)
      }
      function i (t, n, i) {
        e.get(t)[n] = i
      }
      function r () {
        e = new WeakMap()
      }
      return { get: t, remove: n, update: i, dispose: r }
    }
    function Kc (e, t) {
      return e.groupOrder !== t.groupOrder
        ? e.groupOrder - t.groupOrder
        : e.renderOrder !== t.renderOrder
        ? e.renderOrder - t.renderOrder
        : e.program !== t.program
        ? e.program.id - t.program.id
        : e.material.id !== t.material.id
        ? e.material.id - t.material.id
        : e.z !== t.z
        ? e.z - t.z
        : e.id - t.id
    }
    function Qc (e, t) {
      return e.groupOrder !== t.groupOrder
        ? e.groupOrder - t.groupOrder
        : e.renderOrder !== t.renderOrder
        ? e.renderOrder - t.renderOrder
        : e.z !== t.z
        ? t.z - e.z
        : e.id - t.id
    }
    function $c (e) {
      const t = []
      let n = 0
      const i = [],
        r = [],
        a = [],
        s = { id: -1 }
      function o () {
        ;(n = 0), (i.length = 0), (r.length = 0), (a.length = 0)
      }
      function l (i, r, a, o, l, c) {
        let h = t[n]
        const u = e.get(a)
        return (
          void 0 === h
            ? ((h = {
                id: i.id,
                object: i,
                geometry: r,
                material: a,
                program: u.program || s,
                groupOrder: o,
                renderOrder: i.renderOrder,
                z: l,
                group: c
              }),
              (t[n] = h))
            : ((h.id = i.id),
              (h.object = i),
              (h.geometry = r),
              (h.material = a),
              (h.program = u.program || s),
              (h.groupOrder = o),
              (h.renderOrder = i.renderOrder),
              (h.z = l),
              (h.group = c)),
          n++,
          h
        )
      }
      function c (e, t, n, s, o, c) {
        const h = l(e, t, n, s, o, c)
        n.transmission > 0
          ? r.push(h)
          : !0 === n.transparent
          ? a.push(h)
          : i.push(h)
      }
      function h (e, t, n, s, o, c) {
        const h = l(e, t, n, s, o, c)
        n.transmission > 0
          ? r.unshift(h)
          : !0 === n.transparent
          ? a.unshift(h)
          : i.unshift(h)
      }
      function u (e, t) {
        i.length > 1 && i.sort(e || Kc),
          r.length > 1 && r.sort(t || Qc),
          a.length > 1 && a.sort(t || Qc)
      }
      function d () {
        for (let e = n, i = t.length; e < i; e++) {
          const n = t[e]
          if (null === n.id) break
          ;(n.id = null),
            (n.object = null),
            (n.geometry = null),
            (n.material = null),
            (n.program = null),
            (n.group = null)
        }
      }
      return {
        opaque: i,
        transmissive: r,
        transparent: a,
        init: o,
        push: c,
        unshift: h,
        finish: d,
        sort: u
      }
    }
    function eh (e) {
      let t = new WeakMap()
      function n (n, i) {
        let r
        return (
          !1 === t.has(n)
            ? ((r = new $c(e)), t.set(n, [r]))
            : i >= t.get(n).length
            ? ((r = new $c(e)), t.get(n).push(r))
            : (r = t.get(n)[i]),
          r
        )
      }
      function i () {
        t = new WeakMap()
      }
      return { get: n, dispose: i }
    }
    function th () {
      const e = {}
      return {
        get: function (t) {
          if (void 0 !== e[t.id]) return e[t.id]
          let n
          switch (t.type) {
            case 'DirectionalLight':
              n = { direction: new Qn(), color: new xr() }
              break
            case 'SpotLight':
              n = {
                position: new Qn(),
                direction: new Qn(),
                color: new xr(),
                distance: 0,
                coneCos: 0,
                penumbraCos: 0,
                decay: 0
              }
              break
            case 'PointLight':
              n = { position: new Qn(), color: new xr(), distance: 0, decay: 0 }
              break
            case 'HemisphereLight':
              n = {
                direction: new Qn(),
                skyColor: new xr(),
                groundColor: new xr()
              }
              break
            case 'RectAreaLight':
              n = {
                color: new xr(),
                position: new Qn(),
                halfWidth: new Qn(),
                halfHeight: new Qn()
              }
              break
          }
          return (e[t.id] = n), n
        }
      }
    }
    function nh () {
      const e = {}
      return {
        get: function (t) {
          if (void 0 !== e[t.id]) return e[t.id]
          let n
          switch (t.type) {
            case 'DirectionalLight':
              n = {
                shadowBias: 0,
                shadowNormalBias: 0,
                shadowRadius: 1,
                shadowMapSize: new kn()
              }
              break
            case 'SpotLight':
              n = {
                shadowBias: 0,
                shadowNormalBias: 0,
                shadowRadius: 1,
                shadowMapSize: new kn()
              }
              break
            case 'PointLight':
              n = {
                shadowBias: 0,
                shadowNormalBias: 0,
                shadowRadius: 1,
                shadowMapSize: new kn(),
                shadowCameraNear: 1,
                shadowCameraFar: 1e3
              }
              break
          }
          return (e[t.id] = n), n
        }
      }
    }
    let ih = 0
    function rh (e, t) {
      return (t.castShadow ? 1 : 0) - (e.castShadow ? 1 : 0)
    }
    function ah (e, t) {
      const n = new th(),
        i = nh(),
        r = {
          version: 0,
          hash: {
            directionalLength: -1,
            pointLength: -1,
            spotLength: -1,
            rectAreaLength: -1,
            hemiLength: -1,
            numDirectionalShadows: -1,
            numPointShadows: -1,
            numSpotShadows: -1
          },
          ambient: [0, 0, 0],
          probe: [],
          directional: [],
          directionalShadow: [],
          directionalShadowMap: [],
          directionalShadowMatrix: [],
          spot: [],
          spotShadow: [],
          spotShadowMap: [],
          spotShadowMatrix: [],
          rectArea: [],
          rectAreaLTC1: null,
          rectAreaLTC2: null,
          point: [],
          pointShadow: [],
          pointShadowMap: [],
          pointShadowMatrix: [],
          hemi: []
        }
      for (let h = 0; h < 9; h++) r.probe.push(new Qn())
      const a = new Qn(),
        s = new Li(),
        o = new Li()
      function l (a) {
        let s = 0,
          o = 0,
          l = 0
        for (let e = 0; e < 9; e++) r.probe[e].set(0, 0, 0)
        let c = 0,
          h = 0,
          u = 0,
          d = 0,
          p = 0,
          f = 0,
          m = 0,
          g = 0
        a.sort(rh)
        for (let e = 0, t = a.length; e < t; e++) {
          const t = a[e],
            v = t.color,
            y = t.intensity,
            _ = t.distance,
            x = t.shadow && t.shadow.map ? t.shadow.map.texture : null
          if (t.isAmbientLight) (s += v.r * y), (o += v.g * y), (l += v.b * y)
          else if (t.isLightProbe)
            for (let e = 0; e < 9; e++)
              r.probe[e].addScaledVector(t.sh.coefficients[e], y)
          else if (t.isDirectionalLight) {
            const e = n.get(t)
            if (
              (e.color.copy(t.color).multiplyScalar(t.intensity), t.castShadow)
            ) {
              const e = t.shadow,
                n = i.get(t)
              ;(n.shadowBias = e.bias),
                (n.shadowNormalBias = e.normalBias),
                (n.shadowRadius = e.radius),
                (n.shadowMapSize = e.mapSize),
                (r.directionalShadow[c] = n),
                (r.directionalShadowMap[c] = x),
                (r.directionalShadowMatrix[c] = t.shadow.matrix),
                f++
            }
            ;(r.directional[c] = e), c++
          } else if (t.isSpotLight) {
            const e = n.get(t)
            if (
              (e.position.setFromMatrixPosition(t.matrixWorld),
              e.color.copy(v).multiplyScalar(y),
              (e.distance = _),
              (e.coneCos = Math.cos(t.angle)),
              (e.penumbraCos = Math.cos(t.angle * (1 - t.penumbra))),
              (e.decay = t.decay),
              t.castShadow)
            ) {
              const e = t.shadow,
                n = i.get(t)
              ;(n.shadowBias = e.bias),
                (n.shadowNormalBias = e.normalBias),
                (n.shadowRadius = e.radius),
                (n.shadowMapSize = e.mapSize),
                (r.spotShadow[u] = n),
                (r.spotShadowMap[u] = x),
                (r.spotShadowMatrix[u] = t.shadow.matrix),
                g++
            }
            ;(r.spot[u] = e), u++
          } else if (t.isRectAreaLight) {
            const e = n.get(t)
            e.color.copy(v).multiplyScalar(y),
              e.halfWidth.set(0.5 * t.width, 0, 0),
              e.halfHeight.set(0, 0.5 * t.height, 0),
              (r.rectArea[d] = e),
              d++
          } else if (t.isPointLight) {
            const e = n.get(t)
            if (
              (e.color.copy(t.color).multiplyScalar(t.intensity),
              (e.distance = t.distance),
              (e.decay = t.decay),
              t.castShadow)
            ) {
              const e = t.shadow,
                n = i.get(t)
              ;(n.shadowBias = e.bias),
                (n.shadowNormalBias = e.normalBias),
                (n.shadowRadius = e.radius),
                (n.shadowMapSize = e.mapSize),
                (n.shadowCameraNear = e.camera.near),
                (n.shadowCameraFar = e.camera.far),
                (r.pointShadow[h] = n),
                (r.pointShadowMap[h] = x),
                (r.pointShadowMatrix[h] = t.shadow.matrix),
                m++
            }
            ;(r.point[h] = e), h++
          } else if (t.isHemisphereLight) {
            const e = n.get(t)
            e.skyColor.copy(t.color).multiplyScalar(y),
              e.groundColor.copy(t.groundColor).multiplyScalar(y),
              (r.hemi[p] = e),
              p++
          }
        }
        d > 0 &&
          (t.isWebGL2 || !0 === e.has('OES_texture_float_linear')
            ? ((r.rectAreaLTC1 = $o.LTC_FLOAT_1),
              (r.rectAreaLTC2 = $o.LTC_FLOAT_2))
            : !0 === e.has('OES_texture_half_float_linear')
            ? ((r.rectAreaLTC1 = $o.LTC_HALF_1),
              (r.rectAreaLTC2 = $o.LTC_HALF_2))
            : console.error(
                'THREE.WebGLRenderer: Unable to use RectAreaLight. Missing WebGL extensions.'
              )),
          (r.ambient[0] = s),
          (r.ambient[1] = o),
          (r.ambient[2] = l)
        const v = r.hash
        ;(v.directionalLength === c &&
          v.pointLength === h &&
          v.spotLength === u &&
          v.rectAreaLength === d &&
          v.hemiLength === p &&
          v.numDirectionalShadows === f &&
          v.numPointShadows === m &&
          v.numSpotShadows === g) ||
          ((r.directional.length = c),
          (r.spot.length = u),
          (r.rectArea.length = d),
          (r.point.length = h),
          (r.hemi.length = p),
          (r.directionalShadow.length = f),
          (r.directionalShadowMap.length = f),
          (r.pointShadow.length = m),
          (r.pointShadowMap.length = m),
          (r.spotShadow.length = g),
          (r.spotShadowMap.length = g),
          (r.directionalShadowMatrix.length = f),
          (r.pointShadowMatrix.length = m),
          (r.spotShadowMatrix.length = g),
          (v.directionalLength = c),
          (v.pointLength = h),
          (v.spotLength = u),
          (v.rectAreaLength = d),
          (v.hemiLength = p),
          (v.numDirectionalShadows = f),
          (v.numPointShadows = m),
          (v.numSpotShadows = g),
          (r.version = ih++))
      }
      function c (e, t) {
        let n = 0,
          i = 0,
          l = 0,
          c = 0,
          h = 0
        const u = t.matrixWorldInverse
        for (let d = 0, p = e.length; d < p; d++) {
          const t = e[d]
          if (t.isDirectionalLight) {
            const e = r.directional[n]
            e.direction.setFromMatrixPosition(t.matrixWorld),
              a.setFromMatrixPosition(t.target.matrixWorld),
              e.direction.sub(a),
              e.direction.transformDirection(u),
              n++
          } else if (t.isSpotLight) {
            const e = r.spot[l]
            e.position.setFromMatrixPosition(t.matrixWorld),
              e.position.applyMatrix4(u),
              e.direction.setFromMatrixPosition(t.matrixWorld),
              a.setFromMatrixPosition(t.target.matrixWorld),
              e.direction.sub(a),
              e.direction.transformDirection(u),
              l++
          } else if (t.isRectAreaLight) {
            const e = r.rectArea[c]
            e.position.setFromMatrixPosition(t.matrixWorld),
              e.position.applyMatrix4(u),
              o.identity(),
              s.copy(t.matrixWorld),
              s.premultiply(u),
              o.extractRotation(s),
              e.halfWidth.set(0.5 * t.width, 0, 0),
              e.halfHeight.set(0, 0.5 * t.height, 0),
              e.halfWidth.applyMatrix4(o),
              e.halfHeight.applyMatrix4(o),
              c++
          } else if (t.isPointLight) {
            const e = r.point[i]
            e.position.setFromMatrixPosition(t.matrixWorld),
              e.position.applyMatrix4(u),
              i++
          } else if (t.isHemisphereLight) {
            const e = r.hemi[h]
            e.direction.setFromMatrixPosition(t.matrixWorld),
              e.direction.transformDirection(u),
              e.direction.normalize(),
              h++
          }
        }
      }
      return { setup: l, setupView: c, state: r }
    }
    function sh (e, t) {
      const n = new ah(e, t),
        i = [],
        r = []
      function a () {
        ;(i.length = 0), (r.length = 0)
      }
      function s (e) {
        i.push(e)
      }
      function o (e) {
        r.push(e)
      }
      function l () {
        n.setup(i)
      }
      function c (e) {
        n.setupView(i, e)
      }
      const h = { lightsArray: i, shadowsArray: r, lights: n }
      return {
        init: a,
        state: h,
        setupLights: l,
        setupLightsView: c,
        pushLight: s,
        pushShadow: o
      }
    }
    function oh (e, t) {
      let n = new WeakMap()
      function i (i, r = 0) {
        let a
        return (
          !1 === n.has(i)
            ? ((a = new sh(e, t)), n.set(i, [a]))
            : r >= n.get(i).length
            ? ((a = new sh(e, t)), n.get(i).push(a))
            : (a = n.get(i)[r]),
          a
        )
      }
      function r () {
        n = new WeakMap()
      }
      return { get: i, dispose: r }
    }
    class lh extends pr {
      constructor (e) {
        super(),
          (this.type = 'MeshDepthMaterial'),
          (this.depthPacking = xn),
          (this.morphTargets = !1),
          (this.map = null),
          (this.alphaMap = null),
          (this.displacementMap = null),
          (this.displacementScale = 1),
          (this.displacementBias = 0),
          (this.wireframe = !1),
          (this.wireframeLinewidth = 1),
          (this.fog = !1),
          this.setValues(e)
      }
      copy (e) {
        return (
          super.copy(e),
          (this.depthPacking = e.depthPacking),
          (this.morphTargets = e.morphTargets),
          (this.map = e.map),
          (this.alphaMap = e.alphaMap),
          (this.displacementMap = e.displacementMap),
          (this.displacementScale = e.displacementScale),
          (this.displacementBias = e.displacementBias),
          (this.wireframe = e.wireframe),
          (this.wireframeLinewidth = e.wireframeLinewidth),
          this
        )
      }
    }
    lh.prototype.isMeshDepthMaterial = !0
    class ch extends pr {
      constructor (e) {
        super(),
          (this.type = 'MeshDistanceMaterial'),
          (this.referencePosition = new Qn()),
          (this.nearDistance = 1),
          (this.farDistance = 1e3),
          (this.morphTargets = !1),
          (this.map = null),
          (this.alphaMap = null),
          (this.displacementMap = null),
          (this.displacementScale = 1),
          (this.displacementBias = 0),
          (this.fog = !1),
          this.setValues(e)
      }
      copy (e) {
        return (
          super.copy(e),
          this.referencePosition.copy(e.referencePosition),
          (this.nearDistance = e.nearDistance),
          (this.farDistance = e.farDistance),
          (this.morphTargets = e.morphTargets),
          (this.map = e.map),
          (this.alphaMap = e.alphaMap),
          (this.displacementMap = e.displacementMap),
          (this.displacementScale = e.displacementScale),
          (this.displacementBias = e.displacementBias),
          this
        )
      }
    }
    ch.prototype.isMeshDistanceMaterial = !0
    var hh =
        'uniform sampler2D shadow_pass;\nuniform vec2 resolution;\nuniform float radius;\n#include <packing>\nvoid main() {\n\tfloat mean = 0.0;\n\tfloat squared_mean = 0.0;\n\tfloat depth = unpackRGBAToDepth( texture2D( shadow_pass, ( gl_FragCoord.xy ) / resolution ) );\n\tfor ( float i = -1.0; i < 1.0 ; i += SAMPLE_RATE) {\n\t\t#ifdef HORIZONTAL_PASS\n\t\t\tvec2 distribution = unpackRGBATo2Half( texture2D( shadow_pass, ( gl_FragCoord.xy + vec2( i, 0.0 ) * radius ) / resolution ) );\n\t\t\tmean += distribution.x;\n\t\t\tsquared_mean += distribution.y * distribution.y + distribution.x * distribution.x;\n\t\t#else\n\t\t\tfloat depth = unpackRGBAToDepth( texture2D( shadow_pass, ( gl_FragCoord.xy + vec2( 0.0, i ) * radius ) / resolution ) );\n\t\t\tmean += depth;\n\t\t\tsquared_mean += depth * depth;\n\t\t#endif\n\t}\n\tmean = mean * HALF_SAMPLE_RATE;\n\tsquared_mean = squared_mean * HALF_SAMPLE_RATE;\n\tfloat std_dev = sqrt( squared_mean - mean * mean );\n\tgl_FragColor = pack2HalfToRGBA( vec2( mean, std_dev ) );\n}',
      uh = 'void main() {\n\tgl_Position = vec4( position, 1.0 );\n}'
    function dh (e, t, n) {
      let i = new Ta()
      const r = new kn(),
        a = new kn(),
        s = new Yn(),
        o = [],
        l = [],
        c = {},
        h = n.maxTextureSize,
        u = { 0: z, 1: B, 2: U },
        d = new da({
          defines: { SAMPLE_RATE: 2 / 8, HALF_SAMPLE_RATE: 1 / 8 },
          uniforms: {
            shadow_pass: { value: null },
            resolution: { value: new kn() },
            radius: { value: 4 }
          },
          vertexShader: uh,
          fragmentShader: hh
        }),
        p = d.clone()
      p.defines.HORIZONTAL_PASS = 1
      const f = new Ur()
      f.setAttribute(
        'position',
        new Sr(new Float32Array([-1, -1, 0.5, 3, -1, 0.5, -1, 3, 0.5]), 3)
      )
      const m = new ia(f, d),
        g = this
      function v (n, i) {
        const r = t.update(m)
        ;(d.uniforms.shadow_pass.value = n.map.texture),
          (d.uniforms.resolution.value = n.mapSize),
          (d.uniforms.radius.value = n.radius),
          e.setRenderTarget(n.mapPass),
          e.clear(),
          e.renderBufferDirect(i, null, r, d, m, null),
          (p.uniforms.shadow_pass.value = n.mapPass.texture),
          (p.uniforms.resolution.value = n.mapSize),
          (p.uniforms.radius.value = n.radius),
          e.setRenderTarget(n.map),
          e.clear(),
          e.renderBufferDirect(i, null, r, p, m, null)
      }
      function y (e) {
        const t = e << 0
        let n = o[t]
        return (
          void 0 === n &&
            ((n = new lh({ depthPacking: wn, morphTargets: e })), (o[t] = n)),
          n
        )
      }
      function _ (e) {
        const t = e << 0
        let n = l[t]
        return (
          void 0 === n && ((n = new ch({ morphTargets: e })), (l[t] = n)), n
        )
      }
      function x (t, n, i, r, a, s, o) {
        let l = null,
          h = y,
          d = t.customDepthMaterial
        if (
          (!0 === r.isPointLight && ((h = _), (d = t.customDistanceMaterial)),
          void 0 === d)
        ) {
          let e = !1
          !0 === i.morphTargets &&
            (e =
              n.morphAttributes &&
              n.morphAttributes.position &&
              n.morphAttributes.position.length > 0),
            (l = h(e))
        } else l = d
        if (
          e.localClippingEnabled &&
          !0 === i.clipShadows &&
          0 !== i.clippingPlanes.length
        ) {
          const e = l.uuid,
            t = i.uuid
          let n = c[e]
          void 0 === n && ((n = {}), (c[e] = n))
          let r = n[t]
          void 0 === r && ((r = l.clone()), (n[t] = r)), (l = r)
        }
        return (
          (l.visible = i.visible),
          (l.wireframe = i.wireframe),
          (l.side =
            o === F
              ? null !== i.shadowSide
                ? i.shadowSide
                : i.side
              : null !== i.shadowSide
              ? i.shadowSide
              : u[i.side]),
          (l.clipShadows = i.clipShadows),
          (l.clippingPlanes = i.clippingPlanes),
          (l.clipIntersection = i.clipIntersection),
          (l.wireframeLinewidth = i.wireframeLinewidth),
          (l.linewidth = i.linewidth),
          !0 === r.isPointLight &&
            !0 === l.isMeshDistanceMaterial &&
            (l.referencePosition.setFromMatrixPosition(r.matrixWorld),
            (l.nearDistance = a),
            (l.farDistance = s)),
          l
        )
      }
      function w (n, r, a, s, o) {
        if (!1 === n.visible) return
        const l = n.layers.test(r.layers)
        if (
          l &&
          (n.isMesh || n.isLine || n.isPoints) &&
          (n.castShadow || (n.receiveShadow && o === F)) &&
          (!n.frustumCulled || i.intersectsObject(n))
        ) {
          n.modelViewMatrix.multiplyMatrices(
            a.matrixWorldInverse,
            n.matrixWorld
          )
          const i = t.update(n),
            r = n.material
          if (Array.isArray(r)) {
            const t = i.groups
            for (let l = 0, c = t.length; l < c; l++) {
              const c = t[l],
                h = r[c.materialIndex]
              if (h && h.visible) {
                const t = x(n, i, h, s, a.near, a.far, o)
                e.renderBufferDirect(a, null, i, t, n, c)
              }
            }
          } else if (r.visible) {
            const t = x(n, i, r, s, a.near, a.far, o)
            e.renderBufferDirect(a, null, i, t, n, null)
          }
        }
        const c = n.children
        for (let e = 0, t = c.length; e < t; e++) w(c[e], r, a, s, o)
      }
      ;(this.enabled = !1),
        (this.autoUpdate = !0),
        (this.needsUpdate = !1),
        (this.type = N),
        (this.render = function (t, n, o) {
          if (!1 === g.enabled) return
          if (!1 === g.autoUpdate && !1 === g.needsUpdate) return
          if (0 === t.length) return
          const l = e.getRenderTarget(),
            c = e.getActiveCubeFace(),
            u = e.getActiveMipmapLevel(),
            d = e.state
          d.setBlending(H),
            d.buffers.color.setClear(1, 1, 1, 1),
            d.buffers.depth.setTest(!0),
            d.setScissorTest(!1)
          for (let p = 0, f = t.length; p < f; p++) {
            const l = t[p],
              c = l.shadow
            if (void 0 === c) {
              console.warn('THREE.WebGLShadowMap:', l, 'has no shadow.')
              continue
            }
            if (!1 === c.autoUpdate && !1 === c.needsUpdate) continue
            r.copy(c.mapSize)
            const u = c.getFrameExtents()
            if (
              (r.multiply(u),
              a.copy(c.mapSize),
              (r.x > h || r.y > h) &&
                (r.x > h &&
                  ((a.x = Math.floor(h / u.x)),
                  (r.x = a.x * u.x),
                  (c.mapSize.x = a.x)),
                r.y > h &&
                  ((a.y = Math.floor(h / u.y)),
                  (r.y = a.y * u.y),
                  (c.mapSize.y = a.y))),
              null === c.map && !c.isPointLightShadow && this.type === F)
            ) {
              const e = { minFilter: Ue, magFilter: Ue, format: nt }
              ;(c.map = new Xn(r.x, r.y, e)),
                (c.map.texture.name = l.name + '.shadowMap'),
                (c.mapPass = new Xn(r.x, r.y, e)),
                c.camera.updateProjectionMatrix()
            }
            if (null === c.map) {
              const e = { minFilter: Fe, magFilter: Fe, format: nt }
              ;(c.map = new Xn(r.x, r.y, e)),
                (c.map.texture.name = l.name + '.shadowMap'),
                c.camera.updateProjectionMatrix()
            }
            e.setRenderTarget(c.map), e.clear()
            const f = c.getViewportCount()
            for (let e = 0; e < f; e++) {
              const t = c.getViewport(e)
              s.set(a.x * t.x, a.y * t.y, a.x * t.z, a.y * t.w),
                d.viewport(s),
                c.updateMatrices(l, e),
                (i = c.getFrustum()),
                w(n, o, c.camera, l, this.type)
            }
            c.isPointLightShadow || this.type !== F || v(c, o),
              (c.needsUpdate = !1)
          }
          ;(g.needsUpdate = !1), e.setRenderTarget(l, c, u)
        })
    }
    function ph (e, t, n) {
      const i = n.isWebGL2
      function r () {
        let t = !1
        const n = new Yn()
        let i = null
        const r = new Yn(0, 0, 0, 0)
        return {
          setMask: function (n) {
            i === n || t || (e.colorMask(n, n, n, n), (i = n))
          },
          setLocked: function (e) {
            t = e
          },
          setClear: function (t, i, a, s, o) {
            !0 === o && ((t *= s), (i *= s), (a *= s)),
              n.set(t, i, a, s),
              !1 === r.equals(n) && (e.clearColor(t, i, a, s), r.copy(n))
          },
          reset: function () {
            ;(t = !1), (i = null), r.set(-1, 0, 0, 0)
          }
        }
      }
      function a () {
        let t = !1,
          n = null,
          i = null,
          r = null
        return {
          setTest: function (e) {
            e ? be(2929) : Me(2929)
          },
          setMask: function (i) {
            n === i || t || (e.depthMask(i), (n = i))
          },
          setFunc: function (t) {
            if (i !== t) {
              if (t)
                switch (t) {
                  case ce:
                    e.depthFunc(512)
                    break
                  case he:
                    e.depthFunc(519)
                    break
                  case ue:
                    e.depthFunc(513)
                    break
                  case de:
                    e.depthFunc(515)
                    break
                  case pe:
                    e.depthFunc(514)
                    break
                  case fe:
                    e.depthFunc(518)
                    break
                  case me:
                    e.depthFunc(516)
                    break
                  case ge:
                    e.depthFunc(517)
                    break
                  default:
                    e.depthFunc(515)
                }
              else e.depthFunc(515)
              i = t
            }
          },
          setLocked: function (e) {
            t = e
          },
          setClear: function (t) {
            r !== t && (e.clearDepth(t), (r = t))
          },
          reset: function () {
            ;(t = !1), (n = null), (i = null), (r = null)
          }
        }
      }
      function s () {
        let t = !1,
          n = null,
          i = null,
          r = null,
          a = null,
          s = null,
          o = null,
          l = null,
          c = null
        return {
          setTest: function (e) {
            t || (e ? be(2960) : Me(2960))
          },
          setMask: function (i) {
            n === i || t || (e.stencilMask(i), (n = i))
          },
          setFunc: function (t, n, s) {
            ;(i === t && r === n && a === s) ||
              (e.stencilFunc(t, n, s), (i = t), (r = n), (a = s))
          },
          setOp: function (t, n, i) {
            ;(s === t && o === n && l === i) ||
              (e.stencilOp(t, n, i), (s = t), (o = n), (l = i))
          },
          setLocked: function (e) {
            t = e
          },
          setClear: function (t) {
            c !== t && (e.clearStencil(t), (c = t))
          },
          reset: function () {
            ;(t = !1),
              (n = null),
              (i = null),
              (r = null),
              (a = null),
              (s = null),
              (o = null),
              (l = null),
              (c = null)
          }
        }
      }
      const o = new r(),
        l = new a(),
        c = new s()
      let h = {},
        u = null,
        d = {},
        p = null,
        f = !1,
        g = null,
        v = null,
        y = null,
        _ = null,
        x = null,
        w = null,
        b = null,
        M = !1,
        S = null,
        E = null,
        T = null,
        A = null,
        R = null
      const L = e.getParameter(35661)
      let C = !1,
        N = 0
      const O = e.getParameter(7938)
      ;-1 !== O.indexOf('WebGL')
        ? ((N = parseFloat(/^WebGL (\d)/.exec(O)[1])), (C = N >= 1))
        : -1 !== O.indexOf('OpenGL ES') &&
          ((N = parseFloat(/^OpenGL ES (\d)/.exec(O)[1])), (C = N >= 2))
      let F = null,
        B = {}
      const k = e.getParameter(3088),
        ve = e.getParameter(2978),
        ye = new Yn().fromArray(k),
        _e = new Yn().fromArray(ve)
      function xe (t, n, i) {
        const r = new Uint8Array(4),
          a = e.createTexture()
        e.bindTexture(t, a),
          e.texParameteri(t, 10241, 9728),
          e.texParameteri(t, 10240, 9728)
        for (let s = 0; s < i; s++)
          e.texImage2D(n + s, 0, 6408, 1, 1, 0, 6408, 5121, r)
        return a
      }
      const we = {}
      function be (t) {
        !0 !== h[t] && (e.enable(t), (h[t] = !0))
      }
      function Me (t) {
        !1 !== h[t] && (e.disable(t), (h[t] = !1))
      }
      function Se (t) {
        t !== u && (e.bindFramebuffer(36160, t), (u = t))
      }
      function Ee (t, n) {
        return (
          null === n && null !== u && (n = u),
          d[t] !== n &&
            (e.bindFramebuffer(t, n),
            (d[t] = n),
            i && (36009 === t && (d[36160] = n), 36160 === t && (d[36009] = n)),
            !0)
        )
      }
      function Te (t) {
        return p !== t && (e.useProgram(t), (p = t), !0)
      }
      ;(we[3553] = xe(3553, 3553, 1)),
        (we[34067] = xe(34067, 34069, 6)),
        o.setClear(0, 0, 0, 1),
        l.setClear(1),
        c.setClear(0),
        be(2929),
        l.setFunc(de),
        Pe(!1),
        De(D),
        be(2884),
        Le(H)
      const Ae = { [Y]: 32774, [X]: 32778, [J]: 32779 }
      if (i) (Ae[Z] = 32775), (Ae[K] = 32776)
      else {
        const e = t.get('EXT_blend_minmax')
        null !== e && ((Ae[Z] = e.MIN_EXT), (Ae[K] = e.MAX_EXT))
      }
      const Re = {
        [Q]: 0,
        [$]: 1,
        [ee]: 768,
        [ne]: 770,
        [le]: 776,
        [se]: 774,
        [re]: 772,
        [te]: 769,
        [ie]: 771,
        [oe]: 775,
        [ae]: 773
      }
      function Le (t, n, i, r, a, s, o, l) {
        if (t !== H) {
          if ((!1 === f && (be(3042), (f = !0)), t === q))
            (a = a || n),
              (s = s || i),
              (o = o || r),
              (n === v && a === x) ||
                (e.blendEquationSeparate(Ae[n], Ae[a]), (v = n), (x = a)),
              (i === y && r === _ && s === w && o === b) ||
                (e.blendFuncSeparate(Re[i], Re[r], Re[s], Re[o]),
                (y = i),
                (_ = r),
                (w = s),
                (b = o)),
              (g = t),
              (M = null)
          else if (t !== g || l !== M) {
            if (
              ((v === Y && x === Y) ||
                (e.blendEquation(32774), (v = Y), (x = Y)),
              l)
            )
              switch (t) {
                case W:
                  e.blendFuncSeparate(1, 771, 1, 771)
                  break
                case V:
                  e.blendFunc(1, 1)
                  break
                case G:
                  e.blendFuncSeparate(0, 0, 769, 771)
                  break
                case j:
                  e.blendFuncSeparate(0, 768, 0, 770)
                  break
                default:
                  console.error('THREE.WebGLState: Invalid blending: ', t)
                  break
              }
            else
              switch (t) {
                case W:
                  e.blendFuncSeparate(770, 771, 1, 771)
                  break
                case V:
                  e.blendFunc(770, 1)
                  break
                case G:
                  e.blendFunc(0, 769)
                  break
                case j:
                  e.blendFunc(0, 768)
                  break
                default:
                  console.error('THREE.WebGLState: Invalid blending: ', t)
                  break
              }
            ;(y = null), (_ = null), (w = null), (b = null), (g = t), (M = l)
          }
        } else !0 === f && (Me(3042), (f = !1))
      }
      function Ce (e, t) {
        e.side === U ? Me(2884) : be(2884)
        let n = e.side === z
        t && (n = !n),
          Pe(n),
          e.blending === W && !1 === e.transparent
            ? Le(H)
            : Le(
                e.blending,
                e.blendEquation,
                e.blendSrc,
                e.blendDst,
                e.blendEquationAlpha,
                e.blendSrcAlpha,
                e.blendDstAlpha,
                e.premultipliedAlpha
              ),
          l.setFunc(e.depthFunc),
          l.setTest(e.depthTest),
          l.setMask(e.depthWrite),
          o.setMask(e.colorWrite)
        const i = e.stencilWrite
        c.setTest(i),
          i &&
            (c.setMask(e.stencilWriteMask),
            c.setFunc(e.stencilFunc, e.stencilRef, e.stencilFuncMask),
            c.setOp(e.stencilFail, e.stencilZFail, e.stencilZPass)),
          Ne(e.polygonOffset, e.polygonOffsetFactor, e.polygonOffsetUnits),
          !0 === e.alphaToCoverage ? be(32926) : Me(32926)
      }
      function Pe (t) {
        S !== t && (t ? e.frontFace(2304) : e.frontFace(2305), (S = t))
      }
      function De (t) {
        t !== P
          ? (be(2884),
            t !== E &&
              (t === D
                ? e.cullFace(1029)
                : t === I
                ? e.cullFace(1028)
                : e.cullFace(1032)))
          : Me(2884),
          (E = t)
      }
      function Ie (t) {
        t !== T && (C && e.lineWidth(t), (T = t))
      }
      function Ne (t, n, i) {
        t
          ? (be(32823),
            (A === n && R === i) || (e.polygonOffset(n, i), (A = n), (R = i)))
          : Me(32823)
      }
      function Oe (e) {
        e ? be(3089) : Me(3089)
      }
      function Fe (t) {
        void 0 === t && (t = 33984 + L - 1),
          F !== t && (e.activeTexture(t), (F = t))
      }
      function Be (t, n) {
        null === F && Fe()
        let i = B[F]
        void 0 === i && ((i = { type: void 0, texture: void 0 }), (B[F] = i)),
          (i.type === t && i.texture === n) ||
            (e.bindTexture(t, n || we[t]), (i.type = t), (i.texture = n))
      }
      function ze () {
        const t = B[F]
        void 0 !== t &&
          void 0 !== t.type &&
          (e.bindTexture(t.type, null), (t.type = void 0), (t.texture = void 0))
      }
      function Ue () {
        try {
          e.compressedTexImage2D.apply(e, arguments)
        } catch (m) {
          console.error('THREE.WebGLState:', m)
        }
      }
      function ke () {
        try {
          e.texImage2D.apply(e, arguments)
        } catch (m) {
          console.error('THREE.WebGLState:', m)
        }
      }
      function He () {
        try {
          e.texImage3D.apply(e, arguments)
        } catch (m) {
          console.error('THREE.WebGLState:', m)
        }
      }
      function We (t) {
        !1 === ye.equals(t) && (e.scissor(t.x, t.y, t.z, t.w), ye.copy(t))
      }
      function Ve (t) {
        !1 === _e.equals(t) && (e.viewport(t.x, t.y, t.z, t.w), _e.copy(t))
      }
      function Ge () {
        e.disable(3042),
          e.disable(2884),
          e.disable(2929),
          e.disable(32823),
          e.disable(3089),
          e.disable(2960),
          e.disable(32926),
          e.blendEquation(32774),
          e.blendFunc(1, 0),
          e.blendFuncSeparate(1, 0, 1, 0),
          e.colorMask(!0, !0, !0, !0),
          e.clearColor(0, 0, 0, 0),
          e.depthMask(!0),
          e.depthFunc(513),
          e.clearDepth(1),
          e.stencilMask(4294967295),
          e.stencilFunc(519, 0, 4294967295),
          e.stencilOp(7680, 7680, 7680),
          e.clearStencil(0),
          e.cullFace(1029),
          e.frontFace(2305),
          e.polygonOffset(0, 0),
          e.activeTexture(33984),
          e.bindFramebuffer(36160, null),
          !0 === i &&
            (e.bindFramebuffer(36009, null), e.bindFramebuffer(36008, null)),
          e.useProgram(null),
          e.lineWidth(1),
          e.scissor(0, 0, e.canvas.width, e.canvas.height),
          e.viewport(0, 0, e.canvas.width, e.canvas.height),
          (h = {}),
          (F = null),
          (B = {}),
          (u = null),
          (d = {}),
          (p = null),
          (f = !1),
          (g = null),
          (v = null),
          (y = null),
          (_ = null),
          (x = null),
          (w = null),
          (b = null),
          (M = !1),
          (S = null),
          (E = null),
          (T = null),
          (A = null),
          (R = null),
          ye.set(0, 0, e.canvas.width, e.canvas.height),
          _e.set(0, 0, e.canvas.width, e.canvas.height),
          o.reset(),
          l.reset(),
          c.reset()
      }
      return {
        buffers: { color: o, depth: l, stencil: c },
        enable: be,
        disable: Me,
        bindFramebuffer: Ee,
        bindXRFramebuffer: Se,
        useProgram: Te,
        setBlending: Le,
        setMaterial: Ce,
        setFlipSided: Pe,
        setCullFace: De,
        setLineWidth: Ie,
        setPolygonOffset: Ne,
        setScissorTest: Oe,
        activeTexture: Fe,
        bindTexture: Be,
        unbindTexture: ze,
        compressedTexImage2D: Ue,
        texImage2D: ke,
        texImage3D: He,
        scissor: We,
        viewport: Ve,
        reset: Ge
      }
    }
    function fh (e, t, n, i, r, a, s) {
      const o = r.isWebGL2,
        l = r.maxTextures,
        c = r.maxCubemapSize,
        h = r.maxTextureSize,
        u = r.maxSamples,
        d = new WeakMap()
      let p,
        f = !1
      try {
        f =
          'undefined' !== typeof OffscreenCanvas &&
          null !== new OffscreenCanvas(1, 1).getContext('2d')
      } catch ($) {}
      function m (e, t) {
        return f
          ? new OffscreenCanvas(e, t)
          : document.createElementNS('http://www.w3.org/1999/xhtml', 'canvas')
      }
      function g (e, t, n, i) {
        let r = 1
        if (
          ((e.width > i || e.height > i) &&
            (r = i / Math.max(e.width, e.height)),
          r < 1 || !0 === t)
        ) {
          if (
            ('undefined' !== typeof HTMLImageElement &&
              e instanceof HTMLImageElement) ||
            ('undefined' !== typeof HTMLCanvasElement &&
              e instanceof HTMLCanvasElement) ||
            ('undefined' !== typeof ImageBitmap && e instanceof ImageBitmap)
          ) {
            const i = t ? Un : Math.floor,
              a = i(r * e.width),
              s = i(r * e.height)
            void 0 === p && (p = m(a, s))
            const o = n ? m(a, s) : p
            ;(o.width = a), (o.height = s)
            const l = o.getContext('2d')
            return (
              l.drawImage(e, 0, 0, a, s),
              console.warn(
                'THREE.WebGLRenderer: Texture has been resized from (' +
                  e.width +
                  'x' +
                  e.height +
                  ') to (' +
                  a +
                  'x' +
                  s +
                  ').'
              ),
              o
            )
          }
          return (
            'data' in e &&
              console.warn(
                'THREE.WebGLRenderer: Image in DataTexture is too big (' +
                  e.width +
                  'x' +
                  e.height +
                  ').'
              ),
            e
          )
        }
        return e
      }
      function v (e) {
        return Bn(e.width) && Bn(e.height)
      }
      function y (e) {
        return (
          !o &&
          (e.wrapS !== Ne ||
            e.wrapT !== Ne ||
            (e.minFilter !== Fe && e.minFilter !== Ue))
        )
      }
      function _ (e, t) {
        return (
          e.generateMipmaps && t && e.minFilter !== Fe && e.minFilter !== Ue
        )
      }
      function x (t, n, r, a, s = 1) {
        e.generateMipmap(t)
        const o = i.get(n)
        o.__maxMipLevel = Math.log2(Math.max(r, a, s))
      }
      function w (n, i, r) {
        if (!1 === o) return i
        if (null !== n) {
          if (void 0 !== e[n]) return e[n]
          console.warn(
            "THREE.WebGLRenderer: Attempt to use non-existing WebGL internal format '" +
              n +
              "'"
          )
        }
        let a = i
        return (
          6403 === i &&
            (5126 === r && (a = 33326),
            5131 === r && (a = 33325),
            5121 === r && (a = 33321)),
          6407 === i &&
            (5126 === r && (a = 34837),
            5131 === r && (a = 34843),
            5121 === r && (a = 32849)),
          6408 === i &&
            (5126 === r && (a = 34836),
            5131 === r && (a = 34842),
            5121 === r && (a = 32856)),
          (33325 !== a && 33326 !== a && 34842 !== a && 34836 !== a) ||
            t.get('EXT_color_buffer_float'),
          a
        )
      }
      function b (e) {
        return e === Fe || e === Be || e === ze ? 9728 : 9729
      }
      function M (e) {
        const t = e.target
        t.removeEventListener('dispose', M),
          E(t),
          t.isVideoTexture && d.delete(t),
          s.memory.textures--
      }
      function S (e) {
        const t = e.target
        t.removeEventListener('dispose', S), T(t)
      }
      function E (t) {
        const n = i.get(t)
        void 0 !== n.__webglInit &&
          (e.deleteTexture(n.__webglTexture), i.remove(t))
      }
      function T (t) {
        const n = t.texture,
          r = i.get(t),
          a = i.get(n)
        if (t) {
          if (
            (void 0 !== a.__webglTexture &&
              (e.deleteTexture(a.__webglTexture), s.memory.textures--),
            t.depthTexture && t.depthTexture.dispose(),
            t.isWebGLCubeRenderTarget)
          )
            for (let t = 0; t < 6; t++)
              e.deleteFramebuffer(r.__webglFramebuffer[t]),
                r.__webglDepthbuffer &&
                  e.deleteRenderbuffer(r.__webglDepthbuffer[t])
          else
            e.deleteFramebuffer(r.__webglFramebuffer),
              r.__webglDepthbuffer &&
                e.deleteRenderbuffer(r.__webglDepthbuffer),
              r.__webglMultisampledFramebuffer &&
                e.deleteFramebuffer(r.__webglMultisampledFramebuffer),
              r.__webglColorRenderbuffer &&
                e.deleteRenderbuffer(r.__webglColorRenderbuffer),
              r.__webglDepthRenderbuffer &&
                e.deleteRenderbuffer(r.__webglDepthRenderbuffer)
          if (t.isWebGLMultipleRenderTargets)
            for (let t = 0, r = n.length; t < r; t++) {
              const r = i.get(n[t])
              r.__webglTexture &&
                (e.deleteTexture(r.__webglTexture), s.memory.textures--),
                i.remove(n[t])
            }
          i.remove(n), i.remove(t)
        }
      }
      let A = 0
      function R () {
        A = 0
      }
      function L () {
        const e = A
        return (
          e >= l &&
            console.warn(
              'THREE.WebGLTextures: Trying to use ' +
                e +
                ' texture units while this GPU supports only ' +
                l
            ),
          (A += 1),
          e
        )
      }
      function C (e, t) {
        const r = i.get(e)
        if (
          (e.isVideoTexture && X(e), e.version > 0 && r.__version !== e.version)
        ) {
          const n = e.image
          if (void 0 === n)
            console.warn(
              'THREE.WebGLRenderer: Texture marked for update but image is undefined'
            )
          else {
            if (!1 !== n.complete) return void z(r, e, t)
            console.warn(
              'THREE.WebGLRenderer: Texture marked for update but image is incomplete'
            )
          }
        }
        n.activeTexture(33984 + t), n.bindTexture(3553, r.__webglTexture)
      }
      function P (e, t) {
        const r = i.get(e)
        e.version > 0 && r.__version !== e.version
          ? z(r, e, t)
          : (n.activeTexture(33984 + t), n.bindTexture(35866, r.__webglTexture))
      }
      function D (e, t) {
        const r = i.get(e)
        e.version > 0 && r.__version !== e.version
          ? z(r, e, t)
          : (n.activeTexture(33984 + t), n.bindTexture(32879, r.__webglTexture))
      }
      function I (e, t) {
        const r = i.get(e)
        e.version > 0 && r.__version !== e.version
          ? U(r, e, t)
          : (n.activeTexture(33984 + t), n.bindTexture(34067, r.__webglTexture))
      }
      const N = { [Ie]: 10497, [Ne]: 33071, [Oe]: 33648 },
        O = {
          [Fe]: 9728,
          [Be]: 9984,
          [ze]: 9986,
          [Ue]: 9729,
          [ke]: 9985,
          [He]: 9987
        }
      function F (n, a, s) {
        if (
          (s
            ? (e.texParameteri(n, 10242, N[a.wrapS]),
              e.texParameteri(n, 10243, N[a.wrapT]),
              (32879 !== n && 35866 !== n) ||
                e.texParameteri(n, 32882, N[a.wrapR]),
              e.texParameteri(n, 10240, O[a.magFilter]),
              e.texParameteri(n, 10241, O[a.minFilter]))
            : (e.texParameteri(n, 10242, 33071),
              e.texParameteri(n, 10243, 33071),
              (32879 !== n && 35866 !== n) || e.texParameteri(n, 32882, 33071),
              (a.wrapS === Ne && a.wrapT === Ne) ||
                console.warn(
                  'THREE.WebGLRenderer: Texture is not power of two. Texture.wrapS and Texture.wrapT should be set to THREE.ClampToEdgeWrapping.'
                ),
              e.texParameteri(n, 10240, b(a.magFilter)),
              e.texParameteri(n, 10241, b(a.minFilter)),
              a.minFilter !== Fe &&
                a.minFilter !== Ue &&
                console.warn(
                  'THREE.WebGLRenderer: Texture is not power of two. Texture.minFilter should be set to THREE.NearestFilter or THREE.LinearFilter.'
                )),
          !0 === t.has('EXT_texture_filter_anisotropic'))
        ) {
          const s = t.get('EXT_texture_filter_anisotropic')
          if (a.type === Xe && !1 === t.has('OES_texture_float_linear')) return
          if (
            !1 === o &&
            a.type === Je &&
            !1 === t.has('OES_texture_half_float_linear')
          )
            return
          ;(a.anisotropy > 1 || i.get(a).__currentAnisotropy) &&
            (e.texParameterf(
              n,
              s.TEXTURE_MAX_ANISOTROPY_EXT,
              Math.min(a.anisotropy, r.getMaxAnisotropy())
            ),
            (i.get(a).__currentAnisotropy = a.anisotropy))
        }
      }
      function B (t, n) {
        void 0 === t.__webglInit &&
          ((t.__webglInit = !0),
          n.addEventListener('dispose', M),
          (t.__webglTexture = e.createTexture()),
          s.memory.textures++)
      }
      function z (t, i, r) {
        let s = 3553
        i.isDataTexture2DArray && (s = 35866),
          i.isDataTexture3D && (s = 32879),
          B(t, i),
          n.activeTexture(33984 + r),
          n.bindTexture(s, t.__webglTexture),
          e.pixelStorei(37440, i.flipY),
          e.pixelStorei(37441, i.premultiplyAlpha),
          e.pixelStorei(3317, i.unpackAlignment),
          e.pixelStorei(37443, 0)
        const l = y(i) && !1 === v(i.image),
          c = g(i.image, l, !1, h),
          u = v(c) || o,
          d = a.convert(i.format)
        let p,
          f = a.convert(i.type),
          m = w(i.internalFormat, d, f)
        F(s, i, u)
        const b = i.mipmaps
        if (i.isDepthTexture)
          (m = 6402),
            o
              ? (m =
                  i.type === Xe
                    ? 36012
                    : i.type === Ye
                    ? 33190
                    : i.type === $e
                    ? 35056
                    : 33189)
              : i.type === Xe &&
                console.error(
                  'WebGLRenderer: Floating point depth texture requires WebGL2.'
                ),
            i.format === at &&
              6402 === m &&
              i.type !== je &&
              i.type !== Ye &&
              (console.warn(
                'THREE.WebGLRenderer: Use UnsignedShortType or UnsignedIntType for DepthFormat DepthTexture.'
              ),
              (i.type = je),
              (f = a.convert(i.type))),
            i.format === st &&
              6402 === m &&
              ((m = 34041),
              i.type !== $e &&
                (console.warn(
                  'THREE.WebGLRenderer: Use UnsignedInt248Type for DepthStencilFormat DepthTexture.'
                ),
                (i.type = $e),
                (f = a.convert(i.type)))),
            n.texImage2D(3553, 0, m, c.width, c.height, 0, d, f, null)
        else if (i.isDataTexture)
          if (b.length > 0 && u) {
            for (let e = 0, t = b.length; e < t; e++)
              (p = b[e]),
                n.texImage2D(3553, e, m, p.width, p.height, 0, d, f, p.data)
            ;(i.generateMipmaps = !1), (t.__maxMipLevel = b.length - 1)
          } else
            n.texImage2D(3553, 0, m, c.width, c.height, 0, d, f, c.data),
              (t.__maxMipLevel = 0)
        else if (i.isCompressedTexture) {
          for (let e = 0, t = b.length; e < t; e++)
            (p = b[e]),
              i.format !== nt && i.format !== tt
                ? null !== d
                  ? n.compressedTexImage2D(
                      3553,
                      e,
                      m,
                      p.width,
                      p.height,
                      0,
                      p.data
                    )
                  : console.warn(
                      'THREE.WebGLRenderer: Attempt to load unsupported compressed texture format in .uploadTexture()'
                    )
                : n.texImage2D(3553, e, m, p.width, p.height, 0, d, f, p.data)
          t.__maxMipLevel = b.length - 1
        } else if (i.isDataTexture2DArray)
          n.texImage3D(
            35866,
            0,
            m,
            c.width,
            c.height,
            c.depth,
            0,
            d,
            f,
            c.data
          ),
            (t.__maxMipLevel = 0)
        else if (i.isDataTexture3D)
          n.texImage3D(
            32879,
            0,
            m,
            c.width,
            c.height,
            c.depth,
            0,
            d,
            f,
            c.data
          ),
            (t.__maxMipLevel = 0)
        else if (b.length > 0 && u) {
          for (let e = 0, t = b.length; e < t; e++)
            (p = b[e]), n.texImage2D(3553, e, m, d, f, p)
          ;(i.generateMipmaps = !1), (t.__maxMipLevel = b.length - 1)
        } else n.texImage2D(3553, 0, m, d, f, c), (t.__maxMipLevel = 0)
        _(i, u) && x(s, i, c.width, c.height),
          (t.__version = i.version),
          i.onUpdate && i.onUpdate(i)
      }
      function U (t, i, r) {
        if (6 !== i.image.length) return
        B(t, i),
          n.activeTexture(33984 + r),
          n.bindTexture(34067, t.__webglTexture),
          e.pixelStorei(37440, i.flipY),
          e.pixelStorei(37441, i.premultiplyAlpha),
          e.pixelStorei(3317, i.unpackAlignment),
          e.pixelStorei(37443, 0)
        const s =
            i && (i.isCompressedTexture || i.image[0].isCompressedTexture),
          l = i.image[0] && i.image[0].isDataTexture,
          h = []
        for (let e = 0; e < 6; e++)
          h[e] =
            s || l
              ? l
                ? i.image[e].image
                : i.image[e]
              : g(i.image[e], !1, !0, c)
        const u = h[0],
          d = v(u) || o,
          p = a.convert(i.format),
          f = a.convert(i.type),
          m = w(i.internalFormat, p, f)
        let y
        if ((F(34067, i, d), s)) {
          for (let e = 0; e < 6; e++) {
            y = h[e].mipmaps
            for (let t = 0; t < y.length; t++) {
              const r = y[t]
              i.format !== nt && i.format !== tt
                ? null !== p
                  ? n.compressedTexImage2D(
                      34069 + e,
                      t,
                      m,
                      r.width,
                      r.height,
                      0,
                      r.data
                    )
                  : console.warn(
                      'THREE.WebGLRenderer: Attempt to load unsupported compressed texture format in .setTextureCube()'
                    )
                : n.texImage2D(
                    34069 + e,
                    t,
                    m,
                    r.width,
                    r.height,
                    0,
                    p,
                    f,
                    r.data
                  )
            }
          }
          t.__maxMipLevel = y.length - 1
        } else {
          y = i.mipmaps
          for (let e = 0; e < 6; e++)
            if (l) {
              n.texImage2D(
                34069 + e,
                0,
                m,
                h[e].width,
                h[e].height,
                0,
                p,
                f,
                h[e].data
              )
              for (let t = 0; t < y.length; t++) {
                const i = y[t],
                  r = i.image[e].image
                n.texImage2D(
                  34069 + e,
                  t + 1,
                  m,
                  r.width,
                  r.height,
                  0,
                  p,
                  f,
                  r.data
                )
              }
            } else {
              n.texImage2D(34069 + e, 0, m, p, f, h[e])
              for (let t = 0; t < y.length; t++) {
                const i = y[t]
                n.texImage2D(34069 + e, t + 1, m, p, f, i.image[e])
              }
            }
          t.__maxMipLevel = y.length
        }
        _(i, d) && x(34067, i, u.width, u.height),
          (t.__version = i.version),
          i.onUpdate && i.onUpdate(i)
      }
      function k (t, r, s, o, l) {
        const c = a.convert(s.format),
          h = a.convert(s.type),
          u = w(s.internalFormat, c, h)
        32879 === l || 35866 === l
          ? n.texImage3D(l, 0, u, r.width, r.height, r.depth, 0, c, h, null)
          : n.texImage2D(l, 0, u, r.width, r.height, 0, c, h, null),
          n.bindFramebuffer(36160, t),
          e.framebufferTexture2D(36160, o, l, i.get(s).__webglTexture, 0),
          n.bindFramebuffer(36160, null)
      }
      function H (t, n, i) {
        if ((e.bindRenderbuffer(36161, t), n.depthBuffer && !n.stencilBuffer)) {
          let r = 33189
          if (i) {
            const t = n.depthTexture
            t &&
              t.isDepthTexture &&
              (t.type === Xe ? (r = 36012) : t.type === Ye && (r = 33190))
            const i = Y(n)
            e.renderbufferStorageMultisample(36161, i, r, n.width, n.height)
          } else e.renderbufferStorage(36161, r, n.width, n.height)
          e.framebufferRenderbuffer(36160, 36096, 36161, t)
        } else if (n.depthBuffer && n.stencilBuffer) {
          if (i) {
            const t = Y(n)
            e.renderbufferStorageMultisample(36161, t, 35056, n.width, n.height)
          } else e.renderbufferStorage(36161, 34041, n.width, n.height)
          e.framebufferRenderbuffer(36160, 33306, 36161, t)
        } else {
          const t =
              !0 === n.isWebGLMultipleRenderTargets ? n.texture[0] : n.texture,
            r = a.convert(t.format),
            s = a.convert(t.type),
            o = w(t.internalFormat, r, s)
          if (i) {
            const t = Y(n)
            e.renderbufferStorageMultisample(36161, t, o, n.width, n.height)
          } else e.renderbufferStorage(36161, o, n.width, n.height)
        }
        e.bindRenderbuffer(36161, null)
      }
      function W (t, r) {
        const a = r && r.isWebGLCubeRenderTarget
        if (a)
          throw new Error(
            'Depth Texture with cube render targets is not supported'
          )
        if (
          (n.bindFramebuffer(36160, t),
          !r.depthTexture || !r.depthTexture.isDepthTexture)
        )
          throw new Error(
            'renderTarget.depthTexture must be an instance of THREE.DepthTexture'
          )
        ;(i.get(r.depthTexture).__webglTexture &&
          r.depthTexture.image.width === r.width &&
          r.depthTexture.image.height === r.height) ||
          ((r.depthTexture.image.width = r.width),
          (r.depthTexture.image.height = r.height),
          (r.depthTexture.needsUpdate = !0)),
          C(r.depthTexture, 0)
        const s = i.get(r.depthTexture).__webglTexture
        if (r.depthTexture.format === at)
          e.framebufferTexture2D(36160, 36096, 3553, s, 0)
        else {
          if (r.depthTexture.format !== st)
            throw new Error('Unknown depthTexture format')
          e.framebufferTexture2D(36160, 33306, 3553, s, 0)
        }
      }
      function V (t) {
        const r = i.get(t),
          a = !0 === t.isWebGLCubeRenderTarget
        if (t.depthTexture) {
          if (a)
            throw new Error(
              'target.depthTexture not supported in Cube render targets'
            )
          W(r.__webglFramebuffer, t)
        } else if (a) {
          r.__webglDepthbuffer = []
          for (let i = 0; i < 6; i++)
            n.bindFramebuffer(36160, r.__webglFramebuffer[i]),
              (r.__webglDepthbuffer[i] = e.createRenderbuffer()),
              H(r.__webglDepthbuffer[i], t, !1)
        } else
          n.bindFramebuffer(36160, r.__webglFramebuffer),
            (r.__webglDepthbuffer = e.createRenderbuffer()),
            H(r.__webglDepthbuffer, t, !1)
        n.bindFramebuffer(36160, null)
      }
      function G (t) {
        const l = t.texture,
          c = i.get(t),
          h = i.get(l)
        t.addEventListener('dispose', S),
          !0 !== t.isWebGLMultipleRenderTargets &&
            ((h.__webglTexture = e.createTexture()),
            (h.__version = l.version),
            s.memory.textures++)
        const u = !0 === t.isWebGLCubeRenderTarget,
          d = !0 === t.isWebGLMultipleRenderTargets,
          p = !0 === t.isWebGLMultisampleRenderTarget,
          f = l.isDataTexture3D || l.isDataTexture2DArray,
          m = v(t) || o
        if (
          (!o ||
            l.format !== tt ||
            (l.type !== Xe && l.type !== Je) ||
            ((l.format = nt),
            console.warn(
              'THREE.WebGLRenderer: Rendering to textures with RGB format is not supported. Using RGBA format instead.'
            )),
          u)
        ) {
          c.__webglFramebuffer = []
          for (let t = 0; t < 6; t++)
            c.__webglFramebuffer[t] = e.createFramebuffer()
        } else if (((c.__webglFramebuffer = e.createFramebuffer()), d))
          if (r.drawBuffers) {
            const n = t.texture
            for (let t = 0, r = n.length; t < r; t++) {
              const r = i.get(n[t])
              void 0 === r.__webglTexture &&
                ((r.__webglTexture = e.createTexture()), s.memory.textures++)
            }
          } else
            console.warn(
              'THREE.WebGLRenderer: WebGLMultipleRenderTargets can only be used with WebGL2 or WEBGL_draw_buffers extension.'
            )
        else if (p)
          if (o) {
            ;(c.__webglMultisampledFramebuffer = e.createFramebuffer()),
              (c.__webglColorRenderbuffer = e.createRenderbuffer()),
              e.bindRenderbuffer(36161, c.__webglColorRenderbuffer)
            const i = a.convert(l.format),
              r = a.convert(l.type),
              s = w(l.internalFormat, i, r),
              o = Y(t)
            e.renderbufferStorageMultisample(36161, o, s, t.width, t.height),
              n.bindFramebuffer(36160, c.__webglMultisampledFramebuffer),
              e.framebufferRenderbuffer(
                36160,
                36064,
                36161,
                c.__webglColorRenderbuffer
              ),
              e.bindRenderbuffer(36161, null),
              t.depthBuffer &&
                ((c.__webglDepthRenderbuffer = e.createRenderbuffer()),
                H(c.__webglDepthRenderbuffer, t, !0)),
              n.bindFramebuffer(36160, null)
          } else
            console.warn(
              'THREE.WebGLRenderer: WebGLMultisampleRenderTarget can only be used with WebGL2.'
            )
        if (u) {
          n.bindTexture(34067, h.__webglTexture), F(34067, l, m)
          for (let e = 0; e < 6; e++)
            k(c.__webglFramebuffer[e], t, l, 36064, 34069 + e)
          _(l, m) && x(34067, l, t.width, t.height), n.bindTexture(34067, null)
        } else if (d) {
          const e = t.texture
          for (let r = 0, a = e.length; r < a; r++) {
            const a = e[r],
              s = i.get(a)
            n.bindTexture(3553, s.__webglTexture),
              F(3553, a, m),
              k(c.__webglFramebuffer, t, a, 36064 + r, 3553),
              _(a, m) && x(3553, a, t.width, t.height)
          }
          n.bindTexture(3553, null)
        } else {
          let e = 3553
          if (f)
            if (o) {
              const t = l.isDataTexture3D
              e = t ? 32879 : 35866
            } else
              console.warn(
                'THREE.DataTexture3D and THREE.DataTexture2DArray only supported with WebGL2.'
              )
          n.bindTexture(e, h.__webglTexture),
            F(e, l, m),
            k(c.__webglFramebuffer, t, l, 36064, e),
            _(l, m) && x(e, l, t.width, t.height, t.depth),
            n.bindTexture(e, null)
        }
        t.depthBuffer && V(t)
      }
      function j (e) {
        const t = v(e) || o,
          r = !0 === e.isWebGLMultipleRenderTargets ? e.texture : [e.texture]
        for (let a = 0, s = r.length; a < s; a++) {
          const s = r[a]
          if (_(s, t)) {
            const t = e.isWebGLCubeRenderTarget ? 34067 : 3553,
              r = i.get(s).__webglTexture
            n.bindTexture(t, r),
              x(t, s, e.width, e.height),
              n.bindTexture(t, null)
          }
        }
      }
      function q (t) {
        if (t.isWebGLMultisampleRenderTarget)
          if (o) {
            const r = t.width,
              a = t.height
            let s = 16384
            t.depthBuffer && (s |= 256), t.stencilBuffer && (s |= 1024)
            const o = i.get(t)
            n.bindFramebuffer(36008, o.__webglMultisampledFramebuffer),
              n.bindFramebuffer(36009, o.__webglFramebuffer),
              e.blitFramebuffer(0, 0, r, a, 0, 0, r, a, s, 9728),
              n.bindFramebuffer(36008, null),
              n.bindFramebuffer(36009, o.__webglMultisampledFramebuffer)
          } else
            console.warn(
              'THREE.WebGLRenderer: WebGLMultisampleRenderTarget can only be used with WebGL2.'
            )
      }
      function Y (e) {
        return o && e.isWebGLMultisampleRenderTarget
          ? Math.min(u, e.samples)
          : 0
      }
      function X (e) {
        const t = s.render.frame
        d.get(e) !== t && (d.set(e, t), e.update())
      }
      let J = !1,
        Z = !1
      function K (e, t) {
        e &&
          e.isWebGLRenderTarget &&
          (!1 === J &&
            (console.warn(
              "THREE.WebGLTextures.safeSetTexture2D: don't use render targets as textures. Use their .texture property instead."
            ),
            (J = !0)),
          (e = e.texture)),
          C(e, t)
      }
      function Q (e, t) {
        e &&
          e.isWebGLCubeRenderTarget &&
          (!1 === Z &&
            (console.warn(
              "THREE.WebGLTextures.safeSetTextureCube: don't use cube render targets as textures. Use their .texture property instead."
            ),
            (Z = !0)),
          (e = e.texture)),
          I(e, t)
      }
      ;(this.allocateTextureUnit = L),
        (this.resetTextureUnits = R),
        (this.setTexture2D = C),
        (this.setTexture2DArray = P),
        (this.setTexture3D = D),
        (this.setTextureCube = I),
        (this.setupRenderTarget = G),
        (this.updateRenderTargetMipmap = j),
        (this.updateMultisampleRenderTarget = q),
        (this.safeSetTexture2D = K),
        (this.safeSetTextureCube = Q)
    }
    function mh (e, t, n) {
      const i = n.isWebGL2
      function r (e) {
        let n
        if (e === We) return 5121
        if (e === Ze) return 32819
        if (e === Ke) return 32820
        if (e === Qe) return 33635
        if (e === Ve) return 5120
        if (e === Ge) return 5122
        if (e === je) return 5123
        if (e === qe) return 5124
        if (e === Ye) return 5125
        if (e === Xe) return 5126
        if (e === Je)
          return i
            ? 5131
            : ((n = t.get('OES_texture_half_float')),
              null !== n ? n.HALF_FLOAT_OES : null)
        if (e === et) return 6406
        if (e === tt) return 6407
        if (e === nt) return 6408
        if (e === it) return 6409
        if (e === rt) return 6410
        if (e === at) return 6402
        if (e === st) return 34041
        if (e === ot) return 6403
        if (e === lt) return 36244
        if (e === ct) return 33319
        if (e === ht) return 33320
        if (e === ut) return 36248
        if (e === dt) return 36249
        if (e === pt || e === ft || e === mt || e === gt) {
          if (((n = t.get('WEBGL_compressed_texture_s3tc')), null === n))
            return null
          if (e === pt) return n.COMPRESSED_RGB_S3TC_DXT1_EXT
          if (e === ft) return n.COMPRESSED_RGBA_S3TC_DXT1_EXT
          if (e === mt) return n.COMPRESSED_RGBA_S3TC_DXT3_EXT
          if (e === gt) return n.COMPRESSED_RGBA_S3TC_DXT5_EXT
        }
        if (e === vt || e === yt || e === _t || e === xt) {
          if (((n = t.get('WEBGL_compressed_texture_pvrtc')), null === n))
            return null
          if (e === vt) return n.COMPRESSED_RGB_PVRTC_4BPPV1_IMG
          if (e === yt) return n.COMPRESSED_RGB_PVRTC_2BPPV1_IMG
          if (e === _t) return n.COMPRESSED_RGBA_PVRTC_4BPPV1_IMG
          if (e === xt) return n.COMPRESSED_RGBA_PVRTC_2BPPV1_IMG
        }
        if (e === wt)
          return (
            (n = t.get('WEBGL_compressed_texture_etc1')),
            null !== n ? n.COMPRESSED_RGB_ETC1_WEBGL : null
          )
        if (
          (e === bt || e === Mt) &&
          ((n = t.get('WEBGL_compressed_texture_etc')), null !== n)
        ) {
          if (e === bt) return n.COMPRESSED_RGB8_ETC2
          if (e === Mt) return n.COMPRESSED_RGBA8_ETC2_EAC
        }
        return e === St ||
          e === Et ||
          e === Tt ||
          e === At ||
          e === Rt ||
          e === Lt ||
          e === Ct ||
          e === Pt ||
          e === Dt ||
          e === It ||
          e === Nt ||
          e === Ot ||
          e === Ft ||
          e === Bt ||
          e === Ut ||
          e === kt ||
          e === Ht ||
          e === Wt ||
          e === Vt ||
          e === Gt ||
          e === jt ||
          e === qt ||
          e === Yt ||
          e === Xt ||
          e === Jt ||
          e === Zt ||
          e === Kt ||
          e === Qt
          ? ((n = t.get('WEBGL_compressed_texture_astc')),
            null !== n ? e : null)
          : e === zt
          ? ((n = t.get('EXT_texture_compression_bptc')), null !== n ? e : null)
          : e === $e
          ? i
            ? 34042
            : ((n = t.get('WEBGL_depth_texture')),
              null !== n ? n.UNSIGNED_INT_24_8_WEBGL : null)
          : void 0
      }
      return { convert: r }
    }
    class gh extends fa {
      constructor (e = []) {
        super(), (this.cameras = e)
      }
    }
    gh.prototype.isArrayCamera = !0
    class vh extends er {
      constructor () {
        super(), (this.type = 'Group')
      }
    }
    vh.prototype.isGroup = !0
    const yh = { type: 'move' }
    class _h {
      constructor () {
        ;(this._targetRay = null), (this._grip = null), (this._hand = null)
      }
      getHandSpace () {
        return (
          null === this._hand &&
            ((this._hand = new vh()),
            (this._hand.matrixAutoUpdate = !1),
            (this._hand.visible = !1),
            (this._hand.joints = {}),
            (this._hand.inputState = { pinching: !1 })),
          this._hand
        )
      }
      getTargetRaySpace () {
        return (
          null === this._targetRay &&
            ((this._targetRay = new vh()),
            (this._targetRay.matrixAutoUpdate = !1),
            (this._targetRay.visible = !1),
            (this._targetRay.hasLinearVelocity = !1),
            (this._targetRay.linearVelocity = new Qn()),
            (this._targetRay.hasAngularVelocity = !1),
            (this._targetRay.angularVelocity = new Qn())),
          this._targetRay
        )
      }
      getGripSpace () {
        return (
          null === this._grip &&
            ((this._grip = new vh()),
            (this._grip.matrixAutoUpdate = !1),
            (this._grip.visible = !1),
            (this._grip.hasLinearVelocity = !1),
            (this._grip.linearVelocity = new Qn()),
            (this._grip.hasAngularVelocity = !1),
            (this._grip.angularVelocity = new Qn())),
          this._grip
        )
      }
      dispatchEvent (e) {
        return (
          null !== this._targetRay && this._targetRay.dispatchEvent(e),
          null !== this._grip && this._grip.dispatchEvent(e),
          null !== this._hand && this._hand.dispatchEvent(e),
          this
        )
      }
      disconnect (e) {
        return (
          this.dispatchEvent({ type: 'disconnected', data: e }),
          null !== this._targetRay && (this._targetRay.visible = !1),
          null !== this._grip && (this._grip.visible = !1),
          null !== this._hand && (this._hand.visible = !1),
          this
        )
      }
      update (e, t, n) {
        let i = null,
          r = null,
          a = null
        const s = this._targetRay,
          o = this._grip,
          l = this._hand
        if (e && 'visible-blurred' !== t.session.visibilityState)
          if (
            (null !== s &&
              ((i = t.getPose(e.targetRaySpace, n)),
              null !== i &&
                (s.matrix.fromArray(i.transform.matrix),
                s.matrix.decompose(s.position, s.rotation, s.scale),
                i.linearVelocity
                  ? ((s.hasLinearVelocity = !0),
                    s.linearVelocity.copy(i.linearVelocity))
                  : (s.hasLinearVelocity = !1),
                i.angularVelocity
                  ? ((s.hasAngularVelocity = !0),
                    s.angularVelocity.copy(i.angularVelocity))
                  : (s.hasAngularVelocity = !1),
                this.dispatchEvent(yh))),
            l && e.hand)
          ) {
            a = !0
            for (const a of e.hand.values()) {
              const e = t.getJointPose(a, n)
              if (void 0 === l.joints[a.jointName]) {
                const e = new vh()
                ;(e.matrixAutoUpdate = !1),
                  (e.visible = !1),
                  (l.joints[a.jointName] = e),
                  l.add(e)
              }
              const i = l.joints[a.jointName]
              null !== e &&
                (i.matrix.fromArray(e.transform.matrix),
                i.matrix.decompose(i.position, i.rotation, i.scale),
                (i.jointRadius = e.radius)),
                (i.visible = null !== e)
            }
            const i = l.joints['index-finger-tip'],
              r = l.joints['thumb-tip'],
              s = i.position.distanceTo(r.position),
              o = 0.02,
              c = 0.005
            l.inputState.pinching && s > o + c
              ? ((l.inputState.pinching = !1),
                this.dispatchEvent({
                  type: 'pinchend',
                  handedness: e.handedness,
                  target: this
                }))
              : !l.inputState.pinching &&
                s <= o - c &&
                ((l.inputState.pinching = !0),
                this.dispatchEvent({
                  type: 'pinchstart',
                  handedness: e.handedness,
                  target: this
                }))
          } else
            null !== o &&
              e.gripSpace &&
              ((r = t.getPose(e.gripSpace, n)),
              null !== r &&
                (o.matrix.fromArray(r.transform.matrix),
                o.matrix.decompose(o.position, o.rotation, o.scale),
                r.linearVelocity
                  ? ((o.hasLinearVelocity = !0),
                    o.linearVelocity.copy(r.linearVelocity))
                  : (o.hasLinearVelocity = !1),
                r.angularVelocity
                  ? ((o.hasAngularVelocity = !0),
                    o.angularVelocity.copy(r.angularVelocity))
                  : (o.hasAngularVelocity = !1)))
        return (
          null !== s && (s.visible = null !== i),
          null !== o && (o.visible = null !== r),
          null !== l && (l.visible = null !== a),
          this
        )
      }
    }
    class xh extends Ln {
      constructor (e, t) {
        super()
        const n = this,
          i = e.state
        let r = null,
          a = 1,
          s = null,
          o = 'local-floor',
          l = null,
          c = null,
          h = null,
          u = null
        const d = [],
          p = new Map(),
          f = new fa()
        f.layers.enable(1), (f.viewport = new Yn())
        const m = new fa()
        m.layers.enable(2), (m.viewport = new Yn())
        const g = [f, m],
          v = new gh()
        v.layers.enable(1), v.layers.enable(2)
        let y = null,
          _ = null
        function x (e) {
          const t = p.get(e.inputSource)
          t && t.dispatchEvent({ type: e.type, data: e.inputSource })
        }
        function w () {
          p.forEach(function (e, t) {
            e.disconnect(t)
          }),
            p.clear(),
            (y = null),
            (_ = null),
            i.bindXRFramebuffer(null),
            e.setRenderTarget(e.getRenderTarget()),
            L.stop(),
            (n.isPresenting = !1),
            n.dispatchEvent({ type: 'sessionend' })
        }
        function b (e) {
          const t = r.inputSources
          for (let n = 0; n < d.length; n++) p.set(t[n], d[n])
          for (let n = 0; n < e.removed.length; n++) {
            const t = e.removed[n],
              i = p.get(t)
            i &&
              (i.dispatchEvent({ type: 'disconnected', data: t }), p.delete(t))
          }
          for (let n = 0; n < e.added.length; n++) {
            const t = e.added[n],
              i = p.get(t)
            i && i.dispatchEvent({ type: 'connected', data: t })
          }
        }
        ;(this.cameraAutoUpdate = !0),
          (this.enabled = !1),
          (this.isPresenting = !1),
          (this.getController = function (e) {
            let t = d[e]
            return (
              void 0 === t && ((t = new _h()), (d[e] = t)),
              t.getTargetRaySpace()
            )
          }),
          (this.getControllerGrip = function (e) {
            let t = d[e]
            return (
              void 0 === t && ((t = new _h()), (d[e] = t)), t.getGripSpace()
            )
          }),
          (this.getHand = function (e) {
            let t = d[e]
            return (
              void 0 === t && ((t = new _h()), (d[e] = t)), t.getHandSpace()
            )
          }),
          (this.setFramebufferScaleFactor = function (e) {
            ;(a = e),
              !0 === n.isPresenting &&
                console.warn(
                  'THREE.WebXRManager: Cannot change framebuffer scale while presenting.'
                )
          }),
          (this.setReferenceSpaceType = function (e) {
            ;(o = e),
              !0 === n.isPresenting &&
                console.warn(
                  'THREE.WebXRManager: Cannot change reference space type while presenting.'
                )
          }),
          (this.getReferenceSpace = function () {
            return s
          }),
          (this.getSession = function () {
            return r
          }),
          (this.setSession = async function (e) {
            if (((r = e), null !== r)) {
              r.addEventListener('select', x),
                r.addEventListener('selectstart', x),
                r.addEventListener('selectend', x),
                r.addEventListener('squeeze', x),
                r.addEventListener('squeezestart', x),
                r.addEventListener('squeezeend', x),
                r.addEventListener('end', w),
                r.addEventListener('inputsourceschange', b)
              const e = t.getContextAttributes()
              if (
                (!0 !== e.xrCompatible && (await t.makeXRCompatible()),
                void 0 === r.renderState.layers)
              ) {
                const n = {
                    antialias: e.antialias,
                    alpha: e.alpha,
                    depth: e.depth,
                    stencil: e.stencil,
                    framebufferScaleFactor: a
                  },
                  i = new XRWebGLLayer(r, t, n)
                r.updateRenderState({ baseLayer: i })
              } else {
                let n = 0
                e.depth && (n = e.stencil ? 34041 : 6402)
                const i = {
                  colorFormat: e.alpha ? 6408 : 6407,
                  depthFormat: n,
                  scaleFactor: a
                }
                ;(c = new XRWebGLBinding(r, t)),
                  (u = c.createProjectionLayer(i)),
                  (h = t.createFramebuffer()),
                  r.updateRenderState({ layers: [u] })
              }
              ;(s = await r.requestReferenceSpace(o)),
                L.setContext(r),
                L.start(),
                (n.isPresenting = !0),
                n.dispatchEvent({ type: 'sessionstart' })
            }
          })
        const M = new Qn(),
          S = new Qn()
        function E (e, t, n) {
          M.setFromMatrixPosition(t.matrixWorld),
            S.setFromMatrixPosition(n.matrixWorld)
          const i = M.distanceTo(S),
            r = t.projectionMatrix.elements,
            a = n.projectionMatrix.elements,
            s = r[14] / (r[10] - 1),
            o = r[14] / (r[10] + 1),
            l = (r[9] + 1) / r[5],
            c = (r[9] - 1) / r[5],
            h = (r[8] - 1) / r[0],
            u = (a[8] + 1) / a[0],
            d = s * h,
            p = s * u,
            f = i / (-h + u),
            m = f * -h
          t.matrixWorld.decompose(e.position, e.quaternion, e.scale),
            e.translateX(m),
            e.translateZ(f),
            e.matrixWorld.compose(
              e.position,
              e.quaternion,
              e.scale
            ),
            e.matrixWorldInverse.copy(e.matrixWorld).invert()
          const g = s + f,
            v = o + f,
            y = d - m,
            _ = p + (i - m),
            x = ((l * o) / v) * g,
            w = ((c * o) / v) * g
          e.projectionMatrix.makePerspective(y, _, x, w, g, v)
        }
        function T (e, t) {
          null === t
            ? e.matrixWorld.copy(e.matrix)
            : e.matrixWorld.multiplyMatrices(t.matrixWorld, e.matrix),
            e.matrixWorldInverse.copy(e.matrixWorld).invert()
        }
        ;(this.updateCamera = function (e) {
          if (null === r) return
          ;(v.near = m.near = f.near = e.near),
            (v.far = m.far = f.far = e.far),
            (y === v.near && _ === v.far) ||
              (r.updateRenderState({ depthNear: v.near, depthFar: v.far }),
              (y = v.near),
              (_ = v.far))
          const t = e.parent,
            n = v.cameras
          T(v, t)
          for (let r = 0; r < n.length; r++) T(n[r], t)
          v.matrixWorld.decompose(v.position, v.quaternion, v.scale),
            e.position.copy(v.position),
            e.quaternion.copy(v.quaternion),
            e.scale.copy(v.scale),
            e.matrix.copy(v.matrix),
            e.matrixWorld.copy(v.matrixWorld)
          const i = e.children
          for (let r = 0, a = i.length; r < a; r++) i[r].updateMatrixWorld(!0)
          2 === n.length
            ? E(v, f, m)
            : v.projectionMatrix.copy(f.projectionMatrix)
        }),
          (this.getCamera = function () {
            return v
          })
        let A = null
        function R (e, n) {
          if (((l = n.getViewerPose(s)), null !== l)) {
            const e = l.views,
              n = r.renderState.baseLayer
            void 0 === r.renderState.layers &&
              i.bindXRFramebuffer(n.framebuffer)
            let a = !1
            e.length !== v.cameras.length && ((v.cameras.length = 0), (a = !0))
            for (let s = 0; s < e.length; s++) {
              const o = e[s]
              let l = null
              if (void 0 === r.renderState.layers) l = n.getViewport(o)
              else {
                const e = c.getViewSubImage(u, o)
                i.bindXRFramebuffer(h),
                  t.framebufferTexture2D(36160, 36064, 3553, e.colorTexture, 0),
                  void 0 !== e.depthStencilTexture &&
                    t.framebufferTexture2D(
                      36160,
                      36096,
                      3553,
                      e.depthStencilTexture,
                      0
                    ),
                  (l = e.viewport)
              }
              const d = g[s]
              d.matrix.fromArray(o.transform.matrix),
                d.projectionMatrix.fromArray(o.projectionMatrix),
                d.viewport.set(l.x, l.y, l.width, l.height),
                0 === s && v.matrix.copy(d.matrix),
                !0 === a && v.cameras.push(d)
            }
          }
          const a = r.inputSources
          for (let t = 0; t < d.length; t++) {
            const e = d[t],
              i = a[t]
            e.update(i, n, s)
          }
          A && A(e, n)
        }
        const L = new Aa()
        L.setAnimationLoop(R),
          (this.setAnimationLoop = function (e) {
            A = e
          }),
          (this.dispose = function () {})
      }
    }
    function wh (e) {
      function t (e, t) {
        e.fogColor.value.copy(t.color),
          t.isFog
            ? ((e.fogNear.value = t.near), (e.fogFar.value = t.far))
            : t.isFogExp2 && (e.fogDensity.value = t.density)
      }
      function n (e, t, n, v, y) {
        t.isMeshBasicMaterial
          ? i(e, t)
          : t.isMeshLambertMaterial
          ? (i(e, t), l(e, t))
          : t.isMeshToonMaterial
          ? (i(e, t), h(e, t))
          : t.isMeshPhongMaterial
          ? (i(e, t), c(e, t))
          : t.isMeshStandardMaterial
          ? (i(e, t), t.isMeshPhysicalMaterial ? d(e, t, y) : u(e, t))
          : t.isMeshMatcapMaterial
          ? (i(e, t), p(e, t))
          : t.isMeshDepthMaterial
          ? (i(e, t), f(e, t))
          : t.isMeshDistanceMaterial
          ? (i(e, t), m(e, t))
          : t.isMeshNormalMaterial
          ? (i(e, t), g(e, t))
          : t.isLineBasicMaterial
          ? (r(e, t), t.isLineDashedMaterial && a(e, t))
          : t.isPointsMaterial
          ? s(e, t, n, v)
          : t.isSpriteMaterial
          ? o(e, t)
          : t.isShadowMaterial
          ? (e.color.value.copy(t.color), (e.opacity.value = t.opacity))
          : t.isShaderMaterial && (t.uniformsNeedUpdate = !1)
      }
      function i (t, n) {
        ;(t.opacity.value = n.opacity),
          n.color && t.diffuse.value.copy(n.color),
          n.emissive &&
            t.emissive.value
              .copy(n.emissive)
              .multiplyScalar(n.emissiveIntensity),
          n.map && (t.map.value = n.map),
          n.alphaMap && (t.alphaMap.value = n.alphaMap),
          n.specularMap && (t.specularMap.value = n.specularMap)
        const i = e.get(n).envMap
        if (i) {
          ;(t.envMap.value = i),
            (t.flipEnvMap.value =
              i.isCubeTexture && i._needsFlipEnvMap ? -1 : 1),
            (t.reflectivity.value = n.reflectivity),
            (t.refractionRatio.value = n.refractionRatio)
          const r = e.get(i).__maxMipLevel
          void 0 !== r && (t.maxMipLevel.value = r)
        }
        let r, a
        n.lightMap &&
          ((t.lightMap.value = n.lightMap),
          (t.lightMapIntensity.value = n.lightMapIntensity)),
          n.aoMap &&
            ((t.aoMap.value = n.aoMap),
            (t.aoMapIntensity.value = n.aoMapIntensity)),
          n.map
            ? (r = n.map)
            : n.specularMap
            ? (r = n.specularMap)
            : n.displacementMap
            ? (r = n.displacementMap)
            : n.normalMap
            ? (r = n.normalMap)
            : n.bumpMap
            ? (r = n.bumpMap)
            : n.roughnessMap
            ? (r = n.roughnessMap)
            : n.metalnessMap
            ? (r = n.metalnessMap)
            : n.alphaMap
            ? (r = n.alphaMap)
            : n.emissiveMap
            ? (r = n.emissiveMap)
            : n.clearcoatMap
            ? (r = n.clearcoatMap)
            : n.clearcoatNormalMap
            ? (r = n.clearcoatNormalMap)
            : n.clearcoatRoughnessMap && (r = n.clearcoatRoughnessMap),
          void 0 !== r &&
            (r.isWebGLRenderTarget && (r = r.texture),
            !0 === r.matrixAutoUpdate && r.updateMatrix(),
            t.uvTransform.value.copy(r.matrix)),
          n.aoMap ? (a = n.aoMap) : n.lightMap && (a = n.lightMap),
          void 0 !== a &&
            (a.isWebGLRenderTarget && (a = a.texture),
            !0 === a.matrixAutoUpdate && a.updateMatrix(),
            t.uv2Transform.value.copy(a.matrix))
      }
      function r (e, t) {
        e.diffuse.value.copy(t.color), (e.opacity.value = t.opacity)
      }
      function a (e, t) {
        ;(e.dashSize.value = t.dashSize),
          (e.totalSize.value = t.dashSize + t.gapSize),
          (e.scale.value = t.scale)
      }
      function s (e, t, n, i) {
        let r
        e.diffuse.value.copy(t.color),
          (e.opacity.value = t.opacity),
          (e.size.value = t.size * n),
          (e.scale.value = 0.5 * i),
          t.map && (e.map.value = t.map),
          t.alphaMap && (e.alphaMap.value = t.alphaMap),
          t.map ? (r = t.map) : t.alphaMap && (r = t.alphaMap),
          void 0 !== r &&
            (!0 === r.matrixAutoUpdate && r.updateMatrix(),
            e.uvTransform.value.copy(r.matrix))
      }
      function o (e, t) {
        let n
        e.diffuse.value.copy(t.color),
          (e.opacity.value = t.opacity),
          (e.rotation.value = t.rotation),
          t.map && (e.map.value = t.map),
          t.alphaMap && (e.alphaMap.value = t.alphaMap),
          t.map ? (n = t.map) : t.alphaMap && (n = t.alphaMap),
          void 0 !== n &&
            (!0 === n.matrixAutoUpdate && n.updateMatrix(),
            e.uvTransform.value.copy(n.matrix))
      }
      function l (e, t) {
        t.emissiveMap && (e.emissiveMap.value = t.emissiveMap)
      }
      function c (e, t) {
        e.specular.value.copy(t.specular),
          (e.shininess.value = Math.max(t.shininess, 1e-4)),
          t.emissiveMap && (e.emissiveMap.value = t.emissiveMap),
          t.bumpMap &&
            ((e.bumpMap.value = t.bumpMap),
            (e.bumpScale.value = t.bumpScale),
            t.side === z && (e.bumpScale.value *= -1)),
          t.normalMap &&
            ((e.normalMap.value = t.normalMap),
            e.normalScale.value.copy(t.normalScale),
            t.side === z && e.normalScale.value.negate()),
          t.displacementMap &&
            ((e.displacementMap.value = t.displacementMap),
            (e.displacementScale.value = t.displacementScale),
            (e.displacementBias.value = t.displacementBias))
      }
      function h (e, t) {
        t.gradientMap && (e.gradientMap.value = t.gradientMap),
          t.emissiveMap && (e.emissiveMap.value = t.emissiveMap),
          t.bumpMap &&
            ((e.bumpMap.value = t.bumpMap),
            (e.bumpScale.value = t.bumpScale),
            t.side === z && (e.bumpScale.value *= -1)),
          t.normalMap &&
            ((e.normalMap.value = t.normalMap),
            e.normalScale.value.copy(t.normalScale),
            t.side === z && e.normalScale.value.negate()),
          t.displacementMap &&
            ((e.displacementMap.value = t.displacementMap),
            (e.displacementScale.value = t.displacementScale),
            (e.displacementBias.value = t.displacementBias))
      }
      function u (t, n) {
        ;(t.roughness.value = n.roughness),
          (t.metalness.value = n.metalness),
          n.roughnessMap && (t.roughnessMap.value = n.roughnessMap),
          n.metalnessMap && (t.metalnessMap.value = n.metalnessMap),
          n.emissiveMap && (t.emissiveMap.value = n.emissiveMap),
          n.bumpMap &&
            ((t.bumpMap.value = n.bumpMap),
            (t.bumpScale.value = n.bumpScale),
            n.side === z && (t.bumpScale.value *= -1)),
          n.normalMap &&
            ((t.normalMap.value = n.normalMap),
            t.normalScale.value.copy(n.normalScale),
            n.side === z && t.normalScale.value.negate()),
          n.displacementMap &&
            ((t.displacementMap.value = n.displacementMap),
            (t.displacementScale.value = n.displacementScale),
            (t.displacementBias.value = n.displacementBias))
        const i = e.get(n).envMap
        i && (t.envMapIntensity.value = n.envMapIntensity)
      }
      function d (e, t, n) {
        u(e, t),
          (e.reflectivity.value = t.reflectivity),
          (e.clearcoat.value = t.clearcoat),
          (e.clearcoatRoughness.value = t.clearcoatRoughness),
          t.sheen && e.sheen.value.copy(t.sheen),
          t.clearcoatMap && (e.clearcoatMap.value = t.clearcoatMap),
          t.clearcoatRoughnessMap &&
            (e.clearcoatRoughnessMap.value = t.clearcoatRoughnessMap),
          t.clearcoatNormalMap &&
            (e.clearcoatNormalScale.value.copy(t.clearcoatNormalScale),
            (e.clearcoatNormalMap.value = t.clearcoatNormalMap),
            t.side === z && e.clearcoatNormalScale.value.negate()),
          (e.transmission.value = t.transmission),
          t.transmissionMap && (e.transmissionMap.value = t.transmissionMap),
          t.transmission > 0 &&
            ((e.transmissionSamplerMap.value = n.texture),
            e.transmissionSamplerSize.value.set(n.width, n.height)),
          (e.thickness.value = t.thickness),
          t.thicknessMap && (e.thicknessMap.value = t.thicknessMap),
          (e.attenuationDistance.value = t.attenuationDistance),
          e.attenuationColor.value.copy(t.attenuationColor)
      }
      function p (e, t) {
        t.matcap && (e.matcap.value = t.matcap),
          t.bumpMap &&
            ((e.bumpMap.value = t.bumpMap),
            (e.bumpScale.value = t.bumpScale),
            t.side === z && (e.bumpScale.value *= -1)),
          t.normalMap &&
            ((e.normalMap.value = t.normalMap),
            e.normalScale.value.copy(t.normalScale),
            t.side === z && e.normalScale.value.negate()),
          t.displacementMap &&
            ((e.displacementMap.value = t.displacementMap),
            (e.displacementScale.value = t.displacementScale),
            (e.displacementBias.value = t.displacementBias))
      }
      function f (e, t) {
        t.displacementMap &&
          ((e.displacementMap.value = t.displacementMap),
          (e.displacementScale.value = t.displacementScale),
          (e.displacementBias.value = t.displacementBias))
      }
      function m (e, t) {
        t.displacementMap &&
          ((e.displacementMap.value = t.displacementMap),
          (e.displacementScale.value = t.displacementScale),
          (e.displacementBias.value = t.displacementBias)),
          e.referencePosition.value.copy(t.referencePosition),
          (e.nearDistance.value = t.nearDistance),
          (e.farDistance.value = t.farDistance)
      }
      function g (e, t) {
        t.bumpMap &&
          ((e.bumpMap.value = t.bumpMap),
          (e.bumpScale.value = t.bumpScale),
          t.side === z && (e.bumpScale.value *= -1)),
          t.normalMap &&
            ((e.normalMap.value = t.normalMap),
            e.normalScale.value.copy(t.normalScale),
            t.side === z && e.normalScale.value.negate()),
          t.displacementMap &&
            ((e.displacementMap.value = t.displacementMap),
            (e.displacementScale.value = t.displacementScale),
            (e.displacementBias.value = t.displacementBias))
      }
      return { refreshFogUniforms: t, refreshMaterialUniforms: n }
    }
    function bh () {
      const e = document.createElementNS(
        'http://www.w3.org/1999/xhtml',
        'canvas'
      )
      return (e.style.display = 'block'), e
    }
    function Mh (e = {}) {
      const t = void 0 !== e.canvas ? e.canvas : bh(),
        n = void 0 !== e.context ? e.context : null,
        i = void 0 !== e.alpha && e.alpha,
        r = void 0 === e.depth || e.depth,
        a = void 0 === e.stencil || e.stencil,
        s = void 0 !== e.antialias && e.antialias,
        o = void 0 === e.premultipliedAlpha || e.premultipliedAlpha,
        l = void 0 !== e.preserveDrawingBuffer && e.preserveDrawingBuffer,
        c = void 0 !== e.powerPreference ? e.powerPreference : 'default',
        h =
          void 0 !== e.failIfMajorPerformanceCaveat &&
          e.failIfMajorPerformanceCaveat
      let u = null,
        d = null
      const p = [],
        f = []
      ;(this.domElement = t),
        (this.debug = { checkShaderErrors: !0 }),
        (this.autoClear = !0),
        (this.autoClearColor = !0),
        (this.autoClearDepth = !0),
        (this.autoClearStencil = !0),
        (this.sortObjects = !0),
        (this.clippingPlanes = []),
        (this.localClippingEnabled = !1),
        (this.gammaFactor = 2),
        (this.outputEncoding = dn),
        (this.physicallyCorrectLights = !1),
        (this.toneMapping = xe),
        (this.toneMappingExposure = 1)
      const g = this
      let v = !1,
        y = 0,
        _ = 0,
        x = null,
        w = -1,
        b = null
      const M = new Yn(),
        S = new Yn()
      let E = null,
        T = t.width,
        A = t.height,
        R = 1,
        L = null,
        C = null
      const P = new Yn(0, 0, T, A),
        D = new Yn(0, 0, T, A)
      let I = !1
      const N = [],
        O = new Ta()
      let F = !1,
        k = !1,
        H = null
      const W = new Li(),
        V = new Qn(),
        G = {
          background: null,
          fog: null,
          environment: null,
          overrideMaterial: null,
          isScene: !0
        }
      function j () {
        return null === x ? R : 1
      }
      let q,
        Y,
        X,
        J,
        Z,
        K,
        Q,
        $,
        ee,
        te,
        ne,
        ie,
        re,
        ae,
        se,
        oe,
        le,
        ce,
        he,
        ue,
        de,
        pe,
        fe = n
      function me (e, n) {
        for (let i = 0; i < e.length; i++) {
          const r = e[i],
            a = t.getContext(r, n)
          if (null !== a) return a
        }
        return null
      }
      try {
        const e = {
          alpha: i,
          depth: r,
          stencil: a,
          antialias: s,
          premultipliedAlpha: o,
          preserveDrawingBuffer: l,
          powerPreference: c,
          failIfMajorPerformanceCaveat: h
        }
        if (
          (t.addEventListener('webglcontextlost', ye, !1),
          t.addEventListener('webglcontextrestored', _e, !1),
          null === fe)
        ) {
          const t = ['webgl2', 'webgl', 'experimental-webgl']
          if (
            (!0 === g.isWebGL1Renderer && t.shift(),
            (fe = me(t, e)),
            null === fe)
          )
            throw me(t)
              ? new Error(
                  'Error creating WebGL context with your selected attributes.'
                )
              : new Error('Error creating WebGL context.')
        }
        void 0 === fe.getShaderPrecisionFormat &&
          (fe.getShaderPrecisionFormat = function () {
            return { rangeMin: 1, rangeMax: 1, precision: 1 }
          })
      } catch (m) {
        throw (console.error('THREE.WebGLRenderer: ' + m.message), m)
      }
      function ge () {
        ;(q = new ol(fe)),
          (Y = new rl(fe, q, e)),
          q.init(Y),
          (de = new mh(fe, q, Y)),
          (X = new ph(fe, q, Y)),
          (N[0] = 1029),
          (J = new hl(fe)),
          (Z = new Zc()),
          (K = new fh(fe, q, X, Z, Y, de, J)),
          (Q = new sl(g)),
          ($ = new Ra(fe, Y)),
          (pe = new nl(fe, q, $, Y)),
          (ee = new ll(fe, $, J, pe)),
          (te = new fl(fe, ee, $, J)),
          (ce = new pl(fe)),
          (se = new al(Z)),
          (ne = new Jc(g, Q, q, Y, pe, se)),
          (ie = new wh(Z)),
          (re = new eh(Z)),
          (ae = new oh(q, Y)),
          (le = new tl(g, Q, X, te, o)),
          (oe = new dh(g, te, Y)),
          (he = new il(fe, q, J, Y)),
          (ue = new cl(fe, q, J, Y)),
          (J.programs = ne.programs),
          (g.capabilities = Y),
          (g.extensions = q),
          (g.properties = Z),
          (g.renderLists = re),
          (g.shadowMap = oe),
          (g.state = X),
          (g.info = J)
      }
      ge()
      const ve = new xh(g, fe)
      function ye (e) {
        e.preventDefault(),
          console.log('THREE.WebGLRenderer: Context Lost.'),
          (v = !0)
      }
      function _e () {
        console.log('THREE.WebGLRenderer: Context Restored.'), (v = !1)
        const e = J.autoReset,
          t = oe.enabled,
          n = oe.autoUpdate,
          i = oe.needsUpdate,
          r = oe.type
        ge(),
          (J.autoReset = e),
          (oe.enabled = t),
          (oe.autoUpdate = n),
          (oe.needsUpdate = i),
          (oe.type = r)
      }
      function we (e) {
        const t = e.target
        t.removeEventListener('dispose', we), be(t)
      }
      function be (e) {
        Me(e), Z.remove(e)
      }
      function Me (e) {
        const t = Z.get(e).programs
        void 0 !== t &&
          t.forEach(function (e) {
            ne.releaseProgram(e)
          })
      }
      function Se (e, t) {
        e.render(function (e) {
          g.renderBufferImmediate(e, t)
        })
      }
      ;(this.xr = ve),
        (this.getContext = function () {
          return fe
        }),
        (this.getContextAttributes = function () {
          return fe.getContextAttributes()
        }),
        (this.forceContextLoss = function () {
          const e = q.get('WEBGL_lose_context')
          e && e.loseContext()
        }),
        (this.forceContextRestore = function () {
          const e = q.get('WEBGL_lose_context')
          e && e.restoreContext()
        }),
        (this.getPixelRatio = function () {
          return R
        }),
        (this.setPixelRatio = function (e) {
          void 0 !== e && ((R = e), this.setSize(T, A, !1))
        }),
        (this.getSize = function (e) {
          return e.set(T, A)
        }),
        (this.setSize = function (e, n, i) {
          ve.isPresenting
            ? console.warn(
                "THREE.WebGLRenderer: Can't change size while VR device is presenting."
              )
            : ((T = e),
              (A = n),
              (t.width = Math.floor(e * R)),
              (t.height = Math.floor(n * R)),
              !1 !== i &&
                ((t.style.width = e + 'px'), (t.style.height = n + 'px')),
              this.setViewport(0, 0, e, n))
        }),
        (this.getDrawingBufferSize = function (e) {
          return e.set(T * R, A * R).floor()
        }),
        (this.setDrawingBufferSize = function (e, n, i) {
          ;(T = e),
            (A = n),
            (R = i),
            (t.width = Math.floor(e * i)),
            (t.height = Math.floor(n * i)),
            this.setViewport(0, 0, e, n)
        }),
        (this.getCurrentViewport = function (e) {
          return e.copy(M)
        }),
        (this.getViewport = function (e) {
          return e.copy(P)
        }),
        (this.setViewport = function (e, t, n, i) {
          e.isVector4 ? P.set(e.x, e.y, e.z, e.w) : P.set(e, t, n, i),
            X.viewport(
              M.copy(P)
                .multiplyScalar(R)
                .floor()
            )
        }),
        (this.getScissor = function (e) {
          return e.copy(D)
        }),
        (this.setScissor = function (e, t, n, i) {
          e.isVector4 ? D.set(e.x, e.y, e.z, e.w) : D.set(e, t, n, i),
            X.scissor(
              S.copy(D)
                .multiplyScalar(R)
                .floor()
            )
        }),
        (this.getScissorTest = function () {
          return I
        }),
        (this.setScissorTest = function (e) {
          X.setScissorTest((I = e))
        }),
        (this.setOpaqueSort = function (e) {
          L = e
        }),
        (this.setTransparentSort = function (e) {
          C = e
        }),
        (this.getClearColor = function (e) {
          return e.copy(le.getClearColor())
        }),
        (this.setClearColor = function () {
          le.setClearColor.apply(le, arguments)
        }),
        (this.getClearAlpha = function () {
          return le.getClearAlpha()
        }),
        (this.setClearAlpha = function () {
          le.setClearAlpha.apply(le, arguments)
        }),
        (this.clear = function (e, t, n) {
          let i = 0
          ;(void 0 === e || e) && (i |= 16384),
            (void 0 === t || t) && (i |= 256),
            (void 0 === n || n) && (i |= 1024),
            fe.clear(i)
        }),
        (this.clearColor = function () {
          this.clear(!0, !1, !1)
        }),
        (this.clearDepth = function () {
          this.clear(!1, !0, !1)
        }),
        (this.clearStencil = function () {
          this.clear(!1, !1, !0)
        }),
        (this.dispose = function () {
          t.removeEventListener('webglcontextlost', ye, !1),
            t.removeEventListener('webglcontextrestored', _e, !1),
            re.dispose(),
            ae.dispose(),
            Z.dispose(),
            Q.dispose(),
            te.dispose(),
            pe.dispose(),
            ve.dispose(),
            ve.removeEventListener('sessionstart', Ae),
            ve.removeEventListener('sessionend', Re),
            H && (H.dispose(), (H = null)),
            Le.stop()
        }),
        (this.renderBufferImmediate = function (e, t) {
          pe.initAttributes()
          const n = Z.get(e)
          e.hasPositions && !n.position && (n.position = fe.createBuffer()),
            e.hasNormals && !n.normal && (n.normal = fe.createBuffer()),
            e.hasUvs && !n.uv && (n.uv = fe.createBuffer()),
            e.hasColors && !n.color && (n.color = fe.createBuffer())
          const i = t.getAttributes()
          e.hasPositions &&
            (fe.bindBuffer(34962, n.position),
            fe.bufferData(34962, e.positionArray, 35048),
            pe.enableAttribute(i.position),
            fe.vertexAttribPointer(i.position, 3, 5126, !1, 0, 0)),
            e.hasNormals &&
              (fe.bindBuffer(34962, n.normal),
              fe.bufferData(34962, e.normalArray, 35048),
              pe.enableAttribute(i.normal),
              fe.vertexAttribPointer(i.normal, 3, 5126, !1, 0, 0)),
            e.hasUvs &&
              (fe.bindBuffer(34962, n.uv),
              fe.bufferData(34962, e.uvArray, 35048),
              pe.enableAttribute(i.uv),
              fe.vertexAttribPointer(i.uv, 2, 5126, !1, 0, 0)),
            e.hasColors &&
              (fe.bindBuffer(34962, n.color),
              fe.bufferData(34962, e.colorArray, 35048),
              pe.enableAttribute(i.color),
              fe.vertexAttribPointer(i.color, 3, 5126, !1, 0, 0)),
            pe.disableUnusedAttributes(),
            fe.drawArrays(4, 0, e.count),
            (e.count = 0)
        }),
        (this.renderBufferDirect = function (e, t, n, i, r, a) {
          null === t && (t = G)
          const s = r.isMesh && r.matrixWorld.determinant() < 0,
            o = ze(e, t, i, r)
          X.setMaterial(i, s)
          let l = n.index
          const c = n.attributes.position
          if (null === l) {
            if (void 0 === c || 0 === c.count) return
          } else if (0 === l.count) return
          let h,
            u = 1
          !0 === i.wireframe && ((l = ee.getWireframeAttribute(n)), (u = 2)),
            (i.morphTargets || i.morphNormals) && ce.update(r, n, i, o),
            pe.setup(r, i, o, n, l)
          let d = he
          null !== l && ((h = $.get(l)), (d = ue), d.setIndex(h))
          const p = null !== l ? l.count : c.count,
            f = n.drawRange.start * u,
            m = n.drawRange.count * u,
            g = null !== a ? a.start * u : 0,
            v = null !== a ? a.count * u : 1 / 0,
            y = Math.max(f, g),
            _ = Math.min(p, f + m, g + v) - 1,
            x = Math.max(0, _ - y + 1)
          if (0 !== x) {
            if (r.isMesh)
              !0 === i.wireframe
                ? (X.setLineWidth(i.wireframeLinewidth * j()), d.setMode(1))
                : d.setMode(4)
            else if (r.isLine) {
              let e = i.linewidth
              void 0 === e && (e = 1),
                X.setLineWidth(e * j()),
                r.isLineSegments
                  ? d.setMode(1)
                  : r.isLineLoop
                  ? d.setMode(2)
                  : d.setMode(3)
            } else r.isPoints ? d.setMode(0) : r.isSprite && d.setMode(4)
            if (r.isInstancedMesh) d.renderInstances(y, x, r.count)
            else if (n.isInstancedBufferGeometry) {
              const e = Math.min(n.instanceCount, n._maxInstanceCount)
              d.renderInstances(y, x, e)
            } else d.render(y, x)
          }
        }),
        (this.compile = function (e, t) {
          ;(d = ae.get(e)),
            d.init(),
            e.traverseVisible(function (e) {
              e.isLight &&
                e.layers.test(t.layers) &&
                (d.pushLight(e), e.castShadow && d.pushShadow(e))
            }),
            d.setupLights(),
            e.traverse(function (t) {
              const n = t.material
              if (n)
                if (Array.isArray(n))
                  for (let i = 0; i < n.length; i++) {
                    const r = n[i]
                    Oe(r, e, t)
                  }
                else Oe(n, e, t)
            })
        })
      let Ee = null
      function Te (e) {
        Ee && Ee(e)
      }
      function Ae () {
        Le.stop()
      }
      function Re () {
        Le.start()
      }
      const Le = new Aa()
      function Ce (e, t, n, i) {
        if (!1 === e.visible) return
        const r = e.layers.test(t.layers)
        if (r)
          if (e.isGroup) n = e.renderOrder
          else if (e.isLOD) !0 === e.autoUpdate && e.update(t)
          else if (e.isLight) d.pushLight(e), e.castShadow && d.pushShadow(e)
          else if (e.isSprite) {
            if (!e.frustumCulled || O.intersectsSprite(e)) {
              i && V.setFromMatrixPosition(e.matrixWorld).applyMatrix4(W)
              const t = te.update(e),
                r = e.material
              r.visible && u.push(e, t, r, n, V.z, null)
            }
          } else if (e.isImmediateRenderObject)
            i && V.setFromMatrixPosition(e.matrixWorld).applyMatrix4(W),
              u.push(e, null, e.material, n, V.z, null)
          else if (
            (e.isMesh || e.isLine || e.isPoints) &&
            (e.isSkinnedMesh &&
              e.skeleton.frame !== J.render.frame &&
              (e.skeleton.update(), (e.skeleton.frame = J.render.frame)),
            !e.frustumCulled || O.intersectsObject(e))
          ) {
            i && V.setFromMatrixPosition(e.matrixWorld).applyMatrix4(W)
            const t = te.update(e),
              r = e.material
            if (Array.isArray(r)) {
              const i = t.groups
              for (let a = 0, s = i.length; a < s; a++) {
                const s = i[a],
                  o = r[s.materialIndex]
                o && o.visible && u.push(e, t, o, n, V.z, s)
              }
            } else r.visible && u.push(e, t, r, n, V.z, null)
          }
        const a = e.children
        for (let s = 0, o = a.length; s < o; s++) Ce(a[s], t, n, i)
      }
      function Pe (e, t, n, i) {
        if (null === H) {
          const e = !0 === s && !0 === Y.isWebGL2,
            t = e ? Zn : Xn
          H = new t(1024, 1024, {
            generateMipmaps: !0,
            type: null !== de.convert(Je) ? Je : We,
            minFilter: He,
            magFilter: Fe,
            wrapS: Ne,
            wrapT: Ne
          })
        }
        const r = g.getRenderTarget()
        g.setRenderTarget(H), g.clear()
        const a = g.toneMapping
        ;(g.toneMapping = xe),
          De(e, n, i),
          (g.toneMapping = a),
          K.updateMultisampleRenderTarget(H),
          K.updateRenderTargetMipmap(H),
          g.setRenderTarget(r),
          De(t, n, i)
      }
      function De (e, t, n) {
        const i = !0 === t.isScene ? t.overrideMaterial : null
        for (let r = 0, a = e.length; r < a; r++) {
          const a = e[r],
            s = a.object,
            o = a.geometry,
            l = null === i ? a.material : i,
            c = a.group
          if (n.isArrayCamera) {
            const e = n.cameras
            for (let n = 0, i = e.length; n < i; n++) {
              const i = e[n]
              s.layers.test(i.layers) &&
                (X.viewport(M.copy(i.viewport)),
                d.setupLightsView(i),
                Ie(s, t, i, o, l, c))
            }
          } else Ie(s, t, n, o, l, c)
        }
      }
      function Ie (e, t, n, i, r, a) {
        if (
          (e.onBeforeRender(g, t, n, i, r, a),
          e.modelViewMatrix.multiplyMatrices(
            n.matrixWorldInverse,
            e.matrixWorld
          ),
          e.normalMatrix.getNormalMatrix(e.modelViewMatrix),
          e.isImmediateRenderObject)
        ) {
          const i = ze(n, t, r, e)
          X.setMaterial(r), pe.reset(), Se(e, i)
        } else
          !0 === r.transparent && r.side === U
            ? ((r.side = z),
              (r.needsUpdate = !0),
              g.renderBufferDirect(n, t, i, r, e, a),
              (r.side = B),
              (r.needsUpdate = !0),
              g.renderBufferDirect(n, t, i, r, e, a),
              (r.side = U))
            : g.renderBufferDirect(n, t, i, r, e, a)
        e.onAfterRender(g, t, n, i, r, a)
      }
      function Oe (e, t, n) {
        !0 !== t.isScene && (t = G)
        const i = Z.get(e),
          r = d.state.lights,
          a = d.state.shadowsArray,
          s = r.state.version,
          o = ne.getParameters(e, r.state, a, t, n),
          l = ne.getProgramCacheKey(o)
        let c = i.programs
        ;(i.environment = e.isMeshStandardMaterial ? t.environment : null),
          (i.fog = t.fog),
          (i.envMap = Q.get(e.envMap || i.environment)),
          void 0 === c &&
            (e.addEventListener('dispose', we),
            (c = new Map()),
            (i.programs = c))
        let h = c.get(l)
        if (void 0 !== h) {
          if (i.currentProgram === h && i.lightsStateVersion === s)
            return Be(e, o), h
        } else
          (o.uniforms = ne.getUniforms(e)),
            e.onBuild(o, g),
            e.onBeforeCompile(o, g),
            (h = ne.acquireProgram(o, l)),
            c.set(l, h),
            (i.uniforms = o.uniforms)
        const u = i.uniforms
        ;((e.isShaderMaterial || e.isRawShaderMaterial) && !0 !== e.clipping) ||
          (u.clippingPlanes = se.uniform),
          Be(e, o),
          (i.needsLights = ke(e)),
          (i.lightsStateVersion = s),
          i.needsLights &&
            ((u.ambientLightColor.value = r.state.ambient),
            (u.lightProbe.value = r.state.probe),
            (u.directionalLights.value = r.state.directional),
            (u.directionalLightShadows.value = r.state.directionalShadow),
            (u.spotLights.value = r.state.spot),
            (u.spotLightShadows.value = r.state.spotShadow),
            (u.rectAreaLights.value = r.state.rectArea),
            (u.ltc_1.value = r.state.rectAreaLTC1),
            (u.ltc_2.value = r.state.rectAreaLTC2),
            (u.pointLights.value = r.state.point),
            (u.pointLightShadows.value = r.state.pointShadow),
            (u.hemisphereLights.value = r.state.hemi),
            (u.directionalShadowMap.value = r.state.directionalShadowMap),
            (u.directionalShadowMatrix.value = r.state.directionalShadowMatrix),
            (u.spotShadowMap.value = r.state.spotShadowMap),
            (u.spotShadowMatrix.value = r.state.spotShadowMatrix),
            (u.pointShadowMap.value = r.state.pointShadowMap),
            (u.pointShadowMatrix.value = r.state.pointShadowMatrix))
        const p = h.getUniforms(),
          f = xc.seqWithValue(p.seq, u)
        return (i.currentProgram = h), (i.uniformsList = f), h
      }
      function Be (e, t) {
        const n = Z.get(e)
        ;(n.outputEncoding = t.outputEncoding),
          (n.instancing = t.instancing),
          (n.skinning = t.skinning),
          (n.numClippingPlanes = t.numClippingPlanes),
          (n.numIntersection = t.numClipIntersection),
          (n.vertexAlphas = t.vertexAlphas)
      }
      function ze (e, t, n, i) {
        !0 !== t.isScene && (t = G), K.resetTextureUnits()
        const r = t.fog,
          a = n.isMeshStandardMaterial ? t.environment : null,
          s = null === x ? g.outputEncoding : x.texture.encoding,
          o = Q.get(n.envMap || a),
          l =
            !0 === n.vertexColors &&
            i.geometry &&
            i.geometry.attributes.color &&
            4 === i.geometry.attributes.color.itemSize,
          c = Z.get(n),
          h = d.state.lights
        if (!0 === F && (!0 === k || e !== b)) {
          const t = e === b && n.id === w
          se.setState(n, e, t)
        }
        let u = !1
        n.version === c.__version
          ? (c.needsLights && c.lightsStateVersion !== h.state.version) ||
            c.outputEncoding !== s ||
            (i.isInstancedMesh && !1 === c.instancing)
            ? (u = !0)
            : i.isInstancedMesh || !0 !== c.instancing
            ? i.isSkinnedMesh && !1 === c.skinning
              ? (u = !0)
              : i.isSkinnedMesh || !0 !== c.skinning
              ? c.envMap !== o || (n.fog && c.fog !== r)
                ? (u = !0)
                : void 0 === c.numClippingPlanes ||
                  (c.numClippingPlanes === se.numPlanes &&
                    c.numIntersection === se.numIntersection)
                ? c.vertexAlphas !== l && (u = !0)
                : (u = !0)
              : (u = !0)
            : (u = !0)
          : ((u = !0), (c.__version = n.version))
        let p = c.currentProgram
        !0 === u && (p = Oe(n, t, i))
        let f = !1,
          m = !1,
          v = !1
        const y = p.getUniforms(),
          _ = c.uniforms
        if (
          (X.useProgram(p.program) && ((f = !0), (m = !0), (v = !0)),
          n.id !== w && ((w = n.id), (m = !0)),
          f || b !== e)
        ) {
          if (
            (y.setValue(fe, 'projectionMatrix', e.projectionMatrix),
            Y.logarithmicDepthBuffer &&
              y.setValue(
                fe,
                'logDepthBufFC',
                2 / (Math.log(e.far + 1) / Math.LN2)
              ),
            b !== e && ((b = e), (m = !0), (v = !0)),
            n.isShaderMaterial ||
              n.isMeshPhongMaterial ||
              n.isMeshToonMaterial ||
              n.isMeshStandardMaterial ||
              n.envMap)
          ) {
            const t = y.map.cameraPosition
            void 0 !== t &&
              t.setValue(fe, V.setFromMatrixPosition(e.matrixWorld))
          }
          ;(n.isMeshPhongMaterial ||
            n.isMeshToonMaterial ||
            n.isMeshLambertMaterial ||
            n.isMeshBasicMaterial ||
            n.isMeshStandardMaterial ||
            n.isShaderMaterial) &&
            y.setValue(fe, 'isOrthographic', !0 === e.isOrthographicCamera),
            (n.isMeshPhongMaterial ||
              n.isMeshToonMaterial ||
              n.isMeshLambertMaterial ||
              n.isMeshBasicMaterial ||
              n.isMeshStandardMaterial ||
              n.isShaderMaterial ||
              n.isShadowMaterial ||
              i.isSkinnedMesh) &&
              y.setValue(fe, 'viewMatrix', e.matrixWorldInverse)
        }
        if (i.isSkinnedMesh) {
          y.setOptional(fe, i, 'bindMatrix'),
            y.setOptional(fe, i, 'bindMatrixInverse')
          const e = i.skeleton
          e &&
            (Y.floatVertexTextures
              ? (null === e.boneTexture && e.computeBoneTexture(),
                y.setValue(fe, 'boneTexture', e.boneTexture, K),
                y.setValue(fe, 'boneTextureSize', e.boneTextureSize))
              : y.setOptional(fe, e, 'boneMatrices'))
        }
        return (
          (m || c.receiveShadow !== i.receiveShadow) &&
            ((c.receiveShadow = i.receiveShadow),
            y.setValue(fe, 'receiveShadow', i.receiveShadow)),
          m &&
            (y.setValue(fe, 'toneMappingExposure', g.toneMappingExposure),
            c.needsLights && Ue(_, v),
            r && n.fog && ie.refreshFogUniforms(_, r),
            ie.refreshMaterialUniforms(_, n, R, A, H),
            xc.upload(fe, c.uniformsList, _, K)),
          n.isShaderMaterial &&
            !0 === n.uniformsNeedUpdate &&
            (xc.upload(fe, c.uniformsList, _, K), (n.uniformsNeedUpdate = !1)),
          n.isSpriteMaterial && y.setValue(fe, 'center', i.center),
          y.setValue(fe, 'modelViewMatrix', i.modelViewMatrix),
          y.setValue(fe, 'normalMatrix', i.normalMatrix),
          y.setValue(fe, 'modelMatrix', i.matrixWorld),
          p
        )
      }
      function Ue (e, t) {
        ;(e.ambientLightColor.needsUpdate = t),
          (e.lightProbe.needsUpdate = t),
          (e.directionalLights.needsUpdate = t),
          (e.directionalLightShadows.needsUpdate = t),
          (e.pointLights.needsUpdate = t),
          (e.pointLightShadows.needsUpdate = t),
          (e.spotLights.needsUpdate = t),
          (e.spotLightShadows.needsUpdate = t),
          (e.rectAreaLights.needsUpdate = t),
          (e.hemisphereLights.needsUpdate = t)
      }
      function ke (e) {
        return (
          e.isMeshLambertMaterial ||
          e.isMeshToonMaterial ||
          e.isMeshPhongMaterial ||
          e.isMeshStandardMaterial ||
          e.isShadowMaterial ||
          (e.isShaderMaterial && !0 === e.lights)
        )
      }
      Le.setAnimationLoop(Te),
        'undefined' !== typeof window && Le.setContext(window),
        (this.setAnimationLoop = function (e) {
          ;(Ee = e), ve.setAnimationLoop(e), null === e ? Le.stop() : Le.start()
        }),
        ve.addEventListener('sessionstart', Ae),
        ve.addEventListener('sessionend', Re),
        (this.render = function (e, t) {
          if (void 0 !== t && !0 !== t.isCamera)
            return void console.error(
              'THREE.WebGLRenderer.render: camera is not an instance of THREE.Camera.'
            )
          if (!0 === v) return
          !0 === e.autoUpdate && e.updateMatrixWorld(),
            null === t.parent && t.updateMatrixWorld(),
            !0 === ve.enabled &&
              !0 === ve.isPresenting &&
              (!0 === ve.cameraAutoUpdate && ve.updateCamera(t),
              (t = ve.getCamera())),
            !0 === e.isScene && e.onBeforeRender(g, e, t, x),
            (d = ae.get(e, f.length)),
            d.init(),
            f.push(d),
            W.multiplyMatrices(t.projectionMatrix, t.matrixWorldInverse),
            O.setFromProjectionMatrix(W),
            (k = this.localClippingEnabled),
            (F = se.init(this.clippingPlanes, k, t)),
            (u = re.get(e, p.length)),
            u.init(),
            p.push(u),
            Ce(e, t, 0, g.sortObjects),
            u.finish(),
            !0 === g.sortObjects && u.sort(L, C),
            !0 === F && se.beginShadows()
          const n = d.state.shadowsArray
          oe.render(n, e, t),
            d.setupLights(),
            d.setupLightsView(t),
            !0 === F && se.endShadows(),
            !0 === this.info.autoReset && this.info.reset(),
            le.render(u, e)
          const i = u.opaque,
            r = u.transmissive,
            a = u.transparent
          i.length > 0 && De(i, e, t),
            r.length > 0 && Pe(i, r, e, t),
            a.length > 0 && De(a, e, t),
            null !== x &&
              (K.updateMultisampleRenderTarget(x),
              K.updateRenderTargetMipmap(x)),
            !0 === e.isScene && e.onAfterRender(g, e, t),
            X.buffers.depth.setTest(!0),
            X.buffers.depth.setMask(!0),
            X.buffers.color.setMask(!0),
            X.setPolygonOffset(!1),
            pe.resetDefaultState(),
            (w = -1),
            (b = null),
            f.pop(),
            (d = f.length > 0 ? f[f.length - 1] : null),
            p.pop(),
            (u = p.length > 0 ? p[p.length - 1] : null)
        }),
        (this.getActiveCubeFace = function () {
          return y
        }),
        (this.getActiveMipmapLevel = function () {
          return _
        }),
        (this.getRenderTarget = function () {
          return x
        }),
        (this.setRenderTarget = function (e, t = 0, n = 0) {
          ;(x = e),
            (y = t),
            (_ = n),
            e &&
              void 0 === Z.get(e).__webglFramebuffer &&
              K.setupRenderTarget(e)
          let i = null,
            r = !1,
            a = !1
          if (e) {
            const n = e.texture
            ;(n.isDataTexture3D || n.isDataTexture2DArray) && (a = !0)
            const s = Z.get(e).__webglFramebuffer
            e.isWebGLCubeRenderTarget
              ? ((i = s[t]), (r = !0))
              : (i = e.isWebGLMultisampleRenderTarget
                  ? Z.get(e).__webglMultisampledFramebuffer
                  : s),
              M.copy(e.viewport),
              S.copy(e.scissor),
              (E = e.scissorTest)
          } else
            M.copy(P)
              .multiplyScalar(R)
              .floor(),
              S.copy(D)
                .multiplyScalar(R)
                .floor(),
              (E = I)
          const s = X.bindFramebuffer(36160, i)
          if (s && Y.drawBuffers) {
            let t = !1
            if (e)
              if (e.isWebGLMultipleRenderTargets) {
                const n = e.texture
                if (N.length !== n.length || 36064 !== N[0]) {
                  for (let e = 0, t = n.length; e < t; e++) N[e] = 36064 + e
                  ;(N.length = n.length), (t = !0)
                }
              } else
                (1 === N.length && 36064 === N[0]) ||
                  ((N[0] = 36064), (N.length = 1), (t = !0))
            else
              (1 === N.length && 1029 === N[0]) ||
                ((N[0] = 1029), (N.length = 1), (t = !0))
            t &&
              (Y.isWebGL2
                ? fe.drawBuffers(N)
                : q.get('WEBGL_draw_buffers').drawBuffersWEBGL(N))
          }
          if ((X.viewport(M), X.scissor(S), X.setScissorTest(E), r)) {
            const i = Z.get(e.texture)
            fe.framebufferTexture2D(
              36160,
              36064,
              34069 + t,
              i.__webglTexture,
              n
            )
          } else if (a) {
            const i = Z.get(e.texture),
              r = t || 0
            fe.framebufferTextureLayer(
              36160,
              36064,
              i.__webglTexture,
              n || 0,
              r
            )
          }
        }),
        (this.readRenderTargetPixels = function (e, t, n, i, r, a, s) {
          if (!e || !e.isWebGLRenderTarget)
            return void console.error(
              'THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not THREE.WebGLRenderTarget.'
            )
          let o = Z.get(e).__webglFramebuffer
          if ((e.isWebGLCubeRenderTarget && void 0 !== s && (o = o[s]), o)) {
            X.bindFramebuffer(36160, o)
            try {
              const s = e.texture,
                o = s.format,
                l = s.type
              if (o !== nt && de.convert(o) !== fe.getParameter(35739))
                return void console.error(
                  'THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not in RGBA or implementation defined format.'
                )
              const c =
                l === Je &&
                (q.has('EXT_color_buffer_half_float') ||
                  (Y.isWebGL2 && q.has('EXT_color_buffer_float')))
              if (
                l !== We &&
                de.convert(l) !== fe.getParameter(35738) &&
                (l !== Xe ||
                  !(
                    Y.isWebGL2 ||
                    q.has('OES_texture_float') ||
                    q.has('WEBGL_color_buffer_float')
                  )) &&
                !c
              )
                return void console.error(
                  'THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not in UnsignedByteType or implementation defined type.'
                )
              36053 === fe.checkFramebufferStatus(36160)
                ? t >= 0 &&
                  t <= e.width - i &&
                  n >= 0 &&
                  n <= e.height - r &&
                  fe.readPixels(t, n, i, r, de.convert(o), de.convert(l), a)
                : console.error(
                    'THREE.WebGLRenderer.readRenderTargetPixels: readPixels from renderTarget failed. Framebuffer not complete.'
                  )
            } finally {
              const e = null !== x ? Z.get(x).__webglFramebuffer : null
              X.bindFramebuffer(36160, e)
            }
          }
        }),
        (this.copyFramebufferToTexture = function (e, t, n = 0) {
          const i = Math.pow(2, -n),
            r = Math.floor(t.image.width * i),
            a = Math.floor(t.image.height * i)
          let s = de.convert(t.format)
          Y.isWebGL2 && (6407 === s && (s = 32849), 6408 === s && (s = 32856)),
            K.setTexture2D(t, 0),
            fe.copyTexImage2D(3553, n, s, e.x, e.y, r, a, 0),
            X.unbindTexture()
        }),
        (this.copyTextureToTexture = function (e, t, n, i = 0) {
          const r = t.image.width,
            a = t.image.height,
            s = de.convert(n.format),
            o = de.convert(n.type)
          K.setTexture2D(n, 0),
            fe.pixelStorei(37440, n.flipY),
            fe.pixelStorei(37441, n.premultiplyAlpha),
            fe.pixelStorei(3317, n.unpackAlignment),
            t.isDataTexture
              ? fe.texSubImage2D(3553, i, e.x, e.y, r, a, s, o, t.image.data)
              : t.isCompressedTexture
              ? fe.compressedTexSubImage2D(
                  3553,
                  i,
                  e.x,
                  e.y,
                  t.mipmaps[0].width,
                  t.mipmaps[0].height,
                  s,
                  t.mipmaps[0].data
                )
              : fe.texSubImage2D(3553, i, e.x, e.y, s, o, t.image),
            0 === i && n.generateMipmaps && fe.generateMipmap(3553),
            X.unbindTexture()
        }),
        (this.copyTextureToTexture3D = function (e, t, n, i, r = 0) {
          if (g.isWebGL1Renderer)
            return void console.warn(
              'THREE.WebGLRenderer.copyTextureToTexture3D: can only be used with WebGL2.'
            )
          const a = e.max.x - e.min.x + 1,
            s = e.max.y - e.min.y + 1,
            o = e.max.z - e.min.z + 1,
            l = de.convert(i.format),
            c = de.convert(i.type)
          let h
          if (i.isDataTexture3D) K.setTexture3D(i, 0), (h = 32879)
          else {
            if (!i.isDataTexture2DArray)
              return void console.warn(
                'THREE.WebGLRenderer.copyTextureToTexture3D: only supports THREE.DataTexture3D and THREE.DataTexture2DArray.'
              )
            K.setTexture2DArray(i, 0), (h = 35866)
          }
          fe.pixelStorei(37440, i.flipY),
            fe.pixelStorei(37441, i.premultiplyAlpha),
            fe.pixelStorei(3317, i.unpackAlignment)
          const u = fe.getParameter(3314),
            d = fe.getParameter(32878),
            p = fe.getParameter(3316),
            f = fe.getParameter(3315),
            m = fe.getParameter(32877),
            v = n.isCompressedTexture ? n.mipmaps[0] : n.image
          fe.pixelStorei(3314, v.width),
            fe.pixelStorei(32878, v.height),
            fe.pixelStorei(3316, e.min.x),
            fe.pixelStorei(3315, e.min.y),
            fe.pixelStorei(32877, e.min.z),
            n.isDataTexture || n.isDataTexture3D
              ? fe.texSubImage3D(h, r, t.x, t.y, t.z, a, s, o, l, c, v.data)
              : n.isCompressedTexture
              ? (console.warn(
                  'THREE.WebGLRenderer.copyTextureToTexture3D: untested support for compressed srcTexture.'
                ),
                fe.compressedTexSubImage3D(
                  h,
                  r,
                  t.x,
                  t.y,
                  t.z,
                  a,
                  s,
                  o,
                  l,
                  v.data
                ))
              : fe.texSubImage3D(h, r, t.x, t.y, t.z, a, s, o, l, c, v),
            fe.pixelStorei(3314, u),
            fe.pixelStorei(32878, d),
            fe.pixelStorei(3316, p),
            fe.pixelStorei(3315, f),
            fe.pixelStorei(32877, m),
            0 === r && i.generateMipmaps && fe.generateMipmap(h),
            X.unbindTexture()
        }),
        (this.initTexture = function (e) {
          K.setTexture2D(e, 0), X.unbindTexture()
        }),
        (this.resetState = function () {
          ;(y = 0), (_ = 0), (x = null), X.reset(), pe.reset()
        }),
        'undefined' !== typeof __THREE_DEVTOOLS__ &&
          __THREE_DEVTOOLS__.dispatchEvent(
            new CustomEvent('observe', { detail: this })
          )
    }
    class Sh extends Mh {}
    Sh.prototype.isWebGL1Renderer = !0
    class Eh {
      constructor (e, t = 25e-5) {
        ;(this.name = ''), (this.color = new xr(e)), (this.density = t)
      }
      clone () {
        return new Eh(this.color, this.density)
      }
      toJSON () {
        return {
          type: 'FogExp2',
          color: this.color.getHex(),
          density: this.density
        }
      }
    }
    Eh.prototype.isFogExp2 = !0
    class Th {
      constructor (e, t = 1, n = 1e3) {
        ;(this.name = ''),
          (this.color = new xr(e)),
          (this.near = t),
          (this.far = n)
      }
      clone () {
        return new Th(this.color, this.near, this.far)
      }
      toJSON () {
        return {
          type: 'Fog',
          color: this.color.getHex(),
          near: this.near,
          far: this.far
        }
      }
    }
    Th.prototype.isFog = !0
    class Ah extends er {
      constructor () {
        super(),
          (this.type = 'Scene'),
          (this.background = null),
          (this.environment = null),
          (this.fog = null),
          (this.overrideMaterial = null),
          (this.autoUpdate = !0),
          'undefined' !== typeof __THREE_DEVTOOLS__ &&
            __THREE_DEVTOOLS__.dispatchEvent(
              new CustomEvent('observe', { detail: this })
            )
      }
      copy (e, t) {
        return (
          super.copy(e, t),
          null !== e.background && (this.background = e.background.clone()),
          null !== e.environment && (this.environment = e.environment.clone()),
          null !== e.fog && (this.fog = e.fog.clone()),
          null !== e.overrideMaterial &&
            (this.overrideMaterial = e.overrideMaterial.clone()),
          (this.autoUpdate = e.autoUpdate),
          (this.matrixAutoUpdate = e.matrixAutoUpdate),
          this
        )
      }
      toJSON (e) {
        const t = super.toJSON(e)
        return null !== this.fog && (t.object.fog = this.fog.toJSON()), t
      }
    }
    Ah.prototype.isScene = !0
    class Rh {
      constructor (e, t) {
        ;(this.array = e),
          (this.stride = t),
          (this.count = void 0 !== e ? e.length / t : 0),
          (this.usage = Tn),
          (this.updateRange = { offset: 0, count: -1 }),
          (this.version = 0),
          (this.uuid = In())
      }
      onUploadCallback () {}
      set needsUpdate (e) {
        !0 === e && this.version++
      }
      setUsage (e) {
        return (this.usage = e), this
      }
      copy (e) {
        return (
          (this.array = new e.array.constructor(e.array)),
          (this.count = e.count),
          (this.stride = e.stride),
          (this.usage = e.usage),
          this
        )
      }
      copyAt (e, t, n) {
        ;(e *= this.stride), (n *= t.stride)
        for (let i = 0, r = this.stride; i < r; i++)
          this.array[e + i] = t.array[n + i]
        return this
      }
      set (e, t = 0) {
        return this.array.set(e, t), this
      }
      clone (e) {
        void 0 === e.arrayBuffers && (e.arrayBuffers = {}),
          void 0 === this.array.buffer._uuid &&
            (this.array.buffer._uuid = In()),
          void 0 === e.arrayBuffers[this.array.buffer._uuid] &&
            (e.arrayBuffers[this.array.buffer._uuid] = this.array.slice(
              0
            ).buffer)
        const t = new this.array.constructor(
            e.arrayBuffers[this.array.buffer._uuid]
          ),
          n = new this.constructor(t, this.stride)
        return n.setUsage(this.usage), n
      }
      onUpload (e) {
        return (this.onUploadCallback = e), this
      }
      toJSON (e) {
        return (
          void 0 === e.arrayBuffers && (e.arrayBuffers = {}),
          void 0 === this.array.buffer._uuid &&
            (this.array.buffer._uuid = In()),
          void 0 === e.arrayBuffers[this.array.buffer._uuid] &&
            (e.arrayBuffers[
              this.array.buffer._uuid
            ] = Array.prototype.slice.call(new Uint32Array(this.array.buffer))),
          {
            uuid: this.uuid,
            buffer: this.array.buffer._uuid,
            type: this.array.constructor.name,
            stride: this.stride
          }
        )
      }
    }
    Rh.prototype.isInterleavedBuffer = !0
    const Lh = new Qn()
    class Ch {
      constructor (e, t, n, i = !1) {
        ;(this.name = ''),
          (this.data = e),
          (this.itemSize = t),
          (this.offset = n),
          (this.normalized = !0 === i)
      }
      get count () {
        return this.data.count
      }
      get array () {
        return this.data.array
      }
      set needsUpdate (e) {
        this.data.needsUpdate = e
      }
      applyMatrix4 (e) {
        for (let t = 0, n = this.data.count; t < n; t++)
          (Lh.x = this.getX(t)),
            (Lh.y = this.getY(t)),
            (Lh.z = this.getZ(t)),
            Lh.applyMatrix4(e),
            this.setXYZ(t, Lh.x, Lh.y, Lh.z)
        return this
      }
      applyNormalMatrix (e) {
        for (let t = 0, n = this.count; t < n; t++)
          (Lh.x = this.getX(t)),
            (Lh.y = this.getY(t)),
            (Lh.z = this.getZ(t)),
            Lh.applyNormalMatrix(e),
            this.setXYZ(t, Lh.x, Lh.y, Lh.z)
        return this
      }
      transformDirection (e) {
        for (let t = 0, n = this.count; t < n; t++)
          (Lh.x = this.getX(t)),
            (Lh.y = this.getY(t)),
            (Lh.z = this.getZ(t)),
            Lh.transformDirection(e),
            this.setXYZ(t, Lh.x, Lh.y, Lh.z)
        return this
      }
      setX (e, t) {
        return (this.data.array[e * this.data.stride + this.offset] = t), this
      }
      setY (e, t) {
        return (
          (this.data.array[e * this.data.stride + this.offset + 1] = t), this
        )
      }
      setZ (e, t) {
        return (
          (this.data.array[e * this.data.stride + this.offset + 2] = t), this
        )
      }
      setW (e, t) {
        return (
          (this.data.array[e * this.data.stride + this.offset + 3] = t), this
        )
      }
      getX (e) {
        return this.data.array[e * this.data.stride + this.offset]
      }
      getY (e) {
        return this.data.array[e * this.data.stride + this.offset + 1]
      }
      getZ (e) {
        return this.data.array[e * this.data.stride + this.offset + 2]
      }
      getW (e) {
        return this.data.array[e * this.data.stride + this.offset + 3]
      }
      setXY (e, t, n) {
        return (
          (e = e * this.data.stride + this.offset),
          (this.data.array[e + 0] = t),
          (this.data.array[e + 1] = n),
          this
        )
      }
      setXYZ (e, t, n, i) {
        return (
          (e = e * this.data.stride + this.offset),
          (this.data.array[e + 0] = t),
          (this.data.array[e + 1] = n),
          (this.data.array[e + 2] = i),
          this
        )
      }
      setXYZW (e, t, n, i, r) {
        return (
          (e = e * this.data.stride + this.offset),
          (this.data.array[e + 0] = t),
          (this.data.array[e + 1] = n),
          (this.data.array[e + 2] = i),
          (this.data.array[e + 3] = r),
          this
        )
      }
      clone (e) {
        if (void 0 === e) {
          console.log(
            'THREE.InterleavedBufferAttribute.clone(): Cloning an interlaved buffer attribute will deinterleave buffer data.'
          )
          const e = []
          for (let t = 0; t < this.count; t++) {
            const n = t * this.data.stride + this.offset
            for (let t = 0; t < this.itemSize; t++)
              e.push(this.data.array[n + t])
          }
          return new Sr(
            new this.array.constructor(e),
            this.itemSize,
            this.normalized
          )
        }
        return (
          void 0 === e.interleavedBuffers && (e.interleavedBuffers = {}),
          void 0 === e.interleavedBuffers[this.data.uuid] &&
            (e.interleavedBuffers[this.data.uuid] = this.data.clone(e)),
          new Ch(
            e.interleavedBuffers[this.data.uuid],
            this.itemSize,
            this.offset,
            this.normalized
          )
        )
      }
      toJSON (e) {
        if (void 0 === e) {
          console.log(
            'THREE.InterleavedBufferAttribute.toJSON(): Serializing an interlaved buffer attribute will deinterleave buffer data.'
          )
          const e = []
          for (let t = 0; t < this.count; t++) {
            const n = t * this.data.stride + this.offset
            for (let t = 0; t < this.itemSize; t++)
              e.push(this.data.array[n + t])
          }
          return {
            itemSize: this.itemSize,
            type: this.array.constructor.name,
            array: e,
            normalized: this.normalized
          }
        }
        return (
          void 0 === e.interleavedBuffers && (e.interleavedBuffers = {}),
          void 0 === e.interleavedBuffers[this.data.uuid] &&
            (e.interleavedBuffers[this.data.uuid] = this.data.toJSON(e)),
          {
            isInterleavedBufferAttribute: !0,
            itemSize: this.itemSize,
            data: this.data.uuid,
            offset: this.offset,
            normalized: this.normalized
          }
        )
      }
    }
    Ch.prototype.isInterleavedBufferAttribute = !0
    class Ph extends pr {
      constructor (e) {
        super(),
          (this.type = 'SpriteMaterial'),
          (this.color = new xr(16777215)),
          (this.map = null),
          (this.alphaMap = null),
          (this.rotation = 0),
          (this.sizeAttenuation = !0),
          (this.transparent = !0),
          this.setValues(e)
      }
      copy (e) {
        return (
          super.copy(e),
          this.color.copy(e.color),
          (this.map = e.map),
          (this.alphaMap = e.alphaMap),
          (this.rotation = e.rotation),
          (this.sizeAttenuation = e.sizeAttenuation),
          this
        )
      }
    }
    let Dh
    Ph.prototype.isSpriteMaterial = !0
    const Ih = new Qn(),
      Nh = new Qn(),
      Oh = new Qn(),
      Fh = new kn(),
      Bh = new kn(),
      zh = new Li(),
      Uh = new Qn(),
      kh = new Qn(),
      Hh = new Qn(),
      Wh = new kn(),
      Vh = new kn(),
      Gh = new kn()
    class jh extends er {
      constructor (e) {
        if ((super(), (this.type = 'Sprite'), void 0 === Dh)) {
          Dh = new Ur()
          const e = new Float32Array([
              -0.5,
              -0.5,
              0,
              0,
              0,
              0.5,
              -0.5,
              0,
              1,
              0,
              0.5,
              0.5,
              0,
              1,
              1,
              -0.5,
              0.5,
              0,
              0,
              1
            ]),
            t = new Rh(e, 5)
          Dh.setIndex([0, 1, 2, 0, 2, 3]),
            Dh.setAttribute('position', new Ch(t, 3, 0, !1)),
            Dh.setAttribute('uv', new Ch(t, 2, 3, !1))
        }
        ;(this.geometry = Dh),
          (this.material = void 0 !== e ? e : new Ph()),
          (this.center = new kn(0.5, 0.5))
      }
      raycast (e, t) {
        null === e.camera &&
          console.error(
            'THREE.Sprite: "Raycaster.camera" needs to be set in order to raycast against sprites.'
          ),
          Nh.setFromMatrixScale(this.matrixWorld),
          zh.copy(e.camera.matrixWorld),
          this.modelViewMatrix.multiplyMatrices(
            e.camera.matrixWorldInverse,
            this.matrixWorld
          ),
          Oh.setFromMatrixPosition(this.modelViewMatrix),
          e.camera.isPerspectiveCamera &&
            !1 === this.material.sizeAttenuation &&
            Nh.multiplyScalar(-Oh.z)
        const n = this.material.rotation
        let i, r
        0 !== n && ((r = Math.cos(n)), (i = Math.sin(n)))
        const a = this.center
        qh(Uh.set(-0.5, -0.5, 0), Oh, a, Nh, i, r),
          qh(kh.set(0.5, -0.5, 0), Oh, a, Nh, i, r),
          qh(Hh.set(0.5, 0.5, 0), Oh, a, Nh, i, r),
          Wh.set(0, 0),
          Vh.set(1, 0),
          Gh.set(1, 1)
        let s = e.ray.intersectTriangle(Uh, kh, Hh, !1, Ih)
        if (
          null === s &&
          (qh(kh.set(-0.5, 0.5, 0), Oh, a, Nh, i, r),
          Vh.set(0, 1),
          (s = e.ray.intersectTriangle(Uh, Hh, kh, !1, Ih)),
          null === s)
        )
          return
        const o = e.ray.origin.distanceTo(Ih)
        o < e.near ||
          o > e.far ||
          t.push({
            distance: o,
            point: Ih.clone(),
            uv: ur.getUV(Ih, Uh, kh, Hh, Wh, Vh, Gh, new kn()),
            face: null,
            object: this
          })
      }
      copy (e) {
        return (
          super.copy(e),
          void 0 !== e.center && this.center.copy(e.center),
          (this.material = e.material),
          this
        )
      }
    }
    function qh (e, t, n, i, r, a) {
      Fh.subVectors(e, n)
        .addScalar(0.5)
        .multiply(i),
        void 0 !== r
          ? ((Bh.x = a * Fh.x - r * Fh.y), (Bh.y = r * Fh.x + a * Fh.y))
          : Bh.copy(Fh),
        e.copy(t),
        (e.x += Bh.x),
        (e.y += Bh.y),
        e.applyMatrix4(zh)
    }
    jh.prototype.isSprite = !0
    const Yh = new Qn(),
      Xh = new Qn()
    class Jh extends er {
      constructor () {
        super(),
          (this._currentLevel = 0),
          (this.type = 'LOD'),
          Object.defineProperties(this, {
            levels: { enumerable: !0, value: [] },
            isLOD: { value: !0 }
          }),
          (this.autoUpdate = !0)
      }
      copy (e) {
        super.copy(e, !1)
        const t = e.levels
        for (let n = 0, i = t.length; n < i; n++) {
          const e = t[n]
          this.addLevel(e.object.clone(), e.distance)
        }
        return (this.autoUpdate = e.autoUpdate), this
      }
      addLevel (e, t = 0) {
        t = Math.abs(t)
        const n = this.levels
        let i
        for (i = 0; i < n.length; i++) if (t < n[i].distance) break
        return n.splice(i, 0, { distance: t, object: e }), this.add(e), this
      }
      getCurrentLevel () {
        return this._currentLevel
      }
      getObjectForDistance (e) {
        const t = this.levels
        if (t.length > 0) {
          let n, i
          for (n = 1, i = t.length; n < i; n++) if (e < t[n].distance) break
          return t[n - 1].object
        }
        return null
      }
      raycast (e, t) {
        const n = this.levels
        if (n.length > 0) {
          Yh.setFromMatrixPosition(this.matrixWorld)
          const n = e.ray.origin.distanceTo(Yh)
          this.getObjectForDistance(n).raycast(e, t)
        }
      }
      update (e) {
        const t = this.levels
        if (t.length > 1) {
          Yh.setFromMatrixPosition(e.matrixWorld),
            Xh.setFromMatrixPosition(this.matrixWorld)
          const n = Yh.distanceTo(Xh) / e.zoom
          let i, r
          for (t[0].object.visible = !0, i = 1, r = t.length; i < r; i++) {
            if (!(n >= t[i].distance)) break
            ;(t[i - 1].object.visible = !1), (t[i].object.visible = !0)
          }
          for (this._currentLevel = i - 1; i < r; i++) t[i].object.visible = !1
        }
      }
      toJSON (e) {
        const t = super.toJSON(e)
        !1 === this.autoUpdate && (t.object.autoUpdate = !1),
          (t.object.levels = [])
        const n = this.levels
        for (let i = 0, r = n.length; i < r; i++) {
          const e = n[i]
          t.object.levels.push({ object: e.object.uuid, distance: e.distance })
        }
        return t
      }
    }
    const Zh = new Qn(),
      Kh = new Yn(),
      Qh = new Yn(),
      $h = new Qn(),
      eu = new Li()
    class tu extends ia {
      constructor (e, t) {
        super(e, t),
          (this.type = 'SkinnedMesh'),
          (this.bindMode = 'attached'),
          (this.bindMatrix = new Li()),
          (this.bindMatrixInverse = new Li())
      }
      copy (e) {
        return (
          super.copy(e),
          (this.bindMode = e.bindMode),
          this.bindMatrix.copy(e.bindMatrix),
          this.bindMatrixInverse.copy(e.bindMatrixInverse),
          (this.skeleton = e.skeleton),
          this
        )
      }
      bind (e, t) {
        ;(this.skeleton = e),
          void 0 === t &&
            (this.updateMatrixWorld(!0),
            this.skeleton.calculateInverses(),
            (t = this.matrixWorld)),
          this.bindMatrix.copy(t),
          this.bindMatrixInverse.copy(t).invert()
      }
      pose () {
        this.skeleton.pose()
      }
      normalizeSkinWeights () {
        const e = new Yn(),
          t = this.geometry.attributes.skinWeight
        for (let n = 0, i = t.count; n < i; n++) {
          ;(e.x = t.getX(n)),
            (e.y = t.getY(n)),
            (e.z = t.getZ(n)),
            (e.w = t.getW(n))
          const i = 1 / e.manhattanLength()
          i !== 1 / 0 ? e.multiplyScalar(i) : e.set(1, 0, 0, 0),
            t.setXYZW(n, e.x, e.y, e.z, e.w)
        }
      }
      updateMatrixWorld (e) {
        super.updateMatrixWorld(e),
          'attached' === this.bindMode
            ? this.bindMatrixInverse.copy(this.matrixWorld).invert()
            : 'detached' === this.bindMode
            ? this.bindMatrixInverse.copy(this.bindMatrix).invert()
            : console.warn(
                'THREE.SkinnedMesh: Unrecognized bindMode: ' + this.bindMode
              )
      }
      boneTransform (e, t) {
        const n = this.skeleton,
          i = this.geometry
        Kh.fromBufferAttribute(i.attributes.skinIndex, e),
          Qh.fromBufferAttribute(i.attributes.skinWeight, e),
          Zh.fromBufferAttribute(i.attributes.position, e).applyMatrix4(
            this.bindMatrix
          ),
          t.set(0, 0, 0)
        for (let r = 0; r < 4; r++) {
          const e = Qh.getComponent(r)
          if (0 !== e) {
            const i = Kh.getComponent(r)
            eu.multiplyMatrices(n.bones[i].matrixWorld, n.boneInverses[i]),
              t.addScaledVector($h.copy(Zh).applyMatrix4(eu), e)
          }
        }
        return t.applyMatrix4(this.bindMatrixInverse)
      }
    }
    tu.prototype.isSkinnedMesh = !0
    class nu extends er {
      constructor () {
        super(), (this.type = 'Bone')
      }
    }
    nu.prototype.isBone = !0
    class iu extends jn {
      constructor (
        e = null,
        t = 1,
        n = 1,
        i,
        r,
        a,
        s,
        o,
        l = Fe,
        c = Fe,
        h,
        u
      ) {
        super(null, a, s, o, l, c, i, r, h, u),
          (this.image = { data: e, width: t, height: n }),
          (this.magFilter = l),
          (this.minFilter = c),
          (this.generateMipmaps = !1),
          (this.flipY = !1),
          (this.unpackAlignment = 1),
          (this.needsUpdate = !0)
      }
    }
    iu.prototype.isDataTexture = !0
    const ru = new Li(),
      au = new Li()
    class su {
      constructor (e = [], t = []) {
        ;(this.uuid = In()),
          (this.bones = e.slice(0)),
          (this.boneInverses = t),
          (this.boneMatrices = null),
          (this.boneTexture = null),
          (this.boneTextureSize = 0),
          (this.frame = -1),
          this.init()
      }
      init () {
        const e = this.bones,
          t = this.boneInverses
        if (
          ((this.boneMatrices = new Float32Array(16 * e.length)),
          0 === t.length)
        )
          this.calculateInverses()
        else if (e.length !== t.length) {
          console.warn(
            'THREE.Skeleton: Number of inverse bone matrices does not match amount of bones.'
          ),
            (this.boneInverses = [])
          for (let e = 0, t = this.bones.length; e < t; e++)
            this.boneInverses.push(new Li())
        }
      }
      calculateInverses () {
        this.boneInverses.length = 0
        for (let e = 0, t = this.bones.length; e < t; e++) {
          const t = new Li()
          this.bones[e] && t.copy(this.bones[e].matrixWorld).invert(),
            this.boneInverses.push(t)
        }
      }
      pose () {
        for (let e = 0, t = this.bones.length; e < t; e++) {
          const t = this.bones[e]
          t && t.matrixWorld.copy(this.boneInverses[e]).invert()
        }
        for (let e = 0, t = this.bones.length; e < t; e++) {
          const t = this.bones[e]
          t &&
            (t.parent && t.parent.isBone
              ? (t.matrix.copy(t.parent.matrixWorld).invert(),
                t.matrix.multiply(t.matrixWorld))
              : t.matrix.copy(t.matrixWorld),
            t.matrix.decompose(t.position, t.quaternion, t.scale))
        }
      }
      update () {
        const e = this.bones,
          t = this.boneInverses,
          n = this.boneMatrices,
          i = this.boneTexture
        for (let r = 0, a = e.length; r < a; r++) {
          const i = e[r] ? e[r].matrixWorld : au
          ru.multiplyMatrices(i, t[r]), ru.toArray(n, 16 * r)
        }
        null !== i && (i.needsUpdate = !0)
      }
      clone () {
        return new su(this.bones, this.boneInverses)
      }
      computeBoneTexture () {
        let e = Math.sqrt(4 * this.bones.length)
        ;(e = zn(e)), (e = Math.max(e, 4))
        const t = new Float32Array(e * e * 4)
        t.set(this.boneMatrices)
        const n = new iu(t, e, e, nt, Xe)
        return (
          (this.boneMatrices = t),
          (this.boneTexture = n),
          (this.boneTextureSize = e),
          this
        )
      }
      getBoneByName (e) {
        for (let t = 0, n = this.bones.length; t < n; t++) {
          const n = this.bones[t]
          if (n.name === e) return n
        }
      }
      dispose () {
        null !== this.boneTexture &&
          (this.boneTexture.dispose(), (this.boneTexture = null))
      }
      fromJSON (e, t) {
        this.uuid = e.uuid
        for (let n = 0, i = e.bones.length; n < i; n++) {
          const i = e.bones[n]
          let r = t[i]
          void 0 === r &&
            (console.warn('THREE.Skeleton: No bone found with UUID:', i),
            (r = new nu())),
            this.bones.push(r),
            this.boneInverses.push(new Li().fromArray(e.boneInverses[n]))
        }
        return this.init(), this
      }
      toJSON () {
        const e = {
          metadata: {
            version: 4.5,
            type: 'Skeleton',
            generator: 'Skeleton.toJSON'
          },
          bones: [],
          boneInverses: []
        }
        e.uuid = this.uuid
        const t = this.bones,
          n = this.boneInverses
        for (let i = 0, r = t.length; i < r; i++) {
          const r = t[i]
          e.bones.push(r.uuid)
          const a = n[i]
          e.boneInverses.push(a.toArray())
        }
        return e
      }
    }
    const ou = new Li(),
      lu = new Li(),
      cu = [],
      hu = new ia()
    class uu extends ia {
      constructor (e, t, n) {
        super(e, t),
          (this.instanceMatrix = new Sr(new Float32Array(16 * n), 16)),
          (this.instanceColor = null),
          (this.count = n),
          (this.frustumCulled = !1)
      }
      copy (e) {
        return (
          super.copy(e),
          this.instanceMatrix.copy(e.instanceMatrix),
          null !== e.instanceColor &&
            (this.instanceColor = e.instanceColor.clone()),
          (this.count = e.count),
          this
        )
      }
      getColorAt (e, t) {
        t.fromArray(this.instanceColor.array, 3 * e)
      }
      getMatrixAt (e, t) {
        t.fromArray(this.instanceMatrix.array, 16 * e)
      }
      raycast (e, t) {
        const n = this.matrixWorld,
          i = this.count
        if (
          ((hu.geometry = this.geometry),
          (hu.material = this.material),
          void 0 !== hu.material)
        )
          for (let r = 0; r < i; r++) {
            this.getMatrixAt(r, ou),
              lu.multiplyMatrices(n, ou),
              (hu.matrixWorld = lu),
              hu.raycast(e, cu)
            for (let e = 0, n = cu.length; e < n; e++) {
              const n = cu[e]
              ;(n.instanceId = r), (n.object = this), t.push(n)
            }
            cu.length = 0
          }
      }
      setColorAt (e, t) {
        null === this.instanceColor &&
          (this.instanceColor = new Sr(new Float32Array(3 * this.count), 3)),
          t.toArray(this.instanceColor.array, 3 * e)
      }
      setMatrixAt (e, t) {
        t.toArray(this.instanceMatrix.array, 16 * e)
      }
      updateMorphTargets () {}
      dispose () {
        this.dispatchEvent({ type: 'dispose' })
      }
    }
    uu.prototype.isInstancedMesh = !0
    class du extends pr {
      constructor (e) {
        super(),
          (this.type = 'LineBasicMaterial'),
          (this.color = new xr(16777215)),
          (this.linewidth = 1),
          (this.linecap = 'round'),
          (this.linejoin = 'round'),
          (this.morphTargets = !1),
          this.setValues(e)
      }
      copy (e) {
        return (
          super.copy(e),
          this.color.copy(e.color),
          (this.linewidth = e.linewidth),
          (this.linecap = e.linecap),
          (this.linejoin = e.linejoin),
          (this.morphTargets = e.morphTargets),
          this
        )
      }
    }
    du.prototype.isLineBasicMaterial = !0
    const pu = new Qn(),
      fu = new Qn(),
      mu = new Li(),
      gu = new Ri(),
      vu = new xi()
    class yu extends er {
      constructor (e = new Ur(), t = new du()) {
        super(),
          (this.type = 'Line'),
          (this.geometry = e),
          (this.material = t),
          this.updateMorphTargets()
      }
      copy (e) {
        return (
          super.copy(e),
          (this.material = e.material),
          (this.geometry = e.geometry),
          this
        )
      }
      computeLineDistances () {
        const e = this.geometry
        if (e.isBufferGeometry)
          if (null === e.index) {
            const t = e.attributes.position,
              n = [0]
            for (let e = 1, i = t.count; e < i; e++)
              pu.fromBufferAttribute(t, e - 1),
                fu.fromBufferAttribute(t, e),
                (n[e] = n[e - 1]),
                (n[e] += pu.distanceTo(fu))
            e.setAttribute('lineDistance', new Rr(n, 1))
          } else
            console.warn(
              'THREE.Line.computeLineDistances(): Computation only possible with non-indexed BufferGeometry.'
            )
        else
          e.isGeometry &&
            console.error(
              'THREE.Line.computeLineDistances() no longer supports THREE.Geometry. Use THREE.BufferGeometry instead.'
            )
        return this
      }
      raycast (e, t) {
        const n = this.geometry,
          i = this.matrixWorld,
          r = e.params.Line.threshold,
          a = n.drawRange
        if (
          (null === n.boundingSphere && n.computeBoundingSphere(),
          vu.copy(n.boundingSphere),
          vu.applyMatrix4(i),
          (vu.radius += r),
          !1 === e.ray.intersectsSphere(vu))
        )
          return
        mu.copy(i).invert(), gu.copy(e.ray).applyMatrix4(mu)
        const s = r / ((this.scale.x + this.scale.y + this.scale.z) / 3),
          o = s * s,
          l = new Qn(),
          c = new Qn(),
          h = new Qn(),
          u = new Qn(),
          d = this.isLineSegments ? 2 : 1
        if (n.isBufferGeometry) {
          const i = n.index,
            r = n.attributes,
            s = r.position
          if (null !== i) {
            const n = Math.max(0, a.start),
              r = Math.min(i.count, a.start + a.count)
            for (let a = n, p = r - 1; a < p; a += d) {
              const n = i.getX(a),
                r = i.getX(a + 1)
              l.fromBufferAttribute(s, n), c.fromBufferAttribute(s, r)
              const d = gu.distanceSqToSegment(l, c, u, h)
              if (d > o) continue
              u.applyMatrix4(this.matrixWorld)
              const p = e.ray.origin.distanceTo(u)
              p < e.near ||
                p > e.far ||
                t.push({
                  distance: p,
                  point: h.clone().applyMatrix4(this.matrixWorld),
                  index: a,
                  face: null,
                  faceIndex: null,
                  object: this
                })
            }
          } else {
            const n = Math.max(0, a.start),
              i = Math.min(s.count, a.start + a.count)
            for (let r = n, a = i - 1; r < a; r += d) {
              l.fromBufferAttribute(s, r), c.fromBufferAttribute(s, r + 1)
              const n = gu.distanceSqToSegment(l, c, u, h)
              if (n > o) continue
              u.applyMatrix4(this.matrixWorld)
              const i = e.ray.origin.distanceTo(u)
              i < e.near ||
                i > e.far ||
                t.push({
                  distance: i,
                  point: h.clone().applyMatrix4(this.matrixWorld),
                  index: r,
                  face: null,
                  faceIndex: null,
                  object: this
                })
            }
          }
        } else
          n.isGeometry &&
            console.error(
              'THREE.Line.raycast() no longer supports THREE.Geometry. Use THREE.BufferGeometry instead.'
            )
      }
      updateMorphTargets () {
        const e = this.geometry
        if (e.isBufferGeometry) {
          const t = e.morphAttributes,
            n = Object.keys(t)
          if (n.length > 0) {
            const e = t[n[0]]
            if (void 0 !== e) {
              ;(this.morphTargetInfluences = []),
                (this.morphTargetDictionary = {})
              for (let t = 0, n = e.length; t < n; t++) {
                const n = e[t].name || String(t)
                this.morphTargetInfluences.push(0),
                  (this.morphTargetDictionary[n] = t)
              }
            }
          }
        } else {
          const t = e.morphTargets
          void 0 !== t &&
            t.length > 0 &&
            console.error(
              'THREE.Line.updateMorphTargets() does not support THREE.Geometry. Use THREE.BufferGeometry instead.'
            )
        }
      }
    }
    yu.prototype.isLine = !0
    const _u = new Qn(),
      xu = new Qn()
    class wu extends yu {
      constructor (e, t) {
        super(e, t), (this.type = 'LineSegments')
      }
      computeLineDistances () {
        const e = this.geometry
        if (e.isBufferGeometry)
          if (null === e.index) {
            const t = e.attributes.position,
              n = []
            for (let e = 0, i = t.count; e < i; e += 2)
              _u.fromBufferAttribute(t, e),
                xu.fromBufferAttribute(t, e + 1),
                (n[e] = 0 === e ? 0 : n[e - 1]),
                (n[e + 1] = n[e] + _u.distanceTo(xu))
            e.setAttribute('lineDistance', new Rr(n, 1))
          } else
            console.warn(
              'THREE.LineSegments.computeLineDistances(): Computation only possible with non-indexed BufferGeometry.'
            )
        else
          e.isGeometry &&
            console.error(
              'THREE.LineSegments.computeLineDistances() no longer supports THREE.Geometry. Use THREE.BufferGeometry instead.'
            )
        return this
      }
    }
    wu.prototype.isLineSegments = !0
    class bu extends yu {
      constructor (e, t) {
        super(e, t), (this.type = 'LineLoop')
      }
    }
    bu.prototype.isLineLoop = !0
    class Mu extends pr {
      constructor (e) {
        super(),
          (this.type = 'PointsMaterial'),
          (this.color = new xr(16777215)),
          (this.map = null),
          (this.alphaMap = null),
          (this.size = 1),
          (this.sizeAttenuation = !0),
          (this.morphTargets = !1),
          this.setValues(e)
      }
      copy (e) {
        return (
          super.copy(e),
          this.color.copy(e.color),
          (this.map = e.map),
          (this.alphaMap = e.alphaMap),
          (this.size = e.size),
          (this.sizeAttenuation = e.sizeAttenuation),
          (this.morphTargets = e.morphTargets),
          this
        )
      }
    }
    Mu.prototype.isPointsMaterial = !0
    const Su = new Li(),
      Eu = new Ri(),
      Tu = new xi(),
      Au = new Qn()
    class Ru extends er {
      constructor (e = new Ur(), t = new Mu()) {
        super(),
          (this.type = 'Points'),
          (this.geometry = e),
          (this.material = t),
          this.updateMorphTargets()
      }
      copy (e) {
        return (
          super.copy(e),
          (this.material = e.material),
          (this.geometry = e.geometry),
          this
        )
      }
      raycast (e, t) {
        const n = this.geometry,
          i = this.matrixWorld,
          r = e.params.Points.threshold,
          a = n.drawRange
        if (
          (null === n.boundingSphere && n.computeBoundingSphere(),
          Tu.copy(n.boundingSphere),
          Tu.applyMatrix4(i),
          (Tu.radius += r),
          !1 === e.ray.intersectsSphere(Tu))
        )
          return
        Su.copy(i).invert(), Eu.copy(e.ray).applyMatrix4(Su)
        const s = r / ((this.scale.x + this.scale.y + this.scale.z) / 3),
          o = s * s
        if (n.isBufferGeometry) {
          const r = n.index,
            s = n.attributes,
            l = s.position
          if (null !== r) {
            const n = Math.max(0, a.start),
              s = Math.min(r.count, a.start + a.count)
            for (let a = n, c = s; a < c; a++) {
              const n = r.getX(a)
              Au.fromBufferAttribute(l, n), Lu(Au, n, o, i, e, t, this)
            }
          } else {
            const n = Math.max(0, a.start),
              r = Math.min(l.count, a.start + a.count)
            for (let a = n, s = r; a < s; a++)
              Au.fromBufferAttribute(l, a), Lu(Au, a, o, i, e, t, this)
          }
        } else
          console.error(
            'THREE.Points.raycast() no longer supports THREE.Geometry. Use THREE.BufferGeometry instead.'
          )
      }
      updateMorphTargets () {
        const e = this.geometry
        if (e.isBufferGeometry) {
          const t = e.morphAttributes,
            n = Object.keys(t)
          if (n.length > 0) {
            const e = t[n[0]]
            if (void 0 !== e) {
              ;(this.morphTargetInfluences = []),
                (this.morphTargetDictionary = {})
              for (let t = 0, n = e.length; t < n; t++) {
                const n = e[t].name || String(t)
                this.morphTargetInfluences.push(0),
                  (this.morphTargetDictionary[n] = t)
              }
            }
          }
        } else {
          const t = e.morphTargets
          void 0 !== t &&
            t.length > 0 &&
            console.error(
              'THREE.Points.updateMorphTargets() does not support THREE.Geometry. Use THREE.BufferGeometry instead.'
            )
        }
      }
    }
    function Lu (e, t, n, i, r, a, s) {
      const o = Eu.distanceSqToPoint(e)
      if (o < n) {
        const n = new Qn()
        Eu.closestPointToPoint(e, n), n.applyMatrix4(i)
        const l = r.ray.origin.distanceTo(n)
        if (l < r.near || l > r.far) return
        a.push({
          distance: l,
          distanceToRay: Math.sqrt(o),
          point: n,
          index: t,
          face: null,
          object: s
        })
      }
    }
    Ru.prototype.isPoints = !0
    class Cu extends jn {
      constructor (e, t, n, i, r, a, s, o, l) {
        super(e, t, n, i, r, a, s, o, l),
          (this.format = void 0 !== s ? s : tt),
          (this.minFilter = void 0 !== a ? a : Ue),
          (this.magFilter = void 0 !== r ? r : Ue),
          (this.generateMipmaps = !1)
        const c = this
        function h () {
          ;(c.needsUpdate = !0), e.requestVideoFrameCallback(h)
        }
        'requestVideoFrameCallback' in e && e.requestVideoFrameCallback(h)
      }
      clone () {
        return new this.constructor(this.image).copy(this)
      }
      update () {
        const e = this.image,
          t = 'requestVideoFrameCallback' in e
        !1 === t &&
          e.readyState >= e.HAVE_CURRENT_DATA &&
          (this.needsUpdate = !0)
      }
    }
    Cu.prototype.isVideoTexture = !0
    class Pu extends jn {
      constructor (e, t, n, i, r, a, s, o, l, c, h, u) {
        super(null, a, s, o, l, c, i, r, h, u),
          (this.image = { width: t, height: n }),
          (this.mipmaps = e),
          (this.flipY = !1),
          (this.generateMipmaps = !1)
      }
    }
    Pu.prototype.isCompressedTexture = !0
    class Du extends jn {
      constructor (e, t, n, i, r, a, s, o, l) {
        super(e, t, n, i, r, a, s, o, l), (this.needsUpdate = !0)
      }
    }
    Du.prototype.isCanvasTexture = !0
    class Iu extends jn {
      constructor (e, t, n, i, r, a, s, o, l, c) {
        if (((c = void 0 !== c ? c : at), c !== at && c !== st))
          throw new Error(
            'DepthTexture format must be either THREE.DepthFormat or THREE.DepthStencilFormat'
          )
        void 0 === n && c === at && (n = je),
          void 0 === n && c === st && (n = $e),
          super(null, i, r, a, s, o, c, n, l),
          (this.image = { width: e, height: t }),
          (this.magFilter = void 0 !== s ? s : Fe),
          (this.minFilter = void 0 !== o ? o : Fe),
          (this.flipY = !1),
          (this.generateMipmaps = !1)
      }
    }
    Iu.prototype.isDepthTexture = !0
    class Nu extends Ur {
      constructor (e = 1, t = 8, n = 0, i = 2 * Math.PI) {
        super(),
          (this.type = 'CircleGeometry'),
          (this.parameters = {
            radius: e,
            segments: t,
            thetaStart: n,
            thetaLength: i
          }),
          (t = Math.max(3, t))
        const r = [],
          a = [],
          s = [],
          o = [],
          l = new Qn(),
          c = new kn()
        a.push(0, 0, 0), s.push(0, 0, 1), o.push(0.5, 0.5)
        for (let h = 0, u = 3; h <= t; h++, u += 3) {
          const r = n + (h / t) * i
          ;(l.x = e * Math.cos(r)),
            (l.y = e * Math.sin(r)),
            a.push(l.x, l.y, l.z),
            s.push(0, 0, 1),
            (c.x = (a[u] / e + 1) / 2),
            (c.y = (a[u + 1] / e + 1) / 2),
            o.push(c.x, c.y)
        }
        for (let h = 1; h <= t; h++) r.push(h, h + 1, 0)
        this.setIndex(r),
          this.setAttribute('position', new Rr(a, 3)),
          this.setAttribute('normal', new Rr(s, 3)),
          this.setAttribute('uv', new Rr(o, 2))
      }
      static fromJSON (e) {
        return new Nu(e.radius, e.segments, e.thetaStart, e.thetaLength)
      }
    }
    class Ou extends Ur {
      constructor (
        e = 1,
        t = 1,
        n = 1,
        i = 8,
        r = 1,
        a = !1,
        s = 0,
        o = 2 * Math.PI
      ) {
        super(),
          (this.type = 'CylinderGeometry'),
          (this.parameters = {
            radiusTop: e,
            radiusBottom: t,
            height: n,
            radialSegments: i,
            heightSegments: r,
            openEnded: a,
            thetaStart: s,
            thetaLength: o
          })
        const l = this
        ;(i = Math.floor(i)), (r = Math.floor(r))
        const c = [],
          h = [],
          u = [],
          d = []
        let p = 0
        const f = [],
          m = n / 2
        let g = 0
        function v () {
          const a = new Qn(),
            v = new Qn()
          let y = 0
          const _ = (t - e) / n
          for (let l = 0; l <= r; l++) {
            const c = [],
              g = l / r,
              y = g * (t - e) + e
            for (let e = 0; e <= i; e++) {
              const t = e / i,
                r = t * o + s,
                l = Math.sin(r),
                f = Math.cos(r)
              ;(v.x = y * l),
                (v.y = -g * n + m),
                (v.z = y * f),
                h.push(v.x, v.y, v.z),
                a.set(l, _, f).normalize(),
                u.push(a.x, a.y, a.z),
                d.push(t, 1 - g),
                c.push(p++)
            }
            f.push(c)
          }
          for (let e = 0; e < i; e++)
            for (let t = 0; t < r; t++) {
              const n = f[t][e],
                i = f[t + 1][e],
                r = f[t + 1][e + 1],
                a = f[t][e + 1]
              c.push(n, i, a), c.push(i, r, a), (y += 6)
            }
          l.addGroup(g, y, 0), (g += y)
        }
        function y (n) {
          const r = p,
            a = new kn(),
            f = new Qn()
          let v = 0
          const y = !0 === n ? e : t,
            _ = !0 === n ? 1 : -1
          for (let e = 1; e <= i; e++)
            h.push(0, m * _, 0), u.push(0, _, 0), d.push(0.5, 0.5), p++
          const x = p
          for (let e = 0; e <= i; e++) {
            const t = e / i,
              n = t * o + s,
              r = Math.cos(n),
              l = Math.sin(n)
            ;(f.x = y * l),
              (f.y = m * _),
              (f.z = y * r),
              h.push(f.x, f.y, f.z),
              u.push(0, _, 0),
              (a.x = 0.5 * r + 0.5),
              (a.y = 0.5 * l * _ + 0.5),
              d.push(a.x, a.y),
              p++
          }
          for (let e = 0; e < i; e++) {
            const t = r + e,
              i = x + e
            !0 === n ? c.push(i, i + 1, t) : c.push(i + 1, i, t), (v += 3)
          }
          l.addGroup(g, v, !0 === n ? 1 : 2), (g += v)
        }
        v(),
          !1 === a && (e > 0 && y(!0), t > 0 && y(!1)),
          this.setIndex(c),
          this.setAttribute('position', new Rr(h, 3)),
          this.setAttribute('normal', new Rr(u, 3)),
          this.setAttribute('uv', new Rr(d, 2))
      }
      static fromJSON (e) {
        return new Ou(
          e.radiusTop,
          e.radiusBottom,
          e.height,
          e.radialSegments,
          e.heightSegments,
          e.openEnded,
          e.thetaStart,
          e.thetaLength
        )
      }
    }
    class Fu extends Ou {
      constructor (e = 1, t = 1, n = 8, i = 1, r = !1, a = 0, s = 2 * Math.PI) {
        super(0, e, t, n, i, r, a, s),
          (this.type = 'ConeGeometry'),
          (this.parameters = {
            radius: e,
            height: t,
            radialSegments: n,
            heightSegments: i,
            openEnded: r,
            thetaStart: a,
            thetaLength: s
          })
      }
      static fromJSON (e) {
        return new Fu(
          e.radius,
          e.height,
          e.radialSegments,
          e.heightSegments,
          e.openEnded,
          e.thetaStart,
          e.thetaLength
        )
      }
    }
    class Bu extends Ur {
      constructor (e, t, n = 1, i = 0) {
        super(),
          (this.type = 'PolyhedronGeometry'),
          (this.parameters = { vertices: e, indices: t, radius: n, detail: i })
        const r = [],
          a = []
        function s (e) {
          const n = new Qn(),
            i = new Qn(),
            r = new Qn()
          for (let a = 0; a < t.length; a += 3)
            d(t[a + 0], n), d(t[a + 1], i), d(t[a + 2], r), o(n, i, r, e)
        }
        function o (e, t, n, i) {
          const r = i + 1,
            a = []
          for (let s = 0; s <= r; s++) {
            a[s] = []
            const i = e.clone().lerp(n, s / r),
              o = t.clone().lerp(n, s / r),
              l = r - s
            for (let e = 0; e <= l; e++)
              a[s][e] = 0 === e && s === r ? i : i.clone().lerp(o, e / l)
          }
          for (let s = 0; s < r; s++)
            for (let e = 0; e < 2 * (r - s) - 1; e++) {
              const t = Math.floor(e / 2)
              e % 2 === 0
                ? (u(a[s][t + 1]), u(a[s + 1][t]), u(a[s][t]))
                : (u(a[s][t + 1]), u(a[s + 1][t + 1]), u(a[s + 1][t]))
            }
        }
        function l (e) {
          const t = new Qn()
          for (let n = 0; n < r.length; n += 3)
            (t.x = r[n + 0]),
              (t.y = r[n + 1]),
              (t.z = r[n + 2]),
              t.normalize().multiplyScalar(e),
              (r[n + 0] = t.x),
              (r[n + 1] = t.y),
              (r[n + 2] = t.z)
        }
        function c () {
          const e = new Qn()
          for (let t = 0; t < r.length; t += 3) {
            ;(e.x = r[t + 0]), (e.y = r[t + 1]), (e.z = r[t + 2])
            const n = m(e) / 2 / Math.PI + 0.5,
              i = g(e) / Math.PI + 0.5
            a.push(n, 1 - i)
          }
          p(), h()
        }
        function h () {
          for (let e = 0; e < a.length; e += 6) {
            const t = a[e + 0],
              n = a[e + 2],
              i = a[e + 4],
              r = Math.max(t, n, i),
              s = Math.min(t, n, i)
            r > 0.9 &&
              s < 0.1 &&
              (t < 0.2 && (a[e + 0] += 1),
              n < 0.2 && (a[e + 2] += 1),
              i < 0.2 && (a[e + 4] += 1))
          }
        }
        function u (e) {
          r.push(e.x, e.y, e.z)
        }
        function d (t, n) {
          const i = 3 * t
          ;(n.x = e[i + 0]), (n.y = e[i + 1]), (n.z = e[i + 2])
        }
        function p () {
          const e = new Qn(),
            t = new Qn(),
            n = new Qn(),
            i = new Qn(),
            s = new kn(),
            o = new kn(),
            l = new kn()
          for (let c = 0, h = 0; c < r.length; c += 9, h += 6) {
            e.set(r[c + 0], r[c + 1], r[c + 2]),
              t.set(r[c + 3], r[c + 4], r[c + 5]),
              n.set(r[c + 6], r[c + 7], r[c + 8]),
              s.set(a[h + 0], a[h + 1]),
              o.set(a[h + 2], a[h + 3]),
              l.set(a[h + 4], a[h + 5]),
              i
                .copy(e)
                .add(t)
                .add(n)
                .divideScalar(3)
            const u = m(i)
            f(s, h + 0, e, u), f(o, h + 2, t, u), f(l, h + 4, n, u)
          }
        }
        function f (e, t, n, i) {
          i < 0 && 1 === e.x && (a[t] = e.x - 1),
            0 === n.x && 0 === n.z && (a[t] = i / 2 / Math.PI + 0.5)
        }
        function m (e) {
          return Math.atan2(e.z, -e.x)
        }
        function g (e) {
          return Math.atan2(-e.y, Math.sqrt(e.x * e.x + e.z * e.z))
        }
        s(i),
          l(n),
          c(),
          this.setAttribute('position', new Rr(r, 3)),
          this.setAttribute('normal', new Rr(r.slice(), 3)),
          this.setAttribute('uv', new Rr(a, 2)),
          0 === i ? this.computeVertexNormals() : this.normalizeNormals()
      }
      static fromJSON (e) {
        return new Bu(e.vertices, e.indices, e.radius, e.details)
      }
    }
    class zu extends Bu {
      constructor (e = 1, t = 0) {
        const n = (1 + Math.sqrt(5)) / 2,
          i = 1 / n,
          r = [
            -1,
            -1,
            -1,
            -1,
            -1,
            1,
            -1,
            1,
            -1,
            -1,
            1,
            1,
            1,
            -1,
            -1,
            1,
            -1,
            1,
            1,
            1,
            -1,
            1,
            1,
            1,
            0,
            -i,
            -n,
            0,
            -i,
            n,
            0,
            i,
            -n,
            0,
            i,
            n,
            -i,
            -n,
            0,
            -i,
            n,
            0,
            i,
            -n,
            0,
            i,
            n,
            0,
            -n,
            0,
            -i,
            n,
            0,
            -i,
            -n,
            0,
            i,
            n,
            0,
            i
          ],
          a = [
            3,
            11,
            7,
            3,
            7,
            15,
            3,
            15,
            13,
            7,
            19,
            17,
            7,
            17,
            6,
            7,
            6,
            15,
            17,
            4,
            8,
            17,
            8,
            10,
            17,
            10,
            6,
            8,
            0,
            16,
            8,
            16,
            2,
            8,
            2,
            10,
            0,
            12,
            1,
            0,
            1,
            18,
            0,
            18,
            16,
            6,
            10,
            2,
            6,
            2,
            13,
            6,
            13,
            15,
            2,
            16,
            18,
            2,
            18,
            3,
            2,
            3,
            13,
            18,
            1,
            9,
            18,
            9,
            11,
            18,
            11,
            3,
            4,
            14,
            12,
            4,
            12,
            0,
            4,
            0,
            8,
            11,
            9,
            5,
            11,
            5,
            19,
            11,
            19,
            7,
            19,
            5,
            14,
            19,
            14,
            4,
            19,
            4,
            17,
            1,
            12,
            14,
            1,
            14,
            5,
            1,
            5,
            9
          ]
        super(r, a, e, t),
          (this.type = 'DodecahedronGeometry'),
          (this.parameters = { radius: e, detail: t })
      }
      static fromJSON (e) {
        return new zu(e.radius, e.detail)
      }
    }
    const Uu = new Qn(),
      ku = new Qn(),
      Hu = new Qn(),
      Wu = new ur()
    class Vu extends Ur {
      constructor (e, t) {
        if (
          (super(),
          (this.type = 'EdgesGeometry'),
          (this.parameters = { thresholdAngle: t }),
          (t = void 0 !== t ? t : 1),
          !0 === e.isGeometry)
        )
          return void console.error(
            'THREE.EdgesGeometry no longer supports THREE.Geometry. Use THREE.BufferGeometry instead.'
          )
        const n = 4,
          i = Math.pow(10, n),
          r = Math.cos(Pn * t),
          a = e.getIndex(),
          s = e.getAttribute('position'),
          o = a ? a.count : s.count,
          l = [0, 0, 0],
          c = ['a', 'b', 'c'],
          h = new Array(3),
          u = {},
          d = []
        for (let p = 0; p < o; p += 3) {
          a
            ? ((l[0] = a.getX(p)),
              (l[1] = a.getX(p + 1)),
              (l[2] = a.getX(p + 2)))
            : ((l[0] = p), (l[1] = p + 1), (l[2] = p + 2))
          const { a: e, b: t, c: n } = Wu
          if (
            (e.fromBufferAttribute(s, l[0]),
            t.fromBufferAttribute(s, l[1]),
            n.fromBufferAttribute(s, l[2]),
            Wu.getNormal(Hu),
            (h[0] = `${Math.round(e.x * i)},${Math.round(e.y * i)},${Math.round(
              e.z * i
            )}`),
            (h[1] = `${Math.round(t.x * i)},${Math.round(t.y * i)},${Math.round(
              t.z * i
            )}`),
            (h[2] = `${Math.round(n.x * i)},${Math.round(n.y * i)},${Math.round(
              n.z * i
            )}`),
            h[0] !== h[1] && h[1] !== h[2] && h[2] !== h[0])
          )
            for (let i = 0; i < 3; i++) {
              const e = (i + 1) % 3,
                t = h[i],
                n = h[e],
                a = Wu[c[i]],
                s = Wu[c[e]],
                o = `${t}_${n}`,
                p = `${n}_${t}`
              p in u && u[p]
                ? (Hu.dot(u[p].normal) <= r &&
                    (d.push(a.x, a.y, a.z), d.push(s.x, s.y, s.z)),
                  (u[p] = null))
                : o in u ||
                  (u[o] = { index0: l[i], index1: l[e], normal: Hu.clone() })
            }
        }
        for (const p in u)
          if (u[p]) {
            const { index0: e, index1: t } = u[p]
            Uu.fromBufferAttribute(s, e),
              ku.fromBufferAttribute(s, t),
              d.push(Uu.x, Uu.y, Uu.z),
              d.push(ku.x, ku.y, ku.z)
          }
        this.setAttribute('position', new Rr(d, 3))
      }
    }
    class Gu {
      constructor () {
        ;(this.type = 'Curve'), (this.arcLengthDivisions = 200)
      }
      getPoint () {
        return console.warn('THREE.Curve: .getPoint() not implemented.'), null
      }
      getPointAt (e, t) {
        const n = this.getUtoTmapping(e)
        return this.getPoint(n, t)
      }
      getPoints (e = 5) {
        const t = []
        for (let n = 0; n <= e; n++) t.push(this.getPoint(n / e))
        return t
      }
      getSpacedPoints (e = 5) {
        const t = []
        for (let n = 0; n <= e; n++) t.push(this.getPointAt(n / e))
        return t
      }
      getLength () {
        const e = this.getLengths()
        return e[e.length - 1]
      }
      getLengths (e = this.arcLengthDivisions) {
        if (
          this.cacheArcLengths &&
          this.cacheArcLengths.length === e + 1 &&
          !this.needsUpdate
        )
          return this.cacheArcLengths
        this.needsUpdate = !1
        const t = []
        let n,
          i = this.getPoint(0),
          r = 0
        t.push(0)
        for (let a = 1; a <= e; a++)
          (n = this.getPoint(a / e)), (r += n.distanceTo(i)), t.push(r), (i = n)
        return (this.cacheArcLengths = t), t
      }
      updateArcLengths () {
        ;(this.needsUpdate = !0), this.getLengths()
      }
      getUtoTmapping (e, t) {
        const n = this.getLengths()
        let i = 0
        const r = n.length
        let a
        a = t || e * n[r - 1]
        let s,
          o = 0,
          l = r - 1
        while (o <= l)
          if (((i = Math.floor(o + (l - o) / 2)), (s = n[i] - a), s < 0))
            o = i + 1
          else {
            if (!(s > 0)) {
              l = i
              break
            }
            l = i - 1
          }
        if (((i = l), n[i] === a)) return i / (r - 1)
        const c = n[i],
          h = n[i + 1],
          u = h - c,
          d = (a - c) / u,
          p = (i + d) / (r - 1)
        return p
      }
      getTangent (e, t) {
        const n = 1e-4
        let i = e - n,
          r = e + n
        i < 0 && (i = 0), r > 1 && (r = 1)
        const a = this.getPoint(i),
          s = this.getPoint(r),
          o = t || (a.isVector2 ? new kn() : new Qn())
        return (
          o
            .copy(s)
            .sub(a)
            .normalize(),
          o
        )
      }
      getTangentAt (e, t) {
        const n = this.getUtoTmapping(e)
        return this.getTangent(n, t)
      }
      computeFrenetFrames (e, t) {
        const n = new Qn(),
          i = [],
          r = [],
          a = [],
          s = new Qn(),
          o = new Li()
        for (let d = 0; d <= e; d++) {
          const t = d / e
          ;(i[d] = this.getTangentAt(t, new Qn())), i[d].normalize()
        }
        ;(r[0] = new Qn()), (a[0] = new Qn())
        let l = Number.MAX_VALUE
        const c = Math.abs(i[0].x),
          h = Math.abs(i[0].y),
          u = Math.abs(i[0].z)
        c <= l && ((l = c), n.set(1, 0, 0)),
          h <= l && ((l = h), n.set(0, 1, 0)),
          u <= l && n.set(0, 0, 1),
          s.crossVectors(i[0], n).normalize(),
          r[0].crossVectors(i[0], s),
          a[0].crossVectors(i[0], r[0])
        for (let d = 1; d <= e; d++) {
          if (
            ((r[d] = r[d - 1].clone()),
            (a[d] = a[d - 1].clone()),
            s.crossVectors(i[d - 1], i[d]),
            s.length() > Number.EPSILON)
          ) {
            s.normalize()
            const e = Math.acos(Nn(i[d - 1].dot(i[d]), -1, 1))
            r[d].applyMatrix4(o.makeRotationAxis(s, e))
          }
          a[d].crossVectors(i[d], r[d])
        }
        if (!0 === t) {
          let t = Math.acos(Nn(r[0].dot(r[e]), -1, 1))
          ;(t /= e), i[0].dot(s.crossVectors(r[0], r[e])) > 0 && (t = -t)
          for (let n = 1; n <= e; n++)
            r[n].applyMatrix4(o.makeRotationAxis(i[n], t * n)),
              a[n].crossVectors(i[n], r[n])
        }
        return { tangents: i, normals: r, binormals: a }
      }
      clone () {
        return new this.constructor().copy(this)
      }
      copy (e) {
        return (this.arcLengthDivisions = e.arcLengthDivisions), this
      }
      toJSON () {
        const e = {
          metadata: { version: 4.5, type: 'Curve', generator: 'Curve.toJSON' }
        }
        return (
          (e.arcLengthDivisions = this.arcLengthDivisions),
          (e.type = this.type),
          e
        )
      }
      fromJSON (e) {
        return (this.arcLengthDivisions = e.arcLengthDivisions), this
      }
    }
    class ju extends Gu {
      constructor (
        e = 0,
        t = 0,
        n = 1,
        i = 1,
        r = 0,
        a = 2 * Math.PI,
        s = !1,
        o = 0
      ) {
        super(),
          (this.type = 'EllipseCurve'),
          (this.aX = e),
          (this.aY = t),
          (this.xRadius = n),
          (this.yRadius = i),
          (this.aStartAngle = r),
          (this.aEndAngle = a),
          (this.aClockwise = s),
          (this.aRotation = o)
      }
      getPoint (e, t) {
        const n = t || new kn(),
          i = 2 * Math.PI
        let r = this.aEndAngle - this.aStartAngle
        const a = Math.abs(r) < Number.EPSILON
        while (r < 0) r += i
        while (r > i) r -= i
        r < Number.EPSILON && (r = a ? 0 : i),
          !0 !== this.aClockwise || a || (r === i ? (r = -i) : (r -= i))
        const s = this.aStartAngle + e * r
        let o = this.aX + this.xRadius * Math.cos(s),
          l = this.aY + this.yRadius * Math.sin(s)
        if (0 !== this.aRotation) {
          const e = Math.cos(this.aRotation),
            t = Math.sin(this.aRotation),
            n = o - this.aX,
            i = l - this.aY
          ;(o = n * e - i * t + this.aX), (l = n * t + i * e + this.aY)
        }
        return n.set(o, l)
      }
      copy (e) {
        return (
          super.copy(e),
          (this.aX = e.aX),
          (this.aY = e.aY),
          (this.xRadius = e.xRadius),
          (this.yRadius = e.yRadius),
          (this.aStartAngle = e.aStartAngle),
          (this.aEndAngle = e.aEndAngle),
          (this.aClockwise = e.aClockwise),
          (this.aRotation = e.aRotation),
          this
        )
      }
      toJSON () {
        const e = super.toJSON()
        return (
          (e.aX = this.aX),
          (e.aY = this.aY),
          (e.xRadius = this.xRadius),
          (e.yRadius = this.yRadius),
          (e.aStartAngle = this.aStartAngle),
          (e.aEndAngle = this.aEndAngle),
          (e.aClockwise = this.aClockwise),
          (e.aRotation = this.aRotation),
          e
        )
      }
      fromJSON (e) {
        return (
          super.fromJSON(e),
          (this.aX = e.aX),
          (this.aY = e.aY),
          (this.xRadius = e.xRadius),
          (this.yRadius = e.yRadius),
          (this.aStartAngle = e.aStartAngle),
          (this.aEndAngle = e.aEndAngle),
          (this.aClockwise = e.aClockwise),
          (this.aRotation = e.aRotation),
          this
        )
      }
    }
    ju.prototype.isEllipseCurve = !0
    class qu extends ju {
      constructor (e, t, n, i, r, a) {
        super(e, t, n, n, i, r, a), (this.type = 'ArcCurve')
      }
    }
    function Yu () {
      let e = 0,
        t = 0,
        n = 0,
        i = 0
      function r (r, a, s, o) {
        ;(e = r),
          (t = s),
          (n = -3 * r + 3 * a - 2 * s - o),
          (i = 2 * r - 2 * a + s + o)
      }
      return {
        initCatmullRom: function (e, t, n, i, a) {
          r(t, n, a * (n - e), a * (i - t))
        },
        initNonuniformCatmullRom: function (e, t, n, i, a, s, o) {
          let l = (t - e) / a - (n - e) / (a + s) + (n - t) / s,
            c = (n - t) / s - (i - t) / (s + o) + (i - n) / o
          ;(l *= s), (c *= s), r(t, n, l, c)
        },
        calc: function (r) {
          const a = r * r,
            s = a * r
          return e + t * r + n * a + i * s
        }
      }
    }
    qu.prototype.isArcCurve = !0
    const Xu = new Qn(),
      Ju = new Yu(),
      Zu = new Yu(),
      Ku = new Yu()
    class Qu extends Gu {
      constructor (e = [], t = !1, n = 'centripetal', i = 0.5) {
        super(),
          (this.type = 'CatmullRomCurve3'),
          (this.points = e),
          (this.closed = t),
          (this.curveType = n),
          (this.tension = i)
      }
      getPoint (e, t = new Qn()) {
        const n = t,
          i = this.points,
          r = i.length,
          a = (r - (this.closed ? 0 : 1)) * e
        let s,
          o,
          l = Math.floor(a),
          c = a - l
        this.closed
          ? (l += l > 0 ? 0 : (Math.floor(Math.abs(l) / r) + 1) * r)
          : 0 === c && l === r - 1 && ((l = r - 2), (c = 1)),
          this.closed || l > 0
            ? (s = i[(l - 1) % r])
            : (Xu.subVectors(i[0], i[1]).add(i[0]), (s = Xu))
        const h = i[l % r],
          u = i[(l + 1) % r]
        if (
          (this.closed || l + 2 < r
            ? (o = i[(l + 2) % r])
            : (Xu.subVectors(i[r - 1], i[r - 2]).add(i[r - 1]), (o = Xu)),
          'centripetal' === this.curveType || 'chordal' === this.curveType)
        ) {
          const e = 'chordal' === this.curveType ? 0.5 : 0.25
          let t = Math.pow(s.distanceToSquared(h), e),
            n = Math.pow(h.distanceToSquared(u), e),
            i = Math.pow(u.distanceToSquared(o), e)
          n < 1e-4 && (n = 1),
            t < 1e-4 && (t = n),
            i < 1e-4 && (i = n),
            Ju.initNonuniformCatmullRom(s.x, h.x, u.x, o.x, t, n, i),
            Zu.initNonuniformCatmullRom(s.y, h.y, u.y, o.y, t, n, i),
            Ku.initNonuniformCatmullRom(s.z, h.z, u.z, o.z, t, n, i)
        } else
          'catmullrom' === this.curveType &&
            (Ju.initCatmullRom(s.x, h.x, u.x, o.x, this.tension),
            Zu.initCatmullRom(s.y, h.y, u.y, o.y, this.tension),
            Ku.initCatmullRom(s.z, h.z, u.z, o.z, this.tension))
        return n.set(Ju.calc(c), Zu.calc(c), Ku.calc(c)), n
      }
      copy (e) {
        super.copy(e), (this.points = [])
        for (let t = 0, n = e.points.length; t < n; t++) {
          const n = e.points[t]
          this.points.push(n.clone())
        }
        return (
          (this.closed = e.closed),
          (this.curveType = e.curveType),
          (this.tension = e.tension),
          this
        )
      }
      toJSON () {
        const e = super.toJSON()
        e.points = []
        for (let t = 0, n = this.points.length; t < n; t++) {
          const n = this.points[t]
          e.points.push(n.toArray())
        }
        return (
          (e.closed = this.closed),
          (e.curveType = this.curveType),
          (e.tension = this.tension),
          e
        )
      }
      fromJSON (e) {
        super.fromJSON(e), (this.points = [])
        for (let t = 0, n = e.points.length; t < n; t++) {
          const n = e.points[t]
          this.points.push(new Qn().fromArray(n))
        }
        return (
          (this.closed = e.closed),
          (this.curveType = e.curveType),
          (this.tension = e.tension),
          this
        )
      }
    }
    function $u (e, t, n, i, r) {
      const a = 0.5 * (i - t),
        s = 0.5 * (r - n),
        o = e * e,
        l = e * o
      return (
        (2 * n - 2 * i + a + s) * l +
        (-3 * n + 3 * i - 2 * a - s) * o +
        a * e +
        n
      )
    }
    function ed (e, t) {
      const n = 1 - e
      return n * n * t
    }
    function td (e, t) {
      return 2 * (1 - e) * e * t
    }
    function nd (e, t) {
      return e * e * t
    }
    function id (e, t, n, i) {
      return ed(e, t) + td(e, n) + nd(e, i)
    }
    function rd (e, t) {
      const n = 1 - e
      return n * n * n * t
    }
    function ad (e, t) {
      const n = 1 - e
      return 3 * n * n * e * t
    }
    function sd (e, t) {
      return 3 * (1 - e) * e * e * t
    }
    function od (e, t) {
      return e * e * e * t
    }
    function ld (e, t, n, i, r) {
      return rd(e, t) + ad(e, n) + sd(e, i) + od(e, r)
    }
    Qu.prototype.isCatmullRomCurve3 = !0
    class cd extends Gu {
      constructor (e = new kn(), t = new kn(), n = new kn(), i = new kn()) {
        super(),
          (this.type = 'CubicBezierCurve'),
          (this.v0 = e),
          (this.v1 = t),
          (this.v2 = n),
          (this.v3 = i)
      }
      getPoint (e, t = new kn()) {
        const n = t,
          i = this.v0,
          r = this.v1,
          a = this.v2,
          s = this.v3
        return n.set(ld(e, i.x, r.x, a.x, s.x), ld(e, i.y, r.y, a.y, s.y)), n
      }
      copy (e) {
        return (
          super.copy(e),
          this.v0.copy(e.v0),
          this.v1.copy(e.v1),
          this.v2.copy(e.v2),
          this.v3.copy(e.v3),
          this
        )
      }
      toJSON () {
        const e = super.toJSON()
        return (
          (e.v0 = this.v0.toArray()),
          (e.v1 = this.v1.toArray()),
          (e.v2 = this.v2.toArray()),
          (e.v3 = this.v3.toArray()),
          e
        )
      }
      fromJSON (e) {
        return (
          super.fromJSON(e),
          this.v0.fromArray(e.v0),
          this.v1.fromArray(e.v1),
          this.v2.fromArray(e.v2),
          this.v3.fromArray(e.v3),
          this
        )
      }
    }
    cd.prototype.isCubicBezierCurve = !0
    class hd extends Gu {
      constructor (e = new Qn(), t = new Qn(), n = new Qn(), i = new Qn()) {
        super(),
          (this.type = 'CubicBezierCurve3'),
          (this.v0 = e),
          (this.v1 = t),
          (this.v2 = n),
          (this.v3 = i)
      }
      getPoint (e, t = new Qn()) {
        const n = t,
          i = this.v0,
          r = this.v1,
          a = this.v2,
          s = this.v3
        return (
          n.set(
            ld(e, i.x, r.x, a.x, s.x),
            ld(e, i.y, r.y, a.y, s.y),
            ld(e, i.z, r.z, a.z, s.z)
          ),
          n
        )
      }
      copy (e) {
        return (
          super.copy(e),
          this.v0.copy(e.v0),
          this.v1.copy(e.v1),
          this.v2.copy(e.v2),
          this.v3.copy(e.v3),
          this
        )
      }
      toJSON () {
        const e = super.toJSON()
        return (
          (e.v0 = this.v0.toArray()),
          (e.v1 = this.v1.toArray()),
          (e.v2 = this.v2.toArray()),
          (e.v3 = this.v3.toArray()),
          e
        )
      }
      fromJSON (e) {
        return (
          super.fromJSON(e),
          this.v0.fromArray(e.v0),
          this.v1.fromArray(e.v1),
          this.v2.fromArray(e.v2),
          this.v3.fromArray(e.v3),
          this
        )
      }
    }
    hd.prototype.isCubicBezierCurve3 = !0
    class ud extends Gu {
      constructor (e = new kn(), t = new kn()) {
        super(), (this.type = 'LineCurve'), (this.v1 = e), (this.v2 = t)
      }
      getPoint (e, t = new kn()) {
        const n = t
        return (
          1 === e
            ? n.copy(this.v2)
            : (n.copy(this.v2).sub(this.v1), n.multiplyScalar(e).add(this.v1)),
          n
        )
      }
      getPointAt (e, t) {
        return this.getPoint(e, t)
      }
      getTangent (e, t) {
        const n = t || new kn()
        return (
          n
            .copy(this.v2)
            .sub(this.v1)
            .normalize(),
          n
        )
      }
      copy (e) {
        return super.copy(e), this.v1.copy(e.v1), this.v2.copy(e.v2), this
      }
      toJSON () {
        const e = super.toJSON()
        return (e.v1 = this.v1.toArray()), (e.v2 = this.v2.toArray()), e
      }
      fromJSON (e) {
        return (
          super.fromJSON(e),
          this.v1.fromArray(e.v1),
          this.v2.fromArray(e.v2),
          this
        )
      }
    }
    ud.prototype.isLineCurve = !0
    class dd extends Gu {
      constructor (e = new Qn(), t = new Qn()) {
        super(),
          (this.type = 'LineCurve3'),
          (this.isLineCurve3 = !0),
          (this.v1 = e),
          (this.v2 = t)
      }
      getPoint (e, t = new Qn()) {
        const n = t
        return (
          1 === e
            ? n.copy(this.v2)
            : (n.copy(this.v2).sub(this.v1), n.multiplyScalar(e).add(this.v1)),
          n
        )
      }
      getPointAt (e, t) {
        return this.getPoint(e, t)
      }
      copy (e) {
        return super.copy(e), this.v1.copy(e.v1), this.v2.copy(e.v2), this
      }
      toJSON () {
        const e = super.toJSON()
        return (e.v1 = this.v1.toArray()), (e.v2 = this.v2.toArray()), e
      }
      fromJSON (e) {
        return (
          super.fromJSON(e),
          this.v1.fromArray(e.v1),
          this.v2.fromArray(e.v2),
          this
        )
      }
    }
    class pd extends Gu {
      constructor (e = new kn(), t = new kn(), n = new kn()) {
        super(),
          (this.type = 'QuadraticBezierCurve'),
          (this.v0 = e),
          (this.v1 = t),
          (this.v2 = n)
      }
      getPoint (e, t = new kn()) {
        const n = t,
          i = this.v0,
          r = this.v1,
          a = this.v2
        return n.set(id(e, i.x, r.x, a.x), id(e, i.y, r.y, a.y)), n
      }
      copy (e) {
        return (
          super.copy(e),
          this.v0.copy(e.v0),
          this.v1.copy(e.v1),
          this.v2.copy(e.v2),
          this
        )
      }
      toJSON () {
        const e = super.toJSON()
        return (
          (e.v0 = this.v0.toArray()),
          (e.v1 = this.v1.toArray()),
          (e.v2 = this.v2.toArray()),
          e
        )
      }
      fromJSON (e) {
        return (
          super.fromJSON(e),
          this.v0.fromArray(e.v0),
          this.v1.fromArray(e.v1),
          this.v2.fromArray(e.v2),
          this
        )
      }
    }
    pd.prototype.isQuadraticBezierCurve = !0
    class fd extends Gu {
      constructor (e = new Qn(), t = new Qn(), n = new Qn()) {
        super(),
          (this.type = 'QuadraticBezierCurve3'),
          (this.v0 = e),
          (this.v1 = t),
          (this.v2 = n)
      }
      getPoint (e, t = new Qn()) {
        const n = t,
          i = this.v0,
          r = this.v1,
          a = this.v2
        return (
          n.set(
            id(e, i.x, r.x, a.x),
            id(e, i.y, r.y, a.y),
            id(e, i.z, r.z, a.z)
          ),
          n
        )
      }
      copy (e) {
        return (
          super.copy(e),
          this.v0.copy(e.v0),
          this.v1.copy(e.v1),
          this.v2.copy(e.v2),
          this
        )
      }
      toJSON () {
        const e = super.toJSON()
        return (
          (e.v0 = this.v0.toArray()),
          (e.v1 = this.v1.toArray()),
          (e.v2 = this.v2.toArray()),
          e
        )
      }
      fromJSON (e) {
        return (
          super.fromJSON(e),
          this.v0.fromArray(e.v0),
          this.v1.fromArray(e.v1),
          this.v2.fromArray(e.v2),
          this
        )
      }
    }
    fd.prototype.isQuadraticBezierCurve3 = !0
    class md extends Gu {
      constructor (e = []) {
        super(), (this.type = 'SplineCurve'), (this.points = e)
      }
      getPoint (e, t = new kn()) {
        const n = t,
          i = this.points,
          r = (i.length - 1) * e,
          a = Math.floor(r),
          s = r - a,
          o = i[0 === a ? a : a - 1],
          l = i[a],
          c = i[a > i.length - 2 ? i.length - 1 : a + 1],
          h = i[a > i.length - 3 ? i.length - 1 : a + 2]
        return n.set($u(s, o.x, l.x, c.x, h.x), $u(s, o.y, l.y, c.y, h.y)), n
      }
      copy (e) {
        super.copy(e), (this.points = [])
        for (let t = 0, n = e.points.length; t < n; t++) {
          const n = e.points[t]
          this.points.push(n.clone())
        }
        return this
      }
      toJSON () {
        const e = super.toJSON()
        e.points = []
        for (let t = 0, n = this.points.length; t < n; t++) {
          const n = this.points[t]
          e.points.push(n.toArray())
        }
        return e
      }
      fromJSON (e) {
        super.fromJSON(e), (this.points = [])
        for (let t = 0, n = e.points.length; t < n; t++) {
          const n = e.points[t]
          this.points.push(new kn().fromArray(n))
        }
        return this
      }
    }
    md.prototype.isSplineCurve = !0
    var gd = Object.freeze({
      __proto__: null,
      ArcCurve: qu,
      CatmullRomCurve3: Qu,
      CubicBezierCurve: cd,
      CubicBezierCurve3: hd,
      EllipseCurve: ju,
      LineCurve: ud,
      LineCurve3: dd,
      QuadraticBezierCurve: pd,
      QuadraticBezierCurve3: fd,
      SplineCurve: md
    })
    const vd = {
      triangulate: function (e, t, n = 2) {
        const i = t && t.length,
          r = i ? t[0] * n : e.length
        let a = yd(e, 0, r, n, !0)
        const s = []
        if (!a || a.next === a.prev) return s
        let o, l, c, h, u, d, p
        if ((i && (a = Ed(e, t, a, n)), e.length > 80 * n)) {
          ;(o = c = e[0]), (l = h = e[1])
          for (let t = n; t < r; t += n)
            (u = e[t]),
              (d = e[t + 1]),
              u < o && (o = u),
              d < l && (l = d),
              u > c && (c = u),
              d > h && (h = d)
          ;(p = Math.max(c - o, h - l)), (p = 0 !== p ? 1 / p : 0)
        }
        return xd(a, s, n, o, l, p), s
      }
    }
    function yd (e, t, n, i, r) {
      let a, s
      if (r === Xd(e, t, n, i) > 0)
        for (a = t; a < n; a += i) s = jd(a, e[a], e[a + 1], s)
      else for (a = n - i; a >= t; a -= i) s = jd(a, e[a], e[a + 1], s)
      return s && Bd(s, s.next) && (qd(s), (s = s.next)), s
    }
    function _d (e, t) {
      if (!e) return e
      t || (t = e)
      let n,
        i = e
      do {
        if (
          ((n = !1),
          i.steiner || (!Bd(i, i.next) && 0 !== Fd(i.prev, i, i.next)))
        )
          i = i.next
        else {
          if ((qd(i), (i = t = i.prev), i === i.next)) break
          n = !0
        }
      } while (n || i !== t)
      return t
    }
    function xd (e, t, n, i, r, a, s) {
      if (!e) return
      !s && a && Cd(e, i, r, a)
      let o,
        l,
        c = e
      while (e.prev !== e.next)
        if (((o = e.prev), (l = e.next), a ? bd(e, i, r, a) : wd(e)))
          t.push(o.i / n),
            t.push(e.i / n),
            t.push(l.i / n),
            qd(e),
            (e = l.next),
            (c = l.next)
        else if (((e = l), e === c)) {
          s
            ? 1 === s
              ? ((e = Md(_d(e), t, n)), xd(e, t, n, i, r, a, 2))
              : 2 === s && Sd(e, t, n, i, r, a)
            : xd(_d(e), t, n, i, r, a, 1)
          break
        }
    }
    function wd (e) {
      const t = e.prev,
        n = e,
        i = e.next
      if (Fd(t, n, i) >= 0) return !1
      let r = e.next.next
      while (r !== e.prev) {
        if (
          Nd(t.x, t.y, n.x, n.y, i.x, i.y, r.x, r.y) &&
          Fd(r.prev, r, r.next) >= 0
        )
          return !1
        r = r.next
      }
      return !0
    }
    function bd (e, t, n, i) {
      const r = e.prev,
        a = e,
        s = e.next
      if (Fd(r, a, s) >= 0) return !1
      const o = r.x < a.x ? (r.x < s.x ? r.x : s.x) : a.x < s.x ? a.x : s.x,
        l = r.y < a.y ? (r.y < s.y ? r.y : s.y) : a.y < s.y ? a.y : s.y,
        c = r.x > a.x ? (r.x > s.x ? r.x : s.x) : a.x > s.x ? a.x : s.x,
        h = r.y > a.y ? (r.y > s.y ? r.y : s.y) : a.y > s.y ? a.y : s.y,
        u = Dd(o, l, t, n, i),
        d = Dd(c, h, t, n, i)
      let p = e.prevZ,
        f = e.nextZ
      while (p && p.z >= u && f && f.z <= d) {
        if (
          p !== e.prev &&
          p !== e.next &&
          Nd(r.x, r.y, a.x, a.y, s.x, s.y, p.x, p.y) &&
          Fd(p.prev, p, p.next) >= 0
        )
          return !1
        if (
          ((p = p.prevZ),
          f !== e.prev &&
            f !== e.next &&
            Nd(r.x, r.y, a.x, a.y, s.x, s.y, f.x, f.y) &&
            Fd(f.prev, f, f.next) >= 0)
        )
          return !1
        f = f.nextZ
      }
      while (p && p.z >= u) {
        if (
          p !== e.prev &&
          p !== e.next &&
          Nd(r.x, r.y, a.x, a.y, s.x, s.y, p.x, p.y) &&
          Fd(p.prev, p, p.next) >= 0
        )
          return !1
        p = p.prevZ
      }
      while (f && f.z <= d) {
        if (
          f !== e.prev &&
          f !== e.next &&
          Nd(r.x, r.y, a.x, a.y, s.x, s.y, f.x, f.y) &&
          Fd(f.prev, f, f.next) >= 0
        )
          return !1
        f = f.nextZ
      }
      return !0
    }
    function Md (e, t, n) {
      let i = e
      do {
        const r = i.prev,
          a = i.next.next
        !Bd(r, a) &&
          zd(r, i, i.next, a) &&
          Wd(r, a) &&
          Wd(a, r) &&
          (t.push(r.i / n),
          t.push(i.i / n),
          t.push(a.i / n),
          qd(i),
          qd(i.next),
          (i = e = a)),
          (i = i.next)
      } while (i !== e)
      return _d(i)
    }
    function Sd (e, t, n, i, r, a) {
      let s = e
      do {
        let e = s.next.next
        while (e !== s.prev) {
          if (s.i !== e.i && Od(s, e)) {
            let o = Gd(s, e)
            return (
              (s = _d(s, s.next)),
              (o = _d(o, o.next)),
              xd(s, t, n, i, r, a),
              void xd(o, t, n, i, r, a)
            )
          }
          e = e.next
        }
        s = s.next
      } while (s !== e)
    }
    function Ed (e, t, n, i) {
      const r = []
      let a, s, o, l, c
      for (a = 0, s = t.length; a < s; a++)
        (o = t[a] * i),
          (l = a < s - 1 ? t[a + 1] * i : e.length),
          (c = yd(e, o, l, i, !1)),
          c === c.next && (c.steiner = !0),
          r.push(Id(c))
      for (r.sort(Td), a = 0; a < r.length; a++)
        Ad(r[a], n), (n = _d(n, n.next))
      return n
    }
    function Td (e, t) {
      return e.x - t.x
    }
    function Ad (e, t) {
      if (((t = Rd(e, t)), t)) {
        const n = Gd(t, e)
        _d(t, t.next), _d(n, n.next)
      }
    }
    function Rd (e, t) {
      let n = t
      const i = e.x,
        r = e.y
      let a,
        s = -1 / 0
      do {
        if (r <= n.y && r >= n.next.y && n.next.y !== n.y) {
          const e = n.x + ((r - n.y) * (n.next.x - n.x)) / (n.next.y - n.y)
          if (e <= i && e > s) {
            if (((s = e), e === i)) {
              if (r === n.y) return n
              if (r === n.next.y) return n.next
            }
            a = n.x < n.next.x ? n : n.next
          }
        }
        n = n.next
      } while (n !== t)
      if (!a) return null
      if (i === s) return a
      const o = a,
        l = a.x,
        c = a.y
      let h,
        u = 1 / 0
      n = a
      do {
        i >= n.x &&
          n.x >= l &&
          i !== n.x &&
          Nd(r < c ? i : s, r, l, c, r < c ? s : i, r, n.x, n.y) &&
          ((h = Math.abs(r - n.y) / (i - n.x)),
          Wd(n, e) &&
            (h < u || (h === u && (n.x > a.x || (n.x === a.x && Ld(a, n))))) &&
            ((a = n), (u = h))),
          (n = n.next)
      } while (n !== o)
      return a
    }
    function Ld (e, t) {
      return Fd(e.prev, e, t.prev) < 0 && Fd(t.next, e, e.next) < 0
    }
    function Cd (e, t, n, i) {
      let r = e
      do {
        null === r.z && (r.z = Dd(r.x, r.y, t, n, i)),
          (r.prevZ = r.prev),
          (r.nextZ = r.next),
          (r = r.next)
      } while (r !== e)
      ;(r.prevZ.nextZ = null), (r.prevZ = null), Pd(r)
    }
    function Pd (e) {
      let t,
        n,
        i,
        r,
        a,
        s,
        o,
        l,
        c = 1
      do {
        ;(n = e), (e = null), (a = null), (s = 0)
        while (n) {
          for (s++, i = n, o = 0, t = 0; t < c; t++)
            if ((o++, (i = i.nextZ), !i)) break
          l = c
          while (o > 0 || (l > 0 && i))
            0 !== o && (0 === l || !i || n.z <= i.z)
              ? ((r = n), (n = n.nextZ), o--)
              : ((r = i), (i = i.nextZ), l--),
              a ? (a.nextZ = r) : (e = r),
              (r.prevZ = a),
              (a = r)
          n = i
        }
        ;(a.nextZ = null), (c *= 2)
      } while (s > 1)
      return e
    }
    function Dd (e, t, n, i, r) {
      return (
        (e = 32767 * (e - n) * r),
        (t = 32767 * (t - i) * r),
        (e = 16711935 & (e | (e << 8))),
        (e = 252645135 & (e | (e << 4))),
        (e = 858993459 & (e | (e << 2))),
        (e = 1431655765 & (e | (e << 1))),
        (t = 16711935 & (t | (t << 8))),
        (t = 252645135 & (t | (t << 4))),
        (t = 858993459 & (t | (t << 2))),
        (t = 1431655765 & (t | (t << 1))),
        e | (t << 1)
      )
    }
    function Id (e) {
      let t = e,
        n = e
      do {
        ;(t.x < n.x || (t.x === n.x && t.y < n.y)) && (n = t), (t = t.next)
      } while (t !== e)
      return n
    }
    function Nd (e, t, n, i, r, a, s, o) {
      return (
        (r - s) * (t - o) - (e - s) * (a - o) >= 0 &&
        (e - s) * (i - o) - (n - s) * (t - o) >= 0 &&
        (n - s) * (a - o) - (r - s) * (i - o) >= 0
      )
    }
    function Od (e, t) {
      return (
        e.next.i !== t.i &&
        e.prev.i !== t.i &&
        !Hd(e, t) &&
        ((Wd(e, t) &&
          Wd(t, e) &&
          Vd(e, t) &&
          (Fd(e.prev, e, t.prev) || Fd(e, t.prev, t))) ||
          (Bd(e, t) && Fd(e.prev, e, e.next) > 0 && Fd(t.prev, t, t.next) > 0))
      )
    }
    function Fd (e, t, n) {
      return (t.y - e.y) * (n.x - t.x) - (t.x - e.x) * (n.y - t.y)
    }
    function Bd (e, t) {
      return e.x === t.x && e.y === t.y
    }
    function zd (e, t, n, i) {
      const r = kd(Fd(e, t, n)),
        a = kd(Fd(e, t, i)),
        s = kd(Fd(n, i, e)),
        o = kd(Fd(n, i, t))
      return (
        (r !== a && s !== o) ||
        (!(0 !== r || !Ud(e, n, t)) ||
          (!(0 !== a || !Ud(e, i, t)) ||
            (!(0 !== s || !Ud(n, e, i)) || !(0 !== o || !Ud(n, t, i)))))
      )
    }
    function Ud (e, t, n) {
      return (
        t.x <= Math.max(e.x, n.x) &&
        t.x >= Math.min(e.x, n.x) &&
        t.y <= Math.max(e.y, n.y) &&
        t.y >= Math.min(e.y, n.y)
      )
    }
    function kd (e) {
      return e > 0 ? 1 : e < 0 ? -1 : 0
    }
    function Hd (e, t) {
      let n = e
      do {
        if (
          n.i !== e.i &&
          n.next.i !== e.i &&
          n.i !== t.i &&
          n.next.i !== t.i &&
          zd(n, n.next, e, t)
        )
          return !0
        n = n.next
      } while (n !== e)
      return !1
    }
    function Wd (e, t) {
      return Fd(e.prev, e, e.next) < 0
        ? Fd(e, t, e.next) >= 0 && Fd(e, e.prev, t) >= 0
        : Fd(e, t, e.prev) < 0 || Fd(e, e.next, t) < 0
    }
    function Vd (e, t) {
      let n = e,
        i = !1
      const r = (e.x + t.x) / 2,
        a = (e.y + t.y) / 2
      do {
        n.y > a !== n.next.y > a &&
          n.next.y !== n.y &&
          r < ((n.next.x - n.x) * (a - n.y)) / (n.next.y - n.y) + n.x &&
          (i = !i),
          (n = n.next)
      } while (n !== e)
      return i
    }
    function Gd (e, t) {
      const n = new Yd(e.i, e.x, e.y),
        i = new Yd(t.i, t.x, t.y),
        r = e.next,
        a = t.prev
      return (
        (e.next = t),
        (t.prev = e),
        (n.next = r),
        (r.prev = n),
        (i.next = n),
        (n.prev = i),
        (a.next = i),
        (i.prev = a),
        i
      )
    }
    function jd (e, t, n, i) {
      const r = new Yd(e, t, n)
      return (
        i
          ? ((r.next = i.next), (r.prev = i), (i.next.prev = r), (i.next = r))
          : ((r.prev = r), (r.next = r)),
        r
      )
    }
    function qd (e) {
      ;(e.next.prev = e.prev),
        (e.prev.next = e.next),
        e.prevZ && (e.prevZ.nextZ = e.nextZ),
        e.nextZ && (e.nextZ.prevZ = e.prevZ)
    }
    function Yd (e, t, n) {
      ;(this.i = e),
        (this.x = t),
        (this.y = n),
        (this.prev = null),
        (this.next = null),
        (this.z = null),
        (this.prevZ = null),
        (this.nextZ = null),
        (this.steiner = !1)
    }
    function Xd (e, t, n, i) {
      let r = 0
      for (let a = t, s = n - i; a < n; a += i)
        (r += (e[s] - e[a]) * (e[a + 1] + e[s + 1])), (s = a)
      return r
    }
    class Jd {
      static area (e) {
        const t = e.length
        let n = 0
        for (let i = t - 1, r = 0; r < t; i = r++)
          n += e[i].x * e[r].y - e[r].x * e[i].y
        return 0.5 * n
      }
      static isClockWise (e) {
        return Jd.area(e) < 0
      }
      static triangulateShape (e, t) {
        const n = [],
          i = [],
          r = []
        Zd(e), Kd(n, e)
        let a = e.length
        t.forEach(Zd)
        for (let o = 0; o < t.length; o++)
          i.push(a), (a += t[o].length), Kd(n, t[o])
        const s = vd.triangulate(n, i)
        for (let o = 0; o < s.length; o += 3) r.push(s.slice(o, o + 3))
        return r
      }
    }
    function Zd (e) {
      const t = e.length
      t > 2 && e[t - 1].equals(e[0]) && e.pop()
    }
    function Kd (e, t) {
      for (let n = 0; n < t.length; n++) e.push(t[n].x), e.push(t[n].y)
    }
    class Qd extends Ur {
      constructor (e, t) {
        super(),
          (this.type = 'ExtrudeGeometry'),
          (this.parameters = { shapes: e, options: t }),
          (e = Array.isArray(e) ? e : [e])
        const n = this,
          i = [],
          r = []
        for (let s = 0, o = e.length; s < o; s++) {
          const t = e[s]
          a(t)
        }
        function a (e) {
          const a = [],
            s = void 0 !== t.curveSegments ? t.curveSegments : 12,
            o = void 0 !== t.steps ? t.steps : 1
          let l = void 0 !== t.depth ? t.depth : 100,
            c = void 0 === t.bevelEnabled || t.bevelEnabled,
            h = void 0 !== t.bevelThickness ? t.bevelThickness : 6,
            u = void 0 !== t.bevelSize ? t.bevelSize : h - 2,
            d = void 0 !== t.bevelOffset ? t.bevelOffset : 0,
            p = void 0 !== t.bevelSegments ? t.bevelSegments : 3
          const f = t.extrudePath,
            m = void 0 !== t.UVGenerator ? t.UVGenerator : $d
          void 0 !== t.amount &&
            (console.warn(
              'THREE.ExtrudeBufferGeometry: amount has been renamed to depth.'
            ),
            (l = t.amount))
          let g,
            v,
            y,
            _,
            x,
            w = !1
          f &&
            ((g = f.getSpacedPoints(o)),
            (w = !0),
            (c = !1),
            (v = f.computeFrenetFrames(o, !1)),
            (y = new Qn()),
            (_ = new Qn()),
            (x = new Qn())),
            c || ((p = 0), (h = 0), (u = 0), (d = 0))
          const b = e.extractPoints(s)
          let M = b.shape
          const S = b.holes,
            E = !Jd.isClockWise(M)
          if (E) {
            M = M.reverse()
            for (let e = 0, t = S.length; e < t; e++) {
              const t = S[e]
              Jd.isClockWise(t) && (S[e] = t.reverse())
            }
          }
          const T = Jd.triangulateShape(M, S),
            A = M
          for (let t = 0, n = S.length; t < n; t++) {
            const e = S[t]
            M = M.concat(e)
          }
          function R (e, t, n) {
            return (
              t || console.error('THREE.ExtrudeGeometry: vec does not exist'),
              t
                .clone()
                .multiplyScalar(n)
                .add(e)
            )
          }
          const L = M.length,
            C = T.length
          function P (e, t, n) {
            let i, r, a
            const s = e.x - t.x,
              o = e.y - t.y,
              l = n.x - e.x,
              c = n.y - e.y,
              h = s * s + o * o,
              u = s * c - o * l
            if (Math.abs(u) > Number.EPSILON) {
              const u = Math.sqrt(h),
                d = Math.sqrt(l * l + c * c),
                p = t.x - o / u,
                f = t.y + s / u,
                m = n.x - c / d,
                g = n.y + l / d,
                v = ((m - p) * c - (g - f) * l) / (s * c - o * l)
              ;(i = p + s * v - e.x), (r = f + o * v - e.y)
              const y = i * i + r * r
              if (y <= 2) return new kn(i, r)
              a = Math.sqrt(y / 2)
            } else {
              let e = !1
              s > Number.EPSILON
                ? l > Number.EPSILON && (e = !0)
                : s < -Number.EPSILON
                ? l < -Number.EPSILON && (e = !0)
                : Math.sign(o) === Math.sign(c) && (e = !0),
                e
                  ? ((i = -o), (r = s), (a = Math.sqrt(h)))
                  : ((i = s), (r = o), (a = Math.sqrt(h / 2)))
            }
            return new kn(i / a, r / a)
          }
          const D = []
          for (
            let t = 0, n = A.length, i = n - 1, r = t + 1;
            t < n;
            t++, i++, r++
          )
            i === n && (i = 0), r === n && (r = 0), (D[t] = P(A[t], A[i], A[r]))
          const I = []
          let N,
            O = D.concat()
          for (let t = 0, n = S.length; t < n; t++) {
            const e = S[t]
            N = []
            for (
              let t = 0, n = e.length, i = n - 1, r = t + 1;
              t < n;
              t++, i++, r++
            )
              i === n && (i = 0),
                r === n && (r = 0),
                (N[t] = P(e[t], e[i], e[r]))
            I.push(N), (O = O.concat(N))
          }
          for (let t = 0; t < p; t++) {
            const e = t / p,
              n = h * Math.cos((e * Math.PI) / 2),
              i = u * Math.sin((e * Math.PI) / 2) + d
            for (let t = 0, r = A.length; t < r; t++) {
              const e = R(A[t], D[t], i)
              k(e.x, e.y, -n)
            }
            for (let t = 0, r = S.length; t < r; t++) {
              const e = S[t]
              N = I[t]
              for (let t = 0, r = e.length; t < r; t++) {
                const r = R(e[t], N[t], i)
                k(r.x, r.y, -n)
              }
            }
          }
          const F = u + d
          for (let t = 0; t < L; t++) {
            const e = c ? R(M[t], O[t], F) : M[t]
            w
              ? (_.copy(v.normals[0]).multiplyScalar(e.x),
                y.copy(v.binormals[0]).multiplyScalar(e.y),
                x
                  .copy(g[0])
                  .add(_)
                  .add(y),
                k(x.x, x.y, x.z))
              : k(e.x, e.y, 0)
          }
          for (let t = 1; t <= o; t++)
            for (let e = 0; e < L; e++) {
              const n = c ? R(M[e], O[e], F) : M[e]
              w
                ? (_.copy(v.normals[t]).multiplyScalar(n.x),
                  y.copy(v.binormals[t]).multiplyScalar(n.y),
                  x
                    .copy(g[t])
                    .add(_)
                    .add(y),
                  k(x.x, x.y, x.z))
                : k(n.x, n.y, (l / o) * t)
            }
          for (let t = p - 1; t >= 0; t--) {
            const e = t / p,
              n = h * Math.cos((e * Math.PI) / 2),
              i = u * Math.sin((e * Math.PI) / 2) + d
            for (let t = 0, r = A.length; t < r; t++) {
              const e = R(A[t], D[t], i)
              k(e.x, e.y, l + n)
            }
            for (let t = 0, r = S.length; t < r; t++) {
              const e = S[t]
              N = I[t]
              for (let t = 0, r = e.length; t < r; t++) {
                const r = R(e[t], N[t], i)
                w
                  ? k(r.x, r.y + g[o - 1].y, g[o - 1].x + n)
                  : k(r.x, r.y, l + n)
              }
            }
          }
          function B () {
            const e = i.length / 3
            if (c) {
              let e = 0,
                t = L * e
              for (let n = 0; n < C; n++) {
                const e = T[n]
                H(e[2] + t, e[1] + t, e[0] + t)
              }
              ;(e = o + 2 * p), (t = L * e)
              for (let n = 0; n < C; n++) {
                const e = T[n]
                H(e[0] + t, e[1] + t, e[2] + t)
              }
            } else {
              for (let e = 0; e < C; e++) {
                const t = T[e]
                H(t[2], t[1], t[0])
              }
              for (let e = 0; e < C; e++) {
                const t = T[e]
                H(t[0] + L * o, t[1] + L * o, t[2] + L * o)
              }
            }
            n.addGroup(e, i.length / 3 - e, 0)
          }
          function z () {
            const e = i.length / 3
            let t = 0
            U(A, t), (t += A.length)
            for (let n = 0, i = S.length; n < i; n++) {
              const e = S[n]
              U(e, t), (t += e.length)
            }
            n.addGroup(e, i.length / 3 - e, 1)
          }
          function U (e, t) {
            let n = e.length
            while (--n >= 0) {
              const i = n
              let r = n - 1
              r < 0 && (r = e.length - 1)
              for (let e = 0, n = o + 2 * p; e < n; e++) {
                const n = L * e,
                  a = L * (e + 1),
                  s = t + i + n,
                  o = t + r + n,
                  l = t + r + a,
                  c = t + i + a
                W(s, o, l, c)
              }
            }
          }
          function k (e, t, n) {
            a.push(e), a.push(t), a.push(n)
          }
          function H (e, t, r) {
            V(e), V(t), V(r)
            const a = i.length / 3,
              s = m.generateTopUV(n, i, a - 3, a - 2, a - 1)
            G(s[0]), G(s[1]), G(s[2])
          }
          function W (e, t, r, a) {
            V(e), V(t), V(a), V(t), V(r), V(a)
            const s = i.length / 3,
              o = m.generateSideWallUV(n, i, s - 6, s - 3, s - 2, s - 1)
            G(o[0]), G(o[1]), G(o[3]), G(o[1]), G(o[2]), G(o[3])
          }
          function V (e) {
            i.push(a[3 * e + 0]), i.push(a[3 * e + 1]), i.push(a[3 * e + 2])
          }
          function G (e) {
            r.push(e.x), r.push(e.y)
          }
          B(), z()
        }
        this.setAttribute('position', new Rr(i, 3)),
          this.setAttribute('uv', new Rr(r, 2)),
          this.computeVertexNormals()
      }
      toJSON () {
        const e = super.toJSON(),
          t = this.parameters.shapes,
          n = this.parameters.options
        return ep(t, n, e)
      }
      static fromJSON (e, t) {
        const n = []
        for (let r = 0, a = e.shapes.length; r < a; r++) {
          const i = t[e.shapes[r]]
          n.push(i)
        }
        const i = e.options.extrudePath
        return (
          void 0 !== i &&
            (e.options.extrudePath = new gd[i.type]().fromJSON(i)),
          new Qd(n, e.options)
        )
      }
    }
    const $d = {
      generateTopUV: function (e, t, n, i, r) {
        const a = t[3 * n],
          s = t[3 * n + 1],
          o = t[3 * i],
          l = t[3 * i + 1],
          c = t[3 * r],
          h = t[3 * r + 1]
        return [new kn(a, s), new kn(o, l), new kn(c, h)]
      },
      generateSideWallUV: function (e, t, n, i, r, a) {
        const s = t[3 * n],
          o = t[3 * n + 1],
          l = t[3 * n + 2],
          c = t[3 * i],
          h = t[3 * i + 1],
          u = t[3 * i + 2],
          d = t[3 * r],
          p = t[3 * r + 1],
          f = t[3 * r + 2],
          m = t[3 * a],
          g = t[3 * a + 1],
          v = t[3 * a + 2]
        return Math.abs(o - h) < Math.abs(s - c)
          ? [
              new kn(s, 1 - l),
              new kn(c, 1 - u),
              new kn(d, 1 - f),
              new kn(m, 1 - v)
            ]
          : [
              new kn(o, 1 - l),
              new kn(h, 1 - u),
              new kn(p, 1 - f),
              new kn(g, 1 - v)
            ]
      }
    }
    function ep (e, t, n) {
      if (((n.shapes = []), Array.isArray(e)))
        for (let i = 0, r = e.length; i < r; i++) {
          const t = e[i]
          n.shapes.push(t.uuid)
        }
      else n.shapes.push(e.uuid)
      return (
        void 0 !== t.extrudePath &&
          (n.options.extrudePath = t.extrudePath.toJSON()),
        n
      )
    }
    class tp extends Bu {
      constructor (e = 1, t = 0) {
        const n = (1 + Math.sqrt(5)) / 2,
          i = [
            -1,
            n,
            0,
            1,
            n,
            0,
            -1,
            -n,
            0,
            1,
            -n,
            0,
            0,
            -1,
            n,
            0,
            1,
            n,
            0,
            -1,
            -n,
            0,
            1,
            -n,
            n,
            0,
            -1,
            n,
            0,
            1,
            -n,
            0,
            -1,
            -n,
            0,
            1
          ],
          r = [
            0,
            11,
            5,
            0,
            5,
            1,
            0,
            1,
            7,
            0,
            7,
            10,
            0,
            10,
            11,
            1,
            5,
            9,
            5,
            11,
            4,
            11,
            10,
            2,
            10,
            7,
            6,
            7,
            1,
            8,
            3,
            9,
            4,
            3,
            4,
            2,
            3,
            2,
            6,
            3,
            6,
            8,
            3,
            8,
            9,
            4,
            9,
            5,
            2,
            4,
            11,
            6,
            2,
            10,
            8,
            6,
            7,
            9,
            8,
            1
          ]
        super(i, r, e, t),
          (this.type = 'IcosahedronGeometry'),
          (this.parameters = { radius: e, detail: t })
      }
      static fromJSON (e) {
        return new tp(e.radius, e.detail)
      }
    }
    class np extends Ur {
      constructor (e, t = 12, n = 0, i = 2 * Math.PI) {
        super(),
          (this.type = 'LatheGeometry'),
          (this.parameters = {
            points: e,
            segments: t,
            phiStart: n,
            phiLength: i
          }),
          (t = Math.floor(t)),
          (i = Nn(i, 0, 2 * Math.PI))
        const r = [],
          a = [],
          s = [],
          o = 1 / t,
          l = new Qn(),
          c = new kn()
        for (let h = 0; h <= t; h++) {
          const r = n + h * o * i,
            u = Math.sin(r),
            d = Math.cos(r)
          for (let n = 0; n <= e.length - 1; n++)
            (l.x = e[n].x * u),
              (l.y = e[n].y),
              (l.z = e[n].x * d),
              a.push(l.x, l.y, l.z),
              (c.x = h / t),
              (c.y = n / (e.length - 1)),
              s.push(c.x, c.y)
        }
        for (let h = 0; h < t; h++)
          for (let t = 0; t < e.length - 1; t++) {
            const n = t + h * e.length,
              i = n,
              a = n + e.length,
              s = n + e.length + 1,
              o = n + 1
            r.push(i, a, o), r.push(a, s, o)
          }
        if (
          (this.setIndex(r),
          this.setAttribute('position', new Rr(a, 3)),
          this.setAttribute('uv', new Rr(s, 2)),
          this.computeVertexNormals(),
          i === 2 * Math.PI)
        ) {
          const n = this.attributes.normal.array,
            i = new Qn(),
            r = new Qn(),
            a = new Qn(),
            s = t * e.length * 3
          for (let t = 0, o = 0; t < e.length; t++, o += 3)
            (i.x = n[o + 0]),
              (i.y = n[o + 1]),
              (i.z = n[o + 2]),
              (r.x = n[s + o + 0]),
              (r.y = n[s + o + 1]),
              (r.z = n[s + o + 2]),
              a.addVectors(i, r).normalize(),
              (n[o + 0] = n[s + o + 0] = a.x),
              (n[o + 1] = n[s + o + 1] = a.y),
              (n[o + 2] = n[s + o + 2] = a.z)
        }
      }
      static fromJSON (e) {
        return new np(e.points, e.segments, e.phiStart, e.phiLength)
      }
    }
    class ip extends Bu {
      constructor (e = 1, t = 0) {
        const n = [1, 0, 0, -1, 0, 0, 0, 1, 0, 0, -1, 0, 0, 0, 1, 0, 0, -1],
          i = [
            0,
            2,
            4,
            0,
            4,
            3,
            0,
            3,
            5,
            0,
            5,
            2,
            1,
            2,
            5,
            1,
            5,
            3,
            1,
            3,
            4,
            1,
            4,
            2
          ]
        super(n, i, e, t),
          (this.type = 'OctahedronGeometry'),
          (this.parameters = { radius: e, detail: t })
      }
      static fromJSON (e) {
        return new ip(e.radius, e.detail)
      }
    }
    class rp extends Ur {
      constructor (e, t, n) {
        super(),
          (this.type = 'ParametricGeometry'),
          (this.parameters = { func: e, slices: t, stacks: n })
        const i = [],
          r = [],
          a = [],
          s = [],
          o = 1e-5,
          l = new Qn(),
          c = new Qn(),
          h = new Qn(),
          u = new Qn(),
          d = new Qn()
        e.length < 3 &&
          console.error(
            'THREE.ParametricGeometry: Function must now modify a Vector3 as third parameter.'
          )
        const p = t + 1
        for (let f = 0; f <= n; f++) {
          const i = f / n
          for (let n = 0; n <= t; n++) {
            const p = n / t
            e(p, i, c),
              r.push(c.x, c.y, c.z),
              p - o >= 0
                ? (e(p - o, i, h), u.subVectors(c, h))
                : (e(p + o, i, h), u.subVectors(h, c)),
              i - o >= 0
                ? (e(p, i - o, h), d.subVectors(c, h))
                : (e(p, i + o, h), d.subVectors(h, c)),
              l.crossVectors(u, d).normalize(),
              a.push(l.x, l.y, l.z),
              s.push(p, i)
          }
        }
        for (let f = 0; f < n; f++)
          for (let e = 0; e < t; e++) {
            const t = f * p + e,
              n = f * p + e + 1,
              r = (f + 1) * p + e + 1,
              a = (f + 1) * p + e
            i.push(t, n, a), i.push(n, r, a)
          }
        this.setIndex(i),
          this.setAttribute('position', new Rr(r, 3)),
          this.setAttribute('normal', new Rr(a, 3)),
          this.setAttribute('uv', new Rr(s, 2))
      }
    }
    class ap extends Ur {
      constructor (e = 0.5, t = 1, n = 8, i = 1, r = 0, a = 2 * Math.PI) {
        super(),
          (this.type = 'RingGeometry'),
          (this.parameters = {
            innerRadius: e,
            outerRadius: t,
            thetaSegments: n,
            phiSegments: i,
            thetaStart: r,
            thetaLength: a
          }),
          (n = Math.max(3, n)),
          (i = Math.max(1, i))
        const s = [],
          o = [],
          l = [],
          c = []
        let h = e
        const u = (t - e) / i,
          d = new Qn(),
          p = new kn()
        for (let f = 0; f <= i; f++) {
          for (let e = 0; e <= n; e++) {
            const i = r + (e / n) * a
            ;(d.x = h * Math.cos(i)),
              (d.y = h * Math.sin(i)),
              o.push(d.x, d.y, d.z),
              l.push(0, 0, 1),
              (p.x = (d.x / t + 1) / 2),
              (p.y = (d.y / t + 1) / 2),
              c.push(p.x, p.y)
          }
          h += u
        }
        for (let f = 0; f < i; f++) {
          const e = f * (n + 1)
          for (let t = 0; t < n; t++) {
            const i = t + e,
              r = i,
              a = i + n + 1,
              o = i + n + 2,
              l = i + 1
            s.push(r, a, l), s.push(a, o, l)
          }
        }
        this.setIndex(s),
          this.setAttribute('position', new Rr(o, 3)),
          this.setAttribute('normal', new Rr(l, 3)),
          this.setAttribute('uv', new Rr(c, 2))
      }
      static fromJSON (e) {
        return new ap(
          e.innerRadius,
          e.outerRadius,
          e.thetaSegments,
          e.phiSegments,
          e.thetaStart,
          e.thetaLength
        )
      }
    }
    class sp extends Ur {
      constructor (e, t = 12) {
        super(),
          (this.type = 'ShapeGeometry'),
          (this.parameters = { shapes: e, curveSegments: t })
        const n = [],
          i = [],
          r = [],
          a = []
        let s = 0,
          o = 0
        if (!1 === Array.isArray(e)) l(e)
        else
          for (let c = 0; c < e.length; c++)
            l(e[c]), this.addGroup(s, o, c), (s += o), (o = 0)
        function l (e) {
          const s = i.length / 3,
            l = e.extractPoints(t)
          let c = l.shape
          const h = l.holes
          !1 === Jd.isClockWise(c) && (c = c.reverse())
          for (let t = 0, n = h.length; t < n; t++) {
            const e = h[t]
            !0 === Jd.isClockWise(e) && (h[t] = e.reverse())
          }
          const u = Jd.triangulateShape(c, h)
          for (let t = 0, n = h.length; t < n; t++) {
            const e = h[t]
            c = c.concat(e)
          }
          for (let t = 0, n = c.length; t < n; t++) {
            const e = c[t]
            i.push(e.x, e.y, 0), r.push(0, 0, 1), a.push(e.x, e.y)
          }
          for (let t = 0, i = u.length; t < i; t++) {
            const e = u[t],
              i = e[0] + s,
              r = e[1] + s,
              a = e[2] + s
            n.push(i, r, a), (o += 3)
          }
        }
        this.setIndex(n),
          this.setAttribute('position', new Rr(i, 3)),
          this.setAttribute('normal', new Rr(r, 3)),
          this.setAttribute('uv', new Rr(a, 2))
      }
      toJSON () {
        const e = super.toJSON(),
          t = this.parameters.shapes
        return op(t, e)
      }
      static fromJSON (e, t) {
        const n = []
        for (let i = 0, r = e.shapes.length; i < r; i++) {
          const r = t[e.shapes[i]]
          n.push(r)
        }
        return new sp(n, e.curveSegments)
      }
    }
    function op (e, t) {
      if (((t.shapes = []), Array.isArray(e)))
        for (let n = 0, i = e.length; n < i; n++) {
          const i = e[n]
          t.shapes.push(i.uuid)
        }
      else t.shapes.push(e.uuid)
      return t
    }
    class lp extends Ur {
      constructor (
        e = 1,
        t = 8,
        n = 6,
        i = 0,
        r = 2 * Math.PI,
        a = 0,
        s = Math.PI
      ) {
        super(),
          (this.type = 'SphereGeometry'),
          (this.parameters = {
            radius: e,
            widthSegments: t,
            heightSegments: n,
            phiStart: i,
            phiLength: r,
            thetaStart: a,
            thetaLength: s
          }),
          (t = Math.max(3, Math.floor(t))),
          (n = Math.max(2, Math.floor(n)))
        const o = Math.min(a + s, Math.PI)
        let l = 0
        const c = [],
          h = new Qn(),
          u = new Qn(),
          d = [],
          p = [],
          f = [],
          m = []
        for (let g = 0; g <= n; g++) {
          const d = [],
            v = g / n
          let y = 0
          0 == g && 0 == a
            ? (y = 0.5 / t)
            : g == n && o == Math.PI && (y = -0.5 / t)
          for (let n = 0; n <= t; n++) {
            const o = n / t
            ;(h.x = -e * Math.cos(i + o * r) * Math.sin(a + v * s)),
              (h.y = e * Math.cos(a + v * s)),
              (h.z = e * Math.sin(i + o * r) * Math.sin(a + v * s)),
              p.push(h.x, h.y, h.z),
              u.copy(h).normalize(),
              f.push(u.x, u.y, u.z),
              m.push(o + y, 1 - v),
              d.push(l++)
          }
          c.push(d)
        }
        for (let g = 0; g < n; g++)
          for (let e = 0; e < t; e++) {
            const t = c[g][e + 1],
              i = c[g][e],
              r = c[g + 1][e],
              s = c[g + 1][e + 1]
            ;(0 !== g || a > 0) && d.push(t, i, s),
              (g !== n - 1 || o < Math.PI) && d.push(i, r, s)
          }
        this.setIndex(d),
          this.setAttribute('position', new Rr(p, 3)),
          this.setAttribute('normal', new Rr(f, 3)),
          this.setAttribute('uv', new Rr(m, 2))
      }
      static fromJSON (e) {
        return new lp(
          e.radius,
          e.widthSegments,
          e.heightSegments,
          e.phiStart,
          e.phiLength,
          e.thetaStart,
          e.thetaLength
        )
      }
    }
    class cp extends Bu {
      constructor (e = 1, t = 0) {
        const n = [1, 1, 1, -1, -1, 1, -1, 1, -1, 1, -1, -1],
          i = [2, 1, 0, 0, 3, 2, 1, 3, 0, 2, 3, 1]
        super(n, i, e, t),
          (this.type = 'TetrahedronGeometry'),
          (this.parameters = { radius: e, detail: t })
      }
      static fromJSON (e) {
        return new cp(e.radius, e.detail)
      }
    }
    class hp extends Qd {
      constructor (e, t = {}) {
        const n = t.font
        if (!n || !n.isFont)
          return (
            console.error(
              'THREE.TextGeometry: font parameter is not an instance of THREE.Font.'
            ),
            new Ur()
          )
        const i = n.generateShapes(e, t.size)
        ;(t.depth = void 0 !== t.height ? t.height : 50),
          void 0 === t.bevelThickness && (t.bevelThickness = 10),
          void 0 === t.bevelSize && (t.bevelSize = 8),
          void 0 === t.bevelEnabled && (t.bevelEnabled = !1),
          super(i, t),
          (this.type = 'TextGeometry')
      }
    }
    class up extends Ur {
      constructor (e = 1, t = 0.4, n = 8, i = 6, r = 2 * Math.PI) {
        super(),
          (this.type = 'TorusGeometry'),
          (this.parameters = {
            radius: e,
            tube: t,
            radialSegments: n,
            tubularSegments: i,
            arc: r
          }),
          (n = Math.floor(n)),
          (i = Math.floor(i))
        const a = [],
          s = [],
          o = [],
          l = [],
          c = new Qn(),
          h = new Qn(),
          u = new Qn()
        for (let d = 0; d <= n; d++)
          for (let a = 0; a <= i; a++) {
            const p = (a / i) * r,
              f = (d / n) * Math.PI * 2
            ;(h.x = (e + t * Math.cos(f)) * Math.cos(p)),
              (h.y = (e + t * Math.cos(f)) * Math.sin(p)),
              (h.z = t * Math.sin(f)),
              s.push(h.x, h.y, h.z),
              (c.x = e * Math.cos(p)),
              (c.y = e * Math.sin(p)),
              u.subVectors(h, c).normalize(),
              o.push(u.x, u.y, u.z),
              l.push(a / i),
              l.push(d / n)
          }
        for (let d = 1; d <= n; d++)
          for (let e = 1; e <= i; e++) {
            const t = (i + 1) * d + e - 1,
              n = (i + 1) * (d - 1) + e - 1,
              r = (i + 1) * (d - 1) + e,
              s = (i + 1) * d + e
            a.push(t, n, s), a.push(n, r, s)
          }
        this.setIndex(a),
          this.setAttribute('position', new Rr(s, 3)),
          this.setAttribute('normal', new Rr(o, 3)),
          this.setAttribute('uv', new Rr(l, 2))
      }
      static fromJSON (e) {
        return new up(
          e.radius,
          e.tube,
          e.radialSegments,
          e.tubularSegments,
          e.arc
        )
      }
    }
    class dp extends Ur {
      constructor (e = 1, t = 0.4, n = 64, i = 8, r = 2, a = 3) {
        super(),
          (this.type = 'TorusKnotGeometry'),
          (this.parameters = {
            radius: e,
            tube: t,
            tubularSegments: n,
            radialSegments: i,
            p: r,
            q: a
          }),
          (n = Math.floor(n)),
          (i = Math.floor(i))
        const s = [],
          o = [],
          l = [],
          c = [],
          h = new Qn(),
          u = new Qn(),
          d = new Qn(),
          p = new Qn(),
          f = new Qn(),
          m = new Qn(),
          g = new Qn()
        for (let y = 0; y <= n; ++y) {
          const s = (y / n) * r * Math.PI * 2
          v(s, r, a, e, d),
            v(s + 0.01, r, a, e, p),
            m.subVectors(p, d),
            g.addVectors(p, d),
            f.crossVectors(m, g),
            g.crossVectors(f, m),
            f.normalize(),
            g.normalize()
          for (let e = 0; e <= i; ++e) {
            const r = (e / i) * Math.PI * 2,
              a = -t * Math.cos(r),
              s = t * Math.sin(r)
            ;(h.x = d.x + (a * g.x + s * f.x)),
              (h.y = d.y + (a * g.y + s * f.y)),
              (h.z = d.z + (a * g.z + s * f.z)),
              o.push(h.x, h.y, h.z),
              u.subVectors(h, d).normalize(),
              l.push(u.x, u.y, u.z),
              c.push(y / n),
              c.push(e / i)
          }
        }
        for (let y = 1; y <= n; y++)
          for (let e = 1; e <= i; e++) {
            const t = (i + 1) * (y - 1) + (e - 1),
              n = (i + 1) * y + (e - 1),
              r = (i + 1) * y + e,
              a = (i + 1) * (y - 1) + e
            s.push(t, n, a), s.push(n, r, a)
          }
        function v (e, t, n, i, r) {
          const a = Math.cos(e),
            s = Math.sin(e),
            o = (n / t) * e,
            l = Math.cos(o)
          ;(r.x = i * (2 + l) * 0.5 * a),
            (r.y = i * (2 + l) * s * 0.5),
            (r.z = i * Math.sin(o) * 0.5)
        }
        this.setIndex(s),
          this.setAttribute('position', new Rr(o, 3)),
          this.setAttribute('normal', new Rr(l, 3)),
          this.setAttribute('uv', new Rr(c, 2))
      }
      static fromJSON (e) {
        return new dp(
          e.radius,
          e.tube,
          e.tubularSegments,
          e.radialSegments,
          e.p,
          e.q
        )
      }
    }
    class pp extends Ur {
      constructor (e, t = 64, n = 1, i = 8, r = !1) {
        super(),
          (this.type = 'TubeGeometry'),
          (this.parameters = {
            path: e,
            tubularSegments: t,
            radius: n,
            radialSegments: i,
            closed: r
          })
        const a = e.computeFrenetFrames(t, r)
        ;(this.tangents = a.tangents),
          (this.normals = a.normals),
          (this.binormals = a.binormals)
        const s = new Qn(),
          o = new Qn(),
          l = new kn()
        let c = new Qn()
        const h = [],
          u = [],
          d = [],
          p = []
        function f () {
          for (let e = 0; e < t; e++) m(e)
          m(!1 === r ? t : 0), v(), g()
        }
        function m (r) {
          c = e.getPointAt(r / t, c)
          const l = a.normals[r],
            d = a.binormals[r]
          for (let e = 0; e <= i; e++) {
            const t = (e / i) * Math.PI * 2,
              r = Math.sin(t),
              a = -Math.cos(t)
            ;(o.x = a * l.x + r * d.x),
              (o.y = a * l.y + r * d.y),
              (o.z = a * l.z + r * d.z),
              o.normalize(),
              u.push(o.x, o.y, o.z),
              (s.x = c.x + n * o.x),
              (s.y = c.y + n * o.y),
              (s.z = c.z + n * o.z),
              h.push(s.x, s.y, s.z)
          }
        }
        function g () {
          for (let e = 1; e <= t; e++)
            for (let t = 1; t <= i; t++) {
              const n = (i + 1) * (e - 1) + (t - 1),
                r = (i + 1) * e + (t - 1),
                a = (i + 1) * e + t,
                s = (i + 1) * (e - 1) + t
              p.push(n, r, s), p.push(r, a, s)
            }
        }
        function v () {
          for (let e = 0; e <= t; e++)
            for (let n = 0; n <= i; n++)
              (l.x = e / t), (l.y = n / i), d.push(l.x, l.y)
        }
        f(),
          this.setIndex(p),
          this.setAttribute('position', new Rr(h, 3)),
          this.setAttribute('normal', new Rr(u, 3)),
          this.setAttribute('uv', new Rr(d, 2))
      }
      toJSON () {
        const e = super.toJSON()
        return (e.path = this.parameters.path.toJSON()), e
      }
      static fromJSON (e) {
        return new pp(
          new gd[e.path.type]().fromJSON(e.path),
          e.tubularSegments,
          e.radius,
          e.radialSegments,
          e.closed
        )
      }
    }
    class fp extends Ur {
      constructor (e) {
        if ((super(), (this.type = 'WireframeGeometry'), !0 === e.isGeometry))
          return void console.error(
            'THREE.WireframeGeometry no longer supports THREE.Geometry. Use THREE.BufferGeometry instead.'
          )
        const t = [],
          n = [0, 0],
          i = {},
          r = new Qn()
        if (null !== e.index) {
          const a = e.attributes.position,
            s = e.index
          let o = e.groups
          0 === o.length &&
            (o = [{ start: 0, count: s.count, materialIndex: 0 }])
          for (let e = 0, t = o.length; e < t; ++e) {
            const t = o[e],
              r = t.start,
              a = t.count
            for (let e = r, o = r + a; e < o; e += 3)
              for (let t = 0; t < 3; t++) {
                const r = s.getX(e + t),
                  a = s.getX(e + ((t + 1) % 3))
                ;(n[0] = Math.min(r, a)), (n[1] = Math.max(r, a))
                const o = n[0] + ',' + n[1]
                void 0 === i[o] && (i[o] = { index1: n[0], index2: n[1] })
              }
          }
          for (const e in i) {
            const n = i[e]
            r.fromBufferAttribute(a, n.index1),
              t.push(r.x, r.y, r.z),
              r.fromBufferAttribute(a, n.index2),
              t.push(r.x, r.y, r.z)
          }
        } else {
          const n = e.attributes.position
          for (let e = 0, i = n.count / 3; e < i; e++)
            for (let a = 0; a < 3; a++) {
              const i = 3 * e + a
              r.fromBufferAttribute(n, i), t.push(r.x, r.y, r.z)
              const s = 3 * e + ((a + 1) % 3)
              r.fromBufferAttribute(n, s), t.push(r.x, r.y, r.z)
            }
        }
        this.setAttribute('position', new Rr(t, 3))
      }
    }
    var mp = Object.freeze({
      __proto__: null,
      BoxGeometry: sa,
      BoxBufferGeometry: sa,
      CircleGeometry: Nu,
      CircleBufferGeometry: Nu,
      ConeGeometry: Fu,
      ConeBufferGeometry: Fu,
      CylinderGeometry: Ou,
      CylinderBufferGeometry: Ou,
      DodecahedronGeometry: zu,
      DodecahedronBufferGeometry: zu,
      EdgesGeometry: Vu,
      ExtrudeGeometry: Qd,
      ExtrudeBufferGeometry: Qd,
      IcosahedronGeometry: tp,
      IcosahedronBufferGeometry: tp,
      LatheGeometry: np,
      LatheBufferGeometry: np,
      OctahedronGeometry: ip,
      OctahedronBufferGeometry: ip,
      ParametricGeometry: rp,
      ParametricBufferGeometry: rp,
      PlaneGeometry: La,
      PlaneBufferGeometry: La,
      PolyhedronGeometry: Bu,
      PolyhedronBufferGeometry: Bu,
      RingGeometry: ap,
      RingBufferGeometry: ap,
      ShapeGeometry: sp,
      ShapeBufferGeometry: sp,
      SphereGeometry: lp,
      SphereBufferGeometry: lp,
      TetrahedronGeometry: cp,
      TetrahedronBufferGeometry: cp,
      TextGeometry: hp,
      TextBufferGeometry: hp,
      TorusGeometry: up,
      TorusBufferGeometry: up,
      TorusKnotGeometry: dp,
      TorusKnotBufferGeometry: dp,
      TubeGeometry: pp,
      TubeBufferGeometry: pp,
      WireframeGeometry: fp
    })
    class gp extends pr {
      constructor (e) {
        super(),
          (this.type = 'ShadowMaterial'),
          (this.color = new xr(0)),
          (this.transparent = !0),
          this.setValues(e)
      }
      copy (e) {
        return super.copy(e), this.color.copy(e.color), this
      }
    }
    gp.prototype.isShadowMaterial = !0
    class vp extends da {
      constructor (e) {
        super(e), (this.type = 'RawShaderMaterial')
      }
    }
    vp.prototype.isRawShaderMaterial = !0
    class yp extends pr {
      constructor (e) {
        super(),
          (this.defines = { STANDARD: '' }),
          (this.type = 'MeshStandardMaterial'),
          (this.color = new xr(16777215)),
          (this.roughness = 1),
          (this.metalness = 0),
          (this.map = null),
          (this.lightMap = null),
          (this.lightMapIntensity = 1),
          (this.aoMap = null),
          (this.aoMapIntensity = 1),
          (this.emissive = new xr(0)),
          (this.emissiveIntensity = 1),
          (this.emissiveMap = null),
          (this.bumpMap = null),
          (this.bumpScale = 1),
          (this.normalMap = null),
          (this.normalMapType = bn),
          (this.normalScale = new kn(1, 1)),
          (this.displacementMap = null),
          (this.displacementScale = 1),
          (this.displacementBias = 0),
          (this.roughnessMap = null),
          (this.metalnessMap = null),
          (this.alphaMap = null),
          (this.envMap = null),
          (this.envMapIntensity = 1),
          (this.refractionRatio = 0.98),
          (this.wireframe = !1),
          (this.wireframeLinewidth = 1),
          (this.wireframeLinecap = 'round'),
          (this.wireframeLinejoin = 'round'),
          (this.morphTargets = !1),
          (this.morphNormals = !1),
          (this.flatShading = !1),
          (this.vertexTangents = !1),
          this.setValues(e)
      }
      copy (e) {
        return (
          super.copy(e),
          (this.defines = { STANDARD: '' }),
          this.color.copy(e.color),
          (this.roughness = e.roughness),
          (this.metalness = e.metalness),
          (this.map = e.map),
          (this.lightMap = e.lightMap),
          (this.lightMapIntensity = e.lightMapIntensity),
          (this.aoMap = e.aoMap),
          (this.aoMapIntensity = e.aoMapIntensity),
          this.emissive.copy(e.emissive),
          (this.emissiveMap = e.emissiveMap),
          (this.emissiveIntensity = e.emissiveIntensity),
          (this.bumpMap = e.bumpMap),
          (this.bumpScale = e.bumpScale),
          (this.normalMap = e.normalMap),
          (this.normalMapType = e.normalMapType),
          this.normalScale.copy(e.normalScale),
          (this.displacementMap = e.displacementMap),
          (this.displacementScale = e.displacementScale),
          (this.displacementBias = e.displacementBias),
          (this.roughnessMap = e.roughnessMap),
          (this.metalnessMap = e.metalnessMap),
          (this.alphaMap = e.alphaMap),
          (this.envMap = e.envMap),
          (this.envMapIntensity = e.envMapIntensity),
          (this.refractionRatio = e.refractionRatio),
          (this.wireframe = e.wireframe),
          (this.wireframeLinewidth = e.wireframeLinewidth),
          (this.wireframeLinecap = e.wireframeLinecap),
          (this.wireframeLinejoin = e.wireframeLinejoin),
          (this.morphTargets = e.morphTargets),
          (this.morphNormals = e.morphNormals),
          (this.flatShading = e.flatShading),
          (this.vertexTangents = e.vertexTangents),
          this
        )
      }
    }
    yp.prototype.isMeshStandardMaterial = !0
    class _p extends yp {
      constructor (e) {
        super(),
          (this.defines = { STANDARD: '', PHYSICAL: '' }),
          (this.type = 'MeshPhysicalMaterial'),
          (this.clearcoat = 0),
          (this.clearcoatMap = null),
          (this.clearcoatRoughness = 0),
          (this.clearcoatRoughnessMap = null),
          (this.clearcoatNormalScale = new kn(1, 1)),
          (this.clearcoatNormalMap = null),
          (this.reflectivity = 0.5),
          Object.defineProperty(this, 'ior', {
            get: function () {
              return (
                (1 + 0.4 * this.reflectivity) / (1 - 0.4 * this.reflectivity)
              )
            },
            set: function (e) {
              this.reflectivity = Nn((2.5 * (e - 1)) / (e + 1), 0, 1)
            }
          }),
          (this.sheen = null),
          (this.transmission = 0),
          (this.transmissionMap = null),
          (this.thickness = 0.01),
          (this.thicknessMap = null),
          (this.attenuationDistance = 0),
          (this.attenuationColor = new xr(1, 1, 1)),
          this.setValues(e)
      }
      copy (e) {
        return (
          super.copy(e),
          (this.defines = { STANDARD: '', PHYSICAL: '' }),
          (this.clearcoat = e.clearcoat),
          (this.clearcoatMap = e.clearcoatMap),
          (this.clearcoatRoughness = e.clearcoatRoughness),
          (this.clearcoatRoughnessMap = e.clearcoatRoughnessMap),
          (this.clearcoatNormalMap = e.clearcoatNormalMap),
          this.clearcoatNormalScale.copy(e.clearcoatNormalScale),
          (this.reflectivity = e.reflectivity),
          e.sheen
            ? (this.sheen = (this.sheen || new xr()).copy(e.sheen))
            : (this.sheen = null),
          (this.transmission = e.transmission),
          (this.transmissionMap = e.transmissionMap),
          (this.thickness = e.thickness),
          (this.thicknessMap = e.thicknessMap),
          (this.attenuationDistance = e.attenuationDistance),
          this.attenuationColor.copy(e.attenuationColor),
          this
        )
      }
    }
    _p.prototype.isMeshPhysicalMaterial = !0
    class xp extends pr {
      constructor (e) {
        super(),
          (this.type = 'MeshPhongMaterial'),
          (this.color = new xr(16777215)),
          (this.specular = new xr(1118481)),
          (this.shininess = 30),
          (this.map = null),
          (this.lightMap = null),
          (this.lightMapIntensity = 1),
          (this.aoMap = null),
          (this.aoMapIntensity = 1),
          (this.emissive = new xr(0)),
          (this.emissiveIntensity = 1),
          (this.emissiveMap = null),
          (this.bumpMap = null),
          (this.bumpScale = 1),
          (this.normalMap = null),
          (this.normalMapType = bn),
          (this.normalScale = new kn(1, 1)),
          (this.displacementMap = null),
          (this.displacementScale = 1),
          (this.displacementBias = 0),
          (this.specularMap = null),
          (this.alphaMap = null),
          (this.envMap = null),
          (this.combine = ve),
          (this.reflectivity = 1),
          (this.refractionRatio = 0.98),
          (this.wireframe = !1),
          (this.wireframeLinewidth = 1),
          (this.wireframeLinecap = 'round'),
          (this.wireframeLinejoin = 'round'),
          (this.morphTargets = !1),
          (this.morphNormals = !1),
          (this.flatShading = !1),
          this.setValues(e)
      }
      copy (e) {
        return (
          super.copy(e),
          this.color.copy(e.color),
          this.specular.copy(e.specular),
          (this.shininess = e.shininess),
          (this.map = e.map),
          (this.lightMap = e.lightMap),
          (this.lightMapIntensity = e.lightMapIntensity),
          (this.aoMap = e.aoMap),
          (this.aoMapIntensity = e.aoMapIntensity),
          this.emissive.copy(e.emissive),
          (this.emissiveMap = e.emissiveMap),
          (this.emissiveIntensity = e.emissiveIntensity),
          (this.bumpMap = e.bumpMap),
          (this.bumpScale = e.bumpScale),
          (this.normalMap = e.normalMap),
          (this.normalMapType = e.normalMapType),
          this.normalScale.copy(e.normalScale),
          (this.displacementMap = e.displacementMap),
          (this.displacementScale = e.displacementScale),
          (this.displacementBias = e.displacementBias),
          (this.specularMap = e.specularMap),
          (this.alphaMap = e.alphaMap),
          (this.envMap = e.envMap),
          (this.combine = e.combine),
          (this.reflectivity = e.reflectivity),
          (this.refractionRatio = e.refractionRatio),
          (this.wireframe = e.wireframe),
          (this.wireframeLinewidth = e.wireframeLinewidth),
          (this.wireframeLinecap = e.wireframeLinecap),
          (this.wireframeLinejoin = e.wireframeLinejoin),
          (this.morphTargets = e.morphTargets),
          (this.morphNormals = e.morphNormals),
          (this.flatShading = e.flatShading),
          this
        )
      }
    }
    xp.prototype.isMeshPhongMaterial = !0
    class wp extends pr {
      constructor (e) {
        super(),
          (this.defines = { TOON: '' }),
          (this.type = 'MeshToonMaterial'),
          (this.color = new xr(16777215)),
          (this.map = null),
          (this.gradientMap = null),
          (this.lightMap = null),
          (this.lightMapIntensity = 1),
          (this.aoMap = null),
          (this.aoMapIntensity = 1),
          (this.emissive = new xr(0)),
          (this.emissiveIntensity = 1),
          (this.emissiveMap = null),
          (this.bumpMap = null),
          (this.bumpScale = 1),
          (this.normalMap = null),
          (this.normalMapType = bn),
          (this.normalScale = new kn(1, 1)),
          (this.displacementMap = null),
          (this.displacementScale = 1),
          (this.displacementBias = 0),
          (this.alphaMap = null),
          (this.wireframe = !1),
          (this.wireframeLinewidth = 1),
          (this.wireframeLinecap = 'round'),
          (this.wireframeLinejoin = 'round'),
          (this.morphTargets = !1),
          (this.morphNormals = !1),
          this.setValues(e)
      }
      copy (e) {
        return (
          super.copy(e),
          this.color.copy(e.color),
          (this.map = e.map),
          (this.gradientMap = e.gradientMap),
          (this.lightMap = e.lightMap),
          (this.lightMapIntensity = e.lightMapIntensity),
          (this.aoMap = e.aoMap),
          (this.aoMapIntensity = e.aoMapIntensity),
          this.emissive.copy(e.emissive),
          (this.emissiveMap = e.emissiveMap),
          (this.emissiveIntensity = e.emissiveIntensity),
          (this.bumpMap = e.bumpMap),
          (this.bumpScale = e.bumpScale),
          (this.normalMap = e.normalMap),
          (this.normalMapType = e.normalMapType),
          this.normalScale.copy(e.normalScale),
          (this.displacementMap = e.displacementMap),
          (this.displacementScale = e.displacementScale),
          (this.displacementBias = e.displacementBias),
          (this.alphaMap = e.alphaMap),
          (this.wireframe = e.wireframe),
          (this.wireframeLinewidth = e.wireframeLinewidth),
          (this.wireframeLinecap = e.wireframeLinecap),
          (this.wireframeLinejoin = e.wireframeLinejoin),
          (this.morphTargets = e.morphTargets),
          (this.morphNormals = e.morphNormals),
          this
        )
      }
    }
    wp.prototype.isMeshToonMaterial = !0
    class bp extends pr {
      constructor (e) {
        super(),
          (this.type = 'MeshNormalMaterial'),
          (this.bumpMap = null),
          (this.bumpScale = 1),
          (this.normalMap = null),
          (this.normalMapType = bn),
          (this.normalScale = new kn(1, 1)),
          (this.displacementMap = null),
          (this.displacementScale = 1),
          (this.displacementBias = 0),
          (this.wireframe = !1),
          (this.wireframeLinewidth = 1),
          (this.fog = !1),
          (this.morphTargets = !1),
          (this.morphNormals = !1),
          (this.flatShading = !1),
          this.setValues(e)
      }
      copy (e) {
        return (
          super.copy(e),
          (this.bumpMap = e.bumpMap),
          (this.bumpScale = e.bumpScale),
          (this.normalMap = e.normalMap),
          (this.normalMapType = e.normalMapType),
          this.normalScale.copy(e.normalScale),
          (this.displacementMap = e.displacementMap),
          (this.displacementScale = e.displacementScale),
          (this.displacementBias = e.displacementBias),
          (this.wireframe = e.wireframe),
          (this.wireframeLinewidth = e.wireframeLinewidth),
          (this.morphTargets = e.morphTargets),
          (this.morphNormals = e.morphNormals),
          (this.flatShading = e.flatShading),
          this
        )
      }
    }
    bp.prototype.isMeshNormalMaterial = !0
    class Mp extends pr {
      constructor (e) {
        super(),
          (this.type = 'MeshLambertMaterial'),
          (this.color = new xr(16777215)),
          (this.map = null),
          (this.lightMap = null),
          (this.lightMapIntensity = 1),
          (this.aoMap = null),
          (this.aoMapIntensity = 1),
          (this.emissive = new xr(0)),
          (this.emissiveIntensity = 1),
          (this.emissiveMap = null),
          (this.specularMap = null),
          (this.alphaMap = null),
          (this.envMap = null),
          (this.combine = ve),
          (this.reflectivity = 1),
          (this.refractionRatio = 0.98),
          (this.wireframe = !1),
          (this.wireframeLinewidth = 1),
          (this.wireframeLinecap = 'round'),
          (this.wireframeLinejoin = 'round'),
          (this.morphTargets = !1),
          (this.morphNormals = !1),
          this.setValues(e)
      }
      copy (e) {
        return (
          super.copy(e),
          this.color.copy(e.color),
          (this.map = e.map),
          (this.lightMap = e.lightMap),
          (this.lightMapIntensity = e.lightMapIntensity),
          (this.aoMap = e.aoMap),
          (this.aoMapIntensity = e.aoMapIntensity),
          this.emissive.copy(e.emissive),
          (this.emissiveMap = e.emissiveMap),
          (this.emissiveIntensity = e.emissiveIntensity),
          (this.specularMap = e.specularMap),
          (this.alphaMap = e.alphaMap),
          (this.envMap = e.envMap),
          (this.combine = e.combine),
          (this.reflectivity = e.reflectivity),
          (this.refractionRatio = e.refractionRatio),
          (this.wireframe = e.wireframe),
          (this.wireframeLinewidth = e.wireframeLinewidth),
          (this.wireframeLinecap = e.wireframeLinecap),
          (this.wireframeLinejoin = e.wireframeLinejoin),
          (this.morphTargets = e.morphTargets),
          (this.morphNormals = e.morphNormals),
          this
        )
      }
    }
    Mp.prototype.isMeshLambertMaterial = !0
    class Sp extends pr {
      constructor (e) {
        super(),
          (this.defines = { MATCAP: '' }),
          (this.type = 'MeshMatcapMaterial'),
          (this.color = new xr(16777215)),
          (this.matcap = null),
          (this.map = null),
          (this.bumpMap = null),
          (this.bumpScale = 1),
          (this.normalMap = null),
          (this.normalMapType = bn),
          (this.normalScale = new kn(1, 1)),
          (this.displacementMap = null),
          (this.displacementScale = 1),
          (this.displacementBias = 0),
          (this.alphaMap = null),
          (this.morphTargets = !1),
          (this.morphNormals = !1),
          (this.flatShading = !1),
          this.setValues(e)
      }
      copy (e) {
        return (
          super.copy(e),
          (this.defines = { MATCAP: '' }),
          this.color.copy(e.color),
          (this.matcap = e.matcap),
          (this.map = e.map),
          (this.bumpMap = e.bumpMap),
          (this.bumpScale = e.bumpScale),
          (this.normalMap = e.normalMap),
          (this.normalMapType = e.normalMapType),
          this.normalScale.copy(e.normalScale),
          (this.displacementMap = e.displacementMap),
          (this.displacementScale = e.displacementScale),
          (this.displacementBias = e.displacementBias),
          (this.alphaMap = e.alphaMap),
          (this.morphTargets = e.morphTargets),
          (this.morphNormals = e.morphNormals),
          (this.flatShading = e.flatShading),
          this
        )
      }
    }
    Sp.prototype.isMeshMatcapMaterial = !0
    class Ep extends du {
      constructor (e) {
        super(),
          (this.type = 'LineDashedMaterial'),
          (this.scale = 1),
          (this.dashSize = 3),
          (this.gapSize = 1),
          this.setValues(e)
      }
      copy (e) {
        return (
          super.copy(e),
          (this.scale = e.scale),
          (this.dashSize = e.dashSize),
          (this.gapSize = e.gapSize),
          this
        )
      }
    }
    Ep.prototype.isLineDashedMaterial = !0
    var Tp = Object.freeze({
      __proto__: null,
      ShadowMaterial: gp,
      SpriteMaterial: Ph,
      RawShaderMaterial: vp,
      ShaderMaterial: da,
      PointsMaterial: Mu,
      MeshPhysicalMaterial: _p,
      MeshStandardMaterial: yp,
      MeshPhongMaterial: xp,
      MeshToonMaterial: wp,
      MeshNormalMaterial: bp,
      MeshLambertMaterial: Mp,
      MeshDepthMaterial: lh,
      MeshDistanceMaterial: ch,
      MeshBasicMaterial: wr,
      MeshMatcapMaterial: Sp,
      LineDashedMaterial: Ep,
      LineBasicMaterial: du,
      Material: pr
    })
    const Ap = {
      arraySlice: function (e, t, n) {
        return Ap.isTypedArray(e)
          ? new e.constructor(e.subarray(t, void 0 !== n ? n : e.length))
          : e.slice(t, n)
      },
      convertArray: function (e, t, n) {
        return !e || (!n && e.constructor === t)
          ? e
          : 'number' === typeof t.BYTES_PER_ELEMENT
          ? new t(e)
          : Array.prototype.slice.call(e)
      },
      isTypedArray: function (e) {
        return ArrayBuffer.isView(e) && !(e instanceof DataView)
      },
      getKeyframeOrder: function (e) {
        function t (t, n) {
          return e[t] - e[n]
        }
        const n = e.length,
          i = new Array(n)
        for (let r = 0; r !== n; ++r) i[r] = r
        return i.sort(t), i
      },
      sortedArray: function (e, t, n) {
        const i = e.length,
          r = new e.constructor(i)
        for (let a = 0, s = 0; s !== i; ++a) {
          const i = n[a] * t
          for (let n = 0; n !== t; ++n) r[s++] = e[i + n]
        }
        return r
      },
      flattenJSON: function (e, t, n, i) {
        let r = 1,
          a = e[0]
        while (void 0 !== a && void 0 === a[i]) a = e[r++]
        if (void 0 === a) return
        let s = a[i]
        if (void 0 !== s)
          if (Array.isArray(s))
            do {
              ;(s = a[i]),
                void 0 !== s && (t.push(a.time), n.push.apply(n, s)),
                (a = e[r++])
            } while (void 0 !== a)
          else if (void 0 !== s.toArray)
            do {
              ;(s = a[i]),
                void 0 !== s && (t.push(a.time), s.toArray(n, n.length)),
                (a = e[r++])
            } while (void 0 !== a)
          else
            do {
              ;(s = a[i]),
                void 0 !== s && (t.push(a.time), n.push(s)),
                (a = e[r++])
            } while (void 0 !== a)
      },
      subclip: function (e, t, n, i, r = 30) {
        const a = e.clone()
        a.name = t
        const s = []
        for (let l = 0; l < a.tracks.length; ++l) {
          const e = a.tracks[l],
            t = e.getValueSize(),
            o = [],
            c = []
          for (let a = 0; a < e.times.length; ++a) {
            const s = e.times[a] * r
            if (!(s < n || s >= i)) {
              o.push(e.times[a])
              for (let n = 0; n < t; ++n) c.push(e.values[a * t + n])
            }
          }
          0 !== o.length &&
            ((e.times = Ap.convertArray(o, e.times.constructor)),
            (e.values = Ap.convertArray(c, e.values.constructor)),
            s.push(e))
        }
        a.tracks = s
        let o = 1 / 0
        for (let l = 0; l < a.tracks.length; ++l)
          o > a.tracks[l].times[0] && (o = a.tracks[l].times[0])
        for (let l = 0; l < a.tracks.length; ++l) a.tracks[l].shift(-1 * o)
        return a.resetDuration(), a
      },
      makeClipAdditive: function (e, t = 0, n = e, i = 30) {
        i <= 0 && (i = 30)
        const r = n.tracks.length,
          a = t / i
        for (let s = 0; s < r; ++s) {
          const t = n.tracks[s],
            i = t.ValueTypeName
          if ('bool' === i || 'string' === i) continue
          const r = e.tracks.find(function (e) {
            return e.name === t.name && e.ValueTypeName === i
          })
          if (void 0 === r) continue
          let o = 0
          const l = t.getValueSize()
          t.createInterpolant.isInterpolantFactoryMethodGLTFCubicSpline &&
            (o = l / 3)
          let c = 0
          const h = r.getValueSize()
          r.createInterpolant.isInterpolantFactoryMethodGLTFCubicSpline &&
            (c = h / 3)
          const u = t.times.length - 1
          let d
          if (a <= t.times[0]) {
            const e = o,
              n = l - o
            d = Ap.arraySlice(t.values, e, n)
          } else if (a >= t.times[u]) {
            const e = u * l + o,
              n = e + l - o
            d = Ap.arraySlice(t.values, e, n)
          } else {
            const e = t.createInterpolant(),
              n = o,
              i = l - o
            e.evaluate(a), (d = Ap.arraySlice(e.resultBuffer, n, i))
          }
          if ('quaternion' === i) {
            const e = new Kn()
              .fromArray(d)
              .normalize()
              .conjugate()
            e.toArray(d)
          }
          const p = r.times.length
          for (let e = 0; e < p; ++e) {
            const t = e * h + c
            if ('quaternion' === i)
              Kn.multiplyQuaternionsFlat(r.values, t, d, 0, r.values, t)
            else {
              const e = h - 2 * c
              for (let n = 0; n < e; ++n) r.values[t + n] -= d[n]
            }
          }
        }
        return (e.blendMode = hn), e
      }
    }
    class Rp {
      constructor (e, t, n, i) {
        ;(this.parameterPositions = e),
          (this._cachedIndex = 0),
          (this.resultBuffer = void 0 !== i ? i : new t.constructor(n)),
          (this.sampleValues = t),
          (this.valueSize = n),
          (this.settings = null),
          (this.DefaultSettings_ = {})
      }
      evaluate (e) {
        const t = this.parameterPositions
        let n = this._cachedIndex,
          i = t[n],
          r = t[n - 1]
        e: {
          t: {
            let a
            n: {
              i: if (!(e < i)) {
                for (let a = n + 2; ; ) {
                  if (void 0 === i) {
                    if (e < r) break i
                    return (
                      (n = t.length),
                      (this._cachedIndex = n),
                      this.afterEnd_(n - 1, e, r)
                    )
                  }
                  if (n === a) break
                  if (((r = i), (i = t[++n]), e < i)) break t
                }
                a = t.length
                break n
              }
              if (e >= r) break e
              {
                const s = t[1]
                e < s && ((n = 2), (r = s))
                for (let a = n - 2; ; ) {
                  if (void 0 === r)
                    return (this._cachedIndex = 0), this.beforeStart_(0, e, i)
                  if (n === a) break
                  if (((i = r), (r = t[--n - 1]), e >= r)) break t
                }
                ;(a = n), (n = 0)
              }
            }
            while (n < a) {
              const i = (n + a) >>> 1
              e < t[i] ? (a = i) : (n = i + 1)
            }
            if (((i = t[n]), (r = t[n - 1]), void 0 === r))
              return (this._cachedIndex = 0), this.beforeStart_(0, e, i)
            if (void 0 === i)
              return (
                (n = t.length),
                (this._cachedIndex = n),
                this.afterEnd_(n - 1, r, e)
              )
          }
          ;(this._cachedIndex = n), this.intervalChanged_(n, r, i)
        }
        return this.interpolate_(n, r, e, i)
      }
      getSettings_ () {
        return this.settings || this.DefaultSettings_
      }
      copySampleValue_ (e) {
        const t = this.resultBuffer,
          n = this.sampleValues,
          i = this.valueSize,
          r = e * i
        for (let a = 0; a !== i; ++a) t[a] = n[r + a]
        return t
      }
      interpolate_ () {
        throw new Error('call to abstract method')
      }
      intervalChanged_ () {}
    }
    ;(Rp.prototype.beforeStart_ = Rp.prototype.copySampleValue_),
      (Rp.prototype.afterEnd_ = Rp.prototype.copySampleValue_)
    class Lp extends Rp {
      constructor (e, t, n, i) {
        super(e, t, n, i),
          (this._weightPrev = -0),
          (this._offsetPrev = -0),
          (this._weightNext = -0),
          (this._offsetNext = -0),
          (this.DefaultSettings_ = { endingStart: sn, endingEnd: sn })
      }
      intervalChanged_ (e, t, n) {
        const i = this.parameterPositions
        let r = e - 2,
          a = e + 1,
          s = i[r],
          o = i[a]
        if (void 0 === s)
          switch (this.getSettings_().endingStart) {
            case on:
              ;(r = e), (s = 2 * t - n)
              break
            case ln:
              ;(r = i.length - 2), (s = t + i[r] - i[r + 1])
              break
            default:
              ;(r = e), (s = n)
          }
        if (void 0 === o)
          switch (this.getSettings_().endingEnd) {
            case on:
              ;(a = e), (o = 2 * n - t)
              break
            case ln:
              ;(a = 1), (o = n + i[1] - i[0])
              break
            default:
              ;(a = e - 1), (o = t)
          }
        const l = 0.5 * (n - t),
          c = this.valueSize
        ;(this._weightPrev = l / (t - s)),
          (this._weightNext = l / (o - n)),
          (this._offsetPrev = r * c),
          (this._offsetNext = a * c)
      }
      interpolate_ (e, t, n, i) {
        const r = this.resultBuffer,
          a = this.sampleValues,
          s = this.valueSize,
          o = e * s,
          l = o - s,
          c = this._offsetPrev,
          h = this._offsetNext,
          u = this._weightPrev,
          d = this._weightNext,
          p = (n - t) / (i - t),
          f = p * p,
          m = f * p,
          g = -u * m + 2 * u * f - u * p,
          v = (1 + u) * m + (-1.5 - 2 * u) * f + (-0.5 + u) * p + 1,
          y = (-1 - d) * m + (1.5 + d) * f + 0.5 * p,
          _ = d * m - d * f
        for (let x = 0; x !== s; ++x)
          r[x] = g * a[c + x] + v * a[l + x] + y * a[o + x] + _ * a[h + x]
        return r
      }
    }
    class Cp extends Rp {
      constructor (e, t, n, i) {
        super(e, t, n, i)
      }
      interpolate_ (e, t, n, i) {
        const r = this.resultBuffer,
          a = this.sampleValues,
          s = this.valueSize,
          o = e * s,
          l = o - s,
          c = (n - t) / (i - t),
          h = 1 - c
        for (let u = 0; u !== s; ++u) r[u] = a[l + u] * h + a[o + u] * c
        return r
      }
    }
    class Pp extends Rp {
      constructor (e, t, n, i) {
        super(e, t, n, i)
      }
      interpolate_ (e) {
        return this.copySampleValue_(e - 1)
      }
    }
    class Dp {
      constructor (e, t, n, i) {
        if (void 0 === e)
          throw new Error('THREE.KeyframeTrack: track name is undefined')
        if (void 0 === t || 0 === t.length)
          throw new Error(
            'THREE.KeyframeTrack: no keyframes in track named ' + e
          )
        ;(this.name = e),
          (this.times = Ap.convertArray(t, this.TimeBufferType)),
          (this.values = Ap.convertArray(n, this.ValueBufferType)),
          this.setInterpolation(i || this.DefaultInterpolation)
      }
      static toJSON (e) {
        const t = e.constructor
        let n
        if (t.toJSON !== this.toJSON) n = t.toJSON(e)
        else {
          n = {
            name: e.name,
            times: Ap.convertArray(e.times, Array),
            values: Ap.convertArray(e.values, Array)
          }
          const t = e.getInterpolation()
          t !== e.DefaultInterpolation && (n.interpolation = t)
        }
        return (n.type = e.ValueTypeName), n
      }
      InterpolantFactoryMethodDiscrete (e) {
        return new Pp(this.times, this.values, this.getValueSize(), e)
      }
      InterpolantFactoryMethodLinear (e) {
        return new Cp(this.times, this.values, this.getValueSize(), e)
      }
      InterpolantFactoryMethodSmooth (e) {
        return new Lp(this.times, this.values, this.getValueSize(), e)
      }
      setInterpolation (e) {
        let t
        switch (e) {
          case nn:
            t = this.InterpolantFactoryMethodDiscrete
            break
          case rn:
            t = this.InterpolantFactoryMethodLinear
            break
          case an:
            t = this.InterpolantFactoryMethodSmooth
            break
        }
        if (void 0 === t) {
          const t =
            'unsupported interpolation for ' +
            this.ValueTypeName +
            ' keyframe track named ' +
            this.name
          if (void 0 === this.createInterpolant) {
            if (e === this.DefaultInterpolation) throw new Error(t)
            this.setInterpolation(this.DefaultInterpolation)
          }
          return console.warn('THREE.KeyframeTrack:', t), this
        }
        return (this.createInterpolant = t), this
      }
      getInterpolation () {
        switch (this.createInterpolant) {
          case this.InterpolantFactoryMethodDiscrete:
            return nn
          case this.InterpolantFactoryMethodLinear:
            return rn
          case this.InterpolantFactoryMethodSmooth:
            return an
        }
      }
      getValueSize () {
        return this.values.length / this.times.length
      }
      shift (e) {
        if (0 !== e) {
          const t = this.times
          for (let n = 0, i = t.length; n !== i; ++n) t[n] += e
        }
        return this
      }
      scale (e) {
        if (1 !== e) {
          const t = this.times
          for (let n = 0, i = t.length; n !== i; ++n) t[n] *= e
        }
        return this
      }
      trim (e, t) {
        const n = this.times,
          i = n.length
        let r = 0,
          a = i - 1
        while (r !== i && n[r] < e) ++r
        while (-1 !== a && n[a] > t) --a
        if ((++a, 0 !== r || a !== i)) {
          r >= a && ((a = Math.max(a, 1)), (r = a - 1))
          const e = this.getValueSize()
          ;(this.times = Ap.arraySlice(n, r, a)),
            (this.values = Ap.arraySlice(this.values, r * e, a * e))
        }
        return this
      }
      validate () {
        let e = !0
        const t = this.getValueSize()
        t - Math.floor(t) !== 0 &&
          (console.error(
            'THREE.KeyframeTrack: Invalid value size in track.',
            this
          ),
          (e = !1))
        const n = this.times,
          i = this.values,
          r = n.length
        0 === r &&
          (console.error('THREE.KeyframeTrack: Track is empty.', this),
          (e = !1))
        let a = null
        for (let s = 0; s !== r; s++) {
          const t = n[s]
          if ('number' === typeof t && isNaN(t)) {
            console.error(
              'THREE.KeyframeTrack: Time is not a valid number.',
              this,
              s,
              t
            ),
              (e = !1)
            break
          }
          if (null !== a && a > t) {
            console.error(
              'THREE.KeyframeTrack: Out of order keys.',
              this,
              s,
              t,
              a
            ),
              (e = !1)
            break
          }
          a = t
        }
        if (void 0 !== i && Ap.isTypedArray(i))
          for (let s = 0, o = i.length; s !== o; ++s) {
            const t = i[s]
            if (isNaN(t)) {
              console.error(
                'THREE.KeyframeTrack: Value is not a valid number.',
                this,
                s,
                t
              ),
                (e = !1)
              break
            }
          }
        return e
      }
      optimize () {
        const e = Ap.arraySlice(this.times),
          t = Ap.arraySlice(this.values),
          n = this.getValueSize(),
          i = this.getInterpolation() === an,
          r = e.length - 1
        let a = 1
        for (let s = 1; s < r; ++s) {
          let r = !1
          const o = e[s],
            l = e[s + 1]
          if (o !== l && (1 !== s || o !== e[0]))
            if (i) r = !0
            else {
              const e = s * n,
                i = e - n,
                a = e + n
              for (let s = 0; s !== n; ++s) {
                const n = t[e + s]
                if (n !== t[i + s] || n !== t[a + s]) {
                  r = !0
                  break
                }
              }
            }
          if (r) {
            if (s !== a) {
              e[a] = e[s]
              const i = s * n,
                r = a * n
              for (let e = 0; e !== n; ++e) t[r + e] = t[i + e]
            }
            ++a
          }
        }
        if (r > 0) {
          e[a] = e[r]
          for (let e = r * n, i = a * n, s = 0; s !== n; ++s)
            t[i + s] = t[e + s]
          ++a
        }
        return (
          a !== e.length
            ? ((this.times = Ap.arraySlice(e, 0, a)),
              (this.values = Ap.arraySlice(t, 0, a * n)))
            : ((this.times = e), (this.values = t)),
          this
        )
      }
      clone () {
        const e = Ap.arraySlice(this.times, 0),
          t = Ap.arraySlice(this.values, 0),
          n = this.constructor,
          i = new n(this.name, e, t)
        return (i.createInterpolant = this.createInterpolant), i
      }
    }
    ;(Dp.prototype.TimeBufferType = Float32Array),
      (Dp.prototype.ValueBufferType = Float32Array),
      (Dp.prototype.DefaultInterpolation = rn)
    class Ip extends Dp {}
    ;(Ip.prototype.ValueTypeName = 'bool'),
      (Ip.prototype.ValueBufferType = Array),
      (Ip.prototype.DefaultInterpolation = nn),
      (Ip.prototype.InterpolantFactoryMethodLinear = void 0),
      (Ip.prototype.InterpolantFactoryMethodSmooth = void 0)
    class Np extends Dp {}
    Np.prototype.ValueTypeName = 'color'
    class Op extends Dp {}
    Op.prototype.ValueTypeName = 'number'
    class Fp extends Rp {
      constructor (e, t, n, i) {
        super(e, t, n, i)
      }
      interpolate_ (e, t, n, i) {
        const r = this.resultBuffer,
          a = this.sampleValues,
          s = this.valueSize,
          o = (n - t) / (i - t)
        let l = e * s
        for (let c = l + s; l !== c; l += 4)
          Kn.slerpFlat(r, 0, a, l - s, a, l, o)
        return r
      }
    }
    class Bp extends Dp {
      InterpolantFactoryMethodLinear (e) {
        return new Fp(this.times, this.values, this.getValueSize(), e)
      }
    }
    ;(Bp.prototype.ValueTypeName = 'quaternion'),
      (Bp.prototype.DefaultInterpolation = rn),
      (Bp.prototype.InterpolantFactoryMethodSmooth = void 0)
    class zp extends Dp {}
    ;(zp.prototype.ValueTypeName = 'string'),
      (zp.prototype.ValueBufferType = Array),
      (zp.prototype.DefaultInterpolation = nn),
      (zp.prototype.InterpolantFactoryMethodLinear = void 0),
      (zp.prototype.InterpolantFactoryMethodSmooth = void 0)
    class Up extends Dp {}
    Up.prototype.ValueTypeName = 'vector'
    class kp {
      constructor (e, t = -1, n, i = cn) {
        ;(this.name = e),
          (this.tracks = n),
          (this.duration = t),
          (this.blendMode = i),
          (this.uuid = In()),
          this.duration < 0 && this.resetDuration()
      }
      static parse (e) {
        const t = [],
          n = e.tracks,
          i = 1 / (e.fps || 1)
        for (let a = 0, s = n.length; a !== s; ++a) t.push(Wp(n[a]).scale(i))
        const r = new this(e.name, e.duration, t, e.blendMode)
        return (r.uuid = e.uuid), r
      }
      static toJSON (e) {
        const t = [],
          n = e.tracks,
          i = {
            name: e.name,
            duration: e.duration,
            tracks: t,
            uuid: e.uuid,
            blendMode: e.blendMode
          }
        for (let r = 0, a = n.length; r !== a; ++r) t.push(Dp.toJSON(n[r]))
        return i
      }
      static CreateFromMorphTargetSequence (e, t, n, i) {
        const r = t.length,
          a = []
        for (let s = 0; s < r; s++) {
          let e = [],
            o = []
          e.push((s + r - 1) % r, s, (s + 1) % r), o.push(0, 1, 0)
          const l = Ap.getKeyframeOrder(e)
          ;(e = Ap.sortedArray(e, 1, l)),
            (o = Ap.sortedArray(o, 1, l)),
            i || 0 !== e[0] || (e.push(r), o.push(o[0])),
            a.push(
              new Op('.morphTargetInfluences[' + t[s].name + ']', e, o).scale(
                1 / n
              )
            )
        }
        return new this(e, -1, a)
      }
      static findByName (e, t) {
        let n = e
        if (!Array.isArray(e)) {
          const t = e
          n = (t.geometry && t.geometry.animations) || t.animations
        }
        for (let i = 0; i < n.length; i++) if (n[i].name === t) return n[i]
        return null
      }
      static CreateClipsFromMorphTargetSequences (e, t, n) {
        const i = {},
          r = /^([\w-]*?)([\d]+)$/
        for (let s = 0, o = e.length; s < o; s++) {
          const t = e[s],
            n = t.name.match(r)
          if (n && n.length > 1) {
            const e = n[1]
            let r = i[e]
            r || (i[e] = r = []), r.push(t)
          }
        }
        const a = []
        for (const s in i)
          a.push(this.CreateFromMorphTargetSequence(s, i[s], t, n))
        return a
      }
      static parseAnimation (e, t) {
        if (!e)
          return (
            console.error(
              'THREE.AnimationClip: No animation in JSONLoader data.'
            ),
            null
          )
        const n = function (e, t, n, i, r) {
            if (0 !== n.length) {
              const a = [],
                s = []
              Ap.flattenJSON(n, a, s, i),
                0 !== a.length && r.push(new e(t, a, s))
            }
          },
          i = [],
          r = e.name || 'default',
          a = e.fps || 30,
          s = e.blendMode
        let o = e.length || -1
        const l = e.hierarchy || []
        for (let h = 0; h < l.length; h++) {
          const e = l[h].keys
          if (e && 0 !== e.length)
            if (e[0].morphTargets) {
              const t = {}
              let n
              for (n = 0; n < e.length; n++)
                if (e[n].morphTargets)
                  for (let i = 0; i < e[n].morphTargets.length; i++)
                    t[e[n].morphTargets[i]] = -1
              for (const r in t) {
                const t = [],
                  a = []
                for (let i = 0; i !== e[n].morphTargets.length; ++i) {
                  const i = e[n]
                  t.push(i.time), a.push(i.morphTarget === r ? 1 : 0)
                }
                i.push(new Op('.morphTargetInfluence[' + r + ']', t, a))
              }
              o = t.length * (a || 1)
            } else {
              const r = '.bones[' + t[h].name + ']'
              n(Up, r + '.position', e, 'pos', i),
                n(Bp, r + '.quaternion', e, 'rot', i),
                n(Up, r + '.scale', e, 'scl', i)
            }
        }
        if (0 === i.length) return null
        const c = new this(r, o, i, s)
        return c
      }
      resetDuration () {
        const e = this.tracks
        let t = 0
        for (let n = 0, i = e.length; n !== i; ++n) {
          const e = this.tracks[n]
          t = Math.max(t, e.times[e.times.length - 1])
        }
        return (this.duration = t), this
      }
      trim () {
        for (let e = 0; e < this.tracks.length; e++)
          this.tracks[e].trim(0, this.duration)
        return this
      }
      validate () {
        let e = !0
        for (let t = 0; t < this.tracks.length; t++)
          e = e && this.tracks[t].validate()
        return e
      }
      optimize () {
        for (let e = 0; e < this.tracks.length; e++) this.tracks[e].optimize()
        return this
      }
      clone () {
        const e = []
        for (let t = 0; t < this.tracks.length; t++)
          e.push(this.tracks[t].clone())
        return new this.constructor(this.name, this.duration, e, this.blendMode)
      }
      toJSON () {
        return this.constructor.toJSON(this)
      }
    }
    function Hp (e) {
      switch (e.toLowerCase()) {
        case 'scalar':
        case 'double':
        case 'float':
        case 'number':
        case 'integer':
          return Op
        case 'vector':
        case 'vector2':
        case 'vector3':
        case 'vector4':
          return Up
        case 'color':
          return Np
        case 'quaternion':
          return Bp
        case 'bool':
        case 'boolean':
          return Ip
        case 'string':
          return zp
      }
      throw new Error('THREE.KeyframeTrack: Unsupported typeName: ' + e)
    }
    function Wp (e) {
      if (void 0 === e.type)
        throw new Error(
          'THREE.KeyframeTrack: track type undefined, can not parse'
        )
      const t = Hp(e.type)
      if (void 0 === e.times) {
        const t = [],
          n = []
        Ap.flattenJSON(e.keys, t, n, 'value'), (e.times = t), (e.values = n)
      }
      return void 0 !== t.parse
        ? t.parse(e)
        : new t(e.name, e.times, e.values, e.interpolation)
    }
    const Vp = {
      enabled: !1,
      files: {},
      add: function (e, t) {
        !1 !== this.enabled && (this.files[e] = t)
      },
      get: function (e) {
        if (!1 !== this.enabled) return this.files[e]
      },
      remove: function (e) {
        delete this.files[e]
      },
      clear: function () {
        this.files = {}
      }
    }
    class Gp {
      constructor (e, t, n) {
        const i = this
        let r = !1,
          a = 0,
          s = 0,
          o = void 0
        const l = []
        ;(this.onStart = void 0),
          (this.onLoad = e),
          (this.onProgress = t),
          (this.onError = n),
          (this.itemStart = function (e) {
            s++,
              !1 === r && void 0 !== i.onStart && i.onStart(e, a, s),
              (r = !0)
          }),
          (this.itemEnd = function (e) {
            a++,
              void 0 !== i.onProgress && i.onProgress(e, a, s),
              a === s && ((r = !1), void 0 !== i.onLoad && i.onLoad())
          }),
          (this.itemError = function (e) {
            void 0 !== i.onError && i.onError(e)
          }),
          (this.resolveURL = function (e) {
            return o ? o(e) : e
          }),
          (this.setURLModifier = function (e) {
            return (o = e), this
          }),
          (this.addHandler = function (e, t) {
            return l.push(e, t), this
          }),
          (this.removeHandler = function (e) {
            const t = l.indexOf(e)
            return -1 !== t && l.splice(t, 2), this
          }),
          (this.getHandler = function (e) {
            for (let t = 0, n = l.length; t < n; t += 2) {
              const n = l[t],
                i = l[t + 1]
              if ((n.global && (n.lastIndex = 0), n.test(e))) return i
            }
            return null
          })
      }
    }
    const jp = new Gp()
    class qp {
      constructor (e) {
        ;(this.manager = void 0 !== e ? e : jp),
          (this.crossOrigin = 'anonymous'),
          (this.withCredentials = !1),
          (this.path = ''),
          (this.resourcePath = ''),
          (this.requestHeader = {})
      }
      load () {}
      loadAsync (e, t) {
        const n = this
        return new Promise(function (i, r) {
          n.load(e, i, t, r)
        })
      }
      parse () {}
      setCrossOrigin (e) {
        return (this.crossOrigin = e), this
      }
      setWithCredentials (e) {
        return (this.withCredentials = e), this
      }
      setPath (e) {
        return (this.path = e), this
      }
      setResourcePath (e) {
        return (this.resourcePath = e), this
      }
      setRequestHeader (e) {
        return (this.requestHeader = e), this
      }
    }
    const Yp = {}
    class Xp extends qp {
      constructor (e) {
        super(e)
      }
      load (e, t, n, i) {
        void 0 === e && (e = ''),
          void 0 !== this.path && (e = this.path + e),
          (e = this.manager.resolveURL(e))
        const r = this,
          a = Vp.get(e)
        if (void 0 !== a)
          return (
            r.manager.itemStart(e),
            setTimeout(function () {
              t && t(a), r.manager.itemEnd(e)
            }, 0),
            a
          )
        if (void 0 !== Yp[e])
          return void Yp[e].push({ onLoad: t, onProgress: n, onError: i })
        const s = /^data:(.*?)(;base64)?,(.*)$/,
          o = e.match(s)
        let l
        if (o) {
          const n = o[1],
            a = !!o[2]
          let s = o[3]
          ;(s = decodeURIComponent(s)), a && (s = atob(s))
          try {
            let i
            const a = (this.responseType || '').toLowerCase()
            switch (a) {
              case 'arraybuffer':
              case 'blob':
                const e = new Uint8Array(s.length)
                for (let n = 0; n < s.length; n++) e[n] = s.charCodeAt(n)
                i = 'blob' === a ? new Blob([e.buffer], { type: n }) : e.buffer
                break
              case 'document':
                const t = new DOMParser()
                i = t.parseFromString(s, n)
                break
              case 'json':
                i = JSON.parse(s)
                break
              default:
                i = s
                break
            }
            setTimeout(function () {
              t && t(i), r.manager.itemEnd(e)
            }, 0)
          } catch (m) {
            setTimeout(function () {
              i && i(m), r.manager.itemError(e), r.manager.itemEnd(e)
            }, 0)
          }
        } else {
          ;(Yp[e] = []),
            Yp[e].push({ onLoad: t, onProgress: n, onError: i }),
            (l = new XMLHttpRequest()),
            l.open('GET', e, !0),
            l.addEventListener(
              'load',
              function (t) {
                const n = this.response,
                  i = Yp[e]
                if ((delete Yp[e], 200 === this.status || 0 === this.status)) {
                  0 === this.status &&
                    console.warn('THREE.FileLoader: HTTP Status 0 received.'),
                    Vp.add(e, n)
                  for (let e = 0, t = i.length; e < t; e++) {
                    const t = i[e]
                    t.onLoad && t.onLoad(n)
                  }
                  r.manager.itemEnd(e)
                } else {
                  for (let e = 0, n = i.length; e < n; e++) {
                    const n = i[e]
                    n.onError && n.onError(t)
                  }
                  r.manager.itemError(e), r.manager.itemEnd(e)
                }
              },
              !1
            ),
            l.addEventListener(
              'progress',
              function (t) {
                const n = Yp[e]
                for (let e = 0, i = n.length; e < i; e++) {
                  const i = n[e]
                  i.onProgress && i.onProgress(t)
                }
              },
              !1
            ),
            l.addEventListener(
              'error',
              function (t) {
                const n = Yp[e]
                delete Yp[e]
                for (let e = 0, i = n.length; e < i; e++) {
                  const i = n[e]
                  i.onError && i.onError(t)
                }
                r.manager.itemError(e), r.manager.itemEnd(e)
              },
              !1
            ),
            l.addEventListener(
              'abort',
              function (t) {
                const n = Yp[e]
                delete Yp[e]
                for (let e = 0, i = n.length; e < i; e++) {
                  const i = n[e]
                  i.onError && i.onError(t)
                }
                r.manager.itemError(e), r.manager.itemEnd(e)
              },
              !1
            ),
            void 0 !== this.responseType &&
              (l.responseType = this.responseType),
            void 0 !== this.withCredentials &&
              (l.withCredentials = this.withCredentials),
            l.overrideMimeType &&
              l.overrideMimeType(
                void 0 !== this.mimeType ? this.mimeType : 'text/plain'
              )
          for (const e in this.requestHeader)
            l.setRequestHeader(e, this.requestHeader[e])
          l.send(null)
        }
        return r.manager.itemStart(e), l
      }
      setResponseType (e) {
        return (this.responseType = e), this
      }
      setMimeType (e) {
        return (this.mimeType = e), this
      }
    }
    class Jp extends qp {
      constructor (e) {
        super(e)
      }
      load (e, t, n, i) {
        void 0 !== this.path && (e = this.path + e),
          (e = this.manager.resolveURL(e))
        const r = this,
          a = Vp.get(e)
        if (void 0 !== a)
          return (
            r.manager.itemStart(e),
            setTimeout(function () {
              t && t(a), r.manager.itemEnd(e)
            }, 0),
            a
          )
        const s = document.createElementNS(
          'http://www.w3.org/1999/xhtml',
          'img'
        )
        function o () {
          s.removeEventListener('load', o, !1),
            s.removeEventListener('error', l, !1),
            Vp.add(e, this),
            t && t(this),
            r.manager.itemEnd(e)
        }
        function l (t) {
          s.removeEventListener('load', o, !1),
            s.removeEventListener('error', l, !1),
            i && i(t),
            r.manager.itemError(e),
            r.manager.itemEnd(e)
        }
        return (
          s.addEventListener('load', o, !1),
          s.addEventListener('error', l, !1),
          'data:' !== e.substr(0, 5) &&
            void 0 !== this.crossOrigin &&
            (s.crossOrigin = this.crossOrigin),
          r.manager.itemStart(e),
          (s.src = e),
          s
        )
      }
    }
    class Zp extends qp {
      constructor (e) {
        super(e)
      }
      load (e, t, n, i) {
        const r = new ya(),
          a = new Jp(this.manager)
        a.setCrossOrigin(this.crossOrigin), a.setPath(this.path)
        let s = 0
        function o (n) {
          a.load(
            e[n],
            function (e) {
              ;(r.images[n] = e),
                s++,
                6 === s && ((r.needsUpdate = !0), t && t(r))
            },
            void 0,
            i
          )
        }
        for (let l = 0; l < e.length; ++l) o(l)
        return r
      }
    }
    class Kp extends qp {
      constructor (e) {
        super(e)
      }
      load (e, t, n, i) {
        const r = new jn(),
          a = new Jp(this.manager)
        return (
          a.setCrossOrigin(this.crossOrigin),
          a.setPath(this.path),
          a.load(
            e,
            function (n) {
              r.image = n
              const i =
                e.search(/\.jpe?g($|\?)/i) > 0 ||
                0 === e.search(/^data\:image\/jpeg/)
              ;(r.format = i ? tt : nt),
                (r.needsUpdate = !0),
                void 0 !== t && t(r)
            },
            n,
            i
          ),
          r
        )
      }
    }
    class Qp extends Gu {
      constructor () {
        super(),
          (this.type = 'CurvePath'),
          (this.curves = []),
          (this.autoClose = !1)
      }
      add (e) {
        this.curves.push(e)
      }
      closePath () {
        const e = this.curves[0].getPoint(0),
          t = this.curves[this.curves.length - 1].getPoint(1)
        e.equals(t) || this.curves.push(new ud(t, e))
      }
      getPoint (e) {
        const t = e * this.getLength(),
          n = this.getCurveLengths()
        let i = 0
        while (i < n.length) {
          if (n[i] >= t) {
            const e = n[i] - t,
              r = this.curves[i],
              a = r.getLength(),
              s = 0 === a ? 0 : 1 - e / a
            return r.getPointAt(s)
          }
          i++
        }
        return null
      }
      getLength () {
        const e = this.getCurveLengths()
        return e[e.length - 1]
      }
      updateArcLengths () {
        ;(this.needsUpdate = !0),
          (this.cacheLengths = null),
          this.getCurveLengths()
      }
      getCurveLengths () {
        if (
          this.cacheLengths &&
          this.cacheLengths.length === this.curves.length
        )
          return this.cacheLengths
        const e = []
        let t = 0
        for (let n = 0, i = this.curves.length; n < i; n++)
          (t += this.curves[n].getLength()), e.push(t)
        return (this.cacheLengths = e), e
      }
      getSpacedPoints (e = 40) {
        const t = []
        for (let n = 0; n <= e; n++) t.push(this.getPoint(n / e))
        return this.autoClose && t.push(t[0]), t
      }
      getPoints (e = 12) {
        const t = []
        let n
        for (let i = 0, r = this.curves; i < r.length; i++) {
          const a = r[i],
            s =
              a && a.isEllipseCurve
                ? 2 * e
                : a && (a.isLineCurve || a.isLineCurve3)
                ? 1
                : a && a.isSplineCurve
                ? e * a.points.length
                : e,
            o = a.getPoints(s)
          for (let e = 0; e < o.length; e++) {
            const i = o[e]
            ;(n && n.equals(i)) || (t.push(i), (n = i))
          }
        }
        return (
          this.autoClose &&
            t.length > 1 &&
            !t[t.length - 1].equals(t[0]) &&
            t.push(t[0]),
          t
        )
      }
      copy (e) {
        super.copy(e), (this.curves = [])
        for (let t = 0, n = e.curves.length; t < n; t++) {
          const n = e.curves[t]
          this.curves.push(n.clone())
        }
        return (this.autoClose = e.autoClose), this
      }
      toJSON () {
        const e = super.toJSON()
        ;(e.autoClose = this.autoClose), (e.curves = [])
        for (let t = 0, n = this.curves.length; t < n; t++) {
          const n = this.curves[t]
          e.curves.push(n.toJSON())
        }
        return e
      }
      fromJSON (e) {
        super.fromJSON(e), (this.autoClose = e.autoClose), (this.curves = [])
        for (let t = 0, n = e.curves.length; t < n; t++) {
          const n = e.curves[t]
          this.curves.push(new gd[n.type]().fromJSON(n))
        }
        return this
      }
    }
    class $p extends Qp {
      constructor (e) {
        super(),
          (this.type = 'Path'),
          (this.currentPoint = new kn()),
          e && this.setFromPoints(e)
      }
      setFromPoints (e) {
        this.moveTo(e[0].x, e[0].y)
        for (let t = 1, n = e.length; t < n; t++) this.lineTo(e[t].x, e[t].y)
        return this
      }
      moveTo (e, t) {
        return this.currentPoint.set(e, t), this
      }
      lineTo (e, t) {
        const n = new ud(this.currentPoint.clone(), new kn(e, t))
        return this.curves.push(n), this.currentPoint.set(e, t), this
      }
      quadraticCurveTo (e, t, n, i) {
        const r = new pd(this.currentPoint.clone(), new kn(e, t), new kn(n, i))
        return this.curves.push(r), this.currentPoint.set(n, i), this
      }
      bezierCurveTo (e, t, n, i, r, a) {
        const s = new cd(
          this.currentPoint.clone(),
          new kn(e, t),
          new kn(n, i),
          new kn(r, a)
        )
        return this.curves.push(s), this.currentPoint.set(r, a), this
      }
      splineThru (e) {
        const t = [this.currentPoint.clone()].concat(e),
          n = new md(t)
        return (
          this.curves.push(n), this.currentPoint.copy(e[e.length - 1]), this
        )
      }
      arc (e, t, n, i, r, a) {
        const s = this.currentPoint.x,
          o = this.currentPoint.y
        return this.absarc(e + s, t + o, n, i, r, a), this
      }
      absarc (e, t, n, i, r, a) {
        return this.absellipse(e, t, n, n, i, r, a), this
      }
      ellipse (e, t, n, i, r, a, s, o) {
        const l = this.currentPoint.x,
          c = this.currentPoint.y
        return this.absellipse(e + l, t + c, n, i, r, a, s, o), this
      }
      absellipse (e, t, n, i, r, a, s, o) {
        const l = new ju(e, t, n, i, r, a, s, o)
        if (this.curves.length > 0) {
          const e = l.getPoint(0)
          e.equals(this.currentPoint) || this.lineTo(e.x, e.y)
        }
        this.curves.push(l)
        const c = l.getPoint(1)
        return this.currentPoint.copy(c), this
      }
      copy (e) {
        return super.copy(e), this.currentPoint.copy(e.currentPoint), this
      }
      toJSON () {
        const e = super.toJSON()
        return (e.currentPoint = this.currentPoint.toArray()), e
      }
      fromJSON (e) {
        return (
          super.fromJSON(e), this.currentPoint.fromArray(e.currentPoint), this
        )
      }
    }
    class ef extends $p {
      constructor (e) {
        super(e), (this.uuid = In()), (this.type = 'Shape'), (this.holes = [])
      }
      getPointsHoles (e) {
        const t = []
        for (let n = 0, i = this.holes.length; n < i; n++)
          t[n] = this.holes[n].getPoints(e)
        return t
      }
      extractPoints (e) {
        return { shape: this.getPoints(e), holes: this.getPointsHoles(e) }
      }
      copy (e) {
        super.copy(e), (this.holes = [])
        for (let t = 0, n = e.holes.length; t < n; t++) {
          const n = e.holes[t]
          this.holes.push(n.clone())
        }
        return this
      }
      toJSON () {
        const e = super.toJSON()
        ;(e.uuid = this.uuid), (e.holes = [])
        for (let t = 0, n = this.holes.length; t < n; t++) {
          const n = this.holes[t]
          e.holes.push(n.toJSON())
        }
        return e
      }
      fromJSON (e) {
        super.fromJSON(e), (this.uuid = e.uuid), (this.holes = [])
        for (let t = 0, n = e.holes.length; t < n; t++) {
          const n = e.holes[t]
          this.holes.push(new $p().fromJSON(n))
        }
        return this
      }
    }
    class tf extends er {
      constructor (e, t = 1) {
        super(),
          (this.type = 'Light'),
          (this.color = new xr(e)),
          (this.intensity = t)
      }
      dispose () {}
      copy (e) {
        return (
          super.copy(e),
          this.color.copy(e.color),
          (this.intensity = e.intensity),
          this
        )
      }
      toJSON (e) {
        const t = super.toJSON(e)
        return (
          (t.object.color = this.color.getHex()),
          (t.object.intensity = this.intensity),
          void 0 !== this.groundColor &&
            (t.object.groundColor = this.groundColor.getHex()),
          void 0 !== this.distance && (t.object.distance = this.distance),
          void 0 !== this.angle && (t.object.angle = this.angle),
          void 0 !== this.decay && (t.object.decay = this.decay),
          void 0 !== this.penumbra && (t.object.penumbra = this.penumbra),
          void 0 !== this.shadow && (t.object.shadow = this.shadow.toJSON()),
          t
        )
      }
    }
    tf.prototype.isLight = !0
    class nf extends tf {
      constructor (e, t, n) {
        super(e, n),
          (this.type = 'HemisphereLight'),
          this.position.copy(er.DefaultUp),
          this.updateMatrix(),
          (this.groundColor = new xr(t))
      }
      copy (e) {
        return (
          tf.prototype.copy.call(this, e),
          this.groundColor.copy(e.groundColor),
          this
        )
      }
    }
    nf.prototype.isHemisphereLight = !0
    const rf = new Li(),
      af = new Qn(),
      sf = new Qn()
    class of {
      constructor (e) {
        ;(this.camera = e),
          (this.bias = 0),
          (this.normalBias = 0),
          (this.radius = 1),
          (this.mapSize = new kn(512, 512)),
          (this.map = null),
          (this.mapPass = null),
          (this.matrix = new Li()),
          (this.autoUpdate = !0),
          (this.needsUpdate = !1),
          (this._frustum = new Ta()),
          (this._frameExtents = new kn(1, 1)),
          (this._viewportCount = 1),
          (this._viewports = [new Yn(0, 0, 1, 1)])
      }
      getViewportCount () {
        return this._viewportCount
      }
      getFrustum () {
        return this._frustum
      }
      updateMatrices (e) {
        const t = this.camera,
          n = this.matrix
        af.setFromMatrixPosition(e.matrixWorld),
          t.position.copy(af),
          sf.setFromMatrixPosition(e.target.matrixWorld),
          t.lookAt(sf),
          t.updateMatrixWorld(),
          rf.multiplyMatrices(t.projectionMatrix, t.matrixWorldInverse),
          this._frustum.setFromProjectionMatrix(rf),
          n.set(0.5, 0, 0, 0.5, 0, 0.5, 0, 0.5, 0, 0, 0.5, 0.5, 0, 0, 0, 1),
          n.multiply(t.projectionMatrix),
          n.multiply(t.matrixWorldInverse)
      }
      getViewport (e) {
        return this._viewports[e]
      }
      getFrameExtents () {
        return this._frameExtents
      }
      dispose () {
        this.map && this.map.dispose(), this.mapPass && this.mapPass.dispose()
      }
      copy (e) {
        return (
          (this.camera = e.camera.clone()),
          (this.bias = e.bias),
          (this.radius = e.radius),
          this.mapSize.copy(e.mapSize),
          this
        )
      }
      clone () {
        return new this.constructor().copy(this)
      }
      toJSON () {
        const e = {}
        return (
          0 !== this.bias && (e.bias = this.bias),
          0 !== this.normalBias && (e.normalBias = this.normalBias),
          1 !== this.radius && (e.radius = this.radius),
          (512 === this.mapSize.x && 512 === this.mapSize.y) ||
            (e.mapSize = this.mapSize.toArray()),
          (e.camera = this.camera.toJSON(!1).object),
          delete e.camera.matrix,
          e
        )
      }
    }
    class lf extends of {
      constructor () {
        super(new fa(50, 1, 0.5, 500)), (this.focus = 1)
      }
      updateMatrices (e) {
        const t = this.camera,
          n = 2 * Dn * e.angle * this.focus,
          i = this.mapSize.width / this.mapSize.height,
          r = e.distance || t.far
        ;(n === t.fov && i === t.aspect && r === t.far) ||
          ((t.fov = n),
          (t.aspect = i),
          (t.far = r),
          t.updateProjectionMatrix()),
          super.updateMatrices(e)
      }
      copy (e) {
        return super.copy(e), (this.focus = e.focus), this
      }
    }
    lf.prototype.isSpotLightShadow = !0
    class cf extends tf {
      constructor (e, t, n = 0, i = Math.PI / 3, r = 0, a = 1) {
        super(e, t),
          (this.type = 'SpotLight'),
          this.position.copy(er.DefaultUp),
          this.updateMatrix(),
          (this.target = new er()),
          (this.distance = n),
          (this.angle = i),
          (this.penumbra = r),
          (this.decay = a),
          (this.shadow = new lf())
      }
      get power () {
        return this.intensity * Math.PI
      }
      set power (e) {
        this.intensity = e / Math.PI
      }
      dispose () {
        this.shadow.dispose()
      }
      copy (e) {
        return (
          super.copy(e),
          (this.distance = e.distance),
          (this.angle = e.angle),
          (this.penumbra = e.penumbra),
          (this.decay = e.decay),
          (this.target = e.target.clone()),
          (this.shadow = e.shadow.clone()),
          this
        )
      }
    }
    cf.prototype.isSpotLight = !0
    const hf = new Li(),
      uf = new Qn(),
      df = new Qn()
    class pf extends of {
      constructor () {
        super(new fa(90, 1, 0.5, 500)),
          (this._frameExtents = new kn(4, 2)),
          (this._viewportCount = 6),
          (this._viewports = [
            new Yn(2, 1, 1, 1),
            new Yn(0, 1, 1, 1),
            new Yn(3, 1, 1, 1),
            new Yn(1, 1, 1, 1),
            new Yn(3, 0, 1, 1),
            new Yn(1, 0, 1, 1)
          ]),
          (this._cubeDirections = [
            new Qn(1, 0, 0),
            new Qn(-1, 0, 0),
            new Qn(0, 0, 1),
            new Qn(0, 0, -1),
            new Qn(0, 1, 0),
            new Qn(0, -1, 0)
          ]),
          (this._cubeUps = [
            new Qn(0, 1, 0),
            new Qn(0, 1, 0),
            new Qn(0, 1, 0),
            new Qn(0, 1, 0),
            new Qn(0, 0, 1),
            new Qn(0, 0, -1)
          ])
      }
      updateMatrices (e, t = 0) {
        const n = this.camera,
          i = this.matrix,
          r = e.distance || n.far
        r !== n.far && ((n.far = r), n.updateProjectionMatrix()),
          uf.setFromMatrixPosition(e.matrixWorld),
          n.position.copy(uf),
          df.copy(n.position),
          df.add(this._cubeDirections[t]),
          n.up.copy(this._cubeUps[t]),
          n.lookAt(df),
          n.updateMatrixWorld(),
          i.makeTranslation(-uf.x, -uf.y, -uf.z),
          hf.multiplyMatrices(n.projectionMatrix, n.matrixWorldInverse),
          this._frustum.setFromProjectionMatrix(hf)
      }
    }
    pf.prototype.isPointLightShadow = !0
    class ff extends tf {
      constructor (e, t, n = 0, i = 1) {
        super(e, t),
          (this.type = 'PointLight'),
          (this.distance = n),
          (this.decay = i),
          (this.shadow = new pf())
      }
      get power () {
        return 4 * this.intensity * Math.PI
      }
      set power (e) {
        this.intensity = e / (4 * Math.PI)
      }
      dispose () {
        this.shadow.dispose()
      }
      copy (e) {
        return (
          super.copy(e),
          (this.distance = e.distance),
          (this.decay = e.decay),
          (this.shadow = e.shadow.clone()),
          this
        )
      }
    }
    ff.prototype.isPointLight = !0
    class mf extends pa {
      constructor (e = -1, t = 1, n = 1, i = -1, r = 0.1, a = 2e3) {
        super(),
          (this.type = 'OrthographicCamera'),
          (this.zoom = 1),
          (this.view = null),
          (this.left = e),
          (this.right = t),
          (this.top = n),
          (this.bottom = i),
          (this.near = r),
          (this.far = a),
          this.updateProjectionMatrix()
      }
      copy (e, t) {
        return (
          super.copy(e, t),
          (this.left = e.left),
          (this.right = e.right),
          (this.top = e.top),
          (this.bottom = e.bottom),
          (this.near = e.near),
          (this.far = e.far),
          (this.zoom = e.zoom),
          (this.view = null === e.view ? null : Object.assign({}, e.view)),
          this
        )
      }
      setViewOffset (e, t, n, i, r, a) {
        null === this.view &&
          (this.view = {
            enabled: !0,
            fullWidth: 1,
            fullHeight: 1,
            offsetX: 0,
            offsetY: 0,
            width: 1,
            height: 1
          }),
          (this.view.enabled = !0),
          (this.view.fullWidth = e),
          (this.view.fullHeight = t),
          (this.view.offsetX = n),
          (this.view.offsetY = i),
          (this.view.width = r),
          (this.view.height = a),
          this.updateProjectionMatrix()
      }
      clearViewOffset () {
        null !== this.view && (this.view.enabled = !1),
          this.updateProjectionMatrix()
      }
      updateProjectionMatrix () {
        const e = (this.right - this.left) / (2 * this.zoom),
          t = (this.top - this.bottom) / (2 * this.zoom),
          n = (this.right + this.left) / 2,
          i = (this.top + this.bottom) / 2
        let r = n - e,
          a = n + e,
          s = i + t,
          o = i - t
        if (null !== this.view && this.view.enabled) {
          const e = (this.right - this.left) / this.view.fullWidth / this.zoom,
            t = (this.top - this.bottom) / this.view.fullHeight / this.zoom
          ;(r += e * this.view.offsetX),
            (a = r + e * this.view.width),
            (s -= t * this.view.offsetY),
            (o = s - t * this.view.height)
        }
        this.projectionMatrix.makeOrthographic(r, a, s, o, this.near, this.far),
          this.projectionMatrixInverse.copy(this.projectionMatrix).invert()
      }
      toJSON (e) {
        const t = super.toJSON(e)
        return (
          (t.object.zoom = this.zoom),
          (t.object.left = this.left),
          (t.object.right = this.right),
          (t.object.top = this.top),
          (t.object.bottom = this.bottom),
          (t.object.near = this.near),
          (t.object.far = this.far),
          null !== this.view && (t.object.view = Object.assign({}, this.view)),
          t
        )
      }
    }
    mf.prototype.isOrthographicCamera = !0
    class gf extends of {
      constructor () {
        super(new mf(-5, 5, 5, -5, 0.5, 500))
      }
    }
    gf.prototype.isDirectionalLightShadow = !0
    class vf extends tf {
      constructor (e, t) {
        super(e, t),
          (this.type = 'DirectionalLight'),
          this.position.copy(er.DefaultUp),
          this.updateMatrix(),
          (this.target = new er()),
          (this.shadow = new gf())
      }
      dispose () {
        this.shadow.dispose()
      }
      copy (e) {
        return (
          super.copy(e),
          (this.target = e.target.clone()),
          (this.shadow = e.shadow.clone()),
          this
        )
      }
    }
    vf.prototype.isDirectionalLight = !0
    class yf extends tf {
      constructor (e, t) {
        super(e, t), (this.type = 'AmbientLight')
      }
    }
    yf.prototype.isAmbientLight = !0
    class _f extends tf {
      constructor (e, t, n = 10, i = 10) {
        super(e, t),
          (this.type = 'RectAreaLight'),
          (this.width = n),
          (this.height = i)
      }
      copy (e) {
        return (
          super.copy(e), (this.width = e.width), (this.height = e.height), this
        )
      }
      toJSON (e) {
        const t = super.toJSON(e)
        return (t.object.width = this.width), (t.object.height = this.height), t
      }
    }
    _f.prototype.isRectAreaLight = !0
    class xf {
      constructor () {
        this.coefficients = []
        for (let e = 0; e < 9; e++) this.coefficients.push(new Qn())
      }
      set (e) {
        for (let t = 0; t < 9; t++) this.coefficients[t].copy(e[t])
        return this
      }
      zero () {
        for (let e = 0; e < 9; e++) this.coefficients[e].set(0, 0, 0)
        return this
      }
      getAt (e, t) {
        const n = e.x,
          i = e.y,
          r = e.z,
          a = this.coefficients
        return (
          t.copy(a[0]).multiplyScalar(0.282095),
          t.addScaledVector(a[1], 0.488603 * i),
          t.addScaledVector(a[2], 0.488603 * r),
          t.addScaledVector(a[3], 0.488603 * n),
          t.addScaledVector(a[4], n * i * 1.092548),
          t.addScaledVector(a[5], i * r * 1.092548),
          t.addScaledVector(a[6], 0.315392 * (3 * r * r - 1)),
          t.addScaledVector(a[7], n * r * 1.092548),
          t.addScaledVector(a[8], 0.546274 * (n * n - i * i)),
          t
        )
      }
      getIrradianceAt (e, t) {
        const n = e.x,
          i = e.y,
          r = e.z,
          a = this.coefficients
        return (
          t.copy(a[0]).multiplyScalar(0.886227),
          t.addScaledVector(a[1], 1.023328 * i),
          t.addScaledVector(a[2], 1.023328 * r),
          t.addScaledVector(a[3], 1.023328 * n),
          t.addScaledVector(a[4], 0.858086 * n * i),
          t.addScaledVector(a[5], 0.858086 * i * r),
          t.addScaledVector(a[6], 0.743125 * r * r - 0.247708),
          t.addScaledVector(a[7], 0.858086 * n * r),
          t.addScaledVector(a[8], 0.429043 * (n * n - i * i)),
          t
        )
      }
      add (e) {
        for (let t = 0; t < 9; t++) this.coefficients[t].add(e.coefficients[t])
        return this
      }
      addScaledSH (e, t) {
        for (let n = 0; n < 9; n++)
          this.coefficients[n].addScaledVector(e.coefficients[n], t)
        return this
      }
      scale (e) {
        for (let t = 0; t < 9; t++) this.coefficients[t].multiplyScalar(e)
        return this
      }
      lerp (e, t) {
        for (let n = 0; n < 9; n++)
          this.coefficients[n].lerp(e.coefficients[n], t)
        return this
      }
      equals (e) {
        for (let t = 0; t < 9; t++)
          if (!this.coefficients[t].equals(e.coefficients[t])) return !1
        return !0
      }
      copy (e) {
        return this.set(e.coefficients)
      }
      clone () {
        return new this.constructor().copy(this)
      }
      fromArray (e, t = 0) {
        const n = this.coefficients
        for (let i = 0; i < 9; i++) n[i].fromArray(e, t + 3 * i)
        return this
      }
      toArray (e = [], t = 0) {
        const n = this.coefficients
        for (let i = 0; i < 9; i++) n[i].toArray(e, t + 3 * i)
        return e
      }
      static getBasisAt (e, t) {
        const n = e.x,
          i = e.y,
          r = e.z
        ;(t[0] = 0.282095),
          (t[1] = 0.488603 * i),
          (t[2] = 0.488603 * r),
          (t[3] = 0.488603 * n),
          (t[4] = 1.092548 * n * i),
          (t[5] = 1.092548 * i * r),
          (t[6] = 0.315392 * (3 * r * r - 1)),
          (t[7] = 1.092548 * n * r),
          (t[8] = 0.546274 * (n * n - i * i))
      }
    }
    xf.prototype.isSphericalHarmonics3 = !0
    class wf extends tf {
      constructor (e = new xf(), t = 1) {
        super(void 0, t), (this.sh = e)
      }
      copy (e) {
        return super.copy(e), this.sh.copy(e.sh), this
      }
      fromJSON (e) {
        return (this.intensity = e.intensity), this.sh.fromArray(e.sh), this
      }
      toJSON (e) {
        const t = super.toJSON(e)
        return (t.object.sh = this.sh.toArray()), t
      }
    }
    wf.prototype.isLightProbe = !0
    class bf extends qp {
      constructor (e) {
        super(e), (this.textures = {})
      }
      load (e, t, n, i) {
        const r = this,
          a = new Xp(r.manager)
        a.setPath(r.path),
          a.setRequestHeader(r.requestHeader),
          a.setWithCredentials(r.withCredentials),
          a.load(
            e,
            function (n) {
              try {
                t(r.parse(JSON.parse(n)))
              } catch (a) {
                i ? i(a) : console.error(a), r.manager.itemError(e)
              }
            },
            n,
            i
          )
      }
      parse (e) {
        const t = this.textures
        function n (e) {
          return (
            void 0 === t[e] &&
              console.warn('THREE.MaterialLoader: Undefined texture', e),
            t[e]
          )
        }
        const i = new Tp[e.type]()
        if (
          (void 0 !== e.uuid && (i.uuid = e.uuid),
          void 0 !== e.name && (i.name = e.name),
          void 0 !== e.color && void 0 !== i.color && i.color.setHex(e.color),
          void 0 !== e.roughness && (i.roughness = e.roughness),
          void 0 !== e.metalness && (i.metalness = e.metalness),
          void 0 !== e.sheen && (i.sheen = new xr().setHex(e.sheen)),
          void 0 !== e.emissive &&
            void 0 !== i.emissive &&
            i.emissive.setHex(e.emissive),
          void 0 !== e.specular &&
            void 0 !== i.specular &&
            i.specular.setHex(e.specular),
          void 0 !== e.shininess && (i.shininess = e.shininess),
          void 0 !== e.clearcoat && (i.clearcoat = e.clearcoat),
          void 0 !== e.clearcoatRoughness &&
            (i.clearcoatRoughness = e.clearcoatRoughness),
          void 0 !== e.transmission && (i.transmission = e.transmission),
          void 0 !== e.thickness && (i.thickness = e.thickness),
          void 0 !== e.attenuationDistance &&
            (i.attenuationDistance = e.attenuationDistance),
          void 0 !== e.attenuationColor &&
            void 0 !== i.attenuationColor &&
            i.attenuationColor.setHex(e.attenuationColor),
          void 0 !== e.fog && (i.fog = e.fog),
          void 0 !== e.flatShading && (i.flatShading = e.flatShading),
          void 0 !== e.blending && (i.blending = e.blending),
          void 0 !== e.combine && (i.combine = e.combine),
          void 0 !== e.side && (i.side = e.side),
          void 0 !== e.shadowSide && (i.shadowSide = e.shadowSide),
          void 0 !== e.opacity && (i.opacity = e.opacity),
          void 0 !== e.transparent && (i.transparent = e.transparent),
          void 0 !== e.alphaTest && (i.alphaTest = e.alphaTest),
          void 0 !== e.depthTest && (i.depthTest = e.depthTest),
          void 0 !== e.depthWrite && (i.depthWrite = e.depthWrite),
          void 0 !== e.colorWrite && (i.colorWrite = e.colorWrite),
          void 0 !== e.stencilWrite && (i.stencilWrite = e.stencilWrite),
          void 0 !== e.stencilWriteMask &&
            (i.stencilWriteMask = e.stencilWriteMask),
          void 0 !== e.stencilFunc && (i.stencilFunc = e.stencilFunc),
          void 0 !== e.stencilRef && (i.stencilRef = e.stencilRef),
          void 0 !== e.stencilFuncMask &&
            (i.stencilFuncMask = e.stencilFuncMask),
          void 0 !== e.stencilFail && (i.stencilFail = e.stencilFail),
          void 0 !== e.stencilZFail && (i.stencilZFail = e.stencilZFail),
          void 0 !== e.stencilZPass && (i.stencilZPass = e.stencilZPass),
          void 0 !== e.wireframe && (i.wireframe = e.wireframe),
          void 0 !== e.wireframeLinewidth &&
            (i.wireframeLinewidth = e.wireframeLinewidth),
          void 0 !== e.wireframeLinecap &&
            (i.wireframeLinecap = e.wireframeLinecap),
          void 0 !== e.wireframeLinejoin &&
            (i.wireframeLinejoin = e.wireframeLinejoin),
          void 0 !== e.rotation && (i.rotation = e.rotation),
          1 !== e.linewidth && (i.linewidth = e.linewidth),
          void 0 !== e.dashSize && (i.dashSize = e.dashSize),
          void 0 !== e.gapSize && (i.gapSize = e.gapSize),
          void 0 !== e.scale && (i.scale = e.scale),
          void 0 !== e.polygonOffset && (i.polygonOffset = e.polygonOffset),
          void 0 !== e.polygonOffsetFactor &&
            (i.polygonOffsetFactor = e.polygonOffsetFactor),
          void 0 !== e.polygonOffsetUnits &&
            (i.polygonOffsetUnits = e.polygonOffsetUnits),
          void 0 !== e.morphTargets && (i.morphTargets = e.morphTargets),
          void 0 !== e.morphNormals && (i.morphNormals = e.morphNormals),
          void 0 !== e.dithering && (i.dithering = e.dithering),
          void 0 !== e.alphaToCoverage &&
            (i.alphaToCoverage = e.alphaToCoverage),
          void 0 !== e.premultipliedAlpha &&
            (i.premultipliedAlpha = e.premultipliedAlpha),
          void 0 !== e.vertexTangents && (i.vertexTangents = e.vertexTangents),
          void 0 !== e.visible && (i.visible = e.visible),
          void 0 !== e.toneMapped && (i.toneMapped = e.toneMapped),
          void 0 !== e.userData && (i.userData = e.userData),
          void 0 !== e.vertexColors &&
            ('number' === typeof e.vertexColors
              ? (i.vertexColors = e.vertexColors > 0)
              : (i.vertexColors = e.vertexColors)),
          void 0 !== e.uniforms)
        )
          for (const r in e.uniforms) {
            const t = e.uniforms[r]
            switch (((i.uniforms[r] = {}), t.type)) {
              case 't':
                i.uniforms[r].value = n(t.value)
                break
              case 'c':
                i.uniforms[r].value = new xr().setHex(t.value)
                break
              case 'v2':
                i.uniforms[r].value = new kn().fromArray(t.value)
                break
              case 'v3':
                i.uniforms[r].value = new Qn().fromArray(t.value)
                break
              case 'v4':
                i.uniforms[r].value = new Yn().fromArray(t.value)
                break
              case 'm3':
                i.uniforms[r].value = new Hn().fromArray(t.value)
                break
              case 'm4':
                i.uniforms[r].value = new Li().fromArray(t.value)
                break
              default:
                i.uniforms[r].value = t.value
            }
          }
        if (
          (void 0 !== e.defines && (i.defines = e.defines),
          void 0 !== e.vertexShader && (i.vertexShader = e.vertexShader),
          void 0 !== e.fragmentShader && (i.fragmentShader = e.fragmentShader),
          void 0 !== e.extensions)
        )
          for (const r in e.extensions) i.extensions[r] = e.extensions[r]
        if (
          (void 0 !== e.shading && (i.flatShading = 1 === e.shading),
          void 0 !== e.size && (i.size = e.size),
          void 0 !== e.sizeAttenuation &&
            (i.sizeAttenuation = e.sizeAttenuation),
          void 0 !== e.map && (i.map = n(e.map)),
          void 0 !== e.matcap && (i.matcap = n(e.matcap)),
          void 0 !== e.alphaMap && (i.alphaMap = n(e.alphaMap)),
          void 0 !== e.bumpMap && (i.bumpMap = n(e.bumpMap)),
          void 0 !== e.bumpScale && (i.bumpScale = e.bumpScale),
          void 0 !== e.normalMap && (i.normalMap = n(e.normalMap)),
          void 0 !== e.normalMapType && (i.normalMapType = e.normalMapType),
          void 0 !== e.normalScale)
        ) {
          let t = e.normalScale
          !1 === Array.isArray(t) && (t = [t, t]),
            (i.normalScale = new kn().fromArray(t))
        }
        return (
          void 0 !== e.displacementMap &&
            (i.displacementMap = n(e.displacementMap)),
          void 0 !== e.displacementScale &&
            (i.displacementScale = e.displacementScale),
          void 0 !== e.displacementBias &&
            (i.displacementBias = e.displacementBias),
          void 0 !== e.roughnessMap && (i.roughnessMap = n(e.roughnessMap)),
          void 0 !== e.metalnessMap && (i.metalnessMap = n(e.metalnessMap)),
          void 0 !== e.emissiveMap && (i.emissiveMap = n(e.emissiveMap)),
          void 0 !== e.emissiveIntensity &&
            (i.emissiveIntensity = e.emissiveIntensity),
          void 0 !== e.specularMap && (i.specularMap = n(e.specularMap)),
          void 0 !== e.envMap && (i.envMap = n(e.envMap)),
          void 0 !== e.envMapIntensity &&
            (i.envMapIntensity = e.envMapIntensity),
          void 0 !== e.reflectivity && (i.reflectivity = e.reflectivity),
          void 0 !== e.refractionRatio &&
            (i.refractionRatio = e.refractionRatio),
          void 0 !== e.lightMap && (i.lightMap = n(e.lightMap)),
          void 0 !== e.lightMapIntensity &&
            (i.lightMapIntensity = e.lightMapIntensity),
          void 0 !== e.aoMap && (i.aoMap = n(e.aoMap)),
          void 0 !== e.aoMapIntensity && (i.aoMapIntensity = e.aoMapIntensity),
          void 0 !== e.gradientMap && (i.gradientMap = n(e.gradientMap)),
          void 0 !== e.clearcoatMap && (i.clearcoatMap = n(e.clearcoatMap)),
          void 0 !== e.clearcoatRoughnessMap &&
            (i.clearcoatRoughnessMap = n(e.clearcoatRoughnessMap)),
          void 0 !== e.clearcoatNormalMap &&
            (i.clearcoatNormalMap = n(e.clearcoatNormalMap)),
          void 0 !== e.clearcoatNormalScale &&
            (i.clearcoatNormalScale = new kn().fromArray(
              e.clearcoatNormalScale
            )),
          void 0 !== e.transmissionMap &&
            (i.transmissionMap = n(e.transmissionMap)),
          void 0 !== e.thicknessMap && (i.thicknessMap = n(e.thicknessMap)),
          i
        )
      }
      setTextures (e) {
        return (this.textures = e), this
      }
    }
    class Mf {
      static decodeText (e) {
        if ('undefined' !== typeof TextDecoder)
          return new TextDecoder().decode(e)
        let t = ''
        for (let i = 0, r = e.length; i < r; i++) t += String.fromCharCode(e[i])
        try {
          return decodeURIComponent(escape(t))
        } catch (n) {
          return t
        }
      }
      static extractUrlBase (e) {
        const t = e.lastIndexOf('/')
        return -1 === t ? './' : e.substr(0, t + 1)
      }
    }
    class Sf extends Ur {
      constructor () {
        super(),
          (this.type = 'InstancedBufferGeometry'),
          (this.instanceCount = 1 / 0)
      }
      copy (e) {
        return super.copy(e), (this.instanceCount = e.instanceCount), this
      }
      clone () {
        return new this.constructor().copy(this)
      }
      toJSON () {
        const e = super.toJSON(this)
        return (
          (e.instanceCount = this.instanceCount),
          (e.isInstancedBufferGeometry = !0),
          e
        )
      }
    }
    Sf.prototype.isInstancedBufferGeometry = !0
    class Ef extends Sr {
      constructor (e, t, n, i = 1) {
        'number' === typeof n &&
          ((i = n),
          (n = !1),
          console.error(
            'THREE.InstancedBufferAttribute: The constructor now expects normalized as the third argument.'
          )),
          super(e, t, n),
          (this.meshPerAttribute = i)
      }
      copy (e) {
        return super.copy(e), (this.meshPerAttribute = e.meshPerAttribute), this
      }
      toJSON () {
        const e = super.toJSON()
        return (
          (e.meshPerAttribute = this.meshPerAttribute),
          (e.isInstancedBufferAttribute = !0),
          e
        )
      }
    }
    Ef.prototype.isInstancedBufferAttribute = !0
    class Tf extends qp {
      constructor (e) {
        super(e)
      }
      load (e, t, n, i) {
        const r = this,
          a = new Xp(r.manager)
        a.setPath(r.path),
          a.setRequestHeader(r.requestHeader),
          a.setWithCredentials(r.withCredentials),
          a.load(
            e,
            function (n) {
              try {
                t(r.parse(JSON.parse(n)))
              } catch (a) {
                i ? i(a) : console.error(a), r.manager.itemError(e)
              }
            },
            n,
            i
          )
      }
      parse (e) {
        const t = {},
          n = {}
        function i (e, n) {
          if (void 0 !== t[n]) return t[n]
          const i = e.interleavedBuffers,
            a = i[n],
            s = r(e, a.buffer),
            o = Pr(a.type, s),
            l = new Rh(o, a.stride)
          return (l.uuid = a.uuid), (t[n] = l), l
        }
        function r (e, t) {
          if (void 0 !== n[t]) return n[t]
          const i = e.arrayBuffers,
            r = i[t],
            a = new Uint32Array(r).buffer
          return (n[t] = a), a
        }
        const a = e.isInstancedBufferGeometry ? new Sf() : new Ur(),
          s = e.data.index
        if (void 0 !== s) {
          const e = Pr(s.type, s.array)
          a.setIndex(new Sr(e, 1))
        }
        const o = e.data.attributes
        for (const d in o) {
          const t = o[d]
          let n
          if (t.isInterleavedBufferAttribute) {
            const r = i(e.data, t.data)
            n = new Ch(r, t.itemSize, t.offset, t.normalized)
          } else {
            const e = Pr(t.type, t.array),
              i = t.isInstancedBufferAttribute ? Ef : Sr
            n = new i(e, t.itemSize, t.normalized)
          }
          void 0 !== t.name && (n.name = t.name),
            void 0 !== t.usage && n.setUsage(t.usage),
            void 0 !== t.updateRange &&
              ((n.updateRange.offset = t.updateRange.offset),
              (n.updateRange.count = t.updateRange.count)),
            a.setAttribute(d, n)
        }
        const l = e.data.morphAttributes
        if (l)
          for (const d in l) {
            const t = l[d],
              n = []
            for (let r = 0, a = t.length; r < a; r++) {
              const a = t[r]
              let s
              if (a.isInterleavedBufferAttribute) {
                const t = i(e.data, a.data)
                s = new Ch(t, a.itemSize, a.offset, a.normalized)
              } else {
                const e = Pr(a.type, a.array)
                s = new Sr(e, a.itemSize, a.normalized)
              }
              void 0 !== a.name && (s.name = a.name), n.push(s)
            }
            a.morphAttributes[d] = n
          }
        const c = e.data.morphTargetsRelative
        c && (a.morphTargetsRelative = !0)
        const h = e.data.groups || e.data.drawcalls || e.data.offsets
        if (void 0 !== h)
          for (let d = 0, p = h.length; d !== p; ++d) {
            const e = h[d]
            a.addGroup(e.start, e.count, e.materialIndex)
          }
        const u = e.data.boundingSphere
        if (void 0 !== u) {
          const e = new Qn()
          void 0 !== u.center && e.fromArray(u.center),
            (a.boundingSphere = new xi(e, u.radius))
        }
        return (
          e.name && (a.name = e.name),
          e.userData && (a.userData = e.userData),
          a
        )
      }
    }
    class Af extends qp {
      constructor (e) {
        super(e)
      }
      load (e, t, n, i) {
        const r = this,
          a = '' === this.path ? Mf.extractUrlBase(e) : this.path
        this.resourcePath = this.resourcePath || a
        const s = new Xp(this.manager)
        s.setPath(this.path),
          s.setRequestHeader(this.requestHeader),
          s.setWithCredentials(this.withCredentials),
          s.load(
            e,
            function (n) {
              let a = null
              try {
                a = JSON.parse(n)
              } catch (m) {
                return (
                  void 0 !== i && i(m),
                  void console.error(
                    "THREE:ObjectLoader: Can't parse " + e + '.',
                    m.message
                  )
                )
              }
              const s = a.metadata
              void 0 !== s &&
              void 0 !== s.type &&
              'geometry' !== s.type.toLowerCase()
                ? r.parse(a, t)
                : console.error("THREE.ObjectLoader: Can't load " + e)
            },
            n,
            i
          )
      }
      async loadAsync (e, t) {
        const n = this,
          i = '' === this.path ? Mf.extractUrlBase(e) : this.path
        this.resourcePath = this.resourcePath || i
        const r = new Xp(this.manager)
        r.setPath(this.path),
          r.setRequestHeader(this.requestHeader),
          r.setWithCredentials(this.withCredentials)
        const a = await r.loadAsync(e, t),
          s = JSON.parse(a),
          o = s.metadata
        if (
          void 0 === o ||
          void 0 === o.type ||
          'geometry' === o.type.toLowerCase()
        )
          throw new Error("THREE.ObjectLoader: Can't load " + e)
        return await n.parseAsync(s)
      }
      parse (e, t) {
        const n = this.parseAnimations(e.animations),
          i = this.parseShapes(e.shapes),
          r = this.parseGeometries(e.geometries, i),
          a = this.parseImages(e.images, function () {
            void 0 !== t && t(l)
          }),
          s = this.parseTextures(e.textures, a),
          o = this.parseMaterials(e.materials, s),
          l = this.parseObject(e.object, r, o, s, n),
          c = this.parseSkeletons(e.skeletons, l)
        if ((this.bindSkeletons(l, c), void 0 !== t)) {
          let e = !1
          for (const t in a)
            if (a[t] instanceof HTMLImageElement) {
              e = !0
              break
            }
          !1 === e && t(l)
        }
        return l
      }
      async parseAsync (e) {
        const t = this.parseAnimations(e.animations),
          n = this.parseShapes(e.shapes),
          i = this.parseGeometries(e.geometries, n),
          r = await this.parseImagesAsync(e.images),
          a = this.parseTextures(e.textures, r),
          s = this.parseMaterials(e.materials, a),
          o = this.parseObject(e.object, i, s, a, t),
          l = this.parseSkeletons(e.skeletons, o)
        return this.bindSkeletons(o, l), o
      }
      parseShapes (e) {
        const t = {}
        if (void 0 !== e)
          for (let n = 0, i = e.length; n < i; n++) {
            const i = new ef().fromJSON(e[n])
            t[i.uuid] = i
          }
        return t
      }
      parseSkeletons (e, t) {
        const n = {},
          i = {}
        if (
          (t.traverse(function (e) {
            e.isBone && (i[e.uuid] = e)
          }),
          void 0 !== e)
        )
          for (let r = 0, a = e.length; r < a; r++) {
            const t = new su().fromJSON(e[r], i)
            n[t.uuid] = t
          }
        return n
      }
      parseGeometries (e, t) {
        const n = {}
        if (void 0 !== e) {
          const i = new Tf()
          for (let r = 0, a = e.length; r < a; r++) {
            let a
            const s = e[r]
            switch (s.type) {
              case 'BufferGeometry':
              case 'InstancedBufferGeometry':
                a = i.parse(s)
                break
              case 'Geometry':
                console.error(
                  'THREE.ObjectLoader: The legacy Geometry type is no longer supported.'
                )
                break
              default:
                s.type in mp
                  ? (a = mp[s.type].fromJSON(s, t))
                  : console.warn(
                      `THREE.ObjectLoader: Unsupported geometry type "${
                        s.type
                      }"`
                    )
            }
            ;(a.uuid = s.uuid),
              void 0 !== s.name && (a.name = s.name),
              !0 === a.isBufferGeometry &&
                void 0 !== s.userData &&
                (a.userData = s.userData),
              (n[s.uuid] = a)
          }
        }
        return n
      }
      parseMaterials (e, t) {
        const n = {},
          i = {}
        if (void 0 !== e) {
          const r = new bf()
          r.setTextures(t)
          for (let t = 0, a = e.length; t < a; t++) {
            const a = e[t]
            if ('MultiMaterial' === a.type) {
              const e = []
              for (let t = 0; t < a.materials.length; t++) {
                const i = a.materials[t]
                void 0 === n[i.uuid] && (n[i.uuid] = r.parse(i)),
                  e.push(n[i.uuid])
              }
              i[a.uuid] = e
            } else
              void 0 === n[a.uuid] && (n[a.uuid] = r.parse(a)),
                (i[a.uuid] = n[a.uuid])
          }
        }
        return i
      }
      parseAnimations (e) {
        const t = {}
        if (void 0 !== e)
          for (let n = 0; n < e.length; n++) {
            const i = e[n],
              r = kp.parse(i)
            t[r.uuid] = r
          }
        return t
      }
      parseImages (e, t) {
        const n = this,
          i = {}
        let r
        function a (e) {
          return (
            n.manager.itemStart(e),
            r.load(
              e,
              function () {
                n.manager.itemEnd(e)
              },
              void 0,
              function () {
                n.manager.itemError(e), n.manager.itemEnd(e)
              }
            )
          )
        }
        function s (e) {
          if ('string' === typeof e) {
            const t = e,
              i = /^(\/\/)|([a-z]+:(\/\/)?)/i.test(t) ? t : n.resourcePath + t
            return a(i)
          }
          return e.data
            ? { data: Pr(e.type, e.data), width: e.width, height: e.height }
            : null
        }
        if (void 0 !== e && e.length > 0) {
          const n = new Gp(t)
          ;(r = new Jp(n)), r.setCrossOrigin(this.crossOrigin)
          for (let t = 0, r = e.length; t < r; t++) {
            const n = e[t],
              r = n.url
            if (Array.isArray(r)) {
              i[n.uuid] = []
              for (let e = 0, t = r.length; e < t; e++) {
                const t = r[e],
                  a = s(t)
                null !== a &&
                  (a instanceof HTMLImageElement
                    ? i[n.uuid].push(a)
                    : i[n.uuid].push(new iu(a.data, a.width, a.height)))
              }
            } else {
              const e = s(n.url)
              null !== e && (i[n.uuid] = e)
            }
          }
        }
        return i
      }
      async parseImagesAsync (e) {
        const t = this,
          n = {}
        let i
        async function r (e) {
          if ('string' === typeof e) {
            const n = e,
              r = /^(\/\/)|([a-z]+:(\/\/)?)/i.test(n) ? n : t.resourcePath + n
            return await i.loadAsync(r)
          }
          return e.data
            ? { data: Pr(e.type, e.data), width: e.width, height: e.height }
            : null
        }
        if (void 0 !== e && e.length > 0) {
          ;(i = new Jp(this.manager)), i.setCrossOrigin(this.crossOrigin)
          for (let t = 0, i = e.length; t < i; t++) {
            const i = e[t],
              a = i.url
            if (Array.isArray(a)) {
              n[i.uuid] = []
              for (let e = 0, t = a.length; e < t; e++) {
                const t = a[e],
                  s = await r(t)
                null !== s &&
                  (s instanceof HTMLImageElement
                    ? n[i.uuid].push(s)
                    : n[i.uuid].push(new iu(s.data, s.width, s.height)))
              }
            } else {
              const e = await r(i.url)
              null !== e && (n[i.uuid] = e)
            }
          }
        }
        return n
      }
      parseTextures (e, t) {
        function n (e, t) {
          return 'number' === typeof e
            ? e
            : (console.warn(
                'THREE.ObjectLoader.parseTexture: Constant should be in numeric form.',
                e
              ),
              t[e])
        }
        const i = {}
        if (void 0 !== e)
          for (let r = 0, a = e.length; r < a; r++) {
            const a = e[r]
            let s
            void 0 === a.image &&
              console.warn(
                'THREE.ObjectLoader: No "image" specified for',
                a.uuid
              ),
              void 0 === t[a.image] &&
                console.warn('THREE.ObjectLoader: Undefined image', a.image)
            const o = t[a.image]
            Array.isArray(o)
              ? ((s = new ya(o)), 6 === o.length && (s.needsUpdate = !0))
              : ((s =
                  o && o.data ? new iu(o.data, o.width, o.height) : new jn(o)),
                o && (s.needsUpdate = !0)),
              (s.uuid = a.uuid),
              void 0 !== a.name && (s.name = a.name),
              void 0 !== a.mapping && (s.mapping = n(a.mapping, Rf)),
              void 0 !== a.offset && s.offset.fromArray(a.offset),
              void 0 !== a.repeat && s.repeat.fromArray(a.repeat),
              void 0 !== a.center && s.center.fromArray(a.center),
              void 0 !== a.rotation && (s.rotation = a.rotation),
              void 0 !== a.wrap &&
                ((s.wrapS = n(a.wrap[0], Lf)), (s.wrapT = n(a.wrap[1], Lf))),
              void 0 !== a.format && (s.format = a.format),
              void 0 !== a.type && (s.type = a.type),
              void 0 !== a.encoding && (s.encoding = a.encoding),
              void 0 !== a.minFilter && (s.minFilter = n(a.minFilter, Cf)),
              void 0 !== a.magFilter && (s.magFilter = n(a.magFilter, Cf)),
              void 0 !== a.anisotropy && (s.anisotropy = a.anisotropy),
              void 0 !== a.flipY && (s.flipY = a.flipY),
              void 0 !== a.premultiplyAlpha &&
                (s.premultiplyAlpha = a.premultiplyAlpha),
              void 0 !== a.unpackAlignment &&
                (s.unpackAlignment = a.unpackAlignment),
              (i[a.uuid] = s)
          }
        return i
      }
      parseObject (e, t, n, i, r) {
        let a, s, o
        function l (e) {
          return (
            void 0 === t[e] &&
              console.warn('THREE.ObjectLoader: Undefined geometry', e),
            t[e]
          )
        }
        function c (e) {
          if (void 0 !== e) {
            if (Array.isArray(e)) {
              const t = []
              for (let i = 0, r = e.length; i < r; i++) {
                const r = e[i]
                void 0 === n[r] &&
                  console.warn('THREE.ObjectLoader: Undefined material', r),
                  t.push(n[r])
              }
              return t
            }
            return (
              void 0 === n[e] &&
                console.warn('THREE.ObjectLoader: Undefined material', e),
              n[e]
            )
          }
        }
        function h (e) {
          return (
            void 0 === i[e] &&
              console.warn('THREE.ObjectLoader: Undefined texture', e),
            i[e]
          )
        }
        switch (e.type) {
          case 'Scene':
            ;(a = new Ah()),
              void 0 !== e.background &&
                (Number.isInteger(e.background)
                  ? (a.background = new xr(e.background))
                  : (a.background = h(e.background))),
              void 0 !== e.environment && (a.environment = h(e.environment)),
              void 0 !== e.fog &&
                ('Fog' === e.fog.type
                  ? (a.fog = new Th(e.fog.color, e.fog.near, e.fog.far))
                  : 'FogExp2' === e.fog.type &&
                    (a.fog = new Eh(e.fog.color, e.fog.density)))
            break
          case 'PerspectiveCamera':
            ;(a = new fa(e.fov, e.aspect, e.near, e.far)),
              void 0 !== e.focus && (a.focus = e.focus),
              void 0 !== e.zoom && (a.zoom = e.zoom),
              void 0 !== e.filmGauge && (a.filmGauge = e.filmGauge),
              void 0 !== e.filmOffset && (a.filmOffset = e.filmOffset),
              void 0 !== e.view && (a.view = Object.assign({}, e.view))
            break
          case 'OrthographicCamera':
            ;(a = new mf(e.left, e.right, e.top, e.bottom, e.near, e.far)),
              void 0 !== e.zoom && (a.zoom = e.zoom),
              void 0 !== e.view && (a.view = Object.assign({}, e.view))
            break
          case 'AmbientLight':
            a = new yf(e.color, e.intensity)
            break
          case 'DirectionalLight':
            a = new vf(e.color, e.intensity)
            break
          case 'PointLight':
            a = new ff(e.color, e.intensity, e.distance, e.decay)
            break
          case 'RectAreaLight':
            a = new _f(e.color, e.intensity, e.width, e.height)
            break
          case 'SpotLight':
            a = new cf(
              e.color,
              e.intensity,
              e.distance,
              e.angle,
              e.penumbra,
              e.decay
            )
            break
          case 'HemisphereLight':
            a = new nf(e.color, e.groundColor, e.intensity)
            break
          case 'LightProbe':
            a = new wf().fromJSON(e)
            break
          case 'SkinnedMesh':
            ;(s = l(e.geometry)),
              (o = c(e.material)),
              (a = new tu(s, o)),
              void 0 !== e.bindMode && (a.bindMode = e.bindMode),
              void 0 !== e.bindMatrix && a.bindMatrix.fromArray(e.bindMatrix),
              void 0 !== e.skeleton && (a.skeleton = e.skeleton)
            break
          case 'Mesh':
            ;(s = l(e.geometry)), (o = c(e.material)), (a = new ia(s, o))
            break
          case 'InstancedMesh':
            ;(s = l(e.geometry)), (o = c(e.material))
            const t = e.count,
              n = e.instanceMatrix,
              i = e.instanceColor
            ;(a = new uu(s, o, t)),
              (a.instanceMatrix = new Sr(new Float32Array(n.array), 16)),
              void 0 !== i &&
                (a.instanceColor = new Sr(
                  new Float32Array(i.array),
                  i.itemSize
                ))
            break
          case 'LOD':
            a = new Jh()
            break
          case 'Line':
            a = new yu(l(e.geometry), c(e.material))
            break
          case 'LineLoop':
            a = new bu(l(e.geometry), c(e.material))
            break
          case 'LineSegments':
            a = new wu(l(e.geometry), c(e.material))
            break
          case 'PointCloud':
          case 'Points':
            a = new Ru(l(e.geometry), c(e.material))
            break
          case 'Sprite':
            a = new jh(c(e.material))
            break
          case 'Group':
            a = new vh()
            break
          case 'Bone':
            a = new nu()
            break
          default:
            a = new er()
        }
        if (
          ((a.uuid = e.uuid),
          void 0 !== e.name && (a.name = e.name),
          void 0 !== e.matrix
            ? (a.matrix.fromArray(e.matrix),
              void 0 !== e.matrixAutoUpdate &&
                (a.matrixAutoUpdate = e.matrixAutoUpdate),
              a.matrixAutoUpdate &&
                a.matrix.decompose(a.position, a.quaternion, a.scale))
            : (void 0 !== e.position && a.position.fromArray(e.position),
              void 0 !== e.rotation && a.rotation.fromArray(e.rotation),
              void 0 !== e.quaternion && a.quaternion.fromArray(e.quaternion),
              void 0 !== e.scale && a.scale.fromArray(e.scale)),
          void 0 !== e.castShadow && (a.castShadow = e.castShadow),
          void 0 !== e.receiveShadow && (a.receiveShadow = e.receiveShadow),
          e.shadow &&
            (void 0 !== e.shadow.bias && (a.shadow.bias = e.shadow.bias),
            void 0 !== e.shadow.normalBias &&
              (a.shadow.normalBias = e.shadow.normalBias),
            void 0 !== e.shadow.radius && (a.shadow.radius = e.shadow.radius),
            void 0 !== e.shadow.mapSize &&
              a.shadow.mapSize.fromArray(e.shadow.mapSize),
            void 0 !== e.shadow.camera &&
              (a.shadow.camera = this.parseObject(e.shadow.camera))),
          void 0 !== e.visible && (a.visible = e.visible),
          void 0 !== e.frustumCulled && (a.frustumCulled = e.frustumCulled),
          void 0 !== e.renderOrder && (a.renderOrder = e.renderOrder),
          void 0 !== e.userData && (a.userData = e.userData),
          void 0 !== e.layers && (a.layers.mask = e.layers),
          void 0 !== e.children)
        ) {
          const s = e.children
          for (let e = 0; e < s.length; e++)
            a.add(this.parseObject(s[e], t, n, i, r))
        }
        if (void 0 !== e.animations) {
          const t = e.animations
          for (let e = 0; e < t.length; e++) {
            const n = t[e]
            a.animations.push(r[n])
          }
        }
        if ('LOD' === e.type) {
          void 0 !== e.autoUpdate && (a.autoUpdate = e.autoUpdate)
          const t = e.levels
          for (let e = 0; e < t.length; e++) {
            const n = t[e],
              i = a.getObjectByProperty('uuid', n.object)
            void 0 !== i && a.addLevel(i, n.distance)
          }
        }
        return a
      }
      bindSkeletons (e, t) {
        0 !== Object.keys(t).length &&
          e.traverse(function (e) {
            if (!0 === e.isSkinnedMesh && void 0 !== e.skeleton) {
              const n = t[e.skeleton]
              void 0 === n
                ? console.warn(
                    'THREE.ObjectLoader: No skeleton found with UUID:',
                    e.skeleton
                  )
                : e.bind(n, e.bindMatrix)
            }
          })
      }
      setTexturePath (e) {
        return (
          console.warn(
            'THREE.ObjectLoader: .setTexturePath() has been renamed to .setResourcePath().'
          ),
          this.setResourcePath(e)
        )
      }
    }
    const Rf = {
        UVMapping: Te,
        CubeReflectionMapping: Ae,
        CubeRefractionMapping: Re,
        EquirectangularReflectionMapping: Le,
        EquirectangularRefractionMapping: Ce,
        CubeUVReflectionMapping: Pe,
        CubeUVRefractionMapping: De
      },
      Lf = {
        RepeatWrapping: Ie,
        ClampToEdgeWrapping: Ne,
        MirroredRepeatWrapping: Oe
      },
      Cf = {
        NearestFilter: Fe,
        NearestMipmapNearestFilter: Be,
        NearestMipmapLinearFilter: ze,
        LinearFilter: Ue,
        LinearMipmapNearestFilter: ke,
        LinearMipmapLinearFilter: He
      }
    class Pf extends qp {
      constructor (e) {
        super(e),
          'undefined' === typeof createImageBitmap &&
            console.warn(
              'THREE.ImageBitmapLoader: createImageBitmap() not supported.'
            ),
          'undefined' === typeof fetch &&
            console.warn('THREE.ImageBitmapLoader: fetch() not supported.'),
          (this.options = { premultiplyAlpha: 'none' })
      }
      setOptions (e) {
        return (this.options = e), this
      }
      load (e, t, n, i) {
        void 0 === e && (e = ''),
          void 0 !== this.path && (e = this.path + e),
          (e = this.manager.resolveURL(e))
        const r = this,
          a = Vp.get(e)
        if (void 0 !== a)
          return (
            r.manager.itemStart(e),
            setTimeout(function () {
              t && t(a), r.manager.itemEnd(e)
            }, 0),
            a
          )
        const s = {}
        ;(s.credentials =
          'anonymous' === this.crossOrigin ? 'same-origin' : 'include'),
          (s.headers = this.requestHeader),
          fetch(e, s)
            .then(function (e) {
              return e.blob()
            })
            .then(function (e) {
              return createImageBitmap(
                e,
                Object.assign(r.options, { colorSpaceConversion: 'none' })
              )
            })
            .then(function (n) {
              Vp.add(e, n), t && t(n), r.manager.itemEnd(e)
            })
            .catch(function (t) {
              i && i(t), r.manager.itemError(e), r.manager.itemEnd(e)
            }),
          r.manager.itemStart(e)
      }
    }
    Pf.prototype.isImageBitmapLoader = !0
    class Df {
      constructor () {
        ;(this.type = 'ShapePath'),
          (this.color = new xr()),
          (this.subPaths = []),
          (this.currentPath = null)
      }
      moveTo (e, t) {
        return (
          (this.currentPath = new $p()),
          this.subPaths.push(this.currentPath),
          this.currentPath.moveTo(e, t),
          this
        )
      }
      lineTo (e, t) {
        return this.currentPath.lineTo(e, t), this
      }
      quadraticCurveTo (e, t, n, i) {
        return this.currentPath.quadraticCurveTo(e, t, n, i), this
      }
      bezierCurveTo (e, t, n, i, r, a) {
        return this.currentPath.bezierCurveTo(e, t, n, i, r, a), this
      }
      splineThru (e) {
        return this.currentPath.splineThru(e), this
      }
      toShapes (e, t) {
        function n (e) {
          const t = []
          for (let n = 0, i = e.length; n < i; n++) {
            const i = e[n],
              r = new ef()
            ;(r.curves = i.curves), t.push(r)
          }
          return t
        }
        function i (e, t) {
          const n = t.length
          let i = !1
          for (let r = n - 1, a = 0; a < n; r = a++) {
            let n = t[r],
              s = t[a],
              o = s.x - n.x,
              l = s.y - n.y
            if (Math.abs(l) > Number.EPSILON) {
              if (
                (l < 0 && ((n = t[a]), (o = -o), (s = t[r]), (l = -l)),
                e.y < n.y || e.y > s.y)
              )
                continue
              if (e.y === n.y) {
                if (e.x === n.x) return !0
              } else {
                const t = l * (e.x - n.x) - o * (e.y - n.y)
                if (0 === t) return !0
                if (t < 0) continue
                i = !i
              }
            } else {
              if (e.y !== n.y) continue
              if ((s.x <= e.x && e.x <= n.x) || (n.x <= e.x && e.x <= s.x))
                return !0
            }
          }
          return i
        }
        const r = Jd.isClockWise,
          a = this.subPaths
        if (0 === a.length) return []
        if (!0 === t) return n(a)
        let s, o, l
        const c = []
        if (1 === a.length)
          return (o = a[0]), (l = new ef()), (l.curves = o.curves), c.push(l), c
        let h = !r(a[0].getPoints())
        h = e ? !h : h
        const u = [],
          d = []
        let p,
          f,
          m = [],
          g = 0
        ;(d[g] = void 0), (m[g] = [])
        for (let v = 0, y = a.length; v < y; v++)
          (o = a[v]),
            (p = o.getPoints()),
            (s = r(p)),
            (s = e ? !s : s),
            s
              ? (!h && d[g] && g++,
                (d[g] = { s: new ef(), p: p }),
                (d[g].s.curves = o.curves),
                h && g++,
                (m[g] = []))
              : m[g].push({ h: o, p: p[0] })
        if (!d[0]) return n(a)
        if (d.length > 1) {
          let e = !1
          const t = []
          for (let n = 0, i = d.length; n < i; n++) u[n] = []
          for (let n = 0, r = d.length; n < r; n++) {
            const r = m[n]
            for (let a = 0; a < r.length; a++) {
              const s = r[a]
              let o = !0
              for (let r = 0; r < d.length; r++)
                i(s.p, d[r].p) &&
                  (n !== r && t.push({ froms: n, tos: r, hole: a }),
                  o ? ((o = !1), u[r].push(s)) : (e = !0))
              o && u[n].push(s)
            }
          }
          t.length > 0 && (e || (m = u))
        }
        for (let v = 0, y = d.length; v < y; v++) {
          ;(l = d[v].s), c.push(l), (f = m[v])
          for (let e = 0, t = f.length; e < t; e++) l.holes.push(f[e].h)
        }
        return c
      }
    }
    class If {
      constructor (e) {
        ;(this.type = 'Font'), (this.data = e)
      }
      generateShapes (e, t = 100) {
        const n = [],
          i = Nf(e, t, this.data)
        for (let r = 0, a = i.length; r < a; r++)
          Array.prototype.push.apply(n, i[r].toShapes())
        return n
      }
    }
    function Nf (e, t, n) {
      const i = Array.from(e),
        r = t / n.resolution,
        a =
          (n.boundingBox.yMax - n.boundingBox.yMin + n.underlineThickness) * r,
        s = []
      let o = 0,
        l = 0
      for (let c = 0; c < i.length; c++) {
        const e = i[c]
        if ('\n' === e) (o = 0), (l -= a)
        else {
          const t = Of(e, r, o, l, n)
          ;(o += t.offsetX), s.push(t.path)
        }
      }
      return s
    }
    function Of (e, t, n, i, r) {
      const a = r.glyphs[e] || r.glyphs['?']
      if (!a)
        return void console.error(
          'THREE.Font: character "' +
            e +
            '" does not exists in font family ' +
            r.familyName +
            '.'
        )
      const s = new Df()
      let o, l, c, h, u, d, p, f
      if (a.o) {
        const e = a._cachedOutline || (a._cachedOutline = a.o.split(' '))
        for (let r = 0, a = e.length; r < a; ) {
          const a = e[r++]
          switch (a) {
            case 'm':
              ;(o = e[r++] * t + n), (l = e[r++] * t + i), s.moveTo(o, l)
              break
            case 'l':
              ;(o = e[r++] * t + n), (l = e[r++] * t + i), s.lineTo(o, l)
              break
            case 'q':
              ;(c = e[r++] * t + n),
                (h = e[r++] * t + i),
                (u = e[r++] * t + n),
                (d = e[r++] * t + i),
                s.quadraticCurveTo(u, d, c, h)
              break
            case 'b':
              ;(c = e[r++] * t + n),
                (h = e[r++] * t + i),
                (u = e[r++] * t + n),
                (d = e[r++] * t + i),
                (p = e[r++] * t + n),
                (f = e[r++] * t + i),
                s.bezierCurveTo(u, d, p, f, c, h)
              break
          }
        }
      }
      return { offsetX: a.ha * t, path: s }
    }
    If.prototype.isFont = !0
    let Ff
    const Bf = {
      getContext: function () {
        return (
          void 0 === Ff &&
            (Ff = new (window.AudioContext || window.webkitAudioContext)()),
          Ff
        )
      },
      setContext: function (e) {
        Ff = e
      }
    }
    class zf extends qp {
      constructor (e) {
        super(e)
      }
      load (e, t, n, i) {
        const r = this,
          a = new Xp(this.manager)
        a.setResponseType('arraybuffer'),
          a.setPath(this.path),
          a.setRequestHeader(this.requestHeader),
          a.setWithCredentials(this.withCredentials),
          a.load(
            e,
            function (n) {
              try {
                const e = n.slice(0),
                  i = Bf.getContext()
                i.decodeAudioData(e, function (e) {
                  t(e)
                })
              } catch (a) {
                i ? i(a) : console.error(a), r.manager.itemError(e)
              }
            },
            n,
            i
          )
      }
    }
    class Uf extends wf {
      constructor (e, t, n = 1) {
        super(void 0, n)
        const i = new xr().set(e),
          r = new xr().set(t),
          a = new Qn(i.r, i.g, i.b),
          s = new Qn(r.r, r.g, r.b),
          o = Math.sqrt(Math.PI),
          l = o * Math.sqrt(0.75)
        this.sh.coefficients[0]
          .copy(a)
          .add(s)
          .multiplyScalar(o),
          this.sh.coefficients[1]
            .copy(a)
            .sub(s)
            .multiplyScalar(l)
      }
    }
    Uf.prototype.isHemisphereLightProbe = !0
    class kf extends wf {
      constructor (e, t = 1) {
        super(void 0, t)
        const n = new xr().set(e)
        this.sh.coefficients[0]
          .set(n.r, n.g, n.b)
          .multiplyScalar(2 * Math.sqrt(Math.PI))
      }
    }
    kf.prototype.isAmbientLightProbe = !0
    class Hf extends er {
      constructor (e) {
        super(),
          (this.type = 'Audio'),
          (this.listener = e),
          (this.context = e.context),
          (this.gain = this.context.createGain()),
          this.gain.connect(e.getInput()),
          (this.autoplay = !1),
          (this.buffer = null),
          (this.detune = 0),
          (this.loop = !1),
          (this.loopStart = 0),
          (this.loopEnd = 0),
          (this.offset = 0),
          (this.duration = void 0),
          (this.playbackRate = 1),
          (this.isPlaying = !1),
          (this.hasPlaybackControl = !0),
          (this.source = null),
          (this.sourceType = 'empty'),
          (this._startedAt = 0),
          (this._progress = 0),
          (this._connected = !1),
          (this.filters = [])
      }
      getOutput () {
        return this.gain
      }
      setNodeSource (e) {
        return (
          (this.hasPlaybackControl = !1),
          (this.sourceType = 'audioNode'),
          (this.source = e),
          this.connect(),
          this
        )
      }
      setMediaElementSource (e) {
        return (
          (this.hasPlaybackControl = !1),
          (this.sourceType = 'mediaNode'),
          (this.source = this.context.createMediaElementSource(e)),
          this.connect(),
          this
        )
      }
      setMediaStreamSource (e) {
        return (
          (this.hasPlaybackControl = !1),
          (this.sourceType = 'mediaStreamNode'),
          (this.source = this.context.createMediaStreamSource(e)),
          this.connect(),
          this
        )
      }
      setBuffer (e) {
        return (
          (this.buffer = e),
          (this.sourceType = 'buffer'),
          this.autoplay && this.play(),
          this
        )
      }
      play (e = 0) {
        if (!0 === this.isPlaying)
          return void console.warn('THREE.Audio: Audio is already playing.')
        if (!1 === this.hasPlaybackControl)
          return void console.warn(
            'THREE.Audio: this Audio has no playback control.'
          )
        this._startedAt = this.context.currentTime + e
        const t = this.context.createBufferSource()
        return (
          (t.buffer = this.buffer),
          (t.loop = this.loop),
          (t.loopStart = this.loopStart),
          (t.loopEnd = this.loopEnd),
          (t.onended = this.onEnded.bind(this)),
          t.start(this._startedAt, this._progress + this.offset, this.duration),
          (this.isPlaying = !0),
          (this.source = t),
          this.setDetune(this.detune),
          this.setPlaybackRate(this.playbackRate),
          this.connect()
        )
      }
      pause () {
        if (!1 !== this.hasPlaybackControl)
          return (
            !0 === this.isPlaying &&
              ((this._progress +=
                Math.max(this.context.currentTime - this._startedAt, 0) *
                this.playbackRate),
              !0 === this.loop &&
                (this._progress =
                  this._progress % (this.duration || this.buffer.duration)),
              this.source.stop(),
              (this.source.onended = null),
              (this.isPlaying = !1)),
            this
          )
        console.warn('THREE.Audio: this Audio has no playback control.')
      }
      stop () {
        if (!1 !== this.hasPlaybackControl)
          return (
            (this._progress = 0),
            this.source.stop(),
            (this.source.onended = null),
            (this.isPlaying = !1),
            this
          )
        console.warn('THREE.Audio: this Audio has no playback control.')
      }
      connect () {
        if (this.filters.length > 0) {
          this.source.connect(this.filters[0])
          for (let e = 1, t = this.filters.length; e < t; e++)
            this.filters[e - 1].connect(this.filters[e])
          this.filters[this.filters.length - 1].connect(this.getOutput())
        } else this.source.connect(this.getOutput())
        return (this._connected = !0), this
      }
      disconnect () {
        if (this.filters.length > 0) {
          this.source.disconnect(this.filters[0])
          for (let e = 1, t = this.filters.length; e < t; e++)
            this.filters[e - 1].disconnect(this.filters[e])
          this.filters[this.filters.length - 1].disconnect(this.getOutput())
        } else this.source.disconnect(this.getOutput())
        return (this._connected = !1), this
      }
      getFilters () {
        return this.filters
      }
      setFilters (e) {
        return (
          e || (e = []),
          !0 === this._connected
            ? (this.disconnect(), (this.filters = e.slice()), this.connect())
            : (this.filters = e.slice()),
          this
        )
      }
      setDetune (e) {
        if (((this.detune = e), void 0 !== this.source.detune))
          return (
            !0 === this.isPlaying &&
              this.source.detune.setTargetAtTime(
                this.detune,
                this.context.currentTime,
                0.01
              ),
            this
          )
      }
      getDetune () {
        return this.detune
      }
      getFilter () {
        return this.getFilters()[0]
      }
      setFilter (e) {
        return this.setFilters(e ? [e] : [])
      }
      setPlaybackRate (e) {
        if (!1 !== this.hasPlaybackControl)
          return (
            (this.playbackRate = e),
            !0 === this.isPlaying &&
              this.source.playbackRate.setTargetAtTime(
                this.playbackRate,
                this.context.currentTime,
                0.01
              ),
            this
          )
        console.warn('THREE.Audio: this Audio has no playback control.')
      }
      getPlaybackRate () {
        return this.playbackRate
      }
      onEnded () {
        this.isPlaying = !1
      }
      getLoop () {
        return !1 === this.hasPlaybackControl
          ? (console.warn('THREE.Audio: this Audio has no playback control.'),
            !1)
          : this.loop
      }
      setLoop (e) {
        if (!1 !== this.hasPlaybackControl)
          return (
            (this.loop = e),
            !0 === this.isPlaying && (this.source.loop = this.loop),
            this
          )
        console.warn('THREE.Audio: this Audio has no playback control.')
      }
      setLoopStart (e) {
        return (this.loopStart = e), this
      }
      setLoopEnd (e) {
        return (this.loopEnd = e), this
      }
      getVolume () {
        return this.gain.gain.value
      }
      setVolume (e) {
        return (
          this.gain.gain.setTargetAtTime(e, this.context.currentTime, 0.01),
          this
        )
      }
    }
    class Wf {
      constructor (e, t = 2048) {
        ;(this.analyser = e.context.createAnalyser()),
          (this.analyser.fftSize = t),
          (this.data = new Uint8Array(this.analyser.frequencyBinCount)),
          e.getOutput().connect(this.analyser)
      }
      getFrequencyData () {
        return this.analyser.getByteFrequencyData(this.data), this.data
      }
      getAverageFrequency () {
        let e = 0
        const t = this.getFrequencyData()
        for (let n = 0; n < t.length; n++) e += t[n]
        return e / t.length
      }
    }
    class Vf {
      constructor (e, t, n) {
        let i, r, a
        switch (((this.binding = e), (this.valueSize = n), t)) {
          case 'quaternion':
            ;(i = this._slerp),
              (r = this._slerpAdditive),
              (a = this._setAdditiveIdentityQuaternion),
              (this.buffer = new Float64Array(6 * n)),
              (this._workIndex = 5)
            break
          case 'string':
          case 'bool':
            ;(i = this._select),
              (r = this._select),
              (a = this._setAdditiveIdentityOther),
              (this.buffer = new Array(5 * n))
            break
          default:
            ;(i = this._lerp),
              (r = this._lerpAdditive),
              (a = this._setAdditiveIdentityNumeric),
              (this.buffer = new Float64Array(5 * n))
        }
        ;(this._mixBufferRegion = i),
          (this._mixBufferRegionAdditive = r),
          (this._setIdentity = a),
          (this._origIndex = 3),
          (this._addIndex = 4),
          (this.cumulativeWeight = 0),
          (this.cumulativeWeightAdditive = 0),
          (this.useCount = 0),
          (this.referenceCount = 0)
      }
      accumulate (e, t) {
        const n = this.buffer,
          i = this.valueSize,
          r = e * i + i
        let a = this.cumulativeWeight
        if (0 === a) {
          for (let e = 0; e !== i; ++e) n[r + e] = n[e]
          a = t
        } else {
          a += t
          const e = t / a
          this._mixBufferRegion(n, r, 0, e, i)
        }
        this.cumulativeWeight = a
      }
      accumulateAdditive (e) {
        const t = this.buffer,
          n = this.valueSize,
          i = n * this._addIndex
        0 === this.cumulativeWeightAdditive && this._setIdentity(),
          this._mixBufferRegionAdditive(t, i, 0, e, n),
          (this.cumulativeWeightAdditive += e)
      }
      apply (e) {
        const t = this.valueSize,
          n = this.buffer,
          i = e * t + t,
          r = this.cumulativeWeight,
          a = this.cumulativeWeightAdditive,
          s = this.binding
        if (
          ((this.cumulativeWeight = 0),
          (this.cumulativeWeightAdditive = 0),
          r < 1)
        ) {
          const e = t * this._origIndex
          this._mixBufferRegion(n, i, e, 1 - r, t)
        }
        a > 0 && this._mixBufferRegionAdditive(n, i, this._addIndex * t, 1, t)
        for (let o = t, l = t + t; o !== l; ++o)
          if (n[o] !== n[o + t]) {
            s.setValue(n, i)
            break
          }
      }
      saveOriginalState () {
        const e = this.binding,
          t = this.buffer,
          n = this.valueSize,
          i = n * this._origIndex
        e.getValue(t, i)
        for (let r = n, a = i; r !== a; ++r) t[r] = t[i + (r % n)]
        this._setIdentity(),
          (this.cumulativeWeight = 0),
          (this.cumulativeWeightAdditive = 0)
      }
      restoreOriginalState () {
        const e = 3 * this.valueSize
        this.binding.setValue(this.buffer, e)
      }
      _setAdditiveIdentityNumeric () {
        const e = this._addIndex * this.valueSize,
          t = e + this.valueSize
        for (let n = e; n < t; n++) this.buffer[n] = 0
      }
      _setAdditiveIdentityQuaternion () {
        this._setAdditiveIdentityNumeric(),
          (this.buffer[this._addIndex * this.valueSize + 3] = 1)
      }
      _setAdditiveIdentityOther () {
        const e = this._origIndex * this.valueSize,
          t = this._addIndex * this.valueSize
        for (let n = 0; n < this.valueSize; n++)
          this.buffer[t + n] = this.buffer[e + n]
      }
      _select (e, t, n, i, r) {
        if (i >= 0.5) for (let a = 0; a !== r; ++a) e[t + a] = e[n + a]
      }
      _slerp (e, t, n, i) {
        Kn.slerpFlat(e, t, e, t, e, n, i)
      }
      _slerpAdditive (e, t, n, i, r) {
        const a = this._workIndex * r
        Kn.multiplyQuaternionsFlat(e, a, e, t, e, n),
          Kn.slerpFlat(e, t, e, t, e, a, i)
      }
      _lerp (e, t, n, i, r) {
        const a = 1 - i
        for (let s = 0; s !== r; ++s) {
          const r = t + s
          e[r] = e[r] * a + e[n + s] * i
        }
      }
      _lerpAdditive (e, t, n, i, r) {
        for (let a = 0; a !== r; ++a) {
          const r = t + a
          e[r] = e[r] + e[n + a] * i
        }
      }
    }
    const Gf = '\\[\\]\\.:\\/',
      jf = new RegExp('[' + Gf + ']', 'g'),
      qf = '[^' + Gf + ']',
      Yf = '[^' + Gf.replace('\\.', '') + ']',
      Xf = /((?:WC+[\/:])*)/.source.replace('WC', qf),
      Jf = /(WCOD+)?/.source.replace('WCOD', Yf),
      Zf = /(?:\.(WC+)(?:\[(.+)\])?)?/.source.replace('WC', qf),
      Kf = /\.(WC+)(?:\[(.+)\])?/.source.replace('WC', qf),
      Qf = new RegExp('^' + Xf + Jf + Zf + Kf + '$'),
      $f = ['material', 'materials', 'bones']
    class em {
      constructor (e, t, n) {
        const i = n || tm.parseTrackName(t)
        ;(this._targetGroup = e), (this._bindings = e.subscribe_(t, i))
      }
      getValue (e, t) {
        this.bind()
        const n = this._targetGroup.nCachedObjects_,
          i = this._bindings[n]
        void 0 !== i && i.getValue(e, t)
      }
      setValue (e, t) {
        const n = this._bindings
        for (
          let i = this._targetGroup.nCachedObjects_, r = n.length;
          i !== r;
          ++i
        )
          n[i].setValue(e, t)
      }
      bind () {
        const e = this._bindings
        for (
          let t = this._targetGroup.nCachedObjects_, n = e.length;
          t !== n;
          ++t
        )
          e[t].bind()
      }
      unbind () {
        const e = this._bindings
        for (
          let t = this._targetGroup.nCachedObjects_, n = e.length;
          t !== n;
          ++t
        )
          e[t].unbind()
      }
    }
    class tm {
      constructor (e, t, n) {
        ;(this.path = t),
          (this.parsedPath = n || tm.parseTrackName(t)),
          (this.node = tm.findNode(e, this.parsedPath.nodeName) || e),
          (this.rootNode = e),
          (this.getValue = this._getValue_unbound),
          (this.setValue = this._setValue_unbound)
      }
      static create (e, t, n) {
        return e && e.isAnimationObjectGroup
          ? new tm.Composite(e, t, n)
          : new tm(e, t, n)
      }
      static sanitizeNodeName (e) {
        return e.replace(/\s/g, '_').replace(jf, '')
      }
      static parseTrackName (e) {
        const t = Qf.exec(e)
        if (!t) throw new Error('PropertyBinding: Cannot parse trackName: ' + e)
        const n = {
            nodeName: t[2],
            objectName: t[3],
            objectIndex: t[4],
            propertyName: t[5],
            propertyIndex: t[6]
          },
          i = n.nodeName && n.nodeName.lastIndexOf('.')
        if (void 0 !== i && -1 !== i) {
          const e = n.nodeName.substring(i + 1)
          ;-1 !== $f.indexOf(e) &&
            ((n.nodeName = n.nodeName.substring(0, i)), (n.objectName = e))
        }
        if (null === n.propertyName || 0 === n.propertyName.length)
          throw new Error(
            'PropertyBinding: can not parse propertyName from trackName: ' + e
          )
        return n
      }
      static findNode (e, t) {
        if (
          !t ||
          '' === t ||
          '.' === t ||
          -1 === t ||
          t === e.name ||
          t === e.uuid
        )
          return e
        if (e.skeleton) {
          const n = e.skeleton.getBoneByName(t)
          if (void 0 !== n) return n
        }
        if (e.children) {
          const n = function (e) {
              for (let i = 0; i < e.length; i++) {
                const r = e[i]
                if (r.name === t || r.uuid === t) return r
                const a = n(r.children)
                if (a) return a
              }
              return null
            },
            i = n(e.children)
          if (i) return i
        }
        return null
      }
      _getValue_unavailable () {}
      _setValue_unavailable () {}
      _getValue_direct (e, t) {
        e[t] = this.node[this.propertyName]
      }
      _getValue_array (e, t) {
        const n = this.resolvedProperty
        for (let i = 0, r = n.length; i !== r; ++i) e[t++] = n[i]
      }
      _getValue_arrayElement (e, t) {
        e[t] = this.resolvedProperty[this.propertyIndex]
      }
      _getValue_toArray (e, t) {
        this.resolvedProperty.toArray(e, t)
      }
      _setValue_direct (e, t) {
        this.targetObject[this.propertyName] = e[t]
      }
      _setValue_direct_setNeedsUpdate (e, t) {
        ;(this.targetObject[this.propertyName] = e[t]),
          (this.targetObject.needsUpdate = !0)
      }
      _setValue_direct_setMatrixWorldNeedsUpdate (e, t) {
        ;(this.targetObject[this.propertyName] = e[t]),
          (this.targetObject.matrixWorldNeedsUpdate = !0)
      }
      _setValue_array (e, t) {
        const n = this.resolvedProperty
        for (let i = 0, r = n.length; i !== r; ++i) n[i] = e[t++]
      }
      _setValue_array_setNeedsUpdate (e, t) {
        const n = this.resolvedProperty
        for (let i = 0, r = n.length; i !== r; ++i) n[i] = e[t++]
        this.targetObject.needsUpdate = !0
      }
      _setValue_array_setMatrixWorldNeedsUpdate (e, t) {
        const n = this.resolvedProperty
        for (let i = 0, r = n.length; i !== r; ++i) n[i] = e[t++]
        this.targetObject.matrixWorldNeedsUpdate = !0
      }
      _setValue_arrayElement (e, t) {
        this.resolvedProperty[this.propertyIndex] = e[t]
      }
      _setValue_arrayElement_setNeedsUpdate (e, t) {
        ;(this.resolvedProperty[this.propertyIndex] = e[t]),
          (this.targetObject.needsUpdate = !0)
      }
      _setValue_arrayElement_setMatrixWorldNeedsUpdate (e, t) {
        ;(this.resolvedProperty[this.propertyIndex] = e[t]),
          (this.targetObject.matrixWorldNeedsUpdate = !0)
      }
      _setValue_fromArray (e, t) {
        this.resolvedProperty.fromArray(e, t)
      }
      _setValue_fromArray_setNeedsUpdate (e, t) {
        this.resolvedProperty.fromArray(e, t),
          (this.targetObject.needsUpdate = !0)
      }
      _setValue_fromArray_setMatrixWorldNeedsUpdate (e, t) {
        this.resolvedProperty.fromArray(e, t),
          (this.targetObject.matrixWorldNeedsUpdate = !0)
      }
      _getValue_unbound (e, t) {
        this.bind(), this.getValue(e, t)
      }
      _setValue_unbound (e, t) {
        this.bind(), this.setValue(e, t)
      }
      bind () {
        let e = this.node
        const t = this.parsedPath,
          n = t.objectName,
          i = t.propertyName
        let r = t.propertyIndex
        if (
          (e ||
            ((e = tm.findNode(this.rootNode, t.nodeName) || this.rootNode),
            (this.node = e)),
          (this.getValue = this._getValue_unavailable),
          (this.setValue = this._setValue_unavailable),
          !e)
        )
          return void console.error(
            'THREE.PropertyBinding: Trying to update node for track: ' +
              this.path +
              " but it wasn't found."
          )
        if (n) {
          let i = t.objectIndex
          switch (n) {
            case 'materials':
              if (!e.material)
                return void console.error(
                  'THREE.PropertyBinding: Can not bind to material as node does not have a material.',
                  this
                )
              if (!e.material.materials)
                return void console.error(
                  'THREE.PropertyBinding: Can not bind to material.materials as node.material does not have a materials array.',
                  this
                )
              e = e.material.materials
              break
            case 'bones':
              if (!e.skeleton)
                return void console.error(
                  'THREE.PropertyBinding: Can not bind to bones as node does not have a skeleton.',
                  this
                )
              e = e.skeleton.bones
              for (let t = 0; t < e.length; t++)
                if (e[t].name === i) {
                  i = t
                  break
                }
              break
            default:
              if (void 0 === e[n])
                return void console.error(
                  'THREE.PropertyBinding: Can not bind to objectName of node undefined.',
                  this
                )
              e = e[n]
          }
          if (void 0 !== i) {
            if (void 0 === e[i])
              return void console.error(
                'THREE.PropertyBinding: Trying to bind to objectIndex of objectName, but is undefined.',
                this,
                e
              )
            e = e[i]
          }
        }
        const a = e[i]
        if (void 0 === a) {
          const n = t.nodeName
          return void console.error(
            'THREE.PropertyBinding: Trying to update property for track: ' +
              n +
              '.' +
              i +
              " but it wasn't found.",
            e
          )
        }
        let s = this.Versioning.None
        ;(this.targetObject = e),
          void 0 !== e.needsUpdate
            ? (s = this.Versioning.NeedsUpdate)
            : void 0 !== e.matrixWorldNeedsUpdate &&
              (s = this.Versioning.MatrixWorldNeedsUpdate)
        let o = this.BindingType.Direct
        if (void 0 !== r) {
          if ('morphTargetInfluences' === i) {
            if (!e.geometry)
              return void console.error(
                'THREE.PropertyBinding: Can not bind to morphTargetInfluences because node does not have a geometry.',
                this
              )
            if (!e.geometry.isBufferGeometry)
              return void console.error(
                'THREE.PropertyBinding: Can not bind to morphTargetInfluences on THREE.Geometry. Use THREE.BufferGeometry instead.',
                this
              )
            if (!e.geometry.morphAttributes)
              return void console.error(
                'THREE.PropertyBinding: Can not bind to morphTargetInfluences because node does not have a geometry.morphAttributes.',
                this
              )
            void 0 !== e.morphTargetDictionary[r] &&
              (r = e.morphTargetDictionary[r])
          }
          ;(o = this.BindingType.ArrayElement),
            (this.resolvedProperty = a),
            (this.propertyIndex = r)
        } else
          void 0 !== a.fromArray && void 0 !== a.toArray
            ? ((o = this.BindingType.HasFromToArray),
              (this.resolvedProperty = a))
            : Array.isArray(a)
            ? ((o = this.BindingType.EntireArray), (this.resolvedProperty = a))
            : (this.propertyName = i)
        ;(this.getValue = this.GetterByBindingType[o]),
          (this.setValue = this.SetterByBindingTypeAndVersioning[o][s])
      }
      unbind () {
        ;(this.node = null),
          (this.getValue = this._getValue_unbound),
          (this.setValue = this._setValue_unbound)
      }
    }
    ;(tm.Composite = em),
      (tm.prototype.BindingType = {
        Direct: 0,
        EntireArray: 1,
        ArrayElement: 2,
        HasFromToArray: 3
      }),
      (tm.prototype.Versioning = {
        None: 0,
        NeedsUpdate: 1,
        MatrixWorldNeedsUpdate: 2
      }),
      (tm.prototype.GetterByBindingType = [
        tm.prototype._getValue_direct,
        tm.prototype._getValue_array,
        tm.prototype._getValue_arrayElement,
        tm.prototype._getValue_toArray
      ]),
      (tm.prototype.SetterByBindingTypeAndVersioning = [
        [
          tm.prototype._setValue_direct,
          tm.prototype._setValue_direct_setNeedsUpdate,
          tm.prototype._setValue_direct_setMatrixWorldNeedsUpdate
        ],
        [
          tm.prototype._setValue_array,
          tm.prototype._setValue_array_setNeedsUpdate,
          tm.prototype._setValue_array_setMatrixWorldNeedsUpdate
        ],
        [
          tm.prototype._setValue_arrayElement,
          tm.prototype._setValue_arrayElement_setNeedsUpdate,
          tm.prototype._setValue_arrayElement_setMatrixWorldNeedsUpdate
        ],
        [
          tm.prototype._setValue_fromArray,
          tm.prototype._setValue_fromArray_setNeedsUpdate,
          tm.prototype._setValue_fromArray_setMatrixWorldNeedsUpdate
        ]
      ])
    class nm {
      constructor () {
        ;(this.uuid = In()),
          (this._objects = Array.prototype.slice.call(arguments)),
          (this.nCachedObjects_ = 0)
        const e = {}
        this._indicesByUUID = e
        for (let n = 0, i = arguments.length; n !== i; ++n)
          e[arguments[n].uuid] = n
        ;(this._paths = []),
          (this._parsedPaths = []),
          (this._bindings = []),
          (this._bindingsIndicesByPath = {})
        const t = this
        this.stats = {
          objects: {
            get total () {
              return t._objects.length
            },
            get inUse () {
              return this.total - t.nCachedObjects_
            }
          },
          get bindingsPerObject () {
            return t._bindings.length
          }
        }
      }
      add () {
        const e = this._objects,
          t = this._indicesByUUID,
          n = this._paths,
          i = this._parsedPaths,
          r = this._bindings,
          a = r.length
        let s = void 0,
          o = e.length,
          l = this.nCachedObjects_
        for (let c = 0, h = arguments.length; c !== h; ++c) {
          const h = arguments[c],
            u = h.uuid
          let d = t[u]
          if (void 0 === d) {
            ;(d = o++), (t[u] = d), e.push(h)
            for (let e = 0, t = a; e !== t; ++e)
              r[e].push(new tm(h, n[e], i[e]))
          } else if (d < l) {
            s = e[d]
            const o = --l,
              c = e[o]
            ;(t[c.uuid] = d), (e[d] = c), (t[u] = o), (e[o] = h)
            for (let e = 0, t = a; e !== t; ++e) {
              const t = r[e],
                a = t[o]
              let s = t[d]
              ;(t[d] = a),
                void 0 === s && (s = new tm(h, n[e], i[e])),
                (t[o] = s)
            }
          } else
            e[d] !== s &&
              console.error(
                'THREE.AnimationObjectGroup: Different objects with the same UUID detected. Clean the caches or recreate your infrastructure when reloading scenes.'
              )
        }
        this.nCachedObjects_ = l
      }
      remove () {
        const e = this._objects,
          t = this._indicesByUUID,
          n = this._bindings,
          i = n.length
        let r = this.nCachedObjects_
        for (let a = 0, s = arguments.length; a !== s; ++a) {
          const s = arguments[a],
            o = s.uuid,
            l = t[o]
          if (void 0 !== l && l >= r) {
            const a = r++,
              c = e[a]
            ;(t[c.uuid] = l), (e[l] = c), (t[o] = a), (e[a] = s)
            for (let e = 0, t = i; e !== t; ++e) {
              const t = n[e],
                i = t[a],
                r = t[l]
              ;(t[l] = i), (t[a] = r)
            }
          }
        }
        this.nCachedObjects_ = r
      }
      uncache () {
        const e = this._objects,
          t = this._indicesByUUID,
          n = this._bindings,
          i = n.length
        let r = this.nCachedObjects_,
          a = e.length
        for (let s = 0, o = arguments.length; s !== o; ++s) {
          const o = arguments[s],
            l = o.uuid,
            c = t[l]
          if (void 0 !== c)
            if ((delete t[l], c < r)) {
              const s = --r,
                o = e[s],
                l = --a,
                h = e[l]
              ;(t[o.uuid] = c), (e[c] = o), (t[h.uuid] = s), (e[s] = h), e.pop()
              for (let e = 0, t = i; e !== t; ++e) {
                const t = n[e],
                  i = t[s],
                  r = t[l]
                ;(t[c] = i), (t[s] = r), t.pop()
              }
            } else {
              const r = --a,
                s = e[r]
              r > 0 && (t[s.uuid] = c), (e[c] = s), e.pop()
              for (let e = 0, t = i; e !== t; ++e) {
                const t = n[e]
                ;(t[c] = t[r]), t.pop()
              }
            }
        }
        this.nCachedObjects_ = r
      }
      subscribe_ (e, t) {
        const n = this._bindingsIndicesByPath
        let i = n[e]
        const r = this._bindings
        if (void 0 !== i) return r[i]
        const a = this._paths,
          s = this._parsedPaths,
          o = this._objects,
          l = o.length,
          c = this.nCachedObjects_,
          h = new Array(l)
        ;(i = r.length), (n[e] = i), a.push(e), s.push(t), r.push(h)
        for (let u = c, d = o.length; u !== d; ++u) {
          const n = o[u]
          h[u] = new tm(n, e, t)
        }
        return h
      }
      unsubscribe_ (e) {
        const t = this._bindingsIndicesByPath,
          n = t[e]
        if (void 0 !== n) {
          const i = this._paths,
            r = this._parsedPaths,
            a = this._bindings,
            s = a.length - 1,
            o = a[s],
            l = e[s]
          ;(t[l] = n),
            (a[n] = o),
            a.pop(),
            (r[n] = r[s]),
            r.pop(),
            (i[n] = i[s]),
            i.pop()
        }
      }
    }
    nm.prototype.isAnimationObjectGroup = !0
    class im {
      constructor (e, t, n = null, i = t.blendMode) {
        ;(this._mixer = e),
          (this._clip = t),
          (this._localRoot = n),
          (this.blendMode = i)
        const r = t.tracks,
          a = r.length,
          s = new Array(a),
          o = { endingStart: sn, endingEnd: sn }
        for (let l = 0; l !== a; ++l) {
          const e = r[l].createInterpolant(null)
          ;(s[l] = e), (e.settings = o)
        }
        ;(this._interpolantSettings = o),
          (this._interpolants = s),
          (this._propertyBindings = new Array(a)),
          (this._cacheIndex = null),
          (this._byClipCacheIndex = null),
          (this._timeScaleInterpolant = null),
          (this._weightInterpolant = null),
          (this.loop = en),
          (this._loopCount = -1),
          (this._startTime = null),
          (this.time = 0),
          (this.timeScale = 1),
          (this._effectiveTimeScale = 1),
          (this.weight = 1),
          (this._effectiveWeight = 1),
          (this.repetitions = 1 / 0),
          (this.paused = !1),
          (this.enabled = !0),
          (this.clampWhenFinished = !1),
          (this.zeroSlopeAtStart = !0),
          (this.zeroSlopeAtEnd = !0)
      }
      play () {
        return this._mixer._activateAction(this), this
      }
      stop () {
        return this._mixer._deactivateAction(this), this.reset()
      }
      reset () {
        return (
          (this.paused = !1),
          (this.enabled = !0),
          (this.time = 0),
          (this._loopCount = -1),
          (this._startTime = null),
          this.stopFading().stopWarping()
        )
      }
      isRunning () {
        return (
          this.enabled &&
          !this.paused &&
          0 !== this.timeScale &&
          null === this._startTime &&
          this._mixer._isActiveAction(this)
        )
      }
      isScheduled () {
        return this._mixer._isActiveAction(this)
      }
      startAt (e) {
        return (this._startTime = e), this
      }
      setLoop (e, t) {
        return (this.loop = e), (this.repetitions = t), this
      }
      setEffectiveWeight (e) {
        return (
          (this.weight = e),
          (this._effectiveWeight = this.enabled ? e : 0),
          this.stopFading()
        )
      }
      getEffectiveWeight () {
        return this._effectiveWeight
      }
      fadeIn (e) {
        return this._scheduleFading(e, 0, 1)
      }
      fadeOut (e) {
        return this._scheduleFading(e, 1, 0)
      }
      crossFadeFrom (e, t, n) {
        if ((e.fadeOut(t), this.fadeIn(t), n)) {
          const n = this._clip.duration,
            i = e._clip.duration,
            r = i / n,
            a = n / i
          e.warp(1, r, t), this.warp(a, 1, t)
        }
        return this
      }
      crossFadeTo (e, t, n) {
        return e.crossFadeFrom(this, t, n)
      }
      stopFading () {
        const e = this._weightInterpolant
        return (
          null !== e &&
            ((this._weightInterpolant = null),
            this._mixer._takeBackControlInterpolant(e)),
          this
        )
      }
      setEffectiveTimeScale (e) {
        return (
          (this.timeScale = e),
          (this._effectiveTimeScale = this.paused ? 0 : e),
          this.stopWarping()
        )
      }
      getEffectiveTimeScale () {
        return this._effectiveTimeScale
      }
      setDuration (e) {
        return (this.timeScale = this._clip.duration / e), this.stopWarping()
      }
      syncWith (e) {
        return (
          (this.time = e.time),
          (this.timeScale = e.timeScale),
          this.stopWarping()
        )
      }
      halt (e) {
        return this.warp(this._effectiveTimeScale, 0, e)
      }
      warp (e, t, n) {
        const i = this._mixer,
          r = i.time,
          a = this.timeScale
        let s = this._timeScaleInterpolant
        null === s &&
          ((s = i._lendControlInterpolant()), (this._timeScaleInterpolant = s))
        const o = s.parameterPositions,
          l = s.sampleValues
        return (o[0] = r), (o[1] = r + n), (l[0] = e / a), (l[1] = t / a), this
      }
      stopWarping () {
        const e = this._timeScaleInterpolant
        return (
          null !== e &&
            ((this._timeScaleInterpolant = null),
            this._mixer._takeBackControlInterpolant(e)),
          this
        )
      }
      getMixer () {
        return this._mixer
      }
      getClip () {
        return this._clip
      }
      getRoot () {
        return this._localRoot || this._mixer._root
      }
      _update (e, t, n, i) {
        if (!this.enabled) return void this._updateWeight(e)
        const r = this._startTime
        if (null !== r) {
          const i = (e - r) * n
          if (i < 0 || 0 === n) return
          ;(this._startTime = null), (t = n * i)
        }
        t *= this._updateTimeScale(e)
        const a = this._updateTime(t),
          s = this._updateWeight(e)
        if (s > 0) {
          const e = this._interpolants,
            t = this._propertyBindings
          switch (this.blendMode) {
            case hn:
              for (let n = 0, i = e.length; n !== i; ++n)
                e[n].evaluate(a), t[n].accumulateAdditive(s)
              break
            case cn:
            default:
              for (let n = 0, r = e.length; n !== r; ++n)
                e[n].evaluate(a), t[n].accumulate(i, s)
          }
        }
      }
      _updateWeight (e) {
        let t = 0
        if (this.enabled) {
          t = this.weight
          const n = this._weightInterpolant
          if (null !== n) {
            const i = n.evaluate(e)[0]
            ;(t *= i),
              e > n.parameterPositions[1] &&
                (this.stopFading(), 0 === i && (this.enabled = !1))
          }
        }
        return (this._effectiveWeight = t), t
      }
      _updateTimeScale (e) {
        let t = 0
        if (!this.paused) {
          t = this.timeScale
          const n = this._timeScaleInterpolant
          if (null !== n) {
            const i = n.evaluate(e)[0]
            ;(t *= i),
              e > n.parameterPositions[1] &&
                (this.stopWarping(),
                0 === t ? (this.paused = !0) : (this.timeScale = t))
          }
        }
        return (this._effectiveTimeScale = t), t
      }
      _updateTime (e) {
        const t = this._clip.duration,
          n = this.loop
        let i = this.time + e,
          r = this._loopCount
        const a = n === tn
        if (0 === e) return -1 === r ? i : a && 1 === (1 & r) ? t - i : i
        if (n === $t) {
          ;-1 === r && ((this._loopCount = 0), this._setEndings(!0, !0, !1))
          e: {
            if (i >= t) i = t
            else {
              if (!(i < 0)) {
                this.time = i
                break e
              }
              i = 0
            }
            this.clampWhenFinished ? (this.paused = !0) : (this.enabled = !1),
              (this.time = i),
              this._mixer.dispatchEvent({
                type: 'finished',
                action: this,
                direction: e < 0 ? -1 : 1
              })
          }
        } else {
          if (
            (-1 === r &&
              (e >= 0
                ? ((r = 0), this._setEndings(!0, 0 === this.repetitions, a))
                : this._setEndings(0 === this.repetitions, !0, a)),
            i >= t || i < 0)
          ) {
            const n = Math.floor(i / t)
            ;(i -= t * n), (r += Math.abs(n))
            const s = this.repetitions - r
            if (s <= 0)
              this.clampWhenFinished ? (this.paused = !0) : (this.enabled = !1),
                (i = e > 0 ? t : 0),
                (this.time = i),
                this._mixer.dispatchEvent({
                  type: 'finished',
                  action: this,
                  direction: e > 0 ? 1 : -1
                })
            else {
              if (1 === s) {
                const t = e < 0
                this._setEndings(t, !t, a)
              } else this._setEndings(!1, !1, a)
              ;(this._loopCount = r),
                (this.time = i),
                this._mixer.dispatchEvent({
                  type: 'loop',
                  action: this,
                  loopDelta: n
                })
            }
          } else this.time = i
          if (a && 1 === (1 & r)) return t - i
        }
        return i
      }
      _setEndings (e, t, n) {
        const i = this._interpolantSettings
        n
          ? ((i.endingStart = on), (i.endingEnd = on))
          : ((i.endingStart = e ? (this.zeroSlopeAtStart ? on : sn) : ln),
            (i.endingEnd = t ? (this.zeroSlopeAtEnd ? on : sn) : ln))
      }
      _scheduleFading (e, t, n) {
        const i = this._mixer,
          r = i.time
        let a = this._weightInterpolant
        null === a &&
          ((a = i._lendControlInterpolant()), (this._weightInterpolant = a))
        const s = a.parameterPositions,
          o = a.sampleValues
        return (s[0] = r), (o[0] = t), (s[1] = r + e), (o[1] = n), this
      }
    }
    class rm extends Ln {
      constructor (e) {
        super(),
          (this._root = e),
          this._initMemoryManager(),
          (this._accuIndex = 0),
          (this.time = 0),
          (this.timeScale = 1)
      }
      _bindAction (e, t) {
        const n = e._localRoot || this._root,
          i = e._clip.tracks,
          r = i.length,
          a = e._propertyBindings,
          s = e._interpolants,
          o = n.uuid,
          l = this._bindingsByRootAndName
        let c = l[o]
        void 0 === c && ((c = {}), (l[o] = c))
        for (let h = 0; h !== r; ++h) {
          const e = i[h],
            r = e.name
          let l = c[r]
          if (void 0 !== l) a[h] = l
          else {
            if (((l = a[h]), void 0 !== l)) {
              null === l._cacheIndex &&
                (++l.referenceCount, this._addInactiveBinding(l, o, r))
              continue
            }
            const i = t && t._propertyBindings[h].binding.parsedPath
            ;(l = new Vf(
              tm.create(n, r, i),
              e.ValueTypeName,
              e.getValueSize()
            )),
              ++l.referenceCount,
              this._addInactiveBinding(l, o, r),
              (a[h] = l)
          }
          s[h].resultBuffer = l.buffer
        }
      }
      _activateAction (e) {
        if (!this._isActiveAction(e)) {
          if (null === e._cacheIndex) {
            const t = (e._localRoot || this._root).uuid,
              n = e._clip.uuid,
              i = this._actionsByClip[n]
            this._bindAction(e, i && i.knownActions[0]),
              this._addInactiveAction(e, n, t)
          }
          const t = e._propertyBindings
          for (let e = 0, n = t.length; e !== n; ++e) {
            const n = t[e]
            0 === n.useCount++ && (this._lendBinding(n), n.saveOriginalState())
          }
          this._lendAction(e)
        }
      }
      _deactivateAction (e) {
        if (this._isActiveAction(e)) {
          const t = e._propertyBindings
          for (let e = 0, n = t.length; e !== n; ++e) {
            const n = t[e]
            0 === --n.useCount &&
              (n.restoreOriginalState(), this._takeBackBinding(n))
          }
          this._takeBackAction(e)
        }
      }
      _initMemoryManager () {
        ;(this._actions = []),
          (this._nActiveActions = 0),
          (this._actionsByClip = {}),
          (this._bindings = []),
          (this._nActiveBindings = 0),
          (this._bindingsByRootAndName = {}),
          (this._controlInterpolants = []),
          (this._nActiveControlInterpolants = 0)
        const e = this
        this.stats = {
          actions: {
            get total () {
              return e._actions.length
            },
            get inUse () {
              return e._nActiveActions
            }
          },
          bindings: {
            get total () {
              return e._bindings.length
            },
            get inUse () {
              return e._nActiveBindings
            }
          },
          controlInterpolants: {
            get total () {
              return e._controlInterpolants.length
            },
            get inUse () {
              return e._nActiveControlInterpolants
            }
          }
        }
      }
      _isActiveAction (e) {
        const t = e._cacheIndex
        return null !== t && t < this._nActiveActions
      }
      _addInactiveAction (e, t, n) {
        const i = this._actions,
          r = this._actionsByClip
        let a = r[t]
        if (void 0 === a)
          (a = { knownActions: [e], actionByRoot: {} }),
            (e._byClipCacheIndex = 0),
            (r[t] = a)
        else {
          const t = a.knownActions
          ;(e._byClipCacheIndex = t.length), t.push(e)
        }
        ;(e._cacheIndex = i.length), i.push(e), (a.actionByRoot[n] = e)
      }
      _removeInactiveAction (e) {
        const t = this._actions,
          n = t[t.length - 1],
          i = e._cacheIndex
        ;(n._cacheIndex = i), (t[i] = n), t.pop(), (e._cacheIndex = null)
        const r = e._clip.uuid,
          a = this._actionsByClip,
          s = a[r],
          o = s.knownActions,
          l = o[o.length - 1],
          c = e._byClipCacheIndex
        ;(l._byClipCacheIndex = c),
          (o[c] = l),
          o.pop(),
          (e._byClipCacheIndex = null)
        const h = s.actionByRoot,
          u = (e._localRoot || this._root).uuid
        delete h[u],
          0 === o.length && delete a[r],
          this._removeInactiveBindingsForAction(e)
      }
      _removeInactiveBindingsForAction (e) {
        const t = e._propertyBindings
        for (let n = 0, i = t.length; n !== i; ++n) {
          const e = t[n]
          0 === --e.referenceCount && this._removeInactiveBinding(e)
        }
      }
      _lendAction (e) {
        const t = this._actions,
          n = e._cacheIndex,
          i = this._nActiveActions++,
          r = t[i]
        ;(e._cacheIndex = i), (t[i] = e), (r._cacheIndex = n), (t[n] = r)
      }
      _takeBackAction (e) {
        const t = this._actions,
          n = e._cacheIndex,
          i = --this._nActiveActions,
          r = t[i]
        ;(e._cacheIndex = i), (t[i] = e), (r._cacheIndex = n), (t[n] = r)
      }
      _addInactiveBinding (e, t, n) {
        const i = this._bindingsByRootAndName,
          r = this._bindings
        let a = i[t]
        void 0 === a && ((a = {}), (i[t] = a)),
          (a[n] = e),
          (e._cacheIndex = r.length),
          r.push(e)
      }
      _removeInactiveBinding (e) {
        const t = this._bindings,
          n = e.binding,
          i = n.rootNode.uuid,
          r = n.path,
          a = this._bindingsByRootAndName,
          s = a[i],
          o = t[t.length - 1],
          l = e._cacheIndex
        ;(o._cacheIndex = l),
          (t[l] = o),
          t.pop(),
          delete s[r],
          0 === Object.keys(s).length && delete a[i]
      }
      _lendBinding (e) {
        const t = this._bindings,
          n = e._cacheIndex,
          i = this._nActiveBindings++,
          r = t[i]
        ;(e._cacheIndex = i), (t[i] = e), (r._cacheIndex = n), (t[n] = r)
      }
      _takeBackBinding (e) {
        const t = this._bindings,
          n = e._cacheIndex,
          i = --this._nActiveBindings,
          r = t[i]
        ;(e._cacheIndex = i), (t[i] = e), (r._cacheIndex = n), (t[n] = r)
      }
      _lendControlInterpolant () {
        const e = this._controlInterpolants,
          t = this._nActiveControlInterpolants++
        let n = e[t]
        return (
          void 0 === n &&
            ((n = new Cp(
              new Float32Array(2),
              new Float32Array(2),
              1,
              this._controlInterpolantsResultBuffer
            )),
            (n.__cacheIndex = t),
            (e[t] = n)),
          n
        )
      }
      _takeBackControlInterpolant (e) {
        const t = this._controlInterpolants,
          n = e.__cacheIndex,
          i = --this._nActiveControlInterpolants,
          r = t[i]
        ;(e.__cacheIndex = i), (t[i] = e), (r.__cacheIndex = n), (t[n] = r)
      }
      clipAction (e, t, n) {
        const i = t || this._root,
          r = i.uuid
        let a = 'string' === typeof e ? kp.findByName(i, e) : e
        const s = null !== a ? a.uuid : e,
          o = this._actionsByClip[s]
        let l = null
        if (
          (void 0 === n && (n = null !== a ? a.blendMode : cn), void 0 !== o)
        ) {
          const e = o.actionByRoot[r]
          if (void 0 !== e && e.blendMode === n) return e
          ;(l = o.knownActions[0]), null === a && (a = l._clip)
        }
        if (null === a) return null
        const c = new im(this, a, t, n)
        return this._bindAction(c, l), this._addInactiveAction(c, s, r), c
      }
      existingAction (e, t) {
        const n = t || this._root,
          i = n.uuid,
          r = 'string' === typeof e ? kp.findByName(n, e) : e,
          a = r ? r.uuid : e,
          s = this._actionsByClip[a]
        return (void 0 !== s && s.actionByRoot[i]) || null
      }
      stopAllAction () {
        const e = this._actions,
          t = this._nActiveActions
        for (let n = t - 1; n >= 0; --n) e[n].stop()
        return this
      }
      update (e) {
        e *= this.timeScale
        const t = this._actions,
          n = this._nActiveActions,
          i = (this.time += e),
          r = Math.sign(e),
          a = (this._accuIndex ^= 1)
        for (let l = 0; l !== n; ++l) {
          const n = t[l]
          n._update(i, e, r, a)
        }
        const s = this._bindings,
          o = this._nActiveBindings
        for (let l = 0; l !== o; ++l) s[l].apply(a)
        return this
      }
      setTime (e) {
        this.time = 0
        for (let t = 0; t < this._actions.length; t++) this._actions[t].time = 0
        return this.update(e)
      }
      getRoot () {
        return this._root
      }
      uncacheClip (e) {
        const t = this._actions,
          n = e.uuid,
          i = this._actionsByClip,
          r = i[n]
        if (void 0 !== r) {
          const e = r.knownActions
          for (let n = 0, i = e.length; n !== i; ++n) {
            const i = e[n]
            this._deactivateAction(i)
            const r = i._cacheIndex,
              a = t[t.length - 1]
            ;(i._cacheIndex = null),
              (i._byClipCacheIndex = null),
              (a._cacheIndex = r),
              (t[r] = a),
              t.pop(),
              this._removeInactiveBindingsForAction(i)
          }
          delete i[n]
        }
      }
      uncacheRoot (e) {
        const t = e.uuid,
          n = this._actionsByClip
        for (const a in n) {
          const e = n[a].actionByRoot,
            i = e[t]
          void 0 !== i &&
            (this._deactivateAction(i), this._removeInactiveAction(i))
        }
        const i = this._bindingsByRootAndName,
          r = i[t]
        if (void 0 !== r)
          for (const a in r) {
            const e = r[a]
            e.restoreOriginalState(), this._removeInactiveBinding(e)
          }
      }
      uncacheAction (e, t) {
        const n = this.existingAction(e, t)
        null !== n && (this._deactivateAction(n), this._removeInactiveAction(n))
      }
    }
    rm.prototype._controlInterpolantsResultBuffer = new Float32Array(1)
    class am {
      constructor (e) {
        'string' === typeof e &&
          (console.warn('THREE.Uniform: Type parameter is no longer needed.'),
          (e = arguments[1])),
          (this.value = e)
      }
      clone () {
        return new am(
          void 0 === this.value.clone ? this.value : this.value.clone()
        )
      }
    }
    class sm extends Rh {
      constructor (e, t, n = 1) {
        super(e, t), (this.meshPerAttribute = n)
      }
      copy (e) {
        return super.copy(e), (this.meshPerAttribute = e.meshPerAttribute), this
      }
      clone (e) {
        const t = super.clone(e)
        return (t.meshPerAttribute = this.meshPerAttribute), t
      }
      toJSON (e) {
        const t = super.toJSON(e)
        return (
          (t.isInstancedInterleavedBuffer = !0),
          (t.meshPerAttribute = this.meshPerAttribute),
          t
        )
      }
    }
    sm.prototype.isInstancedInterleavedBuffer = !0
    class om {
      constructor (e, t, n, i, r) {
        ;(this.buffer = e),
          (this.type = t),
          (this.itemSize = n),
          (this.elementSize = i),
          (this.count = r),
          (this.version = 0)
      }
      set needsUpdate (e) {
        !0 === e && this.version++
      }
      setBuffer (e) {
        return (this.buffer = e), this
      }
      setType (e, t) {
        return (this.type = e), (this.elementSize = t), this
      }
      setItemSize (e) {
        return (this.itemSize = e), this
      }
      setCount (e) {
        return (this.count = e), this
      }
    }
    om.prototype.isGLBufferAttribute = !0
    const lm = new kn()
    class cm {
      constructor (e = new kn(1 / 0, 1 / 0), t = new kn(-1 / 0, -1 / 0)) {
        ;(this.min = e), (this.max = t)
      }
      set (e, t) {
        return this.min.copy(e), this.max.copy(t), this
      }
      setFromPoints (e) {
        this.makeEmpty()
        for (let t = 0, n = e.length; t < n; t++) this.expandByPoint(e[t])
        return this
      }
      setFromCenterAndSize (e, t) {
        const n = lm.copy(t).multiplyScalar(0.5)
        return this.min.copy(e).sub(n), this.max.copy(e).add(n), this
      }
      clone () {
        return new this.constructor().copy(this)
      }
      copy (e) {
        return this.min.copy(e.min), this.max.copy(e.max), this
      }
      makeEmpty () {
        return (
          (this.min.x = this.min.y = 1 / 0),
          (this.max.x = this.max.y = -1 / 0),
          this
        )
      }
      isEmpty () {
        return this.max.x < this.min.x || this.max.y < this.min.y
      }
      getCenter (e) {
        return this.isEmpty()
          ? e.set(0, 0)
          : e.addVectors(this.min, this.max).multiplyScalar(0.5)
      }
      getSize (e) {
        return this.isEmpty() ? e.set(0, 0) : e.subVectors(this.max, this.min)
      }
      expandByPoint (e) {
        return this.min.min(e), this.max.max(e), this
      }
      expandByVector (e) {
        return this.min.sub(e), this.max.add(e), this
      }
      expandByScalar (e) {
        return this.min.addScalar(-e), this.max.addScalar(e), this
      }
      containsPoint (e) {
        return !(
          e.x < this.min.x ||
          e.x > this.max.x ||
          e.y < this.min.y ||
          e.y > this.max.y
        )
      }
      containsBox (e) {
        return (
          this.min.x <= e.min.x &&
          e.max.x <= this.max.x &&
          this.min.y <= e.min.y &&
          e.max.y <= this.max.y
        )
      }
      getParameter (e, t) {
        return t.set(
          (e.x - this.min.x) / (this.max.x - this.min.x),
          (e.y - this.min.y) / (this.max.y - this.min.y)
        )
      }
      intersectsBox (e) {
        return !(
          e.max.x < this.min.x ||
          e.min.x > this.max.x ||
          e.max.y < this.min.y ||
          e.min.y > this.max.y
        )
      }
      clampPoint (e, t) {
        return t.copy(e).clamp(this.min, this.max)
      }
      distanceToPoint (e) {
        const t = lm.copy(e).clamp(this.min, this.max)
        return t.sub(e).length()
      }
      intersect (e) {
        return this.min.max(e.min), this.max.min(e.max), this
      }
      union (e) {
        return this.min.min(e.min), this.max.max(e.max), this
      }
      translate (e) {
        return this.min.add(e), this.max.add(e), this
      }
      equals (e) {
        return e.min.equals(this.min) && e.max.equals(this.max)
      }
    }
    cm.prototype.isBox2 = !0
    const hm = new Qn(),
      um = new Qn()
    class dm {
      constructor (e = new Qn(), t = new Qn()) {
        ;(this.start = e), (this.end = t)
      }
      set (e, t) {
        return this.start.copy(e), this.end.copy(t), this
      }
      copy (e) {
        return this.start.copy(e.start), this.end.copy(e.end), this
      }
      getCenter (e) {
        return e.addVectors(this.start, this.end).multiplyScalar(0.5)
      }
      delta (e) {
        return e.subVectors(this.end, this.start)
      }
      distanceSq () {
        return this.start.distanceToSquared(this.end)
      }
      distance () {
        return this.start.distanceTo(this.end)
      }
      at (e, t) {
        return this.delta(t)
          .multiplyScalar(e)
          .add(this.start)
      }
      closestPointToPointParameter (e, t) {
        hm.subVectors(e, this.start), um.subVectors(this.end, this.start)
        const n = um.dot(um),
          i = um.dot(hm)
        let r = i / n
        return t && (r = Nn(r, 0, 1)), r
      }
      closestPointToPoint (e, t, n) {
        const i = this.closestPointToPointParameter(e, t)
        return this.delta(n)
          .multiplyScalar(i)
          .add(this.start)
      }
      applyMatrix4 (e) {
        return this.start.applyMatrix4(e), this.end.applyMatrix4(e), this
      }
      equals (e) {
        return e.start.equals(this.start) && e.end.equals(this.end)
      }
      clone () {
        return new this.constructor().copy(this)
      }
    }
    class pm extends er {
      constructor (e) {
        super(),
          (this.material = e),
          (this.render = function () {}),
          (this.hasPositions = !1),
          (this.hasNormals = !1),
          (this.hasColors = !1),
          (this.hasUvs = !1),
          (this.positionArray = null),
          (this.normalArray = null),
          (this.colorArray = null),
          (this.uvArray = null),
          (this.count = 0)
      }
    }
    pm.prototype.isImmediateRenderObject = !0
    const fm = new Qn(),
      mm = new Li(),
      gm = new Li()
    class vm extends wu {
      constructor (e) {
        const t = ym(e),
          n = new Ur(),
          i = [],
          r = [],
          a = new xr(0, 0, 1),
          s = new xr(0, 1, 0)
        for (let l = 0; l < t.length; l++) {
          const e = t[l]
          e.parent &&
            e.parent.isBone &&
            (i.push(0, 0, 0),
            i.push(0, 0, 0),
            r.push(a.r, a.g, a.b),
            r.push(s.r, s.g, s.b))
        }
        n.setAttribute('position', new Rr(i, 3)),
          n.setAttribute('color', new Rr(r, 3))
        const o = new du({
          vertexColors: !0,
          depthTest: !1,
          depthWrite: !1,
          toneMapped: !1,
          transparent: !0
        })
        super(n, o),
          (this.type = 'SkeletonHelper'),
          (this.isSkeletonHelper = !0),
          (this.root = e),
          (this.bones = t),
          (this.matrix = e.matrixWorld),
          (this.matrixAutoUpdate = !1)
      }
      updateMatrixWorld (e) {
        const t = this.bones,
          n = this.geometry,
          i = n.getAttribute('position')
        gm.copy(this.root.matrixWorld).invert()
        for (let r = 0, a = 0; r < t.length; r++) {
          const e = t[r]
          e.parent &&
            e.parent.isBone &&
            (mm.multiplyMatrices(gm, e.matrixWorld),
            fm.setFromMatrixPosition(mm),
            i.setXYZ(a, fm.x, fm.y, fm.z),
            mm.multiplyMatrices(gm, e.parent.matrixWorld),
            fm.setFromMatrixPosition(mm),
            i.setXYZ(a + 1, fm.x, fm.y, fm.z),
            (a += 2))
        }
        ;(n.getAttribute('position').needsUpdate = !0),
          super.updateMatrixWorld(e)
      }
    }
    function ym (e) {
      const t = []
      e && e.isBone && t.push(e)
      for (let n = 0; n < e.children.length; n++)
        t.push.apply(t, ym(e.children[n]))
      return t
    }
    class _m extends wu {
      constructor (e = 10, t = 10, n = 4473924, i = 8947848) {
        ;(n = new xr(n)), (i = new xr(i))
        const r = t / 2,
          a = e / t,
          s = e / 2,
          o = [],
          l = []
        for (let u = 0, d = 0, p = -s; u <= t; u++, p += a) {
          o.push(-s, 0, p, s, 0, p), o.push(p, 0, -s, p, 0, s)
          const e = u === r ? n : i
          e.toArray(l, d),
            (d += 3),
            e.toArray(l, d),
            (d += 3),
            e.toArray(l, d),
            (d += 3),
            e.toArray(l, d),
            (d += 3)
        }
        const c = new Ur()
        c.setAttribute('position', new Rr(o, 3)),
          c.setAttribute('color', new Rr(l, 3))
        const h = new du({ vertexColors: !0, toneMapped: !1 })
        super(c, h), (this.type = 'GridHelper')
      }
    }
    const xm = new Float32Array(1)
    new Int32Array(xm.buffer)
    const wm = 4,
      bm = 8,
      Mm = (Math.pow(2, bm), [0.125, 0.215, 0.35, 0.446, 0.526, 0.582]),
      Sm = bm - wm + 1 + Mm.length,
      Em = new wr({ side: z, depthWrite: !1, depthTest: !1 }),
      { _lodPlanes: Tm, _sizeLods: Am, _sigmas: Rm } = (new ia(new sa(), Em),
      Lm())
    Math.sqrt(5)
    function Lm () {
      const e = [],
        t = [],
        n = []
      let i = bm
      for (let r = 0; r < Sm; r++) {
        const a = Math.pow(2, i)
        t.push(a)
        let s = 1 / a
        r > bm - wm ? (s = Mm[r - bm + wm - 1]) : 0 == r && (s = 0), n.push(s)
        const o = 1 / (a - 1),
          l = -o / 2,
          c = 1 + o / 2,
          h = [l, l, c, l, c, c, l, l, c, c, l, c],
          u = 6,
          d = 6,
          p = 3,
          f = 2,
          m = 1,
          g = new Float32Array(p * d * u),
          v = new Float32Array(f * d * u),
          y = new Float32Array(m * d * u)
        for (let e = 0; e < u; e++) {
          const t = ((e % 3) * 2) / 3 - 1,
            n = e > 2 ? 0 : -1,
            i = [
              t,
              n,
              0,
              t + 2 / 3,
              n,
              0,
              t + 2 / 3,
              n + 1,
              0,
              t,
              n,
              0,
              t + 2 / 3,
              n + 1,
              0,
              t,
              n + 1,
              0
            ]
          g.set(i, p * d * e), v.set(h, f * d * e)
          const r = [e, e, e, e, e, e]
          y.set(r, m * d * e)
        }
        const _ = new Ur()
        _.setAttribute('position', new Sr(g, p)),
          _.setAttribute('uv', new Sr(v, f)),
          _.setAttribute('faceIndex', new Sr(y, m)),
          e.push(_),
          i > wm && i--
      }
      return { _lodPlanes: e, _sizeLods: t, _sigmas: n }
    }
    ;(Gu.create = function (e, t) {
      return (
        console.log('THREE.Curve.create() has been deprecated'),
        (e.prototype = Object.create(Gu.prototype)),
        (e.prototype.constructor = e),
        (e.prototype.getPoint = t),
        e
      )
    }),
      ($p.prototype.fromPoints = function (e) {
        return (
          console.warn(
            'THREE.Path: .fromPoints() has been renamed to .setFromPoints().'
          ),
          this.setFromPoints(e)
        )
      }),
      (_m.prototype.setColors = function () {
        console.error(
          'THREE.GridHelper: setColors() has been deprecated, pass them in the constructor instead.'
        )
      }),
      (vm.prototype.update = function () {
        console.error(
          'THREE.SkeletonHelper: update() no longer needs to be called.'
        )
      }),
      (qp.prototype.extractUrlBase = function (e) {
        return (
          console.warn(
            'THREE.Loader: .extractUrlBase() has been deprecated. Use THREE.LoaderUtils.extractUrlBase() instead.'
          ),
          Mf.extractUrlBase(e)
        )
      }),
      (qp.Handlers = {
        add: function () {
          console.error(
            'THREE.Loader: Handlers.add() has been removed. Use LoadingManager.addHandler() instead.'
          )
        },
        get: function () {
          console.error(
            'THREE.Loader: Handlers.get() has been removed. Use LoadingManager.getHandler() instead.'
          )
        }
      }),
      (cm.prototype.center = function (e) {
        return (
          console.warn(
            'THREE.Box2: .center() has been renamed to .getCenter().'
          ),
          this.getCenter(e)
        )
      }),
      (cm.prototype.empty = function () {
        return (
          console.warn('THREE.Box2: .empty() has been renamed to .isEmpty().'),
          this.isEmpty()
        )
      }),
      (cm.prototype.isIntersectionBox = function (e) {
        return (
          console.warn(
            'THREE.Box2: .isIntersectionBox() has been renamed to .intersectsBox().'
          ),
          this.intersectsBox(e)
        )
      }),
      (cm.prototype.size = function (e) {
        return (
          console.warn('THREE.Box2: .size() has been renamed to .getSize().'),
          this.getSize(e)
        )
      }),
      (ti.prototype.center = function (e) {
        return (
          console.warn(
            'THREE.Box3: .center() has been renamed to .getCenter().'
          ),
          this.getCenter(e)
        )
      }),
      (ti.prototype.empty = function () {
        return (
          console.warn('THREE.Box3: .empty() has been renamed to .isEmpty().'),
          this.isEmpty()
        )
      }),
      (ti.prototype.isIntersectionBox = function (e) {
        return (
          console.warn(
            'THREE.Box3: .isIntersectionBox() has been renamed to .intersectsBox().'
          ),
          this.intersectsBox(e)
        )
      }),
      (ti.prototype.isIntersectionSphere = function (e) {
        return (
          console.warn(
            'THREE.Box3: .isIntersectionSphere() has been renamed to .intersectsSphere().'
          ),
          this.intersectsSphere(e)
        )
      }),
      (ti.prototype.size = function (e) {
        return (
          console.warn('THREE.Box3: .size() has been renamed to .getSize().'),
          this.getSize(e)
        )
      }),
      (xi.prototype.empty = function () {
        return (
          console.warn(
            'THREE.Sphere: .empty() has been renamed to .isEmpty().'
          ),
          this.isEmpty()
        )
      }),
      (Ta.prototype.setFromMatrix = function (e) {
        return (
          console.warn(
            'THREE.Frustum: .setFromMatrix() has been renamed to .setFromProjectionMatrix().'
          ),
          this.setFromProjectionMatrix(e)
        )
      }),
      (dm.prototype.center = function (e) {
        return (
          console.warn(
            'THREE.Line3: .center() has been renamed to .getCenter().'
          ),
          this.getCenter(e)
        )
      }),
      (Hn.prototype.flattenToArrayOffset = function (e, t) {
        return (
          console.warn(
            'THREE.Matrix3: .flattenToArrayOffset() has been deprecated. Use .toArray() instead.'
          ),
          this.toArray(e, t)
        )
      }),
      (Hn.prototype.multiplyVector3 = function (e) {
        return (
          console.warn(
            'THREE.Matrix3: .multiplyVector3() has been removed. Use vector.applyMatrix3( matrix ) instead.'
          ),
          e.applyMatrix3(this)
        )
      }),
      (Hn.prototype.multiplyVector3Array = function () {
        console.error(
          'THREE.Matrix3: .multiplyVector3Array() has been removed.'
        )
      }),
      (Hn.prototype.applyToBufferAttribute = function (e) {
        return (
          console.warn(
            'THREE.Matrix3: .applyToBufferAttribute() has been removed. Use attribute.applyMatrix3( matrix ) instead.'
          ),
          e.applyMatrix3(this)
        )
      }),
      (Hn.prototype.applyToVector3Array = function () {
        console.error('THREE.Matrix3: .applyToVector3Array() has been removed.')
      }),
      (Hn.prototype.getInverse = function (e) {
        return (
          console.warn(
            'THREE.Matrix3: .getInverse() has been removed. Use matrixInv.copy( matrix ).invert(); instead.'
          ),
          this.copy(e).invert()
        )
      }),
      (Li.prototype.extractPosition = function (e) {
        return (
          console.warn(
            'THREE.Matrix4: .extractPosition() has been renamed to .copyPosition().'
          ),
          this.copyPosition(e)
        )
      }),
      (Li.prototype.flattenToArrayOffset = function (e, t) {
        return (
          console.warn(
            'THREE.Matrix4: .flattenToArrayOffset() has been deprecated. Use .toArray() instead.'
          ),
          this.toArray(e, t)
        )
      }),
      (Li.prototype.getPosition = function () {
        return (
          console.warn(
            'THREE.Matrix4: .getPosition() has been removed. Use Vector3.setFromMatrixPosition( matrix ) instead.'
          ),
          new Qn().setFromMatrixColumn(this, 3)
        )
      }),
      (Li.prototype.setRotationFromQuaternion = function (e) {
        return (
          console.warn(
            'THREE.Matrix4: .setRotationFromQuaternion() has been renamed to .makeRotationFromQuaternion().'
          ),
          this.makeRotationFromQuaternion(e)
        )
      }),
      (Li.prototype.multiplyToArray = function () {
        console.warn('THREE.Matrix4: .multiplyToArray() has been removed.')
      }),
      (Li.prototype.multiplyVector3 = function (e) {
        return (
          console.warn(
            'THREE.Matrix4: .multiplyVector3() has been removed. Use vector.applyMatrix4( matrix ) instead.'
          ),
          e.applyMatrix4(this)
        )
      }),
      (Li.prototype.multiplyVector4 = function (e) {
        return (
          console.warn(
            'THREE.Matrix4: .multiplyVector4() has been removed. Use vector.applyMatrix4( matrix ) instead.'
          ),
          e.applyMatrix4(this)
        )
      }),
      (Li.prototype.multiplyVector3Array = function () {
        console.error(
          'THREE.Matrix4: .multiplyVector3Array() has been removed.'
        )
      }),
      (Li.prototype.rotateAxis = function (e) {
        console.warn(
          'THREE.Matrix4: .rotateAxis() has been removed. Use Vector3.transformDirection( matrix ) instead.'
        ),
          e.transformDirection(this)
      }),
      (Li.prototype.crossVector = function (e) {
        return (
          console.warn(
            'THREE.Matrix4: .crossVector() has been removed. Use vector.applyMatrix4( matrix ) instead.'
          ),
          e.applyMatrix4(this)
        )
      }),
      (Li.prototype.translate = function () {
        console.error('THREE.Matrix4: .translate() has been removed.')
      }),
      (Li.prototype.rotateX = function () {
        console.error('THREE.Matrix4: .rotateX() has been removed.')
      }),
      (Li.prototype.rotateY = function () {
        console.error('THREE.Matrix4: .rotateY() has been removed.')
      }),
      (Li.prototype.rotateZ = function () {
        console.error('THREE.Matrix4: .rotateZ() has been removed.')
      }),
      (Li.prototype.rotateByAxis = function () {
        console.error('THREE.Matrix4: .rotateByAxis() has been removed.')
      }),
      (Li.prototype.applyToBufferAttribute = function (e) {
        return (
          console.warn(
            'THREE.Matrix4: .applyToBufferAttribute() has been removed. Use attribute.applyMatrix4( matrix ) instead.'
          ),
          e.applyMatrix4(this)
        )
      }),
      (Li.prototype.applyToVector3Array = function () {
        console.error('THREE.Matrix4: .applyToVector3Array() has been removed.')
      }),
      (Li.prototype.makeFrustum = function (e, t, n, i, r, a) {
        return (
          console.warn(
            'THREE.Matrix4: .makeFrustum() has been removed. Use .makePerspective( left, right, top, bottom, near, far ) instead.'
          ),
          this.makePerspective(e, t, i, n, r, a)
        )
      }),
      (Li.prototype.getInverse = function (e) {
        return (
          console.warn(
            'THREE.Matrix4: .getInverse() has been removed. Use matrixInv.copy( matrix ).invert(); instead.'
          ),
          this.copy(e).invert()
        )
      }),
      (Ma.prototype.isIntersectionLine = function (e) {
        return (
          console.warn(
            'THREE.Plane: .isIntersectionLine() has been renamed to .intersectsLine().'
          ),
          this.intersectsLine(e)
        )
      }),
      (Kn.prototype.multiplyVector3 = function (e) {
        return (
          console.warn(
            'THREE.Quaternion: .multiplyVector3() has been removed. Use is now vector.applyQuaternion( quaternion ) instead.'
          ),
          e.applyQuaternion(this)
        )
      }),
      (Kn.prototype.inverse = function () {
        return (
          console.warn(
            'THREE.Quaternion: .inverse() has been renamed to invert().'
          ),
          this.invert()
        )
      }),
      (Ri.prototype.isIntersectionBox = function (e) {
        return (
          console.warn(
            'THREE.Ray: .isIntersectionBox() has been renamed to .intersectsBox().'
          ),
          this.intersectsBox(e)
        )
      }),
      (Ri.prototype.isIntersectionPlane = function (e) {
        return (
          console.warn(
            'THREE.Ray: .isIntersectionPlane() has been renamed to .intersectsPlane().'
          ),
          this.intersectsPlane(e)
        )
      }),
      (Ri.prototype.isIntersectionSphere = function (e) {
        return (
          console.warn(
            'THREE.Ray: .isIntersectionSphere() has been renamed to .intersectsSphere().'
          ),
          this.intersectsSphere(e)
        )
      }),
      (ur.prototype.area = function () {
        return (
          console.warn(
            'THREE.Triangle: .area() has been renamed to .getArea().'
          ),
          this.getArea()
        )
      }),
      (ur.prototype.barycoordFromPoint = function (e, t) {
        return (
          console.warn(
            'THREE.Triangle: .barycoordFromPoint() has been renamed to .getBarycoord().'
          ),
          this.getBarycoord(e, t)
        )
      }),
      (ur.prototype.midpoint = function (e) {
        return (
          console.warn(
            'THREE.Triangle: .midpoint() has been renamed to .getMidpoint().'
          ),
          this.getMidpoint(e)
        )
      }),
      (ur.prototypenormal = function (e) {
        return (
          console.warn(
            'THREE.Triangle: .normal() has been renamed to .getNormal().'
          ),
          this.getNormal(e)
        )
      }),
      (ur.prototype.plane = function (e) {
        return (
          console.warn(
            'THREE.Triangle: .plane() has been renamed to .getPlane().'
          ),
          this.getPlane(e)
        )
      }),
      (ur.barycoordFromPoint = function (e, t, n, i, r) {
        return (
          console.warn(
            'THREE.Triangle: .barycoordFromPoint() has been renamed to .getBarycoord().'
          ),
          ur.getBarycoord(e, t, n, i, r)
        )
      }),
      (ur.normal = function (e, t, n, i) {
        return (
          console.warn(
            'THREE.Triangle: .normal() has been renamed to .getNormal().'
          ),
          ur.getNormal(e, t, n, i)
        )
      }),
      (ef.prototype.extractAllPoints = function (e) {
        return (
          console.warn(
            'THREE.Shape: .extractAllPoints() has been removed. Use .extractPoints() instead.'
          ),
          this.extractPoints(e)
        )
      }),
      (ef.prototype.extrude = function (e) {
        return (
          console.warn(
            'THREE.Shape: .extrude() has been removed. Use ExtrudeGeometry() instead.'
          ),
          new Qd(this, e)
        )
      }),
      (ef.prototype.makeGeometry = function (e) {
        return (
          console.warn(
            'THREE.Shape: .makeGeometry() has been removed. Use ShapeGeometry() instead.'
          ),
          new sp(this, e)
        )
      }),
      (kn.prototype.fromAttribute = function (e, t, n) {
        return (
          console.warn(
            'THREE.Vector2: .fromAttribute() has been renamed to .fromBufferAttribute().'
          ),
          this.fromBufferAttribute(e, t, n)
        )
      }),
      (kn.prototype.distanceToManhattan = function (e) {
        return (
          console.warn(
            'THREE.Vector2: .distanceToManhattan() has been renamed to .manhattanDistanceTo().'
          ),
          this.manhattanDistanceTo(e)
        )
      }),
      (kn.prototype.lengthManhattan = function () {
        return (
          console.warn(
            'THREE.Vector2: .lengthManhattan() has been renamed to .manhattanLength().'
          ),
          this.manhattanLength()
        )
      }),
      (Qn.prototype.setEulerFromRotationMatrix = function () {
        console.error(
          'THREE.Vector3: .setEulerFromRotationMatrix() has been removed. Use Euler.setFromRotationMatrix() instead.'
        )
      }),
      (Qn.prototype.setEulerFromQuaternion = function () {
        console.error(
          'THREE.Vector3: .setEulerFromQuaternion() has been removed. Use Euler.setFromQuaternion() instead.'
        )
      }),
      (Qn.prototype.getPositionFromMatrix = function (e) {
        return (
          console.warn(
            'THREE.Vector3: .getPositionFromMatrix() has been renamed to .setFromMatrixPosition().'
          ),
          this.setFromMatrixPosition(e)
        )
      }),
      (Qn.prototype.getScaleFromMatrix = function (e) {
        return (
          console.warn(
            'THREE.Vector3: .getScaleFromMatrix() has been renamed to .setFromMatrixScale().'
          ),
          this.setFromMatrixScale(e)
        )
      }),
      (Qn.prototype.getColumnFromMatrix = function (e, t) {
        return (
          console.warn(
            'THREE.Vector3: .getColumnFromMatrix() has been renamed to .setFromMatrixColumn().'
          ),
          this.setFromMatrixColumn(t, e)
        )
      }),
      (Qn.prototype.applyProjection = function (e) {
        return (
          console.warn(
            'THREE.Vector3: .applyProjection() has been removed. Use .applyMatrix4( m ) instead.'
          ),
          this.applyMatrix4(e)
        )
      }),
      (Qn.prototype.fromAttribute = function (e, t, n) {
        return (
          console.warn(
            'THREE.Vector3: .fromAttribute() has been renamed to .fromBufferAttribute().'
          ),
          this.fromBufferAttribute(e, t, n)
        )
      }),
      (Qn.prototype.distanceToManhattan = function (e) {
        return (
          console.warn(
            'THREE.Vector3: .distanceToManhattan() has been renamed to .manhattanDistanceTo().'
          ),
          this.manhattanDistanceTo(e)
        )
      }),
      (Qn.prototype.lengthManhattan = function () {
        return (
          console.warn(
            'THREE.Vector3: .lengthManhattan() has been renamed to .manhattanLength().'
          ),
          this.manhattanLength()
        )
      }),
      (Yn.prototype.fromAttribute = function (e, t, n) {
        return (
          console.warn(
            'THREE.Vector4: .fromAttribute() has been renamed to .fromBufferAttribute().'
          ),
          this.fromBufferAttribute(e, t, n)
        )
      }),
      (Yn.prototype.lengthManhattan = function () {
        return (
          console.warn(
            'THREE.Vector4: .lengthManhattan() has been renamed to .manhattanLength().'
          ),
          this.manhattanLength()
        )
      }),
      (er.prototype.getChildByName = function (e) {
        return (
          console.warn(
            'THREE.Object3D: .getChildByName() has been renamed to .getObjectByName().'
          ),
          this.getObjectByName(e)
        )
      }),
      (er.prototype.renderDepth = function () {
        console.warn(
          'THREE.Object3D: .renderDepth has been removed. Use .renderOrder, instead.'
        )
      }),
      (er.prototype.translate = function (e, t) {
        return (
          console.warn(
            'THREE.Object3D: .translate() has been removed. Use .translateOnAxis( axis, distance ) instead.'
          ),
          this.translateOnAxis(t, e)
        )
      }),
      (er.prototype.getWorldRotation = function () {
        console.error(
          'THREE.Object3D: .getWorldRotation() has been removed. Use THREE.Object3D.getWorldQuaternion( target ) instead.'
        )
      }),
      (er.prototype.applyMatrix = function (e) {
        return (
          console.warn(
            'THREE.Object3D: .applyMatrix() has been renamed to .applyMatrix4().'
          ),
          this.applyMatrix4(e)
        )
      }),
      Object.defineProperties(er.prototype, {
        eulerOrder: {
          get: function () {
            return (
              console.warn(
                'THREE.Object3D: .eulerOrder is now .rotation.order.'
              ),
              this.rotation.order
            )
          },
          set: function (e) {
            console.warn('THREE.Object3D: .eulerOrder is now .rotation.order.'),
              (this.rotation.order = e)
          }
        },
        useQuaternion: {
          get: function () {
            console.warn(
              'THREE.Object3D: .useQuaternion has been removed. The library now uses quaternions by default.'
            )
          },
          set: function () {
            console.warn(
              'THREE.Object3D: .useQuaternion has been removed. The library now uses quaternions by default.'
            )
          }
        }
      }),
      (ia.prototype.setDrawMode = function () {
        console.error(
          'THREE.Mesh: .setDrawMode() has been removed. The renderer now always assumes THREE.TrianglesDrawMode. Transform your geometry via BufferGeometryUtils.toTrianglesDrawMode() if necessary.'
        )
      }),
      Object.defineProperties(ia.prototype, {
        drawMode: {
          get: function () {
            return (
              console.error(
                'THREE.Mesh: .drawMode has been removed. The renderer now always assumes THREE.TrianglesDrawMode.'
              ),
              un
            )
          },
          set: function () {
            console.error(
              'THREE.Mesh: .drawMode has been removed. The renderer now always assumes THREE.TrianglesDrawMode. Transform your geometry via BufferGeometryUtils.toTrianglesDrawMode() if necessary.'
            )
          }
        }
      }),
      (tu.prototype.initBones = function () {
        console.error('THREE.SkinnedMesh: initBones() has been removed.')
      }),
      (fa.prototype.setLens = function (e, t) {
        console.warn(
          'THREE.PerspectiveCamera.setLens is deprecated. Use .setFocalLength and .filmGauge for a photographic setup.'
        ),
          void 0 !== t && (this.filmGauge = t),
          this.setFocalLength(e)
      }),
      Object.defineProperties(tf.prototype, {
        onlyShadow: {
          set: function () {
            console.warn('THREE.Light: .onlyShadow has been removed.')
          }
        },
        shadowCameraFov: {
          set: function (e) {
            console.warn(
              'THREE.Light: .shadowCameraFov is now .shadow.camera.fov.'
            ),
              (this.shadow.camera.fov = e)
          }
        },
        shadowCameraLeft: {
          set: function (e) {
            console.warn(
              'THREE.Light: .shadowCameraLeft is now .shadow.camera.left.'
            ),
              (this.shadow.camera.left = e)
          }
        },
        shadowCameraRight: {
          set: function (e) {
            console.warn(
              'THREE.Light: .shadowCameraRight is now .shadow.camera.right.'
            ),
              (this.shadow.camera.right = e)
          }
        },
        shadowCameraTop: {
          set: function (e) {
            console.warn(
              'THREE.Light: .shadowCameraTop is now .shadow.camera.top.'
            ),
              (this.shadow.camera.top = e)
          }
        },
        shadowCameraBottom: {
          set: function (e) {
            console.warn(
              'THREE.Light: .shadowCameraBottom is now .shadow.camera.bottom.'
            ),
              (this.shadow.camera.bottom = e)
          }
        },
        shadowCameraNear: {
          set: function (e) {
            console.warn(
              'THREE.Light: .shadowCameraNear is now .shadow.camera.near.'
            ),
              (this.shadow.camera.near = e)
          }
        },
        shadowCameraFar: {
          set: function (e) {
            console.warn(
              'THREE.Light: .shadowCameraFar is now .shadow.camera.far.'
            ),
              (this.shadow.camera.far = e)
          }
        },
        shadowCameraVisible: {
          set: function () {
            console.warn(
              'THREE.Light: .shadowCameraVisible has been removed. Use new THREE.CameraHelper( light.shadow.camera ) instead.'
            )
          }
        },
        shadowBias: {
          set: function (e) {
            console.warn('THREE.Light: .shadowBias is now .shadow.bias.'),
              (this.shadow.bias = e)
          }
        },
        shadowDarkness: {
          set: function () {
            console.warn('THREE.Light: .shadowDarkness has been removed.')
          }
        },
        shadowMapWidth: {
          set: function (e) {
            console.warn(
              'THREE.Light: .shadowMapWidth is now .shadow.mapSize.width.'
            ),
              (this.shadow.mapSize.width = e)
          }
        },
        shadowMapHeight: {
          set: function (e) {
            console.warn(
              'THREE.Light: .shadowMapHeight is now .shadow.mapSize.height.'
            ),
              (this.shadow.mapSize.height = e)
          }
        }
      }),
      Object.defineProperties(Sr.prototype, {
        length: {
          get: function () {
            return (
              console.warn(
                'THREE.BufferAttribute: .length has been deprecated. Use .count instead.'
              ),
              this.array.length
            )
          }
        },
        dynamic: {
          get: function () {
            return (
              console.warn(
                'THREE.BufferAttribute: .dynamic has been deprecated. Use .usage instead.'
              ),
              this.usage === An
            )
          },
          set: function () {
            console.warn(
              'THREE.BufferAttribute: .dynamic has been deprecated. Use .usage instead.'
            ),
              this.setUsage(An)
          }
        }
      }),
      (Sr.prototype.setDynamic = function (e) {
        return (
          console.warn(
            'THREE.BufferAttribute: .setDynamic() has been deprecated. Use .setUsage() instead.'
          ),
          this.setUsage(!0 === e ? An : Tn),
          this
        )
      }),
      (Sr.prototype.copyIndicesArray = function () {
        console.error(
          'THREE.BufferAttribute: .copyIndicesArray() has been removed.'
        )
      }),
      (Sr.prototype.setArray = function () {
        console.error(
          'THREE.BufferAttribute: .setArray has been removed. Use BufferGeometry .setAttribute to replace/resize attribute buffers'
        )
      }),
      (Ur.prototype.addIndex = function (e) {
        console.warn(
          'THREE.BufferGeometry: .addIndex() has been renamed to .setIndex().'
        ),
          this.setIndex(e)
      }),
      (Ur.prototype.addAttribute = function (e, t) {
        return (
          console.warn(
            'THREE.BufferGeometry: .addAttribute() has been renamed to .setAttribute().'
          ),
          (t && t.isBufferAttribute) || (t && t.isInterleavedBufferAttribute)
            ? 'index' === e
              ? (console.warn(
                  'THREE.BufferGeometry.addAttribute: Use .setIndex() for index attribute.'
                ),
                this.setIndex(t),
                this)
              : this.setAttribute(e, t)
            : (console.warn(
                'THREE.BufferGeometry: .addAttribute() now expects ( name, attribute ).'
              ),
              this.setAttribute(e, new Sr(arguments[1], arguments[2])))
        )
      }),
      (Ur.prototype.addDrawCall = function (e, t, n) {
        void 0 !== n &&
          console.warn(
            'THREE.BufferGeometry: .addDrawCall() no longer supports indexOffset.'
          ),
          console.warn(
            'THREE.BufferGeometry: .addDrawCall() is now .addGroup().'
          ),
          this.addGroup(e, t)
      }),
      (Ur.prototype.clearDrawCalls = function () {
        console.warn(
          'THREE.BufferGeometry: .clearDrawCalls() is now .clearGroups().'
        ),
          this.clearGroups()
      }),
      (Ur.prototype.computeOffsets = function () {
        console.warn(
          'THREE.BufferGeometry: .computeOffsets() has been removed.'
        )
      }),
      (Ur.prototype.removeAttribute = function (e) {
        return (
          console.warn(
            'THREE.BufferGeometry: .removeAttribute() has been renamed to .deleteAttribute().'
          ),
          this.deleteAttribute(e)
        )
      }),
      (Ur.prototype.applyMatrix = function (e) {
        return (
          console.warn(
            'THREE.BufferGeometry: .applyMatrix() has been renamed to .applyMatrix4().'
          ),
          this.applyMatrix4(e)
        )
      }),
      Object.defineProperties(Ur.prototype, {
        drawcalls: {
          get: function () {
            return (
              console.error(
                'THREE.BufferGeometry: .drawcalls has been renamed to .groups.'
              ),
              this.groups
            )
          }
        },
        offsets: {
          get: function () {
            return (
              console.warn(
                'THREE.BufferGeometry: .offsets has been renamed to .groups.'
              ),
              this.groups
            )
          }
        }
      }),
      (Rh.prototype.setDynamic = function (e) {
        return (
          console.warn(
            'THREE.InterleavedBuffer: .setDynamic() has been deprecated. Use .setUsage() instead.'
          ),
          this.setUsage(!0 === e ? An : Tn),
          this
        )
      }),
      (Rh.prototype.setArray = function () {
        console.error(
          'THREE.InterleavedBuffer: .setArray has been removed. Use BufferGeometry .setAttribute to replace/resize attribute buffers'
        )
      }),
      (Qd.prototype.getArrays = function () {
        console.error('THREE.ExtrudeGeometry: .getArrays() has been removed.')
      }),
      (Qd.prototype.addShapeList = function () {
        console.error(
          'THREE.ExtrudeGeometry: .addShapeList() has been removed.'
        )
      }),
      (Qd.prototype.addShape = function () {
        console.error('THREE.ExtrudeGeometry: .addShape() has been removed.')
      }),
      (Ah.prototype.dispose = function () {
        console.error('THREE.Scene: .dispose() has been removed.')
      }),
      (am.prototype.onUpdate = function () {
        return (
          console.warn(
            'THREE.Uniform: .onUpdate() has been removed. Use object.onBeforeRender() instead.'
          ),
          this
        )
      }),
      Object.defineProperties(pr.prototype, {
        wrapAround: {
          get: function () {
            console.warn('THREE.Material: .wrapAround has been removed.')
          },
          set: function () {
            console.warn('THREE.Material: .wrapAround has been removed.')
          }
        },
        overdraw: {
          get: function () {
            console.warn('THREE.Material: .overdraw has been removed.')
          },
          set: function () {
            console.warn('THREE.Material: .overdraw has been removed.')
          }
        },
        wrapRGB: {
          get: function () {
            return (
              console.warn('THREE.Material: .wrapRGB has been removed.'),
              new xr()
            )
          }
        },
        shading: {
          get: function () {
            console.error(
              'THREE.' +
                this.type +
                ': .shading has been removed. Use the boolean .flatShading instead.'
            )
          },
          set: function (e) {
            console.warn(
              'THREE.' +
                this.type +
                ': .shading has been removed. Use the boolean .flatShading instead.'
            ),
              (this.flatShading = e === k)
          }
        },
        stencilMask: {
          get: function () {
            return (
              console.warn(
                'THREE.' +
                  this.type +
                  ': .stencilMask has been removed. Use .stencilFuncMask instead.'
              ),
              this.stencilFuncMask
            )
          },
          set: function (e) {
            console.warn(
              'THREE.' +
                this.type +
                ': .stencilMask has been removed. Use .stencilFuncMask instead.'
            ),
              (this.stencilFuncMask = e)
          }
        }
      }),
      Object.defineProperties(da.prototype, {
        derivatives: {
          get: function () {
            return (
              console.warn(
                'THREE.ShaderMaterial: .derivatives has been moved to .extensions.derivatives.'
              ),
              this.extensions.derivatives
            )
          },
          set: function (e) {
            console.warn(
              'THREE. ShaderMaterial: .derivatives has been moved to .extensions.derivatives.'
            ),
              (this.extensions.derivatives = e)
          }
        }
      }),
      (Mh.prototype.clearTarget = function (e, t, n, i) {
        console.warn(
          'THREE.WebGLRenderer: .clearTarget() has been deprecated. Use .setRenderTarget() and .clear() instead.'
        ),
          this.setRenderTarget(e),
          this.clear(t, n, i)
      }),
      (Mh.prototype.animate = function (e) {
        console.warn(
          'THREE.WebGLRenderer: .animate() is now .setAnimationLoop().'
        ),
          this.setAnimationLoop(e)
      }),
      (Mh.prototype.getCurrentRenderTarget = function () {
        return (
          console.warn(
            'THREE.WebGLRenderer: .getCurrentRenderTarget() is now .getRenderTarget().'
          ),
          this.getRenderTarget()
        )
      }),
      (Mh.prototype.getMaxAnisotropy = function () {
        return (
          console.warn(
            'THREE.WebGLRenderer: .getMaxAnisotropy() is now .capabilities.getMaxAnisotropy().'
          ),
          this.capabilities.getMaxAnisotropy()
        )
      }),
      (Mh.prototype.getPrecision = function () {
        return (
          console.warn(
            'THREE.WebGLRenderer: .getPrecision() is now .capabilities.precision.'
          ),
          this.capabilities.precision
        )
      }),
      (Mh.prototype.resetGLState = function () {
        return (
          console.warn(
            'THREE.WebGLRenderer: .resetGLState() is now .state.reset().'
          ),
          this.state.reset()
        )
      }),
      (Mh.prototype.supportsFloatTextures = function () {
        return (
          console.warn(
            "THREE.WebGLRenderer: .supportsFloatTextures() is now .extensions.get( 'OES_texture_float' )."
          ),
          this.extensions.get('OES_texture_float')
        )
      }),
      (Mh.prototype.supportsHalfFloatTextures = function () {
        return (
          console.warn(
            "THREE.WebGLRenderer: .supportsHalfFloatTextures() is now .extensions.get( 'OES_texture_half_float' )."
          ),
          this.extensions.get('OES_texture_half_float')
        )
      }),
      (Mh.prototype.supportsStandardDerivatives = function () {
        return (
          console.warn(
            "THREE.WebGLRenderer: .supportsStandardDerivatives() is now .extensions.get( 'OES_standard_derivatives' )."
          ),
          this.extensions.get('OES_standard_derivatives')
        )
      }),
      (Mh.prototype.supportsCompressedTextureS3TC = function () {
        return (
          console.warn(
            "THREE.WebGLRenderer: .supportsCompressedTextureS3TC() is now .extensions.get( 'WEBGL_compressed_texture_s3tc' )."
          ),
          this.extensions.get('WEBGL_compressed_texture_s3tc')
        )
      }),
      (Mh.prototype.supportsCompressedTexturePVRTC = function () {
        return (
          console.warn(
            "THREE.WebGLRenderer: .supportsCompressedTexturePVRTC() is now .extensions.get( 'WEBGL_compressed_texture_pvrtc' )."
          ),
          this.extensions.get('WEBGL_compressed_texture_pvrtc')
        )
      }),
      (Mh.prototype.supportsBlendMinMax = function () {
        return (
          console.warn(
            "THREE.WebGLRenderer: .supportsBlendMinMax() is now .extensions.get( 'EXT_blend_minmax' )."
          ),
          this.extensions.get('EXT_blend_minmax')
        )
      }),
      (Mh.prototype.supportsVertexTextures = function () {
        return (
          console.warn(
            'THREE.WebGLRenderer: .supportsVertexTextures() is now .capabilities.vertexTextures.'
          ),
          this.capabilities.vertexTextures
        )
      }),
      (Mh.prototype.supportsInstancedArrays = function () {
        return (
          console.warn(
            "THREE.WebGLRenderer: .supportsInstancedArrays() is now .extensions.get( 'ANGLE_instanced_arrays' )."
          ),
          this.extensions.get('ANGLE_instanced_arrays')
        )
      }),
      (Mh.prototype.enableScissorTest = function (e) {
        console.warn(
          'THREE.WebGLRenderer: .enableScissorTest() is now .setScissorTest().'
        ),
          this.setScissorTest(e)
      }),
      (Mh.prototype.initMaterial = function () {
        console.warn('THREE.WebGLRenderer: .initMaterial() has been removed.')
      }),
      (Mh.prototype.addPrePlugin = function () {
        console.warn('THREE.WebGLRenderer: .addPrePlugin() has been removed.')
      }),
      (Mh.prototype.addPostPlugin = function () {
        console.warn('THREE.WebGLRenderer: .addPostPlugin() has been removed.')
      }),
      (Mh.prototype.updateShadowMap = function () {
        console.warn(
          'THREE.WebGLRenderer: .updateShadowMap() has been removed.'
        )
      }),
      (Mh.prototype.setFaceCulling = function () {
        console.warn('THREE.WebGLRenderer: .setFaceCulling() has been removed.')
      }),
      (Mh.prototype.allocTextureUnit = function () {
        console.warn(
          'THREE.WebGLRenderer: .allocTextureUnit() has been removed.'
        )
      }),
      (Mh.prototype.setTexture = function () {
        console.warn('THREE.WebGLRenderer: .setTexture() has been removed.')
      }),
      (Mh.prototype.setTexture2D = function () {
        console.warn('THREE.WebGLRenderer: .setTexture2D() has been removed.')
      }),
      (Mh.prototype.setTextureCube = function () {
        console.warn('THREE.WebGLRenderer: .setTextureCube() has been removed.')
      }),
      (Mh.prototype.getActiveMipMapLevel = function () {
        return (
          console.warn(
            'THREE.WebGLRenderer: .getActiveMipMapLevel() is now .getActiveMipmapLevel().'
          ),
          this.getActiveMipmapLevel()
        )
      }),
      Object.defineProperties(Mh.prototype, {
        shadowMapEnabled: {
          get: function () {
            return this.shadowMap.enabled
          },
          set: function (e) {
            console.warn(
              'THREE.WebGLRenderer: .shadowMapEnabled is now .shadowMap.enabled.'
            ),
              (this.shadowMap.enabled = e)
          }
        },
        shadowMapType: {
          get: function () {
            return this.shadowMap.type
          },
          set: function (e) {
            console.warn(
              'THREE.WebGLRenderer: .shadowMapType is now .shadowMap.type.'
            ),
              (this.shadowMap.type = e)
          }
        },
        shadowMapCullFace: {
          get: function () {
            console.warn(
              'THREE.WebGLRenderer: .shadowMapCullFace has been removed. Set Material.shadowSide instead.'
            )
          },
          set: function () {
            console.warn(
              'THREE.WebGLRenderer: .shadowMapCullFace has been removed. Set Material.shadowSide instead.'
            )
          }
        },
        context: {
          get: function () {
            return (
              console.warn(
                'THREE.WebGLRenderer: .context has been removed. Use .getContext() instead.'
              ),
              this.getContext()
            )
          }
        },
        vr: {
          get: function () {
            return (
              console.warn('THREE.WebGLRenderer: .vr has been renamed to .xr'),
              this.xr
            )
          }
        },
        gammaInput: {
          get: function () {
            return (
              console.warn(
                'THREE.WebGLRenderer: .gammaInput has been removed. Set the encoding for textures via Texture.encoding instead.'
              ),
              !1
            )
          },
          set: function () {
            console.warn(
              'THREE.WebGLRenderer: .gammaInput has been removed. Set the encoding for textures via Texture.encoding instead.'
            )
          }
        },
        gammaOutput: {
          get: function () {
            return (
              console.warn(
                'THREE.WebGLRenderer: .gammaOutput has been removed. Set WebGLRenderer.outputEncoding instead.'
              ),
              !1
            )
          },
          set: function (e) {
            console.warn(
              'THREE.WebGLRenderer: .gammaOutput has been removed. Set WebGLRenderer.outputEncoding instead.'
            ),
              (this.outputEncoding = !0 === e ? pn : dn)
          }
        },
        toneMappingWhitePoint: {
          get: function () {
            return (
              console.warn(
                'THREE.WebGLRenderer: .toneMappingWhitePoint has been removed.'
              ),
              1
            )
          },
          set: function () {
            console.warn(
              'THREE.WebGLRenderer: .toneMappingWhitePoint has been removed.'
            )
          }
        }
      }),
      Object.defineProperties(dh.prototype, {
        cullFace: {
          get: function () {
            console.warn(
              'THREE.WebGLRenderer: .shadowMap.cullFace has been removed. Set Material.shadowSide instead.'
            )
          },
          set: function () {
            console.warn(
              'THREE.WebGLRenderer: .shadowMap.cullFace has been removed. Set Material.shadowSide instead.'
            )
          }
        },
        renderReverseSided: {
          get: function () {
            console.warn(
              'THREE.WebGLRenderer: .shadowMap.renderReverseSided has been removed. Set Material.shadowSide instead.'
            )
          },
          set: function () {
            console.warn(
              'THREE.WebGLRenderer: .shadowMap.renderReverseSided has been removed. Set Material.shadowSide instead.'
            )
          }
        },
        renderSingleSided: {
          get: function () {
            console.warn(
              'THREE.WebGLRenderer: .shadowMap.renderSingleSided has been removed. Set Material.shadowSide instead.'
            )
          },
          set: function () {
            console.warn(
              'THREE.WebGLRenderer: .shadowMap.renderSingleSided has been removed. Set Material.shadowSide instead.'
            )
          }
        }
      }),
      Object.defineProperties(Xn.prototype, {
        wrapS: {
          get: function () {
            return (
              console.warn(
                'THREE.WebGLRenderTarget: .wrapS is now .texture.wrapS.'
              ),
              this.texture.wrapS
            )
          },
          set: function (e) {
            console.warn(
              'THREE.WebGLRenderTarget: .wrapS is now .texture.wrapS.'
            ),
              (this.texture.wrapS = e)
          }
        },
        wrapT: {
          get: function () {
            return (
              console.warn(
                'THREE.WebGLRenderTarget: .wrapT is now .texture.wrapT.'
              ),
              this.texture.wrapT
            )
          },
          set: function (e) {
            console.warn(
              'THREE.WebGLRenderTarget: .wrapT is now .texture.wrapT.'
            ),
              (this.texture.wrapT = e)
          }
        },
        magFilter: {
          get: function () {
            return (
              console.warn(
                'THREE.WebGLRenderTarget: .magFilter is now .texture.magFilter.'
              ),
              this.texture.magFilter
            )
          },
          set: function (e) {
            console.warn(
              'THREE.WebGLRenderTarget: .magFilter is now .texture.magFilter.'
            ),
              (this.texture.magFilter = e)
          }
        },
        minFilter: {
          get: function () {
            return (
              console.warn(
                'THREE.WebGLRenderTarget: .minFilter is now .texture.minFilter.'
              ),
              this.texture.minFilter
            )
          },
          set: function (e) {
            console.warn(
              'THREE.WebGLRenderTarget: .minFilter is now .texture.minFilter.'
            ),
              (this.texture.minFilter = e)
          }
        },
        anisotropy: {
          get: function () {
            return (
              console.warn(
                'THREE.WebGLRenderTarget: .anisotropy is now .texture.anisotropy.'
              ),
              this.texture.anisotropy
            )
          },
          set: function (e) {
            console.warn(
              'THREE.WebGLRenderTarget: .anisotropy is now .texture.anisotropy.'
            ),
              (this.texture.anisotropy = e)
          }
        },
        offset: {
          get: function () {
            return (
              console.warn(
                'THREE.WebGLRenderTarget: .offset is now .texture.offset.'
              ),
              this.texture.offset
            )
          },
          set: function (e) {
            console.warn(
              'THREE.WebGLRenderTarget: .offset is now .texture.offset.'
            ),
              (this.texture.offset = e)
          }
        },
        repeat: {
          get: function () {
            return (
              console.warn(
                'THREE.WebGLRenderTarget: .repeat is now .texture.repeat.'
              ),
              this.texture.repeat
            )
          },
          set: function (e) {
            console.warn(
              'THREE.WebGLRenderTarget: .repeat is now .texture.repeat.'
            ),
              (this.texture.repeat = e)
          }
        },
        format: {
          get: function () {
            return (
              console.warn(
                'THREE.WebGLRenderTarget: .format is now .texture.format.'
              ),
              this.texture.format
            )
          },
          set: function (e) {
            console.warn(
              'THREE.WebGLRenderTarget: .format is now .texture.format.'
            ),
              (this.texture.format = e)
          }
        },
        type: {
          get: function () {
            return (
              console.warn(
                'THREE.WebGLRenderTarget: .type is now .texture.type.'
              ),
              this.texture.type
            )
          },
          set: function (e) {
            console.warn(
              'THREE.WebGLRenderTarget: .type is now .texture.type.'
            ),
              (this.texture.type = e)
          }
        },
        generateMipmaps: {
          get: function () {
            return (
              console.warn(
                'THREE.WebGLRenderTarget: .generateMipmaps is now .texture.generateMipmaps.'
              ),
              this.texture.generateMipmaps
            )
          },
          set: function (e) {
            console.warn(
              'THREE.WebGLRenderTarget: .generateMipmaps is now .texture.generateMipmaps.'
            ),
              (this.texture.generateMipmaps = e)
          }
        }
      }),
      (Hf.prototype.load = function (e) {
        console.warn(
          'THREE.Audio: .load has been deprecated. Use THREE.AudioLoader instead.'
        )
        const t = this,
          n = new zf()
        return (
          n.load(e, function (e) {
            t.setBuffer(e)
          }),
          this
        )
      }),
      (Wf.prototype.getData = function () {
        return (
          console.warn(
            'THREE.AudioAnalyser: .getData() is now .getFrequencyData().'
          ),
          this.getFrequencyData()
        )
      }),
      (va.prototype.updateCubeMap = function (e, t) {
        return (
          console.warn('THREE.CubeCamera: .updateCubeMap() is now .update().'),
          this.update(e, t)
        )
      }),
      (va.prototype.clear = function (e, t, n, i) {
        return (
          console.warn(
            'THREE.CubeCamera: .clear() is now .renderTarget.clear().'
          ),
          this.renderTarget.clear(e, t, n, i)
        )
      }),
      (Vn.crossOrigin = void 0),
      (Vn.loadTexture = function (e, t, n, i) {
        console.warn(
          'THREE.ImageUtils.loadTexture has been deprecated. Use THREE.TextureLoader() instead.'
        )
        const r = new Kp()
        r.setCrossOrigin(this.crossOrigin)
        const a = r.load(e, n, void 0, i)
        return t && (a.mapping = t), a
      }),
      (Vn.loadTextureCube = function (e, t, n, i) {
        console.warn(
          'THREE.ImageUtils.loadTextureCube has been deprecated. Use THREE.CubeTextureLoader() instead.'
        )
        const r = new Zp()
        r.setCrossOrigin(this.crossOrigin)
        const a = r.load(e, n, void 0, i)
        return t && (a.mapping = t), a
      }),
      (Vn.loadCompressedTexture = function () {
        console.error(
          'THREE.ImageUtils.loadCompressedTexture has been removed. Use THREE.DDSLoader instead.'
        )
      }),
      (Vn.loadCompressedTextureCube = function () {
        console.error(
          'THREE.ImageUtils.loadCompressedTextureCube has been removed. Use THREE.DDSLoader instead.'
        )
      })
    'undefined' !== typeof __THREE_DEVTOOLS__ &&
      __THREE_DEVTOOLS__.dispatchEvent(
        new CustomEvent('register', { detail: { revision: C } })
      ),
      'undefined' !== typeof window &&
        (window.__THREE__
          ? console.warn(
              'WARNING: Multiple instances of Three.js being imported.'
            )
          : (window.__THREE__ = C))
    var Cm = n('536b')
    const Pm = 'brfv5_js_cb270921_v5.2.1_commercial.brfv5',
      Dm = 'brfv5.browser.examples',
      Im = {}
    let Nm = null,
      Om = null
    const Fm = (e, t, n = '', i = null, r = null) => {
      if (!e) throw 'Please provide a modelName.'
      return new Promise((a, s) => {
        if (Nm && Om) a({ brfv5Manager: Nm, brfv5Config: Om })
        else
          try {
            ;(Im.appId = i || Dm),
              (Im.binaryLocation = n + Pm),
              (Im.modelLocation = n + e + '_c'),
              (Im.modelChunks = t),
              (Im.binaryProgress = r),
              (Im.binaryError = e => {
                s(e)
              }),
              (Im.onInit = (e, t) => {
                ;(Nm = e), (Om = t), a({ brfv5Manager: Nm, brfv5Config: Om })
              }),
              Object(Cm['a'])(Im)
          } catch (o) {
            s(o)
          }
      })
    }
    const Bm = 'threejs_loading:',
      zm = {},
      Um = {},
      km = {},
      Hm = ({ fileList: e, onProgress: t }) =>
        new Promise((n, i) => {
          if ((p(Bm, 'load3DModelList:', e), e)) {
            let r = e.length
            r > 0
              ? e.forEach(e => {
                  if (
                    (e.hasOwnProperty('pathToModel') && (e.url = e.pathToModel),
                    e.hasOwnProperty('pathToTextures') &&
                      (e.texturePath = e.pathToTextures),
                    p(
                      Bm,
                      'load3DModelList: obj:',
                      e,
                      e.hasOwnProperty('object3D')
                    ),
                    e.hasOwnProperty('object3D') &&
                      null !== e.object3D &&
                      (zm[e.url] = e.object3D),
                    !e.url)
                  )
                    return p(Bm, 'load3DModelList: url null:', e.url), void --r
                  Wm(
                    e.url,
                    e.texturePath,
                    e => {
                      p(Bm, 'load3DModelList: loaded:', e)
                      const t = zm[e]
                      Xm(t),
                        --r <= 0 &&
                          (p(Bm, 'load3DModelList: all files loaded'), n())
                    },
                    t,
                    e => {
                      i(e)
                    }
                  )
                })
              : (p(Bm, 'load3DModelList: no files loaded.'), n())
          } else i('No fileList given.')
        }),
      Wm = (e, t, n, i, r) => {
        p(Bm, 'load3DJsonFile: check: url:', e)
        let a = zm[e]
        if (e && !a) {
          p(Bm, 'load3DJsonFile: added: url:', e)
          const a = new Km()
          ;(e.endsWith('.brfv5') || e.endsWith('.artov5')) &&
            a.setResponseType('arraybuffer'),
            a.load(
              e,
              i => {
                Vm(i, e, t, n, r)
              },
              i,
              r
            )
        } else p(Bm, 'load3DJsonFile: already loaded: url:', e), n && n(e)
      },
      Vm = (e, t, n, i, r) => {
        try {
          t.endsWith('.brfv5') || t.endsWith('.artov5')
            ? Jm(Im['process'](new Uint8Array(e)), function (e) {
                Gm(JSON.parse(e), t, n, i, r)
              })
            : Gm(JSON.parse(e), t, n, i, r)
        } catch (a) {
          m(Bm, "Can't parse ", t, a.message), r && r(a)
        }
      },
      Gm = (e, t, n, i, r) => {
        if ((p(Bm, 'parse3DJsonFile: url:', t), !e))
          return m(Bm, "Can't parse " + t + '. No JSON given.'), void (r && r())
        const a = e.metadata
        if (
          void 0 === a ||
          void 0 === a.type ||
          'geometry' === a.type.toLowerCase()
        )
          return (
            m(Bm, "Can't parse " + t + '. No metadata given.'), void (r && r())
          )
        if (n && e.hasOwnProperty('images'))
          for (let s = 0; s < e.images.length; s++) {
            let t = e.images[s]
            t.hasOwnProperty('url') &&
              -1 === t.url.indexOf('data:image') &&
              (t.url = n + t.url.split('/').pop())
          }
        if (!zm[t]) {
          p(Bm, 'parse3DJsonFile: parse:', t)
          const n = new Zm(),
            i = n.parse(e)
          ;(i.name = t), (zm[t] = i), p(Bm, 'object3D:', i)
        }
        i && i(t)
      },
      jm = (e, t) => (
        p(Bm, 'getModelInstance:', t),
        e && t && zm[t]
          ? (e.hasOwnProperty('modelInstanceMap') || (e.modelInstanceMap = {}),
            e.modelInstanceMap[t]
              ? p(Bm, 'getModelInstance: found:', e.modelInstanceMap[t])
              : ((e.modelInstanceMap[t] = zm[t].clone()),
                p(Bm, 'getModelInstance: added:', e.modelInstanceMap[t])),
            e.modelInstanceMap[t])
          : (p(Bm, 'getModelInstance:', !e, !t, !zm[t]),
            f(Bm, 'getModelInstance:', t, e, zm),
            null)
      ),
      qm = (e, t) => (p(Bm, 'getMaterialByName:', t, km[t]), km[t]),
      Ym = e => {
        const t = e.uuid,
          n = e.name
        Um.hasOwnProperty(t)
          ? km.hasOwnProperty(n) &&
            km[n].uuid !== t &&
            f(
              'Loaded material with same name, but different UUID, please check your materials: ' +
                n +
                ' - ' +
                t +
                ' - ' +
                km[n].uuid
            )
          : ((Um[t] = e), (km[n] = e))
      },
      Xm = e => {
        e &&
          e.traverse(e => {
            e.material && Ym(e.material)
          })
      },
      Jm = (e, t) => {
        const n = new FileReader()
        ;(n.onload = e => t(e.target.result)), n.readAsText(new Blob([e]))
      }
    const Zm = Af,
      Km = Xp,
      Qm = 'threejs_setup:'
    Vp.enabled = !0
    const $m = (e, t) => {
        if ((p(Qm, 'create3DScene', e, t), !h.isWebGLSupported || !e)) return !1
        if (
          (e.hasOwnProperty('sceneScale') || (e.sceneScale = 2),
          (e.sceneScale = 2),
          e.scene)
        )
          return tg(e, t), !0
        if (!t) return !1
        ;(e.scene = new Ah()),
          (e.camera = new fa(20, t.width / t.height, 100, 2e4)),
          (e.isInitialized = !0),
          tg(e, t),
          e.renderer.setClearColor(0, 0),
          (e.renderer.outputEncoding = pn),
          (e.renderer.physicallyCorrectLights = !0),
          (e.renderer.toneMapping = Se),
          (e.renderer.toneMappingExposure = 1)
        const n = new vh()
        ;(n.name = 'lightNode'), (e.lightNode = n), e.scene.add(n)
        const i = new yf(16777215, 3)
        return (
          (i.name = 'light_ambient'),
          (e.ambient = i),
          n.add(i),
          (e.modelNodes = []),
          (e.baseNodes = []),
          (e.transforms = []),
          (e.materialIdMap = []),
          (e.materialNameMap = []),
          ig(e, t.width, t.height)
        )
      },
      eg = e =>
        !(!e || !e.isInitialized) ||
        (m('Not initialized. Call create3DScene first.'), !1),
      tg = (e, t) => {
        p(Qm, 'createRenderer', e, t),
          eg(e) &&
            (e.renderer = new Mh({
              canvas: t,
              powerPreference: 'high-performance',
              alpha: !0,
              antialias: !0
            }))
      },
      ng = e => !!eg(e) && (e.renderer.render(e.scene, e.camera), !0),
      ig = (e, t, n) => {
        if ((p(Qm, 'update3DLayout', e, t, n), !eg(e))) return !1
        const i = t * e.sceneScale,
          r = n * e.sceneScale,
          a = i < r ? i : r,
          s = i < r ? r : i
        let o = 0,
          l = 0
        return (
          t < n ? ((o = a), (l = s)) : ((o = s), (l = a)),
          (e.renderer.domElement.width = o),
          (e.renderer.domElement.height = l),
          (e.camera.aspect = o / l),
          e.camera.position.set(0, 0, 0),
          e.camera.lookAt(new Qn(0, 0, 1)),
          e.camera.updateProjectionMatrix(),
          e.renderer.setSize(o, l, !1),
          !0
        )
      },
      rg = (e, t) => {
        if ((p(Qm, 'setNumFaces', e, t), !eg(e))) return !1
        const n = e.modelNodes,
          i = e.baseNodes,
          r = e.transforms,
          a = e.scene
        for (let s = i.length; s < t; s++) {
          const e = new vh()
          ;(e.name = 'baseNode_' + s), i.push(e)
          const t = new vh()
          ;(t.name = 'modelNode_' + s),
            n.push(t),
            r.push({ x: 0, y: 0, z: 0, rx: 0, ry: 0, rz: 0, scale: 0 }),
            e.add(t),
            a.add(e)
        }
        return !0
      },
      ag = e => {
        if ((p(Qm, 'prepareModelNodes', e), !eg(e))) return !1
        const t = e.modelNodes
        for (let n = 0; n < t.length; n++) {
          const e = t[n]
          while (e.children.length) e.remove(e.children[0])
          e.position.set(0, -4, -3)
        }
        return !0
      },
      sg = (e, t, n) => {
        if ((p(Qm, 'add3DModel', e, t), !eg(e))) return !1
        n && cg(t, n)
        const i = e.modelNodes
        for (let r = 0; r < i.length; r++) {
          const e = i[r]
          e.add(t.clone())
        }
        return !0
      },
      og = e => {
        if ((p(Qm, 'hideAllModels', e), !eg(e))) return !1
        const t = e.modelNodes
        for (let n = 0; n < t.length; n++)
          t[n].traverse(e => {
            e.visible = !1
          })
        return !0
      },
      lg = (e, t, n, i) => {
        if ((p(Qm, 'set3DModelByName', e, t, n), !eg(e))) return !1
        const r = e.modelNodes
        let a = null
        for (let s = 0; s < r.length; s++) {
          const e = r[s]
          t && n
            ? (e.traverse(e => {
                e &&
                  e.name === t &&
                  (e.traverse(e => {
                    e && e.name === n && (a = e)
                  }),
                  a ||
                    (t && n && i && i(t, n),
                    e.traverse(t => {
                      !a && t && t !== e && (a = t)
                    })),
                  a || (a = e))
              }),
              e.traverse(e => {
                if (a && e === a)
                  for (let t of a.parent.children) t.visible = !1
              }))
            : t &&
              e.traverse(e => {
                !a && e && e.name === t && (a = e)
              }),
            null !== a &&
              (a.traverse(e => {
                e.visible = !0
              }),
              a.traverseAncestors(e => {
                e.visible = !0
              }))
        }
        return !0
      },
      cg = (e, t) => {
        let n = 0,
          i = 0,
          r = 0,
          a = 1,
          s = 0,
          o = 0,
          l = 0
        t.hasOwnProperty('x') && (n = t.x),
          t.hasOwnProperty('y') && (i = t.y),
          t.hasOwnProperty('z') && (r = t.z),
          t.hasOwnProperty('s') && (a = t.s),
          t.hasOwnProperty('rx') && (s = t.rx),
          t.hasOwnProperty('ry') && (o = t.ry),
          t.hasOwnProperty('rz') && (l = t.rz),
          (0 === n && 0 === i && 0 === r) || e.position.set(n, i, r),
          (0 === s && 0 === o && 0 === l) || e.rotation.set(L(s), L(o), L(l)),
          1 !== a && e.scale.set(a, a, a)
      },
      hg = e => {
        e &&
          e.traverse(e => {
            ;(e.renderOrder = -1),
              e.material &&
                ((e.material.colorWrite = !1), (e.material.opacity = 0))
          })
      },
      ug = (e, t, n) => {
        if ((p(Qm, 'updateMeshMaterial', e, t, n), !eg(e))) return !1
        const i = e.modelNodes
        for (let r = 0; r < i.length; r++) {
          const e = i[r]
          t &&
            e.traverse(e => {
              e &&
                e.name === t &&
                e.material &&
                ((e.material = e.material.clone()),
                n.hasOwnProperty('color') &&
                  (e.material.color = new xr(n.color)),
                n.hasOwnProperty('opacity') && (e.material.opacity = n.opacity),
                n.hasOwnProperty('envMap') &&
                  e.material.envMap &&
                  (e.material.reflectivity = n.envMap.reflectivity))
            })
        }
      },
      dg = (e, t, n) => {
        if ((p(Qm, 'setMeshMaterial', e, t, n), !eg(e))) return !1
        const i = e.modelNodes,
          r = qm(e, n)
        r || m(Qm, 'setMeshMaterial: material missing in mat collection:', n)
        for (let a = 0; a < i.length; a++) {
          const e = i[a]
          t &&
            r &&
            e.traverse(e => {
              e && e.name === t && e.material && (e.material = r)
            })
        }
      },
      pg = (e, t) => {
        if ((p(Qm, 'setModelScale', e, t), !eg(e))) return !1
        const n = e.modelNodes
        for (let i = 0; i < n.length; i++) {
          const e = n[i]
          e.scale.set(t, t, t)
        }
      }
    var fg = function () {
        var e = this,
          t = e.$createElement,
          n = e._self._c || t
        return n(
          'div',
          { staticClass: 'abs oh full-view' },
          [
            n('BRFv5CameraView', {
              ref: '_camera',
              attrs: {
                enabled: e.cameraEnabled,
                constraints: e.cameraConstraints
              },
              on: {
                onEnterFrame: e.onEnterFrame,
                onImageData: e.onImageData,
                onExitFrame: e.onExitFrame,
                onCameraOpened: e.onCameraOpened,
                onCameraClosed: e.onCameraClosed,
                onCameraError: e.onCameraError
              }
            }),
            n(
              'div',
              { staticClass: 'abs full-view', class: { vh: !e.showDebugDraw } },
              [n('canvas', { ref: '_debug', staticClass: 'abs c' })]
            ),
            n('BRFv5Stats', { ref: '_stats', class: { vh: !e.showStats } })
          ],
          1
        )
      },
      mg = []
    const gg = 'brfv5__configure',
      vg = (e, t, n) => {
        p(gg + ': configureFaceTracking:', t, n),
          (e.faceTrackingConfig.numTrackingPasses = t || 3),
          (e.faceTrackingConfig.enableFreeRotation = n),
          (e.faceTrackingConfig.maxRotationZReset = n ? 999 : 34)
      },
      yg = (e, t) => {
        p(gg + ': configureNumFacesToTrack:', t),
          t > 0
            ? ((e.faceTrackingConfig.numFacesToTrack = t),
              (e.enableFaceTracking = !0))
            : ((e.faceTrackingConfig.numFacesToTrack = 1),
              (e.enableFaceTracking = !1))
      },
      _g = (e, t, n) => {
        p(gg + ': configureCameraInput:', t, n)
        const i = Math.min(t, n)
        ;(e.imageConfig.inputWidth = t), (e.imageConfig.inputHeight = n)
        const r = i / 480,
          a = 20,
          s = i - 2 * a * r
        e.faceDetectionConfig.regionOfInterest.setTo(
          0.5 * (t - s),
          0.5 * (n - s),
          s,
          s
        ),
          (e.faceDetectionConfig.minFaceSize = 144 * r),
          (e.faceDetectionConfig.maxFaceSize = 480 * r),
          t < n && (e.faceDetectionConfig.minFaceSize = 240 * r),
          (e.faceDetectionConfig.faceSizeIncrease = 24),
          (e.faceDetectionConfig.stepSize = 0),
          (e.faceDetectionConfig.minNumNeighbors = 12),
          (e.faceDetectionConfig.filterNoise = !0),
          e.faceTrackingConfig.regionOfInterest.setTo(
            a * r,
            a * r,
            t - 2 * a * r,
            n - 2 * a * r
          ),
          (e.faceTrackingConfig.minFaceScaleStart = 50 * r),
          (e.faceTrackingConfig.maxFaceScaleStart = 320 * r),
          (e.faceTrackingConfig.maxRotationXStart = 15),
          (e.faceTrackingConfig.maxRotationYStart = 25),
          (e.faceTrackingConfig.maxRotationZStart = 20),
          (e.faceTrackingConfig.confidenceThresholdStart = 0.8),
          (e.faceTrackingConfig.minFaceScaleReset = 35 * r),
          (e.faceTrackingConfig.maxFaceScaleReset = 420 * r),
          (e.faceTrackingConfig.maxRotationXReset = 35),
          (e.faceTrackingConfig.maxRotationYReset = 45),
          (e.faceTrackingConfig.maxRotationZReset = 34),
          (e.faceTrackingConfig.confidenceThresholdReset = 0.001),
          (e.faceTrackingConfig.enableStabilizer = !0)
      }
    let xg = !1,
      wg = null,
      bg = null
    const Mg = (e, t) => {
        ;(xg = !0),
          (wg = e),
          (bg = t),
          vg(bg, Ig.numTrackingPasses, Ig.enableFreeRotation),
          wg.configure(bg)
      },
      Sg = () => {
        xg = !1
      }
    let Eg = 0,
      Tg = 0,
      Ag = [33]
    const Rg = { time: '' }
    let Lg = 30,
      Cg = Lg,
      Pg = h.mobileOS === s.UNKNOWN ? 3 : 1,
      Dg = h.mobileOS === s.UNKNOWN
    const Ig = { numTrackingPasses: Pg, enableFreeRotation: Dg },
      Ng = () => {
        Eg = window.performance.now()
      },
      Og = () => {
        ;(Tg = window.performance.now()), Fg()
      },
      Fg = () => {
        Ag.push(Tg - Eg)
        while (Ag.length > 30) Ag.shift()
        let e = 0,
          t = !1
        for (let n = 0; n < Ag.length; n++) e += Ag[n]
        ;(e /= Ag.length),
          e < 28
            ? (Cg--,
              Cg < 1 &&
                ((Cg = Lg),
                Pg < 3 ? (Pg++, (t = !0)) : Dg || ((Dg = !0), (t = !0))))
            : e > 37 &&
              (Cg--,
              Cg < 1 &&
                ((Cg = 10),
                Dg ? ((Dg = !1), (t = !0)) : Pg > 1 && (Pg--, (t = !0)))),
          (Rg.time = e.toFixed(0)),
          t && xg && (vg(bg, Pg, Dg), wg.configure(bg))
      }
    const Bg = (e, t, n, i) => {
        e.drawImage(i, 0, 0, t, n)
      },
      zg = (e, t, n, i) => {
        e.setTransform(-1, 0, 0, 1, t, 0),
          e.drawImage(i, 0, 0, t, n),
          e.setTransform(1, 0, 0, 1, 0, 0)
      },
      Ug = (e, t, n, i) => {
        ;(e.strokeStyle = null), (e.fillStyle = Wg(n, 1))
        let r = i || 2
        for (let a = 0; a < t.length; ++a)
          e.beginPath(), e.arc(t[a].x, t[a].y, r, 0, 2 * Math.PI), e.fill()
      },
      kg = (e, t, n, i) => {
        ;(e.strokeStyle = Wg(n, 1)),
          (e.fillStyle = null),
          (e.lineWidth = i || 1),
          e.beginPath(),
          e.rect(t.x, t.y, t.width, t.height),
          e.stroke()
      },
      Hg = (e, t, n, i) => {
        ;(e.strokeStyle = Wg(n, 1)),
          (e.fillStyle = null),
          (e.lineWidth = i || 1)
        for (let r = 0; r < t.length; ++r) {
          let n = t[r]
          e.beginPath(), e.rect(n.x, n.y, n.width, n.height), e.stroke()
        }
      },
      Wg = (e, t) => {
        const n = e + ''
        return n.startsWith('rgb')
          ? e
          : (n.startsWith('#') && (e = parseInt('0x' + n.substr(1))),
            'rgb(' +
              ((e >> 16) & 255).toString(10) +
              ', ' +
              ((e >> 8) & 255).toString(10) +
              ', ' +
              (255 & e).toString(10) +
              ', ' +
              t +
              ')')
      },
      Vg = {
        NO_SCALE: 0,
        STRETCH: 1,
        PROPORTIONAL_INSIDE: 2,
        PROPORTIONAL_OUTSIDE: 3
      },
      Gg = (e, t, n, i, r) => {
        const a = t,
          s = n,
          o = e.parentElement.getBoundingClientRect(),
          l = parseInt(o.left),
          c = parseInt(o.top),
          h = parseInt(o.right) - l,
          u = parseInt(o.bottom) - c
        let d = u,
          p = (d / s) * a
        if (
          (i === Vg.NO_SCALE
            ? ((p = a), (d = s))
            : i === Vg.STRETCH
            ? (p = h)
            : i === Vg.PROPORTIONAL_INSIDE
            ? p > h && ((p = h), (d = (p / a) * s))
            : i === Vg.PROPORTIONAL_OUTSIDE &&
              p < h &&
              ((p = h), (d = (p / a) * s)),
          r)
        ) {
          let t = 1
          ;(t = Math.abs(h - p) < 0.1 ? d / s : p / a),
            (e.style.left = Math.floor(0.5 * (h - p)) + 'px'),
            (e.style.top = Math.floor(0.5 * (u - d)) + 'px'),
            (e.style.transformOrigin = '0 0'),
            (e.style.transform = 'scale(' + t + ')')
        } else (e.style.width = p + 'px'), (e.style.height = d + 'px')
      }
    var jg = function () {
        var e = this,
          t = e.$createElement,
          n = e._self._c || t
        return n('div', { ref: '_camera', staticClass: 'abs oh full-view' }, [
          n('video', {
            ref: '_video',
            staticClass: 'abs cm',
            attrs: { playsinline: '', muted: '' },
            domProps: { muted: !0 }
          }),
          n('canvas', { ref: '_canvas_0', staticClass: 'abs c vh' }),
          n('canvas', { ref: '_canvas_1', staticClass: 'abs c vh' })
        ])
      },
      qg = []
    const Yg = (e, t) => !(!e || !e.play) || (m(t), !1)
    const Xg = {
        USER: 'user',
        ENVIRONMENT: 'environment',
        LEFT: 'left',
        RIGHT: 'right'
      },
      Jg = { width: 640, height: 480, frameRate: 30, facingMode: Xg.USER },
      Zg = {
        width: { ideal: 640, min: 640, max: 1920 },
        height: { ideal: 480, min: 480, max: 1080 },
        frameRate: { ideal: 30, max: 30 },
        facingMode: { ideal: Xg.USER }
      },
      Kg = 'utils__camera: ',
      Qg = e =>
        new Promise((t, n) => {
          window.navigator.mediaDevices
            .getUserMedia({ video: Zg })
            .then(i => {
              ;(e.srcObject = i),
                e
                  .play()
                  .then(() => {
                    t({ video: e })
                  })
                  .catch(e => {
                    n(e)
                  })
            })
            .catch(e => {
              n(e)
            })
        }),
      $g = (e, t) => {
        if (
          Yg(
            e,
            Kg +
              'startCamera: Provide a HTML video element to start the camera stream.'
          )
        )
          return (
            ev(e, !1, !0),
            t || (t = Jg),
            t.width && (Zg.width.ideal = t.width),
            t.height && (Zg.height.ideal = t.height),
            t.frameRate && (Zg.frameRate.ideal = t.frameRate),
            t.facingMode && (Zg.facingMode.ideal = t.facingMode),
            p(Kg + 'startCamera:', Zg),
            Qg(e)
          )
      },
      ev = (e, t = !0, n = !1) => {
        if (
          (n || p(Kg + 'stopCamera'),
          !Yg(
            e,
            Kg +
              'stopCamera: Provide a HTML video element to stop the camera stream.'
          ))
        )
          return
        const i = e.srcObject
        i
          ? i.getTracks().forEach(e => {
              e.stop()
            })
          : n || f(Kg + 'stopCamera: No mediaStream attached to video.'),
          t && !e.paused && e.pause()
      }
    const tv = 'BRFv5CameraView',
      nv = {
        width: 0,
        height: 0,
        frameRate: 30,
        facingMode: 'user',
        mirrored: !0
      },
      iv = (e, t) => !(!t[e] || nv[e] === t[e]) && ((nv[e] = t[e]), !0)
    let rv = -1,
      av = -1,
      sv = null,
      ov = -1,
      lv = !0,
      cv = null,
      hv = null,
      uv = null,
      dv = null
    var pv = {
        name: tv,
        props: {
          enabled: { type: Boolean, default: !1 },
          constraints: { type: Object, default: () => Jg }
        },
        mounted () {
          this.$nextTick(() => {
            E(tv + ': mounted'),
              (sv = window.orientation),
              window.addEventListener('resize', this.onResize),
              window.addEventListener(
                'orientationchange',
                this.onOrientationChange
              ),
              (cv = this.$refs._canvas_0),
              (uv = this.$refs._canvas_1),
              this.enabled &&
                this.openCamera(this.constraints)
                  .catch(e => {
                    this.$emit('onCameraError', { error: e })
                  })
                  .finally(() => {
                    this.$refs._camera.classList.remove('vh')
                  })
          })
        },
        beforeDestroy () {
          E(tv + ': beforeDestroy'),
            window.removeEventListener('resize', this.onResize),
            window.removeEventListener(
              'orientationchange',
              this.onOrientationChange
            ),
            this.closeCamera()
        },
        methods: {
          openCamera (e) {
            E(tv + ': openCamera:', e), e || (e = Jg)
            let t = lv || this.isVideoPaused()
            return (
              (t = iv('width', e) || t),
              (t = iv('height', e) || t),
              (t = iv('frameRate', e) || t),
              (t = iv('facingMode', e) || t),
              (t = iv('mirrored', e) || t),
              new Promise((e, n) => {
                t
                  ? $g(this.$refs._video, nv)
                      .then(({ video: t }) => {
                        ;(rv = t.videoWidth),
                          (av = t.videoHeight),
                          E(tv + ': onCameraOpened:', rv, av),
                          (this.$refs._canvas_0.width = rv),
                          (this.$refs._canvas_0.height = av),
                          (this.$refs._canvas_1.width = rv),
                          (this.$refs._canvas_1.height = av),
                          this.onResize(),
                          this.onAnimationFrame(),
                          this.$emit('onCameraOpened', {
                            width: rv,
                            height: av
                          }),
                          (lv = !1),
                          e({ width: rv, height: av })
                      })
                      .catch(e => {
                        n(e)
                      })
                  : (this.onAnimationFrame(), e({ width: rv, height: av }))
              })
            )
          },
          closeCamera (e = !0, t = !1) {
            E(tv + ': closeCamera:', e, t),
              cancelAnimationFrame(ov),
              ev(this.$refs._video, e, t),
              (this.$refs._canvas_0.style.visibility = null),
              (this.$refs._canvas_1.style.visibility = null),
              this.$emit('onCameraClosed')
          },
          onAnimationFrame () {
            this.$emit('onEnterFrame'),
              cancelAnimationFrame(ov),
              (ov = requestAnimationFrame(this.onAnimationFrame))
            const e = cv.getContext('2d'),
              t = uv.getContext('2d')
            nv.mirrored
              ? zg(t, rv, av, this.$refs._video)
              : Bg(t, rv, av, this.$refs._video),
              null === hv && (hv = e.getImageData(0, 0, rv, av)),
              (dv = t.getImageData(0, 0, rv, av))
            let n = cv === uv
            const i = av / 6
            for (let r = i; r < av && !n; r += i)
              for (let e = r * rv * 4 + 1; e < r * rv * 5 + 1; e += 4)
                if (hv.data[e] !== dv.data[e]) {
                  n = !0
                  break
                }
            if (n) {
              let e = cv
              ;(cv = uv),
                (uv = e),
                (e = hv),
                (hv = dv),
                (dv = e),
                (cv.style.visibility = 'visible'),
                (uv.style.visibility = 'hidden'),
                this.$emit('onImageData', { imageData: hv, canvas: cv }),
                this.$emit('onExitFrame')
            } else;
          },
          isVideoPaused () {
            return this.$refs._video.paused
          },
          onResize () {
            Gg(this.$refs._video, rv, av, Vg.PROPORTIONAL_OUTSIDE),
              Gg(this.$refs._canvas_0, rv, av, Vg.PROPORTIONAL_OUTSIDE),
              Gg(this.$refs._canvas_1, rv, av, Vg.PROPORTIONAL_OUTSIDE)
          },
          onOrientationChange () {
            window.orientation !== sv &&
              ((sv = window.orientation),
              this.isVideoPaused() ||
                (this.$refs._camera.classList.add('vh'),
                this.closeCamera(),
                setTimeout(() => {
                  this.openCamera(this.constraints)
                    .catch(e => {
                      this.$emit('onCameraError', { error: e })
                    })
                    .finally(() => {
                      this.$refs._camera.classList.remove('vh')
                    })
                }, 250)))
          }
        },
        watch: {
          enabled: function (e, t) {
            E(tv + ': watch.enabled:', e, t),
              e
                ? setTimeout(() => {
                    this.openCamera(this.constraints)
                      .catch(e => {
                        this.$emit('onCameraError', { error: e })
                      })
                      .finally(() => {
                        this.$refs._camera.classList.remove('vh')
                      })
                  }, 50)
                : this.closeCamera()
          }
        }
      },
      fv = pv,
      mv = n('2877'),
      gv = Object(mv['a'])(fv, jg, qg, !1, null, null, null),
      vv = gv.exports,
      yv = function () {
        var e = this,
          t = e.$createElement,
          n = e._self._c || t
        return n('div', { ref: '__artov5__stats', staticClass: 'abs tl10' })
      },
      _v = [],
      xv = function () {
        var e = 0,
          t = document.createElement('div')
        function n (e) {
          return t.appendChild(e.dom), e
        }
        function i (n) {
          for (var i = 0; i < t.children.length; i++)
            t.children[i].style.display = i === n ? 'block' : 'none'
          e = n
        }
        ;(t.style.cssText = 'cursor:pointer;opacity:0.9;z-index:10000'),
          t.addEventListener(
            'click',
            function (n) {
              n.preventDefault(), i(++e % t.children.length)
            },
            !1
          )
        var r = (performance || Date).now(),
          a = r,
          s = 0,
          o = n(new xv.Panel('MS', '#fff', '#00a0ff')),
          l = n(new xv.Panel('FPS', '#00a0ff', '#fff'))
        return (
          self.performance && self.performance.memory,
          i(0),
          {
            REVISION: 16,
            dom: t,
            addPanel: n,
            showPanel: i,
            begin: function () {
              r = (performance || Date).now()
            },
            end: function () {
              s++
              var e = (performance || Date).now()
              return (
                o.update(e - r, 200),
                e >= a + 1e3 &&
                  (l.update((1e3 * s) / (e - a), 100), (a = e), (s = 0)),
                e
              )
            },
            setMS: function (e, t) {
              o.update(e, 200, t), l.update(1e3 / e, 100)
            },
            update: function () {
              r = this.end()
            },
            domElement: t,
            setMode: i
          }
        )
      }
    xv.Panel = function (e, t, n) {
      var i = 1 / 0,
        r = 0,
        a = Math.round,
        s = a(window.devicePixelRatio || 1),
        o = 80 * s,
        l = 48 * s,
        c = 3 * s,
        h = 2 * s,
        u = 3 * s,
        d = 15 * s,
        p = 74 * s,
        f = 30 * s,
        m = document.createElement('canvas')
      ;(m.width = o),
        (m.height = l),
        (m.style.cssText = 'width:80px;height:48px')
      var g = m.getContext('2d')
      return (
        (g.font = 'bold ' + 9 * s + 'px Helvetica,Arial,sans-serif'),
        (g.textBaseline = 'top'),
        (g.fillStyle = n),
        g.fillRect(0, 0, o, l),
        (g.fillStyle = t),
        g.fillText(e, c, h),
        g.fillRect(u, d, p, f),
        (g.fillStyle = n),
        (g.globalAlpha = 0.9),
        g.fillRect(u, d, p, f),
        {
          dom: m,
          update: function (l, v, y) {
            ;(i = Math.min(i, l)),
              (r = Math.max(r, l)),
              (g.fillStyle = n),
              (g.globalAlpha = 1),
              g.fillRect(0, 0, o, d),
              (g.fillStyle = t),
              g.fillText(
                a(l) +
                  ' ' +
                  e +
                  ' (' +
                  a(i) +
                  '-' +
                  a(r) +
                  (y ? '-' + y : '') +
                  ')',
                c,
                h
              ),
              g.drawImage(m, u + s, d, p - s, f, u, d, p - s, f),
              g.fillRect(u + p - s, d, s, f),
              (g.fillStyle = n),
              (g.globalAlpha = 0.9),
              g.fillRect(u + p - s, d, s, a((1 - l / v) * f))
          }
        }
      )
    }
    var wv = xv
    const bv = 'BRFv5Stats',
      Mv = new wv()
    var Sv = {
        name: bv,
        mounted () {
          this.$nextTick(() => {
            E(bv + ': mounted'), this.$refs.__artov5__stats.appendChild(Mv.dom)
          })
        },
        methods: {
          updateStats (e, t) {
            e > 0 && Mv.setMS(e, t)
          }
        }
      },
      Ev = Sv,
      Tv = Object(mv['a'])(Ev, yv, _v, !1, null, null, null),
      Av = Tv.exports
    const Rv = 'BRFv5CameraTracker'
    let Lv = -1,
      Cv = -1,
      Pv = null,
      Dv = null
    var Iv = {
        name: Rv,
        components: { BRFv5CameraView: vv, BRFv5Stats: Av },
        props: {
          appId: {
            type: String,
            required: !0,
            validator: function (e) {
              return e.length >= 8
            }
          },
          pathToModels: { type: String, required: !0 },
          modelType: {
            type: String,
            default: '42l',
            validator: function (e) {
              return ['68l', '42l'].indexOf(e) >= 0
            }
          },
          numFacesToTrack: {
            type: Number,
            default: 1,
            validator: function (e) {
              return e >= 1 && e <= 2
            }
          },
          numChunksToLoad: {
            type: Number,
            default: 4,
            validator: function (e) {
              return e >= 1 && e <= 8
            }
          },
          enableDynamicPerformance: { type: Boolean, default: !0 },
          showStats: { type: Boolean, default: !1 },
          showDebugDraw: { type: Boolean, default: !1 },
          cameraEnabled: { type: Boolean, default: !0 },
          cameraConstraints: {
            type: Object,
            default: function () {
              return {
                width: 640,
                height: 480,
                frameRate: 30,
                facingMode: 'user',
                mirrored: !0
              }
            }
          }
        },
        mounted () {
          this.$nextTick(() => {
            E(
              Rv + ': mounted: WebAssembly supported:',
              h.isWebAssemblySupported
            ),
              window.addEventListener('resize', this.onResize),
              Fm(
                this.modelType,
                this.numChunksToLoad,
                this.pathToModels,
                this.appId,
                this.onProgress
              )
                .then(({ brfv5Manager: e, brfv5Config: t }) => {
                  E(Rv + ': loadBRFv5Model: done'),
                    (Pv = e),
                    (Dv = t),
                    this.initTracking(Lv, Cv)
                })
                .catch(e => {
                  this.$emit('onBRFv5Error', { error: e })
                })
          })
        },
        beforeDestroy () {
          E(Rv + ': beforeDestroy'),
            window.removeEventListener('resize', this.onResize)
        },
        methods: {
          initTracking (e, t) {
            e > 0 && t > 0 && ((Lv = e), (Cv = t)),
              E(Rv + ': initTracking: ' + (null !== Dv && Lv > 0)),
              null !== Dv &&
                Lv > 0 &&
                ((this.$refs._debug.width = Lv),
                (this.$refs._debug.height = Cv),
                this.onResize(),
                _g(Dv, Lv, Cv),
                vg(Dv, 3, !0),
                yg(Dv, this.numFacesToTrack),
                Pv.reset(),
                this.enableDynamicPerformance ? Mg(Pv, Dv) : Sg(),
                Pv.configure(Dv),
                this.$emit('onBRFv5Ready', {
                  brfv5: Im,
                  brfv5Manager: Pv,
                  brfv5Config: Dv
                }))
          },
          onImageData ({ imageData: e, canvas: t }) {
            if (!Pv || !e || !t || Lv <= 0) return
            Pv.update(e)
            const n = Pv.getFaces()
            if (this.showDebugDraw) {
              const e = this.$refs._debug.getContext('2d')
              e.clearRect(0, 0, Lv, Cv)
              let t = !Dv.enableFaceTracking
              if (Dv.enableFaceTracking) {
                const n = Math.min(Lv, Cv) / 480,
                  i = Pv.getFaces()
                for (let r = 0; r < i.length; r++) {
                  const a = i[r]
                  a.state === Im.BRFv5State.FACE_TRACKING
                    ? (kg(
                        e,
                        Dv.faceTrackingConfig.regionOfInterest,
                        '#00a0ff',
                        2
                      ),
                      Ug(e, a.landmarks, '#00a0ff', 2 * n),
                      kg(e, a.bounds, '#ffffff', 1))
                    : (t = !0)
                }
              }
              t &&
                (kg(e, Dv.faceDetectionConfig.regionOfInterest, '#ffffff', 2),
                Hg(e, Pv.getDetectedRects(), '#00a0ff', 1),
                Hg(e, Pv.getMergedRects(), '#ffffff', 3))
            }
            this.$emit('onBRFv5Tracked', { faces: n, canvas: t }),
              this.$refs._stats.updateStats(
                Rg.time,
                '' +
                  (Dv.faceTrackingConfig.numTrackingPasses +
                    (Dv.faceTrackingConfig.enableFreeRotation ? 1 : 0))
              )
          },
          onProgress (e) {
            this.$emit('onProgress', e)
          },
          onEnterFrame () {
            Ng()
          },
          onExitFrame () {
            Og()
          },
          onResize () {
            Gg(this.$refs._debug, Lv, Cv, Vg.PROPORTIONAL_OUTSIDE)
          },
          onCameraOpened (e) {
            this.initTracking(e.width, e.height),
              this.$emit('onCameraOpened', e)
          },
          onCameraClosed () {
            this.$emit('onCameraClosed')
          },
          onCameraError (e) {
            this.$emit('onCameraError', { error: e })
          }
        },
        watch: {
          numFacesToTrack: function (e) {
            this.initTracking(Lv, Cv)
          }
        }
      },
      Nv = Iv,
      Ov = Object(mv['a'])(Nv, fg, mg, !1, null, null, null),
      Fv = Ov.exports,
      Bv = function () {
        var e = this,
          t = e.$createElement,
          n = e._self._c || t
        return n('div', { ref: '_camera', staticClass: 'abs oh full-view' }, [
          n('canvas', { ref: '_canvas', staticClass: 'abs c' })
        ])
      },
      zv = []
    const Uv = 'BRFv5CameraCopy'
    var kv = {
        name: Uv,
        props: { input: { type: Object, default: () => null } },
        mounted () {
          this.$nextTick(() => {
            E(Uv + ': mounted'),
              window.addEventListener('resize', this.onResize)
          })
        },
        beforeDestroy () {
          E(Uv + ': beforeDestroy'),
            window.removeEventListener('resize', this.onResize)
        },
        methods: {
          onResize () {
            Gg(
              this.$refs._canvas,
              this.$refs._canvas.width,
              this.$refs._canvas.height,
              Vg.PROPORTIONAL_OUTSIDE
            )
          }
        },
        watch: {
          input: function (e) {
            ;(this.$refs._canvas.width === e.width &&
              this.$refs._canvas.height === e.height) ||
              ((this.$refs._canvas.width = e.width),
              (this.$refs._canvas.height = e.height),
              this.onResize())
            const t = this.$refs._canvas.getContext('2d')
            Bg(t, this.$refs._canvas.width, this.$refs._canvas.height, e.input)
          }
        }
      },
      Hv = kv,
      Wv = Object(mv['a'])(Hv, Bv, zv, !1, null, null, null),
      Vv = Wv.exports,
      Gv = function () {
        var e = this,
          t = e.$createElement,
          n = e._self._c || t
        return n('div', { staticClass: 'abs oh full-view' }, [
          n('canvas', { ref: '_canvas', staticClass: 'abs c bg-t' })
        ])
      },
      jv = []
    const qv = e => {
        for (let t = 0; t < e.baseNodes.length; t++) e.baseNodes[t].visible = !1
      },
      Yv = (e, t, n, i) => {
        const r = e.transforms,
          a = e.baseNodes,
          s = e.scene,
          o = e.renderer.domElement.width,
          l = e.renderer.domElement.height
        if (n >= a.length)
          return void m(
            'threejs_brfv5_mapping.updateByFace: Call setNumFaces before loading the models and starting the tracking.'
          )
        const c = a[n],
          h = r[n]
        if (!s || !t || !t.landmarks) return void (c.visible = !1)
        let u = 1362
        if ((e.camera.isPerspectiveCamera && (u = (l / 480) * 1362), i)) {
          const n = e.sceneScale,
            i = o / n,
            r = l / n
          let a = t.scale * n * 0.0133,
            s = -(t.translationX - 0.5 * i) * n,
            d = -(t.translationY - 0.5 * r) * n,
            p = 1.3 * -t.rotationX,
            f = 1.3 * -t.rotationY,
            m = t.rotationZ,
            g = Math.abs(f) / 30,
            v = Math.abs(p) / 30
          p < 0
            ? ((p *= 1 + g), (f *= 0.95), (d -= 10 * v))
            : ((p *= 1.33), (d += 7 * v)),
            f < 0
              ? p > 0
                ? (m -= g + g * v * 10)
                : (m += g + g * v * 10)
              : p > 0
              ? (m += g + g * v * 10)
              : (m -= g + g * v * 10),
            e.camera.isPerspectiveCamera &&
              ((p -= R(Math.atan(d / u))), (f += R(Math.atan(s / u))))
          const y = s - h.x,
            _ = d - h.y,
            x = Math.abs(y),
            w = Math.abs(_)
          !c.visible || x > 3 || w > 3
            ? ((h.x = h.x + y), (h.y = h.y + _))
            : ((h.x = h.x + y * (x < 1 ? 0.25 : x < 2 ? 0.5 : 0.75)),
              (h.y = h.y + _ * (w < 1 ? 0.25 : w < 2 ? 0.5 : 0.75))),
            (h.z = u - 0.1 * a),
            (h.scale = a)
          const b = p - h.rx,
            M = f - h.ry,
            S = m - h.rz,
            E = Math.abs(b),
            T = Math.abs(M),
            A = Math.abs(S)
          ;(h.rx = h.rx + b * (E < 1 ? 0.25 : E < 2 ? 0.5 : 0.75)),
            (h.ry = h.ry + M * (T < 1 ? 0.25 : T < 2 ? 0.5 : 0.75)),
            (h.rz = h.rz + S * (A < 1 ? 0.25 : A < 2 ? 0.5 : 0.75)),
            c.position.set(h.x, h.y, h.z),
            c.rotation.set(L(h.rx), L(h.ry), L(h.rz)),
            c.scale.set(h.scale, h.scale, h.scale),
            (c.visible = !0)
        } else c.visible = !1
      }
    const Xv = 'ARTOv5ThreeJS'
    let Jv = !1
    var Zv = {
        name: Xv,
        props: {
          resolution: { type: Object, required: !0 },
          view: { type: Object, required: !0 },
          faces: { type: Array, required: !0 },
          numFacesToTrack: { type: Number, default: 1 },
          t3d: { type: Object, default: () => ({}) }
        },
        data () {
          return { idTimeOut: -1 }
        },
        computed: {
          models: function () {
            return this.view.models
          },
          viewSpot: function () {
            return this.view.viewSpot
          }
        },
        mounted () {
          this.$nextTick(() => {
            E(Xv + ': mounted: WebGL supported:', h.isWebGLSupported),
              $m(this.t3d, this.$refs._canvas)
                ? ((Jv = !0),
                  (this.view.t3d = this.t3d),
                  this.setupAPI(),
                  this.updateLayout(
                    this.resolution.width,
                    this.resolution.height
                  ),
                  this.updateModels(),
                  this.$emit('onThreeJSReady'),
                  window.addEventListener('resize', this.onResize),
                  window.dispatchEvent(new Event('resize')))
                : this.onError(new Error('SCENE_CREATION_FAILED'))
          })
        },
        beforeDestroy () {
          E(Xv + ': beforeDestroy'),
            window.removeEventListener('resize', this.onResize),
            window.dispatchEvent(new Event('resize'))
        },
        methods: {
          setupAPI () {
            this.view.api &&
              ((this.view.api.updateMeshMaterial = e => {
                ug(this.t3d, e.nameMesh, e)
              }),
              (this.view.api.updateMaterialConfig = () => {
                for (let t = 0; t < this.models.length; t++) {
                  const n = this.models[t],
                    i = jm(this.t3d, n.pathToModel)
                  if (n.materialConfig) {
                    const e = n.materialConfig.scale
                      ? n.materialConfig.scale
                      : 1
                    pg(this.t3d, e)
                  }
                  if (!n.isMaterialCollection && i && n.materialConfig)
                    for (var e in n.materialConfig)
                      'scale' !== e && dg(this.t3d, e, n.materialConfig[e])
                }
              }))
          },
          updateModels () {
            E(Xv + ': updateModels', this.models),
              rg(this.t3d, this.numFacesToTrack),
              qv(this.t3d),
              this.models &&
                Hm({ fileList: this.models, onProgress: this.onProgress })
                  .then(() => {
                    ag(this.t3d), og(this.t3d)
                    for (let t = 0; t < this.models.length; t++) {
                      const n = this.models[t],
                        i = jm(this.t3d, n.pathToModel)
                      if (
                        (n.isOcclusionModel && hg(i),
                        !n.isMaterialCollection &&
                          i &&
                          (sg(this.t3d, i), n.materialConfig))
                      ) {
                        const t = n.materialConfig.scale
                          ? n.materialConfig.scale
                          : 1
                        for (var e in (pg(this.t3d, t), n.materialConfig))
                          'scale' !== e && dg(this.t3d, e, n.materialConfig[e])
                      }
                    }
                    for (let t = 0; t < this.models.length; t++) {
                      const e = this.models[t]
                      e.isMaterialCollection ||
                        lg(this.t3d, e.pathToModel, e.nameModel, (e, t) => {
                          A('SETTING_3D_MODEL_NAME_FAILED:', t, e),
                            this.onError(
                              new Error('SETTING_3D_MODEL_NAME_FAILED')
                            )
                        })
                    }
                    this.$emit('onThreeJSModelsLoaded')
                  })
                  .catch(e => {
                    console.warn(e),
                      this.onError(new Error('LOADING_3D_MODEL_FAILED'))
                  })
          },
          updateLayout (e, t) {
            E(Xv + ': updateLayout:', e, t),
              e > 0 &&
                t > 0 &&
                ((this.$refs._canvas.width = e),
                (this.$refs._canvas.height = t),
                ig(this.t3d, e, t),
                this.onResize())
          },
          onProgress (e) {
            this.$emit('onProgress', e)
          },
          onError (e) {
            this.$emit('onThreeJSError', { error: e })
          },
          onResize () {
            Gg(
              this.$refs._canvas,
              this.$refs._canvas.width,
              this.$refs._canvas.height,
              Vg.PROPORTIONAL_OUTSIDE
            )
          }
        },
        watch: {
          resolution: function ({ width: e, height: t }) {
            this.updateLayout(e, t)
          },
          numFacesToTrack: function (e) {
            this.updateModels()
          },
          faces: function (e) {
            if (Jv) {
              if (0 === e.length) qv(this.t3d)
              else
                for (let t = 0; t < e.length; t++)
                  Yv(this.t3d, e[t].face, e[t].index, e[t].show)
              ng(this.t3d)
            }
          },
          models: {
            handler (e) {
              clearTimeout(this.idTimeOut),
                (this.idTimeOut = setTimeout(() => {
                  E(Xv + ': watch.models:', e),
                    this.updateModels(),
                    window.dispatchEvent(new Event('resize'))
                }, 250))
            },
            deep: !0
          },
          viewSpot: {
            handler (e) {
              E(Xv + ': watch.viewSpot:', e),
                window.dispatchEvent(new Event('resize'))
            },
            deep: !0
          }
        }
      },
      Kv = Zv,
      Qv = Object(mv['a'])(Kv, Gv, jv, !1, null, null, null),
      $v = Qv.exports,
      ey = function () {
        var e = this,
          t = e.$createElement,
          n = e._self._c || t
        return n('div', { staticClass: 'abs oh full-view bg-main' }, [
          n('div', { staticClass: 'abs oh spinner' }, [
            n(
              'svg',
              {
                attrs: {
                  viewBox: '0 0 10 18',
                  fill: 'none',
                  xmlns: 'http://www.w3.org/2000/svg'
                }
              },
              [
                n('path', {
                  attrs: {
                    d:
                      'm3.116 9.13.03-.123-.03-.122-1.974-7.833h7.716L6.884 8.885l-.03.122.03.122 1.97 7.819H1.146l1.97-7.819Z',
                    stroke: 'currentColor'
                  }
                })
              ]
            )
          ])
        ])
      },
      ty = []
    const ny = 'ARTOv5Preloader'
    var iy = {
        name: ny,
        mounted () {
          this.$nextTick(() => {
            E(ny + ': mounted')
          })
        }
      },
      ry = iy,
      ay = (n('3c76'), Object(mv['a'])(ry, ey, ty, !1, null, '2bcd0ca5', null)),
      sy = ay.exports
    const oy = 'ARTOv5View'
    var ly = {
        name: oy,
        components: {
          BRFv5CameraTracker: Fv,
          BRFv5CameraCopy: Vv,
          ARTOv5ThreeJS: $v,
          ARTOv5Preloader: sy
        },
        props: {
          config: {
            type: Object,
            required: !0,
            validator: function (e) {
              return (
                e.hasOwnProperty('ARTOv5ViewSpot') &&
                e.hasOwnProperty('ARTOv5Model3D') &&
                e.hasOwnProperty('brfv5') &&
                e.hasOwnProperty('camera') &&
                e.hasOwnProperty('views') &&
                e.hasOwnProperty('events')
              )
            }
          }
        },
        data () {
          return {
            preloadProgress: 0,
            numFacesToTrack: 0,
            resolution: { width: -1, height: -1 },
            faces: [],
            currentCanvas: { canvas: null }
          }
        },
        computed: {
          debugLevel: function () {
            return this.config.debugLevel
          },
          isMobileOS: function () {
            return h.isMobileOS
          },
          brfv5: function () {
            return this.config.brfv5
          },
          camera: function () {
            return this.config.camera
          },
          events: function () {
            return this.config.events
          },
          views: function () {
            return this.config.views
          },
          showPreloader: function () {
            return this.config.showPreloader
          }
        },
        mounted () {
          this.$nextTick(() => {
            E(oy + ': mounted')
          }),
            this.setupAPI(),
            this.setupLogging(),
            this.config ||
              this.$nextTick(() => {
                T(
                  oy +
                    ": mounted, but window.artov5 (config) isn't available. Please load artov5's config files first."
                )
              })
        },
        methods: {
          setupAPI () {
            const e = document.createElement('canvas'),
              t = this
            window.artov5.api.takeSnapshot = function (n) {
              if ((E(oy + ': api: takeSnapshot'), !t.currentCanvas.input))
                return (
                  T(oy + ': api: takeSnapshot: missing current canvas.'), null
                )
              ng(t.$refs._renderer[0].t3d)
              const i = t.currentCanvas.input,
                r = t.$refs._renderer[0].$refs._canvas,
                a = n,
                s = e,
                o = i.width,
                l = i.height
              function c (e) {
                const t = s.getContext('2d'),
                  n = e.width,
                  i = e.height,
                  r = o / n < l / i ? l / i : o / n,
                  a = 0.5 * (o - n * r),
                  c = 0.5 * (l - i * r)
                t.setTransform(r, 0, 0, r, a, c),
                  t.drawImage(e, 0, 0),
                  t.setTransform(1, 0, 0, 1, 0, 0)
              }
              ;(s.width = o), (s.height = l)
              const h = s.getContext('2d')
              return (
                h.setTransform(1, 0, 0, 1, 0, 0),
                h.drawImage(i, 0, 0),
                c(r),
                a && c(a),
                s
              )
            }
          },
          setupLogging () {
            const e = this.debugLevel
            ;(0 !== e && 1 !== e && 2 !== e) || (d(e > 1), S(e > 0))
          },
          onReportedProgress (e) {
            b(
              {
                url: e.currentTarget.responseURL,
                loaded: e.loaded,
                total: e.total
              },
              this.onReportProgress
            )
          },
          onReportProgress (e) {
            ;(this.preloadProgress = e),
              this.events.onProgress &&
                this.events.onProgress(this.preloadProgress)
          },
          onBRFv5Tracked ({ faces: e, canvas: t }) {
            const n = []
            for (let i = 0; i < e.length; i++)
              n.push({
                face: e[i],
                index: i,
                show: 'face_tracking' === e[i].state
              })
            this.config.show3DOverlay
              ? (this.faces = n)
              : this.faces.length > 0 && (this.faces = []),
              (this.currentCanvas = {
                input: t,
                width: this.resolution.width,
                height: this.resolution.height
              }),
              this.events.onBRFv5Tracked && this.events.onBRFv5Tracked(n)
          },
          onCameraOpened ({ width: e, height: t }) {
            E(oy + ': onCameraOpened'),
              (this.resolution = { width: e, height: t }),
              this.events.onCameraOpened &&
                this.events.onCameraOpened({ width: e, height: t })
          },
          onCameraClosed () {
            E(oy + ': onCameraClosed'),
              (this.faces = []),
              this.events.onCameraClosed && this.events.onCameraClosed()
          },
          onBRFv5Ready ({ brfv5Config: e }) {
            ;(this.numFacesToTrack = e.faceTrackingConfig.numFacesToTrack),
              E(oy + ': onBRFv5Ready: numFacesToTrack:', this.numFacesToTrack),
              this.events.onBRFv5Ready &&
                this.events.onBRFv5Ready(this.numFacesToTrack)
          },
          onThreeJSReady () {
            E(oy + ': onThreeJSReady'),
              this.events.onThreeJSReady && this.events.onThreeJSReady()
          },
          onThreeJSModelsLoaded () {
            E(oy + ': onThreeJSModelsLoaded'),
              this.events.onThreeJSModelsLoaded &&
                this.events.onThreeJSModelsLoaded()
          },
          onError (e, t) {
            this.onAPIError
              ? this.onAPIError({ code: t, error: e.error })
              : A(oy + ': onError', e)
          },
          onCameraError (e) {
            A(oy + ': onCameraError', e),
              this.events.onCameraError &&
                this.events.onCameraError({
                  code: 'CAMERA_FAILED',
                  error: e.error
                })
          },
          onBRFv5Error (e) {
            A(oy + ': onBRFv5Error', e),
              this.events.onBRFv5Error &&
                this.events.onBRFv5Error({
                  code: 'BRFV5_FAILED',
                  error: e.error
                })
          },
          onThreeJSError (e) {
            A(oy + ': onThreeJSError', e),
              this.events.onThreeJSError &&
                this.events.onThreeJSError({
                  code: '3D_FAILED',
                  error: e.error
                })
          }
        },
        watch: {
          debugLevel: function (e) {
            this.setupLogging()
          }
        }
      },
      cy = ly,
      hy = (n('a1fe'), Object(mv['a'])(cy, r, a, !1, null, null, null)),
      uy = hy.exports
    i['a'].config.productionTip = !1
    let dy = null,
      py = 0
    window.initARTOv5 = e => {
      if (dy || 'object' !== typeof e)
        console.log('Call window.initARTOv5 with a proper config.')
      else {
        dy = e
        const t = i['a'].extend(uy),
          n = new t({ propsData: { config: dy } })
        n.$mount('#__artov5__app')
      }
    }
    const fy = () => {
      dy ||
        (4 === py++ &&
          console.log('Waiting for window.initARTOv5 to be called.'),
        setTimeout(fy, 250))
    }
    fy()
  },
  '536b': function (module, __webpack_exports__, __webpack_require__) {
    'use strict'
    ;(function (__filename, process, global, __dirname) {
      __webpack_require__.d(__webpack_exports__, 'a', function () {
        return brfv5Module
      })
      var core_js_modules_es_typed_array_uint8_array_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
          '5cc6'
        ),
        core_js_modules_es_typed_array_uint8_array_js__WEBPACK_IMPORTED_MODULE_0___default = __webpack_require__.n(
          core_js_modules_es_typed_array_uint8_array_js__WEBPACK_IMPORTED_MODULE_0__
        ),
        core_js_modules_es_typed_array_sort_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
          '219c'
        ),
        core_js_modules_es_typed_array_sort_js__WEBPACK_IMPORTED_MODULE_1___default = __webpack_require__.n(
          core_js_modules_es_typed_array_sort_js__WEBPACK_IMPORTED_MODULE_1__
        ),
        core_js_modules_es_typed_array_uint32_array_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
          'fb2c'
        ),
        core_js_modules_es_typed_array_uint32_array_js__WEBPACK_IMPORTED_MODULE_2___default = __webpack_require__.n(
          core_js_modules_es_typed_array_uint32_array_js__WEBPACK_IMPORTED_MODULE_2__
        ),
        core_js_modules_es_typed_array_uint16_array_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
          '84c3'
        ),
        core_js_modules_es_typed_array_uint16_array_js__WEBPACK_IMPORTED_MODULE_3___default = __webpack_require__.n(
          core_js_modules_es_typed_array_uint16_array_js__WEBPACK_IMPORTED_MODULE_3__
        ),
        core_js_modules_es_typed_array_int8_array_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
          'fd87'
        ),
        core_js_modules_es_typed_array_int8_array_js__WEBPACK_IMPORTED_MODULE_4___default = __webpack_require__.n(
          core_js_modules_es_typed_array_int8_array_js__WEBPACK_IMPORTED_MODULE_4__
        ),
        core_js_modules_es_typed_array_int32_array_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
          '143c'
        ),
        core_js_modules_es_typed_array_int32_array_js__WEBPACK_IMPORTED_MODULE_5___default = __webpack_require__.n(
          core_js_modules_es_typed_array_int32_array_js__WEBPACK_IMPORTED_MODULE_5__
        ),
        core_js_modules_es_string_replace_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
          '5319'
        ),
        core_js_modules_es_string_replace_js__WEBPACK_IMPORTED_MODULE_6___default = __webpack_require__.n(
          core_js_modules_es_string_replace_js__WEBPACK_IMPORTED_MODULE_6__
        ),
        core_js_modules_es_typed_array_int16_array_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
          '8b09'
        ),
        core_js_modules_es_typed_array_int16_array_js__WEBPACK_IMPORTED_MODULE_7___default = __webpack_require__.n(
          core_js_modules_es_typed_array_int16_array_js__WEBPACK_IMPORTED_MODULE_7__
        ),
        core_js_modules_es_typed_array_float32_array_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(
          'cfc3'
        ),
        core_js_modules_es_typed_array_float32_array_js__WEBPACK_IMPORTED_MODULE_8___default = __webpack_require__.n(
          core_js_modules_es_typed_array_float32_array_js__WEBPACK_IMPORTED_MODULE_8__
        ),
        core_js_modules_es_typed_array_float64_array_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(
          '4a9b'
        ),
        core_js_modules_es_typed_array_float64_array_js__WEBPACK_IMPORTED_MODULE_9___default = __webpack_require__.n(
          core_js_modules_es_typed_array_float64_array_js__WEBPACK_IMPORTED_MODULE_9__
        ),
        require,
        require,
        brfv5Module = (function () {
          var _scriptDir =
            'undefined' !== typeof document && document.currentScript
              ? document.currentScript.src
              : void 0
          return (
            (_scriptDir = _scriptDir || __filename),
            function (brfv5Module) {
              brfv5Module = brfv5Module || {}
              var Module =
                  'undefined' !== typeof brfv5Module ? brfv5Module : {},
                readyPromiseResolve,
                readyPromiseReject
              ;(Module['ready'] = new Promise(function (e, t) {
                ;(readyPromiseResolve = e), (readyPromiseReject = t)
              })),
                (function (e) {
                  if (
                    ((e['isWASM'] = !0),
                    (e['isASMJS'] = !1),
                    (e['WebAssemblySupport'] = (function () {
                      try {
                        if (
                          'object' === typeof WebAssembly &&
                          'function' === typeof WebAssembly.instantiate
                        ) {
                          var e = new Uint8Array([
                              0,
                              97,
                              115,
                              109,
                              1,
                              0,
                              0,
                              0,
                              1,
                              6,
                              1,
                              96,
                              1,
                              127,
                              1,
                              127,
                              3,
                              2,
                              1,
                              0,
                              5,
                              3,
                              1,
                              0,
                              1,
                              7,
                              8,
                              1,
                              4,
                              116,
                              101,
                              115,
                              116,
                              0,
                              0,
                              10,
                              16,
                              1,
                              14,
                              0,
                              32,
                              0,
                              65,
                              1,
                              54,
                              2,
                              0,
                              32,
                              0,
                              40,
                              2,
                              0,
                              11
                            ]),
                            t = new WebAssembly.Module(e)
                          if (t instanceof WebAssembly.Module) {
                            var n = new WebAssembly.Instance(t, {})
                            return (
                              n instanceof WebAssembly.Instance &&
                              0 !== n.exports.test(4)
                            )
                          }
                        }
                      } catch (i) {}
                      return !1
                    })()),
                    !e['WebAssemblySupport'])
                  )
                    throw (e['binaryError'] &&
                      e['binaryError']('WebAssembly is not supported'),
                    'WebAssembly is not supported')
                })(Module),
                (function (e) {
                  ;(e['defaultValue'] = function (e, t) {
                    return 'undefined' !== typeof e ? e : t
                  }),
                    'undefined' !== typeof console
                      ? ((e['trace'] = console.log.bind(console)),
                        (e['error'] = console.error.bind(console)),
                        (e['warn'] = console.warn.bind(console)))
                      : ((e['trace'] = function () {}),
                        (e['error'] = e['trace']),
                        (e['warn'] = e['trace'])),
                    (e['BRFv5Landmark'] = function (t, n) {
                      ;(this['x'] = e['defaultValue'](t, 0)),
                        (this['y'] = e['defaultValue'](n, 0))
                    }),
                    (e['BRFv5Landmark']['prototype']['setTo'] = function (
                      t,
                      n
                    ) {
                      ;(this['x'] = e['defaultValue'](t, 0)),
                        (this['y'] = e['defaultValue'](n, 0))
                    }),
                    (e['BRFv5Rectangle'] = function (t, n, i, r) {
                      ;(this['x'] = e['defaultValue'](t, 0)),
                        (this['y'] = e['defaultValue'](n, 0)),
                        (this['width'] = e['defaultValue'](i, 0)),
                        (this['height'] = e['defaultValue'](r, 0))
                    }),
                    (e['BRFv5Rectangle']['prototype']['setTo'] = function (
                      t,
                      n,
                      i,
                      r
                    ) {
                      ;(this['x'] = e['defaultValue'](t, 0)),
                        (this['y'] = e['defaultValue'](n, 0)),
                        (this['width'] = e['defaultValue'](i, 0)),
                        (this['height'] = e['defaultValue'](r, 0))
                    }),
                    (e['BRFv5State'] = {
                      FACE_DETECTION: 'face_detection',
                      FACE_TRACKING: 'face_tracking',
                      RESET: 'reset'
                    }),
                    (e['BRFv5Face'] = function () {
                      ;(this['state'] = e['BRFv5State']['RESET']),
                        (this['confidence'] = 0),
                        (this['landmarks'] = []),
                        (this['vertices'] = []),
                        (this['bounds'] = new e['BRFv5Rectangle'](0, 0, 0, 0)),
                        (this['scale'] = 1),
                        (this['translationX'] = 0),
                        (this['translationY'] = 0),
                        (this['rotationX'] = 0),
                        (this['rotationY'] = 0),
                        (this['rotationZ'] = 0)
                    }),
                    (e['BRFv5Config'] = function () {
                      ;(this['imageConfig'] = {
                        inputWidth: 640,
                        inputHeight: 480
                      }),
                        (this['faceDetectionConfig'] = {
                          regionOfInterest: new e['BRFv5Rectangle'](
                            10,
                            10,
                            620,
                            460
                          ),
                          minFaceSize: 144,
                          maxFaceSize: 480,
                          faceSizeIncrease: 24,
                          stepSize: 0,
                          minNumNeighbors: 12,
                          rectMergeFactor: 0.2,
                          rectSkipFactor: 0.5,
                          filterNoise: !0
                        }),
                        (this['faceTrackingConfig'] = {
                          regionOfInterest: new e['BRFv5Rectangle'](
                            10,
                            10,
                            620,
                            460
                          ),
                          numFacesToTrack: 1,
                          numTrackingPasses: 3,
                          minFaceScaleStart: 35,
                          maxFaceScaleStart: 999,
                          maxRotationXStart: 15,
                          maxRotationYStart: 25,
                          maxRotationZStart: 20,
                          confidenceThresholdStart: 0.8,
                          minFaceScaleReset: 20,
                          maxFaceScaleReset: 420,
                          maxRotationXReset: 35,
                          maxRotationYReset: 45,
                          maxRotationZReset: 999,
                          confidenceThresholdReset: 0,
                          enableStabilizer: !0,
                          enableFreeRotation: !0
                        }),
                        (this['enableFaceTracking'] = !0)
                    }),
                    (e['BRFv5Config']['createInstance'] = function () {
                      return new e['BRFv5Config']()
                    })
                })(Module),
                (function (e) {
                  e['process'] = (function () {
                    return (function () {
                      function e (t, n, i) {
                        function r (s, o) {
                          if (!n[s]) {
                            if (!t[s]) {
                              var l = 'function' == typeof require && require
                              if (!o && l) return require(s, !0)
                              if (a) return a(s, !0)
                              var c = new Error(
                                "Cannot find module '" + s + "'"
                              )
                              throw ((c.code = 'MODULE_NOT_FOUND'), c)
                            }
                            var h = (n[s] = { exports: {} })
                            t[s][0].call(
                              h.exports,
                              function (e) {
                                var n = t[s][1][e]
                                return r(n || e)
                              },
                              h,
                              h.exports,
                              e,
                              t,
                              n,
                              i
                            )
                          }
                          return n[s].exports
                        }
                        for (
                          var a = 'function' == typeof require && require,
                            s = 0;
                          s < i.length;
                          s++
                        )
                          r(i[s])
                        return r
                      }
                      return e
                    })()(
                      {
                        1: [
                          function (e, t, n) {
                            var i = 4096,
                              r = 2 * i + 32,
                              a = 2 * i - 1,
                              s = new Uint32Array([
                                0,
                                1,
                                3,
                                7,
                                15,
                                31,
                                63,
                                127,
                                255,
                                511,
                                1023,
                                2047,
                                4095,
                                8191,
                                16383,
                                32767,
                                65535,
                                131071,
                                262143,
                                524287,
                                1048575,
                                2097151,
                                4194303,
                                8388607,
                                16777215
                              ])
                            function o (e) {
                              ;(this.buf_ = new Uint8Array(r)),
                                (this.input_ = e),
                                this.reset()
                            }
                            ;(o.READ_SIZE = i),
                              (o.IBUF_MASK = a),
                              (o.prototype.reset = function () {
                                ;(this.buf_ptr_ = 0),
                                  (this.val_ = 0),
                                  (this.pos_ = 0),
                                  (this.bit_pos_ = 0),
                                  (this.bit_end_pos_ = 0),
                                  (this.eos_ = 0),
                                  this.readMoreInput()
                                for (var e = 0; e < 4; e++)
                                  (this.val_ |=
                                    this.buf_[this.pos_] << (8 * e)),
                                    ++this.pos_
                                return this.bit_end_pos_ > 0
                              }),
                              (o.prototype.readMoreInput = function () {
                                if (!(this.bit_end_pos_ > 256))
                                  if (this.eos_) {
                                    if (this.bit_pos_ > this.bit_end_pos_)
                                      throw new Error(
                                        'Unexpected end of input ' +
                                          this.bit_pos_ +
                                          ' ' +
                                          this.bit_end_pos_
                                      )
                                  } else {
                                    var e = this.buf_ptr_,
                                      t = this.input_.read(this.buf_, e, i)
                                    if (t < 0)
                                      throw new Error('Unexpected end of input')
                                    if (t < i) {
                                      this.eos_ = 1
                                      for (var n = 0; n < 32; n++)
                                        this.buf_[e + t + n] = 0
                                    }
                                    if (0 === e) {
                                      for (n = 0; n < 32; n++)
                                        this.buf_[(i << 1) + n] = this.buf_[n]
                                      this.buf_ptr_ = i
                                    } else this.buf_ptr_ = 0
                                    this.bit_end_pos_ += t << 3
                                  }
                              }),
                              (o.prototype.fillBitWindow = function () {
                                while (this.bit_pos_ >= 8)
                                  (this.val_ >>>= 8),
                                    (this.val_ |=
                                      this.buf_[this.pos_ & a] << 24),
                                    ++this.pos_,
                                    (this.bit_pos_ = (this.bit_pos_ - 8) >>> 0),
                                    (this.bit_end_pos_ =
                                      (this.bit_end_pos_ - 8) >>> 0)
                              }),
                              (o.prototype.readBits = function (e) {
                                32 - this.bit_pos_ < e && this.fillBitWindow()
                                var t = (this.val_ >>> this.bit_pos_) & s[e]
                                return (this.bit_pos_ += e), t
                              }),
                              (t.exports = o)
                          },
                          {}
                        ],
                        2: [
                          function (e, t, n) {
                            ;(n.lookup = new Uint8Array([
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              4,
                              4,
                              0,
                              0,
                              4,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              8,
                              12,
                              16,
                              12,
                              12,
                              20,
                              12,
                              16,
                              24,
                              28,
                              12,
                              12,
                              32,
                              12,
                              36,
                              12,
                              44,
                              44,
                              44,
                              44,
                              44,
                              44,
                              44,
                              44,
                              44,
                              44,
                              32,
                              32,
                              24,
                              40,
                              28,
                              12,
                              12,
                              48,
                              52,
                              52,
                              52,
                              48,
                              52,
                              52,
                              52,
                              48,
                              52,
                              52,
                              52,
                              52,
                              52,
                              48,
                              52,
                              52,
                              52,
                              52,
                              52,
                              48,
                              52,
                              52,
                              52,
                              52,
                              52,
                              24,
                              12,
                              28,
                              12,
                              12,
                              12,
                              56,
                              60,
                              60,
                              60,
                              56,
                              60,
                              60,
                              60,
                              56,
                              60,
                              60,
                              60,
                              60,
                              60,
                              56,
                              60,
                              60,
                              60,
                              60,
                              60,
                              56,
                              60,
                              60,
                              60,
                              60,
                              60,
                              24,
                              12,
                              28,
                              12,
                              0,
                              0,
                              1,
                              0,
                              1,
                              0,
                              1,
                              0,
                              1,
                              0,
                              1,
                              0,
                              1,
                              0,
                              1,
                              0,
                              1,
                              0,
                              1,
                              0,
                              1,
                              0,
                              1,
                              0,
                              1,
                              0,
                              1,
                              0,
                              1,
                              0,
                              1,
                              0,
                              1,
                              0,
                              1,
                              0,
                              1,
                              0,
                              1,
                              0,
                              1,
                              0,
                              1,
                              0,
                              1,
                              0,
                              1,
                              0,
                              1,
                              0,
                              1,
                              0,
                              1,
                              0,
                              1,
                              0,
                              1,
                              0,
                              1,
                              0,
                              1,
                              0,
                              1,
                              0,
                              1,
                              2,
                              3,
                              2,
                              3,
                              2,
                              3,
                              2,
                              3,
                              2,
                              3,
                              2,
                              3,
                              2,
                              3,
                              2,
                              3,
                              2,
                              3,
                              2,
                              3,
                              2,
                              3,
                              2,
                              3,
                              2,
                              3,
                              2,
                              3,
                              2,
                              3,
                              2,
                              3,
                              2,
                              3,
                              2,
                              3,
                              2,
                              3,
                              2,
                              3,
                              2,
                              3,
                              2,
                              3,
                              2,
                              3,
                              2,
                              3,
                              2,
                              3,
                              2,
                              3,
                              2,
                              3,
                              2,
                              3,
                              2,
                              3,
                              2,
                              3,
                              2,
                              3,
                              2,
                              3,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              1,
                              1,
                              1,
                              1,
                              1,
                              1,
                              1,
                              1,
                              1,
                              1,
                              1,
                              1,
                              1,
                              1,
                              1,
                              2,
                              2,
                              2,
                              2,
                              2,
                              2,
                              2,
                              2,
                              2,
                              2,
                              1,
                              1,
                              1,
                              1,
                              1,
                              1,
                              1,
                              2,
                              2,
                              2,
                              2,
                              2,
                              2,
                              2,
                              2,
                              2,
                              2,
                              2,
                              2,
                              2,
                              2,
                              2,
                              2,
                              2,
                              2,
                              2,
                              2,
                              2,
                              2,
                              2,
                              2,
                              2,
                              2,
                              1,
                              1,
                              1,
                              1,
                              1,
                              1,
                              3,
                              3,
                              3,
                              3,
                              3,
                              3,
                              3,
                              3,
                              3,
                              3,
                              3,
                              3,
                              3,
                              3,
                              3,
                              3,
                              3,
                              3,
                              3,
                              3,
                              3,
                              3,
                              3,
                              3,
                              3,
                              3,
                              1,
                              1,
                              1,
                              1,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              2,
                              2,
                              2,
                              2,
                              2,
                              2,
                              2,
                              2,
                              2,
                              2,
                              2,
                              2,
                              2,
                              2,
                              2,
                              2,
                              2,
                              2,
                              2,
                              2,
                              2,
                              2,
                              2,
                              2,
                              2,
                              2,
                              2,
                              2,
                              2,
                              2,
                              2,
                              2,
                              0,
                              1,
                              1,
                              1,
                              1,
                              1,
                              1,
                              1,
                              1,
                              1,
                              1,
                              1,
                              1,
                              1,
                              1,
                              1,
                              2,
                              2,
                              2,
                              2,
                              2,
                              2,
                              2,
                              2,
                              2,
                              2,
                              2,
                              2,
                              2,
                              2,
                              2,
                              2,
                              2,
                              2,
                              2,
                              2,
                              2,
                              2,
                              2,
                              2,
                              2,
                              2,
                              2,
                              2,
                              2,
                              2,
                              2,
                              2,
                              2,
                              2,
                              2,
                              2,
                              2,
                              2,
                              2,
                              2,
                              2,
                              2,
                              2,
                              2,
                              2,
                              2,
                              2,
                              2,
                              3,
                              3,
                              3,
                              3,
                              3,
                              3,
                              3,
                              3,
                              3,
                              3,
                              3,
                              3,
                              3,
                              3,
                              3,
                              3,
                              3,
                              3,
                              3,
                              3,
                              3,
                              3,
                              3,
                              3,
                              3,
                              3,
                              3,
                              3,
                              3,
                              3,
                              3,
                              3,
                              3,
                              3,
                              3,
                              3,
                              3,
                              3,
                              3,
                              3,
                              3,
                              3,
                              3,
                              3,
                              3,
                              3,
                              3,
                              3,
                              3,
                              3,
                              3,
                              3,
                              3,
                              3,
                              3,
                              3,
                              3,
                              3,
                              3,
                              3,
                              3,
                              3,
                              3,
                              3,
                              4,
                              4,
                              4,
                              4,
                              4,
                              4,
                              4,
                              4,
                              4,
                              4,
                              4,
                              4,
                              4,
                              4,
                              4,
                              4,
                              4,
                              4,
                              4,
                              4,
                              4,
                              4,
                              4,
                              4,
                              4,
                              4,
                              4,
                              4,
                              4,
                              4,
                              4,
                              4,
                              4,
                              4,
                              4,
                              4,
                              4,
                              4,
                              4,
                              4,
                              4,
                              4,
                              4,
                              4,
                              4,
                              4,
                              4,
                              4,
                              4,
                              4,
                              4,
                              4,
                              4,
                              4,
                              4,
                              4,
                              4,
                              4,
                              4,
                              4,
                              4,
                              4,
                              4,
                              4,
                              5,
                              5,
                              5,
                              5,
                              5,
                              5,
                              5,
                              5,
                              5,
                              5,
                              5,
                              5,
                              5,
                              5,
                              5,
                              5,
                              5,
                              5,
                              5,
                              5,
                              5,
                              5,
                              5,
                              5,
                              5,
                              5,
                              5,
                              5,
                              5,
                              5,
                              5,
                              5,
                              5,
                              5,
                              5,
                              5,
                              5,
                              5,
                              5,
                              5,
                              5,
                              5,
                              5,
                              5,
                              5,
                              5,
                              5,
                              5,
                              6,
                              6,
                              6,
                              6,
                              6,
                              6,
                              6,
                              6,
                              6,
                              6,
                              6,
                              6,
                              6,
                              6,
                              6,
                              7,
                              0,
                              8,
                              8,
                              8,
                              8,
                              8,
                              8,
                              8,
                              8,
                              8,
                              8,
                              8,
                              8,
                              8,
                              8,
                              8,
                              16,
                              16,
                              16,
                              16,
                              16,
                              16,
                              16,
                              16,
                              16,
                              16,
                              16,
                              16,
                              16,
                              16,
                              16,
                              16,
                              16,
                              16,
                              16,
                              16,
                              16,
                              16,
                              16,
                              16,
                              16,
                              16,
                              16,
                              16,
                              16,
                              16,
                              16,
                              16,
                              16,
                              16,
                              16,
                              16,
                              16,
                              16,
                              16,
                              16,
                              16,
                              16,
                              16,
                              16,
                              16,
                              16,
                              16,
                              16,
                              24,
                              24,
                              24,
                              24,
                              24,
                              24,
                              24,
                              24,
                              24,
                              24,
                              24,
                              24,
                              24,
                              24,
                              24,
                              24,
                              24,
                              24,
                              24,
                              24,
                              24,
                              24,
                              24,
                              24,
                              24,
                              24,
                              24,
                              24,
                              24,
                              24,
                              24,
                              24,
                              24,
                              24,
                              24,
                              24,
                              24,
                              24,
                              24,
                              24,
                              24,
                              24,
                              24,
                              24,
                              24,
                              24,
                              24,
                              24,
                              24,
                              24,
                              24,
                              24,
                              24,
                              24,
                              24,
                              24,
                              24,
                              24,
                              24,
                              24,
                              24,
                              24,
                              24,
                              24,
                              32,
                              32,
                              32,
                              32,
                              32,
                              32,
                              32,
                              32,
                              32,
                              32,
                              32,
                              32,
                              32,
                              32,
                              32,
                              32,
                              32,
                              32,
                              32,
                              32,
                              32,
                              32,
                              32,
                              32,
                              32,
                              32,
                              32,
                              32,
                              32,
                              32,
                              32,
                              32,
                              32,
                              32,
                              32,
                              32,
                              32,
                              32,
                              32,
                              32,
                              32,
                              32,
                              32,
                              32,
                              32,
                              32,
                              32,
                              32,
                              32,
                              32,
                              32,
                              32,
                              32,
                              32,
                              32,
                              32,
                              32,
                              32,
                              32,
                              32,
                              32,
                              32,
                              32,
                              32,
                              40,
                              40,
                              40,
                              40,
                              40,
                              40,
                              40,
                              40,
                              40,
                              40,
                              40,
                              40,
                              40,
                              40,
                              40,
                              40,
                              40,
                              40,
                              40,
                              40,
                              40,
                              40,
                              40,
                              40,
                              40,
                              40,
                              40,
                              40,
                              40,
                              40,
                              40,
                              40,
                              40,
                              40,
                              40,
                              40,
                              40,
                              40,
                              40,
                              40,
                              40,
                              40,
                              40,
                              40,
                              40,
                              40,
                              40,
                              40,
                              48,
                              48,
                              48,
                              48,
                              48,
                              48,
                              48,
                              48,
                              48,
                              48,
                              48,
                              48,
                              48,
                              48,
                              48,
                              56,
                              0,
                              1,
                              2,
                              3,
                              4,
                              5,
                              6,
                              7,
                              8,
                              9,
                              10,
                              11,
                              12,
                              13,
                              14,
                              15,
                              16,
                              17,
                              18,
                              19,
                              20,
                              21,
                              22,
                              23,
                              24,
                              25,
                              26,
                              27,
                              28,
                              29,
                              30,
                              31,
                              32,
                              33,
                              34,
                              35,
                              36,
                              37,
                              38,
                              39,
                              40,
                              41,
                              42,
                              43,
                              44,
                              45,
                              46,
                              47,
                              48,
                              49,
                              50,
                              51,
                              52,
                              53,
                              54,
                              55,
                              56,
                              57,
                              58,
                              59,
                              60,
                              61,
                              62,
                              63,
                              0,
                              1,
                              2,
                              3,
                              4,
                              5,
                              6,
                              7,
                              8,
                              9,
                              10,
                              11,
                              12,
                              13,
                              14,
                              15,
                              16,
                              17,
                              18,
                              19,
                              20,
                              21,
                              22,
                              23,
                              24,
                              25,
                              26,
                              27,
                              28,
                              29,
                              30,
                              31,
                              32,
                              33,
                              34,
                              35,
                              36,
                              37,
                              38,
                              39,
                              40,
                              41,
                              42,
                              43,
                              44,
                              45,
                              46,
                              47,
                              48,
                              49,
                              50,
                              51,
                              52,
                              53,
                              54,
                              55,
                              56,
                              57,
                              58,
                              59,
                              60,
                              61,
                              62,
                              63,
                              0,
                              1,
                              2,
                              3,
                              4,
                              5,
                              6,
                              7,
                              8,
                              9,
                              10,
                              11,
                              12,
                              13,
                              14,
                              15,
                              16,
                              17,
                              18,
                              19,
                              20,
                              21,
                              22,
                              23,
                              24,
                              25,
                              26,
                              27,
                              28,
                              29,
                              30,
                              31,
                              32,
                              33,
                              34,
                              35,
                              36,
                              37,
                              38,
                              39,
                              40,
                              41,
                              42,
                              43,
                              44,
                              45,
                              46,
                              47,
                              48,
                              49,
                              50,
                              51,
                              52,
                              53,
                              54,
                              55,
                              56,
                              57,
                              58,
                              59,
                              60,
                              61,
                              62,
                              63,
                              0,
                              1,
                              2,
                              3,
                              4,
                              5,
                              6,
                              7,
                              8,
                              9,
                              10,
                              11,
                              12,
                              13,
                              14,
                              15,
                              16,
                              17,
                              18,
                              19,
                              20,
                              21,
                              22,
                              23,
                              24,
                              25,
                              26,
                              27,
                              28,
                              29,
                              30,
                              31,
                              32,
                              33,
                              34,
                              35,
                              36,
                              37,
                              38,
                              39,
                              40,
                              41,
                              42,
                              43,
                              44,
                              45,
                              46,
                              47,
                              48,
                              49,
                              50,
                              51,
                              52,
                              53,
                              54,
                              55,
                              56,
                              57,
                              58,
                              59,
                              60,
                              61,
                              62,
                              63,
                              0,
                              0,
                              0,
                              0,
                              1,
                              1,
                              1,
                              1,
                              2,
                              2,
                              2,
                              2,
                              3,
                              3,
                              3,
                              3,
                              4,
                              4,
                              4,
                              4,
                              5,
                              5,
                              5,
                              5,
                              6,
                              6,
                              6,
                              6,
                              7,
                              7,
                              7,
                              7,
                              8,
                              8,
                              8,
                              8,
                              9,
                              9,
                              9,
                              9,
                              10,
                              10,
                              10,
                              10,
                              11,
                              11,
                              11,
                              11,
                              12,
                              12,
                              12,
                              12,
                              13,
                              13,
                              13,
                              13,
                              14,
                              14,
                              14,
                              14,
                              15,
                              15,
                              15,
                              15,
                              16,
                              16,
                              16,
                              16,
                              17,
                              17,
                              17,
                              17,
                              18,
                              18,
                              18,
                              18,
                              19,
                              19,
                              19,
                              19,
                              20,
                              20,
                              20,
                              20,
                              21,
                              21,
                              21,
                              21,
                              22,
                              22,
                              22,
                              22,
                              23,
                              23,
                              23,
                              23,
                              24,
                              24,
                              24,
                              24,
                              25,
                              25,
                              25,
                              25,
                              26,
                              26,
                              26,
                              26,
                              27,
                              27,
                              27,
                              27,
                              28,
                              28,
                              28,
                              28,
                              29,
                              29,
                              29,
                              29,
                              30,
                              30,
                              30,
                              30,
                              31,
                              31,
                              31,
                              31,
                              32,
                              32,
                              32,
                              32,
                              33,
                              33,
                              33,
                              33,
                              34,
                              34,
                              34,
                              34,
                              35,
                              35,
                              35,
                              35,
                              36,
                              36,
                              36,
                              36,
                              37,
                              37,
                              37,
                              37,
                              38,
                              38,
                              38,
                              38,
                              39,
                              39,
                              39,
                              39,
                              40,
                              40,
                              40,
                              40,
                              41,
                              41,
                              41,
                              41,
                              42,
                              42,
                              42,
                              42,
                              43,
                              43,
                              43,
                              43,
                              44,
                              44,
                              44,
                              44,
                              45,
                              45,
                              45,
                              45,
                              46,
                              46,
                              46,
                              46,
                              47,
                              47,
                              47,
                              47,
                              48,
                              48,
                              48,
                              48,
                              49,
                              49,
                              49,
                              49,
                              50,
                              50,
                              50,
                              50,
                              51,
                              51,
                              51,
                              51,
                              52,
                              52,
                              52,
                              52,
                              53,
                              53,
                              53,
                              53,
                              54,
                              54,
                              54,
                              54,
                              55,
                              55,
                              55,
                              55,
                              56,
                              56,
                              56,
                              56,
                              57,
                              57,
                              57,
                              57,
                              58,
                              58,
                              58,
                              58,
                              59,
                              59,
                              59,
                              59,
                              60,
                              60,
                              60,
                              60,
                              61,
                              61,
                              61,
                              61,
                              62,
                              62,
                              62,
                              62,
                              63,
                              63,
                              63,
                              63,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0,
                              0
                            ])),
                              (n.lookupOffsets = new Uint16Array([
                                1024,
                                1536,
                                1280,
                                1536,
                                0,
                                256,
                                768,
                                512
                              ]))
                          },
                          {}
                        ],
                        3: [
                          function (e, t, n) {
                            var i = e('./streams').BrotliInput,
                              r = e('./streams').BrotliOutput,
                              a = e('./bit_reader'),
                              s = e('./dictionary'),
                              o = e('./huffman').HuffmanCode,
                              l = e('./huffman').BrotliBuildHuffmanTable,
                              c = e('./context'),
                              h = e('./prefix'),
                              u = e('./transform'),
                              d = 8,
                              p = 16,
                              f = 256,
                              m = 704,
                              g = 26,
                              v = 6,
                              y = 2,
                              _ = 8,
                              x = 255,
                              w = 1080,
                              b = 18,
                              M = new Uint8Array([
                                1,
                                2,
                                3,
                                4,
                                0,
                                5,
                                17,
                                6,
                                16,
                                7,
                                8,
                                9,
                                10,
                                11,
                                12,
                                13,
                                14,
                                15
                              ]),
                              S = 16,
                              E = new Uint8Array([
                                3,
                                2,
                                1,
                                0,
                                3,
                                3,
                                3,
                                3,
                                3,
                                3,
                                2,
                                2,
                                2,
                                2,
                                2,
                                2
                              ]),
                              T = new Int8Array([
                                0,
                                0,
                                0,
                                0,
                                -1,
                                1,
                                -2,
                                2,
                                -3,
                                3,
                                -1,
                                1,
                                -2,
                                2,
                                -3,
                                3
                              ]),
                              A = new Uint16Array([
                                256,
                                402,
                                436,
                                468,
                                500,
                                534,
                                566,
                                598,
                                630,
                                662,
                                694,
                                726,
                                758,
                                790,
                                822,
                                854,
                                886,
                                920,
                                952,
                                984,
                                1016,
                                1048,
                                1080
                              ])
                            function R (e) {
                              var t
                              return 0 === e.readBits(1)
                                ? 16
                                : ((t = e.readBits(3)),
                                  t > 0
                                    ? 17 + t
                                    : ((t = e.readBits(3)), t > 0 ? 8 + t : 17))
                            }
                            function L (e) {
                              if (e.readBits(1)) {
                                var t = e.readBits(3)
                                return 0 === t ? 1 : e.readBits(t) + (1 << t)
                              }
                              return 0
                            }
                            function C () {
                              ;(this.meta_block_length = 0),
                                (this.input_end = 0),
                                (this.is_uncompressed = 0),
                                (this.is_metadata = !1)
                            }
                            function P (e) {
                              var t,
                                n,
                                i,
                                r = new C()
                              if (
                                ((r.input_end = e.readBits(1)),
                                r.input_end && e.readBits(1))
                              )
                                return r
                              if (((t = e.readBits(2) + 4), 7 === t)) {
                                if (((r.is_metadata = !0), 0 !== e.readBits(1)))
                                  throw new Error('Invalid reserved bit')
                                if (((n = e.readBits(2)), 0 === n)) return r
                                for (i = 0; i < n; i++) {
                                  var a = e.readBits(8)
                                  if (i + 1 === n && n > 1 && 0 === a)
                                    throw new Error('Invalid size byte')
                                  r.meta_block_length |= a << (8 * i)
                                }
                              } else
                                for (i = 0; i < t; ++i) {
                                  var s = e.readBits(4)
                                  if (i + 1 === t && t > 4 && 0 === s)
                                    throw new Error('Invalid size nibble')
                                  r.meta_block_length |= s << (4 * i)
                                }
                              return (
                                ++r.meta_block_length,
                                r.input_end ||
                                  r.is_metadata ||
                                  (r.is_uncompressed = e.readBits(1)),
                                r
                              )
                            }
                            function D (e, t, n) {
                              var i
                              return (
                                n.fillBitWindow(),
                                (t += (n.val_ >>> n.bit_pos_) & x),
                                (i = e[t].bits - _),
                                i > 0 &&
                                  ((n.bit_pos_ += _),
                                  (t += e[t].value),
                                  (t +=
                                    (n.val_ >>> n.bit_pos_) & ((1 << i) - 1))),
                                (n.bit_pos_ += e[t].bits),
                                e[t].value
                              )
                            }
                            function I (e, t, n, i) {
                              for (
                                var r = 0,
                                  a = d,
                                  s = 0,
                                  c = 0,
                                  h = 32768,
                                  u = [],
                                  f = 0;
                                f < 32;
                                f++
                              )
                                u.push(new o(0, 0))
                              l(u, 0, 5, e, b)
                              while (r < t && h > 0) {
                                var m,
                                  g = 0
                                if (
                                  (i.readMoreInput(),
                                  i.fillBitWindow(),
                                  (g += (i.val_ >>> i.bit_pos_) & 31),
                                  (i.bit_pos_ += u[g].bits),
                                  (m = 255 & u[g].value),
                                  m < p)
                                )
                                  (s = 0),
                                    (n[r++] = m),
                                    0 !== m && ((a = m), (h -= 32768 >> m))
                                else {
                                  var v,
                                    y,
                                    _ = m - 14,
                                    x = 0
                                  if (
                                    (m === p && (x = a),
                                    c !== x && ((s = 0), (c = x)),
                                    (v = s),
                                    s > 0 && ((s -= 2), (s <<= _)),
                                    (s += i.readBits(_) + 3),
                                    (y = s - v),
                                    r + y > t)
                                  )
                                    throw new Error(
                                      '[ReadHuffmanCodeLengths] symbol + repeat_delta > num_symbols'
                                    )
                                  for (var w = 0; w < y; w++) n[r + w] = c
                                  ;(r += y), 0 !== c && (h -= y << (15 - c))
                                }
                              }
                              if (0 !== h)
                                throw new Error(
                                  '[ReadHuffmanCodeLengths] space = ' + h
                                )
                              for (; r < t; r++) n[r] = 0
                            }
                            function N (e, t, n, i) {
                              var r,
                                a = 0,
                                s = new Uint8Array(e)
                              if (
                                (i.readMoreInput(),
                                (r = i.readBits(2)),
                                1 === r)
                              ) {
                                var c = e - 1,
                                  h = 0,
                                  u = new Int32Array(4),
                                  d = i.readBits(2) + 1
                                while (c) (c >>= 1), ++h
                                for (p = 0; p < d; ++p)
                                  (u[p] = i.readBits(h) % e), (s[u[p]] = 2)
                                switch (((s[u[0]] = 1), d)) {
                                  case 1:
                                    break
                                  case 3:
                                    if (
                                      u[0] === u[1] ||
                                      u[0] === u[2] ||
                                      u[1] === u[2]
                                    )
                                      throw new Error(
                                        '[ReadHuffmanCode] invalid symbols'
                                      )
                                    break
                                  case 2:
                                    if (u[0] === u[1])
                                      throw new Error(
                                        '[ReadHuffmanCode] invalid symbols'
                                      )
                                    s[u[1]] = 1
                                    break
                                  case 4:
                                    if (
                                      u[0] === u[1] ||
                                      u[0] === u[2] ||
                                      u[0] === u[3] ||
                                      u[1] === u[2] ||
                                      u[1] === u[3] ||
                                      u[2] === u[3]
                                    )
                                      throw new Error(
                                        '[ReadHuffmanCode] invalid symbols'
                                      )
                                    i.readBits(1)
                                      ? ((s[u[2]] = 3), (s[u[3]] = 3))
                                      : (s[u[0]] = 2)
                                }
                              } else {
                                var p,
                                  f = new Uint8Array(b),
                                  m = 32,
                                  g = 0,
                                  v = [
                                    new o(2, 0),
                                    new o(2, 4),
                                    new o(2, 3),
                                    new o(3, 2),
                                    new o(2, 0),
                                    new o(2, 4),
                                    new o(2, 3),
                                    new o(4, 1),
                                    new o(2, 0),
                                    new o(2, 4),
                                    new o(2, 3),
                                    new o(3, 2),
                                    new o(2, 0),
                                    new o(2, 4),
                                    new o(2, 3),
                                    new o(4, 5)
                                  ]
                                for (p = r; p < b && m > 0; ++p) {
                                  var y,
                                    x = M[p],
                                    w = 0
                                  i.fillBitWindow(),
                                    (w += (i.val_ >>> i.bit_pos_) & 15),
                                    (i.bit_pos_ += v[w].bits),
                                    (y = v[w].value),
                                    (f[x] = y),
                                    0 !== y && ((m -= 32 >> y), ++g)
                                }
                                if (1 !== g && 0 !== m)
                                  throw new Error(
                                    '[ReadHuffmanCode] invalid num_codes or space'
                                  )
                                I(f, e, s, i)
                              }
                              if (((a = l(t, n, _, s, e)), 0 === a))
                                throw new Error(
                                  '[ReadHuffmanCode] BuildHuffmanTable failed: '
                                )
                              return a
                            }
                            function O (e, t, n) {
                              var i, r
                              return (
                                (i = D(e, t, n)),
                                (r = h.kBlockLengthPrefixCode[i].nbits),
                                h.kBlockLengthPrefixCode[i].offset +
                                  n.readBits(r)
                              )
                            }
                            function F (e, t, n) {
                              var i
                              return (
                                e < S
                                  ? ((n += E[e]), (n &= 3), (i = t[n] + T[e]))
                                  : (i = e - S + 1),
                                i
                              )
                            }
                            function B (e, t) {
                              for (var n = e[t], i = t; i; --i) e[i] = e[i - 1]
                              e[0] = n
                            }
                            function z (e, t) {
                              var n,
                                i = new Uint8Array(256)
                              for (n = 0; n < 256; ++n) i[n] = n
                              for (n = 0; n < t; ++n) {
                                var r = e[n]
                                ;(e[n] = i[r]), r && B(i, r)
                              }
                            }
                            function U (e, t) {
                              ;(this.alphabet_size = e),
                                (this.num_htrees = t),
                                (this.codes = new Array(
                                  t + t * A[(e + 31) >>> 5]
                                )),
                                (this.htrees = new Uint32Array(t))
                            }
                            function k (e, t) {
                              var n,
                                i,
                                r,
                                a = { num_htrees: null, context_map: null },
                                s = 0
                              t.readMoreInput()
                              var l = (a.num_htrees = L(t) + 1),
                                c = (a.context_map = new Uint8Array(e))
                              if (l <= 1) return a
                              for (
                                n = t.readBits(1),
                                  n && (s = t.readBits(4) + 1),
                                  i = [],
                                  r = 0;
                                r < w;
                                r++
                              )
                                i[r] = new o(0, 0)
                              for (N(l + s, i, 0, t), r = 0; r < e; ) {
                                var h
                                if (
                                  (t.readMoreInput(), (h = D(i, 0, t)), 0 === h)
                                )
                                  (c[r] = 0), ++r
                                else if (h <= s) {
                                  var u = 1 + (1 << h) + t.readBits(h)
                                  while (--u) {
                                    if (r >= e)
                                      throw new Error(
                                        '[DecodeContextMap] i >= context_map_size'
                                      )
                                    ;(c[r] = 0), ++r
                                  }
                                } else (c[r] = h - s), ++r
                              }
                              return t.readBits(1) && z(c, e), a
                            }
                            function H (e, t, n, i, r, a, s) {
                              var o,
                                l = 2 * n,
                                c = n,
                                h = D(t, n * w, s)
                              ;(o =
                                0 === h
                                  ? r[l + (1 & a[c])]
                                  : 1 === h
                                  ? r[l + ((a[c] - 1) & 1)] + 1
                                  : h - 2),
                                o >= e && (o -= e),
                                (i[n] = o),
                                (r[l + (1 & a[c])] = o),
                                ++a[c]
                            }
                            function W (e, t, n, i, r, s) {
                              var o,
                                l = r + 1,
                                c = n & r,
                                h = s.pos_ & a.IBUF_MASK
                              if (
                                t < 8 ||
                                s.bit_pos_ + (t << 3) < s.bit_end_pos_
                              )
                                while (t-- > 0)
                                  s.readMoreInput(),
                                    (i[c++] = s.readBits(8)),
                                    c === l && (e.write(i, l), (c = 0))
                              else {
                                if (s.bit_end_pos_ < 32)
                                  throw new Error(
                                    '[CopyUncompressedBlockToOutput] br.bit_end_pos_ < 32'
                                  )
                                while (s.bit_pos_ < 32)
                                  (i[c] = s.val_ >>> s.bit_pos_),
                                    (s.bit_pos_ += 8),
                                    ++c,
                                    --t
                                if (
                                  ((o = (s.bit_end_pos_ - s.bit_pos_) >> 3),
                                  h + o > a.IBUF_MASK)
                                ) {
                                  for (
                                    var u = a.IBUF_MASK + 1 - h, d = 0;
                                    d < u;
                                    d++
                                  )
                                    i[c + d] = s.buf_[h + d]
                                  ;(o -= u), (c += u), (t -= u), (h = 0)
                                }
                                for (d = 0; d < o; d++) i[c + d] = s.buf_[h + d]
                                if (((c += o), (t -= o), c >= l)) {
                                  e.write(i, l), (c -= l)
                                  for (d = 0; d < c; d++) i[d] = i[l + d]
                                }
                                while (c + t >= l) {
                                  if (((o = l - c), s.input_.read(i, c, o) < o))
                                    throw new Error(
                                      '[CopyUncompressedBlockToOutput] not enough bytes'
                                    )
                                  e.write(i, l), (t -= o), (c = 0)
                                }
                                if (s.input_.read(i, c, t) < t)
                                  throw new Error(
                                    '[CopyUncompressedBlockToOutput] not enough bytes'
                                  )
                                s.reset()
                              }
                            }
                            function V (e) {
                              var t = (e.bit_pos_ + 7) & -8,
                                n = e.readBits(t - e.bit_pos_)
                              return 0 == n
                            }
                            function G (e) {
                              var t = new i(e),
                                n = new a(t)
                              R(n)
                              var r = P(n)
                              return r.meta_block_length
                            }
                            function j (e, t) {
                              var n = new i(e)
                              null == t && (t = G(e))
                              var a = new Uint8Array(t),
                                s = new r(a)
                              return (
                                q(n, s),
                                s.pos < s.buffer.length &&
                                  (s.buffer = s.buffer.subarray(0, s.pos)),
                                s.buffer
                              )
                            }
                            function q (e, t) {
                              var n,
                                i,
                                r,
                                l,
                                d,
                                p,
                                _,
                                x,
                                b,
                                M = 0,
                                E = 0,
                                T = 0,
                                A = 0,
                                C = [16, 15, 11, 4],
                                I = 0,
                                B = 0,
                                z = 0,
                                G = [new U(0, 0), new U(0, 0), new U(0, 0)],
                                j = 128 + a.READ_SIZE
                              ;(b = new a(e)),
                                (T = R(b)),
                                (i = (1 << T) - 16),
                                (r = 1 << T),
                                (l = r - 1),
                                (d = new Uint8Array(
                                  r + j + s.maxDictionaryWordLength
                                )),
                                (p = r),
                                (_ = []),
                                (x = [])
                              for (var q = 0; q < 3 * w; q++)
                                (_[q] = new o(0, 0)), (x[q] = new o(0, 0))
                              while (!E) {
                                var Y,
                                  X,
                                  J,
                                  Z,
                                  K,
                                  Q,
                                  $,
                                  ee,
                                  te,
                                  ne = 0,
                                  ie = [1 << 28, 1 << 28, 1 << 28],
                                  re = [0],
                                  ae = [1, 1, 1],
                                  se = [0, 1, 0, 1, 0, 1],
                                  oe = [0],
                                  le = null,
                                  ce = null,
                                  he = null,
                                  ue = 0,
                                  de = null,
                                  pe = 0,
                                  fe = 0,
                                  me = null,
                                  ge = 0,
                                  ve = 0,
                                  ye = 0
                                for (n = 0; n < 3; ++n)
                                  (G[n].codes = null), (G[n].htrees = null)
                                b.readMoreInput()
                                var _e = P(b)
                                if (
                                  ((ne = _e.meta_block_length),
                                  M + ne > t.buffer.length)
                                ) {
                                  var xe = new Uint8Array(M + ne)
                                  xe.set(t.buffer), (t.buffer = xe)
                                }
                                if (
                                  ((E = _e.input_end),
                                  (Y = _e.is_uncompressed),
                                  _e.is_metadata)
                                )
                                  for (V(b); ne > 0; --ne)
                                    b.readMoreInput(), b.readBits(8)
                                else if (0 !== ne)
                                  if (Y)
                                    (b.bit_pos_ = (b.bit_pos_ + 7) & -8),
                                      W(t, ne, M, d, l, b),
                                      (M += ne)
                                  else {
                                    for (n = 0; n < 3; ++n)
                                      (ae[n] = L(b) + 1),
                                        ae[n] >= 2 &&
                                          (N(ae[n] + 2, _, n * w, b),
                                          N(g, x, n * w, b),
                                          (ie[n] = O(x, n * w, b)),
                                          (oe[n] = 1))
                                    for (
                                      b.readMoreInput(),
                                        X = b.readBits(2),
                                        J = S + (b.readBits(4) << X),
                                        Z = (1 << X) - 1,
                                        K = J + (48 << X),
                                        ce = new Uint8Array(ae[0]),
                                        n = 0;
                                      n < ae[0];
                                      ++n
                                    )
                                      b.readMoreInput(),
                                        (ce[n] = b.readBits(2) << 1)
                                    var we = k(ae[0] << v, b)
                                    ;(Q = we.num_htrees), (le = we.context_map)
                                    var be = k(ae[2] << y, b)
                                    for (
                                      $ = be.num_htrees,
                                        he = be.context_map,
                                        G[0] = new U(f, Q),
                                        G[1] = new U(m, ae[1]),
                                        G[2] = new U(K, $),
                                        n = 0;
                                      n < 3;
                                      ++n
                                    )
                                      G[n].decode(b)
                                    ;(de = 0),
                                      (me = 0),
                                      (ee = ce[re[0]]),
                                      (ve = c.lookupOffsets[ee]),
                                      (ye = c.lookupOffsets[ee + 1]),
                                      (te = G[1].htrees[0])
                                    while (ne > 0) {
                                      var Me,
                                        Se,
                                        Ee,
                                        Te,
                                        Ae,
                                        Re,
                                        Le,
                                        Ce,
                                        Pe,
                                        De,
                                        Ie,
                                        Ne,
                                        Oe
                                      for (
                                        b.readMoreInput(),
                                          0 === ie[1] &&
                                            (H(ae[1], _, 1, re, se, oe, b),
                                            (ie[1] = O(x, w, b)),
                                            (te = G[1].htrees[re[1]])),
                                          --ie[1],
                                          Me = D(G[1].codes, te, b),
                                          Se = Me >> 6,
                                          Se >= 2
                                            ? ((Se -= 2), (Le = -1))
                                            : (Le = 0),
                                          Ee =
                                            h.kInsertRangeLut[Se] +
                                            ((Me >> 3) & 7),
                                          Te = h.kCopyRangeLut[Se] + (7 & Me),
                                          Ae =
                                            h.kInsertLengthPrefixCode[Ee]
                                              .offset +
                                            b.readBits(
                                              h.kInsertLengthPrefixCode[Ee]
                                                .nbits
                                            ),
                                          Re =
                                            h.kCopyLengthPrefixCode[Te].offset +
                                            b.readBits(
                                              h.kCopyLengthPrefixCode[Te].nbits
                                            ),
                                          B = d[(M - 1) & l],
                                          z = d[(M - 2) & l],
                                          Pe = 0;
                                        Pe < Ae;
                                        ++Pe
                                      )
                                        b.readMoreInput(),
                                          0 === ie[0] &&
                                            (H(ae[0], _, 0, re, se, oe, b),
                                            (ie[0] = O(x, 0, b)),
                                            (ue = re[0] << v),
                                            (de = ue),
                                            (ee = ce[re[0]]),
                                            (ve = c.lookupOffsets[ee]),
                                            (ye = c.lookupOffsets[ee + 1])),
                                          (Ie =
                                            c.lookup[ve + B] |
                                            c.lookup[ye + z]),
                                          (pe = le[de + Ie]),
                                          --ie[0],
                                          (z = B),
                                          (B = D(
                                            G[0].codes,
                                            G[0].htrees[pe],
                                            b
                                          )),
                                          (d[M & l] = B),
                                          (M & l) === l && t.write(d, r),
                                          ++M
                                      if (((ne -= Ae), ne <= 0)) break
                                      if (Le < 0)
                                        if (
                                          (b.readMoreInput(),
                                          0 === ie[2] &&
                                            (H(ae[2], _, 2, re, se, oe, b),
                                            (ie[2] = O(x, 2 * w, b)),
                                            (fe = re[2] << y),
                                            (me = fe)),
                                          --ie[2],
                                          (Ie = 255 & (Re > 4 ? 3 : Re - 2)),
                                          (ge = he[me + Ie]),
                                          (Le = D(
                                            G[2].codes,
                                            G[2].htrees[ge],
                                            b
                                          )),
                                          Le >= J)
                                        )
                                          (Le -= J),
                                            (Oe = Le & Z),
                                            (Le >>= X),
                                            (Ne = 1 + (Le >> 1)),
                                            (Fe = ((2 + (1 & Le)) << Ne) - 4),
                                            (Le =
                                              J +
                                              ((Fe + b.readBits(Ne)) << X) +
                                              Oe)
                                      if (((Ce = F(Le, C, I)), Ce < 0))
                                        throw new Error(
                                          '[BrotliDecompress] invalid distance'
                                        )
                                      if (
                                        ((A = M < i && A !== i ? M : i),
                                        (De = M & l),
                                        Ce > A)
                                      ) {
                                        if (
                                          !(
                                            Re >= s.minDictionaryWordLength &&
                                            Re <= s.maxDictionaryWordLength
                                          )
                                        )
                                          throw new Error(
                                            'Invalid backward reference. pos: ' +
                                              M +
                                              ' distance: ' +
                                              Ce +
                                              ' len: ' +
                                              Re +
                                              ' bytes left: ' +
                                              ne
                                          )
                                        var Fe = s.offsetsByLength[Re],
                                          Be = Ce - A - 1,
                                          ze = s.sizeBitsByLength[Re],
                                          Ue = (1 << ze) - 1,
                                          ke = Be & Ue,
                                          He = Be >> ze
                                        if (
                                          ((Fe += ke * Re),
                                          !(He < u.kNumTransforms))
                                        )
                                          throw new Error(
                                            'Invalid backward reference. pos: ' +
                                              M +
                                              ' distance: ' +
                                              Ce +
                                              ' len: ' +
                                              Re +
                                              ' bytes left: ' +
                                              ne
                                          )
                                        var We = u.transformDictionaryWord(
                                          d,
                                          De,
                                          Fe,
                                          Re,
                                          He
                                        )
                                        if (
                                          ((De += We),
                                          (M += We),
                                          (ne -= We),
                                          De >= p)
                                        ) {
                                          t.write(d, r)
                                          for (var Ve = 0; Ve < De - p; Ve++)
                                            d[Ve] = d[p + Ve]
                                        }
                                      } else {
                                        if (
                                          (Le > 0 && ((C[3 & I] = Ce), ++I),
                                          Re > ne)
                                        )
                                          throw new Error(
                                            'Invalid backward reference. pos: ' +
                                              M +
                                              ' distance: ' +
                                              Ce +
                                              ' len: ' +
                                              Re +
                                              ' bytes left: ' +
                                              ne
                                          )
                                        for (Pe = 0; Pe < Re; ++Pe)
                                          (d[M & l] = d[(M - Ce) & l]),
                                            (M & l) === l && t.write(d, r),
                                            ++M,
                                            --ne
                                      }
                                      ;(B = d[(M - 1) & l]),
                                        (z = d[(M - 2) & l])
                                    }
                                    M &= 1073741823
                                  }
                              }
                              t.write(d, M & l)
                            }
                            ;(U.prototype.decode = function (e) {
                              var t,
                                n,
                                i = 0
                              for (t = 0; t < this.num_htrees; ++t)
                                (this.htrees[t] = i),
                                  (n = N(this.alphabet_size, this.codes, i, e)),
                                  (i += n)
                            }),
                              (n.BrotliDecompressedSize = G),
                              (n.BrotliDecompressBuffer = j),
                              (n.BrotliDecompress = q),
                              s.init()
                          },
                          {
                            './bit_reader': 1,
                            './context': 2,
                            './dictionary': 6,
                            './huffman': 7,
                            './prefix': 9,
                            './streams': 10,
                            './transform': 11
                          }
                        ],
                        4: [
                          function (e, t, n) {
                            var i = e('base64-js')
                            n.init = function () {
                              var t = e('./decode').BrotliDecompressBuffer,
                                n = i.toByteArray(e('./dictionary.bin.js'))
                              return t(n)
                            }
                          },
                          {
                            './decode': 3,
                            './dictionary.bin.js': 5,
                            'base64-js': 8
                          }
                        ],
                        5: [
                          function (e, t, n) {
                            t.exports =
                              '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'
                          },
                          {}
                        ],
                        6: [
                          function (e, t, n) {
                            var i = e('./dictionary-browser')
                            ;(n.init = function () {
                              n.dictionary = i.init()
                            }),
                              (n.offsetsByLength = new Uint32Array([
                                0,
                                0,
                                0,
                                0,
                                0,
                                4096,
                                9216,
                                21504,
                                35840,
                                44032,
                                53248,
                                63488,
                                74752,
                                87040,
                                93696,
                                100864,
                                104704,
                                106752,
                                108928,
                                113536,
                                115968,
                                118528,
                                119872,
                                121280,
                                122016
                              ])),
                              (n.sizeBitsByLength = new Uint8Array([
                                0,
                                0,
                                0,
                                0,
                                10,
                                10,
                                11,
                                11,
                                10,
                                10,
                                10,
                                10,
                                10,
                                9,
                                9,
                                8,
                                7,
                                7,
                                8,
                                7,
                                7,
                                6,
                                6,
                                5,
                                5
                              ])),
                              (n.minDictionaryWordLength = 4),
                              (n.maxDictionaryWordLength = 24)
                          },
                          { './dictionary-browser': 4 }
                        ],
                        7: [
                          function (e, t, n) {
                            function i (e, t) {
                              ;(this.bits = e), (this.value = t)
                            }
                            n.HuffmanCode = i
                            var r = 15
                            function a (e, t) {
                              var n = 1 << (t - 1)
                              while (e & n) n >>= 1
                              return (e & (n - 1)) + n
                            }
                            function s (e, t, n, r, a) {
                              do {
                                ;(r -= n), (e[t + r] = new i(a.bits, a.value))
                              } while (r > 0)
                            }
                            function o (e, t, n) {
                              var i = 1 << (t - n)
                              while (t < r) {
                                if (((i -= e[t]), i <= 0)) break
                                ++t, (i <<= 1)
                              }
                              return t - n
                            }
                            n.BrotliBuildHuffmanTable = function (
                              e,
                              t,
                              n,
                              l,
                              c
                            ) {
                              var h,
                                u,
                                d,
                                p,
                                f,
                                m,
                                g,
                                v,
                                y,
                                _,
                                x,
                                w = t,
                                b = new Int32Array(r + 1),
                                M = new Int32Array(r + 1)
                              for (x = new Int32Array(c), d = 0; d < c; d++)
                                b[l[d]]++
                              for (M[1] = 0, u = 1; u < r; u++)
                                M[u + 1] = M[u] + b[u]
                              for (d = 0; d < c; d++)
                                0 !== l[d] && (x[M[l[d]]++] = d)
                              if (
                                ((v = n), (y = 1 << v), (_ = y), 1 === M[r])
                              ) {
                                for (p = 0; p < _; ++p)
                                  e[t + p] = new i(0, 65535 & x[0])
                                return _
                              }
                              for (
                                p = 0, d = 0, u = 1, f = 2;
                                u <= n;
                                ++u, f <<= 1
                              )
                                for (; b[u] > 0; --b[u])
                                  (h = new i(255 & u, 65535 & x[d++])),
                                    s(e, t + p, f, y, h),
                                    (p = a(p, u))
                              for (
                                g = _ - 1, m = -1, u = n + 1, f = 2;
                                u <= r;
                                ++u, f <<= 1
                              )
                                for (; b[u] > 0; --b[u])
                                  (p & g) !== m &&
                                    ((t += y),
                                    (v = o(b, u, n)),
                                    (y = 1 << v),
                                    (_ += y),
                                    (m = p & g),
                                    (e[w + m] = new i(
                                      (v + n) & 255,
                                      (t - w - m) & 65535
                                    ))),
                                    (h = new i((u - n) & 255, 65535 & x[d++])),
                                    s(e, t + (p >> n), f, y, h),
                                    (p = a(p, u))
                              return _
                            }
                          },
                          {}
                        ],
                        8: [
                          function (e, t, n) {
                            ;(n.byteLength = h),
                              (n.toByteArray = d),
                              (n.fromByteArray = m)
                            for (
                              var i = [],
                                r = [],
                                a =
                                  'undefined' !== typeof Uint8Array
                                    ? Uint8Array
                                    : Array,
                                s =
                                  'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/',
                                o = 0,
                                l = s.length;
                              o < l;
                              ++o
                            )
                              (i[o] = s[o]), (r[s.charCodeAt(o)] = o)
                            function c (e) {
                              var t = e.length
                              if (t % 4 > 0)
                                throw new Error(
                                  'Invalid string. Length must be a multiple of 4'
                                )
                              var n = e.indexOf('=')
                              ;-1 === n && (n = t)
                              var i = n === t ? 0 : 4 - (n % 4)
                              return [n, i]
                            }
                            function h (e) {
                              var t = c(e),
                                n = t[0],
                                i = t[1]
                              return (3 * (n + i)) / 4 - i
                            }
                            function u (e, t, n) {
                              return (3 * (t + n)) / 4 - n
                            }
                            function d (e) {
                              for (
                                var t,
                                  n = c(e),
                                  i = n[0],
                                  s = n[1],
                                  o = new a(u(e, i, s)),
                                  l = 0,
                                  h = s > 0 ? i - 4 : i,
                                  d = 0;
                                d < h;
                                d += 4
                              )
                                (t =
                                  (r[e.charCodeAt(d)] << 18) |
                                  (r[e.charCodeAt(d + 1)] << 12) |
                                  (r[e.charCodeAt(d + 2)] << 6) |
                                  r[e.charCodeAt(d + 3)]),
                                  (o[l++] = (t >> 16) & 255),
                                  (o[l++] = (t >> 8) & 255),
                                  (o[l++] = 255 & t)
                              return (
                                2 === s &&
                                  ((t =
                                    (r[e.charCodeAt(d)] << 2) |
                                    (r[e.charCodeAt(d + 1)] >> 4)),
                                  (o[l++] = 255 & t)),
                                1 === s &&
                                  ((t =
                                    (r[e.charCodeAt(d)] << 10) |
                                    (r[e.charCodeAt(d + 1)] << 4) |
                                    (r[e.charCodeAt(d + 2)] >> 2)),
                                  (o[l++] = (t >> 8) & 255),
                                  (o[l++] = 255 & t)),
                                o
                              )
                            }
                            function p (e) {
                              return (
                                i[(e >> 18) & 63] +
                                i[(e >> 12) & 63] +
                                i[(e >> 6) & 63] +
                                i[63 & e]
                              )
                            }
                            function f (e, t, n) {
                              for (var i, r = [], a = t; a < n; a += 3)
                                (i =
                                  ((e[a] << 16) & 16711680) +
                                  ((e[a + 1] << 8) & 65280) +
                                  (255 & e[a + 2])),
                                  r.push(p(i))
                              return r.join('')
                            }
                            function m (e) {
                              for (
                                var t,
                                  n = e.length,
                                  r = n % 3,
                                  a = [],
                                  s = 16383,
                                  o = 0,
                                  l = n - r;
                                o < l;
                                o += s
                              )
                                a.push(f(e, o, o + s > l ? l : o + s))
                              return (
                                1 === r
                                  ? ((t = e[n - 1]),
                                    a.push(i[t >> 2] + i[(t << 4) & 63] + '=='))
                                  : 2 === r &&
                                    ((t = (e[n - 2] << 8) + e[n - 1]),
                                    a.push(
                                      i[t >> 10] +
                                        i[(t >> 4) & 63] +
                                        i[(t << 2) & 63] +
                                        '='
                                    )),
                                a.join('')
                              )
                            }
                            ;(r['-'.charCodeAt(0)] = 62),
                              (r['_'.charCodeAt(0)] = 63)
                          },
                          {}
                        ],
                        9: [
                          function (e, t, n) {
                            function i (e, t) {
                              ;(this.offset = e), (this.nbits = t)
                            }
                            ;(n.kBlockLengthPrefixCode = [
                              new i(1, 2),
                              new i(5, 2),
                              new i(9, 2),
                              new i(13, 2),
                              new i(17, 3),
                              new i(25, 3),
                              new i(33, 3),
                              new i(41, 3),
                              new i(49, 4),
                              new i(65, 4),
                              new i(81, 4),
                              new i(97, 4),
                              new i(113, 5),
                              new i(145, 5),
                              new i(177, 5),
                              new i(209, 5),
                              new i(241, 6),
                              new i(305, 6),
                              new i(369, 7),
                              new i(497, 8),
                              new i(753, 9),
                              new i(1265, 10),
                              new i(2289, 11),
                              new i(4337, 12),
                              new i(8433, 13),
                              new i(16625, 24)
                            ]),
                              (n.kInsertLengthPrefixCode = [
                                new i(0, 0),
                                new i(1, 0),
                                new i(2, 0),
                                new i(3, 0),
                                new i(4, 0),
                                new i(5, 0),
                                new i(6, 1),
                                new i(8, 1),
                                new i(10, 2),
                                new i(14, 2),
                                new i(18, 3),
                                new i(26, 3),
                                new i(34, 4),
                                new i(50, 4),
                                new i(66, 5),
                                new i(98, 5),
                                new i(130, 6),
                                new i(194, 7),
                                new i(322, 8),
                                new i(578, 9),
                                new i(1090, 10),
                                new i(2114, 12),
                                new i(6210, 14),
                                new i(22594, 24)
                              ]),
                              (n.kCopyLengthPrefixCode = [
                                new i(2, 0),
                                new i(3, 0),
                                new i(4, 0),
                                new i(5, 0),
                                new i(6, 0),
                                new i(7, 0),
                                new i(8, 0),
                                new i(9, 0),
                                new i(10, 1),
                                new i(12, 1),
                                new i(14, 2),
                                new i(18, 2),
                                new i(22, 3),
                                new i(30, 3),
                                new i(38, 4),
                                new i(54, 4),
                                new i(70, 5),
                                new i(102, 5),
                                new i(134, 6),
                                new i(198, 7),
                                new i(326, 8),
                                new i(582, 9),
                                new i(1094, 10),
                                new i(2118, 24)
                              ]),
                              (n.kInsertRangeLut = [
                                0,
                                0,
                                8,
                                8,
                                0,
                                16,
                                8,
                                16,
                                16
                              ]),
                              (n.kCopyRangeLut = [0, 8, 0, 8, 16, 0, 16, 8, 16])
                          },
                          {}
                        ],
                        10: [
                          function (e, t, n) {
                            function i (e) {
                              ;(this.buffer = e), (this.pos = 0)
                            }
                            function r (e) {
                              ;(this.buffer = e), (this.pos = 0)
                            }
                            ;(i.prototype.read = function (e, t, n) {
                              this.pos + n > this.buffer.length &&
                                (n = this.buffer.length - this.pos)
                              for (var i = 0; i < n; i++)
                                e[t + i] = this.buffer[this.pos + i]
                              return (this.pos += n), n
                            }),
                              (n.BrotliInput = i),
                              (r.prototype.write = function (e, t) {
                                if (this.pos + t > this.buffer.length)
                                  throw new Error(
                                    'Output buffer is not large enough'
                                  )
                                return (
                                  this.buffer.set(e.subarray(0, t), this.pos),
                                  (this.pos += t),
                                  t
                                )
                              }),
                              (n.BrotliOutput = r)
                          },
                          {}
                        ],
                        11: [
                          function (e, t, n) {
                            var i = e('./dictionary'),
                              r = 0,
                              a = 1,
                              s = 2,
                              o = 3,
                              l = 4,
                              c = 5,
                              h = 6,
                              u = 7,
                              d = 8,
                              p = 9,
                              f = 10,
                              m = 11,
                              g = 12,
                              v = 13,
                              y = 14,
                              _ = 15,
                              x = 16,
                              w = 17,
                              b = 18,
                              M = 20
                            function S (e, t, n) {
                              ;(this.prefix = new Uint8Array(e.length)),
                                (this.transform = t),
                                (this.suffix = new Uint8Array(n.length))
                              for (var i = 0; i < e.length; i++)
                                this.prefix[i] = e.charCodeAt(i)
                              for (i = 0; i < n.length; i++)
                                this.suffix[i] = n.charCodeAt(i)
                            }
                            var E = [
                              new S('', r, ''),
                              new S('', r, ' '),
                              new S(' ', r, ' '),
                              new S('', g, ''),
                              new S('', f, ' '),
                              new S('', r, ' the '),
                              new S(' ', r, ''),
                              new S('s ', r, ' '),
                              new S('', r, ' of '),
                              new S('', f, ''),
                              new S('', r, ' and '),
                              new S('', v, ''),
                              new S('', a, ''),
                              new S(', ', r, ' '),
                              new S('', r, ', '),
                              new S(' ', f, ' '),
                              new S('', r, ' in '),
                              new S('', r, ' to '),
                              new S('e ', r, ' '),
                              new S('', r, '"'),
                              new S('', r, '.'),
                              new S('', r, '">'),
                              new S('', r, '\n'),
                              new S('', o, ''),
                              new S('', r, ']'),
                              new S('', r, ' for '),
                              new S('', y, ''),
                              new S('', s, ''),
                              new S('', r, ' a '),
                              new S('', r, ' that '),
                              new S(' ', f, ''),
                              new S('', r, '. '),
                              new S('.', r, ''),
                              new S(' ', r, ', '),
                              new S('', _, ''),
                              new S('', r, ' with '),
                              new S('', r, "'"),
                              new S('', r, ' from '),
                              new S('', r, ' by '),
                              new S('', x, ''),
                              new S('', w, ''),
                              new S(' the ', r, ''),
                              new S('', l, ''),
                              new S('', r, '. The '),
                              new S('', m, ''),
                              new S('', r, ' on '),
                              new S('', r, ' as '),
                              new S('', r, ' is '),
                              new S('', u, ''),
                              new S('', a, 'ing '),
                              new S('', r, '\n\t'),
                              new S('', r, ':'),
                              new S(' ', r, '. '),
                              new S('', r, 'ed '),
                              new S('', M, ''),
                              new S('', b, ''),
                              new S('', h, ''),
                              new S('', r, '('),
                              new S('', f, ', '),
                              new S('', d, ''),
                              new S('', r, ' at '),
                              new S('', r, 'ly '),
                              new S(' the ', r, ' of '),
                              new S('', c, ''),
                              new S('', p, ''),
                              new S(' ', f, ', '),
                              new S('', f, '"'),
                              new S('.', r, '('),
                              new S('', m, ' '),
                              new S('', f, '">'),
                              new S('', r, '="'),
                              new S(' ', r, '.'),
                              new S('.com/', r, ''),
                              new S(' the ', r, ' of the '),
                              new S('', f, "'"),
                              new S('', r, '. This '),
                              new S('', r, ','),
                              new S('.', r, ' '),
                              new S('', f, '('),
                              new S('', f, '.'),
                              new S('', r, ' not '),
                              new S(' ', r, '="'),
                              new S('', r, 'er '),
                              new S(' ', m, ' '),
                              new S('', r, 'al '),
                              new S(' ', m, ''),
                              new S('', r, "='"),
                              new S('', m, '"'),
                              new S('', f, '. '),
                              new S(' ', r, '('),
                              new S('', r, 'ful '),
                              new S(' ', f, '. '),
                              new S('', r, 'ive '),
                              new S('', r, 'less '),
                              new S('', m, "'"),
                              new S('', r, 'est '),
                              new S(' ', f, '.'),
                              new S('', m, '">'),
                              new S(' ', r, "='"),
                              new S('', f, ','),
                              new S('', r, 'ize '),
                              new S('', m, '.'),
                              new S('� ', r, ''),
                              new S(' ', r, ','),
                              new S('', f, '="'),
                              new S('', m, '="'),
                              new S('', r, 'ous '),
                              new S('', m, ', '),
                              new S('', f, "='"),
                              new S(' ', f, ','),
                              new S(' ', m, '="'),
                              new S(' ', m, ', '),
                              new S('', m, ','),
                              new S('', m, '('),
                              new S('', m, '. '),
                              new S(' ', m, '.'),
                              new S('', m, "='"),
                              new S(' ', m, '. '),
                              new S(' ', f, '="'),
                              new S(' ', m, "='"),
                              new S(' ', f, "='")
                            ]
                            function T (e, t) {
                              return e[t] < 192
                                ? (e[t] >= 97 && e[t] <= 122 && (e[t] ^= 32), 1)
                                : e[t] < 224
                                ? ((e[t + 1] ^= 32), 2)
                                : ((e[t + 2] ^= 5), 3)
                            }
                            ;(n.kTransforms = E),
                              (n.kNumTransforms = E.length),
                              (n.transformDictionaryWord = function (
                                e,
                                t,
                                n,
                                r,
                                a
                              ) {
                                var s,
                                  o = E[a].prefix,
                                  l = E[a].suffix,
                                  c = E[a].transform,
                                  h = c < g ? 0 : c - (g - 1),
                                  u = 0,
                                  d = t
                                h > r && (h = r)
                                var v = 0
                                while (v < o.length) e[t++] = o[v++]
                                for (
                                  n += h, r -= h, c <= p && (r -= c), u = 0;
                                  u < r;
                                  u++
                                )
                                  e[t++] = i.dictionary[n + u]
                                if (((s = t - r), c === f)) T(e, s)
                                else if (c === m)
                                  while (r > 0) {
                                    var y = T(e, s)
                                    ;(s += y), (r -= y)
                                  }
                                var _ = 0
                                while (_ < l.length) e[t++] = l[_++]
                                return t - d
                              })
                          },
                          { './dictionary': 6 }
                        ],
                        12: [
                          function (e, t, n) {
                            t.exports = e('./dec/decode').BrotliDecompressBuffer
                          },
                          { './dec/decode': 3 }
                        ]
                      },
                      {},
                      [12]
                    )(12)
                  })()
                })(Module),
                (function (e) {
                  var t = 'object' === typeof window,
                    n = 'function' === typeof importScripts,
                    i = 'object' === typeof process && !t && !n,
                    r = null
                  if (n) r = self
                  else if (t) r = window
                  else {
                    if (!i)
                      throw "Can't load library file. Environment must be either window, web worker."
                    r = global
                  }
                  if (!e['binaryLocation'])
                    throw "Can't load library file. binaryLocation not set."
                  if (!e['modelLocation'])
                    throw "Can't load library file. modelLocation not set."
                  if (!e['modelChunks'])
                    throw "Can't load library file. modelChunks not set."
                  if (!r) throw "Can't load library file. Environment not set."
                  if (
                    (e['isWASM'] && !e['isASMJS']) ||
                    (!e['isWASM'] && e['isASMJS'])
                  ) {
                    if (e['isWASM'] && !e['WebAssemblySupport'])
                      throw "Can't load library file. WebAssemblySupport is false."
                    if (!e['brfv5Binary']) {
                      var a = e['modelChunks']
                      ;(e['brfv5Binary'] = null),
                        (e['brfv5ModelChunks'] = []),
                        e['brfv5ModelChunks'].fill(0, 0, a),
                        (e['brfv5BinaryLoadState'] = 0)
                      var s = a + 1,
                        o = function (t) {
                          e['error']('BRFv5 could not be loaded.', t),
                            (e['brfv5Binary'] = null),
                            (e['brfv5ModelChunks'] = null),
                            (e['brfv5BinaryLoadState'] = -1)
                        }
                      if (t || n) {
                        for (
                          var l = function (t) {
                              var n = e['modelLocation'] + t + '.brfv5',
                                i = new XMLHttpRequest()
                              i.open('GET', n, !0),
                                (i.responseType = 'arraybuffer'),
                                (i.onerror = o),
                                (i.onprogress = e['binaryProgress'] || null),
                                (i.onload = function (n) {
                                  e['brfv5BinaryLoadState'] >= 0 &&
                                    ((e['brfv5ModelChunks'][t] = new Uint8Array(
                                      n.currentTarget.response
                                    )),
                                    (e['brfv5BinaryLoadState'] =
                                      e['brfv5BinaryLoadState'] + 1))
                                }),
                                i.send(null)
                            },
                            c = 0;
                          c < a;
                          c++
                        )
                          l(c)
                        var h = e['binaryLocation'],
                          u = new XMLHttpRequest()
                        u.open('GET', h, !0),
                          (u.responseType = 'arraybuffer'),
                          (u.onerror = o),
                          (u.onprogress = e['binaryProgress'] || null),
                          (u.onload = function () {
                            e['brfv5BinaryLoadState'] >= 0 &&
                              (h.endsWith('.brfv5')
                                ? (e['brfv5Binary'] = e['process'](
                                    new Uint8Array(u.response)
                                  ))
                                : (e['brfv5Binary'] = u.response),
                              (e['brfv5BinaryLoadState'] =
                                e['brfv5BinaryLoadState'] + 1))
                          }),
                          e['isASMJS']
                            ? (e['memoryInitializerRequest'] = {
                                response: null,
                                status: 200,
                                addEventListener: function (t, n) {
                                  var i = setInterval(function () {
                                    e['brfv5BinaryLoadState'] === s &&
                                      e['brfv5Binary'] &&
                                      e['brfv5ModelChunks'].length === a &&
                                      ((e['memoryInitializerRequest'].response =
                                        e['brfv5Binary']),
                                      clearInterval(i),
                                      n())
                                  }, 50)
                                }
                              })
                            : (e['instantiateWasm'] = function (t, n) {
                                var i = setInterval(function () {
                                  e['brfv5BinaryLoadState'] === s &&
                                    e['brfv5Binary'] &&
                                    e['brfv5ModelChunks'].length === a &&
                                    (clearInterval(i),
                                    WebAssembly.instantiate(e['brfv5Binary'], t)
                                      .then(function (e) {
                                        n(e.instance)
                                      })
                                      .catch(function (t) {
                                        e['error'](
                                          'BRFv5 could not be instantiated.',
                                          t
                                        )
                                      }))
                                }, 50)
                                return {}
                              }),
                          u.send(null)
                      } else {
                        var d = __webpack_require__('3e8f')
                        for (c = 0; c < a; c++)
                          e['brfv5BinaryLoadState'] >= 0 &&
                            ((e['brfv5ModelChunks'][c] = d.readFileSync(
                              e['modelLocation'] + c + '.brfv5'
                            )),
                            (e['brfv5BinaryLoadState'] =
                              e['brfv5BinaryLoadState'] + 1))
                        h = e['binaryLocation']
                        var p = d.readFileSync(h)
                        e['brfv5BinaryLoadState'] >= 0 &&
                          (h.endsWith('.brfv5')
                            ? (e['brfv5Binary'] = e['process'](p))
                            : (e['brfv5Binary'] = p),
                          (e['brfv5BinaryLoadState'] =
                            e['brfv5BinaryLoadState'] + 1)),
                          (e['instantiateWasm'] = function (t, n) {
                            var i = setInterval(function () {
                              e['brfv5BinaryLoadState'] === s &&
                                e['brfv5Binary'] &&
                                e['brfv5ModelChunks'].length === a &&
                                (clearInterval(i),
                                WebAssembly.instantiate(e['brfv5Binary'], t)
                                  .then(function (e) {
                                    n(e.instance)
                                  })
                                  .catch(function (t) {
                                    e['error'](
                                      'BRFv5 could not be instantiated.',
                                      t
                                    )
                                  }))
                            }, 50)
                            return {}
                          })
                      }
                    }
                  }
                })(Module)
              var moduleOverrides = {},
                key
              for (key in Module)
                Module.hasOwnProperty(key) &&
                  (moduleOverrides[key] = Module[key])
              var arguments_ = [],
                thisProgram = './this.program',
                quit_ = function (e, t) {
                  throw t
                },
                ENVIRONMENT_IS_WEB = !1,
                ENVIRONMENT_IS_WORKER = !1,
                ENVIRONMENT_IS_NODE = !1,
                ENVIRONMENT_IS_SHELL = !1
              ;(ENVIRONMENT_IS_WEB = 'object' === typeof window),
                (ENVIRONMENT_IS_WORKER = 'function' === typeof importScripts),
                (ENVIRONMENT_IS_NODE =
                  'object' === typeof process &&
                  'object' === typeof process.versions &&
                  'string' === typeof process.versions.node),
                (ENVIRONMENT_IS_SHELL =
                  !ENVIRONMENT_IS_WEB &&
                  !ENVIRONMENT_IS_NODE &&
                  !ENVIRONMENT_IS_WORKER)
              var scriptDirectory = '',
                read_,
                readAsync,
                readBinary,
                setWindowTitle,
                nodeFS,
                nodePath
              function locateFile (e) {
                return Module['locateFile']
                  ? Module['locateFile'](e, scriptDirectory)
                  : scriptDirectory + e
              }
              ENVIRONMENT_IS_NODE
                ? ((scriptDirectory = ENVIRONMENT_IS_WORKER
                    ? __webpack_require__('df7c').dirname(scriptDirectory) + '/'
                    : __dirname + '/'),
                  (read_ = function (e, t) {
                    return (
                      nodeFS || (nodeFS = __webpack_require__('3e8f')),
                      nodePath || (nodePath = __webpack_require__('df7c')),
                      (e = nodePath['normalize'](e)),
                      nodeFS['readFileSync'](e, t ? null : 'utf8')
                    )
                  }),
                  (readBinary = function (e) {
                    var t = read_(e, !0)
                    return (
                      t.buffer || (t = new Uint8Array(t)), assert(t.buffer), t
                    )
                  }),
                  process['argv'].length > 1 &&
                    (thisProgram = process['argv'][1].replace(/\\/g, '/')),
                  (arguments_ = process['argv'].slice(2)),
                  process['on']('uncaughtException', function (e) {
                    if (!(e instanceof ExitStatus)) throw e
                  }),
                  process['on']('unhandledRejection', abort),
                  (quit_ = function (e) {
                    process['exit'](e)
                  }),
                  (Module['inspect'] = function () {
                    return '[Emscripten Module object]'
                  }))
                : ENVIRONMENT_IS_SHELL
                ? ('undefined' != typeof read &&
                    (read_ = function (e) {
                      return read(e)
                    }),
                  (readBinary = function (e) {
                    var t
                    return 'function' === typeof readbuffer
                      ? new Uint8Array(readbuffer(e))
                      : ((t = read(e, 'binary')),
                        assert('object' === typeof t),
                        t)
                  }),
                  'undefined' != typeof scriptArgs
                    ? (arguments_ = scriptArgs)
                    : 'undefined' != typeof arguments &&
                      (arguments_ = arguments),
                  'function' === typeof quit &&
                    (quit_ = function (e) {
                      quit(e)
                    }),
                  'undefined' !== typeof print &&
                    ('undefined' === typeof console && (console = {}),
                    (console.log = print),
                    (console.warn = console.error =
                      'undefined' !== typeof printErr ? printErr : print)))
                : (ENVIRONMENT_IS_WEB || ENVIRONMENT_IS_WORKER) &&
                  (ENVIRONMENT_IS_WORKER
                    ? (scriptDirectory = self.location.href)
                    : 'undefined' !== typeof document &&
                      document.currentScript &&
                      (scriptDirectory = document.currentScript.src),
                  _scriptDir && (scriptDirectory = _scriptDir),
                  (scriptDirectory =
                    0 !== scriptDirectory.indexOf('blob:')
                      ? scriptDirectory.substr(
                          0,
                          scriptDirectory.lastIndexOf('/') + 1
                        )
                      : ''),
                  (read_ = function (e) {
                    var t = new XMLHttpRequest()
                    return t.open('GET', e, !1), t.send(null), t.responseText
                  }),
                  ENVIRONMENT_IS_WORKER &&
                    (readBinary = function (e) {
                      var t = new XMLHttpRequest()
                      return (
                        t.open('GET', e, !1),
                        (t.responseType = 'arraybuffer'),
                        t.send(null),
                        new Uint8Array(t.response)
                      )
                    }),
                  (readAsync = function (e, t, n) {
                    var i = new XMLHttpRequest()
                    i.open('GET', e, !0),
                      (i.responseType = 'arraybuffer'),
                      (i.onload = function () {
                        200 == i.status || (0 == i.status && i.response)
                          ? t(i.response)
                          : n()
                      }),
                      (i.onerror = n),
                      i.send(null)
                  }),
                  (setWindowTitle = function (e) {
                    document.title = e
                  }))
              var out = Module['print'] || console.log.bind(console),
                err = Module['printErr'] || console.warn.bind(console)
              for (key in moduleOverrides)
                moduleOverrides.hasOwnProperty(key) &&
                  (Module[key] = moduleOverrides[key])
              ;(moduleOverrides = null),
                Module['arguments'] && (arguments_ = Module['arguments']),
                Module['thisProgram'] && (thisProgram = Module['thisProgram']),
                Module['quit'] && (quit_ = Module['quit'])
              var tempRet0 = 0,
                setTempRet0 = function (e) {
                  tempRet0 = e
                },
                wasmBinary,
                noExitRuntime,
                wasmMemory
              Module['wasmBinary'] && (wasmBinary = Module['wasmBinary']),
                Module['noExitRuntime'] &&
                  (noExitRuntime = Module['noExitRuntime']),
                'object' !== typeof WebAssembly &&
                  abort('no native wasm support detected')
              var ABORT = !1,
                EXITSTATUS = 0
              function assert (e, t) {
                e || abort('Assertion failed: ' + t)
              }
              function getCFunc (e) {
                var t = Module['_' + e]
                return (
                  assert(
                    t,
                    'Cannot call unknown function ' +
                      e +
                      ', make sure it is exported'
                  ),
                  t
                )
              }
              function ccall (e, t, n, i, r) {
                var a = {
                  string: function (e) {
                    var t = 0
                    if (null !== e && void 0 !== e && 0 !== e) {
                      var n = 1 + (e.length << 2)
                      ;(t = stackAlloc(n)), stringToUTF8(e, t, n)
                    }
                    return t
                  },
                  array: function (e) {
                    var t = stackAlloc(e.length)
                    return writeArrayToMemory(e, t), t
                  }
                }
                function s (e) {
                  return 'string' === t
                    ? UTF8ToString(e)
                    : 'boolean' === t
                    ? Boolean(e)
                    : e
                }
                var o = getCFunc(e),
                  l = [],
                  c = 0
                if (i)
                  for (var h = 0; h < i.length; h++) {
                    var u = a[n[h]]
                    u
                      ? (0 === c && (c = stackSave()), (l[h] = u(i[h])))
                      : (l[h] = i[h])
                  }
                var d = o.apply(null, l),
                  p = (r && r.async,
                  'object' === typeof Asyncify && Asyncify.currData),
                  f =
                    'object' === typeof Asyncify &&
                    Asyncify.asyncFinalizers.length > 0
                return p && !f
                  ? new Promise(function (e) {
                      Asyncify.asyncFinalizers.push(function (t) {
                        0 !== c && stackRestore(c), e(s(t))
                      })
                    })
                  : ((d = s(d)),
                    0 !== c && stackRestore(c),
                    r && r.async ? Promise.resolve(d) : d)
              }
              function cwrap (e, t, n, i) {
                n = n || []
                var r = n.every(function (e) {
                    return 'number' === e
                  }),
                  a = 'string' !== t
                return a && r && !i
                  ? getCFunc(e)
                  : function () {
                      return ccall(e, t, n, arguments, i)
                    }
              }
              var UTF8Decoder =
                  'undefined' !== typeof TextDecoder
                    ? new TextDecoder('utf8')
                    : void 0,
                buffer,
                HEAP8,
                HEAPU8,
                HEAP16,
                HEAPU16,
                HEAP32,
                HEAPU32,
                HEAPF32,
                HEAPF64
              function UTF8ArrayToString (e, t, n) {
                var i = t + n,
                  r = t
                while (e[r] && !(r >= i)) ++r
                if (r - t > 16 && e.subarray && UTF8Decoder)
                  return UTF8Decoder.decode(e.subarray(t, r))
                var a = ''
                while (t < r) {
                  var s = e[t++]
                  if (128 & s) {
                    var o = 63 & e[t++]
                    if (192 != (224 & s)) {
                      var l = 63 & e[t++]
                      if (
                        ((s =
                          224 == (240 & s)
                            ? ((15 & s) << 12) | (o << 6) | l
                            : ((7 & s) << 18) |
                              (o << 12) |
                              (l << 6) |
                              (63 & e[t++])),
                        s < 65536)
                      )
                        a += String.fromCharCode(s)
                      else {
                        var c = s - 65536
                        a += String.fromCharCode(
                          55296 | (c >> 10),
                          56320 | (1023 & c)
                        )
                      }
                    } else a += String.fromCharCode(((31 & s) << 6) | o)
                  } else a += String.fromCharCode(s)
                }
                return a
              }
              function UTF8ToString (e, t) {
                return e ? UTF8ArrayToString(HEAPU8, e, t) : ''
              }
              function stringToUTF8Array (e, t, n, i) {
                if (!(i > 0)) return 0
                for (var r = n, a = n + i - 1, s = 0; s < e.length; ++s) {
                  var o = e.charCodeAt(s)
                  if (o >= 55296 && o <= 57343) {
                    var l = e.charCodeAt(++s)
                    o = (65536 + ((1023 & o) << 10)) | (1023 & l)
                  }
                  if (o <= 127) {
                    if (n >= a) break
                    t[n++] = o
                  } else if (o <= 2047) {
                    if (n + 1 >= a) break
                    ;(t[n++] = 192 | (o >> 6)), (t[n++] = 128 | (63 & o))
                  } else if (o <= 65535) {
                    if (n + 2 >= a) break
                    ;(t[n++] = 224 | (o >> 12)),
                      (t[n++] = 128 | ((o >> 6) & 63)),
                      (t[n++] = 128 | (63 & o))
                  } else {
                    if (n + 3 >= a) break
                    ;(t[n++] = 240 | (o >> 18)),
                      (t[n++] = 128 | ((o >> 12) & 63)),
                      (t[n++] = 128 | ((o >> 6) & 63)),
                      (t[n++] = 128 | (63 & o))
                  }
                }
                return (t[n] = 0), n - r
              }
              function stringToUTF8 (e, t, n) {
                return stringToUTF8Array(e, HEAPU8, t, n)
              }
              function lengthBytesUTF8 (e) {
                for (var t = 0, n = 0; n < e.length; ++n) {
                  var i = e.charCodeAt(n)
                  i >= 55296 &&
                    i <= 57343 &&
                    (i =
                      (65536 + ((1023 & i) << 10)) |
                      (1023 & e.charCodeAt(++n))),
                    i <= 127 ? ++t : (t += i <= 2047 ? 2 : i <= 65535 ? 3 : 4)
                }
                return t
              }
              function writeArrayToMemory (e, t) {
                HEAP8.set(e, t)
              }
              function writeAsciiToMemory (e, t, n) {
                for (var i = 0; i < e.length; ++i)
                  HEAP8[t++ >> 0] = e.charCodeAt(i)
                n || (HEAP8[t >> 0] = 0)
              }
              function alignUp (e, t) {
                return e % t > 0 && (e += t - (e % t)), e
              }
              function updateGlobalBufferAndViews (e) {
                ;(buffer = e),
                  (Module['HEAP8'] = HEAP8 = new Int8Array(e)),
                  (Module['HEAP16'] = HEAP16 = new Int16Array(e)),
                  (Module['HEAP32'] = HEAP32 = new Int32Array(e)),
                  (Module['HEAPU8'] = HEAPU8 = new Uint8Array(e)),
                  (Module['HEAPU16'] = HEAPU16 = new Uint16Array(e)),
                  (Module['HEAPU32'] = HEAPU32 = new Uint32Array(e)),
                  (Module['HEAPF32'] = HEAPF32 = new Float32Array(e)),
                  (Module['HEAPF64'] = HEAPF64 = new Float64Array(e))
              }
              var INITIAL_MEMORY = Module['INITIAL_MEMORY'] || 113246208,
                wasmTable
              ;(wasmMemory = Module['wasmMemory']
                ? Module['wasmMemory']
                : new WebAssembly.Memory({
                    initial: INITIAL_MEMORY / 65536,
                    maximum: 32768
                  })),
                wasmMemory && (buffer = wasmMemory.buffer),
                (INITIAL_MEMORY = buffer.byteLength),
                updateGlobalBufferAndViews(buffer)
              var __ATPRERUN__ = [],
                __ATINIT__ = [],
                __ATMAIN__ = [],
                __ATPOSTRUN__ = [],
                runtimeInitialized = !1,
                runtimeExited = !1
              function preRun () {
                if (Module['preRun']) {
                  'function' == typeof Module['preRun'] &&
                    (Module['preRun'] = [Module['preRun']])
                  while (Module['preRun'].length)
                    addOnPreRun(Module['preRun'].shift())
                }
                callRuntimeCallbacks(__ATPRERUN__)
              }
              function initRuntime () {
                ;(runtimeInitialized = !0), callRuntimeCallbacks(__ATINIT__)
              }
              function preMain () {
                callRuntimeCallbacks(__ATMAIN__)
              }
              function exitRuntime () {
                runtimeExited = !0
              }
              function postRun () {
                if (Module['postRun']) {
                  'function' == typeof Module['postRun'] &&
                    (Module['postRun'] = [Module['postRun']])
                  while (Module['postRun'].length)
                    addOnPostRun(Module['postRun'].shift())
                }
                callRuntimeCallbacks(__ATPOSTRUN__)
              }
              function addOnPreRun (e) {
                __ATPRERUN__.unshift(e)
              }
              function addOnPostRun (e) {
                __ATPOSTRUN__.unshift(e)
              }
              var runDependencies = 0,
                runDependencyWatcher = null,
                dependenciesFulfilled = null
              function addRunDependency (e) {
                runDependencies++,
                  Module['monitorRunDependencies'] &&
                    Module['monitorRunDependencies'](runDependencies)
              }
              function removeRunDependency (e) {
                if (
                  (runDependencies--,
                  Module['monitorRunDependencies'] &&
                    Module['monitorRunDependencies'](runDependencies),
                  0 == runDependencies &&
                    (null !== runDependencyWatcher &&
                      (clearInterval(runDependencyWatcher),
                      (runDependencyWatcher = null)),
                    dependenciesFulfilled))
                ) {
                  var t = dependenciesFulfilled
                  ;(dependenciesFulfilled = null), t()
                }
              }
              function abort (e) {
                Module['onAbort'] && Module['onAbort'](e),
                  (e += ''),
                  err(e),
                  (ABORT = !0),
                  (EXITSTATUS = 1),
                  (e =
                    'abort(' +
                    e +
                    '). Build with -s ASSERTIONS=1 for more info.')
                var t = new WebAssembly.RuntimeError(e)
                throw (readyPromiseReject(t), t)
              }
              function hasPrefix (e, t) {
                return String.prototype.startsWith
                  ? e.startsWith(t)
                  : 0 === e.indexOf(t)
              }
              ;(Module['preloadedImages'] = {}),
                (Module['preloadedAudios'] = {})
              var dataURIPrefix = 'data:application/octet-stream;base64,'
              function isDataURI (e) {
                return hasPrefix(e, dataURIPrefix)
              }
              var fileURIPrefix = 'file://'
              function isFileURI (e) {
                return hasPrefix(e, fileURIPrefix)
              }
              var wasmBinaryFile = 'brfv5_js_cb270921_v5.2.1_commercial.wasm'
              function getBinary () {
                try {
                  if (wasmBinary) return new Uint8Array(wasmBinary)
                  if (readBinary) return readBinary(wasmBinaryFile)
                  throw 'both async and sync fetching of the wasm failed'
                } catch (err) {
                  abort(err)
                }
              }
              function getBinaryPromise () {
                return wasmBinary ||
                  (!ENVIRONMENT_IS_WEB && !ENVIRONMENT_IS_WORKER) ||
                  'function' !== typeof fetch ||
                  isFileURI(wasmBinaryFile)
                  ? Promise.resolve().then(getBinary)
                  : fetch(wasmBinaryFile, { credentials: 'same-origin' })
                      .then(function (e) {
                        if (!e['ok'])
                          throw "failed to load wasm binary file at '" +
                            wasmBinaryFile +
                            "'"
                        return e['arrayBuffer']()
                      })
                      .catch(function () {
                        return getBinary()
                      })
              }
              function createWasm () {
                var e = { a: asmLibraryArg }
                function t (e, t) {
                  var n = e.exports
                  ;(n = Asyncify.instrumentWasmExports(n)),
                    (Module['asm'] = n),
                    (wasmTable = Module['asm']['s']),
                    removeRunDependency('wasm-instantiate')
                }
                function n (e) {
                  t(e['instance'])
                }
                function i (t) {
                  return getBinaryPromise()
                    .then(function (t) {
                      return WebAssembly.instantiate(t, e)
                    })
                    .then(t, function (e) {
                      err('failed to asynchronously prepare wasm: ' + e),
                        abort(e)
                    })
                }
                function r () {
                  return wasmBinary ||
                    'function' !== typeof WebAssembly.instantiateStreaming ||
                    isDataURI(wasmBinaryFile) ||
                    isFileURI(wasmBinaryFile) ||
                    'function' !== typeof fetch
                    ? i(n)
                    : fetch(wasmBinaryFile, {
                        credentials: 'same-origin'
                      }).then(function (t) {
                        var r = WebAssembly.instantiateStreaming(t, e)
                        return r.then(n, function (e) {
                          return (
                            err('wasm streaming compile failed: ' + e),
                            err('falling back to ArrayBuffer instantiation'),
                            i(n)
                          )
                        })
                      })
                }
                if (
                  (addRunDependency('wasm-instantiate'),
                  Module['instantiateWasm'])
                )
                  try {
                    var a = Module['instantiateWasm'](e, t)
                    return (a = Asyncify.instrumentWasmExports(a)), a
                  } catch (s) {
                    return (
                      err(
                        'Module.instantiateWasm callback failed with error: ' +
                          s
                      ),
                      !1
                    )
                  }
                return r().catch(readyPromiseReject), {}
              }
              isDataURI(wasmBinaryFile) ||
                (wasmBinaryFile = locateFile(wasmBinaryFile))
              var ASM_CONSTS = {
                415837: function () {
                  Module['onSDKReady']()
                },
                416e3: function () {
                  Module['onSDKConfigured']()
                },
                416162: function (e, t, n, i, r, a, s, o, l, c) {
                  return Module['calc'](Module, e, t, n, i, r, a, s, o, l, c)
                },
                424908: function ($0) {
                  eval(Module['UTF8ToString']($0))
                }
              }
              function callRuntimeCallbacks (e) {
                while (e.length > 0) {
                  var t = e.shift()
                  if ('function' != typeof t) {
                    var n = t.func
                    'number' === typeof n
                      ? void 0 === t.arg
                        ? getDynCaller('v', n)()
                        : getDynCaller('vi', n)(t.arg)
                      : n(void 0 === t.arg ? null : t.arg)
                  } else t(Module)
                }
              }
              function dynCallLegacy (e, t, n) {
                return n && n.length
                  ? Module['dynCall_' + e].apply(null, [t].concat(n))
                  : Module['dynCall_' + e].call(null, t)
              }
              function dynCall (e, t, n) {
                return dynCallLegacy(e, t, n)
              }
              function getDynCaller (e, t) {
                var n = []
                return function () {
                  n.length = arguments.length
                  for (var i = 0; i < arguments.length; i++) n[i] = arguments[i]
                  return dynCall(e, t, n)
                }
              }
              function ___assert_fail (e, t, n, i) {
                abort(
                  'Assertion failed: ' +
                    UTF8ToString(e) +
                    ', at: ' +
                    [
                      t ? UTF8ToString(t) : 'unknown filename',
                      n,
                      i ? UTF8ToString(i) : 'unknown function'
                    ]
                )
              }
              var SYSCALLS = {
                mappings: {},
                buffers: [null, [], []],
                printChar: function (e, t) {
                  var n = SYSCALLS.buffers[e]
                  0 === t || 10 === t
                    ? ((1 === e ? out : err)(UTF8ArrayToString(n, 0)),
                      (n.length = 0))
                    : n.push(t)
                },
                varargs: void 0,
                get: function () {
                  SYSCALLS.varargs += 4
                  var e = HEAP32[(SYSCALLS.varargs - 4) >> 2]
                  return e
                },
                getStr: function (e) {
                  var t = UTF8ToString(e)
                  return t
                },
                get64: function (e, t) {
                  return e
                }
              }
              function ___sys_ioctl (e, t, n) {
                return (SYSCALLS.varargs = n), 0
              }
              function ___sys_open (e, t, n) {
                SYSCALLS.varargs = n
              }
              function _abort () {
                abort()
              }
              function _emscripten_asm_const_int (e, t, n) {
                var i = readAsmConstArgs(t, n)
                return ASM_CONSTS[e].apply(null, i)
              }
              function _emscripten_memcpy_big (e, t, n) {
                HEAPU8.copyWithin(e, t, t + n)
              }
              function _emscripten_get_heap_size () {
                return HEAPU8.length
              }
              function emscripten_realloc_buffer (e) {
                try {
                  return (
                    wasmMemory.grow((e - buffer.byteLength + 65535) >>> 16),
                    updateGlobalBufferAndViews(wasmMemory.buffer),
                    1
                  )
                } catch (t) {}
              }
              function _emscripten_resize_heap (e) {
                e >>>= 0
                var t = _emscripten_get_heap_size(),
                  n = 2147483648
                if (e > n) return !1
                for (var i = 16777216, r = 1; r <= 4; r *= 2) {
                  var a = t + 33554432 / r,
                    s = Math.min(n, alignUp(Math.max(i, e, a), 65536)),
                    o = emscripten_realloc_buffer(s)
                  if (o) return !0
                }
                return !1
              }
              var ENV = {}
              function getExecutableName () {
                return thisProgram || './this.program'
              }
              function getEnvStrings () {
                if (!getEnvStrings.strings) {
                  var e =
                      (
                        ('object' === typeof navigator &&
                          navigator.languages &&
                          navigator.languages[0]) ||
                        'C'
                      ).replace('-', '_') + '.UTF-8',
                    t = {
                      USER: 'web_user',
                      LOGNAME: 'web_user',
                      PATH: '/',
                      PWD: '/',
                      HOME: '/home/web_user',
                      LANG: e,
                      _: getExecutableName()
                    }
                  for (var n in ENV) t[n] = ENV[n]
                  var i = []
                  for (var n in t) i.push(n + '=' + t[n])
                  getEnvStrings.strings = i
                }
                return getEnvStrings.strings
              }
              function _environ_get (e, t) {
                var n = 0
                return (
                  getEnvStrings().forEach(function (i, r) {
                    var a = t + n
                    ;(HEAP32[(e + 4 * r) >> 2] = a),
                      writeAsciiToMemory(i, a),
                      (n += i.length + 1)
                  }),
                  0
                )
              }
              function _environ_sizes_get (e, t) {
                var n = getEnvStrings()
                HEAP32[e >> 2] = n.length
                var i = 0
                return (
                  n.forEach(function (e) {
                    i += e.length + 1
                  }),
                  (HEAP32[t >> 2] = i),
                  0
                )
              }
              function _exit (e) {
                exit(e)
              }
              function _fd_close (e) {
                return 0
              }
              function _fd_read (e, t, n, i) {
                var r = SYSCALLS.getStreamFromFD(e),
                  a = SYSCALLS.doReadv(r, t, n)
                return (HEAP32[i >> 2] = a), 0
              }
              function _fd_seek (e, t, n, i, r) {}
              function _fd_write (e, t, n, i) {
                for (var r = 0, a = 0; a < n; a++) {
                  for (
                    var s = HEAP32[(t + 8 * a) >> 2],
                      o = HEAP32[(t + (8 * a + 4)) >> 2],
                      l = 0;
                    l < o;
                    l++
                  )
                    SYSCALLS.printChar(e, HEAPU8[s + l])
                  r += o
                }
                return (HEAP32[i >> 2] = r), 0
              }
              function _setTempRet0 (e) {
                setTempRet0(0 | e)
              }
              function __isLeapYear (e) {
                return e % 4 === 0 && (e % 100 !== 0 || e % 400 === 0)
              }
              function __arraySum (e, t) {
                for (var n = 0, i = 0; i <= t; n += e[i++]);
                return n
              }
              var __MONTH_DAYS_LEAP = [
                  31,
                  29,
                  31,
                  30,
                  31,
                  30,
                  31,
                  31,
                  30,
                  31,
                  30,
                  31
                ],
                __MONTH_DAYS_REGULAR = [
                  31,
                  28,
                  31,
                  30,
                  31,
                  30,
                  31,
                  31,
                  30,
                  31,
                  30,
                  31
                ]
              function __addDays (e, t) {
                var n = new Date(e.getTime())
                while (t > 0) {
                  var i = __isLeapYear(n.getFullYear()),
                    r = n.getMonth(),
                    a = (i ? __MONTH_DAYS_LEAP : __MONTH_DAYS_REGULAR)[r]
                  if (!(t > a - n.getDate()))
                    return n.setDate(n.getDate() + t), n
                  ;(t -= a - n.getDate() + 1),
                    n.setDate(1),
                    r < 11
                      ? n.setMonth(r + 1)
                      : (n.setMonth(0), n.setFullYear(n.getFullYear() + 1))
                }
                return n
              }
              function _strftime (e, t, n, i) {
                var r = HEAP32[(i + 40) >> 2],
                  a = {
                    tm_sec: HEAP32[i >> 2],
                    tm_min: HEAP32[(i + 4) >> 2],
                    tm_hour: HEAP32[(i + 8) >> 2],
                    tm_mday: HEAP32[(i + 12) >> 2],
                    tm_mon: HEAP32[(i + 16) >> 2],
                    tm_year: HEAP32[(i + 20) >> 2],
                    tm_wday: HEAP32[(i + 24) >> 2],
                    tm_yday: HEAP32[(i + 28) >> 2],
                    tm_isdst: HEAP32[(i + 32) >> 2],
                    tm_gmtoff: HEAP32[(i + 36) >> 2],
                    tm_zone: r ? UTF8ToString(r) : ''
                  },
                  s = UTF8ToString(n),
                  o = {
                    '%c': '%a %b %d %H:%M:%S %Y',
                    '%D': '%m/%d/%y',
                    '%F': '%Y-%m-%d',
                    '%h': '%b',
                    '%r': '%I:%M:%S %p',
                    '%R': '%H:%M',
                    '%T': '%H:%M:%S',
                    '%x': '%m/%d/%y',
                    '%X': '%H:%M:%S',
                    '%Ec': '%c',
                    '%EC': '%C',
                    '%Ex': '%m/%d/%y',
                    '%EX': '%H:%M:%S',
                    '%Ey': '%y',
                    '%EY': '%Y',
                    '%Od': '%d',
                    '%Oe': '%e',
                    '%OH': '%H',
                    '%OI': '%I',
                    '%Om': '%m',
                    '%OM': '%M',
                    '%OS': '%S',
                    '%Ou': '%u',
                    '%OU': '%U',
                    '%OV': '%V',
                    '%Ow': '%w',
                    '%OW': '%W',
                    '%Oy': '%y'
                  }
                for (var l in o) s = s.replace(new RegExp(l, 'g'), o[l])
                var c = [
                    'Sunday',
                    'Monday',
                    'Tuesday',
                    'Wednesday',
                    'Thursday',
                    'Friday',
                    'Saturday'
                  ],
                  h = [
                    'January',
                    'February',
                    'March',
                    'April',
                    'May',
                    'June',
                    'July',
                    'August',
                    'September',
                    'October',
                    'November',
                    'December'
                  ]
                function u (e, t, n) {
                  var i = 'number' === typeof e ? e.toString() : e || ''
                  while (i.length < t) i = n[0] + i
                  return i
                }
                function d (e, t) {
                  return u(e, t, '0')
                }
                function p (e, t) {
                  function n (e) {
                    return e < 0 ? -1 : e > 0 ? 1 : 0
                  }
                  var i
                  return (
                    0 === (i = n(e.getFullYear() - t.getFullYear())) &&
                      0 === (i = n(e.getMonth() - t.getMonth())) &&
                      (i = n(e.getDate() - t.getDate())),
                    i
                  )
                }
                function f (e) {
                  switch (e.getDay()) {
                    case 0:
                      return new Date(e.getFullYear() - 1, 11, 29)
                    case 1:
                      return e
                    case 2:
                      return new Date(e.getFullYear(), 0, 3)
                    case 3:
                      return new Date(e.getFullYear(), 0, 2)
                    case 4:
                      return new Date(e.getFullYear(), 0, 1)
                    case 5:
                      return new Date(e.getFullYear() - 1, 11, 31)
                    case 6:
                      return new Date(e.getFullYear() - 1, 11, 30)
                  }
                }
                function m (e) {
                  var t = __addDays(
                      new Date(e.tm_year + 1900, 0, 1),
                      e.tm_yday
                    ),
                    n = new Date(t.getFullYear(), 0, 4),
                    i = new Date(t.getFullYear() + 1, 0, 4),
                    r = f(n),
                    a = f(i)
                  return p(r, t) <= 0
                    ? p(a, t) <= 0
                      ? t.getFullYear() + 1
                      : t.getFullYear()
                    : t.getFullYear() - 1
                }
                var g = {
                  '%a': function (e) {
                    return c[e.tm_wday].substring(0, 3)
                  },
                  '%A': function (e) {
                    return c[e.tm_wday]
                  },
                  '%b': function (e) {
                    return h[e.tm_mon].substring(0, 3)
                  },
                  '%B': function (e) {
                    return h[e.tm_mon]
                  },
                  '%C': function (e) {
                    var t = e.tm_year + 1900
                    return d((t / 100) | 0, 2)
                  },
                  '%d': function (e) {
                    return d(e.tm_mday, 2)
                  },
                  '%e': function (e) {
                    return u(e.tm_mday, 2, ' ')
                  },
                  '%g': function (e) {
                    return m(e)
                      .toString()
                      .substring(2)
                  },
                  '%G': function (e) {
                    return m(e)
                  },
                  '%H': function (e) {
                    return d(e.tm_hour, 2)
                  },
                  '%I': function (e) {
                    var t = e.tm_hour
                    return 0 == t ? (t = 12) : t > 12 && (t -= 12), d(t, 2)
                  },
                  '%j': function (e) {
                    return d(
                      e.tm_mday +
                        __arraySum(
                          __isLeapYear(e.tm_year + 1900)
                            ? __MONTH_DAYS_LEAP
                            : __MONTH_DAYS_REGULAR,
                          e.tm_mon - 1
                        ),
                      3
                    )
                  },
                  '%m': function (e) {
                    return d(e.tm_mon + 1, 2)
                  },
                  '%M': function (e) {
                    return d(e.tm_min, 2)
                  },
                  '%n': function () {
                    return '\n'
                  },
                  '%p': function (e) {
                    return e.tm_hour >= 0 && e.tm_hour < 12 ? 'AM' : 'PM'
                  },
                  '%S': function (e) {
                    return d(e.tm_sec, 2)
                  },
                  '%t': function () {
                    return '\t'
                  },
                  '%u': function (e) {
                    return e.tm_wday || 7
                  },
                  '%U': function (e) {
                    var t = new Date(e.tm_year + 1900, 0, 1),
                      n = 0 === t.getDay() ? t : __addDays(t, 7 - t.getDay()),
                      i = new Date(e.tm_year + 1900, e.tm_mon, e.tm_mday)
                    if (p(n, i) < 0) {
                      var r =
                          __arraySum(
                            __isLeapYear(i.getFullYear())
                              ? __MONTH_DAYS_LEAP
                              : __MONTH_DAYS_REGULAR,
                            i.getMonth() - 1
                          ) - 31,
                        a = 31 - n.getDate(),
                        s = a + r + i.getDate()
                      return d(Math.ceil(s / 7), 2)
                    }
                    return 0 === p(n, t) ? '01' : '00'
                  },
                  '%V': function (e) {
                    var t,
                      n = new Date(e.tm_year + 1900, 0, 4),
                      i = new Date(e.tm_year + 1901, 0, 4),
                      r = f(n),
                      a = f(i),
                      s = __addDays(new Date(e.tm_year + 1900, 0, 1), e.tm_yday)
                    return p(s, r) < 0
                      ? '53'
                      : p(a, s) <= 0
                      ? '01'
                      : ((t =
                          r.getFullYear() < e.tm_year + 1900
                            ? e.tm_yday + 32 - r.getDate()
                            : e.tm_yday + 1 - r.getDate()),
                        d(Math.ceil(t / 7), 2))
                  },
                  '%w': function (e) {
                    return e.tm_wday
                  },
                  '%W': function (e) {
                    var t = new Date(e.tm_year, 0, 1),
                      n =
                        1 === t.getDay()
                          ? t
                          : __addDays(
                              t,
                              0 === t.getDay() ? 1 : 7 - t.getDay() + 1
                            ),
                      i = new Date(e.tm_year + 1900, e.tm_mon, e.tm_mday)
                    if (p(n, i) < 0) {
                      var r =
                          __arraySum(
                            __isLeapYear(i.getFullYear())
                              ? __MONTH_DAYS_LEAP
                              : __MONTH_DAYS_REGULAR,
                            i.getMonth() - 1
                          ) - 31,
                        a = 31 - n.getDate(),
                        s = a + r + i.getDate()
                      return d(Math.ceil(s / 7), 2)
                    }
                    return 0 === p(n, t) ? '01' : '00'
                  },
                  '%y': function (e) {
                    return (e.tm_year + 1900).toString().substring(2)
                  },
                  '%Y': function (e) {
                    return e.tm_year + 1900
                  },
                  '%z': function (e) {
                    var t = e.tm_gmtoff,
                      n = t >= 0
                    return (
                      (t = Math.abs(t) / 60),
                      (t = (t / 60) * 100 + (t % 60)),
                      (n ? '+' : '-') + String('0000' + t).slice(-4)
                    )
                  },
                  '%Z': function (e) {
                    return e.tm_zone
                  },
                  '%%': function () {
                    return '%'
                  }
                }
                for (var l in g)
                  s.indexOf(l) >= 0 &&
                    (s = s.replace(new RegExp(l, 'g'), g[l](a)))
                var v = intArrayFromString(s, !1)
                return v.length > t
                  ? 0
                  : (writeArrayToMemory(v, e), v.length - 1)
              }
              function _strftime_l (e, t, n, i) {
                return _strftime(e, t, n, i)
              }
              function _time (e) {
                var t = (Date.now() / 1e3) | 0
                return e && (HEAP32[e >> 2] = t), t
              }
              var readAsmConstArgsArray = []
              function readAsmConstArgs (e, t) {
                var n
                ;(readAsmConstArgsArray.length = 0), (t >>= 2)
                while ((n = HEAPU8[e++])) {
                  var i = n < 105
                  i && 1 & t && t++,
                    readAsmConstArgsArray.push(
                      i ? HEAPF64[t++ >> 1] : HEAP32[t]
                    ),
                    ++t
                }
                return readAsmConstArgsArray
              }
              function runAndAbortIfError (e) {
                try {
                  return e()
                } catch (t) {
                  abort(t)
                }
              }
              var Asyncify = {
                State: { Normal: 0, Unwinding: 1, Rewinding: 2 },
                state: 0,
                StackSize: 4096,
                currData: null,
                handleSleepReturnValue: 0,
                exportCallStack: [],
                callStackNameToId: {},
                callStackIdToName: {},
                callStackId: 0,
                afterUnwind: null,
                asyncFinalizers: [],
                sleepCallbacks: [],
                getCallStackId: function (e) {
                  var t = Asyncify.callStackNameToId[e]
                  return (
                    void 0 === t &&
                      ((t = Asyncify.callStackId++),
                      (Asyncify.callStackNameToId[e] = t),
                      (Asyncify.callStackIdToName[t] = e)),
                    t
                  )
                },
                instrumentWasmExports: function (e) {
                  var t = {}
                  for (var n in e)
                    (function (n) {
                      var i = e[n]
                      t[n] =
                        'function' === typeof i
                          ? function () {
                              Asyncify.exportCallStack.push(n)
                              try {
                                return i.apply(null, arguments)
                              } finally {
                                if (ABORT) return
                                var e = Asyncify.exportCallStack.pop()
                                assert(e === n), Asyncify.maybeStopUnwind()
                              }
                            }
                          : i
                    })(n)
                  return t
                },
                maybeStopUnwind: function () {
                  Asyncify.currData &&
                    Asyncify.state === Asyncify.State.Unwinding &&
                    0 === Asyncify.exportCallStack.length &&
                    ((Asyncify.state = Asyncify.State.Normal),
                    runAndAbortIfError(Module['_asyncify_stop_unwind']),
                    'undefined' !== typeof Fibers && Fibers.trampoline(),
                    Asyncify.afterUnwind &&
                      (Asyncify.afterUnwind(), (Asyncify.afterUnwind = null)))
                },
                allocateData: function () {
                  var e = _malloc(12 + Asyncify.StackSize)
                  return (
                    Asyncify.setDataHeader(e, e + 12, Asyncify.StackSize),
                    Asyncify.setDataRewindFunc(e),
                    e
                  )
                },
                setDataHeader: function (e, t, n) {
                  ;(HEAP32[e >> 2] = t), (HEAP32[(e + 4) >> 2] = t + n)
                },
                setDataRewindFunc: function (e) {
                  var t = Asyncify.exportCallStack[0],
                    n = Asyncify.getCallStackId(t)
                  HEAP32[(e + 8) >> 2] = n
                },
                getDataRewindFunc: function (e) {
                  var t = HEAP32[(e + 8) >> 2],
                    n = Asyncify.callStackIdToName[t],
                    i = Module['asm'][n]
                  return i
                },
                handleSleep: function (e) {
                  if (!ABORT) {
                    if (
                      ((noExitRuntime = !0),
                      Asyncify.state === Asyncify.State.Normal)
                    ) {
                      var t = !1,
                        n = !1
                      e(function (e) {
                        if (
                          !ABORT &&
                          ((Asyncify.handleSleepReturnValue = e || 0),
                          (t = !0),
                          n)
                        ) {
                          ;(Asyncify.state = Asyncify.State.Rewinding),
                            runAndAbortIfError(function () {
                              Module['_asyncify_start_rewind'](
                                Asyncify.currData
                              )
                            }),
                            'undefined' !== typeof Browser &&
                              Browser.mainLoop.func &&
                              Browser.mainLoop.resume()
                          var i = Asyncify.getDataRewindFunc(Asyncify.currData),
                            r = i()
                          if (!Asyncify.currData) {
                            var a = Asyncify.asyncFinalizers
                            ;(Asyncify.asyncFinalizers = []),
                              a.forEach(function (e) {
                                e(r)
                              })
                          }
                        }
                      }),
                        (n = !0),
                        t ||
                          ((Asyncify.state = Asyncify.State.Unwinding),
                          (Asyncify.currData = Asyncify.allocateData()),
                          runAndAbortIfError(function () {
                            Module['_asyncify_start_unwind'](Asyncify.currData)
                          }),
                          'undefined' !== typeof Browser &&
                            Browser.mainLoop.func &&
                            Browser.mainLoop.pause())
                    } else
                      Asyncify.state === Asyncify.State.Rewinding
                        ? ((Asyncify.state = Asyncify.State.Normal),
                          runAndAbortIfError(Module['_asyncify_stop_rewind']),
                          _free(Asyncify.currData),
                          (Asyncify.currData = null),
                          Asyncify.sleepCallbacks.forEach(function (e) {
                            e()
                          }))
                        : abort('invalid state: ' + Asyncify.state)
                    return Asyncify.handleSleepReturnValue
                  }
                },
                handleAsync: function (e) {
                  return Asyncify.handleSleep(function (t) {
                    e().then(t)
                  })
                }
              }
              function intArrayFromString (e, t, n) {
                var i = n > 0 ? n : lengthBytesUTF8(e) + 1,
                  r = new Array(i),
                  a = stringToUTF8Array(e, r, 0, r.length)
                return t && (r.length = a), r
              }
              __ATINIT__.push({
                func: function () {
                  ___wasm_call_ctors()
                }
              })
              var asmLibraryArg = {
                  c: ___assert_fail,
                  k: ___sys_ioctl,
                  l: ___sys_open,
                  d: _abort,
                  e: _emscripten_asm_const_int,
                  o: _emscripten_memcpy_big,
                  g: _emscripten_resize_heap,
                  q: _environ_get,
                  r: _environ_sizes_get,
                  f: _exit,
                  i: _fd_close,
                  j: _fd_read,
                  m: _fd_seek,
                  h: _fd_write,
                  a: wasmMemory,
                  n: _setTempRet0,
                  p: _strftime_l,
                  b: _time
                },
                asm = createWasm(),
                ___wasm_call_ctors = (Module[
                  '___wasm_call_ctors'
                ] = function () {
                  return (___wasm_call_ctors = Module['___wasm_call_ctors'] =
                    Module['asm']['t']).apply(null, arguments)
                }),
                __ZN5brfv512BRFv5Manager9configureEv = (Module[
                  '__ZN5brfv512BRFv5Manager9configureEv'
                ] = function () {
                  return (__ZN5brfv512BRFv5Manager9configureEv = Module[
                    '__ZN5brfv512BRFv5Manager9configureEv'
                  ] = Module['asm']['u']).apply(null, arguments)
                }),
                __ZN5brfv512BRFv5Manager6updateEv = (Module[
                  '__ZN5brfv512BRFv5Manager6updateEv'
                ] = function () {
                  return (__ZN5brfv512BRFv5Manager6updateEv = Module[
                    '__ZN5brfv512BRFv5Manager6updateEv'
                  ] = Module['asm']['v']).apply(null, arguments)
                }),
                __ZN5brfv512BRFv5Manager5resetEv = (Module[
                  '__ZN5brfv512BRFv5Manager5resetEv'
                ] = function () {
                  return (__ZN5brfv512BRFv5Manager5resetEv = Module[
                    '__ZN5brfv512BRFv5Manager5resetEv'
                  ] = Module['asm']['w']).apply(null, arguments)
                }),
                __ZN5brfv512BRFv5Manager16getDetectedRectsEv = (Module[
                  '__ZN5brfv512BRFv5Manager16getDetectedRectsEv'
                ] = function () {
                  return (__ZN5brfv512BRFv5Manager16getDetectedRectsEv = Module[
                    '__ZN5brfv512BRFv5Manager16getDetectedRectsEv'
                  ] = Module['asm']['x']).apply(null, arguments)
                }),
                __ZN5brfv512BRFv5Manager14getMergedRectsEv = (Module[
                  '__ZN5brfv512BRFv5Manager14getMergedRectsEv'
                ] = function () {
                  return (__ZN5brfv512BRFv5Manager14getMergedRectsEv = Module[
                    '__ZN5brfv512BRFv5Manager14getMergedRectsEv'
                  ] = Module['asm']['y']).apply(null, arguments)
                }),
                __ZN5brfv512BRFv5Manager8getFacesEv = (Module[
                  '__ZN5brfv512BRFv5Manager8getFacesEv'
                ] = function () {
                  return (__ZN5brfv512BRFv5Manager8getFacesEv = Module[
                    '__ZN5brfv512BRFv5Manager8getFacesEv'
                  ] = Module['asm']['z']).apply(null, arguments)
                }),
                _main = (Module['_main'] = function () {
                  return (_main = Module['_main'] = Module['asm']['A']).apply(
                    null,
                    arguments
                  )
                }),
                ___brfv5__api__configure = (Module[
                  '___brfv5__api__configure'
                ] = function () {
                  return (___brfv5__api__configure = Module[
                    '___brfv5__api__configure'
                  ] = Module['asm']['B']).apply(null, arguments)
                }),
                ___brfv5__api__setupModel = (Module[
                  '___brfv5__api__setupModel'
                ] = function () {
                  return (___brfv5__api__setupModel = Module[
                    '___brfv5__api__setupModel'
                  ] = Module['asm']['C']).apply(null, arguments)
                }),
                ___brfv5__api__update = (Module[
                  '___brfv5__api__update'
                ] = function () {
                  return (___brfv5__api__update = Module[
                    '___brfv5__api__update'
                  ] = Module['asm']['D']).apply(null, arguments)
                }),
                ___brfv5__api__reset = (Module[
                  '___brfv5__api__reset'
                ] = function () {
                  return (___brfv5__api__reset = Module[
                    '___brfv5__api__reset'
                  ] = Module['asm']['E']).apply(null, arguments)
                }),
                ___brfv5__api__getDetectedRects_size = (Module[
                  '___brfv5__api__getDetectedRects_size'
                ] = function () {
                  return (___brfv5__api__getDetectedRects_size = Module[
                    '___brfv5__api__getDetectedRects_size'
                  ] = Module['asm']['F']).apply(null, arguments)
                }),
                ___brfv5__api__getMergedRects_size = (Module[
                  '___brfv5__api__getMergedRects_size'
                ] = function () {
                  return (___brfv5__api__getMergedRects_size = Module[
                    '___brfv5__api__getMergedRects_size'
                  ] = Module['asm']['G']).apply(null, arguments)
                }),
                ___brfv5__api__getFaces_size = (Module[
                  '___brfv5__api__getFaces_size'
                ] = function () {
                  return (___brfv5__api__getFaces_size = Module[
                    '___brfv5__api__getFaces_size'
                  ] = Module['asm']['H']).apply(null, arguments)
                }),
                ___brfv5__api__getFace_size = (Module[
                  '___brfv5__api__getFace_size'
                ] = function () {
                  return (___brfv5__api__getFace_size = Module[
                    '___brfv5__api__getFace_size'
                  ] = Module['asm']['I']).apply(null, arguments)
                }),
                ___brfv5__api__getDetectedRects = (Module[
                  '___brfv5__api__getDetectedRects'
                ] = function () {
                  return (___brfv5__api__getDetectedRects = Module[
                    '___brfv5__api__getDetectedRects'
                  ] = Module['asm']['J']).apply(null, arguments)
                }),
                ___brfv5__api__getMergedRects = (Module[
                  '___brfv5__api__getMergedRects'
                ] = function () {
                  return (___brfv5__api__getMergedRects = Module[
                    '___brfv5__api__getMergedRects'
                  ] = Module['asm']['K']).apply(null, arguments)
                }),
                ___brfv5__api__getFaces = (Module[
                  '___brfv5__api__getFaces'
                ] = function () {
                  return (___brfv5__api__getFaces = Module[
                    '___brfv5__api__getFaces'
                  ] = Module['asm']['L']).apply(null, arguments)
                }),
                _free = (Module['_free'] = function () {
                  return (_free = Module['_free'] = Module['asm']['M']).apply(
                    null,
                    arguments
                  )
                }),
                _malloc = (Module['_malloc'] = function () {
                  return (_malloc = Module['_malloc'] =
                    Module['asm']['N']).apply(null, arguments)
                }),
                stackSave = (Module['stackSave'] = function () {
                  return (stackSave = Module['stackSave'] =
                    Module['asm']['O']).apply(null, arguments)
                }),
                stackRestore = (Module['stackRestore'] = function () {
                  return (stackRestore = Module['stackRestore'] =
                    Module['asm']['P']).apply(null, arguments)
                }),
                stackAlloc = (Module['stackAlloc'] = function () {
                  return (stackAlloc = Module['stackAlloc'] =
                    Module['asm']['Q']).apply(null, arguments)
                }),
                ___original_main = (Module['___original_main'] = function () {
                  return (___original_main = Module['___original_main'] =
                    Module['asm']['R']).apply(null, arguments)
                }),
                dynCall_vii = (Module['dynCall_vii'] = function () {
                  return (dynCall_vii = Module['dynCall_vii'] =
                    Module['asm']['S']).apply(null, arguments)
                }),
                dynCall_iii = (Module['dynCall_iii'] = function () {
                  return (dynCall_iii = Module['dynCall_iii'] =
                    Module['asm']['T']).apply(null, arguments)
                }),
                dynCall_vi = (Module['dynCall_vi'] = function () {
                  return (dynCall_vi = Module['dynCall_vi'] =
                    Module['asm']['U']).apply(null, arguments)
                }),
                dynCall_jiji = (Module['dynCall_jiji'] = function () {
                  return (dynCall_jiji = Module['dynCall_jiji'] =
                    Module['asm']['V']).apply(null, arguments)
                }),
                dynCall_iiii = (Module['dynCall_iiii'] = function () {
                  return (dynCall_iiii = Module['dynCall_iiii'] =
                    Module['asm']['W']).apply(null, arguments)
                }),
                dynCall_ii = (Module['dynCall_ii'] = function () {
                  return (dynCall_ii = Module['dynCall_ii'] =
                    Module['asm']['X']).apply(null, arguments)
                }),
                dynCall_viii = (Module['dynCall_viii'] = function () {
                  return (dynCall_viii = Module['dynCall_viii'] =
                    Module['asm']['Y']).apply(null, arguments)
                }),
                dynCall_viijii = (Module['dynCall_viijii'] = function () {
                  return (dynCall_viijii = Module['dynCall_viijii'] =
                    Module['asm']['Z']).apply(null, arguments)
                }),
                dynCall_viiii = (Module['dynCall_viiii'] = function () {
                  return (dynCall_viiii = Module['dynCall_viiii'] =
                    Module['asm']['_']).apply(null, arguments)
                }),
                dynCall_iiiiiiiii = (Module['dynCall_iiiiiiiii'] = function () {
                  return (dynCall_iiiiiiiii = Module['dynCall_iiiiiiiii'] =
                    Module['asm']['$']).apply(null, arguments)
                }),
                dynCall_iiiiii = (Module['dynCall_iiiiii'] = function () {
                  return (dynCall_iiiiii = Module['dynCall_iiiiii'] =
                    Module['asm']['aa']).apply(null, arguments)
                }),
                dynCall_viiiiii = (Module['dynCall_viiiiii'] = function () {
                  return (dynCall_viiiiii = Module['dynCall_viiiiii'] =
                    Module['asm']['ba']).apply(null, arguments)
                }),
                dynCall_iiiiiiii = (Module['dynCall_iiiiiiii'] = function () {
                  return (dynCall_iiiiiiii = Module['dynCall_iiiiiiii'] =
                    Module['asm']['ca']).apply(null, arguments)
                }),
                dynCall_iiiiiii = (Module['dynCall_iiiiiii'] = function () {
                  return (dynCall_iiiiiii = Module['dynCall_iiiiiii'] =
                    Module['asm']['da']).apply(null, arguments)
                }),
                dynCall_iiiiiijj = (Module['dynCall_iiiiiijj'] = function () {
                  return (dynCall_iiiiiijj = Module['dynCall_iiiiiijj'] =
                    Module['asm']['ea']).apply(null, arguments)
                }),
                dynCall_iiiiij = (Module['dynCall_iiiiij'] = function () {
                  return (dynCall_iiiiij = Module['dynCall_iiiiij'] =
                    Module['asm']['fa']).apply(null, arguments)
                }),
                dynCall_iiiiid = (Module['dynCall_iiiiid'] = function () {
                  return (dynCall_iiiiid = Module['dynCall_iiiiid'] =
                    Module['asm']['ga']).apply(null, arguments)
                }),
                dynCall_iiiiijj = (Module['dynCall_iiiiijj'] = function () {
                  return (dynCall_iiiiijj = Module['dynCall_iiiiijj'] =
                    Module['asm']['ha']).apply(null, arguments)
                }),
                dynCall_iiiii = (Module['dynCall_iiiii'] = function () {
                  return (dynCall_iiiii = Module['dynCall_iiiii'] =
                    Module['asm']['ia']).apply(null, arguments)
                }),
                dynCall_v = (Module['dynCall_v'] = function () {
                  return (dynCall_v = Module['dynCall_v'] =
                    Module['asm']['ja']).apply(null, arguments)
                }),
                dynCall_viiiii = (Module['dynCall_viiiii'] = function () {
                  return (dynCall_viiiii = Module['dynCall_viiiii'] =
                    Module['asm']['ka']).apply(null, arguments)
                }),
                _asyncify_start_unwind = (Module[
                  '_asyncify_start_unwind'
                ] = function () {
                  return (_asyncify_start_unwind = Module[
                    '_asyncify_start_unwind'
                  ] = Module['asm']['la']).apply(null, arguments)
                }),
                _asyncify_stop_unwind = (Module[
                  '_asyncify_stop_unwind'
                ] = function () {
                  return (_asyncify_stop_unwind = Module[
                    '_asyncify_stop_unwind'
                  ] = Module['asm']['ma']).apply(null, arguments)
                }),
                _asyncify_start_rewind = (Module[
                  '_asyncify_start_rewind'
                ] = function () {
                  return (_asyncify_start_rewind = Module[
                    '_asyncify_start_rewind'
                  ] = Module['asm']['na']).apply(null, arguments)
                }),
                _asyncify_stop_rewind = (Module[
                  '_asyncify_stop_rewind'
                ] = function () {
                  return (_asyncify_stop_rewind = Module[
                    '_asyncify_stop_rewind'
                  ] = Module['asm']['oa']).apply(null, arguments)
                }),
                calledRun
              function ExitStatus (e) {
                ;(this.name = 'ExitStatus'),
                  (this.message = 'Program terminated with exit(' + e + ')'),
                  (this.status = e)
              }
              ;(Module['ccall'] = ccall),
                (Module['cwrap'] = cwrap),
                (Module['UTF8ToString'] = UTF8ToString),
                (Module['stringToUTF8'] = stringToUTF8)
              var calledMain = !1
              function callMain (e) {
                var t = Module['_main'],
                  n = 0,
                  i = 0
                try {
                  var r = t(n, i)
                  noExitRuntime || exit(r, !0)
                } catch (s) {
                  if (s instanceof ExitStatus) return
                  if ('unwind' == s) return void (noExitRuntime = !0)
                  var a = s
                  s && 'object' === typeof s && s.stack && (a = [s, s.stack]),
                    err('exception thrown: ' + a),
                    quit_(1, s)
                } finally {
                  calledMain = !0
                }
              }
              function run (e) {
                function t () {
                  calledRun ||
                    ((calledRun = !0),
                    (Module['calledRun'] = !0),
                    ABORT ||
                      (initRuntime(),
                      preMain(),
                      readyPromiseResolve(Module),
                      Module['onRuntimeInitialized'] &&
                        Module['onRuntimeInitialized'](),
                      shouldRunNow && callMain(e),
                      postRun()))
                }
                ;(e = e || arguments_),
                  runDependencies > 0 ||
                    (preRun(),
                    runDependencies > 0 ||
                      (Module['setStatus']
                        ? (Module['setStatus']('Running...'),
                          setTimeout(function () {
                            setTimeout(function () {
                              Module['setStatus']('')
                            }, 1),
                              t()
                          }, 1))
                        : t()))
              }
              function exit (e, t) {
                ;(t && noExitRuntime && 0 === e) ||
                  (noExitRuntime ||
                    ((EXITSTATUS = e),
                    exitRuntime(),
                    Module['onExit'] && Module['onExit'](e),
                    (ABORT = !0)),
                  quit_(e, new ExitStatus(e)))
              }
              if (
                ((dependenciesFulfilled = function e () {
                  calledRun || run(), calledRun || (dependenciesFulfilled = e)
                }),
                (Module['run'] = run),
                Module['preInit'])
              ) {
                'function' == typeof Module['preInit'] &&
                  (Module['preInit'] = [Module['preInit']])
                while (Module['preInit'].length > 0) Module['preInit'].pop()()
              }
              var shouldRunNow = !0
              return (
                Module['noInitialRun'] && (shouldRunNow = !1),
                (noExitRuntime = !0),
                run(),
                (function (e) {
                  ;(e['sdkReady'] = !1), (e['sdkConfigured'] = !1)
                  var t = null,
                    n = 'number',
                    i = 'number',
                    r = 'number',
                    a = [],
                    s = new Float32Array(1).BYTES_PER_ELEMENT,
                    o = new Uint8Array(1).BYTES_PER_ELEMENT,
                    l = function (e, t) {
                      e.length > t ? e.splice(t, e.length - t) : (e.length = t)
                    },
                    c = function (t, n) {
                      if (
                        (t.length > n && t.splice(n, t.length - n),
                        t.length < n)
                      ) {
                        var i = t.length
                        while (i < n)
                          (t[i] = new e['BRFv5Rectangle'](0, 0, 0, 0)), ++i
                      }
                    },
                    h = function (t, n) {
                      if (
                        (t.length > n && t.splice(n, t.length - n),
                        t.length < n)
                      ) {
                        var i = t.length
                        while (i < n) (t[i] = new e['BRFv5Face']()), ++i
                      }
                    },
                    u = function (t, n) {
                      if (
                        (t.length > n && t.splice(n, t.length - n),
                        t.length < n)
                      ) {
                        var i = t.length
                        while (i < n) (t[i] = new e['BRFv5Landmark'](0, 0)), ++i
                      }
                    },
                    d = function (e, t, n) {
                      return (
                        (e['x'] = t[n]),
                        (e['y'] = t[n + 1]),
                        (e['width'] = t[n + 2]),
                        (e['height'] = t[n + 3]),
                        n + 4
                      )
                    },
                    p = function (t, n, i, r) {
                      var a = n[i++]
                      ;(t['state'] =
                        0 === a
                          ? e['BRFv5State']['RESET']
                          : 1 === a
                          ? e['BRFv5State']['FACE_DETECTION']
                          : e['BRFv5State']['FACE_TRACKING']),
                        (t['confidence'] = n[i++]),
                        (t['scale'] = n[i++]),
                        (t['translationX'] = n[i++]),
                        (t['translationY'] = n[i++]),
                        (t['rotationX'] = n[i++]),
                        (t['rotationY'] = n[i++]),
                        (t['rotationZ'] = n[i++]),
                        (t['bounds']['x'] = n[i++]),
                        (t['bounds']['y'] = n[i++]),
                        (t['bounds']['width'] = n[i++]),
                        (t['bounds']['height'] = n[i++])
                      var s = r - 8 - 4
                      ;(s /= 2), u(t['landmarks'], s), l(t['vertices'], 2 * s)
                      for (var o = 0; o < s; o++) {
                        var c = n[i++],
                          h = n[i++],
                          d = t['landmarks'][o]
                        ;(d['x'] = c),
                          (d['y'] = h),
                          (t['vertices'][2 * o] = c),
                          (t['vertices'][2 * o + 1] = h)
                      }
                      return i
                    },
                    f = function (e, t, n) {
                      c(e, n)
                      var i = 0,
                        r = 0
                      while (i < n) (r = d(e[i], t, r)), (i += 1)
                    },
                    m = function (e, t, n, i) {
                      h(e, n)
                      var r = 0,
                        a = 0
                      while (r < n) (a = p(e[r], t, a, i)), (r += 1)
                    },
                    g = e['cwrap']('__brfv5__api__getDetectedRects_size', n, a),
                    v = e['cwrap']('__brfv5__api__getMergedRects_size', n, a),
                    y = e['cwrap']('__brfv5__api__getFaces_size', n, a),
                    _ = e['cwrap']('__brfv5__api__getFace_size', n, a),
                    x = e['cwrap']('__brfv5__api__getDetectedRects', n, [r]),
                    w = e['cwrap']('__brfv5__api__getMergedRects', n, [r]),
                    b = e['cwrap']('__brfv5__api__getFaces', n, [r]),
                    M = e['cwrap']('__brfv5__api__configure', n, [r]),
                    S = e['cwrap']('__brfv5__api__setupModel', t, [n, i, n]),
                    E = e['cwrap']('__brfv5__api__update', t, [i]),
                    T = e['cwrap']('__brfv5__api__reset', t, a),
                    A = 0,
                    R = 0,
                    L = function (t) {
                      if (t) {
                        var n = 35
                        Q(n)
                        for (var i = e['defaultValue'], r = 0; r < n; r++)
                          X[r] = -1
                        t['imageConfig'] &&
                          ((X[0] = i(t['imageConfig']['inputWidth'], -1)),
                          (X[1] = i(t['imageConfig']['inputHeight'], -1))),
                          t['faceDetectionConfig'] &&
                            (t['faceDetectionConfig']['regionOfInterest'] &&
                              ((X[2] = i(
                                t['faceDetectionConfig']['regionOfInterest'][
                                  'x'
                                ],
                                -1
                              )),
                              (X[3] = i(
                                t['faceDetectionConfig']['regionOfInterest'][
                                  'y'
                                ],
                                -1
                              )),
                              (X[4] = i(
                                t['faceDetectionConfig']['regionOfInterest'][
                                  'width'
                                ],
                                -1
                              )),
                              (X[5] = i(
                                t['faceDetectionConfig']['regionOfInterest'][
                                  'height'
                                ],
                                -1
                              ))),
                            (X[6] = i(
                              t['faceDetectionConfig']['minFaceSize'],
                              -1
                            )),
                            (X[7] = i(
                              t['faceDetectionConfig']['maxFaceSize'],
                              -1
                            )),
                            (X[8] = i(
                              t['faceDetectionConfig']['faceSizeIncrease'],
                              -1
                            )),
                            (X[9] = i(
                              t['faceDetectionConfig']['stepSize'],
                              -1
                            )),
                            (X[10] = i(
                              t['faceDetectionConfig']['minNumNeighbors'],
                              -1
                            )),
                            (X[11] = i(
                              t['faceDetectionConfig']['rectMergeFactor'],
                              -1
                            )),
                            (X[12] = i(
                              t['faceDetectionConfig']['rectSkipFactor'],
                              -1
                            )),
                            (X[13] = i(
                              t['faceDetectionConfig']['filterNoise'],
                              -1
                            ))),
                          t['faceTrackingConfig'] &&
                            (t['faceTrackingConfig']['regionOfInterest'] &&
                              ((X[14] = i(
                                t['faceTrackingConfig']['regionOfInterest'][
                                  'x'
                                ],
                                -1
                              )),
                              (X[15] = i(
                                t['faceTrackingConfig']['regionOfInterest'][
                                  'y'
                                ],
                                -1
                              )),
                              (X[16] = i(
                                t['faceTrackingConfig']['regionOfInterest'][
                                  'width'
                                ],
                                -1
                              )),
                              (X[17] = i(
                                t['faceTrackingConfig']['regionOfInterest'][
                                  'height'
                                ],
                                -1
                              ))),
                            (X[18] = i(
                              t['faceTrackingConfig']['numFacesToTrack'],
                              -1
                            )),
                            (X[19] = i(
                              t['faceTrackingConfig']['numTrackingPasses'],
                              -1
                            )),
                            (X[20] = i(
                              t['faceTrackingConfig']['minFaceScaleStart'],
                              -1
                            )),
                            (X[21] = i(
                              t['faceTrackingConfig']['maxFaceScaleStart'],
                              -1
                            )),
                            (X[22] = i(
                              t['faceTrackingConfig']['maxRotationXStart'],
                              -1
                            )),
                            (X[23] = i(
                              t['faceTrackingConfig']['maxRotationYStart'],
                              -1
                            )),
                            (X[24] = i(
                              t['faceTrackingConfig']['maxRotationZStart'],
                              -1
                            )),
                            (X[25] = i(
                              t['faceTrackingConfig'][
                                'confidenceThresholdStart'
                              ],
                              -1
                            )),
                            (X[26] = i(
                              t['faceTrackingConfig']['minFaceScaleReset'],
                              -1
                            )),
                            (X[27] = i(
                              t['faceTrackingConfig']['maxFaceScaleReset'],
                              -1
                            )),
                            (X[28] = i(
                              t['faceTrackingConfig']['maxRotationXReset'],
                              -1
                            )),
                            (X[29] = i(
                              t['faceTrackingConfig']['maxRotationYReset'],
                              -1
                            )),
                            (X[30] = i(
                              t['faceTrackingConfig']['maxRotationZReset'],
                              -1
                            )),
                            (X[31] = i(
                              t['faceTrackingConfig'][
                                'confidenceThresholdReset'
                              ],
                              -1
                            )),
                            (X[32] = i(
                              t['faceTrackingConfig']['enableStabilizer'],
                              -1
                            )),
                            (X[33] = i(
                              t['faceTrackingConfig']['enableFreeRotation'],
                              -1
                            ))),
                          (X[34] = i(t['enableFaceTracking'], -1)),
                          M(Y)
                      }
                    },
                    C = null,
                    P = 0,
                    D = function (t, n) {
                      var i = n['length'] * o
                      ;(!C || 0 === P || i > P) &&
                        (C >= 0 && e['_free'](C),
                        (P = i),
                        (C = e['_malloc'](P))),
                        e['HEAPU8'].set(n, C),
                        S(t, C, n['length'])
                    },
                    I = null,
                    N = 0,
                    O = function (t) {
                      var n = t['data']['length'] * o
                      ;(!I || 0 === N || n > N) &&
                        (I >= 0 && e['_free'](I),
                        (N = n),
                        (I = e['_malloc'](N))),
                        e['HEAPU8'].set(t['data'], I),
                        E(I)
                    },
                    F = function () {
                      T()
                    },
                    B = 0,
                    z = 0,
                    U = 0,
                    k = 0,
                    H = -1,
                    W = null,
                    V = -1,
                    G = null,
                    j = -1,
                    q = null,
                    Y = -1,
                    X = null,
                    J = function (t) {
                      t < 512 && (t = 512)
                      var n = 4 * t * s
                      n > B &&
                        (H >= 0 && e['_free'](H),
                        (B = n),
                        (H = e['_malloc'](B))),
                        (W && W['length'] === t) ||
                          (W = new Float32Array(e['HEAPU8']['buffer'], H, t))
                    },
                    Z = function (t) {
                      t < 64 && (t = 64)
                      var n = 4 * t * s
                      n > z &&
                        (V >= 0 && e['_free'](V),
                        (z = n),
                        (V = e['_malloc'](z))),
                        (G && G['length'] === t) ||
                          (G = new Float32Array(e['HEAPU8']['buffer'], V, t))
                    },
                    K = function (t, n) {
                      t < 1 && (t = 1), t < 64 && (t = 64), n < 1 && (n = 1)
                      var i = t * n * s
                      i > U &&
                        (j >= 0 && e['_free'](j),
                        (U = i),
                        (j = e['_malloc'](U))),
                        (q && q['length'] === t * n) ||
                          (q = new Float32Array(
                            e['HEAPU8']['buffer'],
                            j,
                            t * n
                          ))
                    },
                    Q = function (t) {
                      var n = t * s
                      n > k &&
                        (Y >= 0 && e['_free'](Y),
                        (k = n),
                        (Y = e['_malloc'](k))),
                        (X && X['length'] === t) ||
                          (X = new Float32Array(e['HEAPU8']['buffer'], Y, t))
                    },
                    $ = function (e, t, n) {
                      var i = g(),
                        r = v(),
                        a = y(),
                        s = _()
                      J(i),
                        Z(r),
                        K(a, s),
                        i <= 0 ? (e.length = 0) : (x(H), f(e, W, i)),
                        r <= 0 ? (t.length = 0) : (w(V), f(t, G, r)),
                        a <= 0 ? (n.length = 0) : (b(j), m(n, q, a, s))
                    },
                    ee = function () {
                      var t = this,
                        n = [],
                        i = [],
                        r = [],
                        a = {
                          referToExamples:
                            ' Please refer to the BRFv5 examples on GitHub for the correct usage.',
                          sdkNotReady: 'Error 0001: SDK is not ready yet.',
                          expectedJson:
                            'Error 0002: BRFv5Manager.configure(config): expected config in json format (string or object).',
                          noBRFv5Config:
                            'Error 0003: BRFv5Manager.configure(config): expected a valid BRFv5 config.',
                          sdkNotConfigured:
                            'Warning 0004: BRFv5Manager.update(imageData): BRFv5 was not configured. Using defaults.',
                          configImageData:
                            'Warning 0005: BRFv5Manager.update(imageData): automatic ImageData configuration (width, height).',
                          missingImageData:
                            'Error 0006: BRFv5Manager.update(imageData): expected ImageData.',
                          invalidImageData:
                            'Error 0007: BRFv5Manager.update(imageData): invalid ImageData. BRFv5 uses the ImageData object instead of ImageData.data.'
                        }
                      ;(t['configure'] = function (t) {
                        if (!e['sdkReady'])
                          throw a.sdkNotReady + a.referToExamples
                        if (!t) throw a.expectedJson + a.referToExamples
                        var n = JSON.stringify(t).toString()
                        try {
                          ;(n = JSON.parse(n)),
                            n['imageConfig'] ||
                            n['faceDetectionConfig'] ||
                            n['faceTrackingConfig'] ||
                            n['enableFaceTracking']
                              ? n['imageConfig'] &&
                                (n['imageConfig']['inputWidth'] &&
                                  (A = n['imageConfig']['inputWidth']),
                                n['imageConfig']['inputHeight'] &&
                                  (R = n['imageConfig']['inputHeight']))
                              : (n = null)
                        } catch (i) {
                          n = null
                        }
                        if (!n) throw a.noBRFv5Config + a.referToExamples
                        L(n)
                      }),
                        (t['setupModel'] = function (t, n) {
                          if (!e['sdkReady'])
                            throw a.sdkNotReady + a.referToExamples
                          D(t, n)
                        }),
                        (t['update'] = function (s) {
                          if (!e['sdkReady'])
                            throw a.sdkNotReady + a.referToExamples
                          if (!s) throw a.missingImageData + a.referToExamples
                          if (!s['width'] || !s['height'] || !s['data'])
                            throw a.invalidImageData + a.referToExamples
                          if (
                            (e['sdkConfigured'] ||
                              e['sdkConfiguredTraced'] ||
                              (e['warn'](
                                a.sdkNotConfigured + a.referToExamples
                              ),
                              (e['sdkConfiguredTraced'] = !0)),
                            s['width'] !== A || s['height'] !== R)
                          ) {
                            e['warn'](a.configImageData + a.referToExamples)
                            var o = { imageConfig: {} }
                            ;(o['imageConfig']['inputWidth'] = s['width']),
                              (o['imageConfig']['inputHeight'] = s['height']),
                              t['configure'](o)
                          }
                          O(s), $(n, i, r)
                        }),
                        (t['reset'] = function () {
                          if (!e['sdkReady'])
                            throw a.sdkNotReady + a.referToExamples
                          F(), $(n, i, r)
                        }),
                        (t['getDetectedRects'] = function () {
                          return n
                        }),
                        (t['getMergedRects'] = function () {
                          return i
                        }),
                        (t['getFaces'] = function () {
                          return r
                        })
                    }
                  ;(e['BRFv5Manager'] = new ee()),
                    (e['BRFv5Manager']['getInstance'] = function () {
                      return e['BRFv5Manager']
                    }),
                    (e['onSDKReady'] = function () {
                      e['sdkReady'] = !0
                      for (
                        var t = e['brfv5ModelChunks'].length, n = 0;
                        n < t;
                        n++
                      )
                        e['BRFv5Manager']['setupModel'](
                          n,
                          e['brfv5ModelChunks'][n]
                        )
                      e['onInit'] &&
                      '[object Function]' === {}.toString.call(e['onInit'])
                        ? e['onInit'](
                            e['BRFv5Manager']['getInstance'](),
                            e['BRFv5Config']['createInstance']()
                          )
                        : e['trace']('BRFv5 is ready.')
                    }),
                    (e['onSDKConfigured'] = function () {
                      ;(e['sdkConfigured'] = !0),
                        (e['sdkConfiguredTraced'] = !1)
                    })
                })(Module),
                brfv5Module.ready
              )
            }
          )
        })(),
        _unused_webpack_default_export = brfv5Module
    }.call(
      this,
      '/index.js',
      __webpack_require__('4362'),
      __webpack_require__('c8ba'),
      '/'
    ))
  },
  a1fe: function (e, t, n) {
    'use strict'
    n('e5fa')
  },
  e5fa: function (e, t, n) {}
})
